// Base de données complète des joueurs Inazuma Eleven
// 5429 joueurs - Chaque joueur apparaît UNIQUEMENT dans son jeu de première apparition

export const playersDatabase = [
  {
    "id": 1,
    "name": "Mark Evans",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/w/dwho-wi8ruk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 59,
      "control": 58,
      "pressure": 66,
      "agility": 54,
      "physical": 72,
      "technique": 45
    }
  },
  {
    "id": 2,
    "name": "Axel Blaze",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/1/f1kh7d67sbs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 41,
      "control": 56,
      "pressure": 55,
      "agility": 67,
      "physical": 40,
      "technique": 68
    }
  },
  {
    "id": 5,
    "name": "Jack Wallside",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/r/mrvaa0xojh8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 60,
      "control": 43,
      "pressure": 60,
      "agility": 52,
      "physical": 68,
      "technique": 58
    }
  },
  {
    "id": 6,
    "name": "Nathan Swift",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/5/95k7tlx0k0u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 46,
      "control": 42,
      "pressure": 56,
      "agility": 59,
      "physical": 62,
      "technique": 46
    }
  },
  {
    "id": 7,
    "name": "Kevin Dragonfly",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/d/0dvmw8cb_ye.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 59,
      "control": 52,
      "pressure": 43,
      "agility": 61,
      "physical": 60,
      "technique": 60
    }
  },
  {
    "id": 8,
    "name": "Tod Ironside",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/y/_yjndsfyhyu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 46,
      "control": 54,
      "pressure": 59,
      "agility": 42,
      "physical": 58,
      "technique": 58
    }
  },
  {
    "id": 9,
    "name": "Steve Grim",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/3/f3asqpwqusk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 55,
      "control": 59,
      "pressure": 49,
      "agility": 46,
      "physical": 49,
      "technique": 56
    }
  },
  {
    "id": 10,
    "name": "Maxwell Carson",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/d/rd_khczyztm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 56,
      "control": 45,
      "pressure": 50,
      "agility": 59,
      "physical": 45,
      "technique": 66
    }
  },
  {
    "id": 11,
    "name": "Tim Saunders",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/f/ufxz9wwq5hm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 68,
      "control": 60,
      "pressure": 58,
      "agility": 57,
      "physical": 45,
      "technique": 62
    }
  },
  {
    "id": 12,
    "name": "Sam Kincaid",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/1/a1orm9vieek.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 71,
      "control": 55,
      "pressure": 47,
      "agility": 55,
      "physical": 53,
      "technique": 57
    }
  },
  {
    "id": 13,
    "name": "Jim Wraith",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/w/owsgutjimb8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 46,
      "control": 53,
      "pressure": 60,
      "agility": 49,
      "physical": 77,
      "technique": 50
    }
  },
  {
    "id": 14,
    "name": "William Glass",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/y/uy2tfhpjks0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 50,
      "control": 40,
      "pressure": 55,
      "agility": 77,
      "physical": 47,
      "technique": 59
    }
  },
  {
    "id": 15,
    "name": "Erik Eagle",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/4/e4qtt3lwf_m.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 77,
      "control": 72,
      "pressure": 51,
      "agility": 42,
      "physical": 56,
      "technique": 48
    }
  },
  {
    "id": 16,
    "name": "Bobby Shearer",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/x/-xzmaq-eqf8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 52,
      "control": 49,
      "pressure": 69,
      "agility": 57,
      "physical": 53,
      "technique": 53
    }
  },
  {
    "id": 17,
    "name": "Silvia Woods",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/b/cb88nfolkwe.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 49,
      "control": 46,
      "pressure": 78,
      "agility": 42,
      "physical": 56,
      "technique": 44
    }
  },
  {
    "id": 18,
    "name": "Celia Hills",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/p/zpndk6oxjls.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 64,
      "control": 65,
      "pressure": 54,
      "agility": 48,
      "physical": 57,
      "technique": 54
    }
  },
  {
    "id": 19,
    "name": "Nelly Raimon",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/i/xikbkjcdmjs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 50,
      "control": 55,
      "pressure": 60,
      "agility": 57,
      "physical": 44,
      "technique": 65
    }
  },
  {
    "id": 20,
    "name": "Joseph King",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/w/9wtikebapts.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 30,
      "intelligence": 44,
      "control": 56,
      "pressure": 62,
      "agility": 43,
      "physical": 59,
      "technique": 60
    }
  },
  {
    "id": 21,
    "name": "Peter Drent",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/5/d5w9zd0i6nc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 58,
      "control": 54,
      "pressure": 52,
      "agility": 50,
      "physical": 64,
      "technique": 40
    }
  },
  {
    "id": 22,
    "name": "Ben Simmons",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/r/srbc08syx-0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 58,
      "control": 48,
      "pressure": 76,
      "agility": 56,
      "physical": 68,
      "technique": 47
    }
  },
  {
    "id": 23,
    "name": "Alan Master",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/w/uwgaalaes40.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 74,
      "control": 75,
      "pressure": 58,
      "agility": 57,
      "physical": 40,
      "technique": 55
    }
  },
  {
    "id": 24,
    "name": "Gus Martin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/y/fy3h3amk_lc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 53,
      "control": 44,
      "pressure": 52,
      "agility": 50,
      "physical": 69,
      "technique": 52
    }
  },
  {
    "id": 25,
    "name": "Herman Waldon",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/3/_3uukhtskrs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 60,
      "control": 70,
      "pressure": 54,
      "agility": 54,
      "physical": 49,
      "technique": 59
    }
  },
  {
    "id": 26,
    "name": "John Bloom",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/f/ofl1j41wnye.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 68,
      "control": 65,
      "pressure": 44,
      "agility": 45,
      "physical": 51,
      "technique": 56
    }
  },
  {
    "id": 27,
    "name": "Derek Swing",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/1/61at4120ans.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 62,
      "control": 76,
      "pressure": 48,
      "agility": 42,
      "physical": 56,
      "technique": 60
    }
  },
  {
    "id": 28,
    "name": "Daniel Hatch",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/d/ldrmvkqotue.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 43,
      "control": 47,
      "pressure": 41,
      "agility": 65,
      "physical": 52,
      "technique": 65
    }
  },
  {
    "id": 29,
    "name": "Jude Sharp",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/1/l1wbplzhm4k.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 60,
      "control": 64,
      "pressure": 53,
      "agility": 57,
      "physical": 47,
      "technique": 60
    }
  },
  {
    "id": 30,
    "name": "David Samford",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/d/udbgi0_9hlm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 58,
      "control": 42,
      "pressure": 44,
      "agility": 70,
      "physical": 53,
      "technique": 51
    }
  },
  {
    "id": 31,
    "name": "Bob Carlton",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/y/0yivxpk1ur8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 56,
      "control": 59,
      "pressure": 57,
      "agility": 44,
      "physical": 64,
      "technique": 56
    }
  },
  {
    "id": 32,
    "name": "Cliff Tomlinson",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/a/fat0cwsp5yu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 45,
      "control": 48,
      "pressure": 46,
      "agility": 60,
      "physical": 54,
      "technique": 59
    }
  },
  {
    "id": 33,
    "name": "Jim Lawrenson",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/7/h7uoyp-j8eu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 41,
      "control": 49,
      "pressure": 46,
      "agility": 64,
      "physical": 60,
      "technique": 67
    }
  },
  {
    "id": 34,
    "name": "Barry Potts",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/t/2tljfwyzrt8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 73,
      "control": 57,
      "pressure": 43,
      "agility": 46,
      "physical": 42,
      "technique": 53
    }
  },
  {
    "id": 35,
    "name": "Steve Ingham",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/8/w8g8mttrknm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 43,
      "control": 42,
      "pressure": 44,
      "agility": 66,
      "physical": 53,
      "technique": 54
    }
  },
  {
    "id": 36,
    "name": "Ray Dark",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/w/8wocttgsuu0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 68,
      "control": 55,
      "pressure": 55,
      "agility": 50,
      "physical": 56,
      "technique": 62
    }
  },
  {
    "id": 37,
    "name": "Stephen Black",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/y/ny_j-sgwdnc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 59,
      "control": 45,
      "pressure": 72,
      "agility": 42,
      "physical": 62,
      "technique": 40
    }
  },
  {
    "id": 38,
    "name": "Nathan Jones",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/a/vaeuza7dvs8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 43,
      "control": 56,
      "pressure": 80,
      "agility": 40,
      "physical": 55,
      "technique": 45
    }
  },
  {
    "id": 39,
    "name": "Russell Walk",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/v/pv9hgholaym.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 47,
      "control": 57,
      "pressure": 60,
      "agility": 41,
      "physical": 66,
      "technique": 53
    }
  },
  {
    "id": 40,
    "name": "Jason Jones",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/h/-hman4ox3bk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 47,
      "control": 51,
      "pressure": 75,
      "agility": 48,
      "physical": 74,
      "technique": 58
    }
  },
  {
    "id": 41,
    "name": "Ken Furan",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/m/8mlcjh6dyhk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 55,
      "control": 52,
      "pressure": 79,
      "agility": 52,
      "physical": 65,
      "technique": 55
    }
  },
  {
    "id": 42,
    "name": "Jerry Fulton",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/o/no69oecnf0m.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 41,
      "control": 47,
      "pressure": 62,
      "agility": 41,
      "physical": 64,
      "technique": 49
    }
  },
  {
    "id": 43,
    "name": "Ray Mannings",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/h/thziddpvqu8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 59,
      "control": 76,
      "pressure": 48,
      "agility": 44,
      "physical": 55,
      "technique": 54
    }
  },
  {
    "id": 44,
    "name": "Robert Mayer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/j/cjopw8pvhnu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 65,
      "control": 59,
      "pressure": 43,
      "agility": 59,
      "physical": 56,
      "technique": 48
    }
  },
  {
    "id": 45,
    "name": "Alexander Brave",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/j/ojxxbxm3gy8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 61,
      "control": 60,
      "pressure": 50,
      "agility": 58,
      "physical": 58,
      "technique": 66
    }
  },
  {
    "id": 46,
    "name": "Johan Tassman",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/l/zlmqsoqnnru.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 42,
      "control": 56,
      "pressure": 57,
      "agility": 58,
      "physical": 53,
      "technique": 56
    }
  },
  {
    "id": 47,
    "name": "Troy Moon",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/j/3j9d2pjesh0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 62,
      "control": 58,
      "pressure": 43,
      "agility": 51,
      "physical": 50,
      "technique": 65
    }
  },
  {
    "id": 48,
    "name": "Burt Wolf",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/l/glm8bwf-b0c.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 74,
      "control": 61,
      "pressure": 58,
      "agility": 42,
      "physical": 48,
      "technique": 49
    }
  },
  {
    "id": 49,
    "name": "Rob Crombie",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/k/mkvjitw20us.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 41,
      "control": 42,
      "pressure": 78,
      "agility": 53,
      "physical": 73,
      "technique": 47
    }
  },
  {
    "id": 50,
    "name": "Chuck Dollman",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/m/xmeolswmzne.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 56,
      "control": 55,
      "pressure": 50,
      "agility": 62,
      "physical": 53,
      "technique": 74
    }
  },
  {
    "id": 51,
    "name": "Uxley Allen",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/t/vtz0llegche.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 41,
      "control": 53,
      "pressure": 46,
      "agility": 62,
      "physical": 48,
      "technique": 50
    }
  },
  {
    "id": 52,
    "name": "Phil Noir",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/f/kfovm0iaxss.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 54,
      "control": 41,
      "pressure": 53,
      "agility": 60,
      "physical": 41,
      "technique": 59
    }
  },
  {
    "id": 53,
    "name": "Mick Askley",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/q/eqlg1pxseyc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 67,
      "control": 71,
      "pressure": 42,
      "agility": 59,
      "physical": 58,
      "technique": 67
    }
  },
  {
    "id": 54,
    "name": "Hekyll Jyde",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/5/p54_qlu6ghc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 59,
      "control": 45,
      "pressure": 67,
      "agility": 60,
      "physical": 71,
      "technique": 48
    }
  },
  {
    "id": 56,
    "name": "Lanny Tern",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/2/t2vvykaoccs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 51,
      "control": 46,
      "pressure": 64,
      "agility": 46,
      "physical": 60,
      "technique": 54
    }
  },
  {
    "id": 57,
    "name": "Charlie Boardfield",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/a/pakshsy_xr0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 44,
      "control": 58,
      "pressure": 63,
      "agility": 55,
      "physical": 50,
      "technique": 59
    }
  },
  {
    "id": 58,
    "name": "Hugo Tallgeese",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/v/vvpnupt3ele.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 57,
      "control": 55,
      "pressure": 60,
      "agility": 47,
      "physical": 40,
      "technique": 54
    }
  },
  {
    "id": 59,
    "name": "Wilson Fishman",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/h/ehyg5wlnp4s.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 53,
      "control": 60,
      "pressure": 65,
      "agility": 51,
      "physical": 68,
      "technique": 46
    }
  },
  {
    "id": 60,
    "name": "Peter Johnson",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/m/cmfaxpzhs-s.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 42,
      "control": 45,
      "pressure": 64,
      "agility": 55,
      "physical": 56,
      "technique": 53
    }
  },
  {
    "id": 61,
    "name": "Leonard O'Shea",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/o/tou76w_bbne.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 45,
      "control": 45,
      "pressure": 68,
      "agility": 44,
      "physical": 65,
      "technique": 42
    }
  },
  {
    "id": 62,
    "name": "Cham Lion",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/h/nhnoplkt0t0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 57,
      "control": 61,
      "pressure": 51,
      "agility": 53,
      "physical": 47,
      "technique": 71
    }
  },
  {
    "id": 63,
    "name": "Steve Eagle",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/j/8j8ve0spzec.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 73,
      "control": 61,
      "pressure": 59,
      "agility": 58,
      "physical": 46,
      "technique": 63
    }
  },
  {
    "id": 64,
    "name": "Bruce Monkey",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/j/ijd315vl-h0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 78,
      "control": 55,
      "pressure": 45,
      "agility": 46,
      "physical": 41,
      "technique": 56
    }
  },
  {
    "id": 65,
    "name": "Gary Lancaster",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/l/5lywygjxtsc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 48,
      "control": 59,
      "pressure": 48,
      "agility": 68,
      "physical": 54,
      "technique": 64
    }
  },
  {
    "id": 66,
    "name": "Harry Snake",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/j/xjpbcha4y-8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 59,
      "control": 59,
      "pressure": 58,
      "agility": 61,
      "physical": 44,
      "technique": 64
    }
  },
  {
    "id": 67,
    "name": "Adrian Speed",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/l/mly6v4mcfnu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 46,
      "control": 40,
      "pressure": 54,
      "agility": 65,
      "physical": 42,
      "technique": 65
    }
  },
  {
    "id": 68,
    "name": "Alan Coe",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/k/gk7p8ltkqtk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 59,
      "control": 54,
      "pressure": 44,
      "agility": 54,
      "physical": 57,
      "technique": 56
    }
  },
  {
    "id": 69,
    "name": "Philip Anders",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/m/3mkura1whem.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 48,
      "control": 56,
      "pressure": 59,
      "agility": 55,
      "physical": 55,
      "technique": 63
    }
  },
  {
    "id": 70,
    "name": "Rocky Rackham",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/t/1tny_dnccym.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 44,
      "control": 46,
      "pressure": 71,
      "agility": 42,
      "physical": 64,
      "technique": 49
    }
  },
  {
    "id": 71,
    "name": "Matt Mouseman",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/f/ef8ts8bmvrk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 68,
      "control": 65,
      "pressure": 47,
      "agility": 55,
      "physical": 41,
      "technique": 57
    }
  },
  {
    "id": 72,
    "name": "Chad Bullford",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/q/kqfmbh0ualu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 52,
      "control": 58,
      "pressure": 66,
      "agility": 41,
      "physical": 63,
      "technique": 45
    }
  },
  {
    "id": 73,
    "name": "Harry Savage",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/-/e-qruphieye.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 70,
      "control": 78,
      "pressure": 56,
      "agility": 50,
      "physical": 53,
      "technique": 46
    }
  },
  {
    "id": 74,
    "name": "Flammie Gonzalez",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/z/nz2ghxvgpic.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 44,
      "control": 45,
      "pressure": 54,
      "agility": 65,
      "physical": 48,
      "technique": 73
    }
  },
  {
    "id": 75,
    "name": "Thomas Feldt",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/s/lsetbtpeusc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 44,
      "control": 59,
      "pressure": 64,
      "agility": 46,
      "physical": 57,
      "technique": 53
    }
  },
  {
    "id": 77,
    "name": "Harry Leading",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/d/rdnyso6mbms.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 48,
      "control": 51,
      "pressure": 58,
      "agility": 56,
      "physical": 61,
      "technique": 48
    }
  },
  {
    "id": 79,
    "name": "Terry Stronger",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/r/arw5_xc22_e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 53,
      "control": 45,
      "pressure": 70,
      "agility": 41,
      "physical": 75,
      "technique": 41
    }
  },
  {
    "id": 81,
    "name": "Philip Marvel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/k/ykrlrooaz5e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 59,
      "control": 48,
      "pressure": 56,
      "agility": 57,
      "physical": 75,
      "technique": 45
    }
  },
  {
    "id": 83,
    "name": "Noel Good",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/i/pige8xogeks.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 41,
      "control": 46,
      "pressure": 64,
      "agility": 44,
      "physical": 77,
      "technique": 47
    }
  },
  {
    "id": 85,
    "name": "Tyron Rock",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/n/jndxvkdorqc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 69,
      "control": 64,
      "pressure": 47,
      "agility": 42,
      "physical": 41,
      "technique": 66
    }
  },
  {
    "id": 87,
    "name": "Francis Tell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/l/4lyqc17sgz0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 68,
      "control": 57,
      "pressure": 51,
      "agility": 57,
      "physical": 44,
      "technique": 58
    }
  },
  {
    "id": 89,
    "name": "Samuel Buster",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/p/mpniz44whmc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 64,
      "control": 58,
      "pressure": 40,
      "agility": 57,
      "physical": 57,
      "technique": 58
    }
  },
  {
    "id": 91,
    "name": "Jonathan Seller",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/n/9n8pehekmv0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 44,
      "control": 55,
      "pressure": 46,
      "agility": 65,
      "physical": 56,
      "technique": 49
    }
  },
  {
    "id": 93,
    "name": "Victor Kind",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/p/tpnkegxdt5u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 74,
      "control": 64,
      "pressure": 60,
      "agility": 55,
      "physical": 49,
      "technique": 61
    }
  },
  {
    "id": 95,
    "name": "Neil Turner",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/n/inwfp5x5ak8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 59,
      "control": 41,
      "pressure": 59,
      "agility": 78,
      "physical": 51,
      "technique": 66
    }
  },
  {
    "id": 96,
    "name": "Neil Turner",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/7/m7wvasweef0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 48,
      "control": 54,
      "pressure": 45,
      "agility": 74,
      "physical": 47,
      "technique": 52
    }
  },
  {
    "id": 97,
    "name": "Reg Underwood",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/i/ci1w6kex1qm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 59,
      "control": 42,
      "pressure": 67,
      "agility": 50,
      "physical": 66,
      "technique": 46
    }
  },
  {
    "id": 99,
    "name": "Patrick Stiller",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/g/zgerxbilyzk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 66,
      "control": 62,
      "pressure": 57,
      "agility": 47,
      "physical": 58,
      "technique": 69
    }
  },
  {
    "id": 101,
    "name": "Charles Oughtry",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/b/xbdn5cwndfk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 61,
      "control": 57,
      "pressure": 44,
      "agility": 44,
      "physical": 51,
      "technique": 65
    }
  },
  {
    "id": 103,
    "name": "Clive Mooney",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/p/apysu9wdwsm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 82,
      "intelligence": 46,
      "control": 54,
      "pressure": 44,
      "agility": 56,
      "physical": 48,
      "technique": 64
    }
  },
  {
    "id": 104,
    "name": "Neil Waters",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/g/ggrzhgjvfm8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 60,
      "control": 45,
      "pressure": 60,
      "agility": 55,
      "physical": 67,
      "technique": 59
    }
  },
  {
    "id": 106,
    "name": "Newton Thomas",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/w/vwbkdwhyzbs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 59,
      "control": 56,
      "pressure": 52,
      "agility": 45,
      "physical": 57,
      "technique": 58
    }
  },
  {
    "id": 107,
    "name": "Sam Idol",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/b/nbqrnz0o4lc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 42,
      "control": 44,
      "pressure": 57,
      "agility": 46,
      "physical": 76,
      "technique": 45
    }
  },
  {
    "id": 108,
    "name": "Marcus Train",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/u/tujeeebgnfs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 54,
      "control": 50,
      "pressure": 61,
      "agility": 58,
      "physical": 60,
      "technique": 56
    }
  },
  {
    "id": 109,
    "name": "Light Nobel",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/g/cg4_z7n8g2e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 65,
      "control": 59,
      "pressure": 40,
      "agility": 57,
      "physical": 57,
      "technique": 61
    }
  },
  {
    "id": 110,
    "name": "Walter Valiant",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/n/en_jdi1qlwe.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 65,
      "control": 69,
      "pressure": 41,
      "agility": 54,
      "physical": 49,
      "technique": 52
    }
  },
  {
    "id": 111,
    "name": "Spencer Gates",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/p/vpocwdtqids.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 59,
      "control": 57,
      "pressure": 69,
      "agility": 56,
      "physical": 76,
      "technique": 44
    }
  },
  {
    "id": 112,
    "name": "Josh Spear",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/g/pgt3jami9jc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 56,
      "control": 57,
      "pressure": 45,
      "agility": 61,
      "physical": 41,
      "technique": 63
    }
  },
  {
    "id": 113,
    "name": "Gaby Farmer",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/i/-icwo_ayqq0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 47,
      "control": 60,
      "pressure": 48,
      "agility": 64,
      "physical": 40,
      "technique": 47
    }
  },
  {
    "id": 114,
    "name": "A. Woodbridge",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/i/kijo_yd63vc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 66,
      "control": 61,
      "pressure": 49,
      "agility": 56,
      "physical": 51,
      "technique": 51
    }
  },
  {
    "id": 115,
    "name": "Gus Gamer",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/k/7ksvsnlaac0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 57,
      "control": 54,
      "pressure": 56,
      "agility": 64,
      "physical": 52,
      "technique": 70
    }
  },
  {
    "id": 116,
    "name": "Mark Gambling",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/i/vijiimsj7wu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 45,
      "control": 55,
      "pressure": 59,
      "agility": 64,
      "physical": 52,
      "technique": 54
    }
  },
  {
    "id": 117,
    "name": "Theodore Master",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/k/kk4dlzkzwd8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 82,
      "intelligence": 43,
      "control": 49,
      "pressure": 48,
      "agility": 72,
      "physical": 52,
      "technique": 48
    }
  },
  {
    "id": 118,
    "name": "Ham Signalman",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/l/elb22u_7jjm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 59,
      "control": 61,
      "pressure": 44,
      "agility": 40,
      "physical": 58,
      "technique": 69
    }
  },
  {
    "id": 119,
    "name": "Bill Formby",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/n/1nqxbrzboqk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 60,
      "control": 52,
      "pressure": 70,
      "agility": 48,
      "physical": 63,
      "technique": 43
    }
  },
  {
    "id": 120,
    "name": "Grant Eldorado",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/s/3stl1iltlwk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 28,
      "intelligence": 51,
      "control": 48,
      "pressure": 78,
      "agility": 59,
      "physical": 70,
      "technique": 50
    }
  },
  {
    "id": 121,
    "name": "Mike Vox",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/e/gecqy3txmlm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 50,
      "control": 53,
      "pressure": 50,
      "agility": 40,
      "physical": 74,
      "technique": 57
    }
  },
  {
    "id": 122,
    "name": "Ollie Webb",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/r/mr_flqyftf8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 60,
      "control": 41,
      "pressure": 68,
      "agility": 41,
      "physical": 58,
      "technique": 57
    }
  },
  {
    "id": 123,
    "name": "Manny Artic",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/8/b8ksybiqu-e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 66,
      "control": 70,
      "pressure": 55,
      "agility": 52,
      "physical": 57,
      "technique": 48
    }
  },
  {
    "id": 124,
    "name": "Meina Maiden",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/u/quvzfkeq5ns.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 46,
      "control": 47,
      "pressure": 62,
      "agility": 46,
      "physical": 64,
      "technique": 49
    }
  },
  {
    "id": 125,
    "name": "Morgan Sanders",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/b/tb-t5rxymcu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 55,
      "control": 40,
      "pressure": 68,
      "agility": 41,
      "physical": 73,
      "technique": 51
    }
  },
  {
    "id": 126,
    "name": "Newton Flust",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/u/nudyqmi6t8k.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 43,
      "control": 60,
      "pressure": 57,
      "agility": 43,
      "physical": 71,
      "technique": 56
    }
  },
  {
    "id": 127,
    "name": "Jim Hillfort",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/g/8gs5hzea-pm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 48,
      "control": 55,
      "pressure": 72,
      "agility": 58,
      "physical": 69,
      "technique": 44
    }
  },
  {
    "id": 128,
    "name": "Galen Thunderbird",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/n/-nrlpqws7jm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 46,
      "control": 45,
      "pressure": 56,
      "agility": 52,
      "physical": 58,
      "technique": 44
    }
  },
  {
    "id": 129,
    "name": "Finn Stoned",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/p/ppaeevwww6k.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 48,
      "control": 57,
      "pressure": 68,
      "agility": 55,
      "physical": 71,
      "technique": 54
    }
  },
  {
    "id": 130,
    "name": "Phil Wingate",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/g/vg5xxifejau.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 68,
      "control": 72,
      "pressure": 43,
      "agility": 51,
      "physical": 60,
      "technique": 60
    }
  },
  {
    "id": 131,
    "name": "Jez Shell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/i/eiiq63jkop8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 57,
      "control": 63,
      "pressure": 55,
      "agility": 60,
      "physical": 46,
      "technique": 74
    }
  },
  {
    "id": 132,
    "name": "Jupiter Jumper",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/i/qi3il6ggpwu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 64,
      "control": 61,
      "pressure": 40,
      "agility": 50,
      "physical": 54,
      "technique": 59
    }
  },
  {
    "id": 133,
    "name": "Sam Samurai",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/k/bkgpmfg8el8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 48,
      "control": 43,
      "pressure": 58,
      "agility": 55,
      "physical": 49,
      "technique": 69
    }
  },
  {
    "id": 134,
    "name": "Hank Sullivan",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/i/1idk8ep1ljc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 60,
      "control": 65,
      "pressure": 50,
      "agility": 60,
      "physical": 55,
      "technique": 60
    }
  },
  {
    "id": 135,
    "name": "Sail Bluesea",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/k/eksfr7ppi60.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 53,
      "control": 56,
      "pressure": 50,
      "agility": 67,
      "physical": 43,
      "technique": 60
    }
  },
  {
    "id": 136,
    "name": "John Reynolds",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/l/klpwcmch9ae.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 56,
      "control": 47,
      "pressure": 47,
      "agility": 59,
      "physical": 51,
      "technique": 55
    }
  },
  {
    "id": 137,
    "name": "Dan Hopper",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/n/vn-rvz69qps.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 56,
      "control": 50,
      "pressure": 70,
      "agility": 52,
      "physical": 68,
      "technique": 58
    }
  },
  {
    "id": 138,
    "name": "Cal Trops",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/s/xs5nbaorvvs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 70,
      "control": 63,
      "pressure": 56,
      "agility": 47,
      "physical": 54,
      "technique": 66
    }
  },
  {
    "id": 139,
    "name": "Winston Falls",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/e/meiss_or4ce.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 59,
      "control": 64,
      "pressure": 50,
      "agility": 50,
      "physical": 53,
      "technique": 60
    }
  },
  {
    "id": 140,
    "name": "Kevin Castle",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/r/grrz_i7jn80.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 50,
      "control": 42,
      "pressure": 79,
      "agility": 53,
      "physical": 60,
      "technique": 58
    }
  },
  {
    "id": 141,
    "name": "Sammy Igajima",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/8/e8o-flnjyhm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 73,
      "control": 57,
      "pressure": 48,
      "agility": 54,
      "physical": 40,
      "technique": 50
    }
  },
  {
    "id": 142,
    "name": "Albert Green",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/x/_xzxavtxgje.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 53,
      "control": 40,
      "pressure": 60,
      "agility": 43,
      "physical": 61,
      "technique": 55
    }
  },
  {
    "id": 143,
    "name": "Seward Hayseed",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/4/f4qetiy5zd0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 50,
      "control": 59,
      "pressure": 55,
      "agility": 55,
      "physical": 80,
      "technique": 52
    }
  },
  {
    "id": 144,
    "name": "Kent Work",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/q/uqhl-3-dewc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 54,
      "control": 46,
      "pressure": 69,
      "agility": 58,
      "physical": 67,
      "technique": 51
    }
  },
  {
    "id": 145,
    "name": "Mark Hillvalley",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/x/sxm5qusvb2c.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 40,
      "control": 57,
      "pressure": 67,
      "agility": 40,
      "physical": 69,
      "technique": 55
    }
  },
  {
    "id": 146,
    "name": "Herb Sherman",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/z/dzxy9rkv2f0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 54,
      "control": 53,
      "pressure": 73,
      "agility": 44,
      "physical": 64,
      "technique": 53
    }
  },
  {
    "id": 147,
    "name": "Joe Small",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/2/920tum_ddle.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 69,
      "control": 52,
      "pressure": 57,
      "agility": 58,
      "physical": 42,
      "technique": 50
    }
  },
  {
    "id": 148,
    "name": "Ike Steiner",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/e/mefmdzznuws.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 74,
      "control": 61,
      "pressure": 51,
      "agility": 56,
      "physical": 58,
      "technique": 66
    }
  },
  {
    "id": 149,
    "name": "Orville Newman",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/0/406uy-afjpe.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 72,
      "control": 66,
      "pressure": 56,
      "agility": 49,
      "physical": 59,
      "technique": 66
    }
  },
  {
    "id": 150,
    "name": "Tom Walters",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/c/jcl1fb8_kas.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 67,
      "control": 64,
      "pressure": 45,
      "agility": 55,
      "physical": 58,
      "technique": 51
    }
  },
  {
    "id": 151,
    "name": "Daniel Dawson",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/0/n0q4fa12f2m.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 61,
      "control": 66,
      "pressure": 46,
      "agility": 56,
      "physical": 54,
      "technique": 65
    }
  },
  {
    "id": 152,
    "name": "Stuart Racoonfur",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/c/wchzo_tmofk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 58,
      "control": 43,
      "pressure": 54,
      "agility": 69,
      "physical": 48,
      "technique": 63
    }
  },
  {
    "id": 153,
    "name": "Lorne Mower",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/z/2zcs7imedlu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 55,
      "control": 40,
      "pressure": 70,
      "agility": 52,
      "physical": 69,
      "technique": 52
    }
  },
  {
    "id": 154,
    "name": "Homer Grower",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/b/hbznwda-ww8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 53,
      "control": 49,
      "pressure": 57,
      "agility": 42,
      "physical": 68,
      "technique": 48
    }
  },
  {
    "id": 155,
    "name": "Rolf Howells",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/6/f60r4ess1q8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 43,
      "control": 43,
      "pressure": 58,
      "agility": 41,
      "physical": 74,
      "technique": 42
    }
  },
  {
    "id": 156,
    "name": "Luke Lively",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/s/0sfwv70oyju.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 43,
      "control": 45,
      "pressure": 54,
      "agility": 59,
      "physical": 69,
      "technique": 52
    }
  },
  {
    "id": 157,
    "name": "Ben Nevis",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/9/u9mfgmbgtdk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 55,
      "control": 50,
      "pressure": 58,
      "agility": 59,
      "physical": 66,
      "technique": 48
    }
  },
  {
    "id": 158,
    "name": "Turtle Newfield",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/u/1u_foarz1sk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 60,
      "control": 68,
      "pressure": 59,
      "agility": 54,
      "physical": 46,
      "technique": 57
    }
  },
  {
    "id": 159,
    "name": "John Neville",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/x/fxn30donyam.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 30,
      "intelligence": 47,
      "control": 46,
      "pressure": 66,
      "agility": 52,
      "physical": 72,
      "technique": 55
    }
  },
  {
    "id": 160,
    "name": "Malcolm Night",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/4/_4ecna7ft68.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 43,
      "control": 57,
      "pressure": 59,
      "agility": 49,
      "physical": 62,
      "technique": 43
    }
  },
  {
    "id": 161,
    "name": "Alfred Meenan",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/q/oq1jk_d_aju.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 46,
      "control": 51,
      "pressure": 64,
      "agility": 52,
      "physical": 61,
      "technique": 50
    }
  },
  {
    "id": 162,
    "name": "Dan Mirthful",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/x/mxy_kmptfpu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 46,
      "control": 41,
      "pressure": 71,
      "agility": 53,
      "physical": 56,
      "technique": 47
    }
  },
  {
    "id": 163,
    "name": "Ricky Clover",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/z/9zdejzppo88.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 48,
      "control": 52,
      "pressure": 72,
      "agility": 49,
      "physical": 66,
      "technique": 42
    }
  },
  {
    "id": 164,
    "name": "Toby Damian",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/2/d2graechdcm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 70,
      "control": 59,
      "pressure": 55,
      "agility": 42,
      "physical": 50,
      "technique": 65
    }
  },
  {
    "id": 165,
    "name": "York Nashmith",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/e/serk376bwvk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 64,
      "control": 71,
      "pressure": 50,
      "agility": 60,
      "physical": 48,
      "technique": 59
    }
  },
  {
    "id": 166,
    "name": "Zachary Moore",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/0/y0usg255xqm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 55,
      "control": 59,
      "pressure": 54,
      "agility": 47,
      "physical": 46,
      "technique": 67
    }
  },
  {
    "id": 167,
    "name": "Marvin Murdock",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/c/pcfzrjfd6jk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 40,
      "control": 41,
      "pressure": 40,
      "agility": 62,
      "physical": 41,
      "technique": 64
    }
  },
  {
    "id": 168,
    "name": "Thomas Murdock",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/0/h0e-xiwkbpe.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 57,
      "control": 45,
      "pressure": 49,
      "agility": 61,
      "physical": 50,
      "technique": 69
    }
  },
  {
    "id": 169,
    "name": "Tyler Murdock",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/c/2c1fc3ww28s.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 43,
      "control": 60,
      "pressure": 57,
      "agility": 54,
      "physical": 45,
      "technique": 55
    }
  },
  {
    "id": 170,
    "name": "Simon Calier",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/z/wzwqpqf4dcc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 51,
      "control": 52,
      "pressure": 69,
      "agility": 48,
      "physical": 75,
      "technique": 52
    }
  },
  {
    "id": 171,
    "name": "Brody Gloom",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/b/nbnlivjcuv0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 62,
      "control": 62,
      "pressure": 50,
      "agility": 46,
      "physical": 47,
      "technique": 54
    }
  },
  {
    "id": 172,
    "name": "Victor Talis",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/6/l6gxmmxurp0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 57,
      "control": 58,
      "pressure": 45,
      "agility": 46,
      "physical": 58,
      "technique": 54
    }
  },
  {
    "id": 173,
    "name": "Eren Middleton",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/s/usr2hzxugac.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 57,
      "control": 44,
      "pressure": 73,
      "agility": 43,
      "physical": 59,
      "technique": 46
    }
  },
  {
    "id": 174,
    "name": "Peter Wells",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/9/09ydyuicz6s.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 53,
      "control": 41,
      "pressure": 54,
      "agility": 50,
      "physical": 77,
      "technique": 50
    }
  },
  {
    "id": 175,
    "name": "Seth Nichols",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/7/v7cq7herayu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 54,
      "control": 48,
      "pressure": 55,
      "agility": 55,
      "physical": 68,
      "technique": 44
    }
  },
  {
    "id": 176,
    "name": "Paul Siddon",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/7/b7piycz2hdk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 52,
      "control": 44,
      "pressure": 70,
      "agility": 40,
      "physical": 62,
      "technique": 43
    }
  },
  {
    "id": 177,
    "name": "Apollo Light",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/u/7uk9hbs-y9u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 52,
      "control": 57,
      "pressure": 70,
      "agility": 49,
      "physical": 70,
      "technique": 50
    }
  },
  {
    "id": 178,
    "name": "Jeff Iron",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/8/k87cm-kefo8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 46,
      "control": 40,
      "pressure": 65,
      "agility": 47,
      "physical": 63,
      "technique": 52
    }
  },
  {
    "id": 179,
    "name": "Lane War",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/d/id8ainyoai8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 46,
      "control": 53,
      "pressure": 70,
      "agility": 41,
      "physical": 54,
      "technique": 59
    }
  },
  {
    "id": 180,
    "name": "Danny Wood",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/1/51nhpy-s37u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 46,
      "control": 47,
      "pressure": 72,
      "agility": 48,
      "physical": 68,
      "technique": 58
    }
  },
  {
    "id": 181,
    "name": "Artie Mishman",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/a/zauucflacbk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 66,
      "control": 58,
      "pressure": 45,
      "agility": 48,
      "physical": 51,
      "technique": 55
    }
  },
  {
    "id": 182,
    "name": "Arion Matlock",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/y/oyf1x6tgvom.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 51,
      "control": 59,
      "pressure": 56,
      "agility": 58,
      "physical": 48,
      "technique": 57
    }
  },
  {
    "id": 183,
    "name": "Wesley Knox",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/y/cygta3ucixk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 53,
      "control": 62,
      "pressure": 60,
      "agility": 44,
      "physical": 55,
      "technique": 60
    }
  },
  {
    "id": 184,
    "name": "Jonas Demetrius",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/w/twrmtii4lkm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 57,
      "control": 47,
      "pressure": 46,
      "agility": 59,
      "physical": 45,
      "technique": 58
    }
  },
  {
    "id": 185,
    "name": "Byron Love",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/y/dykb3jbxeis.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 71,
      "control": 57,
      "pressure": 41,
      "agility": 59,
      "physical": 44,
      "technique": 57
    }
  },
  {
    "id": 186,
    "name": "Henry House",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/w/yw7ga2nlp7e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 68,
      "control": 59,
      "pressure": 56,
      "agility": 47,
      "physical": 47,
      "technique": 52
    }
  },
  {
    "id": 187,
    "name": "Iggy Russ",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/f/sfyvjrsdcb0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 25,
      "intelligence": 58,
      "control": 51,
      "pressure": 61,
      "agility": 58,
      "physical": 73,
      "technique": 51
    }
  },
  {
    "id": 188,
    "name": "Gus Heeley",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/3/j3p0ku05xoc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 51,
      "control": 50,
      "pressure": 40,
      "agility": 59,
      "physical": 51,
      "technique": 53
    }
  },
  {
    "id": 189,
    "name": "Harry Closs",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/w/hwuoknmv0uc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 57,
      "control": 44,
      "pressure": 65,
      "agility": 58,
      "physical": 51,
      "technique": 60
    }
  },
  {
    "id": 190,
    "name": "Andy Chronic",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/-/q-fjnyavzd0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 42,
      "control": 56,
      "pressure": 59,
      "agility": 46,
      "physical": 71,
      "technique": 47
    }
  },
  {
    "id": 191,
    "name": "Ned Yousef",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/r/wr880v1ns9e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 74,
      "control": 53,
      "pressure": 53,
      "agility": 46,
      "physical": 58,
      "technique": 70
    }
  },
  {
    "id": 192,
    "name": "Herman Muller",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/5/95cfyipzc3u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 42,
      "control": 50,
      "pressure": 67,
      "agility": 43,
      "physical": 61,
      "technique": 49
    }
  },
  {
    "id": 193,
    "name": "Keth Claus",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/w/dw_wlv6r3xk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 47,
      "control": 51,
      "pressure": 59,
      "agility": 41,
      "physical": 77,
      "technique": 43
    }
  },
  {
    "id": 194,
    "name": "Robert Silver",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/-/s-ormqcrakm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 48,
      "control": 52,
      "pressure": 76,
      "agility": 40,
      "physical": 75,
      "technique": 50
    }
  },
  {
    "id": 195,
    "name": "Izzy Island",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/f/ufjnizohfim.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 43,
      "control": 40,
      "pressure": 62,
      "agility": 53,
      "physical": 67,
      "technique": 41
    }
  },
  {
    "id": 196,
    "name": "Sothern Newman",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/3/f34slmo9yrk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 48,
      "control": 56,
      "pressure": 79,
      "agility": 53,
      "physical": 62,
      "technique": 57
    }
  },
  {
    "id": 197,
    "name": "Irwin Hall",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/y/_ybz2rd1hxu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 67,
      "control": 68,
      "pressure": 40,
      "agility": 45,
      "physical": 41,
      "technique": 53
    }
  },
  {
    "id": 198,
    "name": "Taylor Higgins",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/w/owq4bu7pqc8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 52,
      "control": 71,
      "pressure": 48,
      "agility": 52,
      "physical": 54,
      "technique": 57
    }
  },
  {
    "id": 199,
    "name": "Jamie Cool",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/a/6avgqj4tn9u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 64,
      "control": 66,
      "pressure": 48,
      "agility": 49,
      "physical": 54,
      "technique": 61
    }
  },
  {
    "id": 200,
    "name": "Hans Randall",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/y/lykbhcexgo8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 53,
      "control": 48,
      "pressure": 51,
      "agility": 69,
      "physical": 53,
      "technique": 49
    }
  },
  {
    "id": 201,
    "name": "Michael Riverside",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/a/la_mddxebic.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 68,
      "control": 52,
      "pressure": 42,
      "agility": 40,
      "physical": 49,
      "technique": 63
    }
  },
  {
    "id": 202,
    "name": "Millie Moonlight",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/y/uyotwixksr0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 54,
      "control": 56,
      "pressure": 60,
      "agility": 64,
      "physical": 50,
      "technique": 53
    }
  },
  {
    "id": 203,
    "name": "Karl Blue",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/d/0dtyj_eszxe.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 71,
      "control": 71,
      "pressure": 40,
      "agility": 55,
      "physical": 58,
      "technique": 65
    }
  },
  {
    "id": 204,
    "name": "Theakston Plank",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/1/f1c5oaiw0cs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 55,
      "control": 58,
      "pressure": 53,
      "agility": 56,
      "physical": 60,
      "technique": 71
    }
  },
  {
    "id": 205,
    "name": "Ken Cake",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/u/hublgzw6xes.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 45,
      "control": 52,
      "pressure": 43,
      "agility": 59,
      "physical": 58,
      "technique": 47
    }
  },
  {
    "id": 206,
    "name": "Mitch Grumble",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/8/28qenmwac3e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 68,
      "control": 76,
      "pressure": 56,
      "agility": 49,
      "physical": 60,
      "technique": 59
    }
  },
  {
    "id": 207,
    "name": "Bart Grantham",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/t/wtjxe7jipx0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 44,
      "control": 44,
      "pressure": 57,
      "agility": 41,
      "physical": 61,
      "technique": 57
    }
  },
  {
    "id": 208,
    "name": "Seymour Hillman",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/v/vvrzhm1aiie.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 25,
      "intelligence": 53,
      "control": 48,
      "pressure": 70,
      "agility": 51,
      "physical": 68,
      "technique": 48
    }
  },
  {
    "id": 209,
    "name": "Charles Island",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/a/paysyrasxo0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 59,
      "control": 52,
      "pressure": 67,
      "agility": 40,
      "physical": 69,
      "technique": 45
    }
  },
  {
    "id": 210,
    "name": "Garret Hairtown",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/o/-odnfumo6bc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 44,
      "control": 40,
      "pressure": 68,
      "agility": 47,
      "physical": 57,
      "technique": 59
    }
  },
  {
    "id": 211,
    "name": "Arthur Sweet",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/j/8jerx30e_dc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 47,
      "control": 56,
      "pressure": 73,
      "agility": 56,
      "physical": 65,
      "technique": 47
    }
  },
  {
    "id": 212,
    "name": "Peter Mildred",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/h/nh1wcis-su0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 57,
      "control": 55,
      "pressure": 57,
      "agility": 44,
      "physical": 53,
      "technique": 64
    }
  },
  {
    "id": 213,
    "name": "Josh Nathaniel",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/o/towfpvn2noe.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 68,
      "control": 63,
      "pressure": 46,
      "agility": 56,
      "physical": 41,
      "technique": 63
    }
  },
  {
    "id": 214,
    "name": "Edward Gladstone",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/m/cmnkiqbmk9s.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 56,
      "control": 70,
      "pressure": 52,
      "agility": 42,
      "physical": 59,
      "technique": 59
    }
  },
  {
    "id": 215,
    "name": "Tyler Thomas",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/m/omy8tncutce.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 57,
      "control": 64,
      "pressure": 43,
      "agility": 56,
      "physical": 54,
      "technique": 57
    }
  },
  {
    "id": 216,
    "name": "Joseph Yosemite",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/k/zkpd-ykuaxs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 49,
      "control": 41,
      "pressure": 53,
      "agility": 58,
      "physical": 54,
      "technique": 72
    }
  },
  {
    "id": 217,
    "name": "Ian Suffolk",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/m/3myqkztdhdm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 68,
      "control": 67,
      "pressure": 45,
      "agility": 51,
      "physical": 47,
      "technique": 54
    }
  },
  {
    "id": 218,
    "name": "Constant Builder",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/k/gkdxjmlnmuk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 40,
      "control": 51,
      "pressure": 56,
      "agility": 51,
      "physical": 56,
      "technique": 65
    }
  },
  {
    "id": 219,
    "name": "Ted Poe",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/l/mlgea7-v5ou.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 43,
      "control": 56,
      "pressure": 49,
      "agility": 79,
      "physical": 56,
      "technique": 54
    }
  },
  {
    "id": 220,
    "name": "Marshall Heart",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/j/xjrl3eyvu98.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 43,
      "control": 52,
      "pressure": 60,
      "agility": 73,
      "physical": 48,
      "technique": 64
    }
  },
  {
    "id": 221,
    "name": "Dom Foreman",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/c/vcw5zdk5r78.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 70,
      "control": 62,
      "pressure": 48,
      "agility": 46,
      "physical": 59,
      "technique": 49
    }
  },
  {
    "id": 222,
    "name": "Slot MacHines",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/q/kqny0isd8iu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 53,
      "control": 50,
      "pressure": 70,
      "agility": 54,
      "physical": 74,
      "technique": 55
    }
  },
  {
    "id": 223,
    "name": "Bill Steakspear",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/f/efetn_zljok.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 47,
      "control": 53,
      "pressure": 72,
      "agility": 56,
      "physical": 69,
      "technique": 48
    }
  },
  {
    "id": 224,
    "name": "Joe Ingram",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/5/d5idsaslcoc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 45,
      "control": 45,
      "pressure": 61,
      "agility": 54,
      "physical": 73,
      "technique": 45
    }
  },
  {
    "id": 225,
    "name": "Kendall Sefton",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/w/9wr2_dztpus.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 43,
      "control": 55,
      "pressure": 68,
      "agility": 50,
      "physical": 59,
      "technique": 50
    }
  },
  {
    "id": 226,
    "name": "Jason Strike",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/-/m-axsi_xede.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 53,
      "control": 54,
      "pressure": 60,
      "agility": 50,
      "physical": 61,
      "technique": 51
    }
  },
  {
    "id": 227,
    "name": "Norman Porter",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/f/ofdl87t7bbe.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 49,
      "control": 51,
      "pressure": 59,
      "agility": 52,
      "physical": 66,
      "technique": 55
    }
  },
  {
    "id": 228,
    "name": "Maxwell Claus",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/3/_3sqrelbsos.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 58,
      "control": 57,
      "pressure": 69,
      "agility": 49,
      "physical": 65,
      "technique": 46
    }
  },
  {
    "id": 229,
    "name": "Bruce Chaney",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/y/fypfcz-jzic.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 71,
      "control": 74,
      "pressure": 41,
      "agility": 56,
      "physical": 53,
      "technique": 58
    }
  },
  {
    "id": 230,
    "name": "Leroy Rhymes",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/w/uw--vmyz070.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 69,
      "control": 75,
      "pressure": 51,
      "agility": 46,
      "physical": 59,
      "technique": 58
    }
  },
  {
    "id": 231,
    "name": "Mildford Scott",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/a/aabmerbrtec.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 71,
      "control": 51,
      "pressure": 40,
      "agility": 40,
      "physical": 40,
      "technique": 66
    }
  },
  {
    "id": 232,
    "name": "Lou Edmonds",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/y/rywhzu9r-30.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 57,
      "control": 42,
      "pressure": 52,
      "agility": 74,
      "physical": 52,
      "technique": 61
    }
  },
  {
    "id": 233,
    "name": "Cameron Morefield",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/a/farkpv0ifbu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 68,
      "control": 66,
      "pressure": 46,
      "agility": 41,
      "physical": 47,
      "technique": 53
    }
  },
  {
    "id": 234,
    "name": "Greg Bernard",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/y/0yareqsyyo8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 41,
      "control": 56,
      "pressure": 60,
      "agility": 68,
      "physical": 52,
      "technique": 65
    }
  },
  {
    "id": 235,
    "name": "Peter Banker",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/d/ud5ex3nqhim.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 29,
      "intelligence": 50,
      "control": 52,
      "pressure": 73,
      "agility": 42,
      "physical": 75,
      "technique": 46
    }
  },
  {
    "id": 236,
    "name": "Saul Tunk",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/1/l1i_6ibqq7k.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 65,
      "control": 80,
      "pressure": 50,
      "agility": 48,
      "physical": 43,
      "technique": 57
    }
  },
  {
    "id": 237,
    "name": "Alan Most",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/u/nupjurtgv9k.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 53,
      "control": 58,
      "pressure": 66,
      "agility": 59,
      "physical": 56,
      "technique": 50
    }
  },
  {
    "id": 238,
    "name": "Paul Caperock",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/8/w8-c5u18com.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 40,
      "control": 43,
      "pressure": 64,
      "agility": 54,
      "physical": 57,
      "technique": 57
    }
  },
  {
    "id": 239,
    "name": "Julius Molehill",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/t/2td3qza03u8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 43,
      "control": 56,
      "pressure": 55,
      "agility": 43,
      "physical": 72,
      "technique": 58
    }
  },
  {
    "id": 240,
    "name": "Clint Loggan",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/t/kttlw44rtb8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 60,
      "control": 60,
      "pressure": 45,
      "agility": 60,
      "physical": 40,
      "technique": 61
    }
  },
  {
    "id": 241,
    "name": "Suzanne Yuma",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/v/pvffvewm8xm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 42,
      "control": 59,
      "pressure": 62,
      "agility": 46,
      "physical": 56,
      "technique": 52
    }
  },
  {
    "id": 242,
    "name": "Tammy Fielding",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/a/vamqgzjujr8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 45,
      "control": 55,
      "pressure": 60,
      "agility": 58,
      "physical": 71,
      "technique": 52
    }
  },
  {
    "id": 243,
    "name": "Alex Lovely",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/o/eoxlrmfukiu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 51,
      "control": 55,
      "pressure": 58,
      "agility": 42,
      "physical": 53,
      "technique": 50
    }
  },
  {
    "id": 244,
    "name": "Louis Hillside",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/j/cjqxf_x4hku.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 57,
      "control": 47,
      "pressure": 57,
      "agility": 42,
      "physical": 70,
      "technique": 49
    }
  },
  {
    "id": 245,
    "name": "Ness Sheldon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/h/thh2oaxcmx8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 49,
      "control": 57,
      "pressure": 78,
      "agility": 49,
      "physical": 62,
      "technique": 54
    }
  },
  {
    "id": 246,
    "name": "Lizzy Squirrel",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/o/nocd7dek53m.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 64,
      "control": 54,
      "pressure": 40,
      "agility": 54,
      "physical": 50,
      "technique": 66
    }
  },
  {
    "id": 247,
    "name": "Kippy Jones",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/m/8mziwiiwuek.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 55,
      "control": 73,
      "pressure": 42,
      "agility": 48,
      "physical": 55,
      "technique": 46
    }
  },
  {
    "id": 248,
    "name": "Fayette Riversong",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/m/imm6nvhsz7m.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 54,
      "control": 62,
      "pressure": 49,
      "agility": 42,
      "physical": 49,
      "technique": 61
    }
  },
  {
    "id": 249,
    "name": "Samantha Moonlight",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/k/5k9bkqhoeik.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 46,
      "control": 46,
      "pressure": 54,
      "agility": 61,
      "physical": 44,
      "technique": 52
    }
  },
  {
    "id": 250,
    "name": "Mitch Sandstone",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/m/xmmwqroh_ke.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 59,
      "control": 77,
      "pressure": 56,
      "agility": 56,
      "physical": 54,
      "technique": 75
    }
  },
  {
    "id": 251,
    "name": "Eddie Prentice",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/k/mkx39uobsxs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 47,
      "control": 51,
      "pressure": 43,
      "agility": 58,
      "physical": 45,
      "technique": 55
    }
  },
  {
    "id": 252,
    "name": "Alf Holmes",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/l/gl0cuzdtn3c.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 49,
      "control": 41,
      "pressure": 65,
      "agility": 40,
      "physical": 77,
      "technique": 53
    }
  },
  {
    "id": 253,
    "name": "Ian Stager",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/j/3jfjdm7pke0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 43,
      "pressure": 69,
      "agility": 55,
      "physical": 53,
      "technique": 41
    }
  },
  {
    "id": 254,
    "name": "Fred Crumb",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/c/1cc_tvpfpc0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 43,
      "control": 54,
      "pressure": 62,
      "agility": 54,
      "physical": 53,
      "technique": 49
    }
  },
  {
    "id": 255,
    "name": "Doug Baughan",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/q/eqzeaqp_ixc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 43,
      "control": 54,
      "pressure": 48,
      "agility": 64,
      "physical": 48,
      "technique": 47
    }
  },
  {
    "id": 256,
    "name": "Pip Daltry",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/f/kfqrt363xrs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 41,
      "control": 54,
      "pressure": 60,
      "agility": 58,
      "physical": 68,
      "technique": 56
    }
  },
  {
    "id": 257,
    "name": "Chester Horse Jr",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/e/nefbdmkicqu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 68,
      "control": 70,
      "pressure": 50,
      "agility": 40,
      "physical": 48,
      "technique": 55
    }
  },
  {
    "id": 258,
    "name": "Julia Blaze",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/1/v1wcdbbizyk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 68,
      "control": 68,
      "pressure": 51,
      "agility": 57,
      "physical": 54,
      "technique": 69
    }
  },
  {
    "id": 262,
    "name": "Andy",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/f/zfhygptxm1s.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 53,
      "control": 46,
      "pressure": 67,
      "agility": 59,
      "physical": 55,
      "technique": 49
    }
  },
  {
    "id": 263,
    "name": "Aurelia Dingle",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/p/_py5t_gcyv8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 51,
      "control": 76,
      "pressure": 48,
      "agility": 50,
      "physical": 43,
      "technique": 62
    }
  },
  {
    "id": 264,
    "name": "Jimmy Mach",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/u/tuxgrhzrrgs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 42,
      "control": 59,
      "pressure": 59,
      "agility": 63,
      "physical": 48,
      "technique": 48
    }
  },
  {
    "id": 265,
    "name": "Tony Hacker",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/b/nbsv4asjemc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 67,
      "control": 69,
      "pressure": 53,
      "agility": 47,
      "physical": 57,
      "technique": 66
    }
  },
  {
    "id": 266,
    "name": "Dan Rhino",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/p/8pj0vlkzzv0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 77,
      "control": 62,
      "pressure": 40,
      "agility": 59,
      "physical": 41,
      "technique": 61
    }
  },
  {
    "id": 267,
    "name": "Vin Fleetwood",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/i/-iko78y12t0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 50,
      "control": 51,
      "pressure": 46,
      "agility": 64,
      "physical": 40,
      "technique": 47
    }
  },
  {
    "id": 268,
    "name": "George Winters",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/g/pgvjwd-pbgc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 56,
      "control": 59,
      "pressure": 50,
      "agility": 70,
      "physical": 53,
      "technique": 74
    }
  },
  {
    "id": 269,
    "name": "Den Hidden",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/p/vp28felhuas.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 53,
      "control": 55,
      "pressure": 58,
      "agility": 60,
      "physical": 60,
      "technique": 50
    }
  },
  {
    "id": 270,
    "name": "Shaun Imago",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/n/enhdoht9dze.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 41,
      "control": 56,
      "pressure": 63,
      "agility": 42,
      "physical": 68,
      "technique": 45
    }
  },
  {
    "id": 271,
    "name": "Joe Straiter",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/n/qn4fzsufkms.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 56,
      "control": 48,
      "pressure": 69,
      "agility": 58,
      "physical": 61,
      "technique": 51
    }
  },
  {
    "id": 272,
    "name": "Rupert Spiers",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/l/bljk0tilj_e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 72,
      "control": 66,
      "pressure": 41,
      "agility": 58,
      "physical": 53,
      "technique": 48
    }
  },
  {
    "id": 273,
    "name": "Mark Sudor",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/n/1nspusbsotk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 44,
      "control": 44,
      "pressure": 68,
      "agility": 47,
      "physical": 58,
      "technique": 45
    }
  },
  {
    "id": 274,
    "name": "Ringo Stagg",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/l/eljidtnwfgm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 42,
      "control": 56,
      "pressure": 77,
      "agility": 49,
      "physical": 71,
      "technique": 42
    }
  },
  {
    "id": 275,
    "name": "Jody MacGough",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/k/kka9qwsewa8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 41,
      "control": 47,
      "pressure": 61,
      "agility": 52,
      "physical": 67,
      "technique": 40
    }
  },
  {
    "id": 276,
    "name": "Jeeves Dropper",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/i/vixc9p0kdzu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 74,
      "control": 72,
      "pressure": 60,
      "agility": 45,
      "physical": 55,
      "technique": 51
    }
  },
  {
    "id": 277,
    "name": "Dan Dandy",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/d/xd2atwmiy1u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 60,
      "control": 43,
      "pressure": 72,
      "agility": 47,
      "physical": 63,
      "technique": 48
    }
  },
  {
    "id": 278,
    "name": "Rory Boomer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/r/mrhh-pay1g8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 69,
      "control": 65,
      "pressure": 57,
      "agility": 45,
      "physical": 40,
      "technique": 50
    }
  },
  {
    "id": 279,
    "name": "Tim Toppel",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/e/gekut016amm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 48,
      "control": 47,
      "pressure": 74,
      "agility": 54,
      "physical": 52,
      "technique": 52
    }
  },
  {
    "id": 280,
    "name": "Ames Shivers",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/s/3sv1altatvk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 54,
      "control": 51,
      "pressure": 77,
      "agility": 59,
      "physical": 66,
      "technique": 41
    }
  },
  {
    "id": 281,
    "name": "Chris Glover",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/g/dgqtxgqikqm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 70,
      "control": 70,
      "pressure": 48,
      "agility": 56,
      "physical": 55,
      "technique": 59
    }
  },
  {
    "id": 282,
    "name": "Thor Toise",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/u/yubmc52ynzk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 61,
      "control": 69,
      "pressure": 50,
      "agility": 53,
      "physical": 57,
      "technique": 58
    }
  },
  {
    "id": 283,
    "name": "Colin Salts",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/g/8guhywctymm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 50,
      "control": 58,
      "pressure": 60,
      "agility": 70,
      "physical": 42,
      "technique": 74
    }
  },
  {
    "id": 284,
    "name": "Christian Dear",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/u/nulmfp6x1_k.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 42,
      "control": 41,
      "pressure": 68,
      "agility": 50,
      "physical": 51,
      "technique": 47
    }
  },
  {
    "id": 285,
    "name": "Iggy Loyaller",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/b/tbgtmspfafu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 83,
      "intelligence": 45,
      "control": 52,
      "pressure": 59,
      "agility": 77,
      "physical": 49,
      "technique": 54
    }
  },
  {
    "id": 286,
    "name": "Conan Fox",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/p/cp3yhtplts8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 52,
      "control": 42,
      "pressure": 72,
      "agility": 41,
      "physical": 55,
      "technique": 54
    }
  },
  {
    "id": 287,
    "name": "Spike Coiffs",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/i/eiwup07joq8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 47,
      "control": 51,
      "pressure": 61,
      "agility": 50,
      "physical": 58,
      "technique": 52
    }
  },
  {
    "id": 288,
    "name": "Roger Rocket",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/g/vgbpildzfzu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 40,
      "control": 53,
      "pressure": 62,
      "agility": 41,
      "physical": 64,
      "technique": 60
    }
  },
  {
    "id": 289,
    "name": "Bill Teller",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/p/ppi6xwo7w5k.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 49,
      "control": 42,
      "pressure": 69,
      "agility": 50,
      "physical": 71,
      "technique": 42
    }
  },
  {
    "id": 290,
    "name": "Billy Nomates",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/n/-ntbcpobdkm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 47,
      "control": 46,
      "pressure": 79,
      "agility": 41,
      "physical": 66,
      "technique": 59
    }
  },
  {
    "id": 291,
    "name": "Harry Caine",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/n/knsdtknj61k.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 54,
      "control": 48,
      "pressure": 58,
      "agility": 48,
      "physical": 68,
      "technique": 48
    }
  },
  {
    "id": 292,
    "name": "Martin Sheller",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/l/7ldiabrzxgm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 50,
      "control": 58,
      "pressure": 59,
      "agility": 61,
      "physical": 49,
      "technique": 55
    }
  },
  {
    "id": 293,
    "name": "Alfie Fine",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/n/vngvaaiq2qs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 50,
      "control": 56,
      "pressure": 61,
      "agility": 44,
      "physical": 75,
      "technique": 48
    }
  },
  {
    "id": 294,
    "name": "Cameron Mann",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/l/kl3o3leqbze.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 74,
      "control": 61,
      "pressure": 55,
      "agility": 53,
      "physical": 45,
      "technique": 59
    }
  },
  {
    "id": 295,
    "name": "Don Keys",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/k/eku7k4xiu50.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 44,
      "control": 46,
      "pressure": 49,
      "agility": 65,
      "physical": 47,
      "technique": 65
    }
  },
  {
    "id": 296,
    "name": "Sonny East",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/i/1ilajhxydkc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 41,
      "control": 49,
      "pressure": 78,
      "agility": 52,
      "physical": 77,
      "technique": 48
    }
  },
  {
    "id": 297,
    "name": "Dan Carpenter",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/d/3dignef0gmc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 47,
      "control": 60,
      "pressure": 70,
      "agility": 53,
      "physical": 64,
      "technique": 48
    }
  },
  {
    "id": 298,
    "name": "Doug Walker",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/r/grtnkhjor_0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 51,
      "control": 41,
      "pressure": 78,
      "agility": 50,
      "physical": 59,
      "technique": 60
    }
  },
  {
    "id": 299,
    "name": "Frank Drake",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/e/mewsz8wgefe.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 53,
      "control": 58,
      "pressure": 61,
      "agility": 42,
      "physical": 66,
      "technique": 55
    }
  },
  {
    "id": 300,
    "name": "Chris Massey",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/s/xsbz0dw8zss.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 59,
      "control": 49,
      "pressure": 60,
      "agility": 44,
      "physical": 61,
      "technique": 53
    }
  },
  {
    "id": 301,
    "name": "Carl Sacks",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/g/jg-rfozeute.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 40,
      "control": 48,
      "pressure": 46,
      "agility": 61,
      "physical": 56,
      "technique": 63
    }
  },
  {
    "id": 302,
    "name": "Biff Beeston",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/u/supkoxvk5gs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 44,
      "control": 53,
      "pressure": 73,
      "agility": 60,
      "physical": 59,
      "technique": 51
    }
  },
  {
    "id": 303,
    "name": "Lou Beigh",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/q/uqzbl0mu4zc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 47,
      "control": 49,
      "pressure": 70,
      "agility": 58,
      "physical": 75,
      "technique": 42
    }
  },
  {
    "id": 304,
    "name": "Marv Errick",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/4/f4o6mlauva0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 48,
      "control": 43,
      "pressure": 64,
      "agility": 40,
      "physical": 74,
      "technique": 48
    }
  },
  {
    "id": 305,
    "name": "Bob Whittle",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/x/_xlp1w1cgge.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 59,
      "control": 60,
      "pressure": 42,
      "agility": 72,
      "physical": 60,
      "technique": 62
    }
  },
  {
    "id": 306,
    "name": "Bert Neptune",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/_/o_6uyptmnts.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 63,
      "control": 61,
      "pressure": 57,
      "agility": 60,
      "physical": 59,
      "technique": 56
    }
  },
  {
    "id": 307,
    "name": "Sol Crater",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/e/me9y2wbkivs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 59,
      "control": 51,
      "pressure": 41,
      "agility": 70,
      "physical": 53,
      "technique": 50
    }
  },
  {
    "id": 308,
    "name": "Percy Coldstair",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/2/92mtbpnwlme.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 50,
      "control": 49,
      "pressure": 69,
      "agility": 41,
      "physical": 56,
      "technique": 44
    }
  },
  {
    "id": 309,
    "name": "Dusky Sunfield",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/z/dzvmiss4qg0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 73,
      "control": 68,
      "pressure": 57,
      "agility": 52,
      "physical": 51,
      "technique": 67
    }
  },
  {
    "id": 310,
    "name": "Rocky Shears",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/x/sxehlt0c91c.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 46,
      "control": 52,
      "pressure": 50,
      "agility": 49,
      "physical": 74,
      "technique": 40
    }
  },
  {
    "id": 311,
    "name": "Percy Stent",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/b/ybhfug3gak0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 54,
      "control": 57,
      "pressure": 65,
      "agility": 43,
      "physical": 53,
      "technique": 59
    }
  },
  {
    "id": 312,
    "name": "Art Pendragon",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/z/pzq-5fra35c.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 54,
      "control": 41,
      "pressure": 61,
      "agility": 46,
      "physical": 64,
      "technique": 45
    }
  },
  {
    "id": 313,
    "name": "Dom Ittory",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/b/hblzjeytwv8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 29,
      "intelligence": 49,
      "control": 56,
      "pressure": 76,
      "agility": 50,
      "physical": 75,
      "technique": 59
    }
  },
  {
    "id": 314,
    "name": "Chaz Biggins",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/z/2z6soh-p7mu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 42,
      "control": 57,
      "pressure": 54,
      "agility": 56,
      "physical": 60,
      "technique": 72
    }
  },
  {
    "id": 315,
    "name": "Sly O'Hands",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/c/wcznd8lhogk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 41,
      "control": 49,
      "pressure": 59,
      "agility": 57,
      "physical": 59,
      "technique": 44
    }
  },
  {
    "id": 316,
    "name": "Sean Lavender",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/0/n0ogwdtbj1m.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 43,
      "control": 53,
      "pressure": 59,
      "agility": 50,
      "physical": 44,
      "technique": 54
    }
  },
  {
    "id": 317,
    "name": "Ace Server",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/v/lvvaea_3mzm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 30,
      "intelligence": 49,
      "control": 51,
      "pressure": 76,
      "agility": 45,
      "physical": 72,
      "technique": 50
    }
  },
  {
    "id": 318,
    "name": "Horace Nelson",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/9/u9e7zlznlak.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 41,
      "control": 58,
      "pressure": 69,
      "agility": 56,
      "physical": 74,
      "technique": 59
    }
  },
  {
    "id": 319,
    "name": "Philip Prince",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/6/f6mvnhk_tt8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 42,
      "control": 41,
      "pressure": 72,
      "agility": 52,
      "physical": 62,
      "technique": 56
    }
  },
  {
    "id": 320,
    "name": "Heath Rower",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/q/xqz38kjd0su.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 56,
      "control": 57,
      "pressure": 43,
      "agility": 57,
      "physical": 60,
      "technique": 49
    }
  },
  {
    "id": 321,
    "name": "Kim Arite",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/4/a4cwr1vnzf8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 44,
      "control": 54,
      "pressure": 77,
      "agility": 51,
      "physical": 76,
      "technique": 49
    }
  },
  {
    "id": 322,
    "name": "Jay Archer",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/q/oqnd_8fsmku.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 43,
      "control": 45,
      "pressure": 51,
      "agility": 57,
      "physical": 53,
      "technique": 58
    }
  },
  {
    "id": 323,
    "name": "Bo Ling",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/4/_488sdjol58.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 58,
      "control": 47,
      "pressure": 74,
      "agility": 51,
      "physical": 64,
      "technique": 48
    }
  },
  {
    "id": 324,
    "name": "Chuck Hardy",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/x/fxfjbewg-zm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 54,
      "control": 50,
      "pressure": 43,
      "agility": 67,
      "physical": 47,
      "technique": 49
    }
  },
  {
    "id": 325,
    "name": "Ben Evolent",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/_/u_uoshwatqk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 48,
      "control": 43,
      "pressure": 45,
      "agility": 72,
      "physical": 47,
      "technique": 57
    }
  },
  {
    "id": 326,
    "name": "Will Noble",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/e/sep0c4i2wsk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 57,
      "control": 56,
      "pressure": 54,
      "agility": 55,
      "physical": 71,
      "technique": 44
    }
  },
  {
    "id": 327,
    "name": "Jack Frosty",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/2/d2yvvhem7fm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 43,
      "control": 53,
      "pressure": 76,
      "agility": 45,
      "physical": 68,
      "technique": 49
    }
  },
  {
    "id": 328,
    "name": "Larry Helps",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/z/9z7g8axeo_8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 53,
      "control": 56,
      "pressure": 46,
      "agility": 66,
      "physical": 44,
      "technique": 49
    }
  },
  {
    "id": 329,
    "name": "Monty Patten",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/x/mxkbrlx-jmu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 45,
      "control": 58,
      "pressure": 65,
      "agility": 47,
      "physical": 66,
      "technique": 59
    }
  },
  {
    "id": 330,
    "name": "Chunk Gorman",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/b/4b1zgoucez8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 41,
      "control": 60,
      "pressure": 53,
      "agility": 54,
      "physical": 60,
      "technique": 68
    }
  },
  {
    "id": 331,
    "name": "Balt Decker",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/z/jze4nxympau.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 44,
      "control": 40,
      "pressure": 54,
      "agility": 50,
      "physical": 60,
      "technique": 57
    }
  },
  {
    "id": 332,
    "name": "Drew Crenshaw",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/b/nbf1xw7vis0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 59,
      "control": 59,
      "pressure": 54,
      "agility": 59,
      "physical": 78,
      "technique": 47
    }
  },
  {
    "id": 333,
    "name": "Stan Trum",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/z/wzuu6pdvlfc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 44,
      "control": 44,
      "pressure": 52,
      "agility": 77,
      "physical": 41,
      "technique": 61
    }
  },
  {
    "id": 334,
    "name": "Sham Spike",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/c/2cnhp0odq_s.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 75,
      "control": 64,
      "pressure": 46,
      "agility": 46,
      "physical": 42,
      "technique": 67
    }
  },
  {
    "id": 335,
    "name": "Rainier Welkin",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/0/h08aelon9me.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 42,
      "control": 59,
      "pressure": 69,
      "agility": 40,
      "physical": 74,
      "technique": 53
    }
  },
  {
    "id": 336,
    "name": "Evan Yielding",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/v/fv7cqscl4ke.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 82,
      "intelligence": 42,
      "control": 59,
      "pressure": 51,
      "agility": 63,
      "physical": 54,
      "technique": 64
    }
  },
  {
    "id": 337,
    "name": "Phil Anthropic",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/9/09k9ht6xv5s.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 58,
      "control": 51,
      "pressure": 49,
      "agility": 69,
      "physical": 52,
      "technique": 50
    }
  },
  {
    "id": 338,
    "name": "Fane Club",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/s/uspiuwp5gzc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 58,
      "control": 42,
      "pressure": 61,
      "agility": 47,
      "physical": 53,
      "technique": 58
    }
  },
  {
    "id": 339,
    "name": "Slim Lanky",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/6/l6yp5ppdnq0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 42,
      "control": 47,
      "pressure": 59,
      "agility": 42,
      "physical": 68,
      "technique": 42
    }
  },
  {
    "id": 340,
    "name": "Doug Lee",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/q/rqnxicqhqvc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 56,
      "control": 58,
      "pressure": 72,
      "agility": 47,
      "physical": 56,
      "technique": 50
    }
  },
  {
    "id": 341,
    "name": "Edward Albion",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/4/g4wql9mbhm0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 29,
      "intelligence": 57,
      "control": 43,
      "pressure": 55,
      "agility": 51,
      "physical": 55,
      "technique": 46
    }
  },
  {
    "id": 342,
    "name": "Stu Dent",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/8/k8di59sp5n8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 60,
      "control": 43,
      "pressure": 68,
      "agility": 50,
      "physical": 67,
      "technique": 46
    }
  },
  {
    "id": 343,
    "name": "Barry Straw",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/u/7uyduc0tu-u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 42,
      "control": 52,
      "pressure": 55,
      "agility": 71,
      "physical": 48,
      "technique": 49
    }
  },
  {
    "id": 344,
    "name": "Bobby Peel",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/7/b7r2hfbbhek.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 68,
      "control": 71,
      "pressure": 44,
      "agility": 42,
      "physical": 48,
      "technique": 66
    }
  },
  {
    "id": 345,
    "name": "Dan Castella",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/t/qtgxqgnhmtm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 48,
      "control": 47,
      "pressure": 75,
      "agility": 41,
      "physical": 67,
      "technique": 42
    }
  },
  {
    "id": 346,
    "name": "Bill Moony",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/y/oynle51njrm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 52,
      "control": 53,
      "pressure": 50,
      "agility": 58,
      "physical": 55,
      "technique": 70
    }
  },
  {
    "id": 347,
    "name": "Buddy Goodman",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/a/zawqpgt3kyk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 59,
      "control": 53,
      "pressure": 58,
      "agility": 47,
      "physical": 64,
      "technique": 52
    }
  },
  {
    "id": 348,
    "name": "Dex Territy",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/1/511f6bm_r4u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 54,
      "control": 51,
      "pressure": 65,
      "agility": 44,
      "physical": 67,
      "technique": 44
    }
  },
  {
    "id": 349,
    "name": "Vinny O'Gaines",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/d/ide-xkaf8l8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 69,
      "control": 68,
      "pressure": 57,
      "agility": 47,
      "physical": 53,
      "technique": 59
    }
  },
  {
    "id": 350,
    "name": "Ray Deo",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/3/837mmpdnb0u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 44,
      "control": 53,
      "pressure": 71,
      "agility": 56,
      "physical": 66,
      "technique": 48
    }
  },
  {
    "id": 351,
    "name": "Archie Meades",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/f/nfkhlwld2h8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 40,
      "control": 53,
      "pressure": 60,
      "agility": 40,
      "physical": 73,
      "technique": 53
    }
  },
  {
    "id": 352,
    "name": "Dave Chaucer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/3/j3rkrxsuxrc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 77,
      "control": 78,
      "pressure": 51,
      "agility": 60,
      "physical": 58,
      "technique": 48
    }
  },
  {
    "id": 353,
    "name": "Billy Blanc",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/f/sfgr8oku6y0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 59,
      "control": 60,
      "pressure": 44,
      "agility": 68,
      "physical": 41,
      "technique": 58
    }
  },
  {
    "id": 354,
    "name": "Creed Craving",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/w/ywdev1_mp4e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 47,
      "control": 40,
      "pressure": 78,
      "agility": 54,
      "physical": 60,
      "technique": 47
    }
  },
  {
    "id": 355,
    "name": "Phil Rosey",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/y/dyy_ckzcils.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 40,
      "control": 57,
      "pressure": 42,
      "agility": 58,
      "physical": 52,
      "technique": 50
    }
  },
  {
    "id": 356,
    "name": "Harry Redcastle",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/5/b51jstlwnns.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 66,
      "control": 59,
      "pressure": 51,
      "agility": 52,
      "physical": 52,
      "technique": 61
    }
  },
  {
    "id": 357,
    "name": "Sonny Welkin",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/r/wrecbstkk-e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 61,
      "control": 59,
      "pressure": 57,
      "agility": 56,
      "physical": 56,
      "technique": 58
    }
  },
  {
    "id": 358,
    "name": "Teddy Kodiak",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/-/q-n3sxyc_e0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 70,
      "control": 63,
      "pressure": 50,
      "agility": 54,
      "physical": 60,
      "technique": 55
    }
  },
  {
    "id": 359,
    "name": "Lloyd Tabb",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/w/hwww_o-4stc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 40,
      "control": 49,
      "pressure": 57,
      "agility": 43,
      "physical": 74,
      "technique": 60
    }
  },
  {
    "id": 360,
    "name": "Francis Paine",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/8/v8pood9a1s0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 75,
      "control": 65,
      "pressure": 55,
      "agility": 59,
      "physical": 53,
      "technique": 61
    }
  },
  {
    "id": 361,
    "name": "Griff Strummer",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/u/kuyvj8bgyhc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 51,
      "control": 59,
      "pressure": 74,
      "agility": 60,
      "physical": 61,
      "technique": 50
    }
  },
  {
    "id": 362,
    "name": "Bryce Bergman",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/2/f2xv6jblyuk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 66,
      "control": 64,
      "pressure": 43,
      "agility": 54,
      "physical": 45,
      "technique": 62
    }
  },
  {
    "id": 363,
    "name": "Fingus Inky",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/e/ueaox2nx1nm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 57,
      "control": 69,
      "pressure": 58,
      "agility": 51,
      "physical": 54,
      "technique": 57
    }
  },
  {
    "id": 364,
    "name": "Walter Geyser",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/x/oxj7ers5ah8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 54,
      "control": 59,
      "pressure": 44,
      "agility": 54,
      "physical": 49,
      "technique": 72
    }
  },
  {
    "id": 365,
    "name": "Les Knightley",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/z/_zsapu0dt0u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 40,
      "control": 53,
      "pressure": 69,
      "agility": 51,
      "physical": 73,
      "technique": 47
    }
  },
  {
    "id": 366,
    "name": "Conor Abley",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/4/94vghnmvoyu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 47,
      "control": 40,
      "pressure": 72,
      "agility": 47,
      "physical": 66,
      "technique": 44
    }
  },
  {
    "id": 367,
    "name": "Ainsley Burns",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/q/mqknqyavfb8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 59,
      "control": 47,
      "pressure": 43,
      "agility": 60,
      "physical": 47,
      "technique": 60
    }
  },
  {
    "id": 368,
    "name": "Pete Grimes",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/_/s_hs5v1dwhm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 41,
      "control": 54,
      "pressure": 75,
      "agility": 53,
      "physical": 74,
      "technique": 43
    }
  },
  {
    "id": 369,
    "name": "Manny Steele",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/x/dx2zuqtndsk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 68,
      "control": 67,
      "pressure": 57,
      "agility": 55,
      "physical": 42,
      "technique": 57
    }
  },
  {
    "id": 370,
    "name": "Trey Hugger",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/9/p9jrldqf6tm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 40,
      "control": 47,
      "pressure": 59,
      "agility": 44,
      "physical": 74,
      "technique": 57
    }
  },
  {
    "id": 371,
    "name": "Jack Mate",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/v/yv4kii2_xek.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 51,
      "control": 42,
      "pressure": 59,
      "agility": 41,
      "physical": 80,
      "technique": 60
    }
  },
  {
    "id": 372,
    "name": "Mike Chequer",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/9/29jhsj_22ye.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 60,
      "control": 59,
      "pressure": 64,
      "agility": 52,
      "physical": 74,
      "technique": 45
    }
  },
  {
    "id": 373,
    "name": "Berty Adman",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/v/hvsm_czmbbs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 28,
      "intelligence": 52,
      "control": 47,
      "pressure": 76,
      "agility": 45,
      "physical": 72,
      "technique": 41
    }
  },
  {
    "id": 374,
    "name": "Troy Carr",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/6/n6xtsbseuhc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 51,
      "control": 49,
      "pressure": 47,
      "agility": 57,
      "physical": 41,
      "technique": 60
    }
  },
  {
    "id": 375,
    "name": "Hollis Ticure",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/s/wsayb-k-ds0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 60,
      "control": 41,
      "pressure": 43,
      "agility": 70,
      "physical": 40,
      "technique": 49
    }
  },
  {
    "id": 376,
    "name": "Guy Dance",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/z/uzhuvnysgu0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 67,
      "control": 55,
      "pressure": 40,
      "agility": 58,
      "physical": 59,
      "technique": 68
    }
  },
  {
    "id": 377,
    "name": "Jack Trumper",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/b/lb2pcy-ornc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 44,
      "control": 44,
      "pressure": 48,
      "agility": 64,
      "physical": 57,
      "technique": 67
    }
  },
  {
    "id": 378,
    "name": "John Corder",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/0/f0v6rflgehs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 60,
      "control": 44,
      "pressure": 47,
      "agility": 70,
      "physical": 56,
      "technique": 65
    }
  },
  {
    "id": 379,
    "name": "Nigel Bramel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/c/0ckb86taz0e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 52,
      "control": 44,
      "pressure": 64,
      "agility": 54,
      "physical": 62,
      "technique": 53
    }
  },
  {
    "id": 380,
    "name": "Hank O'Chief",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/2/a2bdn3u4uls.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 57,
      "control": 47,
      "pressure": 73,
      "agility": 48,
      "physical": 50,
      "technique": 58
    }
  },
  {
    "id": 381,
    "name": "Jess Uplement",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/e/xeqigiic54e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 65,
      "control": 65,
      "pressure": 60,
      "agility": 46,
      "physical": 52,
      "technique": 55
    }
  },
  {
    "id": 382,
    "name": "Alec Smart",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/2/_2lpobi3gts.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 43,
      "control": 48,
      "pressure": 66,
      "agility": 55,
      "physical": 67,
      "technique": 45
    }
  },
  {
    "id": 383,
    "name": "Rob Anchor",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/e/oeuij-enree.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 56,
      "control": 43,
      "pressure": 64,
      "agility": 55,
      "physical": 68,
      "technique": 40
    }
  },
  {
    "id": 384,
    "name": "Brent Cross",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/x/ux39wjxfe-0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 68,
      "control": 67,
      "pressure": 53,
      "agility": 52,
      "physical": 57,
      "technique": 63
    }
  },
  {
    "id": 385,
    "name": "Albert Wister",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/z/fzgcdcx_znc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 56,
      "control": 56,
      "pressure": 80,
      "agility": 42,
      "physical": 75,
      "technique": 42
    }
  },
  {
    "id": 386,
    "name": "Nev Erin",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/4/d4bazfft2lc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 60,
      "control": 54,
      "pressure": 41,
      "agility": 63,
      "physical": 53,
      "technique": 60
    }
  },
  {
    "id": 387,
    "name": "Caz Yewell",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/q/sqwhe6jpb40.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 49,
      "control": 47,
      "pressure": 67,
      "agility": 52,
      "physical": 69,
      "technique": 52
    }
  },
  {
    "id": 388,
    "name": "Conor Trail",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/_/m_tunnwhuye.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 46,
      "control": 57,
      "pressure": 64,
      "agility": 57,
      "physical": 68,
      "technique": 55
    }
  },
  {
    "id": 389,
    "name": "Manuel Gere",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/x/9xi1gywbdrs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 55,
      "control": 53,
      "pressure": 55,
      "agility": 56,
      "physical": 62,
      "technique": 47
    }
  },
  {
    "id": 390,
    "name": "Per Hockside",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/9/j9dtrvz5kue.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 44,
      "control": 57,
      "pressure": 47,
      "agility": 79,
      "physical": 43,
      "technique": 61
    }
  },
  {
    "id": 391,
    "name": "Lee Gleagle",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/v/4vsm8qvdjns.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 40,
      "control": 56,
      "pressure": 64,
      "agility": 51,
      "physical": 66,
      "technique": 53
    }
  },
  {
    "id": 392,
    "name": "Paul Pitcher",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/9/w93bmrckolm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 44,
      "control": 50,
      "pressure": 62,
      "agility": 52,
      "physical": 65,
      "technique": 57
    }
  },
  {
    "id": 393,
    "name": "Turner Fortune",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/v/nvgglu6wf4k.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 41,
      "control": 42,
      "pressure": 60,
      "agility": 52,
      "physical": 59,
      "technique": 58
    }
  },
  {
    "id": 394,
    "name": "Walter Walken",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/6/h6lvyjp4wyu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 48,
      "control": 59,
      "pressure": 72,
      "agility": 48,
      "physical": 61,
      "technique": 44
    }
  },
  {
    "id": 395,
    "name": "Sal Curie",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/s/2su012pcdr8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 58,
      "control": 40,
      "pressure": 76,
      "agility": 49,
      "physical": 69,
      "technique": 59
    }
  },
  {
    "id": 396,
    "name": "Silver Platt",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/z/0ztobv7uyt8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 55,
      "control": 44,
      "pressure": 61,
      "agility": 51,
      "physical": 61,
      "technique": 40
    }
  },
  {
    "id": 397,
    "name": "Nick Yergrub",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/b/fbij2qdu1eu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 50,
      "control": 52,
      "pressure": 49,
      "agility": 62,
      "physical": 44,
      "technique": 66
    }
  },
  {
    "id": 398,
    "name": "Mal Inger",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/0/l0b8lnoca-k.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 50,
      "control": 55,
      "pressure": 71,
      "agility": 57,
      "physical": 63,
      "technique": 59
    }
  },
  {
    "id": 399,
    "name": "Jim Cook",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/c/ucwdiyomtnm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 49,
      "control": 56,
      "pressure": 59,
      "agility": 42,
      "physical": 77,
      "technique": 56
    }
  },
  {
    "id": 400,
    "name": "Gus Potter",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/2/g2pf5_nekyk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 42,
      "control": 56,
      "pressure": 76,
      "agility": 40,
      "physical": 69,
      "technique": 56
    }
  },
  {
    "id": 401,
    "name": "Handel Turnon",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/e/re-kuar-nbm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 55,
      "control": 53,
      "pressure": 61,
      "agility": 43,
      "physical": 74,
      "technique": 44
    }
  },
  {
    "id": 402,
    "name": "Peter Malus",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/g/tgo13fy0ms8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 65,
      "control": 67,
      "pressure": 43,
      "agility": 47,
      "physical": 56,
      "technique": 64
    }
  },
  {
    "id": 403,
    "name": "Colin Lection",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/i/cizua6-olhu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 49,
      "control": 49,
      "pressure": 75,
      "agility": 46,
      "physical": 69,
      "technique": 53
    }
  },
  {
    "id": 404,
    "name": "Brock Twigg",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/n/8n6hjnlg-bk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 61,
      "control": 67,
      "pressure": 57,
      "agility": 57,
      "physical": 50,
      "technique": 65
    }
  },
  {
    "id": 405,
    "name": "Paddy Rise",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/p/nplakyt8tym.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 57,
      "control": 43,
      "pressure": 70,
      "agility": 45,
      "physical": 60,
      "technique": 40
    }
  },
  {
    "id": 406,
    "name": "Dustin Westend",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/u/pumckb_qw0m.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 82,
      "intelligence": 44,
      "control": 48,
      "pressure": 58,
      "agility": 58,
      "physical": 52,
      "technique": 62
    }
  },
  {
    "id": 407,
    "name": "Alfonse Way",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/g/-g99n-zq7hk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 69,
      "control": 55,
      "pressure": 52,
      "agility": 48,
      "physical": 46,
      "technique": 71
    }
  },
  {
    "id": 408,
    "name": "Pippin Flowers",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/p/epei0jsionu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 47,
      "control": 56,
      "pressure": 44,
      "agility": 62,
      "physical": 60,
      "technique": 53
    }
  },
  {
    "id": 409,
    "name": "Euan Stamper",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/b/vbvpzckyju8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 49,
      "control": 52,
      "pressure": 64,
      "agility": 42,
      "physical": 64,
      "technique": 51
    }
  },
  {
    "id": 410,
    "name": "Paddy Prunus",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/r/brqxorj6eru.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 28,
      "intelligence": 58,
      "control": 47,
      "pressure": 76,
      "agility": 55,
      "physical": 74,
      "technique": 50
    }
  },
  {
    "id": 411,
    "name": "Brian Presser",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/d/qdhqfuvapy8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 42,
      "control": 40,
      "pressure": 50,
      "agility": 66,
      "physical": 54,
      "technique": 69
    }
  },
  {
    "id": 412,
    "name": "Pete LeGume",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/r/er6dfvmji0c.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 56,
      "control": 58,
      "pressure": 64,
      "agility": 56,
      "physical": 74,
      "technique": 49
    }
  },
  {
    "id": 413,
    "name": "Shylock Watson",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/d/1dl8yqazlh0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 56,
      "control": 48,
      "pressure": 69,
      "agility": 60,
      "physical": 53,
      "technique": 54
    }
  },
  {
    "id": 414,
    "name": "Ed Ripp",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/s/vsojhn17qne.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 50,
      "control": 52,
      "pressure": 74,
      "agility": 44,
      "physical": 75,
      "technique": 42
    }
  },
  {
    "id": 415,
    "name": "Hike Basher",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/e/kezomytb9us.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 52,
      "control": 48,
      "pressure": 40,
      "agility": 71,
      "physical": 47,
      "technique": 65
    }
  },
  {
    "id": 416,
    "name": "Anthony Phinder",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/l/mle0irbt4ss.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 46,
      "control": 51,
      "pressure": 56,
      "agility": 62,
      "physical": 58,
      "technique": 51
    }
  },
  {
    "id": 417,
    "name": "Duncan Jump",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/n/xnvvpunxvhe.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 57,
      "control": 40,
      "pressure": 69,
      "agility": 49,
      "physical": 58,
      "technique": 56
    }
  },
  {
    "id": 418,
    "name": "Lucky Winn",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/i/3imgcjsfgb0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 62,
      "control": 60,
      "pressure": 60,
      "agility": 60,
      "physical": 43,
      "technique": 63
    }
  },
  {
    "id": 419,
    "name": "Gene Bates",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/k/gk9bx20lnyc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 42,
      "control": 56,
      "pressure": 69,
      "agility": 49,
      "physical": 73,
      "technique": 49
    }
  },
  {
    "id": 420,
    "name": "Randolf Finn",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/g/ygcza73hqn0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 29,
      "intelligence": 56,
      "control": 45,
      "pressure": 80,
      "agility": 43,
      "physical": 54,
      "technique": 60
    }
  },
  {
    "id": 421,
    "name": "Ron Away",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/i/diz4ter9h-c.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 84,
      "intelligence": 49,
      "control": 47,
      "pressure": 47,
      "agility": 60,
      "physical": 51,
      "technique": 62
    }
  },
  {
    "id": 422,
    "name": "Rick Hatter",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/g/ng8zdn7i4r0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 55,
      "control": 51,
      "pressure": 56,
      "agility": 69,
      "physical": 41,
      "technique": 52
    }
  },
  {
    "id": 423,
    "name": "Grant Mardy",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/i/8insuydyvyc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 57,
      "control": 46,
      "pressure": 59,
      "agility": 42,
      "physical": 63,
      "technique": 52
    }
  },
  {
    "id": 424,
    "name": "Shawn Broker",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/n/cnun9vo6g4s.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 52,
      "control": 44,
      "pressure": 61,
      "agility": 57,
      "physical": 72,
      "technique": 41
    }
  },
  {
    "id": 425,
    "name": "Anthony Coyne",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/p/tpfgqqoanle.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 41,
      "control": 42,
      "pressure": 66,
      "agility": 51,
      "physical": 59,
      "technique": 52
    }
  },
  {
    "id": 426,
    "name": "Healey Proctor",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/u/vuya-jcsine.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 58,
      "control": 64,
      "pressure": 42,
      "agility": 42,
      "physical": 52,
      "technique": 55
    }
  },
  {
    "id": 427,
    "name": "Ade Posting",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/g/egp7t26wl-s.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 55,
      "control": 46,
      "pressure": 55,
      "agility": 70,
      "physical": 57,
      "technique": 57
    }
  },
  {
    "id": 428,
    "name": "Doug Outon",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/p/-pkoarpeqec.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 63,
      "control": 74,
      "pressure": 57,
      "agility": 42,
      "physical": 59,
      "technique": 70
    }
  },
  {
    "id": 429,
    "name": "Ebenezer Marner",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/b/pb7vtupk9t0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 53,
      "control": 47,
      "pressure": 62,
      "agility": 46,
      "physical": 64,
      "technique": 59
    }
  },
  {
    "id": 430,
    "name": "Davy Johns",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/r/7re3czqgasc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 54,
      "control": 40,
      "pressure": 57,
      "agility": 72,
      "physical": 48,
      "technique": 51
    }
  },
  {
    "id": 431,
    "name": "Bos Horne",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/d/kd1wxmm83h0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 42,
      "control": 50,
      "pressure": 56,
      "agility": 57,
      "physical": 73,
      "technique": 42
    }
  },
  {
    "id": 432,
    "name": "Nick Orner",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/r/krubrnf1wnu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 42,
      "control": 60,
      "pressure": 78,
      "agility": 50,
      "physical": 63,
      "technique": 40
    }
  },
  {
    "id": 433,
    "name": "Nathin Gaunt",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/d/vdf6gyjp7-8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 59,
      "control": 60,
      "pressure": 40,
      "agility": 60,
      "physical": 56,
      "technique": 61
    }
  },
  {
    "id": 434,
    "name": "Quentin Quartz",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/s/1s8pvfwhoem.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 53,
      "control": 57,
      "pressure": 52,
      "agility": 68,
      "physical": 53,
      "technique": 63
    }
  },
  {
    "id": 435,
    "name": "Andrew Meikle",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/e/eenu46w9jtk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 42,
      "control": 45,
      "pressure": 61,
      "agility": 44,
      "physical": 61,
      "technique": 54
    }
  },
  {
    "id": 436,
    "name": "Gary Salmon",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/l/glkywjirmrk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 42,
      "control": 55,
      "pressure": 70,
      "agility": 51,
      "physical": 51,
      "technique": 41
    }
  },
  {
    "id": 437,
    "name": "Fontaine Tapper",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/n/3n7t7cerlym.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 50,
      "control": 52,
      "pressure": 58,
      "agility": 55,
      "physical": 41,
      "technique": 54
    }
  },
  {
    "id": 438,
    "name": "Leon Lawn",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/i/xiymobxj-48.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 50,
      "control": 52,
      "pressure": 65,
      "agility": 54,
      "physical": 71,
      "technique": 44
    }
  },
  {
    "id": 439,
    "name": "Jim Sweatman",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/k/mkphf-xztlu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 50,
      "control": 48,
      "pressure": 82,
      "agility": 47,
      "physical": 74,
      "technique": 48
    }
  },
  {
    "id": 440,
    "name": "Cole Coaker",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/g/sgwf0zu7008.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 30,
      "intelligence": 50,
      "control": 58,
      "pressure": 81,
      "agility": 59,
      "physical": 73,
      "technique": 56
    }
  },
  {
    "id": 441,
    "name": "Stu Born",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/i/jin-zmybzhu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 29,
      "intelligence": 42,
      "control": 52,
      "pressure": 59,
      "agility": 54,
      "physical": 67,
      "technique": 54
    }
  },
  {
    "id": 442,
    "name": "Romeo Montague",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/m/jmymfmsznsc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 43,
      "control": 51,
      "pressure": 66,
      "agility": 56,
      "physical": 70,
      "technique": 43
    }
  },
  {
    "id": 443,
    "name": "Drew Straitedge",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/k/4kdtozkjkf0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 29,
      "intelligence": 57,
      "control": 57,
      "pressure": 70,
      "agility": 50,
      "physical": 68,
      "technique": 50
    }
  },
  {
    "id": 444,
    "name": "Dash Dotter",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/l/ylgy7u_b__e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 65,
      "control": 65,
      "pressure": 55,
      "agility": 52,
      "physical": 41,
      "technique": 65
    }
  },
  {
    "id": 445,
    "name": "Gill O'Mend",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/j/pjr5wrz7sms.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 75,
      "control": 67,
      "pressure": 57,
      "agility": 41,
      "physical": 48,
      "technique": 69
    }
  },
  {
    "id": 446,
    "name": "Pay Chance",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/c/rcwl4ilxxks.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 45,
      "control": 52,
      "pressure": 78,
      "agility": 46,
      "physical": 62,
      "technique": 47
    }
  },
  {
    "id": 447,
    "name": "Bill Aegis",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/q/aqnev3tt65e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 51,
      "control": 58,
      "pressure": 72,
      "agility": 54,
      "physical": 64,
      "technique": 52
    }
  },
  {
    "id": 448,
    "name": "Tosh Coach",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/f/6fexgqylpz0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 45,
      "control": 57,
      "pressure": 69,
      "agility": 41,
      "physical": 66,
      "technique": 52
    }
  },
  {
    "id": 449,
    "name": "Carl Gnu",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/t/lt1qrv-fiqc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 42,
      "control": 44,
      "pressure": 47,
      "agility": 55,
      "physical": 60,
      "technique": 66
    }
  },
  {
    "id": 450,
    "name": "Paul Sapp",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/h/_hkiay99fv0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 68,
      "control": 63,
      "pressure": 44,
      "agility": 51,
      "physical": 50,
      "technique": 57
    }
  },
  {
    "id": 451,
    "name": "Macky Valley",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/v/ov7p3nbhomc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 55,
      "control": 56,
      "pressure": 41,
      "agility": 76,
      "physical": 40,
      "technique": 61
    }
  },
  {
    "id": 452,
    "name": "Troy Trucker",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/h/ghgktmsojk8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 53,
      "control": 52,
      "pressure": 44,
      "agility": 74,
      "physical": 58,
      "technique": 68
    }
  },
  {
    "id": 453,
    "name": "Haden Seek",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/v/rvrfaz00k5u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 83,
      "intelligence": 41,
      "control": 44,
      "pressure": 50,
      "agility": 60,
      "physical": 40,
      "technique": 64
    }
  },
  {
    "id": 454,
    "name": "Kevin Doors",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/a/xaywteb8rzk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 42,
      "control": 59,
      "pressure": 51,
      "agility": 47,
      "physical": 75,
      "technique": 56
    }
  },
  {
    "id": 455,
    "name": "Skip Rooter",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/o/aodr-7ng8qm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 67,
      "control": 63,
      "pressure": 54,
      "agility": 46,
      "physical": 51,
      "technique": 65
    }
  },
  {
    "id": 456,
    "name": "Rip Airman",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/j/cjenqi1q5sm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 54,
      "control": 51,
      "pressure": 70,
      "agility": 43,
      "physical": 66,
      "technique": 46
    }
  },
  {
    "id": 457,
    "name": "Stu Shiner",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/h/zh1s9dtqufk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 40,
      "control": 59,
      "pressure": 83,
      "agility": 42,
      "physical": 62,
      "technique": 48
    }
  },
  {
    "id": 458,
    "name": "Matt Matickal",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/o/towzuamyh_u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 56,
      "control": 43,
      "pressure": 69,
      "agility": 53,
      "physical": 55,
      "technique": 60
    }
  },
  {
    "id": 459,
    "name": "Philip Flagg",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/m/imn4d_aimm8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 56,
      "control": 53,
      "pressure": 68,
      "agility": 54,
      "physical": 65,
      "technique": 59
    }
  },
  {
    "id": 460,
    "name": "Alf Groundsman",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/m/wmygyydarzu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 49,
      "control": 54,
      "pressure": 63,
      "agility": 43,
      "physical": 60,
      "technique": 53
    }
  },
  {
    "id": 461,
    "name": "Ernie Riddell",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/k/nkpbfnl6ga8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 52,
      "control": 46,
      "pressure": 57,
      "agility": 72,
      "physical": 51,
      "technique": 52
    }
  },
  {
    "id": 462,
    "name": "Len Stint",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/h/phckjgx5xlc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 43,
      "control": 52,
      "pressure": 63,
      "agility": 60,
      "physical": 64,
      "technique": 50
    }
  },
  {
    "id": 463,
    "name": "Holly Cricket",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/j/-jtrk5xdcw0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 65,
      "control": 70,
      "pressure": 57,
      "agility": 56,
      "physical": 48,
      "technique": 56
    }
  },
  {
    "id": 464,
    "name": "Jim Reed",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/o/vo__abixefs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 51,
      "control": 56,
      "pressure": 68,
      "agility": 48,
      "physical": 68,
      "technique": 52
    }
  },
  {
    "id": 465,
    "name": "Gwyn Penn",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/v/tv4j0cwdbds.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 46,
      "control": 45,
      "pressure": 74,
      "agility": 53,
      "physical": 67,
      "technique": 53
    }
  },
  {
    "id": 466,
    "name": "Spike Needle",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/h/chjcz9wnswe.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 43,
      "control": 46,
      "pressure": 54,
      "agility": 45,
      "physical": 74,
      "technique": 52
    }
  },
  {
    "id": 467,
    "name": "Ifan Tassy",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/o/8oq3kgjvzq0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 63,
      "control": 72,
      "pressure": 50,
      "agility": 44,
      "physical": 40,
      "technique": 69
    }
  },
  {
    "id": 468,
    "name": "Eggbert Heading",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/a/nabwnffv0jc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 44,
      "control": 43,
      "pressure": 43,
      "agility": 53,
      "physical": 48,
      "technique": 55
    }
  },
  {
    "id": 469,
    "name": "Pascal Blaise",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/q/5qkowsg3tc0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 52,
      "control": 46,
      "pressure": 75,
      "agility": 52,
      "physical": 64,
      "technique": 54
    }
  },
  {
    "id": 470,
    "name": "Will Whist",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/c/icvv7tgn-vc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 48,
      "control": 46,
      "pressure": 79,
      "agility": 44,
      "physical": 59,
      "technique": 41
    }
  },
  {
    "id": 471,
    "name": "Ewan Liner",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/q/mqoihspefd8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 51,
      "control": 59,
      "pressure": 69,
      "agility": 60,
      "physical": 63,
      "technique": 47
    }
  },
  {
    "id": 472,
    "name": "Buster Locke",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/c/xc_dmtp-ywu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 57,
      "control": 46,
      "pressure": 57,
      "agility": 53,
      "physical": 58,
      "technique": 58
    }
  },
  {
    "id": 473,
    "name": "Rex Plorer",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/t/3tc2fo62hqk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 46,
      "control": 55,
      "pressure": 40,
      "agility": 63,
      "physical": 55,
      "technique": 65
    }
  },
  {
    "id": 474,
    "name": "Webber Poster",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/f/gftxyxcmqjm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 72,
      "control": 52,
      "pressure": 52,
      "agility": 54,
      "physical": 58,
      "technique": 52
    }
  },
  {
    "id": 475,
    "name": "Sid Parting",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/k/ekqlcoogvlm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 45,
      "control": 43,
      "pressure": 64,
      "agility": 53,
      "physical": 78,
      "technique": 48
    }
  },
  {
    "id": 476,
    "name": "Eaton Rampage",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/m/1mbqxxoacwk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 54,
      "control": 60,
      "pressure": 46,
      "agility": 57,
      "physical": 49,
      "technique": 55
    }
  },
  {
    "id": 477,
    "name": "Parker Leaper",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/j/vj4fikds32u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 49,
      "control": 51,
      "pressure": 76,
      "agility": 49,
      "physical": 70,
      "technique": 41
    }
  },
  {
    "id": 478,
    "name": "Hank Halberd",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/l/klj-p17oaf8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 42,
      "control": 54,
      "pressure": 65,
      "agility": 49,
      "physical": 50,
      "technique": 42
    }
  },
  {
    "id": 479,
    "name": "Robin Catching",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/h/qh2m-44k96u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 30,
      "intelligence": 53,
      "control": 42,
      "pressure": 64,
      "agility": 48,
      "physical": 65,
      "technique": 53
    }
  },
  {
    "id": 480,
    "name": "Trey Spotter",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/j/hjhhthewqj8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 70,
      "control": 73,
      "pressure": 51,
      "agility": 58,
      "physical": 60,
      "technique": 63
    }
  },
  {
    "id": 481,
    "name": "Onslow Ball",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/h/vhim9o0fvcu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 54,
      "control": 58,
      "pressure": 60,
      "agility": 50,
      "physical": 61,
      "technique": 46
    }
  },
  {
    "id": 482,
    "name": "Tex Tingle",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/j/ej5tqxs_cv8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 42,
      "control": 58,
      "pressure": 55,
      "agility": 58,
      "physical": 65,
      "technique": 60
    }
  },
  {
    "id": 483,
    "name": "Sam Gale",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/m/-maydsn33pm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 54,
      "control": 43,
      "pressure": 66,
      "agility": 50,
      "physical": 66,
      "technique": 42
    }
  },
  {
    "id": 484,
    "name": "Ryder Waverly",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/o/por5utbna8k.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 57,
      "control": 63,
      "pressure": 49,
      "agility": 42,
      "physical": 56,
      "technique": 53
    }
  },
  {
    "id": 485,
    "name": "Leaf Scarlett",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/v/nvslakthf6k.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 55,
      "control": 54,
      "pressure": 45,
      "agility": 56,
      "physical": 45,
      "technique": 67
    }
  },
  {
    "id": 486,
    "name": "Horace Coop",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/h/8hdet11byjm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 59,
      "control": 59,
      "pressure": 72,
      "agility": 45,
      "physical": 73,
      "technique": 58
    }
  },
  {
    "id": 487,
    "name": "Ness Lockley",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/o/co-x-oathp8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 55,
      "control": 40,
      "pressure": 73,
      "agility": 58,
      "physical": 61,
      "technique": 54
    }
  },
  {
    "id": 488,
    "name": "Olef Tennant",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/a/tapqtxmpqau.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 53,
      "control": 46,
      "pressure": 74,
      "agility": 46,
      "physical": 65,
      "technique": 43
    }
  },
  {
    "id": 489,
    "name": "Len Scapp",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/q/zqwiiallnl8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 29,
      "intelligence": 52,
      "control": 58,
      "pressure": 65,
      "agility": 48,
      "physical": 54,
      "technique": 54
    }
  },
  {
    "id": 490,
    "name": "Monty Hillary",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/c/ocbppldxgwu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 52,
      "control": 44,
      "pressure": 46,
      "agility": 64,
      "physical": 48,
      "technique": 57
    }
  },
  {
    "id": 491,
    "name": "Penfold Pulper",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/q/gqakvkk4b60.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 56,
      "control": 53,
      "pressure": 49,
      "agility": 79,
      "physical": 44,
      "technique": 55
    }
  },
  {
    "id": 492,
    "name": "Thomas Cott",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/c/3crf4bscsjc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 48,
      "control": 50,
      "pressure": 78,
      "agility": 53,
      "physical": 62,
      "technique": 40
    }
  },
  {
    "id": 493,
    "name": "Spike Thorne",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/t/xtiwrgzkzps.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 50,
      "control": 60,
      "pressure": 65,
      "agility": 54,
      "physical": 55,
      "technique": 49
    }
  },
  {
    "id": 494,
    "name": "Lincoln Hawking",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/f/mf5rg5_w0ae.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 52,
      "control": 56,
      "pressure": 54,
      "agility": 61,
      "physical": 50,
      "technique": 46
    }
  },
  {
    "id": 495,
    "name": "Ted Larkin",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/k/kk-nogtcxce.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 73,
      "control": 72,
      "pressure": 57,
      "agility": 40,
      "physical": 49,
      "technique": 64
    }
  },
  {
    "id": 496,
    "name": "Madison Cabinet",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/m/vmpsfflmcvs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 42,
      "control": 52,
      "pressure": 58,
      "agility": 56,
      "physical": 57,
      "technique": 40
    }
  },
  {
    "id": 497,
    "name": "Odo Cologne",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/j/1jszwc-uppc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 59,
      "control": 66,
      "pressure": 57,
      "agility": 47,
      "physical": 50,
      "technique": 62
    }
  },
  {
    "id": 498,
    "name": "Nester Damus",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/l/eld479yue80.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 56,
      "control": 58,
      "pressure": 63,
      "agility": 50,
      "physical": 72,
      "technique": 54
    }
  },
  {
    "id": 499,
    "name": "Herb Ivore",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/h/whigkwb2jdc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 51,
      "control": 40,
      "pressure": 51,
      "agility": 60,
      "physical": 54,
      "technique": 55
    }
  },
  {
    "id": 500,
    "name": "Homer Pidgeon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/j/bjtbnp9mow0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 49,
      "control": 49,
      "pressure": 56,
      "agility": 46,
      "physical": 51,
      "technique": 50
    }
  },
  {
    "id": 501,
    "name": "Rob Ottley",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/3/93fqekogpje.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 64,
      "control": 64,
      "pressure": 60,
      "agility": 41,
      "physical": 56,
      "technique": 64
    }
  },
  {
    "id": 502,
    "name": "Scott Springer",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/f/mf0xp1o8iqs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 51,
      "control": 52,
      "pressure": 48,
      "agility": 58,
      "physical": 44,
      "technique": 66
    }
  },
  {
    "id": 503,
    "name": "Viv Grey",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/w/swxe6od0xwc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 57,
      "control": 47,
      "pressure": 72,
      "agility": 54,
      "physical": 62,
      "technique": 54
    }
  },
  {
    "id": 504,
    "name": "Don Snow",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/y/dymlxx7o6d0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 28,
      "intelligence": 54,
      "control": 58,
      "pressure": 70,
      "agility": 53,
      "physical": 53,
      "technique": 44
    }
  },
  {
    "id": 505,
    "name": "Hal Mullet",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/5/f5h55opi_f0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 62,
      "control": 61,
      "pressure": 58,
      "agility": 41,
      "physical": 57,
      "technique": 64
    }
  },
  {
    "id": 506,
    "name": "Isaiah Shutt",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/r/urqyuxpys2c.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 55,
      "control": 48,
      "pressure": 55,
      "agility": 61,
      "physical": 45,
      "technique": 49
    }
  },
  {
    "id": 507,
    "name": "Ace Irvin",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/-/o-zths6qnws.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 54,
      "control": 61,
      "pressure": 41,
      "agility": 47,
      "physical": 47,
      "technique": 67
    }
  },
  {
    "id": 508,
    "name": "Spike Pitt",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/w/_wcmqtcqkle.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 54,
      "control": 53,
      "pressure": 50,
      "agility": 69,
      "physical": 49,
      "technique": 58
    }
  },
  {
    "id": 509,
    "name": "Innes Caving",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/8/l89ubefitas.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 50,
      "control": 48,
      "pressure": 72,
      "agility": 53,
      "physical": 56,
      "technique": 48
    }
  },
  {
    "id": 510,
    "name": "Keanu Dell",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/u/6um12h5yape.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 50,
      "control": 45,
      "pressure": 52,
      "agility": 57,
      "physical": 47,
      "technique": 55
    }
  },
  {
    "id": 511,
    "name": "Casey Novak",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/8/u8x4sgw7hfk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 52,
      "control": 50,
      "pressure": 63,
      "agility": 47,
      "physical": 57,
      "technique": 46
    }
  },
  {
    "id": 512,
    "name": "Ed Halley",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/u/lumzbfwbm2m.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 62,
      "control": 67,
      "pressure": 40,
      "agility": 47,
      "physical": 49,
      "technique": 52
    }
  },
  {
    "id": 513,
    "name": "Burt Mocking",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/7/f7fsscjj5w8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 57,
      "control": 59,
      "pressure": 72,
      "agility": 40,
      "physical": 70,
      "technique": 40
    }
  },
  {
    "id": 514,
    "name": "Oscar Petty",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/t/0t0n_9fzulu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 56,
      "control": 45,
      "pressure": 73,
      "agility": 60,
      "physical": 65,
      "technique": 57
    }
  },
  {
    "id": 515,
    "name": "Waite Forrit",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/y/2yzrrkxfrju.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 69,
      "control": 65,
      "pressure": 60,
      "agility": 56,
      "physical": 54,
      "technique": 52
    }
  },
  {
    "id": 516,
    "name": "Bennett Byers",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/a/hacw8bxl8q8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 49,
      "control": 56,
      "pressure": 77,
      "agility": 46,
      "physical": 62,
      "technique": 50
    }
  },
  {
    "id": 517,
    "name": "Mo Eisner",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/1/n1hfvgetjwm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 49,
      "control": 53,
      "pressure": 63,
      "agility": 51,
      "physical": 50,
      "technique": 52
    }
  },
  {
    "id": 518,
    "name": "Miles Seaford",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/d/wdqkc5ixkdk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 57,
      "control": 59,
      "pressure": 65,
      "agility": 46,
      "physical": 58,
      "technique": 50
    }
  },
  {
    "id": 519,
    "name": "Sayer Lemon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/3/i3v8z0h1d8m.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 56,
      "control": 52,
      "pressure": 71,
      "agility": 52,
      "physical": 64,
      "technique": 58
    }
  },
  {
    "id": 520,
    "name": "Carey Ginu",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/f/tfedelhpupk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 48,
      "control": 45,
      "pressure": 46,
      "agility": 69,
      "physical": 41,
      "technique": 69
    }
  },
  {
    "id": 521,
    "name": "Cass Crocker",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/3/d3rwwct6ram.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 42,
      "control": 41,
      "pressure": 57,
      "agility": 58,
      "physical": 48,
      "technique": 70
    }
  },
  {
    "id": 522,
    "name": "Paul Downs",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/f/sfg3d9la8pk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 71,
      "control": 55,
      "pressure": 41,
      "agility": 43,
      "physical": 50,
      "technique": 70
    }
  },
  {
    "id": 523,
    "name": "Darrel Jeeling",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/w/mwdcog-ijju.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 40,
      "control": 41,
      "pressure": 73,
      "agility": 60,
      "physical": 70,
      "technique": 59
    }
  },
  {
    "id": 524,
    "name": "Nobby Shinn",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/y/9yyjjfyyk68.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 60,
      "control": 43,
      "pressure": 48,
      "agility": 52,
      "physical": 48,
      "technique": 47
    }
  },
  {
    "id": 525,
    "name": "Theo Broma",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/5/_51_ngkeh88.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 43,
      "control": 44,
      "pressure": 62,
      "agility": 53,
      "physical": 68,
      "technique": 43
    }
  },
  {
    "id": 526,
    "name": "Ramsey Faroe",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/r/oreeg5skmpu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 42,
      "control": 43,
      "pressure": 65,
      "agility": 53,
      "physical": 56,
      "technique": 57
    }
  },
  {
    "id": 527,
    "name": "Buster Chopps",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/-/u-nrzkzs5vk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 51,
      "control": 45,
      "pressure": 64,
      "agility": 43,
      "physical": 64,
      "technique": 45
    }
  },
  {
    "id": 528,
    "name": "Vince Bull",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/w/fwwkeb_wucm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 67,
      "control": 67,
      "pressure": 59,
      "agility": 50,
      "physical": 48,
      "technique": 61
    }
  },
  {
    "id": 529,
    "name": "Pat Maclean",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/8/r8psvw80zjk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 41,
      "control": 42,
      "pressure": 51,
      "agility": 64,
      "physical": 43,
      "technique": 52
    }
  },
  {
    "id": 530,
    "name": "Walter Card",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/u/auyzcpaoeqm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 48,
      "control": 42,
      "pressure": 46,
      "agility": 75,
      "physical": 46,
      "technique": 64
    }
  },
  {
    "id": 531,
    "name": "Derek Terr",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/8/08d-yoth_8s.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 43,
      "control": 41,
      "pressure": 58,
      "agility": 75,
      "physical": 53,
      "technique": 62
    }
  },
  {
    "id": 532,
    "name": "Alton Oldhat",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/u/fuyf1x19spe.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 68,
      "control": 64,
      "pressure": 54,
      "agility": 58,
      "physical": 40,
      "technique": 45
    }
  },
  {
    "id": 533,
    "name": "Cal Cooler",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/7/l7rqmka1nv0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 56,
      "control": 51,
      "pressure": 48,
      "agility": 69,
      "physical": 54,
      "technique": 58
    }
  },
  {
    "id": 534,
    "name": "Tom Felix",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/t/utgll1mpkcc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 56,
      "control": 69,
      "pressure": 48,
      "agility": 46,
      "physical": 48,
      "technique": 64
    }
  },
  {
    "id": 535,
    "name": "Terry Orr",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/y/wynxls0jpac.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 49,
      "pressure": 61,
      "agility": 55,
      "physical": 64,
      "technique": 55
    }
  },
  {
    "id": 536,
    "name": "Rudolph Rainder",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/a/naw2itszip0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 43,
      "control": 41,
      "pressure": 52,
      "agility": 58,
      "physical": 63,
      "technique": 41
    }
  },
  {
    "id": 537,
    "name": "Nick Swagg",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/1/h11dbonrxje.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 44,
      "control": 41,
      "pressure": 77,
      "agility": 58,
      "physical": 70,
      "technique": 48
    }
  },
  {
    "id": 538,
    "name": "Hal Leeward",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/d/2dei2xbr66s.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 63,
      "control": 78,
      "pressure": 51,
      "agility": 43,
      "physical": 50,
      "technique": 58
    }
  },
  {
    "id": 539,
    "name": "Arthur Dox",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/3/c376h8cjdfe.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 52,
      "control": 43,
      "pressure": 57,
      "agility": 69,
      "physical": 57,
      "technique": 71
    }
  },
  {
    "id": 540,
    "name": "Reese Ickle",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/f/zfkbqdkzw2s.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 50,
      "control": 55,
      "pressure": 41,
      "agility": 69,
      "physical": 45,
      "technique": 57
    }
  },
  {
    "id": 541,
    "name": "Finn Attick",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/b/zbfp2d6bodk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 48,
      "control": 60,
      "pressure": 74,
      "agility": 53,
      "physical": 65,
      "technique": 51
    }
  },
  {
    "id": 542,
    "name": "Col Lector",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/z/ozuib8c7jum.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 40,
      "control": 46,
      "pressure": 42,
      "agility": 55,
      "physical": 58,
      "technique": 53
    }
  },
  {
    "id": 543,
    "name": "Crispin Shooter",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/c/icn9ihpzwo8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 51,
      "control": 48,
      "pressure": 59,
      "agility": 55,
      "physical": 71,
      "technique": 52
    }
  },
  {
    "id": 544,
    "name": "Stu Perstitious",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/0/508clepj79u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 57,
      "control": 58,
      "pressure": 63,
      "agility": 48,
      "physical": 74,
      "technique": 57
    }
  },
  {
    "id": 545,
    "name": "Ashley Fay",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/v/7v7alhdl-7u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 81,
      "intelligence": 41,
      "control": 43,
      "pressure": 60,
      "agility": 63,
      "physical": 45,
      "technique": 54
    }
  },
  {
    "id": 546,
    "name": "Luke Raffles",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/9/k9khm47fti8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 69,
      "control": 71,
      "pressure": 59,
      "agility": 56,
      "physical": 56,
      "technique": 60
    }
  },
  {
    "id": 547,
    "name": "Stu Helmsley",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/s/qspu1loxmom.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 44,
      "control": 45,
      "pressure": 65,
      "agility": 46,
      "physical": 51,
      "technique": 56
    }
  },
  {
    "id": 548,
    "name": "Terrence Anthem",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/6/b6y1yaotlbk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 42,
      "control": 56,
      "pressure": 59,
      "agility": 44,
      "physical": 76,
      "technique": 58
    }
  },
  {
    "id": 549,
    "name": "Sam O'Reilly",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/4/e4wmeon1bxk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 53,
      "control": 54,
      "pressure": 45,
      "agility": 50,
      "physical": 55,
      "technique": 54
    }
  },
  {
    "id": 550,
    "name": "Ches Nutcracker",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/q/wqnbepe8g7e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 44,
      "control": 56,
      "pressure": 63,
      "agility": 43,
      "physical": 65,
      "technique": 40
    }
  },
  {
    "id": 551,
    "name": "Victor Grand",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/4/b48gzwignis.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 48,
      "control": 50,
      "pressure": 64,
      "agility": 53,
      "physical": 54,
      "technique": 45
    }
  },
  {
    "id": 552,
    "name": "Ant Hophila",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/x/hxfvglxo4oc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 42,
      "control": 53,
      "pressure": 56,
      "agility": 46,
      "physical": 76,
      "technique": 47
    }
  },
  {
    "id": 553,
    "name": "Hunter Glory",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/_/q_u0n0x0vb0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 58,
      "control": 70,
      "pressure": 43,
      "agility": 51,
      "physical": 48,
      "technique": 62
    }
  },
  {
    "id": 554,
    "name": "Joe Rassock",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/e/sepojtjyqd0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 46,
      "control": 43,
      "pressure": 80,
      "agility": 51,
      "physical": 79,
      "technique": 43
    }
  },
  {
    "id": 555,
    "name": "Patch Borgnine",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/2/j2yjosfi9uc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 65,
      "control": 54,
      "pressure": 50,
      "agility": 56,
      "physical": 49,
      "technique": 64
    }
  },
  {
    "id": 556,
    "name": "Ted Fast",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/z/dz78dpwqios.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 40,
      "control": 46,
      "pressure": 80,
      "agility": 50,
      "physical": 70,
      "technique": 58
    }
  },
  {
    "id": 557,
    "name": "Clay Modlin",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/x/yxkdwwwql9e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 48,
      "control": 59,
      "pressure": 51,
      "agility": 58,
      "physical": 56,
      "technique": 55
    }
  },
  {
    "id": 558,
    "name": "Alan Mode",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/b/gb1fb9vyccs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 48,
      "control": 40,
      "pressure": 66,
      "agility": 53,
      "physical": 65,
      "technique": 56
    }
  },
  {
    "id": 559,
    "name": "Harry Harper",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/z/3zeksczivxe.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 53,
      "control": 51,
      "pressure": 80,
      "agility": 55,
      "physical": 67,
      "technique": 50
    }
  },
  {
    "id": 560,
    "name": "Pascal Richter",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/z/_zqkcxsul3u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 69,
      "control": 65,
      "pressure": 48,
      "agility": 42,
      "physical": 56,
      "technique": 67
    }
  },
  {
    "id": 561,
    "name": "Beau Fort",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/x/oxbfxokume8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 53,
      "control": 51,
      "pressure": 61,
      "agility": 43,
      "physical": 52,
      "technique": 58
    }
  },
  {
    "id": 562,
    "name": "Reid Scarlet",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/e/ue4wi1_ctkm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 57,
      "control": 41,
      "pressure": 72,
      "agility": 55,
      "physical": 61,
      "technique": 55
    }
  },
  {
    "id": 563,
    "name": "Joe Lamkin",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/2/f2jrpkzm-xk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 57,
      "control": 67,
      "pressure": 46,
      "agility": 56,
      "physical": 54,
      "technique": 67
    }
  },
  {
    "id": 564,
    "name": "Dylan Magpie",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/x/dxonhtlk7rk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 57,
      "control": 44,
      "pressure": 62,
      "agility": 59,
      "physical": 68,
      "technique": 58
    }
  },
  {
    "id": 565,
    "name": "Gil Rivers",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/_/s__smstwwim.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 85,
      "intelligence": 57,
      "control": 57,
      "pressure": 40,
      "agility": 73,
      "physical": 47,
      "technique": 61
    }
  },
  {
    "id": 566,
    "name": "Des Tiny",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/q/mqczfxy4jc8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 54,
      "control": 40,
      "pressure": 70,
      "agility": 57,
      "physical": 75,
      "technique": 43
    }
  },
  {
    "id": 567,
    "name": "Saul Dowd",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/4/94t4yo-coxu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 54,
      "control": 57,
      "pressure": 62,
      "agility": 46,
      "physical": 62,
      "technique": 54
    }
  },
  {
    "id": 568,
    "name": "Kit Chapman",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/s/jssgdd9gpo8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 50,
      "control": 57,
      "pressure": 49,
      "agility": 68,
      "physical": 58,
      "technique": 52
    }
  },
  {
    "id": 569,
    "name": "Fry Vollity",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/6/46jbu8bae9u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 49,
      "control": 42,
      "pressure": 75,
      "agility": 42,
      "physical": 71,
      "technique": 59
    }
  },
  {
    "id": 570,
    "name": "Clark Roach",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/s/ws4m09stlr0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 66,
      "control": 68,
      "pressure": 56,
      "agility": 43,
      "physical": 46,
      "technique": 56
    }
  },
  {
    "id": 571,
    "name": "Samuel Peeps",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/6/n6jtzc0piic.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 57,
      "control": 48,
      "pressure": 64,
      "agility": 45,
      "physical": 64,
      "technique": 52
    }
  },
  {
    "id": 572,
    "name": "Dai Hart",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/v/hvqykfbh9cs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 58,
      "control": 56,
      "pressure": 64,
      "agility": 44,
      "physical": 63,
      "technique": 42
    }
  },
  {
    "id": 573,
    "name": "Horty Courture",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/9/29b5ngnbqxe.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 50,
      "control": 49,
      "pressure": 50,
      "agility": 69,
      "physical": 59,
      "technique": 62
    }
  },
  {
    "id": 574,
    "name": "Bob Baggum",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/c/0cclj513v3e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 50,
      "control": 49,
      "pressure": 69,
      "agility": 54,
      "physical": 58,
      "technique": 46
    }
  },
  {
    "id": 575,
    "name": "Ollie Twister",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/0/f0tekgtn4es.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 41,
      "control": 44,
      "pressure": 50,
      "agility": 76,
      "physical": 51,
      "technique": 59
    }
  },
  {
    "id": 576,
    "name": "Fred Makepeace",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/b/lbox3bmfnkc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 48,
      "control": 51,
      "pressure": 58,
      "agility": 51,
      "physical": 69,
      "technique": 59
    }
  },
  {
    "id": 577,
    "name": "Walker Sleep",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/z/uz_qaka_gx0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 40,
      "control": 57,
      "pressure": 70,
      "agility": 55,
      "physical": 54,
      "technique": 45
    }
  },
  {
    "id": 578,
    "name": "Sean Trawler",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/z/gzairpddhoc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 65,
      "control": 60,
      "pressure": 58,
      "agility": 58,
      "physical": 52,
      "technique": 66
    }
  },
  {
    "id": 579,
    "name": "Ken Sewer",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/x/rxxpgwlnqb0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 50,
      "control": 41,
      "pressure": 56,
      "agility": 49,
      "physical": 74,
      "technique": 53
    }
  },
  {
    "id": 580,
    "name": "Bamber Shoot",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/z/fz-iofpsvoc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 45,
      "control": 56,
      "pressure": 45,
      "agility": 57,
      "physical": 56,
      "technique": 54
    }
  },
  {
    "id": 581,
    "name": "Sly Winker",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/x/uxpdfgpo490.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 45,
      "control": 50,
      "pressure": 66,
      "agility": 60,
      "physical": 60,
      "technique": 48
    }
  },
  {
    "id": 582,
    "name": "Teller Scoap",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/e/oes2w9cgnde.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 45,
      "control": 54,
      "pressure": 74,
      "agility": 50,
      "physical": 69,
      "technique": 42
    }
  },
  {
    "id": 583,
    "name": "Sam Firman",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/2/_2dx7c6agus.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 55,
      "control": 44,
      "pressure": 63,
      "agility": 56,
      "physical": 69,
      "technique": 45
    }
  },
  {
    "id": 584,
    "name": "Bear Turnbull",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/x/9xalvbo2los.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 55,
      "control": 49,
      "pressure": 54,
      "agility": 68,
      "physical": 52,
      "technique": 50
    }
  },
  {
    "id": 585,
    "name": "Tabor Drummond",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/_/m_rq4komibe.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 52,
      "control": 51,
      "pressure": 76,
      "agility": 56,
      "physical": 71,
      "technique": 51
    }
  },
  {
    "id": 586,
    "name": "Brook Atwater",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/q/sqifr57e970.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 46,
      "control": 44,
      "pressure": 69,
      "agility": 46,
      "physical": 66,
      "technique": 52
    }
  },
  {
    "id": 587,
    "name": "Ike Doerflinger",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/4/d45-ggd-qic.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 44,
      "control": 41,
      "pressure": 56,
      "agility": 63,
      "physical": 49,
      "technique": 63
    }
  },
  {
    "id": 588,
    "name": "Aessop Fabel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/s/psgm3lec330.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 44,
      "control": 52,
      "pressure": 55,
      "agility": 49,
      "physical": 63,
      "technique": 51
    }
  },
  {
    "id": 589,
    "name": "Grant Slammer",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/6/y63ha04maec.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 57,
      "control": 60,
      "pressure": 59,
      "agility": 59,
      "physical": 41,
      "technique": 54
    }
  },
  {
    "id": 590,
    "name": "Robin Cruise",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/s/2sska1xv7o8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 41,
      "control": 59,
      "pressure": 72,
      "agility": 42,
      "physical": 57,
      "technique": 44
    }
  },
  {
    "id": 591,
    "name": "Mark Perfect",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/6/h6drtkxvwbu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 55,
      "control": 46,
      "pressure": 55,
      "agility": 54,
      "physical": 69,
      "technique": 55
    }
  },
  {
    "id": 592,
    "name": "Rolly Kerr",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/v/nv-e-xidj7k.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 54,
      "control": 68,
      "pressure": 46,
      "agility": 55,
      "physical": 57,
      "technique": 66
    }
  },
  {
    "id": 593,
    "name": "Moses Pumper",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/9/w9p_toenoim.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 40,
      "control": 50,
      "pressure": 60,
      "agility": 59,
      "physical": 48,
      "technique": 57
    }
  },
  {
    "id": 594,
    "name": "Knight Reader",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/c/ucij9xwllom.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 50,
      "control": 47,
      "pressure": 72,
      "agility": 59,
      "physical": 66,
      "technique": 56
    }
  },
  {
    "id": 595,
    "name": "Cash Barganier",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/0/l05cqowxm9k.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 46,
      "control": 47,
      "pressure": 47,
      "agility": 66,
      "physical": 57,
      "technique": 64
    }
  },
  {
    "id": 596,
    "name": "Brendan Branch",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/b/fba3dtf5tdu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 60,
      "control": 53,
      "pressure": 64,
      "agility": 42,
      "physical": 57,
      "technique": 47
    }
  },
  {
    "id": 597,
    "name": "Clark Rain",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/z/0zrwusjd-u8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 66,
      "control": 62,
      "pressure": 44,
      "agility": 45,
      "physical": 54,
      "technique": 55
    }
  },
  {
    "id": 598,
    "name": "Luther Rio",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/z/azuofhghzru.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 43,
      "control": 42,
      "pressure": 77,
      "agility": 49,
      "physical": 67,
      "technique": 42
    }
  },
  {
    "id": 599,
    "name": "Florian Hutter",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/x/xxlvyegb0i8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 64,
      "control": 69,
      "pressure": 50,
      "agility": 58,
      "physical": 51,
      "technique": 63
    }
  },
  {
    "id": 600,
    "name": "Scamp Shrimplin",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/p/npz-rb1r1xm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 27,
      "intelligence": 57,
      "control": 43,
      "pressure": 62,
      "agility": 47,
      "physical": 72,
      "technique": 60
    }
  },
  {
    "id": 601,
    "name": "Adam Nesiac",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/n/8ncf8ktryck.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 52,
      "control": 40,
      "pressure": 66,
      "agility": 58,
      "physical": 74,
      "technique": 44
    }
  },
  {
    "id": 602,
    "name": "Rab Acus",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/i/cihqv5mjtiu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 56,
      "control": 58,
      "pressure": 49,
      "agility": 71,
      "physical": 41,
      "technique": 68
    }
  },
  {
    "id": 603,
    "name": "Chris Miles",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/g/tgqlcgazar8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 71,
      "control": 61,
      "pressure": 51,
      "agility": 41,
      "physical": 46,
      "technique": 60
    }
  },
  {
    "id": 604,
    "name": "Shemmy Ramis",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/b/vbxxsfs1fx8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 67,
      "control": 65,
      "pressure": 50,
      "agility": 45,
      "physical": 58,
      "technique": 65
    }
  },
  {
    "id": 605,
    "name": "Lon Grainger",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/p/epm2bg0poku.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 60,
      "control": 53,
      "pressure": 82,
      "agility": 57,
      "physical": 72,
      "technique": 59
    }
  },
  {
    "id": 606,
    "name": "Manny Atom",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/g/-gfds9bhdek.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 46,
      "control": 40,
      "pressure": 45,
      "agility": 54,
      "physical": 45,
      "technique": 68
    }
  },
  {
    "id": 607,
    "name": "Bill Tardy",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/u/pu0i_cn9w3m.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 48,
      "control": 48,
      "pressure": 66,
      "agility": 51,
      "physical": 65,
      "technique": 43
    }
  },
  {
    "id": 608,
    "name": "Fox Copier",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/e/7el6opkfxik.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 82,
      "intelligence": 43,
      "control": 60,
      "pressure": 43,
      "agility": 68,
      "physical": 59,
      "technique": 52
    }
  },
  {
    "id": 609,
    "name": "Cletus Badden",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/s/ks6bjwcl67m.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 57,
      "control": 70,
      "pressure": 47,
      "agility": 46,
      "physical": 49,
      "technique": 60
    }
  },
  {
    "id": 610,
    "name": "Skip Sofrenic",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/e/kehw5xlsbxs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 73,
      "control": 65,
      "pressure": 56,
      "agility": 54,
      "physical": 48,
      "technique": 69
    }
  },
  {
    "id": 611,
    "name": "Mat Char",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/s/vsq3uotw2ke.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 58,
      "control": 47,
      "pressure": 49,
      "agility": 62,
      "physical": 58,
      "technique": 46
    }
  },
  {
    "id": 612,
    "name": "Trey Cultivator",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/d/1dzchtyede0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 51,
      "control": 44,
      "pressure": 63,
      "agility": 50,
      "physical": 66,
      "technique": 51
    }
  },
  {
    "id": 613,
    "name": "Vinny Trioquist",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/r/ercjqs-ku3c.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 47,
      "control": 45,
      "pressure": 43,
      "agility": 69,
      "physical": 47,
      "technique": 61
    }
  },
  {
    "id": 614,
    "name": "Oscar Esher",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/i/3i0epkkygc0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 47,
      "control": 44,
      "pressure": 63,
      "agility": 60,
      "physical": 59,
      "technique": 55
    }
  },
  {
    "id": 615,
    "name": "Saul Searcher",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/n/xnxr6x_6zie.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 55,
      "control": 42,
      "pressure": 66,
      "agility": 55,
      "physical": 70,
      "technique": 53
    }
  },
  {
    "id": 616,
    "name": "Gerry Attrick",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/l/mlmkxozaers.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 55,
      "control": 53,
      "pressure": 76,
      "agility": 46,
      "physical": 64,
      "technique": 47
    }
  },
  {
    "id": 617,
    "name": "Adam Icklock",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/p/spzsmlai5ue.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 47,
      "control": 47,
      "pressure": 74,
      "agility": 46,
      "physical": 67,
      "technique": 50
    }
  },
  {
    "id": 618,
    "name": "Sol Stiss",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/n/jnozla8yuds.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 55,
      "control": 45,
      "pressure": 58,
      "agility": 65,
      "physical": 60,
      "technique": 55
    }
  },
  {
    "id": 619,
    "name": "Des Ainer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/p/tpn4ltwtrie.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 57,
      "control": 78,
      "pressure": 50,
      "agility": 45,
      "physical": 49,
      "technique": 58
    }
  },
  {
    "id": 620,
    "name": "Homer Sockshell",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/n/cnwziswxg7s.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 82,
      "intelligence": 52,
      "control": 52,
      "pressure": 43,
      "agility": 67,
      "physical": 44,
      "technique": 65
    }
  },
  {
    "id": 621,
    "name": "Harley Trotter",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/i/8i1sbxffzbc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 44,
      "control": 50,
      "pressure": 48,
      "agility": 62,
      "physical": 48,
      "technique": 53
    }
  },
  {
    "id": 622,
    "name": "Mark Skidfree",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/g/ngen2ojleo0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 55,
      "control": 58,
      "pressure": 42,
      "agility": 58,
      "physical": 54,
      "technique": 69
    }
  },
  {
    "id": 623,
    "name": "Del Iverryboy",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/b/pbdryxxjbu0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 51,
      "control": 44,
      "pressure": 59,
      "agility": 45,
      "physical": 55,
      "technique": 48
    }
  },
  {
    "id": 624,
    "name": "Scean Spector",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/p/-pyw1oxz2dc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 58,
      "control": 48,
      "pressure": 69,
      "agility": 55,
      "physical": 62,
      "technique": 52
    }
  },
  {
    "id": 625,
    "name": "Nick Knack",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/g/egrfm1i7d9s.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 71,
      "control": 59,
      "pressure": 49,
      "agility": 41,
      "physical": 51,
      "technique": 55
    }
  },
  {
    "id": 626,
    "name": "Dusty Rellicks",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/u/vugklkebuoe.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 71,
      "control": 61,
      "pressure": 42,
      "agility": 50,
      "physical": 54,
      "technique": 57
    }
  },
  {
    "id": 627,
    "name": "Sandy Insolls",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/e/bef86hhjjxs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 65,
      "control": 63,
      "pressure": 59,
      "agility": 45,
      "physical": 54,
      "technique": 62
    }
  },
  {
    "id": 628,
    "name": "Gregory Bones",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/s/qsudx4hzkce.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 66,
      "control": 56,
      "pressure": 57,
      "agility": 45,
      "physical": 53,
      "technique": 70
    }
  },
  {
    "id": 629,
    "name": "Loughrey Mose",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/e/ee1qn5oqfuk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 43,
      "control": 55,
      "pressure": 46,
      "agility": 54,
      "physical": 56,
      "technique": 57
    }
  },
  {
    "id": 630,
    "name": "Willow Withers",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/s/1sexggoqodm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 65,
      "control": 60,
      "pressure": 42,
      "agility": 55,
      "physical": 50,
      "technique": 69
    }
  },
  {
    "id": 631,
    "name": "Winn deBreeze",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/d/vdnezb7id98.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 56,
      "control": 43,
      "pressure": 62,
      "agility": 44,
      "physical": 60,
      "technique": 40
    }
  },
  {
    "id": 632,
    "name": "Buster Clout",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/r/krwlekdywou.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 58,
      "control": 44,
      "pressure": 60,
      "agility": 46,
      "physical": 66,
      "technique": 58
    }
  },
  {
    "id": 633,
    "name": "Errol Lorre",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/k/mkr5w9p01iu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 56,
      "control": 47,
      "pressure": 54,
      "agility": 57,
      "physical": 47,
      "technique": 58
    }
  },
  {
    "id": 634,
    "name": "Fred Ferrell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/i/xigydcpoy78.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 55,
      "control": 73,
      "pressure": 55,
      "agility": 41,
      "physical": 53,
      "technique": 70
    }
  },
  {
    "id": 635,
    "name": "Rod Headstock",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/n/3ndtofcgtbm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 50,
      "control": 52,
      "pressure": 66,
      "agility": 53,
      "physical": 74,
      "technique": 59
    }
  },
  {
    "id": 636,
    "name": "Tim Piece",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/l/glymjg68aok.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 57,
      "control": 41,
      "pressure": 60,
      "agility": 66,
      "physical": 43,
      "technique": 60
    }
  },
  {
    "id": 637,
    "name": "Patrick Edie",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/p/ypnust5enxm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 42,
      "control": 41,
      "pressure": 54,
      "agility": 60,
      "physical": 75,
      "technique": 58
    }
  },
  {
    "id": 638,
    "name": "Art Teest",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/n/dn81_sfkkkk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 64,
      "control": 73,
      "pressure": 45,
      "agility": 57,
      "physical": 50,
      "technique": 54
    }
  },
  {
    "id": 639,
    "name": "Bill Mumm",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/j/pjphjsbw0ps.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 48,
      "control": 53,
      "pressure": 45,
      "agility": 70,
      "physical": 40,
      "technique": 51
    }
  },
  {
    "id": 640,
    "name": "Luke O'Cyte",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/l/ylymotnsz8e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 54,
      "control": 43,
      "pressure": 56,
      "agility": 51,
      "physical": 49,
      "technique": 57
    }
  },
  {
    "id": 641,
    "name": "Ernest Byer",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/k/4k7tdwsksc0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 53,
      "control": 57,
      "pressure": 50,
      "agility": 67,
      "physical": 60,
      "technique": 67
    }
  },
  {
    "id": 642,
    "name": "Isaac Goss",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/m/jmkywp0ebvc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 61,
      "control": 80,
      "pressure": 53,
      "agility": 40,
      "physical": 44,
      "technique": 68
    }
  },
  {
    "id": 643,
    "name": "Walter Poseur",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/t/ltnuewmyepc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 54,
      "control": 46,
      "pressure": 67,
      "agility": 50,
      "physical": 59,
      "technique": 53
    }
  },
  {
    "id": 644,
    "name": "Andy Roff",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/f/6f8pzpaipa0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 52,
      "control": 47,
      "pressure": 52,
      "agility": 55,
      "physical": 70,
      "technique": 40
    }
  },
  {
    "id": 645,
    "name": "Ashley Dale",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/q/aqf6g01ac6e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 44,
      "control": 60,
      "pressure": 40,
      "agility": 60,
      "physical": 48,
      "technique": 57
    }
  },
  {
    "id": 646,
    "name": "Rich Cave",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/c/rcubnlt6xjs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 27,
      "intelligence": 43,
      "control": 50,
      "pressure": 59,
      "agility": 50,
      "physical": 72,
      "technique": 43
    }
  },
  {
    "id": 647,
    "name": "Taka Tanaka",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/o/ford8gqyw2e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 68,
      "control": 69,
      "pressure": 45,
      "agility": 45,
      "physical": 54,
      "technique": 66
    }
  },
  {
    "id": 648,
    "name": "Manny Carbs",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/a/uagir52i7fs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 42,
      "control": 58,
      "pressure": 63,
      "agility": 59,
      "physical": 75,
      "technique": 51
    }
  },
  {
    "id": 649,
    "name": "Al Reddie",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/o/ao7vl4_rapm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 54,
      "control": 72,
      "pressure": 40,
      "agility": 40,
      "physical": 51,
      "technique": 67
    }
  },
  {
    "id": 650,
    "name": "Rush Tooset",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/a/xakomhzr3ak.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 54,
      "control": 74,
      "pressure": 58,
      "agility": 55,
      "physical": 52,
      "technique": 52
    }
  },
  {
    "id": 651,
    "name": "Rod Opsin",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/v/rvp71aszc6u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 49,
      "control": 44,
      "pressure": 58,
      "agility": 55,
      "physical": 56,
      "technique": 74
    }
  },
  {
    "id": 652,
    "name": "Peyton Pope",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/h/ghyaylkjvj8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 41,
      "control": 57,
      "pressure": 70,
      "agility": 46,
      "physical": 51,
      "technique": 41
    }
  },
  {
    "id": 653,
    "name": "Drew Straws",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/m/imfg28ypqp8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 59,
      "control": 50,
      "pressure": 54,
      "agility": 55,
      "physical": 57,
      "technique": 60
    }
  },
  {
    "id": 654,
    "name": "Trey Dalbum",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/o/tounbd-1h8u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 42,
      "control": 60,
      "pressure": 47,
      "agility": 67,
      "physical": 43,
      "technique": 71
    }
  },
  {
    "id": 655,
    "name": "Harly Profett",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/h/zhnsiel9yck.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 72,
      "control": 73,
      "pressure": 49,
      "agility": 42,
      "physical": 58,
      "technique": 50
    }
  },
  {
    "id": 656,
    "name": "Hank O'Buff",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/j/cj8zlhthfvm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 29,
      "intelligence": 59,
      "control": 60,
      "pressure": 82,
      "agility": 49,
      "physical": 67,
      "technique": 52
    }
  },
  {
    "id": 657,
    "name": "Ash Cloud",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/j/2jdrusul4qk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 41,
      "control": 54,
      "pressure": 59,
      "agility": 55,
      "physical": 59,
      "technique": 61
    }
  },
  {
    "id": 658,
    "name": "Stan Dupp",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/l/hlyk5tifvjm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 82,
      "intelligence": 42,
      "control": 51,
      "pressure": 52,
      "agility": 54,
      "physical": 50,
      "technique": 51
    }
  },
  {
    "id": 659,
    "name": "Max Bright",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/o/vohbvy6cigs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 55,
      "control": 78,
      "pressure": 49,
      "agility": 55,
      "physical": 54,
      "technique": 67
    }
  },
  {
    "id": 660,
    "name": "Bill Phee",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/m/em2gcncmp1e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 57,
      "control": 45,
      "pressure": 70,
      "agility": 56,
      "physical": 67,
      "technique": 41
    }
  },
  {
    "id": 661,
    "name": "Lee Figreene",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/j/-jvvr6pu6v0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 53,
      "control": 50,
      "pressure": 60,
      "agility": 73,
      "physical": 49,
      "technique": 63
    }
  },
  {
    "id": 662,
    "name": "Den Taligene",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/h/phk08fpuxmc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 71,
      "control": 68,
      "pressure": 44,
      "agility": 51,
      "physical": 51,
      "technique": 54
    }
  },
  {
    "id": 663,
    "name": "Adam Hesive",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/a/najoscd4sgc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 41,
      "control": 43,
      "pressure": 53,
      "agility": 54,
      "physical": 74,
      "technique": 53
    }
  },
  {
    "id": 664,
    "name": "Mel Lowe",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/o/8osj_j7c_t0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 59,
      "control": 55,
      "pressure": 68,
      "agility": 44,
      "physical": 72,
      "technique": 47
    }
  },
  {
    "id": 665,
    "name": "Rip Winkle",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/h/chx8s-okkze.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 64,
      "control": 70,
      "pressure": 43,
      "agility": 56,
      "physical": 40,
      "technique": 62
    }
  },
  {
    "id": 666,
    "name": "Ben deLimms",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/v/tvadbbownas.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 49,
      "control": 41,
      "pressure": 78,
      "agility": 43,
      "physical": 66,
      "technique": 49
    }
  },
  {
    "id": 667,
    "name": "Pauly Ontology",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/f/zf_fwmrsa_e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 83,
      "intelligence": 57,
      "control": 48,
      "pressure": 60,
      "agility": 58,
      "physical": 55,
      "technique": 59
    }
  },
  {
    "id": 668,
    "name": "Walter Mendip",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/t/otokdznotms.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 45,
      "control": 53,
      "pressure": 57,
      "agility": 66,
      "physical": 45,
      "technique": 62
    }
  },
  {
    "id": 669,
    "name": "Bud Hunter",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/f/gfvphyehmgm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 41,
      "control": 40,
      "pressure": 77,
      "agility": 57,
      "physical": 58,
      "technique": 45
    }
  },
  {
    "id": 670,
    "name": "Sonny Rentman",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/t/3tkiqnibhtk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 44,
      "control": 52,
      "pressure": 43,
      "agility": 76,
      "physical": 53,
      "technique": 58
    }
  },
  {
    "id": 671,
    "name": "Cam Vass",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/c/xch95qxtuzu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 58,
      "control": 45,
      "pressure": 78,
      "agility": 40,
      "physical": 57,
      "technique": 60
    }
  },
  {
    "id": 672,
    "name": "Shay Chez",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/q/mq2cuvxp5a8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 71,
      "control": 60,
      "pressure": 53,
      "agility": 45,
      "physical": 60,
      "technique": 69
    }
  },
  {
    "id": 673,
    "name": "Cory Andish",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/l/klxa62jf8g8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 45,
      "control": 50,
      "pressure": 40,
      "agility": 67,
      "physical": 42,
      "technique": 70
    }
  },
  {
    "id": 674,
    "name": "Glen Adeer",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/j/vjahxjf_r1u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 48,
      "control": 41,
      "pressure": 51,
      "agility": 67,
      "physical": 56,
      "technique": 65
    }
  },
  {
    "id": 675,
    "name": "Norry Sheets",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/m/1mjueuw3kvk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 56,
      "control": 51,
      "pressure": 57,
      "agility": 45,
      "physical": 51,
      "technique": 59
    }
  },
  {
    "id": 676,
    "name": "Lou Paster",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/k/eks1prwnjmm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 53,
      "control": 56,
      "pressure": 59,
      "agility": 69,
      "physical": 58,
      "technique": 72
    }
  },
  {
    "id": 677,
    "name": "Aran Cheeks",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/o/wottymvvuzk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 49,
      "control": 42,
      "pressure": 84,
      "agility": 46,
      "physical": 69,
      "technique": 46
    }
  },
  {
    "id": 678,
    "name": "Abe Seiler",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/m/bmcm1zzvdqm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 72,
      "control": 53,
      "pressure": 57,
      "agility": 48,
      "physical": 56,
      "technique": 55
    }
  },
  {
    "id": 679,
    "name": "Al Urgy",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/o/pothbqzg8_k.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 48,
      "control": 42,
      "pressure": 75,
      "agility": 49,
      "physical": 67,
      "technique": 48
    }
  },
  {
    "id": 680,
    "name": "Conn Pass",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/m/-mim2v_armm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 68,
      "control": 67,
      "pressure": 48,
      "agility": 44,
      "physical": 54,
      "technique": 67
    }
  },
  {
    "id": 681,
    "name": "Heath Cover",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/j/ejbtlyksks8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 41,
      "control": 40,
      "pressure": 56,
      "agility": 43,
      "physical": 61,
      "technique": 45
    }
  },
  {
    "id": 682,
    "name": "Mack Ramey",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/h/vhwyinsojfu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 57,
      "control": 56,
      "pressure": 61,
      "agility": 44,
      "physical": 58,
      "technique": 49
    }
  },
  {
    "id": 683,
    "name": "Miles Ryan",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/a/ta3umu-emzu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 51,
      "control": 55,
      "pressure": 74,
      "agility": 45,
      "physical": 55,
      "technique": 41
    }
  },
  {
    "id": 684,
    "name": "Ike Banner",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/o/cogplry-hq8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 51,
      "control": 40,
      "pressure": 68,
      "agility": 43,
      "physical": 64,
      "technique": 57
    }
  },
  {
    "id": 685,
    "name": "Frank Meyer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/h/8hl6y2t2ukm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 79,
      "control": 56,
      "pressure": 49,
      "agility": 54,
      "physical": 44,
      "technique": 51
    }
  },
  {
    "id": 686,
    "name": "Phil Fog",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/v/nvub1jlm55k.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 57,
      "control": 42,
      "pressure": 65,
      "agility": 53,
      "physical": 58,
      "technique": 47
    }
  },
  {
    "id": 687,
    "name": "Bob Lioteck",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/f/5frdeeiuegm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 53,
      "control": 56,
      "pressure": 65,
      "agility": 58,
      "physical": 61,
      "technique": 43
    }
  },
  {
    "id": 688,
    "name": "Rory Polisher",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/t/itaip7uuz1k.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 47,
      "control": 51,
      "pressure": 76,
      "agility": 53,
      "physical": 73,
      "technique": 51
    }
  },
  {
    "id": 689,
    "name": "Tex Curvator",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/f/mfbvz6ndsze.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 52,
      "control": 45,
      "pressure": 43,
      "agility": 67,
      "physical": 52,
      "technique": 56
    }
  },
  {
    "id": 690,
    "name": "Perry Pincher",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/t/xtwoefbn_qs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 46,
      "control": 53,
      "pressure": 53,
      "agility": 69,
      "physical": 43,
      "technique": 62
    }
  },
  {
    "id": 691,
    "name": "Al Plates",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/c/3ct7ny0vkkc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 59,
      "control": 52,
      "pressure": 44,
      "agility": 65,
      "physical": 52,
      "technique": 59
    }
  },
  {
    "id": 692,
    "name": "Bane Marie",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/q/gqiagnsvn50.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 41,
      "control": 42,
      "pressure": 68,
      "agility": 47,
      "physical": 51,
      "technique": 49
    }
  },
  {
    "id": 693,
    "name": "Cam Broadsheet",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/l/ellgo-a5i_0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 60,
      "control": 77,
      "pressure": 57,
      "agility": 52,
      "physical": 55,
      "technique": 52
    }
  },
  {
    "id": 694,
    "name": "Mo Hawkes",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/j/1junjbmdpmc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 52,
      "control": 59,
      "pressure": 45,
      "agility": 67,
      "physical": 45,
      "technique": 56
    }
  },
  {
    "id": 695,
    "name": "Chris Pecracker",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/m/vm3swctl6ss.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 49,
      "control": 46,
      "pressure": 71,
      "agility": 60,
      "physical": 74,
      "technique": 59
    }
  },
  {
    "id": 696,
    "name": "Andy Crafter",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/k/kkgzdj1xxfe.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 46,
      "control": 53,
      "pressure": 59,
      "agility": 74,
      "physical": 53,
      "technique": 60
    }
  },
  {
    "id": 697,
    "name": "Boe Tyer",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/o/qo5rsu2twgs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 43,
      "control": 50,
      "pressure": 61,
      "agility": 47,
      "physical": 64,
      "technique": 42
    }
  },
  {
    "id": 698,
    "name": "Dave O'Resis",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/m/hmikbrqpdte.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 61,
      "control": 69,
      "pressure": 50,
      "agility": 56,
      "physical": 58,
      "technique": 48
    }
  },
  {
    "id": 699,
    "name": "Victor Mancey",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/y/dyebiujjca0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 84,
      "intelligence": 50,
      "control": 41,
      "pressure": 48,
      "agility": 76,
      "physical": 54,
      "technique": 56
    }
  },
  {
    "id": 700,
    "name": "Ray Dioset",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/w/swv6prfzxzc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 57,
      "control": 42,
      "pressure": 44,
      "agility": 56,
      "physical": 49,
      "technique": 61
    }
  },
  {
    "id": 701,
    "name": "Preston Gumbs",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/f/mfmpc2wrets.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 50,
      "control": 45,
      "pressure": 46,
      "agility": 56,
      "physical": 42,
      "technique": 53
    }
  },
  {
    "id": 702,
    "name": "Tiny Forester",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/3/939uxjwrpge.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 59,
      "control": 47,
      "pressure": 67,
      "agility": 47,
      "physical": 58,
      "technique": 51
    }
  },
  {
    "id": 703,
    "name": "Cardin Hands",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/w/_w6yfqehsme.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 43,
      "control": 41,
      "pressure": 59,
      "agility": 72,
      "physical": 55,
      "technique": 65
    }
  },
  {
    "id": 704,
    "name": "Callan Trens",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/-/o-ltyvi9bvs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 59,
      "control": 42,
      "pressure": 49,
      "agility": 66,
      "physical": 52,
      "technique": 51
    }
  },
  {
    "id": 705,
    "name": "Tim Mittus",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/r/uromhyx101c.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 59,
      "control": 40,
      "pressure": 67,
      "agility": 55,
      "physical": 64,
      "technique": 45
    }
  },
  {
    "id": 706,
    "name": "Keenan Brainard",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/5/f5zhmnxpzg0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 61,
      "control": 55,
      "pressure": 57,
      "agility": 42,
      "physical": 44,
      "technique": 74
    }
  },
  {
    "id": 707,
    "name": "Orson Douvre",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/t/rtmf9ayt-5c.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 46,
      "control": 52,
      "pressure": 65,
      "agility": 44,
      "physical": 65,
      "technique": 43
    }
  },
  {
    "id": 708,
    "name": "Sandy Hope",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/7/a7x-q_uxtk0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 58,
      "control": 43,
      "pressure": 60,
      "agility": 42,
      "physical": 51,
      "technique": 48
    }
  },
  {
    "id": 709,
    "name": "Ort Omaton",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/t/0tmzk-deymu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 29,
      "intelligence": 59,
      "control": 55,
      "pressure": 61,
      "agility": 46,
      "physical": 66,
      "technique": 49
    }
  },
  {
    "id": 710,
    "name": "Clerk Welcome",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/7/f79snb7kfv8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 52,
      "control": 55,
      "pressure": 68,
      "agility": 52,
      "physical": 58,
      "technique": 42
    }
  },
  {
    "id": 711,
    "name": "Rob Ottman",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/u/luen0cosq1m.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 50,
      "control": 50,
      "pressure": 59,
      "agility": 57,
      "physical": 59,
      "technique": 43
    }
  },
  {
    "id": 712,
    "name": "Cam O'Miles",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/8/u8vgzjowhgk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 59,
      "control": 58,
      "pressure": 65,
      "agility": 60,
      "physical": 59,
      "technique": 41
    }
  },
  {
    "id": 713,
    "name": "Jack Pott",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/d/wdoa3666cak.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 45,
      "control": 40,
      "pressure": 67,
      "agility": 48,
      "physical": 53,
      "technique": 45
    }
  },
  {
    "id": 714,
    "name": "Florian Selles",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/1/n1z7afcavzm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 58,
      "control": 53,
      "pressure": 50,
      "agility": 73,
      "physical": 48,
      "technique": 73
    }
  },
  {
    "id": 715,
    "name": "Finn Sawyer",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/a/ha6ojypiat8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 55,
      "control": 50,
      "pressure": 64,
      "agility": 47,
      "physical": 69,
      "technique": 55
    }
  },
  {
    "id": 716,
    "name": "Bobby Constable",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/y/2ylvknpy3gu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 44,
      "control": 47,
      "pressure": 41,
      "agility": 66,
      "physical": 40,
      "technique": 53
    }
  },
  {
    "id": 717,
    "name": "Ray Menn",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/y/cy03vqmqqf8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 56,
      "control": 49,
      "pressure": 50,
      "agility": 77,
      "physical": 48,
      "technique": 67
    }
  },
  {
    "id": 718,
    "name": "Odo Toilette",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/w/zwfw4vqq9su.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 48,
      "control": 53,
      "pressure": 71,
      "agility": 42,
      "physical": 76,
      "technique": 54
    }
  },
  {
    "id": 719,
    "name": "Tel Egram",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/y/9ykdwcafc58.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 63,
      "control": 66,
      "pressure": 54,
      "agility": 52,
      "physical": 54,
      "technique": 54
    }
  },
  {
    "id": 720,
    "name": "Char Shumaker",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/w/mw787jmlvku.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 49,
      "control": 48,
      "pressure": 47,
      "agility": 76,
      "physical": 57,
      "technique": 64
    }
  },
  {
    "id": 721,
    "name": "Sim Pathy",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/f/sfyjo-ttaqk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 54,
      "control": 58,
      "pressure": 53,
      "agility": 48,
      "physical": 53,
      "technique": 44
    }
  },
  {
    "id": 722,
    "name": "Jon Driedon",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/3/d3pofb1x3zm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 52,
      "control": 53,
      "pressure": 44,
      "agility": 50,
      "physical": 57,
      "technique": 58
    }
  },
  {
    "id": 723,
    "name": "Monty Burrows",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/w/fwu0ryn7yfm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 40,
      "control": 47,
      "pressure": 65,
      "agility": 45,
      "physical": 57,
      "technique": 40
    }
  },
  {
    "id": 724,
    "name": "Gaston Berry",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/-/u-fvgnbbfsk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 42,
      "control": 45,
      "pressure": 58,
      "agility": 60,
      "physical": 58,
      "technique": 66
    }
  },
  {
    "id": 725,
    "name": "Cruz Ligner",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/r/or8gv60jqmu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 66,
      "control": 66,
      "pressure": 48,
      "agility": 59,
      "physical": 50,
      "technique": 55
    }
  },
  {
    "id": 726,
    "name": "Irv Washinton",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/5/_5nb4fszh_8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 54,
      "control": 54,
      "pressure": 59,
      "agility": 40,
      "physical": 58,
      "technique": 43
    }
  },
  {
    "id": 727,
    "name": "Shem Bassey",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/t/ltyzjirrgau.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 44,
      "control": 57,
      "pressure": 64,
      "agility": 48,
      "physical": 52,
      "technique": 45
    }
  },
  {
    "id": 728,
    "name": "Pres Cripton",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/7/67d4k33rnz8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 51,
      "control": 46,
      "pressure": 51,
      "agility": 55,
      "physical": 47,
      "technique": 61
    }
  },
  {
    "id": 729,
    "name": "Winston Windfall",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/t/uty1-2-isfc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 69,
      "control": 65,
      "pressure": 50,
      "agility": 43,
      "physical": 47,
      "technique": 61
    }
  },
  {
    "id": 730,
    "name": "Rich Eden",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/7/l7putjyybs0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 58,
      "control": 56,
      "pressure": 80,
      "agility": 50,
      "physical": 72,
      "technique": 41
    }
  },
  {
    "id": 731,
    "name": "Teagen Brewer",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/u/fukhautq0me.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 60,
      "control": 52,
      "pressure": 74,
      "agility": 56,
      "physical": 75,
      "technique": 46
    }
  },
  {
    "id": 732,
    "name": "Ry Sling",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/8/087atrlqz_s.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 55,
      "control": 54,
      "pressure": 54,
      "agility": 56,
      "physical": 63,
      "technique": 56
    }
  },
  {
    "id": 733,
    "name": "Bard Crooner",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/d/2d8cdyzgc5s.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 77,
      "control": 72,
      "pressure": 55,
      "agility": 48,
      "physical": 57,
      "technique": 54
    }
  },
  {
    "id": 734,
    "name": "Armstrong Peck",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/1/h1n9un_8xke.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 28,
      "intelligence": 41,
      "control": 57,
      "pressure": 62,
      "agility": 53,
      "physical": 70,
      "technique": 47
    }
  },
  {
    "id": 735,
    "name": "Carey Vanpark",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/a/naui9qk0eq0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 68,
      "control": 72,
      "pressure": 60,
      "agility": 41,
      "physical": 42,
      "technique": 69
    }
  },
  {
    "id": 736,
    "name": "Garland Gathers",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/y/wyfpqvsopzc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 57,
      "control": 71,
      "pressure": 49,
      "agility": 46,
      "physical": 42,
      "technique": 69
    }
  },
  {
    "id": 737,
    "name": "David Burnum",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/y/iygxhivsom0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 52,
      "control": 44,
      "pressure": 57,
      "agility": 43,
      "physical": 62,
      "technique": 50
    }
  },
  {
    "id": 738,
    "name": "Tad Trinket",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/w/twrqmdjwjvc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 54,
      "control": 71,
      "pressure": 54,
      "agility": 51,
      "physical": 58,
      "technique": 64
    }
  },
  {
    "id": 739,
    "name": "Harvey Lifter",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/0/50eiqdxkd-u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 50,
      "control": 43,
      "pressure": 50,
      "agility": 46,
      "physical": 65,
      "technique": 47
    }
  },
  {
    "id": 740,
    "name": "Kurt Price",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/c/ic1d9ixewn8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 71,
      "control": 66,
      "pressure": 47,
      "agility": 40,
      "physical": 57,
      "technique": 65
    }
  },
  {
    "id": 741,
    "name": "Cameron Hameha",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/z/ozw2u_ewftm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 60,
      "control": 79,
      "pressure": 51,
      "agility": 55,
      "physical": 55,
      "technique": 69
    }
  },
  {
    "id": 742,
    "name": "Will Stonehead",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/b/zbnxdaisoek.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 48,
      "control": 51,
      "pressure": 65,
      "agility": 51,
      "physical": 52,
      "technique": 53
    }
  },
  {
    "id": 743,
    "name": "Hugh Marble",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/6/b6gltzwatyk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 54,
      "control": 56,
      "pressure": 67,
      "agility": 56,
      "physical": 71,
      "technique": 43
    }
  },
  {
    "id": 744,
    "name": "Urson Brown",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/s/qsrqamw6arm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 43,
      "control": 60,
      "pressure": 60,
      "agility": 50,
      "physical": 64,
      "technique": 45
    }
  },
  {
    "id": 745,
    "name": "Bo Luger",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/9/k9yft7jy1l8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 55,
      "control": 52,
      "pressure": 41,
      "agility": 68,
      "physical": 49,
      "technique": 46
    }
  },
  {
    "id": 746,
    "name": "Kim Ono",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/v/7vd--efiy4u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 57,
      "control": 46,
      "pressure": 57,
      "agility": 76,
      "physical": 43,
      "technique": 62
    }
  },
  {
    "id": 747,
    "name": "Bully Thrower",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/_/p_8mpjgq_h8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 41,
      "control": 53,
      "pressure": 40,
      "agility": 58,
      "physical": 58,
      "technique": 60
    }
  },
  {
    "id": 748,
    "name": "Bill Wordsworthy",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/x/-xnhi2gqs0u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 63,
      "control": 68,
      "pressure": 59,
      "agility": 58,
      "physical": 57,
      "technique": 61
    }
  },
  {
    "id": 749,
    "name": "Mo Lusk",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/_/q_wk43pzzy0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 57,
      "control": 57,
      "pressure": 49,
      "agility": 55,
      "physical": 45,
      "technique": 64
    }
  },
  {
    "id": 750,
    "name": "Ben Curd",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/x/hxnrvipjerc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 45,
      "control": 46,
      "pressure": 69,
      "agility": 43,
      "physical": 63,
      "technique": 59
    }
  },
  {
    "id": 751,
    "name": "Powers Squatts",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/4/b4eegv6rrls.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 59,
      "control": 58,
      "pressure": 69,
      "agility": 45,
      "physical": 58,
      "technique": 57
    }
  },
  {
    "id": 752,
    "name": "Paisley Onepiece",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/q/wq1_rqcrg4e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 55,
      "control": 47,
      "pressure": 76,
      "agility": 47,
      "physical": 78,
      "technique": 56
    }
  },
  {
    "id": 753,
    "name": "Gauge Diven",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/x/yxyjfzo9d-e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 45,
      "control": 44,
      "pressure": 70,
      "agility": 47,
      "physical": 61,
      "technique": 59
    }
  },
  {
    "id": 754,
    "name": "Zane Laughead",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/z/dzdcomohuns.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 61,
      "control": 75,
      "pressure": 56,
      "agility": 46,
      "physical": 53,
      "technique": 70
    }
  },
  {
    "id": 755,
    "name": "Daz Tighthead",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/2/j2g37rdpbtc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 41,
      "control": 47,
      "pressure": 77,
      "agility": 50,
      "physical": 76,
      "technique": 47
    }
  },
  {
    "id": 756,
    "name": "Sandy Beecher",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/e/serwwu712e0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 40,
      "control": 54,
      "pressure": 43,
      "agility": 69,
      "physical": 57,
      "technique": 66
    }
  },
  {
    "id": 757,
    "name": "Ty Priter",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/0/m0uonj4xrhc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 85,
      "intelligence": 46,
      "control": 54,
      "pressure": 58,
      "agility": 53,
      "physical": 60,
      "technique": 68
    }
  },
  {
    "id": 758,
    "name": "Nick Savers",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/c/xcfvkcet8s0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 60,
      "control": 55,
      "pressure": 77,
      "agility": 47,
      "physical": 74,
      "technique": 48
    }
  },
  {
    "id": 759,
    "name": "Percy Wrench",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/4/44j5l0qa20u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 67,
      "control": 68,
      "pressure": 46,
      "agility": 53,
      "physical": 60,
      "technique": 60
    }
  },
  {
    "id": 760,
    "name": "Max Scara",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/q/jq4yil2gbh8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 53,
      "control": 60,
      "pressure": 61,
      "agility": 46,
      "physical": 63,
      "technique": 59
    }
  },
  {
    "id": 761,
    "name": "Jonny Strutt",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/_/p_btbwdounm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 82,
      "intelligence": 59,
      "control": 51,
      "pressure": 51,
      "agility": 57,
      "physical": 44,
      "technique": 70
    }
  },
  {
    "id": 762,
    "name": "Larry Oldman",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/x/yxqm2plsduk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 59,
      "control": 43,
      "pressure": 43,
      "agility": 55,
      "physical": 44,
      "technique": 59
    }
  },
  {
    "id": 763,
    "name": "Dom Anding",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/2/a2tqyw3-gsk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 60,
      "control": 58,
      "pressure": 41,
      "agility": 49,
      "physical": 47,
      "technique": 58
    }
  },
  {
    "id": 764,
    "name": "Pip Goodweather",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/e/recx1prerhm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 59,
      "control": 40,
      "pressure": 61,
      "agility": 50,
      "physical": 73,
      "technique": 46
    }
  },
  {
    "id": 765,
    "name": "Bamber Mandrina",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/x/lx_emskmeb8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 42,
      "control": 42,
      "pressure": 70,
      "agility": 57,
      "physical": 71,
      "technique": 52
    }
  },
  {
    "id": 766,
    "name": "Scrap Salvadge",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/z/6zolltc2zyu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 58,
      "control": 41,
      "pressure": 82,
      "agility": 43,
      "physical": 61,
      "technique": 55
    }
  },
  {
    "id": 767,
    "name": "Michael Angeloni",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/z/ozx96gbuun8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 41,
      "control": 49,
      "pressure": 60,
      "agility": 49,
      "physical": 76,
      "technique": 41
    }
  },
  {
    "id": 768,
    "name": "Ryder Wheeling",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/b/_bacxfnu5-u.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 48,
      "control": 58,
      "pressure": 55,
      "agility": 55,
      "physical": 69,
      "technique": 54
    }
  },
  {
    "id": 769,
    "name": "Stu Venier",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/z/rzbrneunys0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 58,
      "control": 50,
      "pressure": 73,
      "agility": 56,
      "physical": 50,
      "technique": 48
    }
  },
  {
    "id": 770,
    "name": "Linden Dray",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/b/gbqwghid1hc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 42,
      "control": 58,
      "pressure": 57,
      "agility": 50,
      "physical": 52,
      "technique": 56
    }
  },
  {
    "id": 771,
    "name": "Patsy Cornish",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/0/a0jfz89vabs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 66,
      "control": 62,
      "pressure": 57,
      "agility": 46,
      "physical": 46,
      "technique": 60
    }
  },
  {
    "id": 772,
    "name": "Sharkey Gobble",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/c/xc4kedbvtye.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 51,
      "control": 58,
      "pressure": 69,
      "agility": 47,
      "physical": 71,
      "technique": 53
    }
  },
  {
    "id": 773,
    "name": "Olly Popman",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/9/z9_4wajdo0e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 59,
      "control": 66,
      "pressure": 40,
      "agility": 50,
      "physical": 58,
      "technique": 58
    }
  },
  {
    "id": 774,
    "name": "Tyche Winham",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/v/cvozdlv5fhs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 59,
      "control": 54,
      "pressure": 67,
      "agility": 52,
      "physical": 63,
      "technique": 60
    }
  },
  {
    "id": 775,
    "name": "Page Helper",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/6/i6tso4axwnc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 56,
      "control": 63,
      "pressure": 43,
      "agility": 53,
      "physical": 48,
      "technique": 58
    }
  },
  {
    "id": 776,
    "name": "Barry Lugh",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/s/tscnjh8ldu0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 46,
      "control": 44,
      "pressure": 51,
      "agility": 53,
      "physical": 60,
      "technique": 50
    }
  },
  {
    "id": 777,
    "name": "Jen Quibble",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/4/n4jvsk_p6rc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 60,
      "control": 48,
      "pressure": 70,
      "agility": 50,
      "physical": 56,
      "technique": 44
    }
  },
  {
    "id": 778,
    "name": "Dan Drobium",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/q/wqs0_1ztxy0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 50,
      "control": 49,
      "pressure": 45,
      "agility": 77,
      "physical": 44,
      "technique": 69
    }
  },
  {
    "id": 779,
    "name": "Lyle O'Day",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/4/y4d_r8zmonc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 58,
      "control": 48,
      "pressure": 60,
      "agility": 59,
      "physical": 44,
      "technique": 49
    }
  },
  {
    "id": 780,
    "name": "Crane Clawson",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/q/pqse8dvcf-0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 67,
      "control": 65,
      "pressure": 41,
      "agility": 56,
      "physical": 55,
      "technique": 55
    }
  },
  {
    "id": 781,
    "name": "Raven Crowe",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/_/j_prveguwee.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 47,
      "control": 51,
      "pressure": 59,
      "agility": 54,
      "physical": 59,
      "technique": 59
    }
  },
  {
    "id": 782,
    "name": "Shirley Ladyman",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/x/4x-kchgudts.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 46,
      "control": 40,
      "pressure": 63,
      "agility": 54,
      "physical": 61,
      "technique": 55
    }
  },
  {
    "id": 783,
    "name": "Cody Barani",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/2/625ws4ucyrs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 46,
      "control": 51,
      "pressure": 63,
      "agility": 49,
      "physical": 61,
      "technique": 58
    }
  },
  {
    "id": 784,
    "name": "Bob Shishker",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/e/lei3bhy41ye.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 46,
      "control": 52,
      "pressure": 56,
      "agility": 64,
      "physical": 55,
      "technique": 56
    }
  },
  {
    "id": 785,
    "name": "Pica Vellosum",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/x/rxrcsahwa40.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 49,
      "control": 54,
      "pressure": 46,
      "agility": 77,
      "physical": 44,
      "technique": 63
    }
  },
  {
    "id": 786,
    "name": "Sascha Powder",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/z/azaj_lhktlc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 49,
      "control": 56,
      "pressure": 53,
      "agility": 56,
      "physical": 59,
      "technique": 49
    }
  },
  {
    "id": 787,
    "name": "Gore Lyath",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/z/uzl7ooiok00.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 75,
      "control": 67,
      "pressure": 44,
      "agility": 60,
      "physical": 47,
      "technique": 74
    }
  },
  {
    "id": 788,
    "name": "Marty Gras",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/b/fbuajxesnhc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 52,
      "control": 47,
      "pressure": 46,
      "agility": 57,
      "physical": 46,
      "technique": 67
    }
  },
  {
    "id": 789,
    "name": "Bob Dingnagian",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/z/xzpx5wnbgr8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 57,
      "control": 71,
      "pressure": 49,
      "agility": 46,
      "physical": 52,
      "technique": 55
    }
  },
  {
    "id": 790,
    "name": "Hugh Dyer",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/b/ab-2uprhryu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 56,
      "control": 53,
      "pressure": 69,
      "agility": 53,
      "physical": 64,
      "technique": 52
    }
  },
  {
    "id": 791,
    "name": "Carl Penter",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/0/g0ddh0epe4k.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 54,
      "control": 55,
      "pressure": 49,
      "agility": 71,
      "physical": 45,
      "technique": 51
    }
  },
  {
    "id": 792,
    "name": "Jebb Ettow",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/c/rcsiql4tzlm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 47,
      "control": 44,
      "pressure": 54,
      "agility": 63,
      "physical": 49,
      "technique": 64
    }
  },
  {
    "id": 793,
    "name": "Julian Siezer",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/9/t9r-esq_2nm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 50,
      "control": 51,
      "pressure": 48,
      "agility": 65,
      "physical": 48,
      "technique": 58
    }
  },
  {
    "id": 794,
    "name": "Bill Dozer",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/v/ivafptmfb-k.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 41,
      "control": 49,
      "pressure": 61,
      "agility": 58,
      "physical": 55,
      "technique": 55
    }
  },
  {
    "id": 795,
    "name": "Benny Factor",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/6/c65q6w5nueu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 59,
      "control": 45,
      "pressure": 57,
      "agility": 46,
      "physical": 56,
      "technique": 41
    }
  },
  {
    "id": 796,
    "name": "Roman Candler",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/s/zsilxpf3dt8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 63,
      "control": 75,
      "pressure": 53,
      "agility": 45,
      "physical": 57,
      "technique": 58
    }
  },
  {
    "id": 797,
    "name": "Ray Whitehead",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/4/h43tmccvksu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 69,
      "control": 78,
      "pressure": 45,
      "agility": 56,
      "physical": 47,
      "technique": 58
    }
  },
  {
    "id": 798,
    "name": "Aston Isher",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/q/2qgyl96vjh8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 69,
      "control": 63,
      "pressure": 44,
      "agility": 47,
      "physical": 49,
      "technique": 54
    }
  },
  {
    "id": 799,
    "name": "Grover Bearing",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/u/kuqjo4jliym.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 46,
      "control": 41,
      "pressure": 68,
      "agility": 42,
      "physical": 68,
      "technique": 58
    }
  },
  {
    "id": 800,
    "name": "Andy Sided",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/g/7ghcfhvflbk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 49,
      "control": 42,
      "pressure": 62,
      "agility": 53,
      "physical": 69,
      "technique": 45
    }
  },
  {
    "id": 801,
    "name": "Phil O'Biblist",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/p/bpc3waaxqhu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 71,
      "control": 75,
      "pressure": 56,
      "agility": 50,
      "physical": 48,
      "technique": 59
    }
  },
  {
    "id": 802,
    "name": "Roy Plimsole",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/b/qbzw7l8t9s8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 45,
      "control": 59,
      "pressure": 61,
      "agility": 54,
      "physical": 74,
      "technique": 49
    }
  },
  {
    "id": 803,
    "name": "Jem Paste",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/g/og0kv8ub4u8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 42,
      "control": 40,
      "pressure": 59,
      "agility": 44,
      "physical": 57,
      "technique": 48
    }
  },
  {
    "id": 804,
    "name": "Mike Creasewell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/i/zifr4di7vnu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 62,
      "control": 54,
      "pressure": 43,
      "agility": 43,
      "physical": 58,
      "technique": 72
    }
  },
  {
    "id": 805,
    "name": "Hale Quinn",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/n/5nmere9zghk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 43,
      "control": 53,
      "pressure": 53,
      "agility": 45,
      "physical": 58,
      "technique": 41
    }
  },
  {
    "id": 806,
    "name": "Al Askan",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/p/ipx_ghbjn0m.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 49,
      "control": 45,
      "pressure": 43,
      "agility": 74,
      "physical": 43,
      "technique": 65
    }
  },
  {
    "id": 807,
    "name": "Scot Chopper",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/l/8lon3syrqlk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 60,
      "control": 51,
      "pressure": 70,
      "agility": 52,
      "physical": 75,
      "technique": 55
    }
  },
  {
    "id": 808,
    "name": "Nick Templeton",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/n/nnzgat-rh4m.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 50,
      "control": 45,
      "pressure": 52,
      "agility": 65,
      "physical": 48,
      "technique": 55
    }
  },
  {
    "id": 809,
    "name": "Butler Chambers",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/l/jlclas3ymus.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 55,
      "control": 60,
      "pressure": 59,
      "agility": 70,
      "physical": 44,
      "technique": 51
    }
  },
  {
    "id": 810,
    "name": "Pip Skinner",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/n/snzqttrilne.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 44,
      "control": 41,
      "pressure": 75,
      "agility": 52,
      "physical": 58,
      "technique": 44
    }
  },
  {
    "id": 811,
    "name": "Dan Vega",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/i/yiqf-wkq-h0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 45,
      "control": 43,
      "pressure": 70,
      "agility": 53,
      "physical": 72,
      "technique": 55
    }
  },
  {
    "id": 812,
    "name": "Manny Kinsland",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/k/dkh-tpcqt0c.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 51,
      "control": 50,
      "pressure": 53,
      "agility": 65,
      "physical": 49,
      "technique": 55
    }
  },
  {
    "id": 813,
    "name": "Chick Adiddy",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/r/brmi9wq8wyc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 43,
      "control": 56,
      "pressure": 58,
      "agility": 63,
      "physical": 55,
      "technique": 54
    }
  },
  {
    "id": 814,
    "name": "Jig Charleston",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/d/wdxdqp2g7b0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 70,
      "control": 75,
      "pressure": 59,
      "agility": 50,
      "physical": 44,
      "technique": 55
    }
  },
  {
    "id": 815,
    "name": "Powers Flawless",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/s/qs02d0doohe.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 55,
      "control": 59,
      "pressure": 53,
      "agility": 44,
      "physical": 63,
      "technique": 48
    }
  },
  {
    "id": 816,
    "name": "Alistair Horizon",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/e/hefxull0jss.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 63,
      "control": 56,
      "pressure": 43,
      "agility": 43,
      "physical": 55,
      "technique": 53
    }
  },
  {
    "id": 817,
    "name": "Tim Bergoods",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/u/vu6pfgmwete.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 60,
      "control": 64,
      "pressure": 52,
      "agility": 42,
      "physical": 41,
      "technique": 59
    }
  },
  {
    "id": 818,
    "name": "Lux Sidebottom",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/g/kgluy5aspes.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 47,
      "control": 43,
      "pressure": 75,
      "agility": 44,
      "physical": 72,
      "technique": 44
    }
  },
  {
    "id": 819,
    "name": "Nat Picker",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/u/quelcwqzwle.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 59,
      "control": 68,
      "pressure": 48,
      "agility": 47,
      "physical": 43,
      "technique": 48
    }
  },
  {
    "id": 820,
    "name": "Harold Derry",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/g/bg1expmj74s.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 42,
      "control": 41,
      "pressure": 64,
      "agility": 52,
      "physical": 67,
      "technique": 54
    }
  },
  {
    "id": 1021,
    "name": "Julius Vernon",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/5/g5zmtnjozlc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 41,
      "control": 51,
      "pressure": 68,
      "agility": 50,
      "physical": 60,
      "technique": 48
    }
  },
  {
    "id": 1022,
    "name": "Robin Sherwood",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/r/rrotayf0e40.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 43,
      "control": 51,
      "pressure": 43,
      "agility": 64,
      "physical": 60,
      "technique": 63
    }
  },
  {
    "id": 1023,
    "name": "Travis McClean",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/w/aw65-6wggrs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 64,
      "control": 69,
      "pressure": 42,
      "agility": 47,
      "physical": 58,
      "technique": 60
    }
  },
  {
    "id": 1024,
    "name": "Rusty Spoakes",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/8/08fhp3vkhue.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 44,
      "control": 57,
      "pressure": 61,
      "agility": 57,
      "physical": 59,
      "technique": 55
    }
  },
  {
    "id": 1025,
    "name": "Clint Wester",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/u/fu0aiizemns.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 40,
      "control": 58,
      "pressure": 77,
      "agility": 47,
      "physical": 68,
      "technique": 48
    }
  },
  {
    "id": 1026,
    "name": "Pete Nokeyo",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/8/r8vn4j6xtlm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 55,
      "control": 55,
      "pressure": 59,
      "agility": 45,
      "physical": 74,
      "technique": 47
    }
  },
  {
    "id": 1027,
    "name": "Will Racer",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/u/auesv2cta4k.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 49,
      "control": 56,
      "pressure": 40,
      "agility": 68,
      "physical": 56,
      "technique": 54
    }
  },
  {
    "id": 1028,
    "name": "Ollie Seeker",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/7/679zgrpl1yu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 62,
      "control": 69,
      "pressure": 50,
      "agility": 48,
      "physical": 53,
      "technique": 60
    }
  },
  {
    "id": 1029,
    "name": "Graham Hush",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/t/ltm4rupfyr8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 46,
      "control": 49,
      "pressure": 41,
      "agility": 60,
      "physical": 49,
      "technique": 59
    }
  },
  {
    "id": 1030,
    "name": "Ronny Knowles",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/y/jylkfndzdt8.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 57,
      "control": 54,
      "pressure": 69,
      "agility": 60,
      "physical": 61,
      "technique": 46
    }
  },
  {
    "id": 1031,
    "name": "Les Abel",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/a/4a6foy7jweu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 59,
      "control": 52,
      "pressure": 45,
      "agility": 69,
      "physical": 49,
      "technique": 55
    }
  },
  {
    "id": 1032,
    "name": "Reg Thrift",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/1/y1zw7vobf-k.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 48,
      "control": 53,
      "pressure": 69,
      "agility": 59,
      "physical": 60,
      "technique": 43
    }
  },
  {
    "id": 1033,
    "name": "Jools Iceberg",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/d/pdorwqo7onm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 50,
      "control": 49,
      "pressure": 47,
      "agility": 73,
      "physical": 51,
      "technique": 63
    }
  },
  {
    "id": 1034,
    "name": "Mark Brent",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/3/d3xjndrzpyk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 63,
      "control": 68,
      "pressure": 40,
      "agility": 47,
      "physical": 60,
      "technique": 66
    }
  },
  {
    "id": 1035,
    "name": "Vern Ironfist",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/f/sfmokinjibm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 57,
      "control": 58,
      "pressure": 60,
      "agility": 77,
      "physical": 48,
      "technique": 56
    }
  },
  {
    "id": 1036,
    "name": "Rob Burnsides",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/b/gbzawitrcqe.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 49,
      "control": 55,
      "pressure": 57,
      "agility": 41,
      "physical": 78,
      "technique": 41
    }
  },
  {
    "id": 1037,
    "name": "Ace Bragg",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/z/3zc77d1rxzs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 63,
      "control": 68,
      "pressure": 50,
      "agility": 59,
      "physical": 46,
      "technique": 58
    }
  },
  {
    "id": 1038,
    "name": "Claude Snap",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/c/xchooaaje5c.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 83,
      "intelligence": 47,
      "control": 49,
      "pressure": 42,
      "agility": 59,
      "physical": 48,
      "technique": 53
    }
  },
  {
    "id": 1039,
    "name": "Paul Rush",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/0/m0qvf_mzpk0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 64,
      "control": 54,
      "pressure": 51,
      "agility": 46,
      "physical": 47,
      "technique": 48
    }
  },
  {
    "id": 1040,
    "name": "Guile Crocket",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/v/kvxzrm01sm0.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 44,
      "control": 51,
      "pressure": 58,
      "agility": 54,
      "physical": 66,
      "technique": 52
    }
  },
  {
    "id": 1041,
    "name": "Carey Bean",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/9/v9msgzspb_c.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 71,
      "control": 66,
      "pressure": 40,
      "agility": 45,
      "physical": 46,
      "technique": 60
    }
  },
  {
    "id": 1042,
    "name": "John Maggie",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/s/1sfnvenh0fs.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 41,
      "control": 51,
      "pressure": 56,
      "agility": 44,
      "physical": 56,
      "technique": 43
    }
  },
  {
    "id": 1043,
    "name": "Chops Denton",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/6/e60g47b9zse.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 70,
      "control": 78,
      "pressure": 48,
      "agility": 46,
      "physical": 41,
      "technique": 70
    }
  },
  {
    "id": 1044,
    "name": "Bobby Yellow",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/q/wqlej2cf-ts.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 40,
      "control": 59,
      "pressure": 74,
      "agility": 53,
      "physical": 72,
      "technique": 42
    }
  },
  {
    "id": 1045,
    "name": "Ace Breaker",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/4/b46_kjkltge.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 40,
      "control": 53,
      "pressure": 66,
      "agility": 57,
      "physical": 53,
      "technique": 48
    }
  },
  {
    "id": 1046,
    "name": "Percy Verence",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/q/vqhy-itsymk.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 52,
      "control": 42,
      "pressure": 53,
      "agility": 65,
      "physical": 45,
      "technique": 52
    }
  },
  {
    "id": 1047,
    "name": "Rex George",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/s/0s9og4sf-gu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 43,
      "control": 50,
      "pressure": 81,
      "agility": 47,
      "physical": 66,
      "technique": 55
    }
  },
  {
    "id": 1048,
    "name": "Dave Altair",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/m/emoe3kelp2e.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 46,
      "control": 58,
      "pressure": 50,
      "agility": 75,
      "physical": 40,
      "technique": 66
    }
  },
  {
    "id": 1049,
    "name": "Gene Bottle",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/q/vqntpxrpskm.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 49,
      "control": 42,
      "pressure": 40,
      "agility": 62,
      "physical": 57,
      "technique": 47
    }
  },
  {
    "id": 1050,
    "name": "Shadow Cimmerian",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/b/zbz2hc8iq1m.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 60,
      "control": 59,
      "pressure": 59,
      "agility": 65,
      "physical": 41,
      "technique": 64
    }
  },
  {
    "id": 1051,
    "name": "Paul Peabody",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/_/p_chtvykhsu.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 56,
      "control": 40,
      "pressure": 66,
      "agility": 50,
      "physical": 71,
      "technique": 44
    }
  },
  {
    "id": 1052,
    "name": "Ton Nino",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/k/gkf_e1sirxc.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 68,
      "control": 55,
      "pressure": 49,
      "agility": 44,
      "physical": 42,
      "technique": 66
    }
  },
  {
    "id": 1056,
    "name": "Sagaminator",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/z/czxp9uz6a5m.png",
    "game": [
      "Inazuma Eleven 1"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 51,
      "control": 46,
      "pressure": 45,
      "agility": 56,
      "physical": 56,
      "technique": 67
    }
  },
  {
    "id": 1057,
    "name": "Galileo",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/n/4nterayuxru.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 45,
      "control": 49,
      "pressure": 68,
      "agility": 58,
      "physical": 63,
      "technique": 48
    }
  },
  {
    "id": 1058,
    "name": "Coral",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/i/yioxcdtmilk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 42,
      "control": 55,
      "pressure": 53,
      "agility": 50,
      "physical": 66,
      "technique": 60
    }
  },
  {
    "id": 1059,
    "name": "Gigs",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/k/pk_qvilcp4m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 60,
      "control": 52,
      "pressure": 70,
      "agility": 40,
      "physical": 61,
      "technique": 46
    }
  },
  {
    "id": 1060,
    "name": "Ganymede",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/r/rr4mb7zwk-m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 57,
      "control": 58,
      "pressure": 57,
      "agility": 40,
      "physical": 63,
      "technique": 53
    }
  },
  {
    "id": 1061,
    "name": "Charon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/d/adjtse_knnk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 40,
      "control": 56,
      "pressure": 72,
      "agility": 48,
      "physical": 72,
      "technique": 51
    }
  },
  {
    "id": 1062,
    "name": "Pandora",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/s/6sqy_zkcstu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 70,
      "control": 67,
      "pressure": 43,
      "agility": 60,
      "physical": 53,
      "technique": 70
    }
  },
  {
    "id": 1063,
    "name": "Grengo",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/e/leb5sms4_e8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 55,
      "control": 66,
      "pressure": 59,
      "agility": 41,
      "physical": 44,
      "technique": 61
    }
  },
  {
    "id": 1064,
    "name": "Io",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/u/_ukhjrvayhu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 73,
      "control": 69,
      "pressure": 60,
      "agility": 58,
      "physical": 60,
      "technique": 57
    }
  },
  {
    "id": 1065,
    "name": "Rihm",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/g/ogvaoujg1s8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 54,
      "control": 45,
      "pressure": 40,
      "agility": 63,
      "physical": 41,
      "technique": 61
    }
  },
  {
    "id": 1066,
    "name": "Janus",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/u/guonuvapu-c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 75,
      "control": 80,
      "pressure": 48,
      "agility": 48,
      "physical": 59,
      "technique": 58
    }
  },
  {
    "id": 1067,
    "name": "Diam",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/g/rg_s5qmt5n0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 45,
      "control": 46,
      "pressure": 59,
      "agility": 63,
      "physical": 46,
      "technique": 49
    }
  },
  {
    "id": 1068,
    "name": "Dvalin",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/n/yn5cli7sjsc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 48,
      "control": 43,
      "pressure": 58,
      "agility": 51,
      "physical": 59,
      "technique": 47
    }
  },
  {
    "id": 1069,
    "name": "Kenville",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/i/4ia32voa8ys.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 43,
      "control": 60,
      "pressure": 54,
      "agility": 50,
      "physical": 72,
      "technique": 44
    }
  },
  {
    "id": 1070,
    "name": "Mole",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/k/jkrwbqogrbe.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 59,
      "control": 51,
      "pressure": 58,
      "agility": 42,
      "physical": 68,
      "technique": 57
    }
  },
  {
    "id": 1071,
    "name": "Kayson",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/r/lrsk1z6muhe.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 52,
      "control": 59,
      "pressure": 69,
      "agility": 49,
      "physical": 57,
      "technique": 57
    }
  },
  {
    "id": 1072,
    "name": "Tytan",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/d/6ddrymc250s.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 57,
      "control": 58,
      "pressure": 71,
      "agility": 57,
      "physical": 55,
      "technique": 58
    }
  },
  {
    "id": 1073,
    "name": "Fedora",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/s/as-elrp-muc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 80,
      "control": 58,
      "pressure": 48,
      "agility": 60,
      "physical": 46,
      "technique": 57
    }
  },
  {
    "id": 1074,
    "name": "Krypto",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/e/rep_mupehn0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 77,
      "control": 68,
      "pressure": 42,
      "agility": 58,
      "physical": 53,
      "technique": 70
    }
  },
  {
    "id": 1075,
    "name": "Sworm",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/u/fuwnxjmmgyc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 57,
      "control": 72,
      "pressure": 58,
      "agility": 60,
      "physical": 40,
      "technique": 65
    }
  },
  {
    "id": 1076,
    "name": "Mercury",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/g/ugbg6cqcrr0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 82,
      "intelligence": 57,
      "control": 56,
      "pressure": 57,
      "agility": 69,
      "physical": 56,
      "technique": 66
    }
  },
  {
    "id": 1077,
    "name": "Metron",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/u/aualgdjvkhu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 45,
      "control": 45,
      "pressure": 48,
      "agility": 66,
      "physical": 44,
      "technique": 68
    }
  },
  {
    "id": 1078,
    "name": "Zell",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/g/xgrqnifvn08.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 58,
      "control": 44,
      "pressure": 48,
      "agility": 61,
      "physical": 50,
      "technique": 60
    }
  },
  {
    "id": 1090,
    "name": "Grent",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/g/-gdcdkjkbiu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 50,
      "control": 44,
      "pressure": 71,
      "agility": 48,
      "physical": 51,
      "technique": 49
    }
  },
  {
    "id": 1092,
    "name": "Baller",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/p/epg3oxws0ck.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 57,
      "control": 49,
      "pressure": 75,
      "agility": 51,
      "physical": 68,
      "technique": 56
    }
  },
  {
    "id": 1094,
    "name": "Balcke",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/k/rkqk3_p0lsc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 51,
      "control": 50,
      "pressure": 75,
      "agility": 60,
      "physical": 69,
      "technique": 56
    }
  },
  {
    "id": 1095,
    "name": "Seats",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/f/pfx4zm7yoqc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 50,
      "control": 50,
      "pressure": 72,
      "agility": 48,
      "physical": 65,
      "technique": 59
    }
  },
  {
    "id": 1096,
    "name": "Bomber",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/u/cunrgoeaxek.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 69,
      "control": 70,
      "pressure": 41,
      "agility": 56,
      "physical": 41,
      "technique": 59
    }
  },
  {
    "id": 1098,
    "name": "Heat",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/b/8beeztxieku.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 54,
      "control": 79,
      "pressure": 51,
      "agility": 51,
      "physical": 49,
      "technique": 75
    }
  },
  {
    "id": 1100,
    "name": "Lean",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/q/jq0nk7oq7ks.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 54,
      "control": 70,
      "pressure": 56,
      "agility": 51,
      "physical": 56,
      "technique": 54
    }
  },
  {
    "id": 1101,
    "name": "Bountine",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/a/9alv72nyc1e.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 64,
      "control": 60,
      "pressure": 42,
      "agility": 47,
      "physical": 45,
      "technique": 57
    }
  },
  {
    "id": 1102,
    "name": "Sidern",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/o/mo60wjrixgs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 60,
      "control": 57,
      "pressure": 43,
      "agility": 76,
      "physical": 43,
      "technique": 46
    }
  },
  {
    "id": 1103,
    "name": "Torch",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/d/mdglyf7jc3c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 43,
      "control": 58,
      "pressure": 52,
      "agility": 74,
      "physical": 48,
      "technique": 53
    }
  },
  {
    "id": 1105,
    "name": "Neppten",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/r/xrrq1gdzve0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 52,
      "control": 44,
      "pressure": 45,
      "agility": 56,
      "physical": 46,
      "technique": 59
    }
  },
  {
    "id": 1107,
    "name": "Beluga",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/j/ajw29vz6ngm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 50,
      "control": 45,
      "pressure": 78,
      "agility": 41,
      "physical": 65,
      "technique": 49
    }
  },
  {
    "id": 1108,
    "name": "Arkew",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/m/6m1duisy4m8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 57,
      "control": 51,
      "pressure": 73,
      "agility": 59,
      "physical": 58,
      "technique": 54
    }
  },
  {
    "id": 1109,
    "name": "Clear",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/n/vnrwjowwzxm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 40,
      "control": 49,
      "pressure": 68,
      "agility": 43,
      "physical": 76,
      "technique": 40
    }
  },
  {
    "id": 1111,
    "name": "Gocker",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/g/tgwknxi6c3m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 53,
      "control": 42,
      "pressure": 75,
      "agility": 53,
      "physical": 56,
      "technique": 54
    }
  },
  {
    "id": 1113,
    "name": "Icer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/t/4tyfar-e9g8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 66,
      "control": 63,
      "pressure": 42,
      "agility": 44,
      "physical": 56,
      "technique": 70
    }
  },
  {
    "id": 1114,
    "name": "Balen",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/c/ycrqtmlwiam.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 55,
      "control": 64,
      "pressure": 59,
      "agility": 54,
      "physical": 57,
      "technique": 66
    }
  },
  {
    "id": 1115,
    "name": "Droll",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/p/np1_esxypx8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 65,
      "control": 65,
      "pressure": 51,
      "agility": 57,
      "physical": 43,
      "technique": 60
    }
  },
  {
    "id": 1117,
    "name": "Rhine",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/d/5dknvhuqoou.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 61,
      "control": 61,
      "pressure": 58,
      "agility": 59,
      "physical": 58,
      "technique": 48
    }
  },
  {
    "id": 1119,
    "name": "Blown",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/o/souyibi0v_k.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 59,
      "control": 48,
      "pressure": 53,
      "agility": 53,
      "physical": 49,
      "technique": 60
    }
  },
  {
    "id": 1120,
    "name": "Gazelle",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/r/ir7gceyqjb8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 51,
      "control": 47,
      "pressure": 53,
      "agility": 64,
      "physical": 40,
      "technique": 45
    }
  },
  {
    "id": 1122,
    "name": "Frost",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/o/zoeev_nhjgs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 52,
      "control": 55,
      "pressure": 46,
      "agility": 51,
      "physical": 53,
      "technique": 61
    }
  },
  {
    "id": 1123,
    "name": "Nero",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/b/kb0ecmbrptm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 52,
      "control": 57,
      "pressure": 67,
      "agility": 57,
      "physical": 65,
      "technique": 53
    }
  },
  {
    "id": 1124,
    "name": "Gele",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/0/q0xrpr0zcn8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 52,
      "control": 59,
      "pressure": 70,
      "agility": 51,
      "physical": 75,
      "technique": 57
    }
  },
  {
    "id": 1125,
    "name": "Kiburn",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/c/bcmkiusjx-u.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 58,
      "control": 51,
      "pressure": 60,
      "agility": 44,
      "physical": 66,
      "technique": 47
    }
  },
  {
    "id": 1126,
    "name": "Zohen",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/9/z9hwm3ap04u.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 57,
      "control": 56,
      "pressure": 65,
      "agility": 44,
      "physical": 61,
      "technique": 41
    }
  },
  {
    "id": 1127,
    "name": "Hauser",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/v/ovq3him1zl8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 42,
      "control": 56,
      "pressure": 57,
      "agility": 46,
      "physical": 69,
      "technique": 41
    }
  },
  {
    "id": 1128,
    "name": "Kormer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/6/i6zcyvt9srm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 60,
      "control": 71,
      "pressure": 52,
      "agility": 53,
      "physical": 54,
      "technique": 50
    }
  },
  {
    "id": 1129,
    "name": "Kiwill",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/s/5scjfq1hbyk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 59,
      "control": 69,
      "pressure": 59,
      "agility": 52,
      "physical": 54,
      "technique": 51
    }
  },
  {
    "id": 1130,
    "name": "Ark",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/4/n497un2lmnm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 70,
      "control": 69,
      "pressure": 42,
      "agility": 50,
      "physical": 45,
      "technique": 54
    }
  },
  {
    "id": 1131,
    "name": "Wittz",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/q/8qmadyqfluk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 51,
      "control": 50,
      "pressure": 40,
      "agility": 56,
      "physical": 53,
      "technique": 50
    }
  },
  {
    "id": 1132,
    "name": "Bellatrix",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/4/s4xxzzzwq4e.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 73,
      "control": 62,
      "pressure": 46,
      "agility": 40,
      "physical": 52,
      "technique": 48
    }
  },
  {
    "id": 1133,
    "name": "Xene",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/q/jqm20m_shls.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 42,
      "control": 40,
      "pressure": 40,
      "agility": 56,
      "physical": 47,
      "technique": 53
    }
  },
  {
    "id": 1135,
    "name": "Ken Ironwall",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/i/yi2p3e1leik.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 51,
      "control": 46,
      "pressure": 77,
      "agility": 56,
      "physical": 65,
      "technique": 46
    }
  },
  {
    "id": 1136,
    "name": "Timothy Western",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/n/4nv6kdadxou.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 59,
      "control": 56,
      "pressure": 75,
      "agility": 57,
      "physical": 61,
      "technique": 52
    }
  },
  {
    "id": 1137,
    "name": "Wallace Hammond",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/l/jlkbj8m5cb8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 48,
      "control": 41,
      "pressure": 57,
      "agility": 49,
      "physical": 60,
      "technique": 51
    }
  },
  {
    "id": 1138,
    "name": "Shirley Stevens",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/e/lejhnl0vzd8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 55,
      "control": 55,
      "pressure": 78,
      "agility": 46,
      "physical": 76,
      "technique": 59
    }
  },
  {
    "id": 1139,
    "name": "Ian Smith",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/s/6ssmkasv0uu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 41,
      "control": 43,
      "pressure": 63,
      "agility": 47,
      "physical": 76,
      "technique": 50
    }
  },
  {
    "id": 1140,
    "name": "Taylor Firepool",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/d/adxtzhnnbok.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 66,
      "control": 56,
      "pressure": 59,
      "agility": 52,
      "physical": 53,
      "technique": 67
    }
  },
  {
    "id": 1141,
    "name": "Marge Fielding",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/r/rray04bds9m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 61,
      "control": 73,
      "pressure": 56,
      "agility": 55,
      "physical": 54,
      "technique": 61
    }
  },
  {
    "id": 1142,
    "name": "Marshall Firsthand",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/b/fb_qf1c_lck.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 59,
      "control": 61,
      "pressure": 47,
      "agility": 52,
      "physical": 45,
      "technique": 52
    }
  },
  {
    "id": 1143,
    "name": "Holly Mirror",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/p/upolokkfmxm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 55,
      "control": 42,
      "pressure": 45,
      "agility": 61,
      "physical": 55,
      "technique": 63
    }
  },
  {
    "id": 1144,
    "name": "Victoria Vanguard",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/b/abvgyltmhds.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 54,
      "control": 64,
      "pressure": 60,
      "agility": 57,
      "physical": 41,
      "technique": 55
    }
  },
  {
    "id": 1146,
    "name": "Joe Kenneddy",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/p/xpknf0l2que.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 57,
      "control": 56,
      "pressure": 59,
      "agility": 52,
      "physical": 59,
      "technique": 59
    }
  },
  {
    "id": 1147,
    "name": "Ian Sights",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/g/rghsmp--fo0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 58,
      "control": 49,
      "pressure": 74,
      "agility": 48,
      "physical": 57,
      "technique": 56
    }
  },
  {
    "id": 1148,
    "name": "Greene Beray",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/u/gu2zhwyey9c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 59,
      "control": 48,
      "pressure": 66,
      "agility": 54,
      "physical": 75,
      "technique": 58
    }
  },
  {
    "id": 1149,
    "name": "Ryan Tappin",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/p/ipxvppko37c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 75,
      "control": 67,
      "pressure": 45,
      "agility": 56,
      "physical": 42,
      "technique": 54
    }
  },
  {
    "id": 1150,
    "name": "Linda Shadey",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/n/tnaoiwssai0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 53,
      "control": 47,
      "pressure": 44,
      "agility": 71,
      "physical": 57,
      "technique": 64
    }
  },
  {
    "id": 1151,
    "name": "Sid Safehouse",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/i/zij7xtzavoe.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 55,
      "control": 42,
      "pressure": 66,
      "agility": 50,
      "physical": 59,
      "technique": 48
    }
  },
  {
    "id": 1152,
    "name": "Adam Ropes",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/i/4iijdww3axs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 51,
      "control": 57,
      "pressure": 53,
      "agility": 51,
      "physical": 53,
      "technique": 46
    }
  },
  {
    "id": 1153,
    "name": "Joaquine Downtown",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/n/ynb8qlj_vrc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 58,
      "control": 52,
      "pressure": 57,
      "agility": 44,
      "physical": 64,
      "technique": 55
    }
  },
  {
    "id": 1154,
    "name": "Milton Bindings",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/l/plwd90ffci0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 48,
      "control": 58,
      "pressure": 59,
      "agility": 59,
      "physical": 74,
      "technique": 53
    }
  },
  {
    "id": 1155,
    "name": "Spike Gleeson",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/e/re3bttxphk0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 60,
      "control": 51,
      "pressure": 78,
      "agility": 47,
      "physical": 76,
      "technique": 53
    }
  },
  {
    "id": 1156,
    "name": "Sean Snowfield",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/s/asgg-sxtqxc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 75,
      "control": 65,
      "pressure": 54,
      "agility": 44,
      "physical": 52,
      "technique": 64
    }
  },
  {
    "id": 1157,
    "name": "Kerry Bootgaiter",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/d/6dlvtpebf3s.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 57,
      "control": 55,
      "pressure": 53,
      "agility": 53,
      "physical": 57,
      "technique": 56
    }
  },
  {
    "id": 1158,
    "name": "Maddox Rock",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/r/lru0awihyee.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 79,
      "control": 65,
      "pressure": 49,
      "agility": 45,
      "physical": 47,
      "technique": 65
    }
  },
  {
    "id": 1159,
    "name": "Robert Skipolson",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/b/_brsx9hdv7s.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 69,
      "control": 54,
      "pressure": 41,
      "agility": 54,
      "physical": 59,
      "technique": 58
    }
  },
  {
    "id": 1160,
    "name": "Shawn Froste",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/p/opancch54ie.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 57,
      "control": 41,
      "pressure": 71,
      "agility": 50,
      "physical": 60,
      "technique": 56
    }
  },
  {
    "id": 1163,
    "name": "Shawn Froste",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/k/wk5ezxf-7dm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 59,
      "control": 44,
      "pressure": 46,
      "agility": 57,
      "physical": 53,
      "technique": 69
    }
  },
  {
    "id": 1164,
    "name": "Roland Climbstein",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/b/gbbagdowzkk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 59,
      "control": 41,
      "pressure": 43,
      "agility": 71,
      "physical": 47,
      "technique": 57
    }
  },
  {
    "id": 1165,
    "name": "Quentin Rackner",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/p/rpwhr8ok0xm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 84,
      "intelligence": 57,
      "control": 52,
      "pressure": 44,
      "agility": 69,
      "physical": 46,
      "technique": 69
    }
  },
  {
    "id": 1166,
    "name": "Trent Peggs",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/g/xgtu4hdcb38.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 51,
      "control": 59,
      "pressure": 64,
      "agility": 57,
      "physical": 59,
      "technique": 55
    }
  },
  {
    "id": 1167,
    "name": "Martin Ursus",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/u/aui1ve74seu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 43,
      "control": 52,
      "pressure": 55,
      "agility": 50,
      "physical": 58,
      "technique": 43
    }
  },
  {
    "id": 1168,
    "name": "Pete Bogg",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/p/cplp7hpupcu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 69,
      "control": 60,
      "pressure": 57,
      "agility": 53,
      "physical": 40,
      "technique": 60
    }
  },
  {
    "id": 1169,
    "name": "Gem Strata",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/n/znuiw4puex8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 58,
      "control": 48,
      "pressure": 74,
      "agility": 51,
      "physical": 68,
      "technique": 55
    }
  },
  {
    "id": 1170,
    "name": "Horace Onlign",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/i/ti39fl6mxrm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 45,
      "control": 48,
      "pressure": 59,
      "agility": 73,
      "physical": 48,
      "technique": 61
    }
  },
  {
    "id": 1171,
    "name": "Hilton Bernaton",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/n/snbzvhuzhmm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 63,
      "control": 58,
      "pressure": 57,
      "agility": 47,
      "physical": 60,
      "technique": 48
    }
  },
  {
    "id": 1172,
    "name": "Crane Kik",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/0/q0vv6ss06o8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 50,
      "control": 58,
      "pressure": 53,
      "agility": 51,
      "physical": 58,
      "technique": 59
    }
  },
  {
    "id": 1173,
    "name": "Parry Waxon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/b/kbmgppz8pum.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 53,
      "control": 49,
      "pressure": 58,
      "agility": 52,
      "physical": 66,
      "technique": 47
    }
  },
  {
    "id": 1174,
    "name": "Bri Spark",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/z/7z9bew_gidk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 50,
      "control": 52,
      "pressure": 54,
      "agility": 43,
      "physical": 53,
      "technique": 57
    }
  },
  {
    "id": 1175,
    "name": "Max Fortune",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/s/5s6dqptqnbk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 42,
      "control": 51,
      "pressure": 59,
      "agility": 42,
      "physical": 75,
      "technique": 58
    }
  },
  {
    "id": 1176,
    "name": "Brendan Water",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/6/i6l8hwlqkom.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 57,
      "control": 42,
      "pressure": 51,
      "agility": 50,
      "physical": 70,
      "technique": 48
    }
  },
  {
    "id": 1177,
    "name": "Junior Fardream",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/v/ovojul-y_i8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 67,
      "control": 74,
      "pressure": 43,
      "agility": 42,
      "physical": 53,
      "technique": 54
    }
  },
  {
    "id": 1178,
    "name": "Ian Telektual",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/9/z9zo50yis7u.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 58,
      "control": 70,
      "pressure": 59,
      "agility": 56,
      "physical": 48,
      "technique": 56
    }
  },
  {
    "id": 1179,
    "name": "Lee Dinglite",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/x/txmwi5ba1e8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 57,
      "control": 63,
      "pressure": 55,
      "agility": 41,
      "physical": 58,
      "technique": 58
    }
  },
  {
    "id": 1180,
    "name": "Marshall Artz",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/_/c_xrlg96y3u.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 59,
      "control": 49,
      "pressure": 51,
      "agility": 58,
      "physical": 55,
      "technique": 66
    }
  },
  {
    "id": 1181,
    "name": "Tyke Wando",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/x/yxmc_h0z5b0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 50,
      "control": 48,
      "pressure": 45,
      "agility": 64,
      "physical": 45,
      "technique": 62
    }
  },
  {
    "id": 1182,
    "name": "Dirk Artz",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/_/d_99s4sjuoc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 52,
      "control": 58,
      "pressure": 44,
      "agility": 59,
      "physical": 51,
      "technique": 67
    }
  },
  {
    "id": 1183,
    "name": "Scott Banyan",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/q/jqeiblnbhis.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 46,
      "control": 56,
      "pressure": 62,
      "agility": 41,
      "physical": 61,
      "technique": 44
    }
  },
  {
    "id": 1185,
    "name": "Earnest Bookworm",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/4/s4vpsab7m7e.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 45,
      "control": 53,
      "pressure": 56,
      "agility": 53,
      "physical": 70,
      "technique": 52
    }
  },
  {
    "id": 1186,
    "name": "Ollie Gami",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/z/qzo1cdtxj9e.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 53,
      "control": 40,
      "pressure": 63,
      "agility": 58,
      "physical": 75,
      "technique": 40
    }
  },
  {
    "id": 1187,
    "name": "Roman Kandel",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/x/hxzuv81tkos.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 59,
      "control": 63,
      "pressure": 57,
      "agility": 41,
      "physical": 56,
      "technique": 58
    }
  },
  {
    "id": 1188,
    "name": "Don Ation",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/e/be6h8halruc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 47,
      "control": 57,
      "pressure": 45,
      "agility": 64,
      "physical": 57,
      "technique": 72
    }
  },
  {
    "id": 1189,
    "name": "Isaias Setik",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/i/mi4sg8b7ug8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 57,
      "control": 41,
      "pressure": 58,
      "agility": 60,
      "physical": 72,
      "technique": 60
    }
  },
  {
    "id": 1190,
    "name": "Joseph King",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/0/k07toapik30.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 42,
      "control": 51,
      "pressure": 68,
      "agility": 46,
      "physical": 65,
      "technique": 55
    }
  },
  {
    "id": 1191,
    "name": "Rowan Beltzer",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/b/qbymdh6arxe.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 53,
      "control": 43,
      "pressure": 66,
      "agility": 57,
      "physical": 66,
      "technique": 50
    }
  },
  {
    "id": 1192,
    "name": "Blade Healen",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/z/bzphw4c68ks.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 49,
      "control": 51,
      "pressure": 71,
      "agility": 53,
      "physical": 63,
      "technique": 44
    }
  },
  {
    "id": 1193,
    "name": "Argie Bargie",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/s/zsubehow5is.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 58,
      "control": 48,
      "pressure": 56,
      "agility": 43,
      "physical": 70,
      "technique": 46
    }
  },
  {
    "id": 1194,
    "name": "Lee Bamboo",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/6/o6f6zeosure.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 52,
      "control": 44,
      "pressure": 74,
      "agility": 60,
      "physical": 58,
      "technique": 52
    }
  },
  {
    "id": 1195,
    "name": "Eton Messer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/v/iv8pgddkhx0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 71,
      "control": 64,
      "pressure": 58,
      "agility": 58,
      "physical": 40,
      "technique": 62
    }
  },
  {
    "id": 1196,
    "name": "Jonah Spark",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/9/59nun87emcc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 64,
      "control": 68,
      "pressure": 50,
      "agility": 52,
      "physical": 49,
      "technique": 71
    }
  },
  {
    "id": 1197,
    "name": "Sue Sparrow",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/x/nxy28x48r90.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 62,
      "control": 65,
      "pressure": 56,
      "agility": 44,
      "physical": 49,
      "technique": 63
    }
  },
  {
    "id": 1198,
    "name": "Riley Jamm",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/_/8_dxroeggoc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 55,
      "control": 47,
      "pressure": 40,
      "agility": 57,
      "physical": 40,
      "technique": 65
    }
  },
  {
    "id": 1199,
    "name": "Caleb Stonewall",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/x/sxyalpxpni8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 68,
      "control": 71,
      "pressure": 50,
      "agility": 52,
      "physical": 49,
      "technique": 60
    }
  },
  {
    "id": 1200,
    "name": "David Samford",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/_/j_p7mwx1kru.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 54,
      "control": 54,
      "pressure": 49,
      "agility": 59,
      "physical": 53,
      "technique": 67
    }
  },
  {
    "id": 1201,
    "name": "Jimbo Cellar",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/q/dqko1te9_xk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 47,
      "control": 49,
      "pressure": 77,
      "agility": 49,
      "physical": 66,
      "technique": 40
    }
  },
  {
    "id": 1202,
    "name": "Zenn Wildhorse",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/4/y47vysihscm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 44,
      "control": 56,
      "pressure": 42,
      "agility": 51,
      "physical": 41,
      "technique": 53
    }
  },
  {
    "id": 1203,
    "name": "Dawson Little",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/z/wz8z2lwrxem.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 49,
      "control": 45,
      "pressure": 66,
      "agility": 58,
      "physical": 73,
      "technique": 41
    }
  },
  {
    "id": 1204,
    "name": "Cosimo Beck",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/x/bxnsb0wr63k.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 58,
      "control": 66,
      "pressure": 60,
      "agility": 58,
      "physical": 44,
      "technique": 55
    }
  },
  {
    "id": 1205,
    "name": "Maston Color",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/e/heunipjzpxu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 75,
      "control": 73,
      "pressure": 53,
      "agility": 54,
      "physical": 51,
      "technique": 66
    }
  },
  {
    "id": 1206,
    "name": "Daisy Fields",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/e/pee7gjsukvc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 41,
      "control": 56,
      "pressure": 63,
      "agility": 48,
      "physical": 58,
      "technique": 48
    }
  },
  {
    "id": 1207,
    "name": "Alexia Sand",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/r/jr9ov-nmrps.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 49,
      "control": 46,
      "pressure": 66,
      "agility": 56,
      "physical": 69,
      "technique": 46
    }
  },
  {
    "id": 1208,
    "name": "Hellen Hearth",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/d/4dmv4bbc88e.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 40,
      "control": 41,
      "pressure": 67,
      "agility": 53,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 1209,
    "name": "Rose Pinkpetal",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/i/6ilzwytw56e.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 52,
      "control": 46,
      "pressure": 60,
      "agility": 49,
      "physical": 61,
      "technique": 46
    }
  },
  {
    "id": 1210,
    "name": "Esther Greenland",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/k/lk6s7n1kujs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 45,
      "control": 42,
      "pressure": 60,
      "agility": 57,
      "physical": 71,
      "technique": 40
    }
  },
  {
    "id": 1211,
    "name": "Bela Bluebells",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/l/rlzno6achpc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 73,
      "control": 69,
      "pressure": 56,
      "agility": 50,
      "physical": 60,
      "technique": 63
    }
  },
  {
    "id": 1212,
    "name": "Natalie Sunrise",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/n/anogffm4ma0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 63,
      "control": 62,
      "pressure": 41,
      "agility": 56,
      "physical": 55,
      "technique": 59
    }
  },
  {
    "id": 1213,
    "name": "Hillary Bush",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/n/unxe0ilarlc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 73,
      "control": 65,
      "pressure": 41,
      "agility": 49,
      "physical": 52,
      "technique": 63
    }
  },
  {
    "id": 1214,
    "name": "Mary Moor",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/p/fpm_z3dggw0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 75,
      "control": 64,
      "pressure": 58,
      "agility": 60,
      "physical": 50,
      "technique": 60
    }
  },
  {
    "id": 1215,
    "name": "Suzette Hartland",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/n/xn9yd2kpn6u.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 44,
      "control": 52,
      "pressure": 46,
      "agility": 71,
      "physical": 49,
      "technique": 65
    }
  },
  {
    "id": 1216,
    "name": "Lily Willow",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/p/apmtujstkj8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 83,
      "intelligence": 57,
      "control": 42,
      "pressure": 46,
      "agility": 76,
      "physical": 42,
      "technique": 57
    }
  },
  {
    "id": 1217,
    "name": "Dell Closeout",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/g/ggvm9uzb_pm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 52,
      "control": 43,
      "pressure": 56,
      "agility": 46,
      "physical": 74,
      "technique": 46
    }
  },
  {
    "id": 1218,
    "name": "Amy Spires",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/i/riehqr_hsak.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 42,
      "control": 50,
      "pressure": 65,
      "agility": 58,
      "physical": 72,
      "technique": 44
    }
  },
  {
    "id": 1219,
    "name": "Peony Cash",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/p/tpzb-ytnxck.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 55,
      "control": 64,
      "pressure": 49,
      "agility": 51,
      "physical": 57,
      "technique": 69
    }
  },
  {
    "id": 1220,
    "name": "Gayle Revel",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/b/ibo6tnl36vm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 65,
      "control": 71,
      "pressure": 48,
      "agility": 49,
      "physical": 48,
      "technique": 52
    }
  },
  {
    "id": 1221,
    "name": "Janine Brook",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/u/culpaq-_pp8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 59,
      "control": 52,
      "pressure": 75,
      "agility": 45,
      "physical": 57,
      "technique": 56
    }
  },
  {
    "id": 1222,
    "name": "Nerina Hartland",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/g/ugcf748fkgm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 59,
      "control": 59,
      "pressure": 74,
      "agility": 41,
      "physical": 61,
      "technique": 45
    }
  },
  {
    "id": 1223,
    "name": "Darren LaChance",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/y/oy1sibyz7wc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 53,
      "control": 42,
      "pressure": 67,
      "agility": 47,
      "physical": 67,
      "technique": 43
    }
  },
  {
    "id": 1224,
    "name": "Drancis Fake",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/3/u3wzbgt7oqs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 54,
      "control": 60,
      "pressure": 64,
      "agility": 56,
      "physical": 64,
      "technique": 60
    }
  },
  {
    "id": 1225,
    "name": "Mick Mishap",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/f/ffn425lbjje.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 50,
      "control": 50,
      "pressure": 61,
      "agility": 54,
      "physical": 65,
      "technique": 45
    }
  },
  {
    "id": 1226,
    "name": "Louis Leave",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/-/d-gkygztmle.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 58,
      "control": 56,
      "pressure": 67,
      "agility": 46,
      "physical": 70,
      "technique": 60
    }
  },
  {
    "id": 1227,
    "name": "Maurice Badgame",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/w/swrf1f_xlws.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 52,
      "control": 55,
      "pressure": 68,
      "agility": 50,
      "physical": 60,
      "technique": 41
    }
  },
  {
    "id": 1228,
    "name": "Cannon Random",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/5/m5ywmckf-2c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 78,
      "control": 62,
      "pressure": 45,
      "agility": 54,
      "physical": 44,
      "technique": 56
    }
  },
  {
    "id": 1229,
    "name": "Ulric Richmen",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/r/9rdrl9sltf0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 73,
      "control": 62,
      "pressure": 51,
      "agility": 60,
      "physical": 57,
      "technique": 55
    }
  },
  {
    "id": 1230,
    "name": "Dany Destiny",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/k/mkxn0a56oy8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 52,
      "control": 53,
      "pressure": 61,
      "agility": 57,
      "physical": 66,
      "technique": 48
    }
  },
  {
    "id": 1231,
    "name": "Spencer Duskplay",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/t/4tnoxpj9zj0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 63,
      "control": 72,
      "pressure": 40,
      "agility": 59,
      "physical": 55,
      "technique": 53
    }
  },
  {
    "id": 1232,
    "name": "Jonathan Luckyman",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/7/w7wlnoa04lu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 53,
      "control": 41,
      "pressure": 45,
      "agility": 64,
      "physical": 40,
      "technique": 67
    }
  },
  {
    "id": 1233,
    "name": "Joe Poker",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/t/ntnegxmovw8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 59,
      "control": 58,
      "pressure": 55,
      "agility": 76,
      "physical": 50,
      "technique": 73
    }
  },
  {
    "id": 1234,
    "name": "Wiley Cracker",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/8/h8exzstgg2m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 56,
      "control": 46,
      "pressure": 69,
      "agility": 54,
      "physical": 58,
      "technique": 54
    }
  },
  {
    "id": 1235,
    "name": "Mark Failing",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/u/2u1qet18nfk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 56,
      "control": 53,
      "pressure": 56,
      "agility": 73,
      "physical": 43,
      "technique": 56
    }
  },
  {
    "id": 1236,
    "name": "Alton Cotts",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/1/01ymwknqidk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 70,
      "control": 55,
      "pressure": 46,
      "agility": 42,
      "physical": 49,
      "technique": 62
    }
  },
  {
    "id": 1237,
    "name": "Mike Passing",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/d/fddtd1bqlwm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 82,
      "intelligence": 57,
      "control": 51,
      "pressure": 56,
      "agility": 66,
      "physical": 51,
      "technique": 66
    }
  },
  {
    "id": 1238,
    "name": "Knowle Bathers",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/y/lygyoo0iqq8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 54,
      "control": 52,
      "pressure": 68,
      "agility": 42,
      "physical": 60,
      "technique": 47
    }
  },
  {
    "id": 1239,
    "name": "Dave Fate",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/7/j78j6wvh06c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 81,
      "intelligence": 41,
      "control": 45,
      "pressure": 46,
      "agility": 65,
      "physical": 42,
      "technique": 66
    }
  },
  {
    "id": 1240,
    "name": "Augustus Hargrave",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/g/9gjnrd9b51u.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 73,
      "control": 61,
      "pressure": 60,
      "agility": 57,
      "physical": 54,
      "technique": 54
    }
  },
  {
    "id": 1241,
    "name": "Windell Balding",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/b/_borfavt8zu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 75,
      "control": 68,
      "pressure": 46,
      "agility": 46,
      "physical": 47,
      "technique": 70
    }
  },
  {
    "id": 1242,
    "name": "Rocky Black",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/s/bshhlvlrape.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 25,
      "intelligence": 41,
      "control": 58,
      "pressure": 54,
      "agility": 46,
      "physical": 68,
      "technique": 59
    }
  },
  {
    "id": 1243,
    "name": "Chad Taylor",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/9/79kuyy-zvj0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 54,
      "control": 45,
      "pressure": 61,
      "agility": 46,
      "physical": 61,
      "technique": 50
    }
  },
  {
    "id": 1244,
    "name": "Victor Hills",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/v/kvv11nyjc6c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 51,
      "control": 59,
      "pressure": 53,
      "agility": 41,
      "physical": 72,
      "technique": 53
    }
  },
  {
    "id": 1245,
    "name": "Hurley Kane",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/0/i0spbukph8c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 40,
      "control": 55,
      "pressure": 59,
      "agility": 45,
      "physical": 72,
      "technique": 52
    }
  },
  {
    "id": 1246,
    "name": "Hector Redding",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/c/5cji2rs1qp0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 46,
      "control": 56,
      "pressure": 71,
      "agility": 44,
      "physical": 73,
      "technique": 46
    }
  },
  {
    "id": 1247,
    "name": "Mackenzie Fordline",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/z/zza9l2z9fve.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 54,
      "control": 67,
      "pressure": 43,
      "agility": 58,
      "physical": 59,
      "technique": 69
    }
  },
  {
    "id": 1248,
    "name": "Cadence Soundtown",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/b/obxcij_hycs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 57,
      "control": 62,
      "pressure": 54,
      "agility": 52,
      "physical": 42,
      "technique": 55
    }
  },
  {
    "id": 1250,
    "name": "Dora Delight",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/x/cxoe5e8lvje.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 57,
      "control": 56,
      "pressure": 57,
      "agility": 53,
      "physical": 59,
      "technique": 57
    }
  },
  {
    "id": 1251,
    "name": "Tom Contented",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/z/tz_lu7af4qs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 69,
      "control": 64,
      "pressure": 40,
      "agility": 47,
      "physical": 42,
      "technique": 61
    }
  },
  {
    "id": 1252,
    "name": "Joston Easton",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/x/dxkoo6twz8m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 45,
      "control": 43,
      "pressure": 46,
      "agility": 72,
      "physical": 47,
      "technique": 52
    }
  },
  {
    "id": 1253,
    "name": "Spring Millpond",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/z/yzvjjf1s0pk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 45,
      "control": 54,
      "pressure": 56,
      "agility": 68,
      "physical": 43,
      "technique": 72
    }
  },
  {
    "id": 1254,
    "name": "Gaston Cooley",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/2/s228wyakbvu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 52,
      "control": 52,
      "pressure": 52,
      "agility": 50,
      "physical": 70,
      "technique": 41
    }
  },
  {
    "id": 1255,
    "name": "Bevan Breakfast",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/e/jehddnmesc8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 49,
      "control": 43,
      "pressure": 65,
      "agility": 42,
      "physical": 76,
      "technique": 60
    }
  },
  {
    "id": 1256,
    "name": "Jack Griddle",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/_/h_abz-0ypa8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 74,
      "control": 75,
      "pressure": 54,
      "agility": 56,
      "physical": 47,
      "technique": 55
    }
  },
  {
    "id": 1257,
    "name": "Stan Andagi",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/x/qxxgebsiepu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 64,
      "control": 56,
      "pressure": 42,
      "agility": 49,
      "physical": 45,
      "technique": 57
    }
  },
  {
    "id": 1258,
    "name": "Coral Talent",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/4/w4svncnaxjk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 50,
      "control": 48,
      "pressure": 40,
      "agility": 59,
      "physical": 46,
      "technique": 48
    }
  },
  {
    "id": 1259,
    "name": "Jambo Reemoth",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/p/op_woljxra8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 49,
      "control": 58,
      "pressure": 41,
      "agility": 75,
      "physical": 55,
      "technique": 56
    }
  },
  {
    "id": 1260,
    "name": "Thomas Feldt",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/s/7stn_noteqm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 26,
      "intelligence": 49,
      "control": 60,
      "pressure": 57,
      "agility": 41,
      "physical": 78,
      "technique": 54
    }
  },
  {
    "id": 1261,
    "name": "Malcolm Night",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/9/b9wss6dlxw8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 40,
      "control": 59,
      "pressure": 60,
      "agility": 45,
      "physical": 54,
      "technique": 56
    }
  },
  {
    "id": 1262,
    "name": "Shadow Cimmerian",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/v/qvbzbf7fcdu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 56,
      "control": 45,
      "pressure": 52,
      "agility": 63,
      "physical": 59,
      "technique": 70
    }
  },
  {
    "id": 1263,
    "name": "Jim Wraith",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/0/o0gvvcpzzfu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 40,
      "control": 46,
      "pressure": 67,
      "agility": 43,
      "physical": 63,
      "technique": 45
    }
  },
  {
    "id": 1264,
    "name": "Tod Ironside",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/c/zc3ocjpj028.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 62,
      "control": 70,
      "pressure": 47,
      "agility": 58,
      "physical": 60,
      "technique": 64
    }
  },
  {
    "id": 1265,
    "name": "Steve Grim",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/z/5zu7r-6bbwm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 65,
      "control": 56,
      "pressure": 58,
      "agility": 43,
      "physical": 60,
      "technique": 55
    }
  },
  {
    "id": 1266,
    "name": "Tim Saunders",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/b/ibla8bc7slk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 71,
      "control": 76,
      "pressure": 43,
      "agility": 47,
      "physical": 51,
      "technique": 58
    }
  },
  {
    "id": 1267,
    "name": "Sam Kincaid",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/x/8xacnmfzlam.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 61,
      "control": 69,
      "pressure": 46,
      "agility": 47,
      "physical": 51,
      "technique": 59
    }
  },
  {
    "id": 1268,
    "name": "Maxwell Carson",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/z/nzrjgz5jmpk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 73,
      "control": 65,
      "pressure": 60,
      "agility": 54,
      "physical": 52,
      "technique": 63
    }
  },
  {
    "id": 1269,
    "name": "Nathan Swift",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/x/jxwu6ywqhfe.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 55,
      "control": 50,
      "pressure": 51,
      "agility": 70,
      "physical": 41,
      "technique": 67
    }
  },
  {
    "id": 1271,
    "name": "Kevin Dragonfly",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/z/szbpxnwqq2s.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 58,
      "control": 46,
      "pressure": 51,
      "agility": 53,
      "physical": 54,
      "technique": 65
    }
  },
  {
    "id": 1272,
    "name": "Godric Wyles",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/u/futkwhaljtk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 74,
      "control": 54,
      "pressure": 42,
      "agility": 44,
      "physical": 56,
      "technique": 71
    }
  },
  {
    "id": 1273,
    "name": "Cam Mando",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/3/u3unuf1wots.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 40,
      "control": 40,
      "pressure": 72,
      "agility": 49,
      "physical": 72,
      "technique": 43
    }
  },
  {
    "id": 1274,
    "name": "Harry Boufante",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/y/oyns9yaedzc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 46,
      "control": 44,
      "pressure": 70,
      "agility": 44,
      "physical": 60,
      "technique": 56
    }
  },
  {
    "id": 1275,
    "name": "Todd Stuhl",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/w/_w8zqnmkwa0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 42,
      "control": 45,
      "pressure": 66,
      "agility": 42,
      "physical": 64,
      "technique": 40
    }
  },
  {
    "id": 1276,
    "name": "Aspen Blewit",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/r/9r7v--0i1g0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 58,
      "control": 51,
      "pressure": 70,
      "agility": 58,
      "physical": 65,
      "technique": 53
    }
  },
  {
    "id": 1277,
    "name": "Marismus Oregon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/5/m5kotbsyy1c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 55,
      "control": 41,
      "pressure": 56,
      "agility": 41,
      "physical": 75,
      "technique": 48
    }
  },
  {
    "id": 1278,
    "name": "Garjan Cypress",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/w/swp7acn6tvs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 75,
      "control": 74,
      "pressure": 55,
      "agility": 56,
      "physical": 53,
      "technique": 47
    }
  },
  {
    "id": 1279,
    "name": "Judas Deathcap",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/-/d-yatjbaame.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 72,
      "control": 75,
      "pressure": 51,
      "agility": 50,
      "physical": 56,
      "technique": 52
    }
  },
  {
    "id": 1280,
    "name": "Chase Faithfull",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/u/punccucinzs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 80,
      "control": 75,
      "pressure": 52,
      "agility": 59,
      "physical": 59,
      "technique": 64
    }
  },
  {
    "id": 1281,
    "name": "Chris Ticker",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/8/y8wjxrkykqe.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 45,
      "control": 43,
      "pressure": 51,
      "agility": 67,
      "physical": 53,
      "technique": 60
    }
  },
  {
    "id": 1282,
    "name": "Roy Daring",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/u/2unurqtrrgk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 56,
      "control": 45,
      "pressure": 41,
      "agility": 69,
      "physical": 50,
      "technique": 63
    }
  },
  {
    "id": 1283,
    "name": "Scaber Enoki",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/8/h88pgvlrg1m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 45,
      "control": 40,
      "pressure": 41,
      "agility": 60,
      "physical": 41,
      "technique": 67
    }
  },
  {
    "id": 1284,
    "name": "Seymour Hillman",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/1/o1pswzafzau.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 47,
      "control": 50,
      "pressure": 73,
      "agility": 56,
      "physical": 54,
      "technique": 56
    }
  },
  {
    "id": 1285,
    "name": "Charles Island",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/a/iaszje1nggk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 50,
      "control": 55,
      "pressure": 59,
      "agility": 40,
      "physical": 74,
      "technique": 46
    }
  },
  {
    "id": 1286,
    "name": "Garret Hairtown",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/y/5yd4o7t3rtm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 47,
      "control": 55,
      "pressure": 58,
      "agility": 45,
      "physical": 62,
      "technique": 45
    }
  },
  {
    "id": 1287,
    "name": "Arthur Sweet",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/t/7takgibbuvm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 56,
      "control": 49,
      "pressure": 77,
      "agility": 56,
      "physical": 76,
      "technique": 57
    }
  },
  {
    "id": 1288,
    "name": "Peter Mildred",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/7/k7rfndnhdmk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 71,
      "control": 65,
      "pressure": 44,
      "agility": 55,
      "physical": 54,
      "technique": 63
    }
  },
  {
    "id": 1289,
    "name": "Josh Nathaniel",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/u/quiweasp2gu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 73,
      "control": 53,
      "pressure": 50,
      "agility": 55,
      "physical": 55,
      "technique": 52
    }
  },
  {
    "id": 1290,
    "name": "Edward Gladstone",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/8/b85rz_0tb18.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 56,
      "control": 73,
      "pressure": 44,
      "agility": 51,
      "physical": 46,
      "technique": 66
    }
  },
  {
    "id": 1291,
    "name": "Tyler Thomas",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/w/vwgjcy3x8ku.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 55,
      "control": 59,
      "pressure": 59,
      "agility": 44,
      "physical": 48,
      "technique": 63
    }
  },
  {
    "id": 1292,
    "name": "Joseph Yosemite",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/-/e-3ovnrlr58.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 48,
      "control": 44,
      "pressure": 50,
      "agility": 65,
      "physical": 53,
      "technique": 65
    }
  },
  {
    "id": 1293,
    "name": "Ian Suffolk",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/w/wwsl1mycwvc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 75,
      "control": 71,
      "pressure": 58,
      "agility": 57,
      "physical": 51,
      "technique": 68
    }
  },
  {
    "id": 1294,
    "name": "Constant Builder",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/-/b-deyz-4dm0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 51,
      "control": 43,
      "pressure": 48,
      "agility": 68,
      "physical": 45,
      "technique": 60
    }
  },
  {
    "id": 1295,
    "name": "David Evans",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/f/cft3awvkb0e.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 60,
      "control": 52,
      "pressure": 62,
      "agility": 56,
      "physical": 51,
      "technique": 47
    }
  },
  {
    "id": 1326,
    "name": "Aquilina Schiller",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/-/g-obvenkgrc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 41,
      "control": 45,
      "pressure": 48,
      "agility": 65,
      "physical": 56,
      "technique": 64
    }
  },
  {
    "id": 1327,
    "name": "Thor Stoutberg",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/g/ag7gjc6nhqe.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 74,
      "control": 65,
      "pressure": 60,
      "agility": 48,
      "physical": 52,
      "technique": 66
    }
  },
  {
    "id": 1329,
    "name": "Syon Blaze",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/p/gpyvabpvuw0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 40,
      "control": 52,
      "pressure": 53,
      "agility": 76,
      "physical": 41,
      "technique": 55
    }
  },
  {
    "id": 1332,
    "name": "Curtis Croon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/f/lfqe4gdjzy8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 57,
      "control": 56,
      "pressure": 64,
      "agility": 59,
      "physical": 66,
      "technique": 53
    }
  },
  {
    "id": 1333,
    "name": "Georgio Plumber",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/q/rqjxr9org4m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 49,
      "control": 45,
      "pressure": 40,
      "agility": 64,
      "physical": 56,
      "technique": 66
    }
  },
  {
    "id": 1334,
    "name": "Vince Firewall",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/c/ac4qgcorrlk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 41,
      "control": 42,
      "pressure": 78,
      "agility": 52,
      "physical": 57,
      "technique": 51
    }
  },
  {
    "id": 1335,
    "name": "Roy Diggins",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/j/yj_mobc9unk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 40,
      "control": 50,
      "pressure": 64,
      "agility": 44,
      "physical": 57,
      "technique": 50
    }
  },
  {
    "id": 1336,
    "name": "Quill Inker",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/l/plotfk6hd-m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 59,
      "control": 76,
      "pressure": 47,
      "agility": 59,
      "physical": 49,
      "technique": 72
    }
  },
  {
    "id": 1337,
    "name": "Bertram Manning",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/k/jktyw5pp2e8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 66,
      "control": 70,
      "pressure": 45,
      "agility": 57,
      "physical": 43,
      "technique": 54
    }
  },
  {
    "id": 1338,
    "name": "Laura Quilter",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/m/4mc57gp1btu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 70,
      "control": 66,
      "pressure": 42,
      "agility": 42,
      "physical": 51,
      "technique": 69
    }
  },
  {
    "id": 1339,
    "name": "Des Igner",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/m/mmjhklqx8s8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 45,
      "control": 51,
      "pressure": 57,
      "agility": 42,
      "physical": 78,
      "technique": 55
    }
  },
  {
    "id": 1340,
    "name": "Jarmon Fisk",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/o/9osan0mtrhu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 48,
      "control": 40,
      "pressure": 68,
      "agility": 42,
      "physical": 68,
      "technique": 40
    }
  },
  {
    "id": 1341,
    "name": "Hugh Tinter",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/m/tmjn91fkwn0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 48,
      "control": 53,
      "pressure": 81,
      "agility": 58,
      "physical": 69,
      "technique": 43
    }
  },
  {
    "id": 1342,
    "name": "Tim Pression",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/o/io4sqkjed-c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 43,
      "control": 41,
      "pressure": 74,
      "agility": 53,
      "physical": 62,
      "technique": 56
    }
  },
  {
    "id": 1343,
    "name": "Claire Taker",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/h/chbzdxwwoes.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 56,
      "control": 52,
      "pressure": 64,
      "agility": 46,
      "physical": 64,
      "technique": 50
    }
  },
  {
    "id": 1344,
    "name": "Heath Planner",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/j/zjq4uowsfte.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 40,
      "control": 40,
      "pressure": 67,
      "agility": 40,
      "physical": 73,
      "technique": 56
    }
  },
  {
    "id": 1345,
    "name": "Pace Keeping",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/o/xotkaxiaare.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 43,
      "control": 52,
      "pressure": 59,
      "agility": 40,
      "physical": 72,
      "technique": 44
    }
  },
  {
    "id": 1346,
    "name": "Arthur Easley",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/a/aacftoe6tys.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 58,
      "control": 47,
      "pressure": 70,
      "agility": 50,
      "physical": 54,
      "technique": 56
    }
  },
  {
    "id": 1347,
    "name": "Carl Rhodes",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/v/gv_w-txyy4c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 46,
      "control": 51,
      "pressure": 63,
      "agility": 55,
      "physical": 67,
      "technique": 53
    }
  },
  {
    "id": 1348,
    "name": "Eugene Conwell",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/h/rhortsxi1l0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 51,
      "control": 56,
      "pressure": 48,
      "agility": 61,
      "physical": 47,
      "technique": 56
    }
  },
  {
    "id": 1349,
    "name": "Arnan Wheelie",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/t/ltxjihuqs0c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 64,
      "control": 59,
      "pressure": 59,
      "agility": 47,
      "physical": 43,
      "technique": 58
    }
  },
  {
    "id": 1350,
    "name": "Stu Boilin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/f/ufaopeyq_h0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 45,
      "control": 48,
      "pressure": 61,
      "agility": 50,
      "physical": 61,
      "technique": 54
    }
  },
  {
    "id": 1351,
    "name": "Marvin Reading",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/t/atpjhxylasc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 48,
      "control": 58,
      "pressure": 81,
      "agility": 43,
      "physical": 66,
      "technique": 46
    }
  },
  {
    "id": 1352,
    "name": "Callie Graffy",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/f/rf-cmo-fth0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 52,
      "control": 52,
      "pressure": 58,
      "agility": 50,
      "physical": 74,
      "technique": 56
    }
  },
  {
    "id": 1353,
    "name": "Ant Anomy",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/q/lqd3f1lxybe.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 65,
      "control": 69,
      "pressure": 52,
      "agility": 50,
      "physical": 50,
      "technique": 60
    }
  },
  {
    "id": 1354,
    "name": "Laurie Nowlin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/c/6cswyktt1ys.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 58,
      "control": 50,
      "pressure": 66,
      "agility": 44,
      "physical": 65,
      "technique": 43
    }
  },
  {
    "id": 1355,
    "name": "Lucille Strummon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/j/4jrkct_bw0s.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 40,
      "control": 51,
      "pressure": 73,
      "agility": 51,
      "physical": 61,
      "technique": 41
    }
  },
  {
    "id": 1356,
    "name": "Leon Hotair",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/l/jlarxsz7dhe.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 42,
      "control": 43,
      "pressure": 52,
      "agility": 69,
      "physical": 53,
      "technique": 50
    }
  },
  {
    "id": 1357,
    "name": "John Bleach",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/k/pk5eixszon0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 44,
      "control": 41,
      "pressure": 55,
      "agility": 51,
      "physical": 53,
      "technique": 55
    }
  },
  {
    "id": 1358,
    "name": "Carey Filling",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/m/ymi_pokjfuc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 44,
      "control": 45,
      "pressure": 66,
      "agility": 47,
      "physical": 54,
      "technique": 50
    }
  },
  {
    "id": 1359,
    "name": "Conn Fuchus",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/m/sm3n-djrir0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 47,
      "control": 43,
      "pressure": 60,
      "agility": 41,
      "physical": 69,
      "technique": 41
    }
  },
  {
    "id": 1360,
    "name": "Iain Igma",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/o/doggt8vrpyc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 44,
      "control": 49,
      "pressure": 65,
      "agility": 54,
      "physical": 58,
      "technique": 40
    }
  },
  {
    "id": 1361,
    "name": "Carrie O'Kea",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/m/zmdlj9myu08.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 40,
      "control": 55,
      "pressure": 77,
      "agility": 58,
      "physical": 58,
      "technique": 56
    }
  },
  {
    "id": 1362,
    "name": "Stuart Leafe",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/h/ihpf3f1q2nk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 52,
      "control": 41,
      "pressure": 57,
      "agility": 59,
      "physical": 60,
      "technique": 60
    }
  },
  {
    "id": 1363,
    "name": "Cole Stoaker",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/j/tj--agtqbum.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 45,
      "control": 59,
      "pressure": 63,
      "agility": 44,
      "physical": 65,
      "technique": 54
    }
  },
  {
    "id": 1364,
    "name": "Justin Primm",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/o/ro5i05b8esm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 50,
      "control": 52,
      "pressure": 79,
      "agility": 50,
      "physical": 66,
      "technique": 49
    }
  },
  {
    "id": 1365,
    "name": "Mark Smudge",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/a/gaidzgngzhk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 57,
      "control": 44,
      "pressure": 65,
      "agility": 50,
      "physical": 72,
      "technique": 45
    }
  },
  {
    "id": 1366,
    "name": "Travis Borer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/v/avr2kbsogbu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 58,
      "control": 70,
      "pressure": 53,
      "agility": 54,
      "physical": 46,
      "technique": 59
    }
  },
  {
    "id": 1367,
    "name": "Anton Donce",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/h/xhaxnk00ry8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 61,
      "control": 67,
      "pressure": 52,
      "agility": 58,
      "physical": 41,
      "technique": 57
    }
  },
  {
    "id": 1368,
    "name": "Chase Spoor",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/t/ftlpwp3wmnu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 53,
      "control": 66,
      "pressure": 49,
      "agility": 59,
      "physical": 42,
      "technique": 54
    }
  },
  {
    "id": 1369,
    "name": "George Barros",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/f/0fuu7wrsh-8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 57,
      "control": 54,
      "pressure": 50,
      "agility": 64,
      "physical": 44,
      "technique": 53
    }
  },
  {
    "id": 1370,
    "name": "Olivia Baker",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/7/i7c_ytimgtm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 61,
      "control": 65,
      "pressure": 47,
      "agility": 44,
      "physical": 40,
      "technique": 53
    }
  },
  {
    "id": 1371,
    "name": "Gem Shorn",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/t/5tze1secnek.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 49,
      "control": 49,
      "pressure": 55,
      "agility": 45,
      "physical": 69,
      "technique": 51
    }
  },
  {
    "id": 1372,
    "name": "Lou Daguerre",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/8/z8qrmxxu4-u.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 44,
      "control": 48,
      "pressure": 70,
      "agility": 46,
      "physical": 56,
      "technique": 54
    }
  },
  {
    "id": 1373,
    "name": "Ollie Tuckney",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/u/ouhkloxuvn8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 69,
      "control": 61,
      "pressure": 40,
      "agility": 55,
      "physical": 57,
      "technique": 64
    }
  },
  {
    "id": 1374,
    "name": "Manuel Kinart",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/1/q1mwlxfcql8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 58,
      "control": 56,
      "pressure": 46,
      "agility": 59,
      "physical": 56,
      "technique": 61
    }
  },
  {
    "id": 1375,
    "name": "Skip Vinall",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/d/bdx3ioj494u.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 44,
      "control": 56,
      "pressure": 58,
      "agility": 42,
      "physical": 65,
      "technique": 41
    }
  },
  {
    "id": 1376,
    "name": "Junior Gambit",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/y/7y0cb1wwiyk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 66,
      "control": 58,
      "pressure": 46,
      "agility": 44,
      "physical": 45,
      "technique": 62
    }
  },
  {
    "id": 1377,
    "name": "Florian Fauna",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/a/kafj2kwklrm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 40,
      "control": 40,
      "pressure": 54,
      "agility": 69,
      "physical": 44,
      "technique": 67
    }
  },
  {
    "id": 1378,
    "name": "Clark Tappen",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/w/-w67hhzocuk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 47,
      "control": 48,
      "pressure": 72,
      "agility": 43,
      "physical": 76,
      "technique": 47
    }
  },
  {
    "id": 1379,
    "name": "Ryan O'Laugh",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/y/pylaq4vsvnm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 43,
      "control": 47,
      "pressure": 72,
      "agility": 51,
      "physical": 57,
      "technique": 52
    }
  },
  {
    "id": 1380,
    "name": "Rod Sweeper",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/w/hwqxw5cbols.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 42,
      "control": 45,
      "pressure": 42,
      "agility": 80,
      "physical": 41,
      "technique": 54
    }
  },
  {
    "id": 1381,
    "name": "Reg Strimmer",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/y/qyh2dg6hj4e.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 59,
      "control": 58,
      "pressure": 61,
      "agility": 58,
      "physical": 52,
      "technique": 53
    }
  },
  {
    "id": 1382,
    "name": "Will Ramin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/3/w3cdobppwy0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 41,
      "control": 52,
      "pressure": 60,
      "agility": 51,
      "physical": 77,
      "technique": 53
    }
  },
  {
    "id": 1383,
    "name": "Andy Fudge",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/f/bfzijkpt7rc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 47,
      "control": 56,
      "pressure": 60,
      "agility": 73,
      "physical": 45,
      "technique": 68
    }
  },
  {
    "id": 1384,
    "name": "Tate Immy",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/-/d-0-n97_-tc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 63,
      "control": 67,
      "pressure": 50,
      "agility": 57,
      "physical": 53,
      "technique": 63
    }
  },
  {
    "id": 1385,
    "name": "Gerald Pourer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/w/ywffgcdfte0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 62,
      "control": 75,
      "pressure": 47,
      "agility": 46,
      "physical": 40,
      "technique": 57
    }
  },
  {
    "id": 1386,
    "name": "Nate Checker",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/5/s5mqzfonm-e.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 72,
      "control": 71,
      "pressure": 42,
      "agility": 47,
      "physical": 41,
      "technique": 66
    }
  },
  {
    "id": 1387,
    "name": "Bomber Pikes",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/r/jrxlego3lns.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 28,
      "intelligence": 50,
      "control": 48,
      "pressure": 67,
      "agility": 41,
      "physical": 65,
      "technique": 43
    }
  },
  {
    "id": 1388,
    "name": "Gary Burdine",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/7/x7otvtnvsye.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 58,
      "control": 59,
      "pressure": 66,
      "agility": 41,
      "physical": 80,
      "technique": 49
    }
  },
  {
    "id": 1389,
    "name": "Chloe Glazier",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/t/mtzycsrvbbs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 56,
      "control": 46,
      "pressure": 56,
      "agility": 55,
      "physical": 76,
      "technique": 60
    }
  },
  {
    "id": 1390,
    "name": "Reed Harpen",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/7/o7w5sbba-ue.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 68,
      "control": 55,
      "pressure": 44,
      "agility": 47,
      "physical": 46,
      "technique": 51
    }
  },
  {
    "id": 1391,
    "name": "Beat Scatton",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/t/ztnybkngtns.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 58,
      "control": 63,
      "pressure": 45,
      "agility": 42,
      "physical": 56,
      "technique": 66
    }
  },
  {
    "id": 1392,
    "name": "Al Itchen",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/8/58ets5somhc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 63,
      "control": 65,
      "pressure": 43,
      "agility": 56,
      "physical": 45,
      "technique": 50
    }
  },
  {
    "id": 1393,
    "name": "Rock Poulon",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/u/iu1m_g0sl00.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 52,
      "control": 59,
      "pressure": 66,
      "agility": 40,
      "physical": 70,
      "technique": 47
    }
  },
  {
    "id": 1394,
    "name": "Beau Hammock",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/1/k1yqrfm-oy0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 70,
      "control": 65,
      "pressure": 52,
      "agility": 58,
      "physical": 58,
      "technique": 56
    }
  },
  {
    "id": 1395,
    "name": "Clef Bassett",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/d/7ddx8gaejbc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 70,
      "control": 75,
      "pressure": 55,
      "agility": 49,
      "physical": 53,
      "technique": 70
    }
  },
  {
    "id": 1396,
    "name": "Ovie Whisker",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/y/bygev91mwhs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 52,
      "control": 60,
      "pressure": 64,
      "agility": 58,
      "physical": 58,
      "technique": 59
    }
  },
  {
    "id": 1397,
    "name": "Bill Clanger",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/a/qarlcct27se.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 46,
      "control": 50,
      "pressure": 61,
      "agility": 48,
      "physical": 61,
      "technique": 43
    }
  },
  {
    "id": 1398,
    "name": "Mary Cramer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/w/ewu9zpqucts.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 55,
      "control": 58,
      "pressure": 44,
      "agility": 47,
      "physical": 44,
      "technique": 60
    }
  },
  {
    "id": 1399,
    "name": "Ralph Vance",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/y/vyfcew2uxee.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 56,
      "control": 54,
      "pressure": 59,
      "agility": 65,
      "physical": 56,
      "technique": 59
    }
  },
  {
    "id": 1400,
    "name": "Ray Bowing",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/w/bwerex_nqyk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 82,
      "intelligence": 41,
      "control": 57,
      "pressure": 53,
      "agility": 53,
      "physical": 50,
      "technique": 61
    }
  },
  {
    "id": 1401,
    "name": "Vick Pointer",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/y/wy1wpozd9bm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 53,
      "control": 44,
      "pressure": 44,
      "agility": 66,
      "physical": 46,
      "technique": 57
    }
  },
  {
    "id": 1402,
    "name": "Skip Docker",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/3/q3wf6tsvih8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 49,
      "control": 43,
      "pressure": 66,
      "agility": 58,
      "physical": 63,
      "technique": 53
    }
  },
  {
    "id": 1403,
    "name": "Becky Shuffle",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/f/hfnkxskvlsu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 50,
      "control": 50,
      "pressure": 59,
      "agility": 52,
      "physical": 48,
      "technique": 65
    }
  },
  {
    "id": 1404,
    "name": "Esther Egerer",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/-/j-g451ydguu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 50,
      "control": 49,
      "pressure": 55,
      "agility": 68,
      "physical": 42,
      "technique": 55
    }
  },
  {
    "id": 1405,
    "name": "Mia Pitchford",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/w/swrzuk-5nn8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 54,
      "control": 56,
      "pressure": 72,
      "agility": 48,
      "physical": 68,
      "technique": 44
    }
  },
  {
    "id": 1406,
    "name": "Philippa Konik",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/5/y5yshxlx4hm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 59,
      "control": 57,
      "pressure": 47,
      "agility": 42,
      "physical": 43,
      "technique": 55
    }
  },
  {
    "id": 1407,
    "name": "Amy Stinger",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/r/drdnqotlv0k.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 51,
      "control": 43,
      "pressure": 58,
      "agility": 56,
      "physical": 66,
      "technique": 42
    }
  },
  {
    "id": 1408,
    "name": "Nancy Polearm",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/7/378vblupylm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 41,
      "control": 52,
      "pressure": 71,
      "agility": 47,
      "physical": 64,
      "technique": 44
    }
  },
  {
    "id": 1409,
    "name": "Sally Tare",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/t/gtn02aitf4k.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 65,
      "control": 69,
      "pressure": 40,
      "agility": 44,
      "physical": 58,
      "technique": 56
    }
  },
  {
    "id": 1410,
    "name": "Anna Bugeisha",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/x/sxygqawhhts.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 59,
      "control": 40,
      "pressure": 41,
      "agility": 65,
      "physical": 59,
      "technique": 60
    }
  },
  {
    "id": 1411,
    "name": "Stu Hoofer",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/_/d_pnhlwbmge.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 30,
      "intelligence": 52,
      "control": 52,
      "pressure": 71,
      "agility": 49,
      "physical": 71,
      "technique": 56
    }
  },
  {
    "id": 1412,
    "name": "Coe Dachy",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/q/9qksu4ft5a0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 58,
      "control": 43,
      "pressure": 64,
      "agility": 43,
      "physical": 65,
      "technique": 56
    }
  },
  {
    "id": 1413,
    "name": "Flip Sliden",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/4/m47z5hjpuzc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 60,
      "control": 46,
      "pressure": 40,
      "agility": 70,
      "physical": 56,
      "technique": 70
    }
  },
  {
    "id": 1414,
    "name": "Jesse Spiller",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/z/oz8vxexfr1c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 40,
      "control": 55,
      "pressure": 60,
      "agility": 48,
      "physical": 76,
      "technique": 56
    }
  },
  {
    "id": 1415,
    "name": "Kate Later",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/x/_xno6hx_8g0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 56,
      "control": 59,
      "pressure": 53,
      "agility": 57,
      "physical": 73,
      "technique": 43
    }
  },
  {
    "id": 1416,
    "name": "Clara Tompkins",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/e/feu7p8i3jme.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 59,
      "control": 50,
      "pressure": 69,
      "agility": 45,
      "physical": 76,
      "technique": 53
    }
  },
  {
    "id": 1417,
    "name": "Betty Backer",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/2/u2faedenkvs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 52,
      "control": 55,
      "pressure": 51,
      "agility": 58,
      "physical": 55,
      "technique": 50
    }
  },
  {
    "id": 1418,
    "name": "Thomas Worth",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/c/acgc1ohvdqe.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 56,
      "control": 55,
      "pressure": 71,
      "agility": 60,
      "physical": 70,
      "technique": 50
    }
  },
  {
    "id": 1419,
    "name": "Brenda Brandish",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/0/r0rjyxhvuzs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 55,
      "control": 52,
      "pressure": 54,
      "agility": 71,
      "physical": 40,
      "technique": 59
    }
  },
  {
    "id": 1420,
    "name": "Isla Pullens",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/c/fckucwocp1m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 43,
      "control": 41,
      "pressure": 63,
      "agility": 53,
      "physical": 72,
      "technique": 45
    }
  },
  {
    "id": 1421,
    "name": "Bob Jammen",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/0/007pvpomigk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 55,
      "control": 42,
      "pressure": 67,
      "agility": 51,
      "physical": 68,
      "technique": 46
    }
  },
  {
    "id": 1422,
    "name": "Hank Cranker",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/b/uby68s7uxmu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 81,
      "intelligence": 44,
      "control": 57,
      "pressure": 45,
      "agility": 58,
      "physical": 49,
      "technique": 58
    }
  },
  {
    "id": 1423,
    "name": "Prunella Keep",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/z/lzpbrtdu6v8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 45,
      "control": 51,
      "pressure": 56,
      "agility": 54,
      "physical": 50,
      "technique": 60
    }
  },
  {
    "id": 1424,
    "name": "Jimmy Brim",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/s/nsuh_0p4_t8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 50,
      "control": 53,
      "pressure": 56,
      "agility": 49,
      "physical": 70,
      "technique": 45
    }
  },
  {
    "id": 1425,
    "name": "Verity Soliz",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/6/w6fmslpcsgu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 61,
      "control": 64,
      "pressure": 46,
      "agility": 43,
      "physical": 54,
      "technique": 74
    }
  },
  {
    "id": 1426,
    "name": "Yve Dunbar",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/v/2v8tbwcknak.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 41,
      "control": 43,
      "pressure": 53,
      "agility": 56,
      "physical": 79,
      "technique": 49
    }
  },
  {
    "id": 1427,
    "name": "Cat Selima",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/9/h9nysp6wkzm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 73,
      "control": 58,
      "pressure": 54,
      "agility": 55,
      "physical": 52,
      "technique": 57
    }
  },
  {
    "id": 1428,
    "name": "Aurie Garmer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/x/zxyqdk5stmk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 79,
      "control": 73,
      "pressure": 53,
      "agility": 56,
      "physical": 42,
      "technique": 54
    }
  },
  {
    "id": 1429,
    "name": "Lana Service",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/_/c_dlwbfoa_m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 52,
      "control": 42,
      "pressure": 68,
      "agility": 55,
      "physical": 74,
      "technique": 45
    }
  },
  {
    "id": 1430,
    "name": "Claire Voyant",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/v/kvtlaoaok5c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 64,
      "control": 74,
      "pressure": 57,
      "agility": 60,
      "physical": 42,
      "technique": 48
    }
  },
  {
    "id": 1431,
    "name": "Algy Kelp",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/9/79cqtxm0jk0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 76,
      "control": 73,
      "pressure": 44,
      "agility": 58,
      "physical": 60,
      "technique": 71
    }
  },
  {
    "id": 1432,
    "name": "Ann Taisie",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/s/bs_f-st88qe.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 55,
      "control": 40,
      "pressure": 60,
      "agility": 61,
      "physical": 52,
      "technique": 53
    }
  },
  {
    "id": 1433,
    "name": "Kelly Scrivens",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/6/q6o-tt1grzs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 68,
      "control": 58,
      "pressure": 47,
      "agility": 50,
      "physical": 56,
      "technique": 54
    }
  },
  {
    "id": 1434,
    "name": "Fern Mycota",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/b/obji9knqufs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 57,
      "control": 45,
      "pressure": 78,
      "agility": 60,
      "physical": 64,
      "technique": 48
    }
  },
  {
    "id": 1435,
    "name": "Lara Creamer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/z/zz4dq1bq5se.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 65,
      "control": 69,
      "pressure": 51,
      "agility": 52,
      "physical": 41,
      "technique": 58
    }
  },
  {
    "id": 1436,
    "name": "Kim Knotted",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/c/5cb2do0ymm0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 65,
      "control": 59,
      "pressure": 46,
      "agility": 55,
      "physical": 48,
      "technique": 63
    }
  },
  {
    "id": 1437,
    "name": "Nina Trowel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/0/i0qxuxsih_c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 43,
      "control": 57,
      "pressure": 59,
      "agility": 53,
      "physical": 71,
      "technique": 60
    }
  },
  {
    "id": 1438,
    "name": "Harriet Reaching",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/e/8evpfaraga0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 58,
      "control": 52,
      "pressure": 52,
      "agility": 40,
      "physical": 50,
      "technique": 54
    }
  },
  {
    "id": 1439,
    "name": "Sadey Stewer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/2/n2kuyl36rzc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 60,
      "control": 71,
      "pressure": 40,
      "agility": 46,
      "physical": 42,
      "technique": 55
    }
  },
  {
    "id": 1440,
    "name": "June Stagner",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/e/je_jok-zkf8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 55,
      "control": 45,
      "pressure": 61,
      "agility": 52,
      "physical": 70,
      "technique": 47
    }
  },
  {
    "id": 1441,
    "name": "Lacey Threader",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/2/s2ocfbyjnsu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 74,
      "control": 59,
      "pressure": 47,
      "agility": 54,
      "physical": 47,
      "technique": 58
    }
  },
  {
    "id": 1442,
    "name": "Marcy Laise",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/z/yzt3wgtbsmk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 69,
      "control": 60,
      "pressure": 54,
      "agility": 42,
      "physical": 48,
      "technique": 48
    }
  },
  {
    "id": 1443,
    "name": "Bella Shaded",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/x/dxcw75l7__m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 46,
      "control": 44,
      "pressure": 80,
      "agility": 59,
      "physical": 69,
      "technique": 43
    }
  },
  {
    "id": 1444,
    "name": "Walter Trope",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/q/bqbkvgzx65m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 54,
      "control": 59,
      "pressure": 59,
      "agility": 45,
      "physical": 65,
      "technique": 49
    }
  },
  {
    "id": 1445,
    "name": "Flora Summars",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/4/w4qr4f_txkk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 43,
      "control": 46,
      "pressure": 54,
      "agility": 57,
      "physical": 56,
      "technique": 62
    }
  },
  {
    "id": 1446,
    "name": "Lucia Ander",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/x/qxjerckliqu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 73,
      "control": 72,
      "pressure": 57,
      "agility": 54,
      "physical": 41,
      "technique": 55
    }
  },
  {
    "id": 1447,
    "name": "Rosy Roker",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/_/h_4_g9sfpz8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 55,
      "control": 58,
      "pressure": 68,
      "agility": 56,
      "physical": 78,
      "technique": 59
    }
  },
  {
    "id": 1448,
    "name": "Pam Vision",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/v/vvhn3wv9omu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 56,
      "control": 52,
      "pressure": 71,
      "agility": 58,
      "physical": 62,
      "technique": 55
    }
  },
  {
    "id": 1449,
    "name": "Ruth Karnes",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/9/k92gapjhfv8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 58,
      "control": 63,
      "pressure": 42,
      "agility": 52,
      "physical": 56,
      "technique": 54
    }
  },
  {
    "id": 1450,
    "name": "Rose Bedd",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/v/qv5n0gjy6au.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 69,
      "control": 70,
      "pressure": 60,
      "agility": 58,
      "physical": 58,
      "technique": 58
    }
  },
  {
    "id": 1451,
    "name": "Bailey Sitter",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/9/b9isz5fixz8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 46,
      "control": 51,
      "pressure": 57,
      "agility": 68,
      "physical": 43,
      "technique": 63
    }
  },
  {
    "id": 1452,
    "name": "Adel Tactor",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/s/7srzkkwaitm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 43,
      "control": 48,
      "pressure": 66,
      "agility": 60,
      "physical": 68,
      "technique": 46
    }
  },
  {
    "id": 1453,
    "name": "Emma Barres",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/6/k6a4nbw6pgk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 49,
      "control": 44,
      "pressure": 80,
      "agility": 51,
      "physical": 59,
      "technique": 60
    }
  },
  {
    "id": 1454,
    "name": "Orpah Talkington",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/b/ibdkjcewkmk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 55,
      "control": 57,
      "pressure": 43,
      "agility": 59,
      "physical": 43,
      "technique": 58
    }
  },
  {
    "id": 1455,
    "name": "Sable Tatter",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/z/5zsfk9isnvm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 49,
      "control": 54,
      "pressure": 52,
      "agility": 63,
      "physical": 44,
      "technique": 52
    }
  },
  {
    "id": 1456,
    "name": "Sym Copate",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/0/o0-rafxe_gu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 58,
      "control": 62,
      "pressure": 57,
      "agility": 54,
      "physical": 47,
      "technique": 57
    }
  },
  {
    "id": 1457,
    "name": "Jerry Bateman",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/e/cebjrsy8y58.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 81,
      "intelligence": 45,
      "control": 55,
      "pressure": 59,
      "agility": 59,
      "physical": 52,
      "technique": 54
    }
  },
  {
    "id": 1458,
    "name": "Fonda Katz",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/2/t2wogtug1ku.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 61,
      "control": 57,
      "pressure": 52,
      "agility": 52,
      "physical": 57,
      "technique": 59
    }
  },
  {
    "id": 1459,
    "name": "Beck Hand",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/e/derlcsdpum0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 47,
      "control": 47,
      "pressure": 50,
      "agility": 64,
      "physical": 49,
      "technique": 59
    }
  },
  {
    "id": 1460,
    "name": "Sandra Mudd",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/2/y2aext715vc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 57,
      "control": 51,
      "pressure": 47,
      "agility": 65,
      "physical": 59,
      "technique": 49
    }
  },
  {
    "id": 1461,
    "name": "Alexis Watchorn",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/z/sz5xioo9m1s.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 54,
      "control": 42,
      "pressure": 48,
      "agility": 65,
      "physical": 44,
      "technique": 50
    }
  },
  {
    "id": 1462,
    "name": "Pete Manter",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/x/jxiqpxohhge.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 63,
      "control": 61,
      "pressure": 47,
      "agility": 52,
      "physical": 42,
      "technique": 65
    }
  },
  {
    "id": 1463,
    "name": "Chris Country",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/q/hqpmho6rkae.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 64,
      "control": 53,
      "pressure": 51,
      "agility": 56,
      "physical": 58,
      "technique": 63
    }
  },
  {
    "id": 1464,
    "name": "Paul Steed",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/4/q4-tmxcrjzs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 60,
      "control": 51,
      "pressure": 57,
      "agility": 43,
      "physical": 65,
      "technique": 43
    }
  },
  {
    "id": 1465,
    "name": "Ben Whistler",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/x/wxdyfkpz8tc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 59,
      "control": 57,
      "pressure": 60,
      "agility": 50,
      "physical": 63,
      "technique": 48
    }
  },
  {
    "id": 1466,
    "name": "Roman Blac",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/_/b_s5y1pjrg0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 43,
      "control": 40,
      "pressure": 57,
      "agility": 44,
      "physical": 60,
      "technique": 43
    }
  },
  {
    "id": 1467,
    "name": "Lewis Brownie",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/v/1vthd4mb2fc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 40,
      "control": 43,
      "pressure": 65,
      "agility": 46,
      "physical": 55,
      "technique": 51
    }
  },
  {
    "id": 1468,
    "name": "Connor Seuer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/9/e9iauhq7bs0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 67,
      "control": 51,
      "pressure": 54,
      "agility": 52,
      "physical": 50,
      "technique": 64
    }
  },
  {
    "id": 1469,
    "name": "Kaya Haskell",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/d/4d0rnczxa_e.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 54,
      "control": 52,
      "pressure": 54,
      "agility": 67,
      "physical": 44,
      "technique": 57
    }
  },
  {
    "id": 1470,
    "name": "Minnie Stratio",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/r/jrfwg9_l3ms.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 49,
      "control": 46,
      "pressure": 80,
      "agility": 56,
      "physical": 71,
      "technique": 56
    }
  },
  {
    "id": 1471,
    "name": "Elegance Stuckon",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/e/pemfzgkdcsc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 59,
      "control": 44,
      "pressure": 46,
      "agility": 62,
      "physical": 46,
      "technique": 64
    }
  },
  {
    "id": 1472,
    "name": "Odette Musetta",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/s/ysxkefs5vf0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 43,
      "control": 41,
      "pressure": 54,
      "agility": 50,
      "physical": 53,
      "technique": 53
    }
  },
  {
    "id": 1473,
    "name": "Gertrude Choker",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/n/anq4wg-vqz0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 48,
      "control": 40,
      "pressure": 63,
      "agility": 45,
      "physical": 59,
      "technique": 59
    }
  },
  {
    "id": 1474,
    "name": "Polly Targest",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/l/rlhzd5yvhqc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 70,
      "control": 66,
      "pressure": 52,
      "agility": 42,
      "physical": 50,
      "technique": 58
    }
  },
  {
    "id": 1475,
    "name": "Odessa Ryder",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/k/lkcsoktnyks.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 63,
      "control": 76,
      "pressure": 40,
      "agility": 52,
      "physical": 44,
      "technique": 59
    }
  },
  {
    "id": 1476,
    "name": "Robyn Weaver",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/i/6iznjbldf5e.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 28,
      "intelligence": 46,
      "control": 46,
      "pressure": 74,
      "agility": 46,
      "physical": 68,
      "technique": 60
    }
  },
  {
    "id": 1477,
    "name": "Tess Masters",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/i/oimvswi_4gs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 57,
      "control": 54,
      "pressure": 42,
      "agility": 63,
      "physical": 47,
      "technique": 68
    }
  },
  {
    "id": 1478,
    "name": "Cale Sticklin",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/g/_g90_pufv1e.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 58,
      "control": 49,
      "pressure": 58,
      "agility": 72,
      "physical": 45,
      "technique": 50
    }
  },
  {
    "id": 1479,
    "name": "Farris Stickman",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/i/rim5lonm0zk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 53,
      "control": 47,
      "pressure": 66,
      "agility": 45,
      "physical": 69,
      "technique": 47
    }
  },
  {
    "id": 1480,
    "name": "Tim Personator",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/g/ggxyixb2zqm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 57,
      "control": 60,
      "pressure": 45,
      "agility": 42,
      "physical": 54,
      "technique": 55
    }
  },
  {
    "id": 1481,
    "name": "Sherlock Sagers",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/p/ap0tbk0-sk8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 56,
      "control": 46,
      "pressure": 52,
      "agility": 41,
      "physical": 60,
      "technique": 60
    }
  },
  {
    "id": 1482,
    "name": "Ryan Haywood",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/n/xnfm21seb5u.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 47,
      "control": 41,
      "pressure": 63,
      "agility": 47,
      "physical": 73,
      "technique": 53
    }
  },
  {
    "id": 1483,
    "name": "Osier Twining",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/g/zgcqysaoe_u.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 43,
      "control": 42,
      "pressure": 66,
      "agility": 45,
      "physical": 65,
      "technique": 53
    }
  },
  {
    "id": 1484,
    "name": "Rock Scowlon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/u/cuzx1tmspm8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 59,
      "control": 41,
      "pressure": 55,
      "agility": 60,
      "physical": 57,
      "technique": 54
    }
  },
  {
    "id": 1485,
    "name": "Al Stringer",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/b/ibqemotacsm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 59,
      "control": 53,
      "pressure": 61,
      "agility": 40,
      "physical": 68,
      "technique": 41
    }
  },
  {
    "id": 1486,
    "name": "Bill Fierce",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/p/tphllx1gxfk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 63,
      "control": 58,
      "pressure": 52,
      "agility": 46,
      "physical": 58,
      "technique": 67
    }
  },
  {
    "id": 1487,
    "name": "Rob Otts",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/d/nde9682cwgm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 54,
      "control": 58,
      "pressure": 62,
      "agility": 51,
      "physical": 64,
      "technique": 44
    }
  },
  {
    "id": 1488,
    "name": "Chad Jowell",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/r/wrvcxdq47tk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 52,
      "control": 47,
      "pressure": 78,
      "agility": 59,
      "physical": 63,
      "technique": 45
    }
  },
  {
    "id": 1489,
    "name": "Egon Omercer",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/d/ydgx5k6negm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 57,
      "control": 54,
      "pressure": 74,
      "agility": 48,
      "physical": 74,
      "technique": 54
    }
  },
  {
    "id": 1490,
    "name": "Luis Springs",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/r/prr2u1c3p1k.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 47,
      "control": 54,
      "pressure": 73,
      "agility": 56,
      "physical": 73,
      "technique": 40
    }
  },
  {
    "id": 1491,
    "name": "Bruce Barkley",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/e/jeydhop_cvu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 53,
      "control": 55,
      "pressure": 57,
      "agility": 63,
      "physical": 46,
      "technique": 66
    }
  },
  {
    "id": 1492,
    "name": "Chip Spacek",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/s/4sdiqxpfxm8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 46,
      "control": 40,
      "pressure": 69,
      "agility": 59,
      "physical": 60,
      "technique": 45
    }
  },
  {
    "id": 1493,
    "name": "Mason Tirell",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/n/6ne-eodp0g8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 59,
      "control": 48,
      "pressure": 65,
      "agility": 50,
      "physical": 70,
      "technique": 44
    }
  },
  {
    "id": 1494,
    "name": "Dale Riverhead",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/l/ll1fpx7tztu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 44,
      "control": 50,
      "pressure": 68,
      "agility": 45,
      "physical": 55,
      "technique": 54
    }
  },
  {
    "id": 1495,
    "name": "Adelpha Lovelace",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/k/rkwq6sobszk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 45,
      "control": 44,
      "pressure": 70,
      "agility": 48,
      "physical": 60,
      "technique": 48
    }
  },
  {
    "id": 1496,
    "name": "Egon Timing",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/i/ainlxtohbam.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 57,
      "control": 70,
      "pressure": 49,
      "agility": 50,
      "physical": 52,
      "technique": 66
    }
  },
  {
    "id": 1497,
    "name": "Tony Frogge",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/i/uiytmerdm_k.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 52,
      "control": 54,
      "pressure": 59,
      "agility": 63,
      "physical": 52,
      "technique": 59
    }
  },
  {
    "id": 1498,
    "name": "Fred Punch",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/g/fgpylhn5lmm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 55,
      "control": 44,
      "pressure": 57,
      "agility": 49,
      "physical": 79,
      "technique": 45
    }
  },
  {
    "id": 1499,
    "name": "Hannibal Whipp",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/i/xiy_rgewqgs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 43,
      "control": 41,
      "pressure": 65,
      "agility": 55,
      "physical": 62,
      "technique": 57
    }
  },
  {
    "id": 1500,
    "name": "Luke Severin",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/g/agde8fikhte.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 70,
      "control": 61,
      "pressure": 46,
      "agility": 46,
      "physical": 45,
      "technique": 45
    }
  },
  {
    "id": 1501,
    "name": "Harry Keenan",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/p/gpgrvcxcyz0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 43,
      "control": 54,
      "pressure": 59,
      "agility": 73,
      "physical": 55,
      "technique": 61
    }
  },
  {
    "id": 1502,
    "name": "Nick Uman",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/n/rnrkc9x4fac.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 50,
      "control": 59,
      "pressure": 49,
      "agility": 59,
      "physical": 49,
      "technique": 58
    }
  },
  {
    "id": 1503,
    "name": "Mac Robat",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/g/tgwwskjuagc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 58,
      "control": 58,
      "pressure": 45,
      "agility": 75,
      "physical": 57,
      "technique": 58
    }
  },
  {
    "id": 1504,
    "name": "Ace Slider",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/u/iun3bbfu310.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 50,
      "control": 49,
      "pressure": 58,
      "agility": 55,
      "physical": 70,
      "technique": 43
    }
  },
  {
    "id": 1505,
    "name": "Olivia Twist",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/b/cbecsgwmcve.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 49,
      "control": 47,
      "pressure": 52,
      "agility": 74,
      "physical": 50,
      "technique": 48
    }
  },
  {
    "id": 1506,
    "name": "Wiley Blinks",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/p/zp1j_5wcvms.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 58,
      "control": 52,
      "pressure": 53,
      "agility": 63,
      "physical": 49,
      "technique": 49
    }
  },
  {
    "id": 1507,
    "name": "Shona Shopbell",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/d/hdk7o0v-ize.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 59,
      "control": 58,
      "pressure": 70,
      "agility": 50,
      "physical": 60,
      "technique": 47
    }
  },
  {
    "id": 1508,
    "name": "Crystal Clears",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/r/2r7ajlzelqs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 51,
      "control": 51,
      "pressure": 60,
      "agility": 58,
      "physical": 57,
      "technique": 68
    }
  },
  {
    "id": 1509,
    "name": "Beata Pummel",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/v/cvuo_lt2bbk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 52,
      "control": 56,
      "pressure": 45,
      "agility": 60,
      "physical": 51,
      "technique": 71
    }
  },
  {
    "id": 1510,
    "name": "Aya Strand",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/h/thfjs0lm2ym.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 56,
      "control": 54,
      "pressure": 61,
      "agility": 41,
      "physical": 67,
      "technique": 47
    }
  },
  {
    "id": 1511,
    "name": "Tara Gaudier",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/o/no88bp-eds8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 44,
      "control": 43,
      "pressure": 67,
      "agility": 47,
      "physical": 56,
      "technique": 49
    }
  },
  {
    "id": 1512,
    "name": "James Hearson",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/a/8andswy-uhu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 54,
      "control": 69,
      "pressure": 46,
      "agility": 53,
      "physical": 46,
      "technique": 63
    }
  },
  {
    "id": 1513,
    "name": "Anne Somnia",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/h/-hkbcpksrnu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 60,
      "control": 47,
      "pressure": 69,
      "agility": 40,
      "physical": 60,
      "technique": 47
    }
  },
  {
    "id": 1514,
    "name": "Pearl Wann",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/j/pj7gvwsogu8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 46,
      "control": 60,
      "pressure": 63,
      "agility": 48,
      "physical": 67,
      "technique": 46
    }
  },
  {
    "id": 1515,
    "name": "Hugh Dunnit",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/m/vmyv8tzgz0m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 43,
      "control": 49,
      "pressure": 65,
      "agility": 49,
      "physical": 65,
      "technique": 46
    }
  },
  {
    "id": 1516,
    "name": "Steve Squander",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/o/eop0rs_aehk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 49,
      "control": 60,
      "pressure": 42,
      "agility": 69,
      "physical": 52,
      "technique": 49
    }
  },
  {
    "id": 1517,
    "name": "Lehman Rind",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/k/qkwsgf8454m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 68,
      "control": 69,
      "pressure": 48,
      "agility": 53,
      "physical": 60,
      "technique": 61
    }
  },
  {
    "id": 1518,
    "name": "Ian Fantile",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/m/bmnnngaculk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 47,
      "control": 60,
      "pressure": 57,
      "agility": 41,
      "physical": 71,
      "technique": 54
    }
  },
  {
    "id": 1519,
    "name": "Zach Putter",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/k/1k8axhtl1ne.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 71,
      "control": 66,
      "pressure": 44,
      "agility": 47,
      "physical": 42,
      "technique": 61
    }
  },
  {
    "id": 1520,
    "name": "Juan Word",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/m/emnh6e1xyus.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 54,
      "control": 53,
      "pressure": 64,
      "agility": 55,
      "physical": 60,
      "technique": 57
    }
  },
  {
    "id": 1521,
    "name": "Alex Copple",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/j/kjuupda5t0c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 30,
      "intelligence": 47,
      "control": 41,
      "pressure": 56,
      "agility": 53,
      "physical": 78,
      "technique": 49
    }
  },
  {
    "id": 1522,
    "name": "Jan Jared",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/l/vlf1e8mdah0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 53,
      "control": 41,
      "pressure": 71,
      "agility": 59,
      "physical": 64,
      "technique": 56
    }
  },
  {
    "id": 1523,
    "name": "Bigsby Pigford",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/q/xqypql0vfb0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 48,
      "control": 43,
      "pressure": 44,
      "agility": 75,
      "physical": 50,
      "technique": 57
    }
  },
  {
    "id": 1524,
    "name": "Erica Hogland",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/c/mcpihasvoyc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 59,
      "control": 54,
      "pressure": 50,
      "agility": 62,
      "physical": 51,
      "technique": 47
    }
  },
  {
    "id": 1525,
    "name": "Ramona Wriston",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/t/gtk9uhnddss.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 61,
      "control": 64,
      "pressure": 56,
      "agility": 45,
      "physical": 53,
      "technique": 55
    }
  },
  {
    "id": 1526,
    "name": "Mark Izushy",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/f/3f7c54bnwhe.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 59,
      "control": 45,
      "pressure": 69,
      "agility": 59,
      "physical": 56,
      "technique": 41
    }
  },
  {
    "id": 1527,
    "name": "Vince Tinct",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/v/dveei1cfxes.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 58,
      "control": 50,
      "pressure": 55,
      "agility": 46,
      "physical": 73,
      "technique": 56
    }
  },
  {
    "id": 1528,
    "name": "Daryl Floor",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/h/yh1llkk_6te.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 43,
      "control": 51,
      "pressure": 52,
      "agility": 67,
      "physical": 58,
      "technique": 55
    }
  },
  {
    "id": 1529,
    "name": "Becca Pilgreen",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/c/acauzbw8nik.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 40,
      "control": 50,
      "pressure": 70,
      "agility": 46,
      "physical": 77,
      "technique": 55
    }
  },
  {
    "id": 1530,
    "name": "Langley Span",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/q/rqxpe-wgg7m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 55,
      "control": 57,
      "pressure": 76,
      "agility": 42,
      "physical": 78,
      "technique": 53
    }
  },
  {
    "id": 1531,
    "name": "Swithin Sainte",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/f/lfs6njfovb8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 58,
      "control": 57,
      "pressure": 46,
      "agility": 47,
      "physical": 59,
      "technique": 71
    }
  },
  {
    "id": 1532,
    "name": "Dan Cawarry",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/t/6tjbgcj04ou.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 46,
      "control": 57,
      "pressure": 51,
      "agility": 59,
      "physical": 50,
      "technique": 60
    }
  },
  {
    "id": 1533,
    "name": "Hans Freesing",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/m/4mkhofxy9uu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 43,
      "control": 52,
      "pressure": 74,
      "agility": 41,
      "physical": 69,
      "technique": 44
    }
  },
  {
    "id": 1534,
    "name": "Peter Fakhoury",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/k/jkvmj6xiqd8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 59,
      "control": 70,
      "pressure": 44,
      "agility": 59,
      "physical": 55,
      "technique": 62
    }
  },
  {
    "id": 1535,
    "name": "Steve Sancey",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/l/pl2twniql9m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 78,
      "control": 55,
      "pressure": 59,
      "agility": 59,
      "physical": 58,
      "technique": 58
    }
  },
  {
    "id": 1536,
    "name": "Michael Gibe",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/j/yjhydyeqiok.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 51,
      "control": 57,
      "pressure": 57,
      "agility": 52,
      "physical": 70,
      "technique": 54
    }
  },
  {
    "id": 1537,
    "name": "Skeet Blaston",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/j/sj4qsvhyvxm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 67,
      "control": 69,
      "pressure": 41,
      "agility": 41,
      "physical": 41,
      "technique": 50
    }
  },
  {
    "id": 1538,
    "name": "Achilles Chinner",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/h/dhjlbqhicck.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 48,
      "control": 49,
      "pressure": 70,
      "agility": 58,
      "physical": 75,
      "technique": 44
    }
  },
  {
    "id": 1539,
    "name": "Scott Tickle",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/j/zjsgbrobjue.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 54,
      "control": 56,
      "pressure": 55,
      "agility": 54,
      "physical": 69,
      "technique": 54
    }
  },
  {
    "id": 1540,
    "name": "Junior Cage",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/h/chjn2uo7ods.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 50,
      "control": 58,
      "pressure": 73,
      "agility": 54,
      "physical": 66,
      "technique": 41
    }
  },
  {
    "id": 1541,
    "name": "Terry Namby",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/o/ioaslj7z79c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 53,
      "control": 50,
      "pressure": 44,
      "agility": 61,
      "physical": 43,
      "technique": 57
    }
  },
  {
    "id": 1542,
    "name": "Joe Chugger",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/m/tmxzi2djwo0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 45,
      "control": 46,
      "pressure": 66,
      "agility": 48,
      "physical": 68,
      "technique": 58
    }
  },
  {
    "id": 1543,
    "name": "Sonny Cinders",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/h/rh2vmvplti0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 59,
      "control": 48,
      "pressure": 61,
      "agility": 43,
      "physical": 69,
      "technique": 57
    }
  },
  {
    "id": 1544,
    "name": "Cash Winfall",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/v/gvholqpf-7c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 57,
      "control": 42,
      "pressure": 59,
      "agility": 43,
      "physical": 78,
      "technique": 57
    }
  },
  {
    "id": 1545,
    "name": "Lou Fauntleroy",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/a/aak7yncxlbs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 67,
      "control": 59,
      "pressure": 47,
      "agility": 60,
      "physical": 60,
      "technique": 60
    }
  },
  {
    "id": 1546,
    "name": "Carol Chanter",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/o/xova1y6tmoe.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 48,
      "control": 41,
      "pressure": 74,
      "agility": 55,
      "physical": 57,
      "technique": 57
    }
  },
  {
    "id": 1547,
    "name": "Guy Kogan",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/c/fcqce_5pbxs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 60,
      "control": 44,
      "pressure": 64,
      "agility": 55,
      "physical": 75,
      "technique": 59
    }
  },
  {
    "id": 1548,
    "name": "Max Motto",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/q/0qbjpaf1ske.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 71,
      "control": 63,
      "pressure": 60,
      "agility": 60,
      "physical": 41,
      "technique": 48
    }
  },
  {
    "id": 1549,
    "name": "Perry Postiche",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/c/6cuohj1atxs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 56,
      "control": 46,
      "pressure": 71,
      "agility": 59,
      "physical": 63,
      "technique": 41
    }
  },
  {
    "id": 1550,
    "name": "Nelson Levene",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/q/lqljq2t6-ce.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 58,
      "control": 40,
      "pressure": 73,
      "agility": 42,
      "physical": 59,
      "technique": 40
    }
  },
  {
    "id": 1551,
    "name": "Kurt Sermons",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/f/rfg85rmyli0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 56,
      "control": 51,
      "pressure": 78,
      "agility": 60,
      "physical": 76,
      "technique": 57
    }
  },
  {
    "id": 1552,
    "name": "Ed Hartsell",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/t/at3duuaimrc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 53,
      "control": 47,
      "pressure": 71,
      "agility": 40,
      "physical": 65,
      "technique": 43
    }
  },
  {
    "id": 1553,
    "name": "Chester Takes",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/m/ymwb6nskjxc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 62,
      "control": 65,
      "pressure": 42,
      "agility": 55,
      "physical": 44,
      "technique": 54
    }
  },
  {
    "id": 1554,
    "name": "Curtis Rebell",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/k/pkbgxy0eok0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 55,
      "control": 43,
      "pressure": 58,
      "agility": 61,
      "physical": 49,
      "technique": 62
    }
  },
  {
    "id": 1555,
    "name": "Cody Fink",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/l/jlivevbw7ee.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 62,
      "control": 64,
      "pressure": 58,
      "agility": 56,
      "physical": 57,
      "technique": 50
    }
  },
  {
    "id": 1556,
    "name": "Siria Chattsley",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/j/4jt0pqnsw3s.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 56,
      "control": 44,
      "pressure": 55,
      "agility": 72,
      "physical": 59,
      "technique": 64
    }
  },
  {
    "id": 1557,
    "name": "Darren Catt",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/j/mjssydkoxie.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 53,
      "control": 53,
      "pressure": 56,
      "agility": 69,
      "physical": 45,
      "technique": 64
    }
  },
  {
    "id": 1558,
    "name": "Garry Planer",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/h/9hdn1ic0c7s.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 46,
      "control": 53,
      "pressure": 63,
      "agility": 43,
      "physical": 59,
      "technique": 60
    }
  },
  {
    "id": 1559,
    "name": "Glenn Broth",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/j/tjgavjl99xm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 58,
      "control": 43,
      "pressure": 72,
      "agility": 47,
      "physical": 61,
      "technique": 49
    }
  },
  {
    "id": 1560,
    "name": "Harry Angue",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/h/ih3hccthqkk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 56,
      "control": 44,
      "pressure": 51,
      "agility": 41,
      "physical": 79,
      "technique": 48
    }
  },
  {
    "id": 1561,
    "name": "Benny Terra",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/o/couurbypleu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 68,
      "control": 53,
      "pressure": 45,
      "agility": 40,
      "physical": 60,
      "technique": 65
    }
  },
  {
    "id": 1562,
    "name": "Jasmine Veile",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/m/zml18--1i38.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 81,
      "intelligence": 50,
      "control": 55,
      "pressure": 48,
      "agility": 56,
      "physical": 57,
      "technique": 63
    }
  },
  {
    "id": 1563,
    "name": "Belle Allure",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/h/xhipsnsznx8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 60,
      "control": 73,
      "pressure": 43,
      "agility": 56,
      "physical": 45,
      "technique": 52
    }
  },
  {
    "id": 1564,
    "name": "Doug Lapp",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/v/avti_ykjgcu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 58,
      "control": 59,
      "pressure": 69,
      "agility": 56,
      "physical": 69,
      "technique": 42
    }
  },
  {
    "id": 1565,
    "name": "Eric Motter",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/a/gaw9sf_rvik.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 30,
      "intelligence": 41,
      "control": 52,
      "pressure": 63,
      "agility": 58,
      "physical": 65,
      "technique": 44
    }
  },
  {
    "id": 1566,
    "name": "Gyll Netters",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/o/robcb6zr4rm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 60,
      "control": 54,
      "pressure": 41,
      "agility": 57,
      "physical": 48,
      "technique": 52
    }
  },
  {
    "id": 1567,
    "name": "Farrah Fairway",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/c/lc-ew3azfuk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 48,
      "control": 59,
      "pressure": 47,
      "agility": 62,
      "physical": 41,
      "technique": 64
    }
  },
  {
    "id": 1568,
    "name": "Jess Winkles",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/q/uqpldi8jydm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 81,
      "intelligence": 42,
      "control": 49,
      "pressure": 42,
      "agility": 66,
      "physical": 55,
      "technique": 58
    }
  },
  {
    "id": 1569,
    "name": "Barbara Clector",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/u/ouz0-npdzo8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 56,
      "control": 44,
      "pressure": 77,
      "agility": 54,
      "physical": 65,
      "technique": 59
    }
  },
  {
    "id": 1570,
    "name": "Marilyn Henshaw",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/8/z8ovtyp5e9u.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 55,
      "control": 45,
      "pressure": 55,
      "agility": 45,
      "physical": 61,
      "technique": 56
    }
  },
  {
    "id": 1571,
    "name": "Nancy Pickney",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/t/5tlgavcxrdk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 60,
      "control": 51,
      "pressure": 58,
      "agility": 54,
      "physical": 65,
      "technique": 45
    }
  },
  {
    "id": 1572,
    "name": "Clay Turnor",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/7/i76btq6lgum.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 58,
      "control": 55,
      "pressure": 79,
      "agility": 46,
      "physical": 69,
      "technique": 59
    }
  },
  {
    "id": 1573,
    "name": "Horace Shlock",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/a/ka9ddjondom.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 51,
      "control": 47,
      "pressure": 52,
      "agility": 64,
      "physical": 47,
      "technique": 57
    }
  },
  {
    "id": 1574,
    "name": "Sabrina Passman",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/y/7ym8u2odubk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 82,
      "intelligence": 42,
      "control": 57,
      "pressure": 42,
      "agility": 61,
      "physical": 57,
      "technique": 58
    }
  },
  {
    "id": 1575,
    "name": "Harpo Thermier",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/d/bdvj9r7vb7u.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 67,
      "control": 69,
      "pressure": 50,
      "agility": 54,
      "physical": 51,
      "technique": 58
    }
  },
  {
    "id": 1576,
    "name": "August Dyers",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/1/q1eoqudv2i8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 65,
      "control": 63,
      "pressure": 56,
      "agility": 45,
      "physical": 42,
      "technique": 62
    }
  },
  {
    "id": 1577,
    "name": "Nev Puffer",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/f/efhwhzenr3u.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 47,
      "control": 51,
      "pressure": 69,
      "agility": 50,
      "physical": 64,
      "technique": 58
    }
  },
  {
    "id": 1578,
    "name": "Elata Mighty",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/3/v3qrmm438e8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 44,
      "control": 50,
      "pressure": 57,
      "agility": 55,
      "physical": 65,
      "technique": 47
    }
  },
  {
    "id": 1579,
    "name": "Ben Danna",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/f/bflcwnx-doc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 50,
      "control": 48,
      "pressure": 44,
      "agility": 61,
      "physical": 59,
      "technique": 66
    }
  },
  {
    "id": 1580,
    "name": "Elsa Roamer",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/3/w3697yxewb0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 42,
      "control": 55,
      "pressure": 43,
      "agility": 70,
      "physical": 52,
      "technique": 51
    }
  },
  {
    "id": 1581,
    "name": "Archy Seago",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/y/qyziofimf7e.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 53,
      "control": 54,
      "pressure": 46,
      "agility": 66,
      "physical": 42,
      "technique": 46
    }
  },
  {
    "id": 1582,
    "name": "Erhardt Knead",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/w/hwopf6e2ois.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 40,
      "control": 45,
      "pressure": 68,
      "agility": 53,
      "physical": 78,
      "technique": 49
    }
  },
  {
    "id": 1583,
    "name": "Lynne Mandel",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/r/jrv1rjwatos.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 59,
      "control": 66,
      "pressure": 60,
      "agility": 49,
      "physical": 60,
      "technique": 66
    }
  },
  {
    "id": 1584,
    "name": "Craig Placid",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/5/s5eugcwga9e.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 56,
      "control": 44,
      "pressure": 47,
      "agility": 61,
      "physical": 40,
      "technique": 54
    }
  },
  {
    "id": 1585,
    "name": "Leon Morcey",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/w/yw9hvbfo1d0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 44,
      "control": 60,
      "pressure": 64,
      "agility": 58,
      "physical": 71,
      "technique": 41
    }
  },
  {
    "id": 1586,
    "name": "Dom Edarry",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/-/d-ma4-jsyuc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 62,
      "control": 60,
      "pressure": 54,
      "agility": 41,
      "physical": 55,
      "technique": 49
    }
  },
  {
    "id": 1587,
    "name": "Jay Asher",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/u/3uzyjzgw_r0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 47,
      "control": 48,
      "pressure": 62,
      "agility": 58,
      "physical": 69,
      "technique": 50
    }
  },
  {
    "id": 1588,
    "name": "Toby Cohill",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/8/g8c5kmgksic.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 44,
      "control": 48,
      "pressure": 65,
      "agility": 44,
      "physical": 69,
      "technique": 53
    }
  },
  {
    "id": 1589,
    "name": "Nolene Ider",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/u/iunykfs_t30.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 65,
      "control": 63,
      "pressure": 59,
      "agility": 47,
      "physical": 55,
      "technique": 68
    }
  },
  {
    "id": 1590,
    "name": "Hoots Knightly",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/8/588tn6kfaec.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 60,
      "control": 58,
      "pressure": 65,
      "agility": 45,
      "physical": 75,
      "technique": 41
    }
  },
  {
    "id": 1591,
    "name": "Bash Beaton",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/t/ztfm0n_n1ks.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 60,
      "control": 58,
      "pressure": 52,
      "agility": 79,
      "physical": 41,
      "technique": 75
    }
  },
  {
    "id": 1592,
    "name": "Terry Toolan",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/7/o7uhzyz3yxe.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 55,
      "control": 40,
      "pressure": 49,
      "agility": 53,
      "physical": 46,
      "technique": 62
    }
  },
  {
    "id": 1593,
    "name": "Callum Biddy",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/a/qapb3blbdre.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 58,
      "control": 71,
      "pressure": 55,
      "agility": 54,
      "physical": 53,
      "technique": 65
    }
  },
  {
    "id": 1594,
    "name": "Alan Sumner",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/y/byy6a-thwis.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 48,
      "control": 59,
      "pressure": 63,
      "agility": 57,
      "physical": 68,
      "technique": 52
    }
  },
  {
    "id": 1595,
    "name": "Trixy Wonder",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/d/7d7pjjypfcc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 62,
      "control": 78,
      "pressure": 51,
      "agility": 55,
      "physical": 45,
      "technique": 64
    }
  },
  {
    "id": 1596,
    "name": "Colet First",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/1/k1kukc-tox0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 60,
      "control": 47,
      "pressure": 66,
      "agility": 45,
      "physical": 53,
      "technique": 54
    }
  },
  {
    "id": 1597,
    "name": "Mac Gabbon",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/f/-f12vr9xpoc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 43,
      "control": 51,
      "pressure": 55,
      "agility": 52,
      "physical": 44,
      "technique": 54
    }
  },
  {
    "id": 1598,
    "name": "Tip Bolster",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/3/p3ex4ubli90.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 56,
      "control": 48,
      "pressure": 79,
      "agility": 50,
      "physical": 75,
      "technique": 50
    }
  },
  {
    "id": 1599,
    "name": "Draco Scallon",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/f/hffaivscdru.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 45,
      "control": 41,
      "pressure": 54,
      "agility": 68,
      "physical": 41,
      "technique": 49
    }
  },
  {
    "id": 1600,
    "name": "Sofia Brashier",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/3/q3u7pq04ui8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 40,
      "control": 48,
      "pressure": 51,
      "agility": 56,
      "physical": 57,
      "technique": 67
    }
  },
  {
    "id": 1601,
    "name": "Tam Boyish",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/y/wynocnbwbcm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 65,
      "control": 61,
      "pressure": 54,
      "agility": 47,
      "physical": 55,
      "technique": 65
    }
  },
  {
    "id": 1602,
    "name": "Mat Halled",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/w/bw8vxynk2xk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 47,
      "control": 57,
      "pressure": 66,
      "agility": 53,
      "physical": 52,
      "technique": 57
    }
  },
  {
    "id": 1603,
    "name": "James Strang",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/r/dr7zfr1mz3k.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 59,
      "control": 53,
      "pressure": 60,
      "agility": 57,
      "physical": 60,
      "technique": 53
    }
  },
  {
    "id": 1604,
    "name": "Ian Watchen",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/5/y5ksyutceem.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 56,
      "control": 70,
      "pressure": 40,
      "agility": 56,
      "physical": 48,
      "technique": 53
    }
  },
  {
    "id": 1605,
    "name": "Rose Snelgrove",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/w/swpnhjmurk8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 59,
      "control": 52,
      "pressure": 76,
      "agility": 57,
      "physical": 59,
      "technique": 47
    }
  },
  {
    "id": 1606,
    "name": "Bert Emmerson",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/-/j-ygm2augxu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 45,
      "control": 56,
      "pressure": 43,
      "agility": 73,
      "physical": 51,
      "technique": 68
    }
  },
  {
    "id": 1607,
    "name": "Irving Gusher",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/u/xune97dmho8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 54,
      "control": 48,
      "pressure": 48,
      "agility": 64,
      "physical": 60,
      "technique": 52
    }
  },
  {
    "id": 1608,
    "name": "Lionel Silent",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/8/m8w_qel2mbu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 60,
      "control": 53,
      "pressure": 64,
      "agility": 40,
      "physical": 67,
      "technique": 56
    }
  },
  {
    "id": 1609,
    "name": "Owen Rage",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/4/m4dnme7eywc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 48,
      "control": 46,
      "pressure": 55,
      "agility": 56,
      "physical": 62,
      "technique": 55
    }
  },
  {
    "id": 1610,
    "name": "Alice Nutty",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/q/9qysh7d-fd0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 54,
      "control": 60,
      "pressure": 75,
      "agility": 43,
      "physical": 69,
      "technique": 57
    }
  },
  {
    "id": 1611,
    "name": "Conrad Jacket",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/_/d_rzymo2qje.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 57,
      "control": 63,
      "pressure": 52,
      "agility": 60,
      "physical": 53,
      "technique": 53
    }
  },
  {
    "id": 1612,
    "name": "Hilda Bronski",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/x/sxg4fzomhqs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 52,
      "control": 44,
      "pressure": 45,
      "agility": 70,
      "physical": 46,
      "technique": 60
    }
  },
  {
    "id": 1613,
    "name": "Clint Peacock",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/2/u2nkxacgcws.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 72,
      "control": 73,
      "pressure": 48,
      "agility": 49,
      "physical": 49,
      "technique": 58
    }
  },
  {
    "id": 1614,
    "name": "Pace Maker",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/e/fewfc_6avle.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 45,
      "control": 59,
      "pressure": 43,
      "agility": 55,
      "physical": 58,
      "technique": 60
    }
  },
  {
    "id": 1615,
    "name": "Vanity Percy",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/x/_x1wpipsaf0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 59,
      "control": 48,
      "pressure": 64,
      "agility": 58,
      "physical": 53,
      "technique": 49
    }
  },
  {
    "id": 1616,
    "name": "Phil Pagoda",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/z/ozeridpo32c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 53,
      "control": 41,
      "pressure": 69,
      "agility": 53,
      "physical": 60,
      "technique": 56
    }
  },
  {
    "id": 1617,
    "name": "Niki Colbeck",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/z/6z7jtqqkqj0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 46,
      "control": 56,
      "pressure": 67,
      "agility": 57,
      "physical": 64,
      "technique": 51
    }
  },
  {
    "id": 1618,
    "name": "Guy Pinnay",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/b/lbko-vmw96c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 74,
      "control": 68,
      "pressure": 58,
      "agility": 40,
      "physical": 40,
      "technique": 54
    }
  },
  {
    "id": 1619,
    "name": "Wayne Fluke",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/z/lzrlkuf5cw8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 49,
      "control": 58,
      "pressure": 82,
      "agility": 51,
      "physical": 67,
      "technique": 45
    }
  },
  {
    "id": 1620,
    "name": "Red Dayers",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/b/ubgejrjdxlu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 44,
      "control": 43,
      "pressure": 57,
      "agility": 48,
      "physical": 70,
      "technique": 47
    }
  },
  {
    "id": 1621,
    "name": "Shay Diebold",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/0/00dxamwlefk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 57,
      "control": 56,
      "pressure": 44,
      "agility": 63,
      "physical": 40,
      "technique": 63
    }
  },
  {
    "id": 1622,
    "name": "Tigh Gerwhite",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/c/fcyq3zwxp2m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 43,
      "control": 56,
      "pressure": 55,
      "agility": 70,
      "physical": 41,
      "technique": 59
    }
  },
  {
    "id": 1623,
    "name": "Cerise Crane",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/9/h91mzqidswm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 65,
      "control": 65,
      "pressure": 47,
      "agility": 51,
      "physical": 46,
      "technique": 59
    }
  },
  {
    "id": 1624,
    "name": "Drack Gorn",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/v/2vet0venbdk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 53,
      "control": 51,
      "pressure": 69,
      "agility": 54,
      "physical": 75,
      "technique": 51
    }
  },
  {
    "id": 1625,
    "name": "Terry Pinn",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/6/w6nynixv0ju.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 42,
      "control": 54,
      "pressure": 72,
      "agility": 49,
      "physical": 68,
      "technique": 43
    }
  },
  {
    "id": 1626,
    "name": "Justin Cush",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/s/nsw5k3xvzq8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 50,
      "control": 48,
      "pressure": 60,
      "agility": 57,
      "physical": 59,
      "technique": 54
    }
  },
  {
    "id": 1627,
    "name": "Bert McClure",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/4/t4ph76u3-vu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 40,
      "control": 40,
      "pressure": 69,
      "agility": 60,
      "physical": 68,
      "technique": 44
    }
  },
  {
    "id": 1628,
    "name": "Richard Trogg",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/q/iqyawfyntc8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 54,
      "control": 42,
      "pressure": 58,
      "agility": 70,
      "physical": 43,
      "technique": 54
    }
  },
  {
    "id": 1629,
    "name": "Shirly Quirk",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/0/n0ow5t86z6c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 59,
      "control": 49,
      "pressure": 62,
      "agility": 49,
      "physical": 57,
      "technique": 57
    }
  },
  {
    "id": 1630,
    "name": "Elias Lens",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/c/8c_3usaa0j0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 64,
      "control": 71,
      "pressure": 50,
      "agility": 46,
      "physical": 43,
      "technique": 61
    }
  },
  {
    "id": 1631,
    "name": "Terry Dryden",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/z/czcchpvibpe.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 68,
      "control": 78,
      "pressure": 57,
      "agility": 42,
      "physical": 56,
      "technique": 68
    }
  },
  {
    "id": 1632,
    "name": "Ardel Kernel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/b/tbtjqwjysas.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 49,
      "control": 53,
      "pressure": 70,
      "agility": 41,
      "physical": 58,
      "technique": 60
    }
  },
  {
    "id": 1633,
    "name": "Carl Belcher",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/6/v6q_epbepcs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 44,
      "control": 56,
      "pressure": 65,
      "agility": 54,
      "physical": 63,
      "technique": 45
    }
  },
  {
    "id": 1634,
    "name": "Mal Maroon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/s/esbepw9keve.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 56,
      "control": 57,
      "pressure": 59,
      "agility": 46,
      "physical": 72,
      "technique": 56
    }
  },
  {
    "id": 1635,
    "name": "Ralph Fary",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/9/-94r6lisxp0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 47,
      "control": 46,
      "pressure": 49,
      "agility": 58,
      "physical": 45,
      "technique": 52
    }
  },
  {
    "id": 1636,
    "name": "Floyd Spades",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/v/pvjkx0uwc8c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 66,
      "control": 72,
      "pressure": 48,
      "agility": 54,
      "physical": 45,
      "technique": 55
    }
  },
  {
    "id": 1637,
    "name": "Remy Diggun",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/_/7_2sm5t07d0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 55,
      "control": 56,
      "pressure": 68,
      "agility": 50,
      "physical": 67,
      "technique": 56
    }
  },
  {
    "id": 1638,
    "name": "Bern Macmahon",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/x/kxhzlglowwc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 70,
      "control": 68,
      "pressure": 51,
      "agility": 58,
      "physical": 55,
      "technique": 66
    }
  },
  {
    "id": 1639,
    "name": "Wally Cooper",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/_/k_c-rhch3c8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 48,
      "control": 47,
      "pressure": 68,
      "agility": 44,
      "physical": 59,
      "technique": 56
    }
  },
  {
    "id": 1640,
    "name": "Griff Hardcasel",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/x/vxtf84k9avu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 57,
      "control": 44,
      "pressure": 53,
      "agility": 72,
      "physical": 52,
      "technique": 56
    }
  },
  {
    "id": 1641,
    "name": "Pat Lubow",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/4/14oqvlr1vpk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 53,
      "control": 59,
      "pressure": 53,
      "agility": 55,
      "physical": 69,
      "technique": 47
    }
  },
  {
    "id": 1642,
    "name": "Wilma Morgan",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/q/eq_lca3pc8m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 58,
      "control": 42,
      "pressure": 82,
      "agility": 43,
      "physical": 67,
      "technique": 55
    }
  },
  {
    "id": 1643,
    "name": "Carys Chaparon",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/x/gx4xsdljh6m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 45,
      "control": 42,
      "pressure": 42,
      "agility": 65,
      "physical": 45,
      "technique": 60
    }
  },
  {
    "id": 1644,
    "name": "Claire Hostess",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/z/3zj2b8dzqjk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 50,
      "control": 54,
      "pressure": 56,
      "agility": 67,
      "physical": 59,
      "technique": 58
    }
  },
  {
    "id": 1645,
    "name": "Katy Punter",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/2/x2qdsh2rfpu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 51,
      "control": 45,
      "pressure": 63,
      "agility": 43,
      "physical": 61,
      "technique": 55
    }
  },
  {
    "id": 1646,
    "name": "Pete Pimento",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/e/mebi_eqrya8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 56,
      "control": 44,
      "pressure": 58,
      "agility": 61,
      "physical": 50,
      "technique": 60
    }
  },
  {
    "id": 1647,
    "name": "Mary Hugland",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/0/s0k6ottjvlu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 50,
      "control": 47,
      "pressure": 54,
      "agility": 45,
      "physical": 73,
      "technique": 49
    }
  },
  {
    "id": 1648,
    "name": "Lee Screener",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/c/jcvbjs1z4w8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 53,
      "control": 44,
      "pressure": 54,
      "agility": 57,
      "physical": 75,
      "technique": 52
    }
  },
  {
    "id": 1649,
    "name": "Camilla Textor",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/0/t0aqnlfghdu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 49,
      "control": 49,
      "pressure": 58,
      "agility": 76,
      "physical": 60,
      "technique": 75
    }
  },
  {
    "id": 1650,
    "name": "Bish Beaton",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/c/ccrxga58qw8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 81,
      "intelligence": 43,
      "control": 43,
      "pressure": 45,
      "agility": 60,
      "physical": 54,
      "technique": 62
    }
  },
  {
    "id": 1651,
    "name": "Simeon Squareyes",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/z/8ziezhm0fqm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 56,
      "control": 51,
      "pressure": 56,
      "agility": 70,
      "physical": 57,
      "technique": 68
    }
  },
  {
    "id": 1652,
    "name": "Stu Borneman",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/b/nb5le4qoyjk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 47,
      "control": 48,
      "pressure": 73,
      "agility": 60,
      "physical": 54,
      "technique": 50
    }
  },
  {
    "id": 1653,
    "name": "Herbie Garnet",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/6/p6-5wh4i3lk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 40,
      "control": 50,
      "pressure": 84,
      "agility": 53,
      "physical": 65,
      "technique": 51
    }
  },
  {
    "id": 1654,
    "name": "Arvin Inkwell",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/s/-spydeeyawm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 44,
      "control": 42,
      "pressure": 70,
      "agility": 55,
      "physical": 65,
      "technique": 57
    }
  },
  {
    "id": 1655,
    "name": "Rayce Sprinton",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/9/e9stodrqv28.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 62,
      "control": 77,
      "pressure": 51,
      "agility": 50,
      "physical": 43,
      "technique": 68
    }
  },
  {
    "id": 1656,
    "name": "Dreama Bartle",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/v/vvdmj8nqcfu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 40,
      "control": 57,
      "pressure": 52,
      "agility": 76,
      "physical": 55,
      "technique": 65
    }
  },
  {
    "id": 1657,
    "name": "Jane Ledbelly",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/_/b_iusxoil68.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 50,
      "control": 59,
      "pressure": 62,
      "agility": 54,
      "physical": 59,
      "technique": 51
    }
  },
  {
    "id": 1658,
    "name": "Dory O'Bonn",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/x/qxt1_ooyiju.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 41,
      "control": 55,
      "pressure": 68,
      "agility": 46,
      "physical": 68,
      "technique": 44
    }
  },
  {
    "id": 1659,
    "name": "Selma Heaver",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/_/e_i4lph7pl0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 44,
      "control": 50,
      "pressure": 53,
      "agility": 44,
      "physical": 58,
      "technique": 58
    }
  },
  {
    "id": 1660,
    "name": "Kath Leaflin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/x/1x5ziwhbewc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 60,
      "control": 48,
      "pressure": 55,
      "agility": 41,
      "physical": 72,
      "technique": 50
    }
  },
  {
    "id": 1661,
    "name": "Marg Shuttle",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/4/v4asbtyjx2s.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 58,
      "control": 57,
      "pressure": 53,
      "agility": 49,
      "physical": 60,
      "technique": 66
    }
  },
  {
    "id": 1662,
    "name": "Duke Scrubine",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/q/kqrn2suzcfe.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 58,
      "control": 44,
      "pressure": 66,
      "agility": 44,
      "physical": 65,
      "technique": 42
    }
  },
  {
    "id": 1663,
    "name": "Waylon Tripp",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/x/mxsrylgfzde.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 53,
      "control": 51,
      "pressure": 54,
      "agility": 73,
      "physical": 53,
      "technique": 52
    }
  },
  {
    "id": 1664,
    "name": "Jim Bunner",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/z/xzdw10gl0ws.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 42,
      "control": 58,
      "pressure": 62,
      "agility": 46,
      "physical": 77,
      "technique": 44
    }
  },
  {
    "id": 1665,
    "name": "Jon Izumo",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/2/32-fmpvtbqc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 44,
      "control": 47,
      "pressure": 50,
      "agility": 59,
      "physical": 49,
      "technique": 62
    }
  },
  {
    "id": 1666,
    "name": "Del Brighton",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/e/gepklwzxsj0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 41,
      "control": 58,
      "pressure": 45,
      "agility": 73,
      "physical": 45,
      "technique": 57
    }
  },
  {
    "id": 1667,
    "name": "Haden Safe",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/0/y0w86bw1lcc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 52,
      "control": 53,
      "pressure": 41,
      "agility": 57,
      "physical": 54,
      "technique": 48
    }
  },
  {
    "id": 1668,
    "name": "Lisle Plotter",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/c/dcbdxkwpmv0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 59,
      "control": 56,
      "pressure": 48,
      "agility": 61,
      "physical": 60,
      "technique": 61
    }
  },
  {
    "id": 1669,
    "name": "Fen Skates",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/i/_ixm0hlfn8e.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 46,
      "control": 54,
      "pressure": 50,
      "agility": 71,
      "physical": 41,
      "technique": 58
    }
  },
  {
    "id": 1670,
    "name": "Rhoda Dough",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/k/okmtzed_kps.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 56,
      "control": 57,
      "pressure": 71,
      "agility": 59,
      "physical": 60,
      "technique": 42
    }
  },
  {
    "id": 1671,
    "name": "Neil Seating",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/l/ulfykd23_vc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 51,
      "control": 76,
      "pressure": 43,
      "agility": 52,
      "physical": 58,
      "technique": 70
    }
  },
  {
    "id": 1672,
    "name": "Flo Nighting",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/n/fn05n8qnsc0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 50,
      "control": 60,
      "pressure": 64,
      "agility": 41,
      "physical": 54,
      "technique": 56
    }
  },
  {
    "id": 1673,
    "name": "Elinor Maven",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/s/dszljlchxa0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 43,
      "control": 58,
      "pressure": 46,
      "agility": 55,
      "physical": 50,
      "technique": 57
    }
  },
  {
    "id": 1674,
    "name": "Kay Gateley",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/e/secekakb6pc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 45,
      "control": 40,
      "pressure": 42,
      "agility": 60,
      "physical": 56,
      "technique": 55
    }
  },
  {
    "id": 1675,
    "name": "Dexter Caise",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/r/mrhx3hrtpjs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 55,
      "control": 60,
      "pressure": 70,
      "agility": 54,
      "physical": 72,
      "technique": 46
    }
  },
  {
    "id": 1676,
    "name": "Serena Besse",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/d/9dqqa43pi6e.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 60,
      "control": 59,
      "pressure": 59,
      "agility": 56,
      "physical": 46,
      "technique": 60
    }
  },
  {
    "id": 1677,
    "name": "Adrian Heartly",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/p/jpvir10lffs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 54,
      "control": 53,
      "pressure": 70,
      "agility": 58,
      "physical": 77,
      "technique": 46
    }
  },
  {
    "id": 1678,
    "name": "Cary Fearless",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/b/4bepgksxo2e.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 84,
      "intelligence": 43,
      "control": 43,
      "pressure": 58,
      "agility": 71,
      "physical": 49,
      "technique": 70
    }
  },
  {
    "id": 1679,
    "name": "Wally Waymire",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/p/wpfkclb4jak.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 48,
      "control": 40,
      "pressure": 66,
      "agility": 42,
      "physical": 70,
      "technique": 52
    }
  },
  {
    "id": 1680,
    "name": "Ted Autumn",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/b/nb0fx09ckpm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 51,
      "control": 43,
      "pressure": 64,
      "agility": 51,
      "physical": 63,
      "technique": 55
    }
  },
  {
    "id": 1681,
    "name": "Boomer Smolen",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/u/huxwipikrj8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 60,
      "control": 45,
      "pressure": 80,
      "agility": 59,
      "physical": 68,
      "technique": 41
    }
  },
  {
    "id": 1682,
    "name": "Hank Ershef",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/g/2gmrpwuw86u.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 60,
      "control": 69,
      "pressure": 51,
      "agility": 49,
      "physical": 55,
      "technique": 55
    }
  },
  {
    "id": 1683,
    "name": "Tim Opener",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/n/0nhnhp8c58u.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 40,
      "control": 52,
      "pressure": 73,
      "agility": 43,
      "physical": 68,
      "technique": 42
    }
  },
  {
    "id": 1685,
    "name": "Beth Doodle",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/g/lgzzftvuhvm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 60,
      "control": 59,
      "pressure": 53,
      "agility": 52,
      "physical": 47,
      "technique": 57
    }
  },
  {
    "id": 1686,
    "name": "Lamar Bonesteel",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/i/uic4ysjumck.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 71,
      "control": 76,
      "pressure": 49,
      "agility": 40,
      "physical": 50,
      "technique": 53
    }
  },
  {
    "id": 1687,
    "name": "Dom Round",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/i/gi9gdfk2rjm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 45,
      "control": 57,
      "pressure": 58,
      "agility": 55,
      "physical": 62,
      "technique": 42
    }
  },
  {
    "id": 1688,
    "name": "Chip Stocks",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/k/rkmbugsmgqk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 40,
      "control": 41,
      "pressure": 56,
      "agility": 65,
      "physical": 44,
      "technique": 52
    }
  },
  {
    "id": 1689,
    "name": "Blake Nailor",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/i/fidkapg55fm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 54,
      "control": 59,
      "pressure": 73,
      "agility": 56,
      "physical": 73,
      "technique": 60
    }
  },
  {
    "id": 1690,
    "name": "Dotty Hickman",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/k/ukyrtwgdu2k.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 58,
      "control": 58,
      "pressure": 57,
      "agility": 47,
      "physical": 47,
      "technique": 74
    }
  },
  {
    "id": 1691,
    "name": "Wright Tandem",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/l/olre-lvlhwu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 54,
      "control": 60,
      "pressure": 61,
      "agility": 51,
      "physical": 60,
      "technique": 58
    }
  },
  {
    "id": 1692,
    "name": "Shaun Bonnie",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/n/_ng_t0zxml8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 42,
      "control": 44,
      "pressure": 55,
      "agility": 60,
      "physical": 73,
      "technique": 51
    }
  },
  {
    "id": 1693,
    "name": "Andrew Hooper",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/s/9snj9thdjj8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 59,
      "control": 56,
      "pressure": 45,
      "agility": 64,
      "physical": 53,
      "technique": 68
    }
  },
  {
    "id": 1694,
    "name": "Toya Boyde",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/e/mewcqshnkqu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 55,
      "control": 51,
      "pressure": 67,
      "agility": 41,
      "physical": 66,
      "technique": 48
    }
  },
  {
    "id": 1695,
    "name": "Taryn Shyder",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/r/sr13dpyvrwk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 40,
      "control": 57,
      "pressure": 46,
      "agility": 63,
      "physical": 60,
      "technique": 61
    }
  },
  {
    "id": 1696,
    "name": "Jasmin Trier",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/d/ddewuwuv8dm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 48,
      "control": 54,
      "pressure": 62,
      "agility": 57,
      "physical": 60,
      "technique": 41
    }
  },
  {
    "id": 1697,
    "name": "Dave Lung",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/p/pp7of9x3b8k.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 51,
      "control": 48,
      "pressure": 62,
      "agility": 55,
      "physical": 68,
      "technique": 57
    }
  },
  {
    "id": 1698,
    "name": "Teal Redsky",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/b/ybkvycxn2pm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 59,
      "control": 40,
      "pressure": 40,
      "agility": 54,
      "physical": 60,
      "technique": 55
    }
  },
  {
    "id": 1699,
    "name": "Truman Verdy",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/p/2priod4exjs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 47,
      "control": 44,
      "pressure": 59,
      "agility": 47,
      "physical": 68,
      "technique": 56
    }
  },
  {
    "id": 1700,
    "name": "Chance Cerulean",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/b/hbgdf8e-6qe.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 69,
      "control": 71,
      "pressure": 56,
      "agility": 43,
      "physical": 47,
      "technique": 71
    }
  },
  {
    "id": 1701,
    "name": "Amy Peach",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/u/nud2whr2pw0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 71,
      "control": 70,
      "pressure": 52,
      "agility": 45,
      "physical": 40,
      "technique": 54
    }
  },
  {
    "id": 1702,
    "name": "Virgil Amber",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/g/wgyx7enmidc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 59,
      "control": 56,
      "pressure": 76,
      "agility": 58,
      "physical": 59,
      "technique": 55
    }
  },
  {
    "id": 1703,
    "name": "Grant Stodgell",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/n/un1lvhfgnfc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 45,
      "control": 49,
      "pressure": 58,
      "agility": 64,
      "physical": 51,
      "technique": 63
    }
  },
  {
    "id": 1704,
    "name": "Payne Outler",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/p/lpeq445ak20.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 46,
      "control": 56,
      "pressure": 59,
      "agility": 44,
      "physical": 62,
      "technique": 43
    }
  },
  {
    "id": 1705,
    "name": "Malcolm Shirker",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/g/fgnfrlms_we.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 55,
      "control": 62,
      "pressure": 53,
      "agility": 56,
      "physical": 49,
      "technique": 65
    }
  },
  {
    "id": 1706,
    "name": "Hanna Slack",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/i/0iw-gaqosls.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 75,
      "control": 68,
      "pressure": 53,
      "agility": 55,
      "physical": 49,
      "technique": 70
    }
  },
  {
    "id": 1707,
    "name": "Dom Poppy",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/i/aipm3xpk1ae.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 43,
      "control": 48,
      "pressure": 74,
      "agility": 41,
      "physical": 56,
      "technique": 49
    }
  },
  {
    "id": 1708,
    "name": "Portia Maricle",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/k/xkyhaopwyps.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 70,
      "control": 62,
      "pressure": 59,
      "agility": 45,
      "physical": 44,
      "technique": 46
    }
  },
  {
    "id": 1709,
    "name": "Susan Doiley",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/o/bon1gorcmck.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 60,
      "control": 61,
      "pressure": 54,
      "agility": 52,
      "physical": 41,
      "technique": 55
    }
  },
  {
    "id": 1710,
    "name": "Hannah Breer",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/m/qm8urx34lxm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 47,
      "control": 57,
      "pressure": 45,
      "agility": 79,
      "physical": 59,
      "technique": 53
    }
  },
  {
    "id": 1711,
    "name": "Phil Seebold",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/j/kjfh4kcw-r8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 48,
      "control": 48,
      "pressure": 41,
      "agility": 61,
      "physical": 52,
      "technique": 60
    }
  },
  {
    "id": 1712,
    "name": "Bobbie Tomey",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/h/7huav1kktiu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 58,
      "control": 47,
      "pressure": 41,
      "agility": 56,
      "physical": 49,
      "technique": 67
    }
  },
  {
    "id": 1713,
    "name": "Randolph Lords",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/a/5apc7s2mwku.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 28,
      "intelligence": 41,
      "control": 45,
      "pressure": 57,
      "agility": 58,
      "physical": 63,
      "technique": 50
    }
  },
  {
    "id": 1714,
    "name": "Robin Traylor",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/o/ioy9wtqc7x8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 73,
      "control": 73,
      "pressure": 56,
      "agility": 50,
      "physical": 47,
      "technique": 58
    }
  },
  {
    "id": 1715,
    "name": "Fawn Blossom",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/h/oh7ifoluo3m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 56,
      "control": 47,
      "pressure": 58,
      "agility": 40,
      "physical": 66,
      "technique": 41
    }
  },
  {
    "id": 1716,
    "name": "Isabell Mish",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/v/zvkpoxdujek.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 69,
      "control": 68,
      "pressure": 42,
      "agility": 46,
      "physical": 44,
      "technique": 54
    }
  },
  {
    "id": 1717,
    "name": "Rudy Stemper",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/f/tf1xz8ame7m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 75,
      "control": 72,
      "pressure": 43,
      "agility": 50,
      "physical": 40,
      "technique": 62
    }
  },
  {
    "id": 1718,
    "name": "Betty Evenson",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/t/cteq0dm2pik.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 68,
      "control": 73,
      "pressure": 47,
      "agility": 42,
      "physical": 50,
      "technique": 61
    }
  },
  {
    "id": 1719,
    "name": "Harpo Kendrick",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/f/yffducv_ike.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 52,
      "control": 45,
      "pressure": 58,
      "agility": 54,
      "physical": 57,
      "technique": 48
    }
  },
  {
    "id": 1720,
    "name": "Colin Glower",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/t/dtu8d9jflxs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 54,
      "control": 69,
      "pressure": 60,
      "agility": 44,
      "physical": 55,
      "technique": 49
    }
  },
  {
    "id": 1721,
    "name": "Tailor Wilden",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/c/jcnjqg8nq3c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 40,
      "control": 58,
      "pressure": 52,
      "agility": 58,
      "physical": 57,
      "technique": 64
    }
  },
  {
    "id": 1722,
    "name": "Sim Cebus",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/q/sq8o9fa39e0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 40,
      "control": 50,
      "pressure": 60,
      "agility": 53,
      "physical": 62,
      "technique": 43
    }
  },
  {
    "id": 1723,
    "name": "Sam Banks",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/l/ql70tgib4c0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 80,
      "control": 67,
      "pressure": 44,
      "agility": 53,
      "physical": 60,
      "technique": 74
    }
  },
  {
    "id": 1724,
    "name": "Frank Homey",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/j/hjkv-5uhvxc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 52,
      "control": 49,
      "pressure": 55,
      "agility": 54,
      "physical": 70,
      "technique": 45
    }
  },
  {
    "id": 1725,
    "name": "Gregg Deremer",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/m/bmpgtkbpgrs.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 53,
      "control": 48,
      "pressure": 76,
      "agility": 41,
      "physical": 61,
      "technique": 46
    }
  },
  {
    "id": 1726,
    "name": "Verne Spring",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/k/wkybab9tnie.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 69,
      "control": 60,
      "pressure": 56,
      "agility": 40,
      "physical": 47,
      "technique": 70
    }
  },
  {
    "id": 1727,
    "name": "Bryan Klamm",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/o/eonzxw-xqds.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 71,
      "control": 76,
      "pressure": 59,
      "agility": 49,
      "physical": 48,
      "technique": 62
    }
  },
  {
    "id": 1728,
    "name": "Colt Youngstein",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/m/1mw4cpylhue.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 57,
      "control": 54,
      "pressure": 74,
      "agility": 58,
      "physical": 70,
      "technique": 41
    }
  },
  {
    "id": 1729,
    "name": "Will Kilmon",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/j/djjzkiqiwlk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 65,
      "control": 58,
      "pressure": 59,
      "agility": 43,
      "physical": 45,
      "technique": 59
    }
  },
  {
    "id": 1730,
    "name": "Milly Vacey",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/l/slssndmyd4m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 49,
      "control": 47,
      "pressure": 45,
      "agility": 62,
      "physical": 44,
      "technique": 57
    }
  },
  {
    "id": 1731,
    "name": "Gary Primo",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/m/9magz_fafru.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 47,
      "control": 43,
      "pressure": 40,
      "agility": 58,
      "physical": 51,
      "technique": 57
    }
  },
  {
    "id": 1732,
    "name": "Bobby Duo",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/t/_tha3mnsatu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 42,
      "control": 59,
      "pressure": 68,
      "agility": 48,
      "physical": 64,
      "technique": 49
    }
  },
  {
    "id": 1733,
    "name": "Stan Treece",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/f/of27azrwte8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 65,
      "control": 69,
      "pressure": 57,
      "agility": 51,
      "physical": 55,
      "technique": 49
    }
  },
  {
    "id": 1734,
    "name": "Lillie Quattro",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/q/uqvojeeey-m.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 61,
      "control": 66,
      "pressure": 57,
      "agility": 52,
      "physical": 58,
      "technique": 68
    }
  },
  {
    "id": 1735,
    "name": "Eddy Pentaris",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/c/fckvk74k1nk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 56,
      "control": 45,
      "pressure": 77,
      "agility": 59,
      "physical": 65,
      "technique": 55
    }
  },
  {
    "id": 1736,
    "name": "Candice Mell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/o/rob3v27gsym.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 66,
      "control": 72,
      "pressure": 58,
      "agility": 55,
      "physical": 42,
      "technique": 52
    }
  },
  {
    "id": 1737,
    "name": "Alex Dauger",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/a/aaqw4jd8_bk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 55,
      "control": 57,
      "pressure": 68,
      "agility": 43,
      "physical": 67,
      "technique": 43
    }
  },
  {
    "id": 1738,
    "name": "Joe Divide",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/o/0oxbiiu1ete.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 40,
      "control": 40,
      "pressure": 51,
      "agility": 67,
      "physical": 52,
      "technique": 58
    }
  },
  {
    "id": 1739,
    "name": "Sam Willing",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/a/faa6p3ypzes.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 44,
      "control": 40,
      "pressure": 73,
      "agility": 54,
      "physical": 70,
      "technique": 52
    }
  },
  {
    "id": 1740,
    "name": "Mary Antoine",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/v/lvjpcqhhg-c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 67,
      "control": 73,
      "pressure": 45,
      "agility": 47,
      "physical": 48,
      "technique": 50
    }
  },
  {
    "id": 1741,
    "name": "Edward Baron",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/h/uhsuxvh9rn0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 53,
      "control": 56,
      "pressure": 46,
      "agility": 55,
      "physical": 59,
      "technique": 61
    }
  },
  {
    "id": 1742,
    "name": "Tim Platton",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/m/wmvyfmzrul0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 72,
      "control": 73,
      "pressure": 48,
      "agility": 59,
      "physical": 42,
      "technique": 65
    }
  },
  {
    "id": 1743,
    "name": "Argento Salvage",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/o/noktyzvrd4c.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 51,
      "control": 52,
      "pressure": 72,
      "agility": 51,
      "physical": 68,
      "technique": 57
    }
  },
  {
    "id": 1744,
    "name": "Finn Geld",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/h/hhhmhugj2ys.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 59,
      "control": 49,
      "pressure": 51,
      "agility": 59,
      "physical": 49,
      "technique": 54
    }
  },
  {
    "id": 1745,
    "name": "Ian Moray",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/j/2j2hmrgzbre.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 65,
      "control": 64,
      "pressure": 53,
      "agility": 60,
      "physical": 51,
      "technique": 68
    }
  },
  {
    "id": 1746,
    "name": "Gil Holden",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/j/cjjf9cf78us.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 41,
      "control": 43,
      "pressure": 56,
      "agility": 57,
      "physical": 72,
      "technique": 44
    }
  },
  {
    "id": 1747,
    "name": "Doyle Palmer",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/l/zl4-qjjbrne.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 46,
      "control": 43,
      "pressure": 70,
      "agility": 51,
      "physical": 69,
      "technique": 45
    }
  },
  {
    "id": 1748,
    "name": "Audry Orange",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/j/9j31-qj0uys.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 56,
      "control": 57,
      "pressure": 49,
      "agility": 58,
      "physical": 47,
      "technique": 72
    }
  },
  {
    "id": 1749,
    "name": "May Apple",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/l/mlgutvvodbe.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 74,
      "control": 64,
      "pressure": 45,
      "agility": 50,
      "physical": 44,
      "technique": 51
    }
  },
  {
    "id": 1750,
    "name": "Ginny White",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/k/sklhaiag2h0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 60,
      "control": 51,
      "pressure": 53,
      "agility": 67,
      "physical": 50,
      "technique": 49
    }
  },
  {
    "id": 1751,
    "name": "Angus Hogg",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/m/dmuat388bsc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 83,
      "intelligence": 56,
      "control": 59,
      "pressure": 57,
      "agility": 76,
      "physical": 47,
      "technique": 67
    }
  },
  {
    "id": 1752,
    "name": "Sabrina Carow",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/f/ufi9uriqzn0.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 43,
      "control": 54,
      "pressure": 55,
      "agility": 44,
      "physical": 72,
      "technique": 42
    }
  },
  {
    "id": 1753,
    "name": "Bob Beelzy",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/q/oqbi9m9ighe.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 59,
      "control": 40,
      "pressure": 61,
      "agility": 60,
      "physical": 71,
      "technique": 48
    }
  },
  {
    "id": 1754,
    "name": "Patt Howell",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/c/_cwpqzbyr0s.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 52,
      "control": 53,
      "pressure": 66,
      "agility": 54,
      "physical": 66,
      "technique": 44
    }
  },
  {
    "id": 1755,
    "name": "Ol Factory",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/o/lopxh-y6mle.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 51,
      "control": 52,
      "pressure": 61,
      "agility": 40,
      "physical": 62,
      "technique": 49
    }
  },
  {
    "id": 1756,
    "name": "Tom Skipper",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/a/6a-qmb-ah4s.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 81,
      "intelligence": 45,
      "control": 59,
      "pressure": 51,
      "agility": 69,
      "physical": 46,
      "technique": 54
    }
  },
  {
    "id": 1757,
    "name": "Colin Binder",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/e/jek9yrxs6wu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 56,
      "control": 71,
      "pressure": 42,
      "agility": 55,
      "physical": 47,
      "technique": 68
    }
  },
  {
    "id": 1758,
    "name": "Larry Pogue",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/r/prpih2eap2k.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 43,
      "control": 53,
      "pressure": 54,
      "agility": 63,
      "physical": 45,
      "technique": 58
    }
  },
  {
    "id": 1759,
    "name": "Rob Cardson",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/d/ydypmjigifm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 52,
      "control": 49,
      "pressure": 70,
      "agility": 47,
      "physical": 66,
      "technique": 41
    }
  },
  {
    "id": 1760,
    "name": "Ken Mayfield",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/i/aif1iqwmndm.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 52,
      "control": 55,
      "pressure": 78,
      "agility": 53,
      "physical": 59,
      "technique": 43
    }
  },
  {
    "id": 1761,
    "name": "Casey Leather",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/k/rkuupvw2kwk.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 69,
      "control": 59,
      "pressure": 48,
      "agility": 47,
      "physical": 44,
      "technique": 58
    }
  },
  {
    "id": 1762,
    "name": "Ethan Swallow",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/l/llnhcyj-_qu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 56,
      "control": 72,
      "pressure": 44,
      "agility": 49,
      "physical": 52,
      "technique": 58
    }
  },
  {
    "id": 1763,
    "name": "Bob Daruma",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/n/6n8axnfesj8.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 60,
      "control": 60,
      "pressure": 53,
      "agility": 49,
      "physical": 53,
      "technique": 69
    }
  },
  {
    "id": 1764,
    "name": "Mitch Blackston",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/n/ondyaagm1cu.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 54,
      "control": 54,
      "pressure": 51,
      "agility": 50,
      "physical": 40,
      "technique": 51
    }
  },
  {
    "id": 1765,
    "name": "In Chikita",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/t/fttcduuqeuc.png",
    "game": [
      "Inazuma Eleven 2"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 55,
      "control": 57,
      "pressure": 59,
      "agility": 58,
      "physical": 47,
      "technique": 69
    }
  },
  {
    "id": 1769,
    "name": "Austin Hobbes",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/u/vu_2_98zume.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 45,
      "control": 45,
      "pressure": 42,
      "agility": 70,
      "physical": 54,
      "technique": 59
    }
  },
  {
    "id": 1770,
    "name": "Archer Hawkins",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/7/p7cdsgjrbs0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 44,
      "control": 49,
      "pressure": 58,
      "agility": 41,
      "physical": 67,
      "technique": 50
    }
  },
  {
    "id": 1771,
    "name": "Xavier Foster",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/y/8yq-vg9hzzc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 58,
      "control": 47,
      "pressure": 45,
      "agility": 71,
      "physical": 54,
      "technique": 51
    }
  },
  {
    "id": 1772,
    "name": "Jordan Greenway",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/1/t14qrku1rke.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 64,
      "control": 62,
      "pressure": 55,
      "agility": 46,
      "physical": 51,
      "technique": 63
    }
  },
  {
    "id": 1773,
    "name": "Caleb Stonewall",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/a/nabfc5b9eq0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 62,
      "control": 61,
      "pressure": 54,
      "agility": 44,
      "physical": 45,
      "technique": 66
    }
  },
  {
    "id": 1774,
    "name": "Percival Travis",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/w/bwxwy2_pw90.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 61,
      "control": 66,
      "pressure": 56,
      "agility": 40,
      "physical": 56,
      "technique": 68
    }
  },
  {
    "id": 1775,
    "name": "Camellia Travis",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/3/o32tnwlthge.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 52,
      "control": 49,
      "pressure": 72,
      "agility": 42,
      "physical": 68,
      "technique": 49
    }
  },
  {
    "id": 1776,
    "name": "Isaac Glass",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/t/-ttibfvr2fc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 42,
      "control": 40,
      "pressure": 55,
      "agility": 60,
      "physical": 44,
      "technique": 50
    }
  },
  {
    "id": 1777,
    "name": "Gene Whalon",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/u/purwl1flw1m.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 50,
      "control": 42,
      "pressure": 55,
      "agility": 53,
      "physical": 63,
      "technique": 51
    }
  },
  {
    "id": 1778,
    "name": "David Waterman",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/7/v7ifyoqtfv8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 51,
      "control": 53,
      "pressure": 68,
      "agility": 50,
      "physical": 73,
      "technique": 56
    }
  },
  {
    "id": 1779,
    "name": "Sonny Shore",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/t/et5k1xmxomu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 42,
      "control": 41,
      "pressure": 58,
      "agility": 51,
      "physical": 66,
      "technique": 59
    }
  },
  {
    "id": 1780,
    "name": "Kjell Snapper",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/y/cy-4boe7tgu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 57,
      "control": 49,
      "pressure": 73,
      "agility": 44,
      "physical": 60,
      "technique": 47
    }
  },
  {
    "id": 1781,
    "name": "Ken Crackham",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/a/tapz2x4bat8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 41,
      "control": 54,
      "pressure": 61,
      "agility": 42,
      "physical": 56,
      "technique": 43
    }
  },
  {
    "id": 1782,
    "name": "Shawn Princeton",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/1/n1sslsnj1zm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 67,
      "control": 66,
      "pressure": 56,
      "agility": 45,
      "physical": 59,
      "technique": 63
    }
  },
  {
    "id": 1783,
    "name": "Matt Fischer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/d/8ddnitrzyak.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 56,
      "control": 71,
      "pressure": 51,
      "agility": 59,
      "physical": 47,
      "technique": 52
    }
  },
  {
    "id": 1784,
    "name": "Hank Tennyson",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/3/i3iv5eor__m.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 59,
      "control": 70,
      "pressure": 45,
      "agility": 45,
      "physical": 44,
      "technique": 58
    }
  },
  {
    "id": 1785,
    "name": "Dolph Hensen",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/f/5ft0uhorsmk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 66,
      "control": 56,
      "pressure": 47,
      "agility": 53,
      "physical": 43,
      "technique": 51
    }
  },
  {
    "id": 1786,
    "name": "Hamilton Reith",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/3/x3i5oghizge.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 46,
      "control": 45,
      "pressure": 43,
      "agility": 72,
      "physical": 58,
      "technique": 68
    }
  },
  {
    "id": 1787,
    "name": "Joe Dawes",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/f/mf5yjfhyets.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 46,
      "control": 43,
      "pressure": 50,
      "agility": 63,
      "physical": 54,
      "technique": 67
    }
  },
  {
    "id": 1788,
    "name": "Quincy Horace",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/w/gwatwcuqrzc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 47,
      "control": 48,
      "pressure": 75,
      "agility": 56,
      "physical": 76,
      "technique": 57
    }
  },
  {
    "id": 1789,
    "name": "Holly Summers",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/y/3yrmd9yqga0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 61,
      "control": 62,
      "pressure": 45,
      "agility": 53,
      "physical": 48,
      "technique": 68
    }
  },
  {
    "id": 1790,
    "name": "Derek Rabson",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/5/15sqzkggdg0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 59,
      "control": 71,
      "pressure": 42,
      "agility": 46,
      "physical": 50,
      "technique": 58
    }
  },
  {
    "id": 1791,
    "name": "Barack Daniels",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/r/erdxebg8u1c.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 59,
      "control": 46,
      "pressure": 76,
      "agility": 54,
      "physical": 59,
      "technique": 46
    }
  },
  {
    "id": 1792,
    "name": "Bruce Marlin",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/-/k--engz0bvs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 58,
      "control": 45,
      "pressure": 44,
      "agility": 68,
      "physical": 43,
      "technique": 58
    }
  },
  {
    "id": 1793,
    "name": "Robert Kleiser",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/w/8w28mu4bix0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 58,
      "control": 42,
      "pressure": 40,
      "agility": 70,
      "physical": 48,
      "technique": 62
    }
  },
  {
    "id": 1794,
    "name": "Nasir Mustafa",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/c/dcmsyxlmqkc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 28,
      "intelligence": 54,
      "control": 44,
      "pressure": 71,
      "agility": 48,
      "physical": 55,
      "technique": 54
    }
  },
  {
    "id": 1795,
    "name": "Faraz Farooq",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/t/9tfzhsqulqs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 46,
      "control": 45,
      "pressure": 62,
      "agility": 54,
      "physical": 66,
      "technique": 51
    }
  },
  {
    "id": 1796,
    "name": "Bilal Kalil",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/f/mf04mt2uize.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 41,
      "control": 57,
      "pressure": 70,
      "agility": 47,
      "physical": 72,
      "technique": 52
    }
  },
  {
    "id": 1798,
    "name": "Jamila Wali",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/k/okzkikk4nfe.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 54,
      "control": 40,
      "pressure": 71,
      "agility": 60,
      "physical": 56,
      "technique": 59
    }
  },
  {
    "id": 1799,
    "name": "Musa Sylla",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/m/_mcfp1ccgss.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 54,
      "control": 49,
      "pressure": 55,
      "agility": 56,
      "physical": 74,
      "technique": 55
    }
  },
  {
    "id": 1800,
    "name": "Yusuf Massoud",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/j/fjhwco3kvmc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 54,
      "control": 73,
      "pressure": 51,
      "agility": 53,
      "physical": 56,
      "technique": 53
    }
  },
  {
    "id": 1801,
    "name": "Sulayk Sulaiman",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/l/ulqrxxrw4_0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 65,
      "control": 64,
      "pressure": 44,
      "agility": 59,
      "physical": 42,
      "technique": 66
    }
  },
  {
    "id": 1802,
    "name": "Sayid Armand",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/h/ahvjaassfac.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 69,
      "control": 68,
      "pressure": 55,
      "agility": 49,
      "physical": 45,
      "technique": 56
    }
  },
  {
    "id": 1803,
    "name": "Mansur Jasim",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/j/rjeotl0oyz0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 60,
      "control": 56,
      "pressure": 58,
      "agility": 59,
      "physical": 59,
      "technique": 49
    }
  },
  {
    "id": 1804,
    "name": "Zack Abdulla",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/h/fhfl3k9htfu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 41,
      "control": 44,
      "pressure": 47,
      "agility": 64,
      "physical": 42,
      "technique": 68
    }
  },
  {
    "id": 1805,
    "name": "Majdi Ismail",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/j/0j0eabbb-s8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 46,
      "control": 47,
      "pressure": 45,
      "agility": 71,
      "physical": 58,
      "technique": 46
    }
  },
  {
    "id": 1806,
    "name": "Talal Hamad",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/m/umxxjgutlmm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 58,
      "control": 47,
      "pressure": 56,
      "agility": 60,
      "physical": 78,
      "technique": 60
    }
  },
  {
    "id": 1807,
    "name": "Hasan Ahmed",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/o/lomqk5ipm_k.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 52,
      "control": 56,
      "pressure": 72,
      "agility": 51,
      "physical": 50,
      "technique": 60
    }
  },
  {
    "id": 1808,
    "name": "Khalfan Jibril",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/v/nvhmkgafj5k.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 48,
      "control": 58,
      "pressure": 68,
      "agility": 53,
      "physical": 72,
      "technique": 42
    }
  },
  {
    "id": 1809,
    "name": "Rajab Ismail",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/h/whqtnf8_okm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 65,
      "control": 76,
      "pressure": 48,
      "agility": 56,
      "physical": 56,
      "technique": 63
    }
  },
  {
    "id": 1810,
    "name": "Adel Siddique",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/o/2ozy0cj37q8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 57,
      "control": 40,
      "pressure": 42,
      "agility": 66,
      "physical": 54,
      "technique": 59
    }
  },
  {
    "id": 1811,
    "name": "Eliza Mannan",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/f/cfvj1znj93e.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 63,
      "control": 58,
      "pressure": 50,
      "agility": 43,
      "physical": 43,
      "technique": 58
    }
  },
  {
    "id": 1812,
    "name": "Zack Cummings",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/o/boos4k_otf0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 51,
      "control": 58,
      "pressure": 58,
      "agility": 44,
      "physical": 70,
      "technique": 55
    }
  },
  {
    "id": 1813,
    "name": "Wilbur Watkins",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/u/iuwehtp6yae.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 42,
      "control": 48,
      "pressure": 47,
      "agility": 58,
      "physical": 48,
      "technique": 53
    }
  },
  {
    "id": 1814,
    "name": "Dave Quagmire",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/d/cdjl8bipg5s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 64,
      "control": 59,
      "pressure": 56,
      "agility": 48,
      "physical": 41,
      "technique": 59
    }
  },
  {
    "id": 1815,
    "name": "Zeke Valanche",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/y/ky2qjrrs1y0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 47,
      "control": 52,
      "pressure": 41,
      "agility": 58,
      "physical": 51,
      "technique": 55
    }
  },
  {
    "id": 1816,
    "name": "Ethan Whitering",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/d/rdg5e1dsw1s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 61,
      "control": 65,
      "pressure": 45,
      "agility": 52,
      "physical": 53,
      "technique": 60
    }
  },
  {
    "id": 1817,
    "name": "Jeongsu Cho",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/c/9cyqg5gaozu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 44,
      "control": 54,
      "pressure": 77,
      "agility": 46,
      "physical": 75,
      "technique": 48
    }
  },
  {
    "id": 1818,
    "name": "Umi Hwang",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/t/dtrfvkzs7tk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 58,
      "control": 58,
      "pressure": 58,
      "agility": 54,
      "physical": 63,
      "technique": 55
    }
  },
  {
    "id": 1819,
    "name": "Dooyoon Hong",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/f/sfg-4bvowgm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 42,
      "control": 53,
      "pressure": 58,
      "agility": 57,
      "physical": 69,
      "technique": 44
    }
  },
  {
    "id": 1820,
    "name": "Minho Cho",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/k/ukniwchetmm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 51,
      "control": 43,
      "pressure": 55,
      "agility": 40,
      "physical": 80,
      "technique": 48
    }
  },
  {
    "id": 1821,
    "name": "Songhwan Ko",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/m/fmwd79h--vk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 46,
      "control": 58,
      "pressure": 66,
      "agility": 53,
      "physical": 56,
      "technique": 53
    }
  },
  {
    "id": 1822,
    "name": "Paekyeong Park",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/j/_j12ogu2l1u.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 61,
      "control": 79,
      "pressure": 53,
      "agility": 53,
      "physical": 41,
      "technique": 55
    }
  },
  {
    "id": 1824,
    "name": "Eunyeong Kim",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/h/6h7p0sxub5u.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 54,
      "control": 62,
      "pressure": 48,
      "agility": 41,
      "physical": 50,
      "technique": 62
    }
  },
  {
    "id": 1825,
    "name": "Claude Beacons",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/j/ljkuztxusk8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 54,
      "control": 60,
      "pressure": 51,
      "agility": 62,
      "physical": 55,
      "technique": 64
    }
  },
  {
    "id": 1826,
    "name": "Changsu Choi",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/h/lhrjdsednmc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 63,
      "control": 73,
      "pressure": 57,
      "agility": 52,
      "physical": 52,
      "technique": 54
    }
  },
  {
    "id": 1827,
    "name": "Bryce Whitingale",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/j/ujgcut4ngv0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 49,
      "control": 41,
      "pressure": 53,
      "agility": 63,
      "physical": 50,
      "technique": 64
    }
  },
  {
    "id": 1828,
    "name": "Chi-Won Ho",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/m/0md39onvv1e.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 41,
      "control": 48,
      "pressure": 62,
      "agility": 50,
      "physical": 61,
      "technique": 43
    }
  },
  {
    "id": 1829,
    "name": "Dong-Hyun Seul",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/o/foywqxrv4gs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 42,
      "control": 50,
      "pressure": 57,
      "agility": 40,
      "physical": 79,
      "technique": 46
    }
  },
  {
    "id": 1830,
    "name": "Jung-Hoon Yi",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/v/hv1k-o559as.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 69,
      "control": 61,
      "pressure": 50,
      "agility": 49,
      "physical": 56,
      "technique": 66
    }
  },
  {
    "id": 1831,
    "name": "Sung-Jin Noh",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/h/2hertxfdqze.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 44,
      "control": 42,
      "pressure": 50,
      "agility": 61,
      "physical": 53,
      "technique": 51
    }
  },
  {
    "id": 1832,
    "name": "Joon-Ho Ja",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/o/woneakqllt0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 66,
      "control": 55,
      "pressure": 54,
      "agility": 58,
      "physical": 43,
      "technique": 59
    }
  },
  {
    "id": 1833,
    "name": "Lee Ji Seong",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/3/t3koymrzqes.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 40,
      "control": 53,
      "pressure": 69,
      "agility": 49,
      "physical": 50,
      "technique": 54
    }
  },
  {
    "id": 1834,
    "name": "Freddy McQueen",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/u/5u8va4rhr08.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 42,
      "control": 44,
      "pressure": 58,
      "agility": 55,
      "physical": 64,
      "technique": 40
    }
  },
  {
    "id": 1835,
    "name": "Jonny Gascoigne",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/b/zbfgtlkpkum.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 60,
      "control": 48,
      "pressure": 69,
      "agility": 41,
      "physical": 74,
      "technique": 47
    }
  },
  {
    "id": 1836,
    "name": "David Buckingham",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/p/opub-actjnk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 50,
      "control": 58,
      "pressure": 63,
      "agility": 44,
      "physical": 64,
      "technique": 46
    }
  },
  {
    "id": 1837,
    "name": "Lance Rawton",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/i/qipdqdq_mhk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 40,
      "control": 45,
      "pressure": 56,
      "agility": 51,
      "physical": 66,
      "technique": 59
    }
  },
  {
    "id": 1838,
    "name": "Edge Ripper",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/g/bgy8982fhsm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 53,
      "control": 56,
      "pressure": 74,
      "agility": 47,
      "physical": 62,
      "technique": 52
    }
  },
  {
    "id": 1839,
    "name": "Peter Cole",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/p/7p7juhdnuy8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 68,
      "control": 61,
      "pressure": 40,
      "agility": 42,
      "physical": 45,
      "technique": 63
    }
  },
  {
    "id": 1840,
    "name": "Gary Mane",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/n/knkodel35bu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 66,
      "control": 64,
      "pressure": 52,
      "agility": 51,
      "physical": 56,
      "technique": 48
    }
  },
  {
    "id": 1841,
    "name": "Paul Appleton",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/n/-n1wytmve-8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 73,
      "control": 70,
      "pressure": 46,
      "agility": 53,
      "physical": 42,
      "technique": 67
    }
  },
  {
    "id": 1842,
    "name": "Eric Purpleton",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/l/plerfsavznu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 61,
      "control": 70,
      "pressure": 42,
      "agility": 47,
      "physical": 49,
      "technique": 63
    }
  },
  {
    "id": 1843,
    "name": "Edgar Partinus",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/n/hnfcftjmsh0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 48,
      "control": 52,
      "pressure": 55,
      "agility": 77,
      "physical": 57,
      "technique": 71
    }
  },
  {
    "id": 1844,
    "name": "Phillip Owen",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/l/qlu9osvc_sc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 51,
      "control": 55,
      "pressure": 52,
      "agility": 61,
      "physical": 42,
      "technique": 52
    }
  },
  {
    "id": 1845,
    "name": "Servilius Jeeves",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/k/wkni7paukys.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 50,
      "control": 43,
      "pressure": 75,
      "agility": 53,
      "physical": 60,
      "technique": 44
    }
  },
  {
    "id": 1846,
    "name": "Martin Squall",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/i/bi8pww8unbe.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 51,
      "control": 45,
      "pressure": 61,
      "agility": 57,
      "physical": 71,
      "technique": 48
    }
  },
  {
    "id": 1847,
    "name": "Nick Woodgate",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/d/dd714pucihe.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 48,
      "control": 56,
      "pressure": 59,
      "agility": 66,
      "physical": 41,
      "technique": 65
    }
  },
  {
    "id": 1848,
    "name": "Mikey Richards",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/r/yrkuvwi4p0s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 59,
      "control": 68,
      "pressure": 48,
      "agility": 51,
      "physical": 47,
      "technique": 59
    }
  },
  {
    "id": 1849,
    "name": "Sirius Pounding",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/e/sephgl9w6uc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 61,
      "control": 61,
      "pressure": 56,
      "agility": 44,
      "physical": 55,
      "technique": 58
    }
  },
  {
    "id": 1851,
    "name": "Aaron Adams",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/w/vwj02v5fvcs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 52,
      "control": 54,
      "pressure": 58,
      "agility": 63,
      "physical": 48,
      "technique": 48
    }
  },
  {
    "id": 1852,
    "name": "Indigo Lazuli",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/d/_dstmyqrh98.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 26,
      "intelligence": 54,
      "control": 56,
      "pressure": 80,
      "agility": 47,
      "physical": 66,
      "technique": 57
    }
  },
  {
    "id": 1853,
    "name": "Roseo Diamante",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/s/fsxmfvfjydm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 57,
      "control": 59,
      "pressure": 51,
      "agility": 42,
      "physical": 55,
      "technique": 54
    }
  },
  {
    "id": 1854,
    "name": "Azubel Turchese",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/e/ueahyq5zfuk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 48,
      "control": 42,
      "pressure": 65,
      "agility": 55,
      "physical": 74,
      "technique": 56
    }
  },
  {
    "id": 1855,
    "name": "Nello Agata",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/l/slhbcjr1aok.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 44,
      "control": 59,
      "pressure": 66,
      "agility": 58,
      "physical": 60,
      "technique": 54
    }
  },
  {
    "id": 1856,
    "name": "Azzurro Zaffiro",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/n/dn26x2np3bm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 40,
      "control": 47,
      "pressure": 55,
      "agility": 60,
      "physical": 62,
      "technique": 59
    }
  },
  {
    "id": 1857,
    "name": "Beldio Smeraldo",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/i/9ivpir4hc78.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 74,
      "control": 78,
      "pressure": 56,
      "agility": 54,
      "physical": 44,
      "technique": 61
    }
  },
  {
    "id": 1858,
    "name": "Rosso Granato",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/k/mkkupue9viu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 68,
      "control": 74,
      "pressure": 50,
      "agility": 45,
      "physical": 58,
      "technique": 48
    }
  },
  {
    "id": 1859,
    "name": "Giallo Topazio",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/g/4gb2-zdfi38.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 69,
      "control": 77,
      "pressure": 46,
      "agility": 47,
      "physical": 58,
      "technique": 73
    }
  },
  {
    "id": 1860,
    "name": "Bianco Perla",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/i/jiqxtm7lleu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 42,
      "control": 54,
      "pressure": 45,
      "agility": 69,
      "physical": 41,
      "technique": 55
    }
  },
  {
    "id": 1861,
    "name": "Giulio Acuto",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/g/ngxajnyseo0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 66,
      "control": 68,
      "pressure": 55,
      "agility": 60,
      "physical": 40,
      "technique": 66
    }
  },
  {
    "id": 1863,
    "name": "Violetto Ametista",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/i/wia7kyuwpbc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 46,
      "control": 42,
      "pressure": 40,
      "agility": 64,
      "physical": 51,
      "technique": 71
    }
  },
  {
    "id": 1864,
    "name": "Grigio Quarzo",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/n/2njo3fhec7s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 45,
      "control": 54,
      "pressure": 65,
      "agility": 47,
      "physical": 67,
      "technique": 56
    }
  },
  {
    "id": 1865,
    "name": "Pardo Berillo",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/p/hpsva6hkxie.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 46,
      "control": 57,
      "pressure": 65,
      "agility": 47,
      "physical": 51,
      "technique": 56
    }
  },
  {
    "id": 1866,
    "name": "Marrone Corniola",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/u/fuvz0jvi0oe.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 65,
      "control": 54,
      "pressure": 59,
      "agility": 59,
      "physical": 49,
      "technique": 54
    }
  },
  {
    "id": 1867,
    "name": "Amaranto Rubino",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/g/0gkszczyz9s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 59,
      "control": 68,
      "pressure": 49,
      "agility": 50,
      "physical": 43,
      "technique": 59
    }
  },
  {
    "id": 1868,
    "name": "Avorio Opale",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/p/uphnkbg6sdc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 40,
      "control": 48,
      "pressure": 59,
      "agility": 54,
      "physical": 51,
      "technique": 57
    }
  },
  {
    "id": 1869,
    "name": "Mister D",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/-/e-svbqfl4xe.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 62,
      "control": 67,
      "pressure": 50,
      "agility": 53,
      "physical": 58,
      "technique": 54
    }
  },
  {
    "id": 1870,
    "name": "Jorge Ortega",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/d/fdgv46jxze0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 59,
      "control": 52,
      "pressure": 74,
      "agility": 45,
      "physical": 78,
      "technique": 53
    }
  },
  {
    "id": 1871,
    "name": "Thiago Torres",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/s/_slgrn8fske.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 49,
      "control": 57,
      "pressure": 61,
      "agility": 57,
      "physical": 59,
      "technique": 55
    }
  },
  {
    "id": 1872,
    "name": "Julio Acosta",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/e/oeubgyalbxs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 54,
      "control": 58,
      "pressure": 68,
      "agility": 54,
      "physical": 57,
      "technique": 59
    }
  },
  {
    "id": 1873,
    "name": "Grande Díaz",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/l/mltdobijers.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 60,
      "control": 42,
      "pressure": 71,
      "agility": 54,
      "physical": 56,
      "technique": 54
    }
  },
  {
    "id": 1874,
    "name": "Ramón Martínez",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/n/9ni8f-uzpie.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 58,
      "control": 54,
      "pressure": 75,
      "agility": 47,
      "physical": 68,
      "technique": 54
    }
  },
  {
    "id": 1875,
    "name": "Esteban Carlos",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/i/dibjwjb7cc0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 62,
      "control": 79,
      "pressure": 50,
      "agility": 56,
      "physical": 48,
      "technique": 55
    }
  },
  {
    "id": 1876,
    "name": "Sergio Pérez",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/k/skwo7c9bxxc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 65,
      "control": 59,
      "pressure": 51,
      "agility": 40,
      "physical": 44,
      "technique": 58
    }
  },
  {
    "id": 1877,
    "name": "Roberto Torres",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/g/ygpwkr-jwo0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 75,
      "control": 71,
      "pressure": 43,
      "agility": 55,
      "physical": 57,
      "technique": 65
    }
  },
  {
    "id": 1878,
    "name": "Pablo Castillo",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/i/pi-rnuyz79c.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 77,
      "control": 52,
      "pressure": 48,
      "agility": 51,
      "physical": 43,
      "technique": 60
    }
  },
  {
    "id": 1879,
    "name": "Leone Badigo",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/g/hglc9vrqar8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 58,
      "control": 49,
      "pressure": 40,
      "agility": 53,
      "physical": 52,
      "technique": 64
    }
  },
  {
    "id": 1880,
    "name": "Diego Oro",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/i/2iu9qq3q3iu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 82,
      "intelligence": 52,
      "control": 45,
      "pressure": 52,
      "agility": 68,
      "physical": 46,
      "technique": 62
    }
  },
  {
    "id": 1881,
    "name": "Lionel Cruz",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/n/wn3idncicck.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 49,
      "control": 42,
      "pressure": 76,
      "agility": 47,
      "physical": 65,
      "technique": 43
    }
  },
  {
    "id": 1882,
    "name": "Mario Saviola",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/p/npgpuykyvxm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 56,
      "control": 54,
      "pressure": 51,
      "agility": 61,
      "physical": 46,
      "technique": 66
    }
  },
  {
    "id": 1883,
    "name": "Hernán Tévez",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/u/lub1ar20q3m.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 41,
      "control": 48,
      "pressure": 72,
      "agility": 43,
      "physical": 57,
      "technique": 53
    }
  },
  {
    "id": 1884,
    "name": "Herman Samuel",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/g/ugwutuqohek.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 57,
      "control": 65,
      "pressure": 49,
      "agility": 51,
      "physical": 45,
      "technique": 65
    }
  },
  {
    "id": 1885,
    "name": "Ricardo Agüero",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/p/0pth-jlgyku.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 53,
      "control": 54,
      "pressure": 59,
      "agility": 69,
      "physical": 47,
      "technique": 57
    }
  },
  {
    "id": 1886,
    "name": "Daniel Sturbin",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/r/-rxgi3qtnr0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 45,
      "control": 58,
      "pressure": 57,
      "agility": 60,
      "physical": 52,
      "technique": 51
    }
  },
  {
    "id": 1887,
    "name": "Billy Dash",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/v/nvljb-zu57k.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 41,
      "control": 44,
      "pressure": 71,
      "agility": 43,
      "physical": 75,
      "technique": 49
    }
  },
  {
    "id": 1888,
    "name": "Ted Bryant",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/6/t6o8sjgcmbu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 43,
      "control": 42,
      "pressure": 64,
      "agility": 54,
      "physical": 71,
      "technique": 43
    }
  },
  {
    "id": 1889,
    "name": "Tony Strider",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/s/cszd_cgmho8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 44,
      "control": 59,
      "pressure": 57,
      "agility": 49,
      "physical": 67,
      "technique": 47
    }
  },
  {
    "id": 1890,
    "name": "Drake Dynamo",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/z/ezebrfykku8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 53,
      "control": 55,
      "pressure": 69,
      "agility": 46,
      "physical": 77,
      "technique": 43
    }
  },
  {
    "id": 1891,
    "name": "Bobby Shearer",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/b/vbvg86uwjdu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 57,
      "control": 43,
      "pressure": 56,
      "agility": 57,
      "physical": 73,
      "technique": 59
    }
  },
  {
    "id": 1892,
    "name": "Steve Woodmark",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/0/p0mvvnh489k.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 66,
      "control": 63,
      "pressure": 60,
      "agility": 53,
      "physical": 46,
      "technique": 57
    }
  },
  {
    "id": 1893,
    "name": "Erik Eagle",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/c/-c90cyhcrom.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 63,
      "control": 64,
      "pressure": 49,
      "agility": 47,
      "physical": 54,
      "technique": 65
    }
  },
  {
    "id": 1894,
    "name": "Shane Pierce",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/2/k2cszveg2xk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 65,
      "control": 70,
      "pressure": 56,
      "agility": 40,
      "physical": 52,
      "technique": 55
    }
  },
  {
    "id": 1895,
    "name": "Mark Krueger",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/e/7ezneqiabcm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 66,
      "control": 60,
      "pressure": 43,
      "agility": 44,
      "physical": 40,
      "technique": 61
    }
  },
  {
    "id": 1896,
    "name": "Dylan Keats",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/2/v2oaerrt6us.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 49,
      "control": 58,
      "pressure": 47,
      "agility": 55,
      "physical": 45,
      "technique": 56
    }
  },
  {
    "id": 1897,
    "name": "Gabriel Jax",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/e/kezhpunpxde.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 45,
      "control": 56,
      "pressure": 60,
      "agility": 65,
      "physical": 40,
      "technique": 72
    }
  },
  {
    "id": 1898,
    "name": "Alex Hawke",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/x/ex6u6j4hi90.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 60,
      "control": 44,
      "pressure": 61,
      "agility": 59,
      "physical": 63,
      "technique": 51
    }
  },
  {
    "id": 1899,
    "name": "Corey Washington",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/z/1zl1x2ebpoc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 55,
      "control": 53,
      "pressure": 55,
      "agility": 45,
      "physical": 60,
      "technique": 51
    }
  },
  {
    "id": 1900,
    "name": "Bob Bobbins",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/4/34mp5vm3kic.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 51,
      "control": 48,
      "pressure": 63,
      "agility": 51,
      "physical": 74,
      "technique": 42
    }
  },
  {
    "id": 1901,
    "name": "Petie Pooma",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/q/gq9iuqqnn70.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 66,
      "control": 61,
      "pressure": 47,
      "agility": 41,
      "physical": 46,
      "technique": 65
    }
  },
  {
    "id": 1902,
    "name": "Norbert Poindexter",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/_/m_e9hnffsbe.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 56,
      "control": 43,
      "pressure": 50,
      "agility": 77,
      "physical": 41,
      "technique": 72
    }
  },
  {
    "id": 1903,
    "name": "Mac Scryde",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/5/p5ablimxgic.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 59,
      "control": 62,
      "pressure": 51,
      "agility": 40,
      "physical": 55,
      "technique": 57
    }
  },
  {
    "id": 1904,
    "name": "Gigi Blasi",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/v/tvfp12qoncs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 55,
      "control": 46,
      "pressure": 74,
      "agility": 52,
      "physical": 72,
      "technique": 57
    }
  },
  {
    "id": 1905,
    "name": "Vento Galliano",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/6/n686mrlgsic.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 53,
      "control": 57,
      "pressure": 72,
      "agility": 58,
      "physical": 66,
      "technique": 58
    }
  },
  {
    "id": 1906,
    "name": "Ottorino Nobili",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/s/8snbluda_r0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 51,
      "control": 48,
      "pressure": 70,
      "agility": 58,
      "physical": 77,
      "technique": 50
    }
  },
  {
    "id": 1907,
    "name": "Anton Graziuso",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/z/-zkhlnr26x0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 60,
      "control": 41,
      "pressure": 62,
      "agility": 51,
      "physical": 64,
      "technique": 54
    }
  },
  {
    "id": 1908,
    "name": "Marco Maserati",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/b/pb7miy3mxkc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 59,
      "control": 42,
      "pressure": 61,
      "agility": 51,
      "physical": 63,
      "technique": 56
    }
  },
  {
    "id": 1909,
    "name": "Angelo Gabrini",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/0/v0ytbvceies.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 68,
      "control": 64,
      "pressure": 56,
      "agility": 58,
      "physical": 43,
      "technique": 51
    }
  },
  {
    "id": 1910,
    "name": "Gianluca Zanardi",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/c/ecpy2qk-p3e.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 61,
      "control": 74,
      "pressure": 42,
      "agility": 60,
      "physical": 45,
      "technique": 71
    }
  },
  {
    "id": 1911,
    "name": "Giorgio Giannini",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/2/q2wqhdncois.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 66,
      "control": 65,
      "pressure": 56,
      "agility": 52,
      "physical": 53,
      "technique": 59
    }
  },
  {
    "id": 1912,
    "name": "Dante Diavolo",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/e/benlqibmf7e.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 64,
      "control": 74,
      "pressure": 49,
      "agility": 43,
      "physical": 44,
      "technique": 53
    }
  },
  {
    "id": 1913,
    "name": "Paolo Bianchi",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/2/128gwjivkxk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 51,
      "control": 50,
      "pressure": 58,
      "agility": 63,
      "physical": 52,
      "technique": 58
    }
  },
  {
    "id": 1914,
    "name": "Raffaele Generani",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/e/eenndcuvjkm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 51,
      "control": 56,
      "pressure": 55,
      "agility": 70,
      "physical": 51,
      "technique": 57
    }
  },
  {
    "id": 1915,
    "name": "Daniele Sanctis",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/x/kxusobbd8e8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 56,
      "control": 52,
      "pressure": 51,
      "agility": 58,
      "physical": 74,
      "technique": 53
    }
  },
  {
    "id": 1916,
    "name": "Enrico Oliviero",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/z/vzfzj-9nr3u.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 73,
      "control": 57,
      "pressure": 40,
      "agility": 47,
      "physical": 52,
      "technique": 68
    }
  },
  {
    "id": 1917,
    "name": "Alessandro Rossa",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/4/x4yvnnvluxu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 60,
      "control": 65,
      "pressure": 44,
      "agility": 41,
      "physical": 51,
      "technique": 58
    }
  },
  {
    "id": 1918,
    "name": "Giuseppe Cannavaro",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/q/mqpogyjx5c8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 54,
      "control": 51,
      "pressure": 56,
      "agility": 53,
      "physical": 56,
      "technique": 41
    }
  },
  {
    "id": 1920,
    "name": "Falcão Da Silva",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/5/p5rwz3ht4fe.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 44,
      "control": 59,
      "pressure": 59,
      "agility": 54,
      "physical": 67,
      "technique": 55
    }
  },
  {
    "id": 1921,
    "name": "Carlos Lagarto",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/w/jwyfgqybnl0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 55,
      "control": 46,
      "pressure": 66,
      "agility": 47,
      "physical": 61,
      "technique": 51
    }
  },
  {
    "id": 1922,
    "name": "Antonio Bagre",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/-/4-dknvuhgwc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 46,
      "control": 40,
      "pressure": 77,
      "agility": 44,
      "physical": 58,
      "technique": 52
    }
  },
  {
    "id": 1923,
    "name": "Monstro Ximenes",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/f/6fe4jmgnlqc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 59,
      "control": 40,
      "pressure": 58,
      "agility": 44,
      "physical": 77,
      "technique": 40
    }
  },
  {
    "id": 1924,
    "name": "Formiga Clemens",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/3/l31zozg3ij0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 55,
      "control": 42,
      "pressure": 61,
      "agility": 47,
      "physical": 70,
      "technique": 44
    }
  },
  {
    "id": 1925,
    "name": "Presa Passos",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/y/rywsduv_9de.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 70,
      "control": 66,
      "pressure": 46,
      "agility": 51,
      "physical": 48,
      "technique": 71
    }
  },
  {
    "id": 1926,
    "name": "Borboleta Barboza",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/w/awnnwrzfqws.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 76,
      "control": 75,
      "pressure": 40,
      "agility": 40,
      "physical": 56,
      "technique": 50
    }
  },
  {
    "id": 1927,
    "name": "Coruja Cerezo",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/a/uayvbcwn3pe.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 60,
      "control": 72,
      "pressure": 46,
      "agility": 54,
      "physical": 58,
      "technique": 54
    }
  },
  {
    "id": 1928,
    "name": "Leonardo Almeida",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/y/fyp0sjwda8s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 52,
      "control": 68,
      "pressure": 53,
      "agility": 41,
      "physical": 54,
      "technique": 51
    }
  },
  {
    "id": 1929,
    "name": "Mac Robingo",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/a/xay52ifu7qm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 40,
      "control": 60,
      "pressure": 53,
      "agility": 59,
      "physical": 57,
      "technique": 52
    }
  },
  {
    "id": 1930,
    "name": "Gato Carvalho",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/y/aydybd5uwjk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 57,
      "control": 60,
      "pressure": 41,
      "agility": 60,
      "physical": 41,
      "technique": 65
    }
  },
  {
    "id": 1931,
    "name": "Xavier Ribeiro",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/d/gdgtiammjdu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 52,
      "control": 41,
      "pressure": 65,
      "agility": 47,
      "physical": 68,
      "technique": 43
    }
  },
  {
    "id": 1932,
    "name": "Ulisses Nogueira",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/1/r1rml_qcow8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 60,
      "control": 54,
      "pressure": 61,
      "agility": 59,
      "physical": 63,
      "technique": 40
    }
  },
  {
    "id": 1933,
    "name": "Gervasio Oliveira",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/u/tuwqlm4wl28.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 43,
      "control": 58,
      "pressure": 68,
      "agility": 55,
      "physical": 66,
      "technique": 57
    }
  },
  {
    "id": 1934,
    "name": "Tigre Mendes",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/8/i8nxmzekmfu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 61,
      "control": 65,
      "pressure": 47,
      "agility": 47,
      "physical": 58,
      "technique": 56
    }
  },
  {
    "id": 1935,
    "name": "Grillo Santos",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/t/ctee1erctlk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 48,
      "control": 51,
      "pressure": 42,
      "agility": 77,
      "physical": 41,
      "technique": 66
    }
  },
  {
    "id": 1936,
    "name": "Leão Samus",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/t/7t_zufp1hd0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 49,
      "control": 59,
      "pressure": 68,
      "agility": 50,
      "physical": 69,
      "technique": 58
    }
  },
  {
    "id": 1937,
    "name": "Zoolan Rice",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/7/k7o456ppquc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 29,
      "intelligence": 54,
      "control": 47,
      "pressure": 75,
      "agility": 54,
      "physical": 68,
      "technique": 45
    }
  },
  {
    "id": 1938,
    "name": "Cyril Fox",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/7/p7k9zjr89v0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 57,
      "control": 48,
      "pressure": 75,
      "agility": 56,
      "physical": 68,
      "technique": 55
    }
  },
  {
    "id": 1939,
    "name": "Jacques Allemand",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/u/vuhik-k0ipe.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 42,
      "control": 40,
      "pressure": 55,
      "agility": 54,
      "physical": 55,
      "technique": 56
    }
  },
  {
    "id": 1940,
    "name": "Phil A. Minion",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/8/e82pnbcol8s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 55,
      "control": 40,
      "pressure": 66,
      "agility": 60,
      "physical": 59,
      "technique": 56
    }
  },
  {
    "id": 1941,
    "name": "Buddy Plains",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/d/cdx1jyqig6s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 45,
      "control": 57,
      "pressure": 67,
      "agility": 59,
      "physical": 54,
      "technique": 53
    }
  },
  {
    "id": 1942,
    "name": "Dean Goddard",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/1/t1aukn2ynje.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 49,
      "control": 51,
      "pressure": 65,
      "agility": 51,
      "physical": 66,
      "technique": 46
    }
  },
  {
    "id": 1943,
    "name": "Cecil Crowley",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/a/najh36dq4p0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 65,
      "control": 58,
      "pressure": 47,
      "agility": 47,
      "physical": 43,
      "technique": 50
    }
  },
  {
    "id": 1944,
    "name": "Seth Hedges",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/y/8ysaaflqvac.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 66,
      "control": 63,
      "pressure": 47,
      "agility": 53,
      "physical": 54,
      "technique": 59
    }
  },
  {
    "id": 1945,
    "name": "Niccolo Mantegna",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/y/iytyrimiyl0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 55,
      "control": 66,
      "pressure": 58,
      "agility": 44,
      "physical": 55,
      "technique": 70
    }
  },
  {
    "id": 1946,
    "name": "Damien Crawford",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/w/5wc5g3ayfwc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 68,
      "control": 59,
      "pressure": 50,
      "agility": 55,
      "physical": 45,
      "technique": 72
    }
  },
  {
    "id": 1947,
    "name": "Avinash Chowdhury",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/y/xyh0c2j7-68.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 48,
      "control": 51,
      "pressure": 45,
      "agility": 71,
      "physical": 50,
      "technique": 62
    }
  },
  {
    "id": 1948,
    "name": "Sedgley Scofield",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/w/mw2vxjvbtju.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 40,
      "control": 43,
      "pressure": 58,
      "agility": 80,
      "physical": 51,
      "technique": 63
    }
  },
  {
    "id": 1949,
    "name": "Grizzler Bruin",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/f/gfvgiuajmpk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 55,
      "control": 54,
      "pressure": 56,
      "agility": 47,
      "physical": 64,
      "technique": 48
    }
  },
  {
    "id": 1950,
    "name": "Ian C. Wincy",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/3/33kbpr8zlam.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 53,
      "control": 56,
      "pressure": 70,
      "agility": 41,
      "physical": 51,
      "technique": 43
    }
  },
  {
    "id": 1951,
    "name": "Bandy Horsman",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/w/1wjdhyufocm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 67,
      "control": 65,
      "pressure": 40,
      "agility": 41,
      "physical": 44,
      "technique": 66
    }
  },
  {
    "id": 1952,
    "name": "Ali Caiman",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/-/e-s8mniljvk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 49,
      "control": 53,
      "pressure": 51,
      "agility": 59,
      "physical": 41,
      "technique": 55
    }
  },
  {
    "id": 1953,
    "name": "Chris Ellis",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/r/krxjfq9twpu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 45,
      "control": 59,
      "pressure": 61,
      "agility": 59,
      "physical": 73,
      "technique": 51
    }
  },
  {
    "id": 1954,
    "name": "Hector Helio",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/7/v7w7tryajw8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 51,
      "control": 49,
      "pressure": 55,
      "agility": 49,
      "physical": 67,
      "technique": 44
    }
  },
  {
    "id": 1955,
    "name": "Hector Helio",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/3/33c_6oketzm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 41,
      "control": 54,
      "pressure": 58,
      "agility": 41,
      "physical": 52,
      "technique": 48
    }
  },
  {
    "id": 1956,
    "name": "Zephyr Vitesse",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/u/puto-2hiw2m.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 40,
      "control": 53,
      "pressure": 75,
      "agility": 42,
      "physical": 70,
      "technique": 49
    }
  },
  {
    "id": 1957,
    "name": "Walter Mountain",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/8/-8ivtjhy7fk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 58,
      "control": 45,
      "pressure": 65,
      "agility": 47,
      "physical": 62,
      "technique": 58
    }
  },
  {
    "id": 1958,
    "name": "Jimi Gaines",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/d/8dlz9qze-dk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 43,
      "control": 53,
      "pressure": 75,
      "agility": 52,
      "physical": 59,
      "technique": 58
    }
  },
  {
    "id": 1959,
    "name": "Ian Ferrum",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/1/n1usqvvktwm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 55,
      "control": 60,
      "pressure": 66,
      "agility": 54,
      "physical": 56,
      "technique": 43
    }
  },
  {
    "id": 1960,
    "name": "Quint Hampton",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/a/ta3ndygsmq8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 63,
      "control": 60,
      "pressure": 40,
      "agility": 59,
      "physical": 52,
      "technique": 56
    }
  },
  {
    "id": 1961,
    "name": "Yasir Haddad",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/y/cyggungwlju.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 66,
      "control": 63,
      "pressure": 46,
      "agility": 40,
      "physical": 42,
      "technique": 68
    }
  },
  {
    "id": 1962,
    "name": "Keith Ryan",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/y/oy5efaf0sc8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 69,
      "control": 74,
      "pressure": 40,
      "agility": 46,
      "physical": 55,
      "technique": 53
    }
  },
  {
    "id": 1963,
    "name": "Maximino Cruz",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/w/zwi_y_jobvu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 68,
      "control": 56,
      "pressure": 48,
      "agility": 48,
      "physical": 47,
      "technique": 53
    }
  },
  {
    "id": 1964,
    "name": "Gareth Flare",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/y/3ytyo-qhgd0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 51,
      "control": 56,
      "pressure": 47,
      "agility": 55,
      "physical": 58,
      "technique": 68
    }
  },
  {
    "id": 1965,
    "name": "Drago Hill",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/w/gwitfbm9nwc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 44,
      "control": 41,
      "pressure": 55,
      "agility": 66,
      "physical": 59,
      "technique": 51
    }
  },
  {
    "id": 1966,
    "name": "Keenan DiFortune",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/f/mfbmwc514qs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 53,
      "control": 53,
      "pressure": 64,
      "agility": 53,
      "physical": 57,
      "technique": 46
    }
  },
  {
    "id": 1967,
    "name": "Jarell Mangrove",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/3/x3wh7jfpvje.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 42,
      "control": 43,
      "pressure": 67,
      "agility": 53,
      "physical": 74,
      "technique": 45
    }
  },
  {
    "id": 1968,
    "name": "Vic Vitrum",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/w/vw3bv6njqle.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 55,
      "control": 64,
      "pressure": 49,
      "agility": 55,
      "physical": 60,
      "technique": 59
    }
  },
  {
    "id": 1969,
    "name": "Li Leung",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/-/k-g64frz9ws.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 69,
      "control": 70,
      "pressure": 52,
      "agility": 58,
      "physical": 50,
      "technique": 54
    }
  },
  {
    "id": 1970,
    "name": "Jazzy Hedgeer",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/r/erlpryeri2c.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 46,
      "control": 57,
      "pressure": 52,
      "agility": 59,
      "physical": 45,
      "technique": 52
    }
  },
  {
    "id": 1971,
    "name": "David Arrows",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/t/ktv1j7gglc8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 47,
      "control": 42,
      "pressure": 84,
      "agility": 50,
      "physical": 61,
      "technique": 59
    }
  },
  {
    "id": 1972,
    "name": "Roger Pialat",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/t/9t9nuviddps.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 44,
      "control": 53,
      "pressure": 77,
      "agility": 40,
      "physical": 63,
      "technique": 55
    }
  },
  {
    "id": 1973,
    "name": "Kevin Pinot",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/c/dceshy9l2jc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 41,
      "control": 42,
      "pressure": 67,
      "agility": 40,
      "physical": 64,
      "technique": 50
    }
  },
  {
    "id": 1974,
    "name": "Michaël Aron",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/q/sqvzqnbxb60.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 42,
      "control": 43,
      "pressure": 64,
      "agility": 57,
      "physical": 66,
      "technique": 54
    }
  },
  {
    "id": 1975,
    "name": "Francis Poujol",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/l/uloveujde80.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 43,
      "control": 43,
      "pressure": 72,
      "agility": 56,
      "physical": 71,
      "technique": 50
    }
  },
  {
    "id": 1976,
    "name": "Pierre Godin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/j/fjzoprvnzpc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 52,
      "control": 60,
      "pressure": 62,
      "agility": 57,
      "physical": 66,
      "technique": 45
    }
  },
  {
    "id": 1977,
    "name": "Roland Pérec",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/m/_m6762avgvs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 62,
      "control": 65,
      "pressure": 45,
      "agility": 42,
      "physical": 50,
      "technique": 66
    }
  },
  {
    "id": 1978,
    "name": "Julien Rousseau",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/k/oklaxj8vrce.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 68,
      "control": 68,
      "pressure": 57,
      "agility": 55,
      "physical": 55,
      "technique": 66
    }
  },
  {
    "id": 1979,
    "name": "Stéphane Hinault",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/o/6o0cme_3mjs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 67,
      "control": 72,
      "pressure": 51,
      "agility": 43,
      "physical": 40,
      "technique": 53
    }
  },
  {
    "id": 1980,
    "name": "Romuald Huysmans",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/m/lmfjl7znhqe.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 66,
      "control": 58,
      "pressure": 40,
      "agility": 58,
      "physical": 60,
      "technique": 69
    }
  },
  {
    "id": 1981,
    "name": "Jérôme Hervaud",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/o/loeur6qea8k.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 45,
      "control": 57,
      "pressure": 47,
      "agility": 74,
      "physical": 40,
      "technique": 60
    }
  },
  {
    "id": 1982,
    "name": "Alain Favreau",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/m/umvp8f2-tpm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 50,
      "control": 57,
      "pressure": 41,
      "agility": 71,
      "physical": 49,
      "technique": 53
    }
  },
  {
    "id": 1983,
    "name": "Émile Lazare",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/j/0jm6vyd2yv8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 27,
      "intelligence": 44,
      "control": 58,
      "pressure": 57,
      "agility": 42,
      "physical": 58,
      "technique": 51
    }
  },
  {
    "id": 1984,
    "name": "André Pinson",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/h/fh9bcnlm1cu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 45,
      "control": 40,
      "pressure": 55,
      "agility": 56,
      "physical": 69,
      "technique": 50
    }
  },
  {
    "id": 1985,
    "name": "Jean Gutain",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/a/ha6hs-3gwau.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 43,
      "control": 47,
      "pressure": 63,
      "agility": 48,
      "physical": 67,
      "technique": 52
    }
  },
  {
    "id": 1986,
    "name": "Claude Moreau",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/o/2olmbbradp8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 60,
      "control": 66,
      "pressure": 60,
      "agility": 46,
      "physical": 57,
      "technique": 61
    }
  },
  {
    "id": 1987,
    "name": "Michel Morland",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/h/whotscksojm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 57,
      "control": 46,
      "pressure": 49,
      "agility": 67,
      "physical": 41,
      "technique": 69
    }
  },
  {
    "id": 1988,
    "name": "Fermín Sánchez",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/t/dtphgnr_dqk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 54,
      "control": 53,
      "pressure": 72,
      "agility": 59,
      "physical": 66,
      "technique": 53
    }
  },
  {
    "id": 1989,
    "name": "José Costa",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/c/9ckuz6e3owu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 53,
      "control": 55,
      "pressure": 60,
      "agility": 56,
      "physical": 69,
      "technique": 46
    }
  },
  {
    "id": 1990,
    "name": "Rafael López",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/q/mq71ef4nfd8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 53,
      "control": 54,
      "pressure": 66,
      "agility": 42,
      "physical": 77,
      "technique": 57
    }
  },
  {
    "id": 1991,
    "name": "Antonio Gallego",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/l/ol8pwcqhaf8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 48,
      "control": 40,
      "pressure": 80,
      "agility": 55,
      "physical": 56,
      "technique": 57
    }
  },
  {
    "id": 1992,
    "name": "Queraldo Naval",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/j/_jnidjmbt2u.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 48,
      "control": 50,
      "pressure": 77,
      "agility": 51,
      "physical": 55,
      "technique": 47
    }
  },
  {
    "id": 1993,
    "name": "Juan Nadal",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/m/fmu9o-5tywk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 69,
      "control": 75,
      "pressure": 42,
      "agility": 52,
      "physical": 46,
      "technique": 46
    }
  },
  {
    "id": 1994,
    "name": "Igor Ferreira",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/k/ukfcjbfp1lm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 53,
      "control": 67,
      "pressure": 59,
      "agility": 52,
      "physical": 42,
      "technique": 63
    }
  },
  {
    "id": 1995,
    "name": "Pedro Moreno",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/o/aogesmclsak.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 71,
      "control": 60,
      "pressure": 43,
      "agility": 43,
      "physical": 52,
      "technique": 53
    }
  },
  {
    "id": 1996,
    "name": "Miguel Pereira",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/m/rmrl_z6x_pm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 55,
      "control": 70,
      "pressure": 40,
      "agility": 42,
      "physical": 46,
      "technique": 55
    }
  },
  {
    "id": 1997,
    "name": "Samuel Mayo",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/o/fokolyz4efs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 42,
      "control": 57,
      "pressure": 59,
      "agility": 53,
      "physical": 51,
      "technique": 55
    }
  },
  {
    "id": 1998,
    "name": "Davi Peroqué",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/m/0m7jinvcz2e.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 41,
      "control": 56,
      "pressure": 42,
      "agility": 70,
      "physical": 53,
      "technique": 51
    }
  },
  {
    "id": 1999,
    "name": "Juan Espindola",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/j/ujy8bqgkgw0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 47,
      "control": 42,
      "pressure": 79,
      "agility": 58,
      "physical": 61,
      "technique": 43
    }
  },
  {
    "id": 2000,
    "name": "Isaac César",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/h/lhpd2vgwrlc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 52,
      "control": 57,
      "pressure": 50,
      "agility": 55,
      "physical": 41,
      "technique": 51
    }
  },
  {
    "id": 2001,
    "name": "Laudelino Castor",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/a/nauby2ucujc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 46,
      "control": 52,
      "pressure": 58,
      "agility": 44,
      "physical": 67,
      "technique": 59
    }
  },
  {
    "id": 2002,
    "name": "Carlos Arroyo",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/o/wofg1jymdq0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 51,
      "control": 54,
      "pressure": 48,
      "agility": 40,
      "physical": 52,
      "technique": 61
    }
  },
  {
    "id": 2003,
    "name": "Federico Rubiera",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/h/2h8vmuhu2we.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 55,
      "control": 48,
      "pressure": 57,
      "agility": 66,
      "physical": 58,
      "technique": 55
    }
  },
  {
    "id": 2004,
    "name": "Thorsten Welger",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/b/zbnemm8ecxm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 46,
      "control": 43,
      "pressure": 75,
      "agility": 40,
      "physical": 62,
      "technique": 59
    }
  },
  {
    "id": 2005,
    "name": "Alexander Hausen",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/u/5uer17jm338.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 55,
      "control": 48,
      "pressure": 73,
      "agility": 49,
      "physical": 75,
      "technique": 41
    }
  },
  {
    "id": 2006,
    "name": "Heinrich Farber",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/g/ig1kyev2aeu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 53,
      "control": 52,
      "pressure": 51,
      "agility": 40,
      "physical": 66,
      "technique": 48
    }
  },
  {
    "id": 2007,
    "name": "Kurt Zawel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/n/knyw2d9afcu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 54,
      "control": 49,
      "pressure": 67,
      "agility": 47,
      "physical": 67,
      "technique": 58
    }
  },
  {
    "id": 2008,
    "name": "Lukas Schmidt",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/p/7pd3bibgyx8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 60,
      "control": 60,
      "pressure": 73,
      "agility": 56,
      "physical": 63,
      "technique": 43
    }
  },
  {
    "id": 2009,
    "name": "Theodor Ulrich",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/g/bggci_uohrm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 65,
      "control": 69,
      "pressure": 55,
      "agility": 53,
      "physical": 43,
      "technique": 67
    }
  },
  {
    "id": 2010,
    "name": "Jan Oster",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/i/qirjlaisqik.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 60,
      "control": 61,
      "pressure": 43,
      "agility": 43,
      "physical": 58,
      "technique": 65
    }
  },
  {
    "id": 2011,
    "name": "Niklas Kuster",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/i/eiu7unlwndm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 70,
      "control": 71,
      "pressure": 55,
      "agility": 60,
      "physical": 54,
      "technique": 55
    }
  },
  {
    "id": 2012,
    "name": "Jonas Polk",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/k/vkfa5ytkguk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 67,
      "control": 62,
      "pressure": 46,
      "agility": 41,
      "physical": 57,
      "technique": 67
    }
  },
  {
    "id": 2013,
    "name": "Maximilian Müller",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/i/biexjzkdbce.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 47,
      "control": 43,
      "pressure": 59,
      "agility": 64,
      "physical": 43,
      "technique": 57
    }
  },
  {
    "id": 2014,
    "name": "Peter Naumann",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/k/wk12omc5sxs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 41,
      "control": 44,
      "pressure": 48,
      "agility": 73,
      "physical": 47,
      "technique": 53
    }
  },
  {
    "id": 2015,
    "name": "Gerhard Enders",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/l/qlwddr3xzrc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 49,
      "control": 46,
      "pressure": 62,
      "agility": 54,
      "physical": 59,
      "technique": 46
    }
  },
  {
    "id": 2016,
    "name": "Erwin Völz",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/n/hnniwurl0i0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 42,
      "control": 60,
      "pressure": 42,
      "agility": 67,
      "physical": 44,
      "technique": 68
    }
  },
  {
    "id": 2017,
    "name": "Jens Hoffman",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/s/jsg-e3dnxk0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 51,
      "control": 59,
      "pressure": 59,
      "agility": 60,
      "physical": 49,
      "technique": 67
    }
  },
  {
    "id": 2018,
    "name": "Ernst Fliedner",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/e/serfzildcxc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 70,
      "control": 63,
      "pressure": 56,
      "agility": 52,
      "physical": 54,
      "technique": 71
    }
  },
  {
    "id": 2019,
    "name": "Emmanuel Ewerz",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/r/yryqgvqvp3s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 42,
      "control": 42,
      "pressure": 55,
      "agility": 50,
      "physical": 67,
      "technique": 45
    }
  },
  {
    "id": 2020,
    "name": "Zolani Baloi",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/s/fsjyqshouem.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 52,
      "control": 55,
      "pressure": 58,
      "agility": 48,
      "physical": 56,
      "technique": 49
    }
  },
  {
    "id": 2021,
    "name": "Dakarai Furman",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/d/_dqt5xygh-8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 52,
      "control": 58,
      "pressure": 72,
      "agility": 43,
      "physical": 64,
      "technique": 52
    }
  },
  {
    "id": 2022,
    "name": "Jake Fana",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/r/orbmuou8mnu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 58,
      "control": 44,
      "pressure": 53,
      "agility": 43,
      "physical": 53,
      "technique": 55
    }
  },
  {
    "id": 2023,
    "name": "Masego Molelo",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/k/mkcq6xgqjlu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 60,
      "control": 60,
      "pressure": 58,
      "agility": 40,
      "physical": 62,
      "technique": 44
    }
  },
  {
    "id": 2024,
    "name": "Cassius Tobler",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/i/9itxxogqk48.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 42,
      "control": 59,
      "pressure": 68,
      "agility": 44,
      "physical": 64,
      "technique": 42
    }
  },
  {
    "id": 2025,
    "name": "Anton Nortje",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/n/dnoee1virym.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 52,
      "control": 72,
      "pressure": 59,
      "agility": 49,
      "physical": 54,
      "technique": 62
    }
  },
  {
    "id": 2026,
    "name": "Adam Marunga",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/l/sl_lpkzy8rk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 67,
      "control": 79,
      "pressure": 47,
      "agility": 59,
      "physical": 60,
      "technique": 60
    }
  },
  {
    "id": 2027,
    "name": "Reggie Ines",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/p/ypa9yhw6bum.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 63,
      "control": 70,
      "pressure": 58,
      "agility": 55,
      "physical": 40,
      "technique": 56
    }
  },
  {
    "id": 2028,
    "name": "Siyabonga Mahlangu",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/n/pnxc14wa2nk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 53,
      "control": 66,
      "pressure": 47,
      "agility": 46,
      "physical": 45,
      "technique": 63
    }
  },
  {
    "id": 2029,
    "name": "Nathan Tswane",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/p/hpqrv5fjxle.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 47,
      "control": 48,
      "pressure": 60,
      "agility": 64,
      "physical": 47,
      "technique": 64
    }
  },
  {
    "id": 2030,
    "name": "Melisizwe Zamani",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/n/2nbwcg5z64s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 40,
      "control": 54,
      "pressure": 43,
      "agility": 62,
      "physical": 44,
      "technique": 57
    }
  },
  {
    "id": 2031,
    "name": "Herschel De Villiers",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/i/wi4frbm7pyc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 45,
      "control": 46,
      "pressure": 47,
      "agility": 76,
      "physical": 59,
      "technique": 62
    }
  },
  {
    "id": 2032,
    "name": "Moeneeb Booysen",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/g/ngjk8kqbir0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 51,
      "control": 58,
      "pressure": 74,
      "agility": 49,
      "physical": 63,
      "technique": 50
    }
  },
  {
    "id": 2033,
    "name": "Kennedy McCarthy",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/b/lbo4s94tnt0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 53,
      "control": 54,
      "pressure": 67,
      "agility": 59,
      "physical": 61,
      "technique": 49
    }
  },
  {
    "id": 2034,
    "name": "Hugh Makebe",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/p/up_z_cexkec.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 51,
      "control": 48,
      "pressure": 60,
      "agility": 54,
      "physical": 72,
      "technique": 50
    }
  },
  {
    "id": 2035,
    "name": "Themba Sepeng",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/g/0gcssfrf_-s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 68,
      "control": 71,
      "pressure": 48,
      "agility": 53,
      "physical": 42,
      "technique": 68
    }
  },
  {
    "id": 2036,
    "name": "Anorel",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/c/cc42wd5uk_s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 54,
      "control": 56,
      "pressure": 60,
      "agility": 42,
      "physical": 74,
      "technique": 53
    }
  },
  {
    "id": 2037,
    "name": "Nenel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/z/8zbdfamc_fc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 43,
      "control": 55,
      "pressure": 75,
      "agility": 51,
      "physical": 72,
      "technique": 55
    }
  },
  {
    "id": 2038,
    "name": "Genel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/b/nbqio_qmss0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 49,
      "control": 60,
      "pressure": 56,
      "agility": 51,
      "physical": 77,
      "technique": 49
    }
  },
  {
    "id": 2039,
    "name": "Ekadel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/6/p6t-gm4kxq0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 46,
      "control": 43,
      "pressure": 59,
      "agility": 60,
      "physical": 74,
      "technique": 41
    }
  },
  {
    "id": 2040,
    "name": "Lephiel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/s/-scfrzew6zc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 56,
      "control": 50,
      "pressure": 79,
      "agility": 49,
      "physical": 71,
      "technique": 58
    }
  },
  {
    "id": 2041,
    "name": "Sachinel",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/9/e9_q4er4p5s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 64,
      "control": 71,
      "pressure": 58,
      "agility": 58,
      "physical": 56,
      "technique": 50
    }
  },
  {
    "id": 2042,
    "name": "Wenel",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/v/vvolv7ncike.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 53,
      "control": 73,
      "pressure": 51,
      "agility": 42,
      "physical": 54,
      "technique": 58
    }
  },
  {
    "id": 2043,
    "name": "Ientel",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/_/b_xtk2ogf1s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 69,
      "control": 77,
      "pressure": 42,
      "agility": 59,
      "physical": 50,
      "technique": 52
    }
  },
  {
    "id": 2044,
    "name": "Nuel",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/x/qxayjjoaoge.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 68,
      "control": 75,
      "pressure": 42,
      "agility": 48,
      "physical": 48,
      "technique": 64
    }
  },
  {
    "id": 2045,
    "name": "Gaiel",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/_/e_b_tihtjqk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 51,
      "control": 47,
      "pressure": 51,
      "agility": 61,
      "physical": 41,
      "technique": 74
    }
  },
  {
    "id": 2046,
    "name": "Sanctus",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/x/1xqe-3hpkzm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 60,
      "control": 43,
      "pressure": 51,
      "agility": 77,
      "physical": 55,
      "technique": 63
    }
  },
  {
    "id": 2047,
    "name": "Astaroth",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/c/8cswivaougk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 56,
      "control": 57,
      "pressure": 76,
      "agility": 46,
      "physical": 72,
      "technique": 48
    }
  },
  {
    "id": 2048,
    "name": "Bael",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/z/czpfxivghmu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 49,
      "control": 46,
      "pressure": 65,
      "agility": 42,
      "physical": 65,
      "technique": 53
    }
  },
  {
    "id": 2049,
    "name": "Abigor",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/b/tb-kc3jamv8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 56,
      "control": 40,
      "pressure": 58,
      "agility": 42,
      "physical": 72,
      "technique": 45
    }
  },
  {
    "id": 2050,
    "name": "Behemoth",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/6/v654yub2jt8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 56,
      "control": 54,
      "pressure": 66,
      "agility": 43,
      "physical": 69,
      "technique": 58
    }
  },
  {
    "id": 2051,
    "name": "Belial",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/s/esizfr9mkgu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 44,
      "control": 53,
      "pressure": 72,
      "agility": 47,
      "physical": 63,
      "technique": 41
    }
  },
  {
    "id": 2052,
    "name": "Malphas",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/9/-9rsmmierak.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 72,
      "control": 61,
      "pressure": 58,
      "agility": 51,
      "physical": 45,
      "technique": 63
    }
  },
  {
    "id": 2053,
    "name": "Glasya",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/v/pvanhzu-8zm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 73,
      "control": 65,
      "pressure": 40,
      "agility": 45,
      "physical": 49,
      "technique": 67
    }
  },
  {
    "id": 2054,
    "name": "Jezebeth",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/_/7_lvq-tcbmk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 64,
      "control": 60,
      "pressure": 50,
      "agility": 43,
      "physical": 48,
      "technique": 67
    }
  },
  {
    "id": 2055,
    "name": "Arachne",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/x/kxu09blm2_m.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 53,
      "control": 55,
      "pressure": 58,
      "agility": 44,
      "physical": 44,
      "technique": 67
    }
  },
  {
    "id": 2056,
    "name": "Thanatos",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/_/k_p5nacvxts.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 48,
      "control": 58,
      "pressure": 49,
      "agility": 69,
      "physical": 59,
      "technique": 65
    }
  },
  {
    "id": 2057,
    "name": "Destra",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/x/vx-yk_kv6ge.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 47,
      "control": 51,
      "pressure": 56,
      "agility": 61,
      "physical": 40,
      "technique": 54
    }
  },
  {
    "id": 2069,
    "name": "Lars Luceafăr",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/6/n6eeto9n0hc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 46,
      "control": 55,
      "pressure": 59,
      "agility": 56,
      "physical": 65,
      "technique": 46
    }
  },
  {
    "id": 2070,
    "name": "Lump Trungus",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/v/tvnxa1ifbbs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 30,
      "intelligence": 41,
      "control": 45,
      "pressure": 64,
      "agility": 52,
      "physical": 79,
      "technique": 57
    }
  },
  {
    "id": 2071,
    "name": "Bump Trungus",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/9/c9wqtku_sye.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 51,
      "control": 59,
      "pressure": 67,
      "agility": 60,
      "physical": 54,
      "technique": 44
    }
  },
  {
    "id": 2072,
    "name": "Oni Triumvir",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/c/ecrmdt8tp0e.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 68,
      "control": 77,
      "pressure": 57,
      "agility": 49,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 2073,
    "name": "Drachen Gunther",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/0/v0gtusapehs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 76,
      "control": 68,
      "pressure": 55,
      "agility": 58,
      "physical": 46,
      "technique": 58
    }
  },
  {
    "id": 2074,
    "name": "Mystral Callous",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/b/pbdy9xvhxnc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 53,
      "control": 52,
      "pressure": 51,
      "agility": 53,
      "physical": 42,
      "technique": 50
    }
  },
  {
    "id": 2075,
    "name": "Radd Ischer",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/z/-zy5qojbcu0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 47,
      "control": 42,
      "pressure": 71,
      "agility": 56,
      "physical": 71,
      "technique": 50
    }
  },
  {
    "id": 2076,
    "name": "Escavan Malice",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/v/fvg6uqiv3yk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 58,
      "control": 47,
      "pressure": 58,
      "agility": 56,
      "physical": 44,
      "technique": 64
    }
  },
  {
    "id": 2077,
    "name": "Bash Lancer",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/x/7x8am8sdwy0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 44,
      "control": 45,
      "pressure": 42,
      "agility": 71,
      "physical": 41,
      "technique": 46
    }
  },
  {
    "id": 2078,
    "name": "Ichabod Stark",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/z/vznnw9lk30u.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 72,
      "control": 59,
      "pressure": 59,
      "agility": 45,
      "physical": 52,
      "technique": 58
    }
  },
  {
    "id": 2079,
    "name": "Jynx Jenkins",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/x/kxws7cdwah8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 54,
      "control": 44,
      "pressure": 56,
      "agility": 51,
      "physical": 60,
      "technique": 55
    }
  },
  {
    "id": 2080,
    "name": "Canon Evans",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/n/rnp03-pv5dc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 51,
      "control": 48,
      "pressure": 53,
      "agility": 60,
      "physical": 44,
      "technique": 54
    }
  },
  {
    "id": 2083,
    "name": "Lucia",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/d/kdbju-9yebm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 41,
      "control": 46,
      "pressure": 43,
      "agility": 59,
      "physical": 43,
      "technique": 49
    }
  },
  {
    "id": 2085,
    "name": "Percy Verens",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/z/8zj9wduxzcc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 59,
      "control": 47,
      "pressure": 51,
      "agility": 63,
      "physical": 58,
      "technique": 59
    }
  },
  {
    "id": 2086,
    "name": "Bishop Carver",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/c/ccaijeh5s8s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 26,
      "intelligence": 40,
      "control": 45,
      "pressure": 63,
      "agility": 41,
      "physical": 61,
      "technique": 55
    }
  },
  {
    "id": 2087,
    "name": "Skyler Styler",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/0/t0xpohhdbpe.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 67,
      "control": 71,
      "pressure": 56,
      "agility": 55,
      "physical": 60,
      "technique": 62
    }
  },
  {
    "id": 2088,
    "name": "Balen Straw",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/v/vv21g4vveje.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 48,
      "control": 44,
      "pressure": 80,
      "agility": 54,
      "physical": 60,
      "technique": 41
    }
  },
  {
    "id": 2089,
    "name": "Malachi Way",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/9/e9hunhzvp6s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 60,
      "control": 54,
      "pressure": 64,
      "agility": 57,
      "physical": 55,
      "technique": 46
    }
  },
  {
    "id": 2090,
    "name": "Paul Kerface",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/s/-skheagdcac.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 55,
      "control": 48,
      "pressure": 52,
      "agility": 60,
      "physical": 63,
      "technique": 56
    }
  },
  {
    "id": 2091,
    "name": "Chip Tatum",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/6/p6vazlgnxp0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 64,
      "control": 65,
      "pressure": 43,
      "agility": 60,
      "physical": 47,
      "technique": 71
    }
  },
  {
    "id": 2092,
    "name": "Rebus Stumper",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/q/7qqycojfwwc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 70,
      "control": 65,
      "pressure": 45,
      "agility": 46,
      "physical": 57,
      "technique": 72
    }
  },
  {
    "id": 2093,
    "name": "Cutter Shorten",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/4/k4b5vxf_7l0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 59,
      "control": 51,
      "pressure": 61,
      "agility": 52,
      "physical": 61,
      "technique": 42
    }
  },
  {
    "id": 2094,
    "name": "Manny Pickles",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/q/kqa01wm2aju.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 60,
      "control": 42,
      "pressure": 68,
      "agility": 42,
      "physical": 64,
      "technique": 56
    }
  },
  {
    "id": 2095,
    "name": "Campen Allerjee",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/4/v4xvypqm368.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 50,
      "control": 41,
      "pressure": 41,
      "agility": 78,
      "physical": 57,
      "technique": 57
    }
  },
  {
    "id": 2096,
    "name": "Climie Hills",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/x/1xsgl0fecam.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 47,
      "control": 40,
      "pressure": 78,
      "agility": 45,
      "physical": 59,
      "technique": 49
    }
  },
  {
    "id": 2097,
    "name": "Earl Bird",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/_/e_jbml5-vpk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 57,
      "control": 50,
      "pressure": 56,
      "agility": 45,
      "physical": 65,
      "technique": 44
    }
  },
  {
    "id": 2098,
    "name": "Walt Whittler",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/e/gekdisrsqvk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 58,
      "control": 44,
      "pressure": 69,
      "agility": 44,
      "physical": 75,
      "technique": 60
    }
  },
  {
    "id": 2099,
    "name": "Merry Piper",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/2/32v8ltnohcm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 53,
      "control": 49,
      "pressure": 60,
      "agility": 68,
      "physical": 42,
      "technique": 59
    }
  },
  {
    "id": 2100,
    "name": "Traylor Beadle",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/z/xz2j2w4gy88.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 66,
      "control": 53,
      "pressure": 52,
      "agility": 47,
      "physical": 51,
      "technique": 69
    }
  },
  {
    "id": 2101,
    "name": "Doug Boateng",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/x/mxhobpeafpu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 54,
      "control": 55,
      "pressure": 47,
      "agility": 70,
      "physical": 45,
      "technique": 48
    }
  },
  {
    "id": 2102,
    "name": "Fanny Oakley",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/z/cz37el3nhlu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 49,
      "control": 53,
      "pressure": 59,
      "agility": 74,
      "physical": 40,
      "technique": 63
    }
  },
  {
    "id": 2103,
    "name": "Bucky Colt",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/c/8cuoxwcfyfk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 55,
      "control": 43,
      "pressure": 60,
      "agility": 65,
      "physical": 52,
      "technique": 55
    }
  },
  {
    "id": 2104,
    "name": "Chuckie Roper",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/0/n0lv6pk_f2m.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 66,
      "control": 71,
      "pressure": 53,
      "agility": 52,
      "physical": 51,
      "technique": 58
    }
  },
  {
    "id": 2105,
    "name": "Lucien Brightside",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/v/pvizuw2tawm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 53,
      "control": 56,
      "pressure": 70,
      "agility": 43,
      "physical": 65,
      "technique": 46
    }
  },
  {
    "id": 2106,
    "name": "Caffrey Punt",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/9/-9ts5pqp3dk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 30,
      "intelligence": 44,
      "control": 58,
      "pressure": 63,
      "agility": 43,
      "physical": 68,
      "technique": 40
    }
  },
  {
    "id": 2107,
    "name": "Debra Lee",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/s/eswnqslhcju.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 48,
      "control": 48,
      "pressure": 47,
      "agility": 64,
      "physical": 43,
      "technique": 72
    }
  },
  {
    "id": 2108,
    "name": "Goodie Touchouse",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/6/v6bghtdbvq8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 51,
      "control": 41,
      "pressure": 62,
      "agility": 59,
      "physical": 72,
      "technique": 57
    }
  },
  {
    "id": 2109,
    "name": "Ray Pier",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/q/bq-e2ga5ivu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 82,
      "intelligence": 43,
      "control": 49,
      "pressure": 45,
      "agility": 51,
      "physical": 52,
      "technique": 54
    }
  },
  {
    "id": 2110,
    "name": "Jen Erris",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/4/q4p_bfmdlc8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 50,
      "control": 60,
      "pressure": 73,
      "agility": 46,
      "physical": 62,
      "technique": 59
    }
  },
  {
    "id": 2111,
    "name": "Jude Ellery",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/q/equybevkewc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 77,
      "control": 71,
      "pressure": 52,
      "agility": 43,
      "physical": 59,
      "technique": 53
    }
  },
  {
    "id": 2112,
    "name": "Seamus Rock",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/4/14ltshjwpd0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 52,
      "control": 49,
      "pressure": 56,
      "agility": 48,
      "physical": 67,
      "technique": 49
    }
  },
  {
    "id": 2113,
    "name": "Tim Roubadour",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/x/vxgm_884cje.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 51,
      "control": 66,
      "pressure": 52,
      "agility": 45,
      "physical": 43,
      "technique": 54
    }
  },
  {
    "id": 2114,
    "name": "Matt Skerade",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/_/k_3hsdacxqs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 60,
      "control": 55,
      "pressure": 62,
      "agility": 56,
      "physical": 50,
      "technique": 60
    }
  },
  {
    "id": 2115,
    "name": "Florence Tripps",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/e/mewb8aiu0ws.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 46,
      "control": 51,
      "pressure": 62,
      "agility": 50,
      "physical": 78,
      "technique": 60
    }
  },
  {
    "id": 2116,
    "name": "Inke Marks",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/2/x2b6rluuzle.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 48,
      "control": 48,
      "pressure": 78,
      "agility": 58,
      "physical": 65,
      "technique": 49
    }
  },
  {
    "id": 2117,
    "name": "Gary Baldi",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/z/3zipc4bcsf0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 51,
      "control": 52,
      "pressure": 64,
      "agility": 60,
      "physical": 70,
      "technique": 44
    }
  },
  {
    "id": 2118,
    "name": "Bobby Peeler",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/x/gxtuvh9mb2c.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 75,
      "control": 63,
      "pressure": 58,
      "agility": 47,
      "physical": 50,
      "technique": 64
    }
  },
  {
    "id": 2119,
    "name": "Mark Brand",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/b/ybs2ek-emj0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 83,
      "intelligence": 60,
      "control": 53,
      "pressure": 48,
      "agility": 56,
      "physical": 53,
      "technique": 58
    }
  },
  {
    "id": 2120,
    "name": "Hedwig Hodge",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/z/dzdxz1y-l6c.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 57,
      "control": 56,
      "pressure": 64,
      "agility": 48,
      "physical": 54,
      "technique": 43
    }
  },
  {
    "id": 2121,
    "name": "Bill Mallard",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/n/_nlgqwr0kps.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 53,
      "control": 57,
      "pressure": 69,
      "agility": 60,
      "physical": 65,
      "technique": 60
    }
  },
  {
    "id": 2122,
    "name": "Roo Hopper",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/l/ol6n9pnonae.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 55,
      "control": 41,
      "pressure": 67,
      "agility": 45,
      "physical": 61,
      "technique": 42
    }
  },
  {
    "id": 2123,
    "name": "Cole Bear",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/k/ukzsus4gs60.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 67,
      "control": 63,
      "pressure": 42,
      "agility": 41,
      "physical": 44,
      "technique": 59
    }
  },
  {
    "id": 2124,
    "name": "Al Opino",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/i/fiozdte8_jc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 40,
      "control": 52,
      "pressure": 71,
      "agility": 53,
      "physical": 76,
      "technique": 48
    }
  },
  {
    "id": 2125,
    "name": "Oz Tier",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/d/ddvvt0mq6pc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 51,
      "control": 59,
      "pressure": 77,
      "agility": 55,
      "physical": 70,
      "technique": 57
    }
  },
  {
    "id": 2126,
    "name": "Shelley Wordsworth",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/r/sreoalqqx80.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 83,
      "intelligence": 44,
      "control": 49,
      "pressure": 57,
      "agility": 67,
      "physical": 50,
      "technique": 53
    }
  },
  {
    "id": 2127,
    "name": "Stu Potter",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/e/me97twfiice.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 44,
      "control": 51,
      "pressure": 65,
      "agility": 45,
      "physical": 76,
      "technique": 41
    }
  },
  {
    "id": 2128,
    "name": "Bern Ballast",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/s/9sma-p5ypvs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 48,
      "control": 50,
      "pressure": 61,
      "agility": 42,
      "physical": 80,
      "technique": 56
    }
  },
  {
    "id": 2129,
    "name": "Heidi Rood",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/g/jgzcpk66oqe.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 40,
      "control": 46,
      "pressure": 57,
      "agility": 57,
      "physical": 69,
      "technique": 56
    }
  },
  {
    "id": 2130,
    "name": "Elvis Schumacher",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/u/4ucjibcafjs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 69,
      "control": 64,
      "pressure": 47,
      "agility": 52,
      "physical": 44,
      "technique": 69
    }
  },
  {
    "id": 2131,
    "name": "Snezhana White",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/g/wgzu4avjkpm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 44,
      "control": 60,
      "pressure": 55,
      "agility": 72,
      "physical": 42,
      "technique": 52
    }
  },
  {
    "id": 2132,
    "name": "Abel Forager",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/u/nuopvlzzj8k.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 46,
      "control": 42,
      "pressure": 72,
      "agility": 50,
      "physical": 69,
      "technique": 55
    }
  },
  {
    "id": 2133,
    "name": "Will Wary",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/b/hbl6g4g78cu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 42,
      "control": 60,
      "pressure": 56,
      "agility": 50,
      "physical": 66,
      "technique": 50
    }
  },
  {
    "id": 2134,
    "name": "Rocco Shale",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/p/2p6brhgbrv8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 66,
      "control": 55,
      "pressure": 55,
      "agility": 49,
      "physical": 49,
      "technique": 68
    }
  },
  {
    "id": 2135,
    "name": "Bob Jobbe",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/i/0i9hfeytup8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 44,
      "control": 40,
      "pressure": 47,
      "agility": 60,
      "physical": 58,
      "technique": 61
    }
  },
  {
    "id": 2136,
    "name": "Lee Bei",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/g/fgmmohux5au.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 46,
      "control": 47,
      "pressure": 54,
      "agility": 43,
      "physical": 73,
      "technique": 49
    }
  },
  {
    "id": 2137,
    "name": "Quincy Wang",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/p/lpvt78hfm6k.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 47,
      "control": 45,
      "pressure": 56,
      "agility": 72,
      "physical": 57,
      "technique": 74
    }
  },
  {
    "id": 2138,
    "name": "Dan Fei",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/n/uneywdhlhjm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 47,
      "control": 52,
      "pressure": 49,
      "agility": 62,
      "physical": 56,
      "technique": 52
    }
  },
  {
    "id": 2139,
    "name": "Liddy Gan",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/n/gnhqnoehg2k.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 55,
      "control": 55,
      "pressure": 61,
      "agility": 50,
      "physical": 77,
      "technique": 53
    }
  },
  {
    "id": 2140,
    "name": "Tom Bulldown",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/l/rlqlkxi9rfm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 60,
      "control": 64,
      "pressure": 48,
      "agility": 45,
      "physical": 40,
      "technique": 59
    }
  },
  {
    "id": 2141,
    "name": "Ria Vivalist",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/n/fnfak4iiuqk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 56,
      "control": 60,
      "pressure": 51,
      "agility": 70,
      "physical": 56,
      "technique": 54
    }
  },
  {
    "id": 2142,
    "name": "Sunniffa Scentgood",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/l/uluhjhuy5jm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 42,
      "control": 60,
      "pressure": 50,
      "agility": 72,
      "physical": 51,
      "technique": 53
    }
  },
  {
    "id": 2143,
    "name": "Julia Mason",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/k/oknuaab6md8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 52,
      "control": 59,
      "pressure": 55,
      "agility": 40,
      "physical": 64,
      "technique": 44
    }
  },
  {
    "id": 2144,
    "name": "Ria Carnival",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/i/_i813l9ahwu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 30,
      "intelligence": 54,
      "control": 42,
      "pressure": 63,
      "agility": 51,
      "physical": 69,
      "technique": 40
    }
  },
  {
    "id": 2145,
    "name": "Gracey Grapples",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/d/9d7pz8vsk2u.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 53,
      "control": 43,
      "pressure": 60,
      "agility": 55,
      "physical": 54,
      "technique": 51
    }
  },
  {
    "id": 2146,
    "name": "Shep Woolacombe",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/r/mrki0djwjf8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 47,
      "control": 44,
      "pressure": 60,
      "agility": 63,
      "physical": 51,
      "technique": 62
    }
  },
  {
    "id": 2147,
    "name": "Sue Accharin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/e/sep9ne8e8lm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 45,
      "control": 47,
      "pressure": 62,
      "agility": 48,
      "physical": 64,
      "technique": 56
    }
  },
  {
    "id": 2148,
    "name": "Venus Demila",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/s/dsyckhakrwk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 45,
      "control": 45,
      "pressure": 60,
      "agility": 55,
      "physical": 54,
      "technique": 44
    }
  },
  {
    "id": 2149,
    "name": "Steven Nevets",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/g/pgne7szg2pm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 53,
      "control": 45,
      "pressure": 62,
      "agility": 56,
      "physical": 61,
      "technique": 58
    }
  },
  {
    "id": 2150,
    "name": "Gerald Gerund",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/u/yuwlwt_8bak.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 60,
      "control": 49,
      "pressure": 66,
      "agility": 49,
      "physical": 72,
      "technique": 56
    }
  },
  {
    "id": 2151,
    "name": "Tracy Tracker",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/g/2gnoms2162e.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 46,
      "control": 52,
      "pressure": 80,
      "agility": 48,
      "physical": 72,
      "technique": 55
    }
  },
  {
    "id": 2152,
    "name": "Bernadette Stoker",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/u/hu8jhtqpxfs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 45,
      "control": 55,
      "pressure": 51,
      "agility": 63,
      "physical": 49,
      "technique": 66
    }
  },
  {
    "id": 2153,
    "name": "Keshia Readingplace",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/b/nbf8ywlhilc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 73,
      "control": 72,
      "pressure": 44,
      "agility": 51,
      "physical": 40,
      "technique": 68
    }
  },
  {
    "id": 2154,
    "name": "Sahara Kalahari",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/p/wpudfpd9pw0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 47,
      "control": 44,
      "pressure": 73,
      "agility": 55,
      "physical": 74,
      "technique": 50
    }
  },
  {
    "id": 2155,
    "name": "Fala Polaris",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/i/uipbxwrrkq0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 40,
      "control": 58,
      "pressure": 59,
      "agility": 45,
      "physical": 59,
      "technique": 54
    }
  },
  {
    "id": 2156,
    "name": "Ian Flappable",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/g/lgygcp3rnjc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 59,
      "control": 46,
      "pressure": 60,
      "agility": 70,
      "physical": 44,
      "technique": 68
    }
  },
  {
    "id": 2157,
    "name": "Penny Linguine",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/p/fp7vp0cjsds.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 56,
      "control": 62,
      "pressure": 49,
      "agility": 51,
      "physical": 60,
      "technique": 63
    }
  },
  {
    "id": 2158,
    "name": "Poppy Playhard",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/n/0nk0ilkz_we.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 42,
      "control": 57,
      "pressure": 60,
      "agility": 57,
      "physical": 62,
      "technique": 60
    }
  },
  {
    "id": 2159,
    "name": "Connie Fuchsia",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/n/an1stgn7yps.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 41,
      "control": 53,
      "pressure": 65,
      "agility": 42,
      "physical": 57,
      "technique": 45
    }
  },
  {
    "id": 2160,
    "name": "Baron Blackgold",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/l/xlen-5bb18e.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 66,
      "control": 67,
      "pressure": 60,
      "agility": 45,
      "physical": 42,
      "technique": 49
    }
  },
  {
    "id": 2161,
    "name": "Marty Oshker",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/h/bhr_i5fzlxm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 45,
      "control": 50,
      "pressure": 69,
      "agility": 56,
      "physical": 62,
      "technique": 43
    }
  },
  {
    "id": 2162,
    "name": "Nat Meg",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/j/qjgepg5jmkk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 73,
      "control": 68,
      "pressure": 53,
      "agility": 40,
      "physical": 44,
      "technique": 62
    }
  },
  {
    "id": 2163,
    "name": "Eddy Steady",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/m/kmdrcbmbteu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 48,
      "control": 59,
      "pressure": 47,
      "agility": 65,
      "physical": 46,
      "technique": 61
    }
  },
  {
    "id": 2164,
    "name": "Severin Volei",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/o/7oykxkq7-38.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 53,
      "control": 52,
      "pressure": 43,
      "agility": 55,
      "physical": 42,
      "technique": 53
    }
  },
  {
    "id": 2165,
    "name": "Brava Hardy",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/v/5v1wf94x7x8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 58,
      "control": 52,
      "pressure": 49,
      "agility": 76,
      "physical": 58,
      "technique": 61
    }
  },
  {
    "id": 2166,
    "name": "Helmut Hoarder",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/h/ihe3ycetwcu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 49,
      "control": 54,
      "pressure": 41,
      "agility": 51,
      "physical": 51,
      "technique": 69
    }
  },
  {
    "id": 2167,
    "name": "Strama daKoto",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/o/oonchfrljik.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 40,
      "control": 41,
      "pressure": 46,
      "agility": 64,
      "physical": 59,
      "technique": 70
    }
  },
  {
    "id": 2168,
    "name": "Olaf Nobeard",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/a/zawjmgnform.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 43,
      "control": 51,
      "pressure": 53,
      "agility": 40,
      "physical": 59,
      "technique": 60
    }
  },
  {
    "id": 2169,
    "name": "Gudrun Lodestone",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/q/tqp79to9puk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 52,
      "control": 53,
      "pressure": 44,
      "agility": 75,
      "physical": 53,
      "technique": 75
    }
  },
  {
    "id": 2170,
    "name": "Carol Fairfoot",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/c/ccyaqsohedm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 59,
      "control": 58,
      "pressure": 43,
      "agility": 71,
      "physical": 49,
      "technique": 52
    }
  },
  {
    "id": 2171,
    "name": "Michael Shako",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/q/yqdxktholxs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 53,
      "control": 48,
      "pressure": 69,
      "agility": 41,
      "physical": 58,
      "technique": 53
    }
  },
  {
    "id": 2172,
    "name": "Direm Ederi",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/c/dcy2nsh0ice.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 49,
      "control": 44,
      "pressure": 46,
      "agility": 72,
      "physical": 58,
      "technique": 65
    }
  },
  {
    "id": 2173,
    "name": "Marina Coaster",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/t/jtrd0xy89i0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 40,
      "control": 55,
      "pressure": 60,
      "agility": 66,
      "physical": 57,
      "technique": 58
    }
  },
  {
    "id": 2174,
    "name": "Wowzer Bigtop",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/f/sfgizougqrc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 60,
      "control": 42,
      "pressure": 58,
      "agility": 52,
      "physical": 60,
      "technique": 54
    }
  },
  {
    "id": 2175,
    "name": "Derry Farmer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/k/qkn-3xgqvxc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 56,
      "control": 52,
      "pressure": 54,
      "agility": 47,
      "physical": 50,
      "technique": 63
    }
  },
  {
    "id": 2176,
    "name": "Devlin Ogor",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/m/hmwfaogq4k0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 45,
      "control": 57,
      "pressure": 65,
      "agility": 49,
      "physical": 56,
      "technique": 42
    }
  },
  {
    "id": 2177,
    "name": "Fez Monkton",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/j/bj1qj1vynee.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 45,
      "control": 50,
      "pressure": 56,
      "agility": 61,
      "physical": 46,
      "technique": 53
    }
  },
  {
    "id": 2178,
    "name": "Berthel Stagg",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/l/wlelkkzig3s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 49,
      "control": 47,
      "pressure": 60,
      "agility": 41,
      "physical": 63,
      "technique": 45
    }
  },
  {
    "id": 2179,
    "name": "Damon Sumner",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/h/eh7tvhwahie.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 58,
      "control": 50,
      "pressure": 41,
      "agility": 80,
      "physical": 41,
      "technique": 53
    }
  },
  {
    "id": 2180,
    "name": "Anders Thettock",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/j/1jky44w6q7s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 47,
      "control": 58,
      "pressure": 58,
      "agility": 58,
      "physical": 42,
      "technique": 69
    }
  },
  {
    "id": 2181,
    "name": "Laititia Cheeseman",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/m/dm_5uzk5dem.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 52,
      "control": 58,
      "pressure": 40,
      "agility": 48,
      "physical": 44,
      "technique": 54
    }
  },
  {
    "id": 2182,
    "name": "Isodoura Bouquet",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/k/skoydmcdwtk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 49,
      "control": 42,
      "pressure": 74,
      "agility": 46,
      "physical": 53,
      "technique": 60
    }
  },
  {
    "id": 2183,
    "name": "May Jarrett",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/l/mlttqr3lfnu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 43,
      "control": 47,
      "pressure": 48,
      "agility": 59,
      "physical": 48,
      "technique": 53
    }
  },
  {
    "id": 2184,
    "name": "Des Einer",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/j/9jcm9urxo-8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 81,
      "intelligence": 53,
      "control": 42,
      "pressure": 58,
      "agility": 54,
      "physical": 44,
      "technique": 58
    }
  },
  {
    "id": 2185,
    "name": "Kev Fiyah",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/c/_cbqt3ddt48.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 52,
      "control": 52,
      "pressure": 61,
      "agility": 53,
      "physical": 73,
      "technique": 53
    }
  },
  {
    "id": 2186,
    "name": "Shadi Mesmer",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/q/oqqx-ilnalu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 42,
      "control": 59,
      "pressure": 67,
      "agility": 49,
      "physical": 67,
      "technique": 46
    }
  },
  {
    "id": 2187,
    "name": "Preston Digitator",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/f/ufjetvqv1rk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 47,
      "control": 44,
      "pressure": 69,
      "agility": 42,
      "physical": 77,
      "technique": 57
    }
  },
  {
    "id": 2188,
    "name": "Roman Fawkes",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/t/ft4laq2vyym.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 54,
      "control": 53,
      "pressure": 66,
      "agility": 51,
      "physical": 76,
      "technique": 57
    }
  },
  {
    "id": 2189,
    "name": "Morty Portland",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/h/rhh9xn13_nk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 74,
      "control": 59,
      "pressure": 49,
      "agility": 51,
      "physical": 59,
      "technique": 66
    }
  },
  {
    "id": 2190,
    "name": "Fabrice Pesci",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/v/av2ccytnsum.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 42,
      "control": 43,
      "pressure": 64,
      "agility": 46,
      "physical": 65,
      "technique": 55
    }
  },
  {
    "id": 2191,
    "name": "Boo Spector",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/h/0htrgzaez4s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 58,
      "control": 47,
      "pressure": 69,
      "agility": 54,
      "physical": 68,
      "technique": 44
    }
  },
  {
    "id": 2192,
    "name": "Cole Tivator",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/v/fvcwrm8-ele.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 54,
      "control": 60,
      "pressure": 65,
      "agility": 54,
      "physical": 62,
      "technique": 58
    }
  },
  {
    "id": 2193,
    "name": "Blagun White",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/a/la_f47j2rr0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 68,
      "control": 72,
      "pressure": 54,
      "agility": 57,
      "physical": 49,
      "technique": 55
    }
  },
  {
    "id": 2194,
    "name": "Jeanie Tanner",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/o/uookvevmgyc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 56,
      "control": 65,
      "pressure": 42,
      "agility": 41,
      "physical": 41,
      "technique": 50
    }
  },
  {
    "id": 2195,
    "name": "Monty Tasker",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/j/wjj47d9gdec.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 43,
      "control": 45,
      "pressure": 63,
      "agility": 41,
      "physical": 63,
      "technique": 42
    }
  },
  {
    "id": 2196,
    "name": "Artie Xan",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/h/nh4zwibaut0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 69,
      "control": 53,
      "pressure": 51,
      "agility": 58,
      "physical": 51,
      "technique": 57
    }
  },
  {
    "id": 2197,
    "name": "Genghis Cohen",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/o/hobsf_usbne.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 56,
      "control": 77,
      "pressure": 55,
      "agility": 48,
      "physical": 45,
      "technique": 61
    }
  },
  {
    "id": 2198,
    "name": "Adam Venturus",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/m/2mqnoaio2-s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 47,
      "control": 49,
      "pressure": 59,
      "agility": 63,
      "physical": 52,
      "technique": 55
    }
  },
  {
    "id": 2199,
    "name": "Zahida Zahid",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/m/cmvvznlkrbe.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 59,
      "control": 49,
      "pressure": 42,
      "agility": 70,
      "physical": 58,
      "technique": 64
    }
  },
  {
    "id": 2200,
    "name": "Zowie Trope",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/k/zkk00ytw8ys.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 56,
      "control": 67,
      "pressure": 59,
      "agility": 45,
      "physical": 44,
      "technique": 55
    }
  },
  {
    "id": 2201,
    "name": "Roland Lex",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/m/9mr_a7hfdne.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 43,
      "control": 56,
      "pressure": 45,
      "agility": 66,
      "physical": 48,
      "technique": 60
    }
  },
  {
    "id": 2202,
    "name": "Holly Marx",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/k/mkae3eh_uus.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 49,
      "control": 41,
      "pressure": 66,
      "agility": 45,
      "physical": 63,
      "technique": 42
    }
  },
  {
    "id": 2203,
    "name": "Springer Boreham",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/l/sl5rkzu3b0c.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 46,
      "control": 58,
      "pressure": 49,
      "agility": 68,
      "physical": 52,
      "technique": 64
    }
  },
  {
    "id": 2204,
    "name": "Kandhul Lai",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/j/djikjmyn2h0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 51,
      "control": 60,
      "pressure": 58,
      "agility": 60,
      "physical": 60,
      "technique": 63
    }
  },
  {
    "id": 2205,
    "name": "Kit Fischer",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/c/fcpwn_ghzb0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 49,
      "control": 40,
      "pressure": 60,
      "agility": 52,
      "physical": 71,
      "technique": 50
    }
  },
  {
    "id": 2206,
    "name": "Becks Binder",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/q/uq-3kagbeyc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 54,
      "control": 57,
      "pressure": 56,
      "agility": 60,
      "physical": 40,
      "technique": 65
    }
  },
  {
    "id": 2207,
    "name": "Ralph Chasing",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/f/ofdczdztrss.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 57,
      "control": 46,
      "pressure": 48,
      "agility": 78,
      "physical": 45,
      "technique": 49
    }
  },
  {
    "id": 2208,
    "name": "Phil Debonair",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/t/_tsj0ivpghe.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 73,
      "control": 67,
      "pressure": 59,
      "agility": 56,
      "physical": 43,
      "technique": 68
    }
  },
  {
    "id": 2209,
    "name": "Si Sosman",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/h/lht7fvwlhes.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 55,
      "control": 54,
      "pressure": 68,
      "agility": 51,
      "physical": 60,
      "technique": 55
    }
  },
  {
    "id": 2210,
    "name": "Aaron Gossamer",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/v/6viaoqwxmte.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 46,
      "control": 40,
      "pressure": 69,
      "agility": 52,
      "physical": 70,
      "technique": 50
    }
  },
  {
    "id": 2211,
    "name": "Pomponius Fanfair",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/h/uh5xyr54tbk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 55,
      "control": 63,
      "pressure": 52,
      "agility": 46,
      "physical": 50,
      "technique": 49
    }
  },
  {
    "id": 2212,
    "name": "Fanella Waftgood",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/v/lvi2fufcaym.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 78,
      "control": 70,
      "pressure": 57,
      "agility": 58,
      "physical": 45,
      "technique": 61
    }
  },
  {
    "id": 2213,
    "name": "Irina Swift",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/a/fardmzqk1s8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 40,
      "control": 55,
      "pressure": 46,
      "agility": 62,
      "physical": 56,
      "technique": 61
    }
  },
  {
    "id": 2214,
    "name": "Rick Shaw",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/o/0oaihmmwyhu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 56,
      "control": 44,
      "pressure": 59,
      "agility": 50,
      "physical": 75,
      "technique": 49
    }
  },
  {
    "id": 2215,
    "name": "Montaine Skalin",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/j/2jd-pvecdnu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 43,
      "control": 57,
      "pressure": 41,
      "agility": 59,
      "physical": 52,
      "technique": 65
    }
  },
  {
    "id": 2216,
    "name": "Meowlinda Purrsival",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/h/hhsfiq4mwu8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 43,
      "control": 40,
      "pressure": 68,
      "agility": 59,
      "physical": 72,
      "technique": 57
    }
  },
  {
    "id": 2217,
    "name": "Rune Sigilsson",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/o/nopqx3nuf0m.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 49,
      "control": 58,
      "pressure": 46,
      "agility": 52,
      "physical": 48,
      "technique": 56
    }
  },
  {
    "id": 2218,
    "name": "Onslow Mastick",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/m/wm-lciruohk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 50,
      "control": 60,
      "pressure": 59,
      "agility": 68,
      "physical": 43,
      "technique": 54
    }
  },
  {
    "id": 2219,
    "name": "Blowie Armstraw",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/m/imbttfo2p4m.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 62,
      "control": 64,
      "pressure": 58,
      "agility": 57,
      "physical": 40,
      "technique": 49
    }
  },
  {
    "id": 2220,
    "name": "Paddy Filler",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/k/tkwya6omilk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 43,
      "control": 58,
      "pressure": 61,
      "agility": 54,
      "physical": 65,
      "technique": 40
    }
  },
  {
    "id": 2221,
    "name": "Avid Peddler",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/a/vamjj_9gjyu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 58,
      "control": 53,
      "pressure": 45,
      "agility": 72,
      "physical": 51,
      "technique": 67
    }
  },
  {
    "id": 2222,
    "name": "Woody Prince",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/y/eyxcoab8or8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 49,
      "control": 49,
      "pressure": 62,
      "agility": 46,
      "physical": 67,
      "technique": 55
    }
  },
  {
    "id": 2223,
    "name": "Demerara Kane",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/d/-d03ddu07lm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 45,
      "control": 49,
      "pressure": 52,
      "agility": 53,
      "physical": 41,
      "technique": 60
    }
  },
  {
    "id": 2224,
    "name": "Tiny Jetson",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/1/p1fwwiiow4k.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 52,
      "control": 58,
      "pressure": 40,
      "agility": 64,
      "physical": 53,
      "technique": 55
    }
  },
  {
    "id": 2225,
    "name": "Joe Java",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/u/nucke7ait-k.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 64,
      "control": 61,
      "pressure": 46,
      "agility": 48,
      "physical": 46,
      "technique": 68
    }
  },
  {
    "id": 2226,
    "name": "Wulf Blackbean",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/8/88zrze8y-nm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 57,
      "control": 58,
      "pressure": 66,
      "agility": 60,
      "physical": 63,
      "technique": 45
    }
  },
  {
    "id": 2227,
    "name": "Neville Boyle",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/t/ctqegzjqlt8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 41,
      "control": 58,
      "pressure": 45,
      "agility": 71,
      "physical": 52,
      "technique": 65
    }
  },
  {
    "id": 2228,
    "name": "Ameen Abel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/7/t7h_nmvqmeu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 48,
      "control": 41,
      "pressure": 64,
      "agility": 42,
      "physical": 59,
      "technique": 42
    }
  },
  {
    "id": 2229,
    "name": "Bombasta Flamboyanzi",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/r/zren8rsibh8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 52,
      "control": 43,
      "pressure": 48,
      "agility": 70,
      "physical": 40,
      "technique": 53
    }
  },
  {
    "id": 2230,
    "name": "Fada Prendi",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/5/o5vgrukyssu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 48,
      "control": 60,
      "pressure": 60,
      "agility": 65,
      "physical": 41,
      "technique": 49
    }
  },
  {
    "id": 2231,
    "name": "Bella Baker",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/r/gr0llvd7n-0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 52,
      "control": 54,
      "pressure": 42,
      "agility": 75,
      "physical": 41,
      "technique": 50
    }
  },
  {
    "id": 2232,
    "name": "Olivia Palme",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/5/35fqmqlbgnc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 66,
      "control": 61,
      "pressure": 42,
      "agility": 60,
      "physical": 46,
      "technique": 50
    }
  },
  {
    "id": 2233,
    "name": "Gustav Weathervane",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/w/xwmf13qjvts.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 40,
      "control": 56,
      "pressure": 59,
      "agility": 59,
      "physical": 58,
      "technique": 45
    }
  },
  {
    "id": 2234,
    "name": "Grover Noggin",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/-/m-x-yi2z4ee.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 66,
      "control": 71,
      "pressure": 48,
      "agility": 41,
      "physical": 47,
      "technique": 51
    }
  },
  {
    "id": 2235,
    "name": "Blazer Firefoot",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/f/kfqi2rkf9ye.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 56,
      "control": 48,
      "pressure": 73,
      "agility": 46,
      "physical": 74,
      "technique": 51
    }
  },
  {
    "id": 2236,
    "name": "Adam Montayne",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/3/v3hdbuclqrs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 51,
      "control": 53,
      "pressure": 42,
      "agility": 73,
      "physical": 49,
      "technique": 53
    }
  },
  {
    "id": 2237,
    "name": "Chauncey Slinka",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/y/1yc2iz3tllc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 79,
      "control": 69,
      "pressure": 44,
      "agility": 49,
      "physical": 57,
      "technique": 56
    }
  },
  {
    "id": 2238,
    "name": "Leighton Bolt",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/w/ewzxlmrxi40.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 48,
      "control": 51,
      "pressure": 73,
      "agility": 41,
      "physical": 61,
      "technique": 60
    }
  },
  {
    "id": 2239,
    "name": "Lucien Thrope",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/a/wampubs1vhc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 41,
      "control": 57,
      "pressure": 58,
      "agility": 59,
      "physical": 64,
      "technique": 51
    }
  },
  {
    "id": 2240,
    "name": "Lenton Gouger",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/y/by9u5-0pc00.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 58,
      "control": 51,
      "pressure": 78,
      "agility": 54,
      "physical": 58,
      "technique": 56
    }
  },
  {
    "id": 2241,
    "name": "Titania Khamun",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/a/paylx3e69hc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 61,
      "control": 69,
      "pressure": 46,
      "agility": 47,
      "physical": 40,
      "technique": 73
    }
  },
  {
    "id": 2242,
    "name": "Eveline Veitch",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/y/-yde6i4aqs0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 74,
      "control": 69,
      "pressure": 52,
      "agility": 58,
      "physical": 40,
      "technique": 50
    }
  },
  {
    "id": 2243,
    "name": "Eldritch Priest",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/d/edgxpvnilye.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 45,
      "control": 49,
      "pressure": 66,
      "agility": 58,
      "physical": 78,
      "technique": 54
    }
  },
  {
    "id": 2244,
    "name": "Gene Bulge",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/1/v1rqeqryibs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 44,
      "control": 49,
      "pressure": 54,
      "agility": 76,
      "physical": 57,
      "technique": 57
    }
  },
  {
    "id": 2245,
    "name": "Candy Reviva",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/u/tuwmqz5enhs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 46,
      "control": 42,
      "pressure": 58,
      "agility": 60,
      "physical": 63,
      "technique": 50
    }
  },
  {
    "id": 2246,
    "name": "Pacey Mack",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/8/c8nthmfkg0e.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 49,
      "control": 58,
      "pressure": 56,
      "agility": 52,
      "physical": 64,
      "technique": 45
    }
  },
  {
    "id": 2247,
    "name": "Anil Latikal",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/t/8teyurqsvu0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 52,
      "control": 43,
      "pressure": 71,
      "agility": 45,
      "physical": 66,
      "technique": 51
    }
  },
  {
    "id": 2248,
    "name": "Indy Ferrante",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/7/n7155umw4nc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 73,
      "control": 73,
      "pressure": 44,
      "agility": 48,
      "physical": 40,
      "technique": 58
    }
  },
  {
    "id": 2249,
    "name": "Stan Tistischen",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/r/5rkhijp0fy0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 42,
      "control": 52,
      "pressure": 53,
      "agility": 52,
      "physical": 49,
      "technique": 52
    }
  },
  {
    "id": 2250,
    "name": "Simon Borg",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/5/i57alcpoyrc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 60,
      "control": 60,
      "pressure": 63,
      "agility": 56,
      "physical": 64,
      "technique": 60
    }
  },
  {
    "id": 2251,
    "name": "Clark Phylen",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/r/mrgn_dghth8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 40,
      "control": 53,
      "pressure": 53,
      "agility": 70,
      "physical": 51,
      "technique": 54
    }
  },
  {
    "id": 2252,
    "name": "Gram Vineela",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/5/x5rssig9-0u.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 61,
      "control": 68,
      "pressure": 55,
      "agility": 55,
      "physical": 41,
      "technique": 64
    }
  },
  {
    "id": 2253,
    "name": "Yasser Rightaway",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/w/3wyzb_z1luk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 49,
      "control": 51,
      "pressure": 60,
      "agility": 44,
      "physical": 54,
      "technique": 40
    }
  },
  {
    "id": 2254,
    "name": "Adora Shivers",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/-/g-d4savpmnm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 69,
      "control": 60,
      "pressure": 40,
      "agility": 45,
      "physical": 42,
      "technique": 55
    }
  },
  {
    "id": 2255,
    "name": "Roland Allardyce",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/f/efekczhjjhm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 47,
      "control": 55,
      "pressure": 57,
      "agility": 59,
      "physical": 48,
      "technique": 52
    }
  },
  {
    "id": 2256,
    "name": "Lacy Cagney",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/3/131fvmhzosk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 50,
      "control": 54,
      "pressure": 62,
      "agility": 58,
      "physical": 57,
      "technique": 40
    }
  },
  {
    "id": 2257,
    "name": "Justice Gavel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/y/vyww87ur7yu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 56,
      "control": 47,
      "pressure": 54,
      "agility": 59,
      "physical": 57,
      "technique": 43
    }
  },
  {
    "id": 2258,
    "name": "Raleigh Greenstreet",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/w/kwnrreyrwb8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 57,
      "control": 60,
      "pressure": 57,
      "agility": 55,
      "physical": 57,
      "technique": 57
    }
  },
  {
    "id": 2259,
    "name": "Melody Toontune",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/a/qayjgjxjx-u.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 60,
      "control": 45,
      "pressure": 67,
      "agility": 45,
      "physical": 57,
      "technique": 55
    }
  },
  {
    "id": 2260,
    "name": "Zip Windrush",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/y/hypon2xzcn8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 41,
      "control": 41,
      "pressure": 44,
      "agility": 71,
      "physical": 47,
      "technique": 46
    }
  },
  {
    "id": 2261,
    "name": "Buster Lungs",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/2/l28ar2jbim0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 43,
      "control": 59,
      "pressure": 55,
      "agility": 50,
      "physical": 45,
      "technique": 57
    }
  },
  {
    "id": 2262,
    "name": "Stanza Verse",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/e/6en78jv7pvc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 59,
      "control": 80,
      "pressure": 58,
      "agility": 58,
      "physical": 43,
      "technique": 54
    }
  },
  {
    "id": 2263,
    "name": "Dextra Gleeson",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/x/axuovuaz61s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 53,
      "control": 56,
      "pressure": 47,
      "agility": 72,
      "physical": 46,
      "technique": 53
    }
  },
  {
    "id": 2264,
    "name": "Aidull Wanabi",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/z/rzfvcr8jxge.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 52,
      "control": 44,
      "pressure": 40,
      "agility": 80,
      "physical": 47,
      "technique": 60
    }
  },
  {
    "id": 2265,
    "name": "Earle Humble",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/4/p4yzsyulsae.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 40,
      "control": 40,
      "pressure": 76,
      "agility": 52,
      "physical": 62,
      "technique": 53
    }
  },
  {
    "id": 2266,
    "name": "Rich Fowler",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/q/yqpsbnif_zs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 48,
      "control": 46,
      "pressure": 65,
      "agility": 54,
      "physical": 69,
      "technique": 52
    }
  },
  {
    "id": 2267,
    "name": "Rio Shoring",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/_/4_knsq9xktc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 57,
      "control": 44,
      "pressure": 56,
      "agility": 45,
      "physical": 66,
      "technique": 59
    }
  },
  {
    "id": 2268,
    "name": "Joy Seeker",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/x/jx7g_vbtng0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 56,
      "control": 52,
      "pressure": 56,
      "agility": 60,
      "physical": 44,
      "technique": 54
    }
  },
  {
    "id": 2269,
    "name": "Haydn Woe",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/9/99eeoiypafc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 65,
      "control": 69,
      "pressure": 44,
      "agility": 50,
      "physical": 60,
      "technique": 67
    }
  },
  {
    "id": 2270,
    "name": "Levi Atherton",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/v/mv1_jd-1ts0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 47,
      "control": 52,
      "pressure": 53,
      "agility": 46,
      "physical": 65,
      "technique": 47
    }
  },
  {
    "id": 2271,
    "name": "Flick Screening",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/9/i9uy5c38mau.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 51,
      "control": 57,
      "pressure": 63,
      "agility": 45,
      "physical": 62,
      "technique": 44
    }
  },
  {
    "id": 2272,
    "name": "Buff Bagenal",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/v/tvftujrghz8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 60,
      "control": 48,
      "pressure": 55,
      "agility": 52,
      "physical": 52,
      "technique": 58
    }
  },
  {
    "id": 2273,
    "name": "Mariah Knowles",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/6/z68mh-koutm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 49,
      "control": 59,
      "pressure": 54,
      "agility": 62,
      "physical": 59,
      "technique": 74
    }
  },
  {
    "id": 2274,
    "name": "Phil Harmonic",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/s/csnhqbc05gk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 66,
      "control": 64,
      "pressure": 58,
      "agility": 47,
      "physical": 44,
      "technique": 47
    }
  },
  {
    "id": 2275,
    "name": "Ghoulian Haunter",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/z/azkbeyqy8mk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 48,
      "control": 54,
      "pressure": 56,
      "agility": 75,
      "physical": 57,
      "technique": 58
    }
  },
  {
    "id": 2276,
    "name": "Jacko Lenton",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/b/xb76pn2irvm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 40,
      "control": 41,
      "pressure": 59,
      "agility": 60,
      "physical": 53,
      "technique": 62
    }
  },
  {
    "id": 2277,
    "name": "Dee Tarrant",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/0/r0yp66dqk18.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 54,
      "control": 45,
      "pressure": 71,
      "agility": 59,
      "physical": 55,
      "technique": 53
    }
  },
  {
    "id": 2278,
    "name": "Lee Bartarian",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/c/gcpuxflqjgu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 48,
      "control": 42,
      "pressure": 60,
      "agility": 42,
      "physical": 70,
      "technique": 58
    }
  },
  {
    "id": 2279,
    "name": "Amir Rika",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/2/u2w2mimyu58.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 45,
      "control": 54,
      "pressure": 60,
      "agility": 72,
      "physical": 47,
      "technique": 47
    }
  },
  {
    "id": 2280,
    "name": "Ewan Envoi",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/e/lenxl3aidku.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 70,
      "control": 61,
      "pressure": 41,
      "agility": 60,
      "physical": 60,
      "technique": 63
    }
  },
  {
    "id": 2281,
    "name": "Jen DeRites",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/6/k6xbkfo_js0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 46,
      "control": 40,
      "pressure": 52,
      "agility": 62,
      "physical": 51,
      "technique": 49
    }
  },
  {
    "id": 2282,
    "name": "Judge Jury",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/s/7sagjgofkfc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 61,
      "control": 60,
      "pressure": 41,
      "agility": 43,
      "physical": 54,
      "technique": 66
    }
  },
  {
    "id": 2283,
    "name": "Leo Maine",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/9/b9jva9dnr_s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 81,
      "intelligence": 57,
      "control": 52,
      "pressure": 58,
      "agility": 77,
      "physical": 45,
      "technique": 59
    }
  },
  {
    "id": 2284,
    "name": "Scorpia Venin",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/v/qvs03c738me.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 46,
      "control": 54,
      "pressure": 59,
      "agility": 54,
      "physical": 59,
      "technique": 42
    }
  },
  {
    "id": 2285,
    "name": "Noel Taurius",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/0/o0vozbpb5ke.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 47,
      "control": 51,
      "pressure": 49,
      "agility": 62,
      "physical": 57,
      "technique": 62
    }
  },
  {
    "id": 2286,
    "name": "Pan Kidd",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/c/zckj0kphu5s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 63,
      "control": 71,
      "pressure": 42,
      "agility": 45,
      "physical": 49,
      "technique": 55
    }
  },
  {
    "id": 2287,
    "name": "Cuba Lieber",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/z/5zh8n56phzc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 61,
      "control": 64,
      "pressure": 46,
      "agility": 51,
      "physical": 45,
      "technique": 59
    }
  },
  {
    "id": 2288,
    "name": "Arthur Crabbe",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/b/ib2dkgctmq0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 41,
      "control": 43,
      "pressure": 57,
      "agility": 42,
      "physical": 76,
      "technique": 55
    }
  },
  {
    "id": 2289,
    "name": "Regina Raffles",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/x/8xjf7lfxrvc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 41,
      "control": 55,
      "pressure": 47,
      "agility": 75,
      "physical": 54,
      "technique": 53
    }
  },
  {
    "id": 2290,
    "name": "Ian Fountry",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/z/nz4kw05lgm0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 64,
      "control": 63,
      "pressure": 54,
      "agility": 55,
      "physical": 45,
      "technique": 62
    }
  },
  {
    "id": 2291,
    "name": "Mark Osman",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/x/jxjpm1wcnku.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 46,
      "control": 47,
      "pressure": 71,
      "agility": 46,
      "physical": 73,
      "technique": 53
    }
  },
  {
    "id": 2292,
    "name": "Colin Mando",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/z/szsihkw4k58.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 77,
      "control": 61,
      "pressure": 53,
      "agility": 44,
      "physical": 40,
      "technique": 53
    }
  },
  {
    "id": 2293,
    "name": "Pete Parrish",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/2/y2x9yxjw_zm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 49,
      "control": 40,
      "pressure": 52,
      "agility": 73,
      "physical": 44,
      "technique": 64
    }
  },
  {
    "id": 2294,
    "name": "Serge Major",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/e/deacfofksqk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 54,
      "control": 42,
      "pressure": 65,
      "agility": 60,
      "physical": 60,
      "technique": 49
    }
  },
  {
    "id": 2295,
    "name": "Susan Taylor",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/_/b_haxxxmxsk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 53,
      "control": 59,
      "pressure": 77,
      "agility": 54,
      "physical": 70,
      "technique": 41
    }
  },
  {
    "id": 2296,
    "name": "Keenan Guru",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/x/wx2hcoxc6fm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 51,
      "control": 54,
      "pressure": 68,
      "agility": 45,
      "physical": 63,
      "technique": 58
    }
  },
  {
    "id": 2297,
    "name": "Lovell Ribner",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/4/q4vupteup_8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 40,
      "control": 40,
      "pressure": 48,
      "agility": 64,
      "physical": 46,
      "technique": 52
    }
  },
  {
    "id": 2298,
    "name": "Curtis Carson",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/q/hqk1isiuimu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 56,
      "control": 52,
      "pressure": 61,
      "agility": 42,
      "physical": 65,
      "technique": 53
    }
  },
  {
    "id": 2299,
    "name": "Falah Hazbin",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/6/v6btthhmfz8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 53,
      "control": 65,
      "pressure": 53,
      "agility": 57,
      "physical": 55,
      "technique": 53
    }
  },
  {
    "id": 2300,
    "name": "Marthin Bannister",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/s/ksqm-eh2oau.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 59,
      "control": 52,
      "pressure": 40,
      "agility": 59,
      "physical": 43,
      "technique": 51
    }
  },
  {
    "id": 2301,
    "name": "Orion Tearing",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/6/q6lhqxtdxv8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 43,
      "control": 56,
      "pressure": 49,
      "agility": 51,
      "physical": 57,
      "technique": 58
    }
  },
  {
    "id": 2302,
    "name": "Reese Fryer",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/s/bsum9ol56mu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 45,
      "control": 47,
      "pressure": 58,
      "agility": 54,
      "physical": 74,
      "technique": 44
    }
  },
  {
    "id": 2303,
    "name": "Ben Feuer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/9/793tu1-xpgk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 54,
      "control": 65,
      "pressure": 53,
      "agility": 42,
      "physical": 49,
      "technique": 57
    }
  },
  {
    "id": 2304,
    "name": "Edison Ford",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/v/kvgydkyli1m.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 67,
      "control": 63,
      "pressure": 44,
      "agility": 59,
      "physical": 59,
      "technique": 52
    }
  },
  {
    "id": 2305,
    "name": "Eva Chatton",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/0/i0buttknnzm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 40,
      "control": 46,
      "pressure": 52,
      "agility": 62,
      "physical": 55,
      "technique": 61
    }
  },
  {
    "id": 2306,
    "name": "Pezi Miste",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/c/5cwpassdkak.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 41,
      "control": 50,
      "pressure": 75,
      "agility": 55,
      "physical": 71,
      "technique": 54
    }
  },
  {
    "id": 2307,
    "name": "Preston Creasefree",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/z/zzt6txzv_gu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 76,
      "control": 62,
      "pressure": 58,
      "agility": 58,
      "physical": 46,
      "technique": 69
    }
  },
  {
    "id": 2308,
    "name": "Anna Mite",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/b/obib-o_vst8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 46,
      "control": 48,
      "pressure": 67,
      "agility": 40,
      "physical": 67,
      "technique": 44
    }
  },
  {
    "id": 2309,
    "name": "Bear Zurka",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/x/cxddpd8n1su.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 49,
      "control": 47,
      "pressure": 73,
      "agility": 55,
      "physical": 68,
      "technique": 41
    }
  },
  {
    "id": 2310,
    "name": "Pasha Lomo",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/z/tzsii8a3yf8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 58,
      "control": 54,
      "pressure": 43,
      "agility": 73,
      "physical": 40,
      "technique": 57
    }
  },
  {
    "id": 2311,
    "name": "Lennon Trousers",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/x/dx3v49t-5zc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 46,
      "control": 60,
      "pressure": 53,
      "agility": 66,
      "physical": 47,
      "technique": 47
    }
  },
  {
    "id": 2312,
    "name": "Drysden Waller",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/z/yzgovc1eua0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 69,
      "control": 76,
      "pressure": 57,
      "agility": 55,
      "physical": 51,
      "technique": 64
    }
  },
  {
    "id": 2313,
    "name": "Zipp Fastener",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/2/s2l7gfamhge.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 59,
      "control": 55,
      "pressure": 52,
      "agility": 75,
      "physical": 50,
      "technique": 55
    }
  },
  {
    "id": 2314,
    "name": "Brook Dredger",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/e/jeuargm2mts.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 64,
      "control": 55,
      "pressure": 58,
      "agility": 45,
      "physical": 48,
      "technique": 68
    }
  },
  {
    "id": 2315,
    "name": "Luke Nohans",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/_/h_tgf50ajvs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 77,
      "control": 69,
      "pressure": 51,
      "agility": 45,
      "physical": 44,
      "technique": 62
    }
  },
  {
    "id": 2316,
    "name": "BA Branssen",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/x/qxinogsgkme.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 64,
      "control": 69,
      "pressure": 45,
      "agility": 47,
      "physical": 45,
      "technique": 57
    }
  },
  {
    "id": 2317,
    "name": "Fabrice Soffner",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/4/w4bs7bnorg0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 42,
      "control": 50,
      "pressure": 40,
      "agility": 72,
      "physical": 45,
      "technique": 63
    }
  },
  {
    "id": 2318,
    "name": "Virgil Milliner",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/q/bqwzwkbs81c.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 64,
      "control": 62,
      "pressure": 57,
      "agility": 54,
      "physical": 41,
      "technique": 70
    }
  },
  {
    "id": 2319,
    "name": "Nishan Naudle",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/6/16prnpcwbk0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 43,
      "control": 60,
      "pressure": 54,
      "agility": 54,
      "physical": 57,
      "technique": 59
    }
  },
  {
    "id": 2320,
    "name": "Chandler Spillane",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/s/es-kkwkk25c.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 67,
      "control": 60,
      "pressure": 45,
      "agility": 58,
      "physical": 51,
      "technique": 68
    }
  },
  {
    "id": 2321,
    "name": "Monarch Rome",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/s/4sobptxa3qs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 43,
      "control": 49,
      "pressure": 55,
      "agility": 59,
      "physical": 55,
      "technique": 58
    }
  },
  {
    "id": 2322,
    "name": "Sonny Wukong",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/e/jez6esx6aze.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 40,
      "control": 45,
      "pressure": 40,
      "agility": 56,
      "physical": 43,
      "technique": 58
    }
  },
  {
    "id": 2323,
    "name": "Joe Bajie",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/r/pr6pxxeyv50.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 66,
      "control": 77,
      "pressure": 45,
      "agility": 52,
      "physical": 42,
      "technique": 67
    }
  },
  {
    "id": 2324,
    "name": "Sean Wujing",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/d/ydlu6oiickc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 41,
      "control": 43,
      "pressure": 55,
      "agility": 57,
      "physical": 75,
      "technique": 40
    }
  },
  {
    "id": 2325,
    "name": "Tony Sanzang",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/i/aimyuxwkhmc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 56,
      "control": 49,
      "pressure": 69,
      "agility": 49,
      "physical": 66,
      "technique": 59
    }
  },
  {
    "id": 2326,
    "name": "Helmut Hardy",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/k/rk9t5oweq_0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 61,
      "control": 77,
      "pressure": 40,
      "agility": 52,
      "physical": 45,
      "technique": 63
    }
  },
  {
    "id": 2327,
    "name": "Harley Hogg",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/l/llemq1jwffe.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 46,
      "control": 43,
      "pressure": 74,
      "agility": 57,
      "physical": 75,
      "technique": 47
    }
  },
  {
    "id": 2328,
    "name": "Ezio Ryder",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/n/6nvhhkfsyss.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 49,
      "control": 56,
      "pressure": 58,
      "agility": 55,
      "physical": 62,
      "technique": 46
    }
  },
  {
    "id": 2329,
    "name": "Tori Torrence",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/n/onqf2hgovte.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 42,
      "control": 53,
      "pressure": 48,
      "agility": 57,
      "physical": 50,
      "technique": 63
    }
  },
  {
    "id": 2330,
    "name": "Placido Cannes",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/p/_ph-b4g04gs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 42,
      "control": 42,
      "pressure": 68,
      "agility": 60,
      "physical": 57,
      "technique": 60
    }
  },
  {
    "id": 2331,
    "name": "Noyss Kensler",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/n/rn6zb5p9zmm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 41,
      "control": 58,
      "pressure": 56,
      "agility": 54,
      "physical": 56,
      "technique": 52
    }
  },
  {
    "id": 2332,
    "name": "Hedwig Setter",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/p/gplssgph0_k.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 74,
      "control": 70,
      "pressure": 60,
      "agility": 59,
      "physical": 56,
      "technique": 64
    }
  },
  {
    "id": 2333,
    "name": "Phineas Hudd",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/g/agon_b6pbfu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 50,
      "control": 56,
      "pressure": 53,
      "agility": 73,
      "physical": 60,
      "technique": 59
    }
  },
  {
    "id": 2334,
    "name": "Viking Beagle",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/i/xizgskc1ss8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 59,
      "control": 46,
      "pressure": 63,
      "agility": 59,
      "physical": 56,
      "technique": 52
    }
  },
  {
    "id": 2335,
    "name": "Seth Paynter",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/p/zpea89ozpq8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 60,
      "control": 71,
      "pressure": 49,
      "agility": 47,
      "physical": 50,
      "technique": 53
    }
  },
  {
    "id": 2336,
    "name": "Indira Patil",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/b/cbv7rcojezu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 44,
      "control": 44,
      "pressure": 77,
      "agility": 45,
      "physical": 71,
      "technique": 46
    }
  },
  {
    "id": 2337,
    "name": "T.T. Mann",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/u/iumocfdrx5k.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 62,
      "control": 68,
      "pressure": 46,
      "agility": 58,
      "physical": 45,
      "technique": 53
    }
  },
  {
    "id": 2338,
    "name": "Concordia Choral",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/g/tg9vvg7rckm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 76,
      "control": 67,
      "pressure": 50,
      "agility": 53,
      "physical": 40,
      "technique": 56
    }
  },
  {
    "id": 2339,
    "name": "Assumpta Meakin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/s/nsc3et4z71k.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 49,
      "control": 57,
      "pressure": 63,
      "agility": 50,
      "physical": 64,
      "technique": 52
    }
  },
  {
    "id": 2340,
    "name": "Laurie Driver",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/e/wezwzsejwgm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 46,
      "control": 50,
      "pressure": 85,
      "agility": 43,
      "physical": 63,
      "technique": 60
    }
  },
  {
    "id": 2341,
    "name": "Raine Walker",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/s/ys8ddb08ptk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 51,
      "control": 56,
      "pressure": 48,
      "agility": 67,
      "physical": 40,
      "technique": 48
    }
  },
  {
    "id": 2342,
    "name": "Martha Hubbard",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/e/pen8wksgegm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 48,
      "control": 60,
      "pressure": 49,
      "agility": 67,
      "physical": 48,
      "technique": 53
    }
  },
  {
    "id": 2343,
    "name": "Bernina Nightoil",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/r/jrujj5noxa8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 64,
      "control": 75,
      "pressure": 44,
      "agility": 43,
      "physical": 52,
      "technique": 70
    }
  },
  {
    "id": 2344,
    "name": "Erik Strongarm",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/d/4dfoogb0czu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 56,
      "control": 53,
      "pressure": 50,
      "agility": 42,
      "physical": 63,
      "technique": 43
    }
  },
  {
    "id": 2345,
    "name": "Gunnar Boatwright",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/i/6iy0gftyz1u.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 54,
      "control": 50,
      "pressure": 50,
      "agility": 45,
      "physical": 43,
      "technique": 53
    }
  },
  {
    "id": 2346,
    "name": "Sigmund Wayfinder",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/k/lkpvng1i0g8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 44,
      "control": 49,
      "pressure": 55,
      "agility": 58,
      "physical": 45,
      "technique": 69
    }
  },
  {
    "id": 2347,
    "name": "Grim Jinxweaver",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/l/rlkge9aqbmm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 65,
      "control": 73,
      "pressure": 52,
      "agility": 56,
      "physical": 42,
      "technique": 61
    }
  },
  {
    "id": 2348,
    "name": "Tia Cruz",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/n/an7bzcmqsvk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 40,
      "control": 46,
      "pressure": 46,
      "agility": 61,
      "physical": 59,
      "technique": 52
    }
  },
  {
    "id": 2349,
    "name": "Thomas Oquendo",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/n/unezcplylqm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 48,
      "control": 50,
      "pressure": 72,
      "agility": 54,
      "physical": 57,
      "technique": 49
    }
  },
  {
    "id": 2350,
    "name": "Reyes Cabedo",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/p/fp14vwdimzk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 48,
      "control": 45,
      "pressure": 42,
      "agility": 61,
      "physical": 57,
      "technique": 56
    }
  },
  {
    "id": 2351,
    "name": "Newt Perfect",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/n/xnu11xkbh1e.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 53,
      "control": 49,
      "pressure": 45,
      "agility": 55,
      "physical": 58,
      "technique": 53
    }
  },
  {
    "id": 2352,
    "name": "Carmen Aria",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/p/apfuyos7qgs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 44,
      "control": 42,
      "pressure": 45,
      "agility": 70,
      "physical": 47,
      "technique": 52
    }
  },
  {
    "id": 2353,
    "name": "Dorian Lucenzo",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/g/gg8hltzzfmc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 59,
      "control": 42,
      "pressure": 58,
      "agility": 59,
      "physical": 58,
      "technique": 47
    }
  },
  {
    "id": 2354,
    "name": "Wesley Provolone",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/i/rinams_jyv0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 41,
      "control": 40,
      "pressure": 72,
      "agility": 53,
      "physical": 53,
      "technique": 58
    }
  },
  {
    "id": 2355,
    "name": "Joachim Zooner",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/p/tpkci1tl3t0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 63,
      "control": 69,
      "pressure": 57,
      "agility": 49,
      "physical": 48,
      "technique": 55
    }
  },
  {
    "id": 2356,
    "name": "Bjorn Villen",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/b/ib79lklfagc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 53,
      "control": 46,
      "pressure": 42,
      "agility": 78,
      "physical": 42,
      "technique": 49
    }
  },
  {
    "id": 2357,
    "name": "Theron Starr",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/u/cuyi2x-xvas.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 45,
      "control": 59,
      "pressure": 47,
      "agility": 76,
      "physical": 55,
      "technique": 67
    }
  },
  {
    "id": 2358,
    "name": "Niall Kuhn",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/g/zgppboytcze.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 57,
      "control": 58,
      "pressure": 66,
      "agility": 40,
      "physical": 58,
      "technique": 59
    }
  },
  {
    "id": 2359,
    "name": "Graplen Hawk",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/s/hswxqlbplms.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 59,
      "control": 71,
      "pressure": 55,
      "agility": 48,
      "physical": 54,
      "technique": 48
    }
  },
  {
    "id": 2360,
    "name": "Tribulus Galtrop",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/e/2enqha91i_e.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 51,
      "control": 59,
      "pressure": 72,
      "agility": 50,
      "physical": 65,
      "technique": 51
    }
  },
  {
    "id": 2361,
    "name": "Sunil Rahman",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/a/cayibajh2um.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 51,
      "control": 51,
      "pressure": 79,
      "agility": 54,
      "physical": 73,
      "technique": 49
    }
  },
  {
    "id": 2362,
    "name": "Súphis Cheops",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/o/todd2lf9bnk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 57,
      "control": 60,
      "pressure": 52,
      "agility": 54,
      "physical": 45,
      "technique": 63
    }
  },
  {
    "id": 2363,
    "name": "Khefren Chepren",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/h/nhg2l4w1uhu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 57,
      "control": 45,
      "pressure": 43,
      "agility": 62,
      "physical": 51,
      "technique": 74
    }
  },
  {
    "id": 2364,
    "name": "Mykerinos Menkh",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/v/8vrxihwpd08.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 46,
      "control": 42,
      "pressure": 45,
      "agility": 62,
      "physical": 57,
      "technique": 65
    }
  },
  {
    "id": 2365,
    "name": "Narcissa Plane",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/o/-owlmeejgy8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 60,
      "control": 54,
      "pressure": 71,
      "agility": 57,
      "physical": 54,
      "technique": 56
    }
  },
  {
    "id": 2366,
    "name": "Pauletta Porter",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/m/pmnqlhizrbu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 55,
      "control": 71,
      "pressure": 58,
      "agility": 41,
      "physical": 45,
      "technique": 49
    }
  },
  {
    "id": 2367,
    "name": "Hattie Couture",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/j/vjefy8xrehk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 67,
      "control": 70,
      "pressure": 54,
      "agility": 40,
      "physical": 41,
      "technique": 72
    }
  },
  {
    "id": 2368,
    "name": "Urbana Street",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/h/eh1-1dxrzsm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 57,
      "control": 41,
      "pressure": 56,
      "agility": 61,
      "physical": 45,
      "technique": 55
    }
  },
  {
    "id": 2369,
    "name": "Lovell Lyons",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/l/qlkmeoyjutk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 72,
      "control": 72,
      "pressure": 55,
      "agility": 59,
      "physical": 57,
      "technique": 53
    }
  },
  {
    "id": 2370,
    "name": "Pease Marrowfat",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/j/bj7hpxuz5em.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 53,
      "control": 58,
      "pressure": 49,
      "agility": 60,
      "physical": 54,
      "technique": 64
    }
  },
  {
    "id": 2371,
    "name": "Ram Horner",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/l/1lgkzwd6yys.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 75,
      "control": 64,
      "pressure": 60,
      "agility": 56,
      "physical": 44,
      "technique": 59
    }
  },
  {
    "id": 2372,
    "name": "Pius Fisher",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/j/ejrrep7a1be.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 45,
      "control": 46,
      "pressure": 60,
      "agility": 47,
      "physical": 73,
      "technique": 43
    }
  },
  {
    "id": 2373,
    "name": "Archie Rider",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/m/kmyensoiah0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 49,
      "control": 53,
      "pressure": 45,
      "agility": 73,
      "physical": 58,
      "technique": 61
    }
  },
  {
    "id": 2374,
    "name": "Virginia Goldstein",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/k/vkd_gtoytsc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 60,
      "control": 51,
      "pressure": 50,
      "agility": 69,
      "physical": 52,
      "technique": 59
    }
  },
  {
    "id": 2375,
    "name": "Norton Waters",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/f/xfejo06eouc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 53,
      "control": 43,
      "pressure": 67,
      "agility": 55,
      "physical": 77,
      "technique": 41
    }
  },
  {
    "id": 2376,
    "name": "Jen Miniver",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/t/mt1cjlckfn0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 53,
      "control": 70,
      "pressure": 57,
      "agility": 60,
      "physical": 49,
      "technique": 50
    }
  },
  {
    "id": 2377,
    "name": "Ernest Goodman",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/c/gcw3wwpswhe.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 52,
      "control": 57,
      "pressure": 54,
      "agility": 55,
      "physical": 51,
      "technique": 61
    }
  },
  {
    "id": 2378,
    "name": "Galahad Chevalier",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/q/3qnwdppwd0s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 46,
      "control": 60,
      "pressure": 50,
      "agility": 68,
      "physical": 48,
      "technique": 62
    }
  },
  {
    "id": 2379,
    "name": "Wanda Spelling",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/a/dayoskm06le.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 56,
      "control": 44,
      "pressure": 67,
      "agility": 42,
      "physical": 74,
      "technique": 44
    }
  },
  {
    "id": 2380,
    "name": "Nick Pincher",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/o/yopvbbqox4s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 45,
      "control": 52,
      "pressure": 72,
      "agility": 45,
      "physical": 60,
      "technique": 55
    }
  },
  {
    "id": 2381,
    "name": "Marshall Artison",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/t/atckxqyngdm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 61,
      "control": 56,
      "pressure": 48,
      "agility": 56,
      "physical": 42,
      "technique": 67
    }
  },
  {
    "id": 2382,
    "name": "Mary Curey",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/f/rftf6v-3nuk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 50,
      "control": 44,
      "pressure": 57,
      "agility": 40,
      "physical": 56,
      "technique": 43
    }
  },
  {
    "id": 2383,
    "name": "Ian Bick",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/q/lqowpyl_4ou.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 43,
      "control": 46,
      "pressure": 76,
      "agility": 53,
      "physical": 77,
      "technique": 43
    }
  },
  {
    "id": 2384,
    "name": "Jib Spinaker",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/c/6c_rentfv98.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 59,
      "control": 42,
      "pressure": 40,
      "agility": 66,
      "physical": 50,
      "technique": 57
    }
  },
  {
    "id": 2385,
    "name": "Odo Riffeck",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/j/4j4nqu_pq78.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 60,
      "control": 52,
      "pressure": 66,
      "agility": 58,
      "physical": 54,
      "technique": 47
    }
  },
  {
    "id": 2386,
    "name": "Fox Wiley",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/l/jljshrzt9iu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 48,
      "control": 41,
      "pressure": 65,
      "agility": 59,
      "physical": 69,
      "technique": 47
    }
  },
  {
    "id": 2387,
    "name": "Gladius Swinger",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/k/pkqzu2sbiok.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 68,
      "control": 61,
      "pressure": 42,
      "agility": 45,
      "physical": 52,
      "technique": 66
    }
  },
  {
    "id": 2388,
    "name": "Asif Ecks",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/m/ymb45jkhlbm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 63,
      "control": 62,
      "pressure": 43,
      "agility": 48,
      "physical": 49,
      "technique": 49
    }
  },
  {
    "id": 2389,
    "name": "Roy Ellway",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/m/smkgiejdckk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 49,
      "control": 45,
      "pressure": 58,
      "agility": 57,
      "physical": 59,
      "technique": 60
    }
  },
  {
    "id": 2390,
    "name": "Scott Amundsen",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/o/dovbl7v5vxm.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 50,
      "control": 56,
      "pressure": 45,
      "agility": 64,
      "physical": 47,
      "technique": 66
    }
  },
  {
    "id": 2391,
    "name": "Mike Roscopy",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/m/zmom_6mwo7s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 55,
      "control": 43,
      "pressure": 42,
      "agility": 61,
      "physical": 53,
      "technique": 48
    }
  },
  {
    "id": 2392,
    "name": "Gruff Dorman",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/o/co_tsfakjie.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 54,
      "control": 58,
      "pressure": 58,
      "agility": 77,
      "physical": 40,
      "technique": 55
    }
  },
  {
    "id": 2393,
    "name": "Snowy Bergman",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/h/ihcyby1cwo0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 50,
      "control": 56,
      "pressure": 40,
      "agility": 61,
      "physical": 44,
      "technique": 59
    }
  },
  {
    "id": 2394,
    "name": "Tiger Bleriot",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/j/tjt5snt47bc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 49,
      "control": 47,
      "pressure": 75,
      "agility": 59,
      "physical": 63,
      "technique": 50
    }
  },
  {
    "id": 2395,
    "name": "Ugg LeMugg",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/o/roqlc-bu-dc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 48,
      "control": 40,
      "pressure": 56,
      "agility": 77,
      "physical": 43,
      "technique": 60
    }
  },
  {
    "id": 2396,
    "name": "Hans Popov",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/a/gabevbnutu0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 45,
      "control": 50,
      "pressure": 63,
      "agility": 60,
      "physical": 66,
      "technique": 49
    }
  },
  {
    "id": 2397,
    "name": "Norman Zeus",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/v/av4x8csmmoe.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 66,
      "control": 66,
      "pressure": 44,
      "agility": 41,
      "physical": 41,
      "technique": 56
    }
  },
  {
    "id": 2398,
    "name": "Tommo Marrow",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/h/xhjqrj0cl9s.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 40,
      "control": 59,
      "pressure": 55,
      "agility": 41,
      "physical": 70,
      "technique": 49
    }
  },
  {
    "id": 2399,
    "name": "Lyle Covet",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/t/ft2igu3-sce.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 55,
      "control": 40,
      "pressure": 54,
      "agility": 73,
      "physical": 54,
      "technique": 55
    }
  },
  {
    "id": 2400,
    "name": "Graham Dupree",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/f/0fhpnrrebxs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 40,
      "control": 50,
      "pressure": 68,
      "agility": 52,
      "physical": 63,
      "technique": 41
    }
  },
  {
    "id": 2401,
    "name": "Dirk Byker",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/t/6tiijy7x-ke.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 45,
      "control": 49,
      "pressure": 51,
      "agility": 54,
      "physical": 57,
      "technique": 49
    }
  },
  {
    "id": 2402,
    "name": "Charles LeMans",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/f/lf5dondltxs.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 64,
      "control": 74,
      "pressure": 48,
      "agility": 58,
      "physical": 47,
      "technique": 47
    }
  },
  {
    "id": 2403,
    "name": "Walter Carr",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/q/rqa2d6odm3c.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 62,
      "control": 64,
      "pressure": 45,
      "agility": 41,
      "physical": 47,
      "technique": 60
    }
  },
  {
    "id": 2404,
    "name": "Buzz Scrambler",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/c/acrxwfo5le0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 50,
      "control": 53,
      "pressure": 48,
      "agility": 67,
      "physical": 52,
      "technique": 51
    }
  },
  {
    "id": 2405,
    "name": "Nifty Throttler",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/j/yjsleccvoc0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 45,
      "control": 47,
      "pressure": 40,
      "agility": 54,
      "physical": 56,
      "technique": 50
    }
  },
  {
    "id": 2406,
    "name": "Dino Zolletta",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/_/g_k7zf85mim.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 57,
      "control": 41,
      "pressure": 44,
      "agility": 68,
      "physical": 59,
      "technique": 49
    }
  },
  {
    "id": 2407,
    "name": "Karl Kappa",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/s/cshjkf4lhr8.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 50,
      "control": 56,
      "pressure": 69,
      "agility": 42,
      "physical": 67,
      "technique": 47
    }
  },
  {
    "id": 2409,
    "name": "Decker Pile",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/s/_sdeekkykne.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 54,
      "control": 49,
      "pressure": 77,
      "agility": 55,
      "physical": 75,
      "technique": 50
    }
  },
  {
    "id": 2410,
    "name": "Chucky Cardaway",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/d/fd-rn5r6_h0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 58,
      "control": 59,
      "pressure": 41,
      "agility": 71,
      "physical": 54,
      "technique": 57
    }
  },
  {
    "id": 2411,
    "name": "Bernie Ellement",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/r/urpkgg3as0c.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 44,
      "control": 53,
      "pressure": 52,
      "agility": 70,
      "physical": 54,
      "technique": 65
    }
  },
  {
    "id": 2412,
    "name": "Woody Ellement",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/k/skiwoflsxyc.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 45,
      "control": 51,
      "pressure": 65,
      "agility": 58,
      "physical": 59,
      "technique": 42
    }
  },
  {
    "id": 2413,
    "name": "Gail Ellement",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/i/di53jgdw6b0.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 46,
      "control": 49,
      "pressure": 53,
      "agility": 55,
      "physical": 67,
      "technique": 43
    }
  },
  {
    "id": 2414,
    "name": "Clay Ellement",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/n/9nacw92ephe.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 63,
      "control": 69,
      "pressure": 60,
      "agility": 40,
      "physical": 60,
      "technique": 69
    }
  },
  {
    "id": 2415,
    "name": "Neville Goodenough",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/l/mlrjdcqkiss.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 79,
      "control": 57,
      "pressure": 49,
      "agility": 56,
      "physical": 45,
      "technique": 57
    }
  },
  {
    "id": 2416,
    "name": "Lucien Rarey",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/p/4pu7sptgfte.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 64,
      "control": 56,
      "pressure": 45,
      "agility": 52,
      "physical": 47,
      "technique": 47
    }
  },
  {
    "id": 2417,
    "name": "Stackem Skyhigh",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/n/jnlabw18oes.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 60,
      "control": 48,
      "pressure": 50,
      "agility": 68,
      "physical": 45,
      "technique": 62
    }
  },
  {
    "id": 2418,
    "name": "Anfaira D'vantage",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/p/np-xbx81jym.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 61,
      "control": 62,
      "pressure": 41,
      "agility": 57,
      "physical": 41,
      "technique": 53
    }
  },
  {
    "id": 2419,
    "name": "Walken Ruhlbuch",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/i/2isdltvhrhu.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 55,
      "control": 51,
      "pressure": 55,
      "agility": 57,
      "physical": 67,
      "technique": 59
    }
  },
  {
    "id": 2424,
    "name": "Maasa Sudou",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/g/ugiqyxijhhk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 70,
      "control": 62,
      "pressure": 58,
      "agility": 54,
      "physical": 54,
      "technique": 62
    }
  },
  {
    "id": 2426,
    "name": "Yurina Kumai",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/e/regtelt7rlk.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 49,
      "control": 45,
      "pressure": 40,
      "agility": 62,
      "physical": 44,
      "technique": 60
    }
  },
  {
    "id": 2427,
    "name": "Miyabi Natsuyaki",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/s/gs3ypalbg4m.png",
    "game": [
      "Inazuma Eleven 3"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 42,
      "control": 49,
      "pressure": 47,
      "agility": 60,
      "physical": 40,
      "technique": 57
    }
  },
  {
    "id": 2432,
    "name": "Arion Sherwind",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/o/ooxd-ldeoym.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 72,
      "control": 58,
      "pressure": 44,
      "agility": 55,
      "physical": 43,
      "technique": 67
    }
  },
  {
    "id": 2433,
    "name": "Victor Blade",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/o/3obvj1s3khe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 53,
      "control": 59,
      "pressure": 52,
      "agility": 58,
      "physical": 42,
      "technique": 49
    }
  },
  {
    "id": 2434,
    "name": "Riccardo Di Rigo",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/m/zmait0l-frk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 72,
      "control": 59,
      "pressure": 40,
      "agility": 42,
      "physical": 54,
      "technique": 61
    }
  },
  {
    "id": 2435,
    "name": "Jean-Pierre Lapin",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/j/njcpxktux08.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 42,
      "control": 57,
      "pressure": 59,
      "agility": 54,
      "physical": 53,
      "technique": 48
    }
  },
  {
    "id": 2436,
    "name": "Gabriel Garcia",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/q/-qqyycnc_bu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 60,
      "control": 45,
      "pressure": 68,
      "agility": 52,
      "physical": 69,
      "technique": 52
    }
  },
  {
    "id": 2437,
    "name": "Samguk Han",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/t/vt4mmg0wnsm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 55,
      "pressure": 75,
      "agility": 53,
      "physical": 62,
      "technique": 43
    }
  },
  {
    "id": 2438,
    "name": "Subaru Honda",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/c/pcbtf9b4sy8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 51,
      "control": 52,
      "pressure": 61,
      "agility": 42,
      "physical": 65,
      "technique": 48
    }
  },
  {
    "id": 2439,
    "name": "Wanli Changcheng",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/l/8ltucb1u6hu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 60,
      "control": 41,
      "pressure": 60,
      "agility": 48,
      "physical": 60,
      "technique": 42
    }
  },
  {
    "id": 2440,
    "name": "Adé Kébé",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/m/tm_6i5mcium.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 62,
      "control": 61,
      "pressure": 46,
      "agility": 56,
      "physical": 40,
      "technique": 56
    }
  },
  {
    "id": 2441,
    "name": "Eugene Peabody",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/k/ckobpgampnk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 68,
      "control": 67,
      "pressure": 58,
      "agility": 48,
      "physical": 46,
      "technique": 45
    }
  },
  {
    "id": 2442,
    "name": "Michael Ballzack",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/m/gmqokkknj0s.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 55,
      "control": 48,
      "pressure": 52,
      "agility": 73,
      "physical": 48,
      "technique": 71
    }
  },
  {
    "id": 2443,
    "name": "Doug McArthur",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/h/xh4aaoz_rn0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 59,
      "control": 52,
      "pressure": 48,
      "agility": 64,
      "physical": 44,
      "technique": 67
    }
  },
  {
    "id": 2444,
    "name": "Aitor Cazador",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/o/koonzotp5sc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 47,
      "control": 49,
      "pressure": 67,
      "agility": 48,
      "physical": 59,
      "technique": 45
    }
  },
  {
    "id": 2446,
    "name": "Ryoma Nishiki",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/h/ehtsktyhmys.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 70,
      "control": 75,
      "pressure": 44,
      "agility": 56,
      "physical": 50,
      "technique": 64
    }
  },
  {
    "id": 2447,
    "name": "Lucian Dark",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/v/1vczns-bhbe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 42,
      "control": 52,
      "pressure": 51,
      "agility": 71,
      "physical": 53,
      "technique": 68
    }
  },
  {
    "id": 2448,
    "name": "Lars Dijkstra",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/j/mjj73x_f8uc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 59,
      "control": 52,
      "pressure": 42,
      "agility": 56,
      "physical": 44,
      "technique": 58
    }
  },
  {
    "id": 2449,
    "name": "Sven Johansson",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/a/va_g0xltuh0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 47,
      "control": 54,
      "pressure": 63,
      "agility": 48,
      "physical": 71,
      "technique": 56
    }
  },
  {
    "id": 2450,
    "name": "Mark Evans",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/k/_k2bq4onqie.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 49,
      "control": 46,
      "pressure": 79,
      "agility": 41,
      "physical": 77,
      "technique": 54
    }
  },
  {
    "id": 2451,
    "name": "Celia Hills",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/b/2birdzthg-s.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 57,
      "control": 72,
      "pressure": 60,
      "agility": 59,
      "physical": 47,
      "technique": 67
    }
  },
  {
    "id": 2452,
    "name": "Skie Blue",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/h/kh5u-b7dslk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 45,
      "control": 59,
      "pressure": 55,
      "agility": 59,
      "physical": 62,
      "technique": 56
    }
  },
  {
    "id": 2453,
    "name": "Rosie Redd",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/v/vvi1tkdn_4m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 62,
      "control": 56,
      "pressure": 58,
      "agility": 60,
      "physical": 50,
      "technique": 61
    }
  },
  {
    "id": 2454,
    "name": "Jade Greene",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/f/hf3tipefyhk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 47,
      "control": 54,
      "pressure": 51,
      "agility": 61,
      "physical": 58,
      "technique": 57
    }
  },
  {
    "id": 2455,
    "name": "Montaña Tábano",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/t/ptsg4oxm5re.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 52,
      "control": 52,
      "pressure": 62,
      "agility": 59,
      "physical": 65,
      "technique": 47
    }
  },
  {
    "id": 2456,
    "name": "Tom Gato",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/c/vcpvr1ieml0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 60,
      "control": 44,
      "pressure": 67,
      "agility": 53,
      "physical": 72,
      "technique": 48
    }
  },
  {
    "id": 2457,
    "name": "Joaquín Coronado",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/q/eq-0gke-h4c.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 46,
      "control": 54,
      "pressure": 63,
      "agility": 53,
      "physical": 73,
      "technique": 51
    }
  },
  {
    "id": 2458,
    "name": "Conant Ó Briain",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/l/cl5ootwsk-c.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 41,
      "control": 54,
      "pressure": 58,
      "agility": 56,
      "physical": 62,
      "technique": 55
    }
  },
  {
    "id": 2459,
    "name": "Sirius Starsky",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/j/tjijfswojn0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 43,
      "control": 54,
      "pressure": 62,
      "agility": 50,
      "physical": 60,
      "technique": 46
    }
  },
  {
    "id": 2460,
    "name": "Shunsuke Aoyama",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/m/nmr8wxfg8te.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 74,
      "control": 63,
      "pressure": 55,
      "agility": 58,
      "physical": 49,
      "technique": 63
    }
  },
  {
    "id": 2461,
    "name": "Bucky Woodchuck",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/k/8kad7ojares.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 73,
      "control": 76,
      "pressure": 55,
      "agility": 50,
      "physical": 46,
      "technique": 73
    }
  },
  {
    "id": 2462,
    "name": "Punkie Mahican",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/o/iolfkdg42he.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 68,
      "control": 61,
      "pressure": 45,
      "agility": 45,
      "physical": 54,
      "technique": 55
    }
  },
  {
    "id": 2463,
    "name": "Hugues Baudet",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/m/5mukn8gcbss.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 66,
      "control": 68,
      "pressure": 58,
      "agility": 51,
      "physical": 58,
      "technique": 65
    }
  },
  {
    "id": 2464,
    "name": "Jagur Meister",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/o/xopp99pl6-m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 44,
      "control": 54,
      "pressure": 50,
      "agility": 65,
      "physical": 48,
      "technique": 68
    }
  },
  {
    "id": 2465,
    "name": "Friedrich Schiller",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/m/mm-iqcpxxnk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 53,
      "control": 42,
      "pressure": 40,
      "agility": 68,
      "physical": 40,
      "technique": 70
    }
  },
  {
    "id": 2466,
    "name": "Adarn Shame",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/j/gjd9dfc5itu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 42,
      "control": 58,
      "pressure": 62,
      "agility": 48,
      "physical": 67,
      "technique": 42
    }
  },
  {
    "id": 2467,
    "name": "Ota Shape",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/h/3hscug6dpe8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 48,
      "control": 51,
      "pressure": 67,
      "agility": 46,
      "physical": 58,
      "technique": 49
    }
  },
  {
    "id": 2468,
    "name": "Nogo Sarikid",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/a/1araa5ovky8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 66,
      "control": 64,
      "pressure": 51,
      "agility": 58,
      "physical": 42,
      "technique": 62
    }
  },
  {
    "id": 2469,
    "name": "Lance Speares",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/7/d7h8bstpzuu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 46,
      "control": 55,
      "pressure": 67,
      "agility": 53,
      "physical": 67,
      "technique": 52
    }
  },
  {
    "id": 2470,
    "name": "Dirk Anlace",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/u/9ucjsxyhs0k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 42,
      "control": 56,
      "pressure": 66,
      "agility": 41,
      "physical": 52,
      "technique": 55
    }
  },
  {
    "id": 2471,
    "name": "Clay Moor",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/8/m8zo_o-9bhm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 55,
      "control": 58,
      "pressure": 62,
      "agility": 51,
      "physical": 58,
      "technique": 52
    }
  },
  {
    "id": 2472,
    "name": "Nun Chuck",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/d/od00rxsrebm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 55,
      "control": 42,
      "pressure": 73,
      "agility": 40,
      "physical": 61,
      "technique": 56
    }
  },
  {
    "id": 2473,
    "name": "Spike Stiletto",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/1/_1fv8okrpyk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 49,
      "control": 45,
      "pressure": 68,
      "agility": 47,
      "physical": 56,
      "technique": 46
    }
  },
  {
    "id": 2474,
    "name": "Bilbo Baton",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/a/famgv1_jcsu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 54,
      "control": 62,
      "pressure": 55,
      "agility": 40,
      "physical": 44,
      "technique": 49
    }
  },
  {
    "id": 2475,
    "name": "Jack Knife",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/y/uyxbckzzxh8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 60,
      "control": 67,
      "pressure": 51,
      "agility": 47,
      "physical": 45,
      "technique": 65
    }
  },
  {
    "id": 2476,
    "name": "Bayonet Gunne",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/y/ayozzha7weu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 78,
      "control": 69,
      "pressure": 47,
      "agility": 51,
      "physical": 51,
      "technique": 59
    }
  },
  {
    "id": 2477,
    "name": "Howie Itzer",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/w/rwz4e48b7t8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 49,
      "control": 55,
      "pressure": 53,
      "agility": 51,
      "physical": 59,
      "technique": 63
    }
  },
  {
    "id": 2478,
    "name": "Flam Berger",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/w/0wzupgty3y0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 58,
      "control": 50,
      "pressure": 51,
      "agility": 65,
      "physical": 45,
      "technique": 66
    }
  },
  {
    "id": 2479,
    "name": "Matt Chetty",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/f/ufqh6bm6cse.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 57,
      "control": 40,
      "pressure": 54,
      "agility": 48,
      "physical": 73,
      "technique": 49
    }
  },
  {
    "id": 2480,
    "name": "Harold Shields",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/3/l3haxkaavhs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 56,
      "control": 59,
      "pressure": 51,
      "agility": 70,
      "physical": 56,
      "technique": 60
    }
  },
  {
    "id": 2481,
    "name": "Hal Byrd",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/w/nwmc59ssqns.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 64,
      "control": 62,
      "pressure": 56,
      "agility": 44,
      "physical": 47,
      "technique": 55
    }
  },
  {
    "id": 2482,
    "name": "Morgan Stern",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/-/w-x9uc0whue.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 46,
      "control": 46,
      "pressure": 71,
      "agility": 55,
      "physical": 72,
      "technique": 47
    }
  },
  {
    "id": 2483,
    "name": "Roman Ballista",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/r/2r0ihfbey00.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 68,
      "control": 74,
      "pressure": 45,
      "agility": 47,
      "physical": 51,
      "technique": 70
    }
  },
  {
    "id": 2484,
    "name": "Saber Sabel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/w/7w2e1dpflo8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 44,
      "control": 58,
      "pressure": 71,
      "agility": 57,
      "physical": 72,
      "technique": 50
    }
  },
  {
    "id": 2485,
    "name": "Par Scal",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/7/97161kozhtc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 49,
      "control": 50,
      "pressure": 62,
      "agility": 57,
      "physical": 59,
      "technique": 44
    }
  },
  {
    "id": 2486,
    "name": "Tez La",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/u/duwpm577yns.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 56,
      "control": 45,
      "pressure": 57,
      "agility": 41,
      "physical": 59,
      "technique": 46
    }
  },
  {
    "id": 2487,
    "name": "Aris Tottle",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/8/s8nulgdbf-e.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 57,
      "control": 44,
      "pressure": 70,
      "agility": 48,
      "physical": 53,
      "technique": 48
    }
  },
  {
    "id": 2488,
    "name": "Archie Medes",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/d/udgylfpta4e.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 50,
      "control": 47,
      "pressure": 58,
      "agility": 55,
      "physical": 51,
      "technique": 48
    }
  },
  {
    "id": 2489,
    "name": "Socrat Eiss",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/1/f1rtigpx3ls.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 42,
      "control": 56,
      "pressure": 60,
      "agility": 50,
      "physical": 71,
      "technique": 55
    }
  },
  {
    "id": 2490,
    "name": "Ian Stein",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/a/_aymb9cfcrc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 60,
      "control": 75,
      "pressure": 54,
      "agility": 46,
      "physical": 51,
      "technique": 66
    }
  },
  {
    "id": 2491,
    "name": "Ed Ison",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/y/oydh2c6lvy0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 78,
      "control": 69,
      "pressure": 52,
      "agility": 59,
      "physical": 46,
      "technique": 64
    }
  },
  {
    "id": 2492,
    "name": "Mitchell Angelio",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/y/6y8fhp5hinc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 65,
      "control": 58,
      "pressure": 45,
      "agility": 53,
      "physical": 41,
      "technique": 50
    }
  },
  {
    "id": 2493,
    "name": "Moe Sart",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/w/lwn-qwf9lu0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 42,
      "control": 60,
      "pressure": 58,
      "agility": 57,
      "physical": 40,
      "technique": 58
    }
  },
  {
    "id": 2494,
    "name": "Dave Inchy",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/y/lywzwxw0e4u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 69,
      "control": 66,
      "pressure": 60,
      "agility": 44,
      "physical": 59,
      "technique": 61
    }
  },
  {
    "id": 2495,
    "name": "Frank Lyn",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/w/uwnsdowopl8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 54,
      "control": 49,
      "pressure": 58,
      "agility": 65,
      "physical": 42,
      "technique": 47
    }
  },
  {
    "id": 2496,
    "name": "Cooper Nikos",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/f/0fenotfgcrm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 40,
      "control": 46,
      "pressure": 68,
      "agility": 51,
      "physical": 69,
      "technique": 47
    }
  },
  {
    "id": 2497,
    "name": "Leo Gally",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/3/f31gjsj8xyk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 48,
      "control": 41,
      "pressure": 76,
      "agility": 60,
      "physical": 52,
      "technique": 47
    }
  },
  {
    "id": 2498,
    "name": "Desmond Cartes",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/w/hwyan1xq0ek.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 73,
      "control": 62,
      "pressure": 55,
      "agility": 40,
      "physical": 42,
      "technique": 63
    }
  },
  {
    "id": 2499,
    "name": "Connor Fuschius",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/-/2-d7gkxqztm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 62,
      "control": 61,
      "pressure": 41,
      "agility": 41,
      "physical": 55,
      "technique": 72
    }
  },
  {
    "id": 2500,
    "name": "Dar Wynne",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/r/wrgozxiisn8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 58,
      "control": 50,
      "pressure": 51,
      "agility": 70,
      "physical": 41,
      "technique": 59
    }
  },
  {
    "id": 2501,
    "name": "Tom Jefferson",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/a/_ahsafgbw2u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 57,
      "control": 51,
      "pressure": 60,
      "agility": 71,
      "physical": 44,
      "technique": 74
    }
  },
  {
    "id": 2502,
    "name": "Starbuck Rogers",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/x/5x7fzlziyq0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 58,
      "control": 47,
      "pressure": 72,
      "agility": 50,
      "physical": 64,
      "technique": 58
    }
  },
  {
    "id": 2503,
    "name": "Worff Chewback",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/4/z4ywg4satke.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 40,
      "control": 44,
      "pressure": 70,
      "agility": 53,
      "physical": 68,
      "technique": 58
    }
  },
  {
    "id": 2504,
    "name": "Dart H. Cylon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/q/oqprnhk6a5s.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 56,
      "control": 56,
      "pressure": 71,
      "agility": 55,
      "physical": 56,
      "technique": 50
    }
  },
  {
    "id": 2505,
    "name": "Scotty O'Brien",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/x/qxunjeywf_s.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 52,
      "control": 50,
      "pressure": 72,
      "agility": 53,
      "physical": 65,
      "technique": 45
    }
  },
  {
    "id": 2506,
    "name": "Billy-Lee Adarma",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/z/bzfsoh-some.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 66,
      "control": 63,
      "pressure": 59,
      "agility": 51,
      "physical": 48,
      "technique": 64
    }
  },
  {
    "id": 2507,
    "name": "Zaphod Riker",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/2/728zd8lkds0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 73,
      "control": 61,
      "pressure": 46,
      "agility": 53,
      "physical": 47,
      "technique": 71
    }
  },
  {
    "id": 2508,
    "name": "Cyber Dalekman",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/e/ken4wdtewfc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 77,
      "control": 72,
      "pressure": 57,
      "agility": 48,
      "physical": 55,
      "technique": 53
    }
  },
  {
    "id": 2509,
    "name": "Lucas Skywalk",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/0/-0ygbou8xg0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 62,
      "control": 58,
      "pressure": 56,
      "agility": 40,
      "physical": 46,
      "technique": 52
    }
  },
  {
    "id": 2510,
    "name": "Jimmy Kyrk",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/c/pcdbsxig6tc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 51,
      "control": 47,
      "pressure": 49,
      "agility": 56,
      "physical": 44,
      "technique": 72
    }
  },
  {
    "id": 2511,
    "name": "Harkness Torchwood",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/0/h0ym2wbpb_8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 49,
      "control": 54,
      "pressure": 48,
      "agility": 69,
      "physical": 42,
      "technique": 57
    }
  },
  {
    "id": 2512,
    "name": "Jean-Luc Janeway",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/c/qcptbpn12mu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 60,
      "control": 51,
      "pressure": 49,
      "agility": 61,
      "physical": 49,
      "technique": 50
    }
  },
  {
    "id": 2513,
    "name": "Wesley Sheridan",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/z/wzkyiss9dsk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 53,
      "control": 52,
      "pressure": 68,
      "agility": 56,
      "physical": 64,
      "technique": 46
    }
  },
  {
    "id": 2514,
    "name": "Sithri Peon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/b/bb75lt0hufm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 46,
      "control": 53,
      "pressure": 57,
      "agility": 51,
      "physical": 66,
      "technique": 53
    }
  },
  {
    "id": 2515,
    "name": "Isaac Binks",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/6/d68ll0mrrzm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 56,
      "control": 46,
      "pressure": 67,
      "agility": 40,
      "physical": 61,
      "technique": 58
    }
  },
  {
    "id": 2516,
    "name": "Carl Rissian",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/s/ysnemlargqk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 61,
      "control": 67,
      "pressure": 47,
      "agility": 54,
      "physical": 48,
      "technique": 58
    }
  },
  {
    "id": 2517,
    "name": "Robert Affett",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/9/s9ux1w1zzku.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 55,
      "control": 52,
      "pressure": 42,
      "agility": 62,
      "physical": 58,
      "technique": 59
    }
  },
  {
    "id": 2518,
    "name": "Deanna Tam",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/v/fvknjcztjwk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 69,
      "control": 56,
      "pressure": 56,
      "agility": 43,
      "physical": 59,
      "technique": 63
    }
  },
  {
    "id": 2519,
    "name": "Aum Nirvana",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/6/_6vd_vicoj0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 56,
      "control": 53,
      "pressure": 63,
      "agility": 58,
      "physical": 57,
      "technique": 51
    }
  },
  {
    "id": 2520,
    "name": "Adamant Walhalla",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/v/fv22syxk7de.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 41,
      "control": 56,
      "pressure": 57,
      "agility": 57,
      "physical": 74,
      "technique": 47
    }
  },
  {
    "id": 2521,
    "name": "Omega Elysium",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/9/u9hxbnxwwws.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 59,
      "control": 42,
      "pressure": 61,
      "agility": 51,
      "physical": 65,
      "technique": 49
    }
  },
  {
    "id": 2522,
    "name": "Fürimmer Jung",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/c/scalvujct2s.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 50,
      "control": 48,
      "pressure": 72,
      "agility": 46,
      "physical": 66,
      "technique": 54
    }
  },
  {
    "id": 2523,
    "name": "Zenith Shangrila",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/0/d0xqcrfm-fe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 47,
      "control": 43,
      "pressure": 69,
      "agility": 53,
      "physical": 70,
      "technique": 53
    }
  },
  {
    "id": 2524,
    "name": "Optimum Limbo",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/b/9bsfr2wull0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 76,
      "control": 64,
      "pressure": 43,
      "agility": 57,
      "physical": 52,
      "technique": 63
    }
  },
  {
    "id": 2525,
    "name": "Panacea Utopia",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/z/mzj-8jwumwc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 63,
      "control": 69,
      "pressure": 44,
      "agility": 45,
      "physical": 45,
      "technique": 55
    }
  },
  {
    "id": 2526,
    "name": "Acme Rapture",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/z/4zcmnev2bp0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 70,
      "control": 58,
      "pressure": 43,
      "agility": 49,
      "physical": 46,
      "technique": 58
    }
  },
  {
    "id": 2527,
    "name": "Ultima Nextworld",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/x/jxthg7zmsac.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 41,
      "control": 51,
      "pressure": 49,
      "agility": 63,
      "physical": 55,
      "technique": 54
    }
  },
  {
    "id": 2528,
    "name": "Maxim Millennium",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/z/nz2k666fn28.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 46,
      "control": 40,
      "pressure": 50,
      "agility": 58,
      "physical": 49,
      "technique": 62
    }
  },
  {
    "id": 2529,
    "name": "Infinity Beyond",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/x/wxhrxfc_gfu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 58,
      "control": 46,
      "pressure": 42,
      "agility": 77,
      "physical": 55,
      "technique": 70
    }
  },
  {
    "id": 2530,
    "name": "Apex Paradiso",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/e/2ekeeyp3vlk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 59,
      "control": 44,
      "pressure": 62,
      "agility": 50,
      "physical": 78,
      "technique": 51
    }
  },
  {
    "id": 2531,
    "name": "Pearl Gates",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/2/h2v_pnpn4wm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 53,
      "control": 49,
      "pressure": 51,
      "agility": 63,
      "physical": 46,
      "technique": 57
    }
  },
  {
    "id": 2532,
    "name": "Perpetuo Xanadu",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/x/fxsjh-dh9qm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 61,
      "control": 54,
      "pressure": 43,
      "agility": 46,
      "physical": 40,
      "technique": 56
    }
  },
  {
    "id": 2533,
    "name": "Sempiterno Bliss",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/_/0_jcqb7bqjk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 69,
      "control": 59,
      "pressure": 58,
      "agility": 42,
      "physical": 52,
      "technique": 65
    }
  },
  {
    "id": 2534,
    "name": "Myriad Arcadia",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/q/uqa35cotldu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 60,
      "control": 45,
      "pressure": 74,
      "agility": 43,
      "physical": 66,
      "technique": 59
    }
  },
  {
    "id": 2535,
    "name": "Primo Eden",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/h/uhvgk9vpolm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 46,
      "control": 58,
      "pressure": 68,
      "agility": 44,
      "physical": 68,
      "technique": 54
    }
  },
  {
    "id": 2536,
    "name": "Preston Princeton",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/6/f6bflnb-qa8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 58,
      "control": 52,
      "pressure": 53,
      "agility": 51,
      "physical": 59,
      "technique": 55
    }
  },
  {
    "id": 2537,
    "name": "Dracon Yale",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/v/_viwy602l6m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 44,
      "control": 40,
      "pressure": 54,
      "agility": 43,
      "physical": 54,
      "technique": 58
    }
  },
  {
    "id": 2538,
    "name": "Duke Dartmouth",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/9/o9tr1fsmijk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 60,
      "control": 40,
      "pressure": 65,
      "agility": 53,
      "physical": 66,
      "technique": 52
    }
  },
  {
    "id": 2539,
    "name": "Cameron Cambridge",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/c/mcunbcagnpk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 60,
      "control": 60,
      "pressure": 73,
      "agility": 52,
      "physical": 61,
      "technique": 52
    }
  },
  {
    "id": 2540,
    "name": "Earl Eton",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/0/90ls2jmag8m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 60,
      "control": 56,
      "pressure": 56,
      "agility": 42,
      "physical": 42,
      "technique": 55
    }
  },
  {
    "id": 2541,
    "name": "Caesar Cornell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/b/dbgzl-tsvc8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 56,
      "control": 57,
      "pressure": 54,
      "agility": 53,
      "physical": 50,
      "technique": 59
    }
  },
  {
    "id": 2542,
    "name": "Hampton Harvard",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/z/sz34ib1o4vu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 60,
      "control": 56,
      "pressure": 54,
      "agility": 43,
      "physical": 51,
      "technique": 62
    }
  },
  {
    "id": 2543,
    "name": "Baron Oxford",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/z/yzig5m2kfq8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 43,
      "control": 53,
      "pressure": 69,
      "agility": 41,
      "physical": 55,
      "technique": 46
    }
  },
  {
    "id": 2544,
    "name": "Sterling Stanford",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/x/px5buzqwyju.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 66,
      "control": 57,
      "pressure": 47,
      "agility": 50,
      "physical": 58,
      "technique": 69
    }
  },
  {
    "id": 2545,
    "name": "Colby Columbia",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/z/hzimoyz5tp0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 50,
      "control": 44,
      "pressure": 42,
      "agility": 56,
      "physical": 49,
      "technique": 55
    }
  },
  {
    "id": 2546,
    "name": "Rex Remington",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/x/2xttjn_d-8c.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 43,
      "control": 54,
      "pressure": 47,
      "agility": 67,
      "physical": 47,
      "technique": 66
    }
  },
  {
    "id": 2547,
    "name": "Fred Featherstonhaugh",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/e/wewywqkllcs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 50,
      "control": 43,
      "pressure": 61,
      "agility": 44,
      "physical": 61,
      "technique": 42
    }
  },
  {
    "id": 2548,
    "name": "Arthur Ascot",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/2/n2b5dvsxmve.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 44,
      "control": 44,
      "pressure": 73,
      "agility": 44,
      "physical": 56,
      "technique": 49
    }
  },
  {
    "id": 2549,
    "name": "Stuart St John",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/x/lxglz2-djpe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 40,
      "control": 57,
      "pressure": 61,
      "agility": 51,
      "physical": 52,
      "technique": 59
    }
  },
  {
    "id": 2550,
    "name": "Wenceslas Wales",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/_/u_3eejynoas.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 54,
      "control": 52,
      "pressure": 60,
      "agility": 74,
      "physical": 51,
      "technique": 54
    }
  },
  {
    "id": 2551,
    "name": "Yorick York",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/q/0quxnutv76c.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 72,
      "control": 57,
      "pressure": 58,
      "agility": 42,
      "physical": 60,
      "technique": 70
    }
  },
  {
    "id": 2552,
    "name": "Jude Sharp",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/d/mda8pecb4xs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 61,
      "control": 75,
      "pressure": 50,
      "agility": 46,
      "physical": 57,
      "technique": 59
    }
  },
  {
    "id": 2554,
    "name": "David Samford",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/l/flv05ldflc0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 48,
      "control": 44,
      "pressure": 60,
      "agility": 59,
      "physical": 49,
      "technique": 67
    }
  },
  {
    "id": 2555,
    "name": "Ishmael Ahab",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/s/nsmzyj79wls.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 59,
      "control": 57,
      "pressure": 79,
      "agility": 59,
      "physical": 60,
      "technique": 42
    }
  },
  {
    "id": 2556,
    "name": "Octavus Kraken",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/d/tdvsh-o1ffc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 41,
      "control": 47,
      "pressure": 55,
      "agility": 55,
      "physical": 59,
      "technique": 59
    }
  },
  {
    "id": 2557,
    "name": "Roger Jolly",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/r/crenmbopo20.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 44,
      "control": 51,
      "pressure": 78,
      "agility": 49,
      "physical": 72,
      "technique": 42
    }
  },
  {
    "id": 2558,
    "name": "Sinbad Saylor",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/k/ekzriy6jtw0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 42,
      "control": 40,
      "pressure": 58,
      "agility": 53,
      "physical": 57,
      "technique": 42
    }
  },
  {
    "id": 2559,
    "name": "Rob Crusoe",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/i/viowpnczadc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 49,
      "control": 53,
      "pressure": 67,
      "agility": 44,
      "physical": 61,
      "technique": 44
    }
  },
  {
    "id": 2560,
    "name": "Cheung Po",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/n/pnlfc6pr1js.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 69,
      "control": 68,
      "pressure": 40,
      "agility": 46,
      "physical": 44,
      "technique": 59
    }
  },
  {
    "id": 2561,
    "name": "William Kidd",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/l/-l6kxfpryqe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 59,
      "control": 73,
      "pressure": 47,
      "agility": 45,
      "physical": 48,
      "technique": 51
    }
  },
  {
    "id": 2562,
    "name": "Santelmo Phyre",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/p/kpf8aimj_vs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 74,
      "control": 72,
      "pressure": 47,
      "agility": 41,
      "physical": 60,
      "technique": 64
    }
  },
  {
    "id": 2563,
    "name": "Dakkar Nemo",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/n/7n0dt3qzsce.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 62,
      "control": 57,
      "pressure": 56,
      "agility": 51,
      "physical": 56,
      "technique": 63
    }
  },
  {
    "id": 2564,
    "name": "Davy Jones",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/p/vpvq32j6zwk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 42,
      "control": 43,
      "pressure": 53,
      "agility": 63,
      "physical": 58,
      "technique": 67
    }
  },
  {
    "id": 2565,
    "name": "Calico Corsair",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/n/knexajfaedm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 41,
      "control": 52,
      "pressure": 56,
      "agility": 63,
      "physical": 40,
      "technique": 65
    }
  },
  {
    "id": 2566,
    "name": "Nick Tofobia",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/i/ei9ejuwirj8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 30,
      "intelligence": 43,
      "control": 41,
      "pressure": 75,
      "agility": 46,
      "physical": 69,
      "technique": 58
    }
  },
  {
    "id": 2567,
    "name": "Marley Hookson",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/g/1gmlkrwygqu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 58,
      "control": 75,
      "pressure": 53,
      "agility": 53,
      "physical": 56,
      "technique": 68
    }
  },
  {
    "id": 2568,
    "name": "Bart Black",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/b/3bl5kyeedwu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 53,
      "control": 43,
      "pressure": 72,
      "agility": 40,
      "physical": 65,
      "technique": 44
    }
  },
  {
    "id": 2569,
    "name": "Frank Drake",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/p/gp6ynnikul8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 51,
      "control": 56,
      "pressure": 64,
      "agility": 58,
      "physical": 61,
      "technique": 46
    }
  },
  {
    "id": 2570,
    "name": "Barnabas Rossa",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/g/mgzt0qxsbfm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 84,
      "intelligence": 41,
      "control": 44,
      "pressure": 59,
      "agility": 62,
      "physical": 40,
      "technique": 61
    }
  },
  {
    "id": 2571,
    "name": "Longjohn Silver",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/m/smsakkhfljm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 45,
      "control": 59,
      "pressure": 60,
      "agility": 54,
      "physical": 74,
      "technique": 52
    }
  },
  {
    "id": 2572,
    "name": "Alessandro il Grande",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/s/tsyfgrybuck.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 55,
      "control": 58,
      "pressure": 58,
      "agility": 45,
      "physical": 61,
      "technique": 60
    }
  },
  {
    "id": 2573,
    "name": "Gene Ghiskhan",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/d/nd7qv2tjb8u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 53,
      "control": 56,
      "pressure": 74,
      "agility": 53,
      "physical": 67,
      "technique": 52
    }
  },
  {
    "id": 2574,
    "name": "Attila Hun",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/r/8rkl4jlz2p8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 58,
      "control": 58,
      "pressure": 63,
      "agility": 49,
      "physical": 61,
      "technique": 47
    }
  },
  {
    "id": 2575,
    "name": "Sun Tzu",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/k/-knxwqzfzj8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 53,
      "control": 58,
      "pressure": 76,
      "agility": 43,
      "physical": 59,
      "technique": 60
    }
  },
  {
    "id": 2576,
    "name": "Arty Xerxes",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/i/pi827v_le6u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 48,
      "control": 43,
      "pressure": 56,
      "agility": 42,
      "physical": 59,
      "technique": 59
    }
  },
  {
    "id": 2577,
    "name": "Darius Cyrus",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/n/vnfdoyktrak.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 80,
      "control": 61,
      "pressure": 42,
      "agility": 42,
      "physical": 51,
      "technique": 56
    }
  },
  {
    "id": 2578,
    "name": "Jerry Onimo",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/l/eluifnsxgpm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 63,
      "control": 67,
      "pressure": 60,
      "agility": 42,
      "physical": 56,
      "technique": 52
    }
  },
  {
    "id": 2579,
    "name": "Leon Ohnepart",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/p/qpr60av1hwk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 54,
      "control": 53,
      "pressure": 47,
      "agility": 43,
      "physical": 55,
      "technique": 52
    }
  },
  {
    "id": 2580,
    "name": "Robert Lee",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/p/1p7wd-agtjs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 42,
      "control": 45,
      "pressure": 54,
      "agility": 65,
      "physical": 48,
      "technique": 48
    }
  },
  {
    "id": 2581,
    "name": "Nobby Naga",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/n/enk3ubm8a6e.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 51,
      "control": 58,
      "pressure": 52,
      "agility": 52,
      "physical": 56,
      "technique": 50
    }
  },
  {
    "id": 2582,
    "name": "Salvador Addin",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/i/kipc9ct01a0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 54,
      "control": 44,
      "pressure": 62,
      "agility": 58,
      "physical": 62,
      "technique": 40
    }
  },
  {
    "id": 2583,
    "name": "Otto Bismark",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/g/vgyjqj1oypc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 50,
      "control": 47,
      "pressure": 67,
      "agility": 51,
      "physical": 78,
      "technique": 60
    }
  },
  {
    "id": 2584,
    "name": "Jean Darc",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/b/xbf_-6nidvc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 43,
      "control": 60,
      "pressure": 50,
      "agility": 44,
      "physical": 66,
      "technique": 52
    }
  },
  {
    "id": 2585,
    "name": "Bobby Bruce",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/p/mpuetfbywc0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 60,
      "control": 40,
      "pressure": 53,
      "agility": 59,
      "physical": 59,
      "technique": 64
    }
  },
  {
    "id": 2586,
    "name": "Hanny Bawl",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/g/ggnray0qf8e.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 53,
      "control": 57,
      "pressure": 52,
      "agility": 68,
      "physical": 53,
      "technique": 50
    }
  },
  {
    "id": 2587,
    "name": "Sturm Schwartzkopf",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/o/doj7nbh_mqk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 56,
      "control": 57,
      "pressure": 59,
      "agility": 72,
      "physical": 45,
      "technique": 50
    }
  },
  {
    "id": 2588,
    "name": "Wolfe Whyte",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/c/pcjtq-zv0x8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 45,
      "control": 43,
      "pressure": 65,
      "agility": 52,
      "physical": 59,
      "technique": 51
    }
  },
  {
    "id": 2589,
    "name": "Sascha Kotch",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/t/vtay5jsdbrm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 51,
      "control": 44,
      "pressure": 62,
      "agility": 45,
      "physical": 68,
      "technique": 56
    }
  },
  {
    "id": 2590,
    "name": "Guy l'Acier",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/f/efx5ucknsik.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 53,
      "control": 47,
      "pressure": 71,
      "agility": 47,
      "physical": 73,
      "technique": 48
    }
  },
  {
    "id": 2591,
    "name": "Matther Horne",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/k/ck2l6fylpkk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 58,
      "control": 46,
      "pressure": 60,
      "agility": 41,
      "physical": 59,
      "technique": 59
    }
  },
  {
    "id": 2592,
    "name": "Iggie Loo",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/m/tmhex6-xexm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 49,
      "control": 46,
      "pressure": 55,
      "agility": 55,
      "physical": 71,
      "technique": 58
    }
  },
  {
    "id": 2593,
    "name": "Bob Sled",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/j/njkxenl5x38.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 57,
      "control": 69,
      "pressure": 41,
      "agility": 46,
      "physical": 48,
      "technique": 50
    }
  },
  {
    "id": 2594,
    "name": "Blain Chills",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/l/8lvqpytdceu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 73,
      "control": 51,
      "pressure": 51,
      "agility": 48,
      "physical": 54,
      "technique": 58
    }
  },
  {
    "id": 2595,
    "name": "Art Tundra",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/h/ihqiyvuh778.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 61,
      "control": 59,
      "pressure": 56,
      "agility": 55,
      "physical": 47,
      "technique": 65
    }
  },
  {
    "id": 2596,
    "name": "Borel Aurora",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/j/5jbp1qibwiu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 59,
      "control": 69,
      "pressure": 60,
      "agility": 60,
      "physical": 47,
      "technique": 67
    }
  },
  {
    "id": 2597,
    "name": "Njord Snio",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/h/xhakvrbs3k0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 55,
      "control": 43,
      "pressure": 43,
      "agility": 61,
      "physical": 41,
      "technique": 62
    }
  },
  {
    "id": 2598,
    "name": "Yule Hoarfrost",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/j/mjxfcunoaxc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 50,
      "control": 45,
      "pressure": 40,
      "agility": 75,
      "physical": 43,
      "technique": 68
    }
  },
  {
    "id": 2599,
    "name": "Suno Aisu",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/m/gmswrjsgv3s.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 42,
      "control": 45,
      "pressure": 62,
      "agility": 51,
      "physical": 74,
      "technique": 55
    }
  },
  {
    "id": 2600,
    "name": "Himesh Himalaya",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/o/3ojr820acee.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 42,
      "control": 54,
      "pressure": 61,
      "agility": 48,
      "physical": 70,
      "technique": 43
    }
  },
  {
    "id": 2601,
    "name": "Blake Wintry",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/v/1vknsvm2hce.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 54,
      "control": 74,
      "pressure": 58,
      "agility": 43,
      "physical": 54,
      "technique": 57
    }
  },
  {
    "id": 2602,
    "name": "Fritz Brisk",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/h/ehvs_qamqxs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 69,
      "control": 61,
      "pressure": 53,
      "agility": 54,
      "physical": 46,
      "technique": 57
    }
  },
  {
    "id": 2603,
    "name": "Grisley Bear",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/o/ko2zsn1efrc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 45,
      "control": 41,
      "pressure": 42,
      "agility": 62,
      "physical": 52,
      "technique": 54
    }
  },
  {
    "id": 2604,
    "name": "Wilder Bigfoot",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/h/9hao0gu3twu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 68,
      "control": 67,
      "pressure": 52,
      "agility": 58,
      "physical": 41,
      "technique": 58
    }
  },
  {
    "id": 2605,
    "name": "Strom Boojum",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/c/vc3re26pqi0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 49,
      "control": 57,
      "pressure": 62,
      "agility": 60,
      "physical": 55,
      "technique": 45
    }
  },
  {
    "id": 2606,
    "name": "Dock Hickory",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/t/ptuenrphfoe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 40,
      "control": 55,
      "pressure": 61,
      "agility": 43,
      "physical": 58,
      "technique": 46
    }
  },
  {
    "id": 2607,
    "name": "Bourne Birch",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/f/-fl_gupbybs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 40,
      "control": 42,
      "pressure": 63,
      "agility": 48,
      "physical": 57,
      "technique": 42
    }
  },
  {
    "id": 2608,
    "name": "Flynt Pine",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/k/8kijon733ds.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 58,
      "control": 50,
      "pressure": 75,
      "agility": 48,
      "physical": 73,
      "technique": 40
    }
  },
  {
    "id": 2609,
    "name": "Trent Poplar",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/m/nmtcjydnaue.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 59,
      "control": 52,
      "pressure": 59,
      "agility": 43,
      "physical": 67,
      "technique": 46
    }
  },
  {
    "id": 2610,
    "name": "River Willows",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/j/tjw3wvofvo0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 73,
      "control": 55,
      "pressure": 52,
      "agility": 58,
      "physical": 50,
      "technique": 53
    }
  },
  {
    "id": 2611,
    "name": "Beck Heath",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/l/clbwdqo_c9c.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 70,
      "control": 53,
      "pressure": 52,
      "agility": 48,
      "physical": 47,
      "technique": 56
    }
  },
  {
    "id": 2612,
    "name": "Brook Linden",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/h/oh-osdndlc0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 64,
      "control": 74,
      "pressure": 46,
      "agility": 49,
      "physical": 48,
      "technique": 65
    }
  },
  {
    "id": 2613,
    "name": "Bay Laurel",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/j/zjpvbirnixc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 75,
      "control": 59,
      "pressure": 41,
      "agility": 53,
      "physical": 41,
      "technique": 58
    }
  },
  {
    "id": 2614,
    "name": "Langford Ash",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/h/3huibjiupd8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 54,
      "control": 57,
      "pressure": 55,
      "agility": 63,
      "physical": 54,
      "technique": 56
    }
  },
  {
    "id": 2615,
    "name": "Escott Aspen",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/j/gjld2ceueuu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 48,
      "control": 45,
      "pressure": 57,
      "agility": 56,
      "physical": 56,
      "technique": 52
    }
  },
  {
    "id": 2616,
    "name": "Maxwell Mahogany",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/m/mmg2lbxcxok.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 60,
      "control": 51,
      "pressure": 58,
      "agility": 50,
      "physical": 66,
      "technique": 57
    }
  },
  {
    "id": 2617,
    "name": "Bradford Ash",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/o/xo3xi-xmc9m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 50,
      "control": 44,
      "pressure": 52,
      "agility": 66,
      "physical": 42,
      "technique": 48
    }
  },
  {
    "id": 2618,
    "name": "Calder Elm",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/v/vvwlmnfkz7m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 53,
      "control": 42,
      "pressure": 55,
      "agility": 74,
      "physical": 40,
      "technique": 51
    }
  },
  {
    "id": 2619,
    "name": "Laike Alder",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/h/khbqlyjw0ik.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 55,
      "control": 54,
      "pressure": 66,
      "agility": 50,
      "physical": 65,
      "technique": 48
    }
  },
  {
    "id": 2620,
    "name": "Tahoma Sequoia",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/o/eoifyfw4bou.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 58,
      "control": 72,
      "pressure": 47,
      "agility": 46,
      "physical": 52,
      "technique": 67
    }
  },
  {
    "id": 2621,
    "name": "Byron Love",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/l/gltgpqjnrn0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 65,
      "control": 58,
      "pressure": 46,
      "agility": 57,
      "physical": 56,
      "technique": 71
    }
  },
  {
    "id": 2622,
    "name": "Abram Cadabra",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/u/9u63nyaqk3k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 54,
      "control": 60,
      "pressure": 68,
      "agility": 60,
      "physical": 60,
      "technique": 44
    }
  },
  {
    "id": 2623,
    "name": "Jaymes Randie",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/7/d7zc0v1i_xu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 55,
      "control": 57,
      "pressure": 58,
      "agility": 46,
      "physical": 69,
      "technique": 46
    }
  },
  {
    "id": 2624,
    "name": "Daffyd Blayne",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/t/stojzqtysk8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 40,
      "control": 52,
      "pressure": 69,
      "agility": 47,
      "physical": 51,
      "technique": 60
    }
  },
  {
    "id": 2625,
    "name": "Al Kazam",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/y/uyv_3jb0xi8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 49,
      "control": 59,
      "pressure": 61,
      "agility": 58,
      "physical": 54,
      "technique": 56
    }
  },
  {
    "id": 2626,
    "name": "Sigfryd Roi",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/a/faeea2no6ru.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 48,
      "control": 42,
      "pressure": 66,
      "agility": 46,
      "physical": 60,
      "technique": 46
    }
  },
  {
    "id": 2627,
    "name": "Dave Coppfielder",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/1/_19rjrsgpxk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 60,
      "control": 78,
      "pressure": 50,
      "agility": 41,
      "physical": 49,
      "technique": 51
    }
  },
  {
    "id": 2628,
    "name": "Launce Berton",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/d/odmkku08icm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 70,
      "control": 65,
      "pressure": 47,
      "agility": 45,
      "physical": 47,
      "technique": 64
    }
  },
  {
    "id": 2629,
    "name": "Ledger Demain",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/3/63zsvz3ef9k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 55,
      "control": 79,
      "pressure": 47,
      "agility": 43,
      "physical": 47,
      "technique": 53
    }
  },
  {
    "id": 2630,
    "name": "Harrold Houdini",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/f/lfcz4mrkoom.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 71,
      "control": 64,
      "pressure": 57,
      "agility": 57,
      "physical": 60,
      "technique": 67
    }
  },
  {
    "id": 2631,
    "name": "Hocus Sesame",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/3/l3z-inytjis.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 47,
      "control": 46,
      "pressure": 50,
      "agility": 54,
      "physical": 43,
      "technique": 52
    }
  },
  {
    "id": 2632,
    "name": "Pocus Sesame",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/f/ufofpy-xkre.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 41,
      "control": 40,
      "pressure": 60,
      "agility": 61,
      "physical": 45,
      "technique": 64
    }
  },
  {
    "id": 2633,
    "name": "Pen Teller",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/w/0wlqcflfrx0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 59,
      "control": 53,
      "pressure": 70,
      "agility": 45,
      "physical": 65,
      "technique": 60
    }
  },
  {
    "id": 2634,
    "name": "Petey Sorcar",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/y/fy6lx6tl8cc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 59,
      "control": 57,
      "pressure": 60,
      "agility": 45,
      "physical": 56,
      "technique": 42
    }
  },
  {
    "id": 2635,
    "name": "Trump Loyal",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/5/h59xfj_j5ec.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 59,
      "control": 71,
      "pressure": 43,
      "agility": 55,
      "physical": 57,
      "technique": 56
    }
  },
  {
    "id": 2636,
    "name": "Daren Blakh",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/r/2rm2yczzu30.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 46,
      "control": 59,
      "pressure": 58,
      "agility": 54,
      "physical": 56,
      "technique": 68
    }
  },
  {
    "id": 2637,
    "name": "Billy Lingsoo",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/-/w-vdhbs7hxe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 59,
      "control": 52,
      "pressure": 60,
      "agility": 70,
      "physical": 41,
      "technique": 59
    }
  },
  {
    "id": 2638,
    "name": "Hans Sleight",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/j/mjxvz5yn-d8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 44,
      "control": 55,
      "pressure": 70,
      "agility": 49,
      "physical": 60,
      "technique": 44
    }
  },
  {
    "id": 2639,
    "name": "Ringo Saturn",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/4/z4gov70tlje.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 57,
      "control": 48,
      "pressure": 77,
      "agility": 43,
      "physical": 71,
      "technique": 45
    }
  },
  {
    "id": 2640,
    "name": "Auberon Ouranos",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/x/5xd7gmbl-p0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 43,
      "control": 56,
      "pressure": 70,
      "agility": 54,
      "physical": 70,
      "technique": 43
    }
  },
  {
    "id": 2641,
    "name": "Manning Moon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/_/i_yarznftac.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 60,
      "control": 42,
      "pressure": 67,
      "agility": 56,
      "physical": 59,
      "technique": 58
    }
  },
  {
    "id": 2642,
    "name": "Terran Gaea",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/e/ke1gfa1zwcc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 49,
      "control": 41,
      "pressure": 64,
      "agility": 42,
      "physical": 69,
      "technique": 60
    }
  },
  {
    "id": 2643,
    "name": "Crateris Mercury",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/2/72eno_tj7v0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 43,
      "control": 49,
      "pressure": 74,
      "agility": 55,
      "physical": 72,
      "technique": 59
    }
  },
  {
    "id": 2644,
    "name": "Nix Pluto",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/z/bzns7imbope.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 72,
      "control": 57,
      "pressure": 47,
      "agility": 57,
      "physical": 42,
      "technique": 56
    }
  },
  {
    "id": 2645,
    "name": "Neith Venus",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/x/qxwzwda7j8s.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 74,
      "control": 73,
      "pressure": 44,
      "agility": 59,
      "physical": 48,
      "technique": 54
    }
  },
  {
    "id": 2646,
    "name": "Callis Jove",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/b/ebprnqdzede.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 63,
      "control": 67,
      "pressure": 42,
      "agility": 54,
      "physical": 54,
      "technique": 57
    }
  },
  {
    "id": 2647,
    "name": "Deimos Mars",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/z/vzykkvljpws.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 72,
      "control": 63,
      "pressure": 53,
      "agility": 48,
      "physical": 47,
      "technique": 50
    }
  },
  {
    "id": 2648,
    "name": "Sol Daystar",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/b/bbdhqusqicm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 60,
      "control": 51,
      "pressure": 45,
      "agility": 59,
      "physical": 45,
      "technique": 72
    }
  },
  {
    "id": 2649,
    "name": "Triton Nettuno",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/z/wzym9rkqlvk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 46,
      "control": 60,
      "pressure": 45,
      "agility": 67,
      "physical": 40,
      "technique": 66
    }
  },
  {
    "id": 2650,
    "name": "Astro Ceres",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/c/qcrtum_yqpu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 46,
      "control": 46,
      "pressure": 72,
      "agility": 45,
      "physical": 71,
      "technique": 54
    }
  },
  {
    "id": 2651,
    "name": "Chiron Vestal",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/0/h0gydzzi988.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 41,
      "control": 47,
      "pressure": 53,
      "agility": 69,
      "physical": 53,
      "technique": 66
    }
  },
  {
    "id": 2652,
    "name": "Xeno Eris",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/v/jvnutqlo468.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 53,
      "control": 66,
      "pressure": 56,
      "agility": 52,
      "physical": 44,
      "technique": 59
    }
  },
  {
    "id": 2653,
    "name": "Namak Haumea",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/9/s9wpavt0vju.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 49,
      "control": 56,
      "pressure": 65,
      "agility": 60,
      "physical": 69,
      "technique": 46
    }
  },
  {
    "id": 2654,
    "name": "Mac Emake",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/s/ys16tiy8gpk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 48,
      "control": 52,
      "pressure": 71,
      "agility": 59,
      "physical": 63,
      "technique": 49
    }
  },
  {
    "id": 2655,
    "name": "Hailey Cometti",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/j/4jo3o0xvz8u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 57,
      "control": 51,
      "pressure": 57,
      "agility": 46,
      "physical": 67,
      "technique": 57
    }
  },
  {
    "id": 2656,
    "name": "Theo Divine",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/v/fvoizxpndae.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 43,
      "control": 41,
      "pressure": 75,
      "agility": 46,
      "physical": 57,
      "technique": 50
    }
  },
  {
    "id": 2657,
    "name": "Mnemo Pool",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/6/_6t9ks6vog0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 51,
      "control": 60,
      "pressure": 70,
      "agility": 41,
      "physical": 58,
      "technique": 58
    }
  },
  {
    "id": 2658,
    "name": "Perses Destroyer",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/s/osccntcvftc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 45,
      "control": 47,
      "pressure": 74,
      "agility": 45,
      "physical": 52,
      "technique": 58
    }
  },
  {
    "id": 2659,
    "name": "Iapetus Pierce",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/z/mzbajko5avc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 43,
      "control": 44,
      "pressure": 67,
      "agility": 44,
      "physical": 73,
      "technique": 48
    }
  },
  {
    "id": 2660,
    "name": "Phoebus Moonlight",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/b/9bqhk1odtm0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 59,
      "control": 50,
      "pressure": 70,
      "agility": 55,
      "physical": 54,
      "technique": 59
    }
  },
  {
    "id": 2661,
    "name": "Rae Godmother",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/0/d0ju3odlyge.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 58,
      "control": 68,
      "pressure": 51,
      "agility": 59,
      "physical": 45,
      "technique": 62
    }
  },
  {
    "id": 2662,
    "name": "Hyperion Wise",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/c/sc41ax7x11s.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 53,
      "control": 60,
      "pressure": 53,
      "agility": 54,
      "physical": 46,
      "technique": 60
    }
  },
  {
    "id": 2663,
    "name": "Cronus Fourseasons",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/2/y2htra4tske.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 58,
      "control": 64,
      "pressure": 43,
      "agility": 43,
      "physical": 57,
      "technique": 53
    }
  },
  {
    "id": 2664,
    "name": "Oceanus Worldstream",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/e/pe2mglep_5s.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 78,
      "control": 59,
      "pressure": 52,
      "agility": 54,
      "physical": 56,
      "technique": 72
    }
  },
  {
    "id": 2665,
    "name": "Coeus Heavens",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/2/h2tbckxgevm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 43,
      "control": 60,
      "pressure": 50,
      "agility": 70,
      "physical": 49,
      "technique": 66
    }
  },
  {
    "id": 2666,
    "name": "Tet Aqua",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/e/2ecgxbxazmk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 46,
      "control": 43,
      "pressure": 57,
      "agility": 55,
      "physical": 52,
      "technique": 58
    }
  },
  {
    "id": 2667,
    "name": "Eos Dawn",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/x/wx_vigesggu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 50,
      "control": 41,
      "pressure": 65,
      "agility": 51,
      "physical": 77,
      "technique": 42
    }
  },
  {
    "id": 2668,
    "name": "Pallas Brandish",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/z/nzo0p5ior18.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 55,
      "control": 41,
      "pressure": 65,
      "agility": 53,
      "physical": 69,
      "technique": 40
    }
  },
  {
    "id": 2669,
    "name": "Themis Law",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/4/l4johgweuz8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 71,
      "control": 51,
      "pressure": 55,
      "agility": 49,
      "physical": 57,
      "technique": 54
    }
  },
  {
    "id": 2670,
    "name": "Atlas Carrier",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/q/uq4jmfw-dau.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 55,
      "control": 51,
      "pressure": 56,
      "agility": 73,
      "physical": 47,
      "technique": 64
    }
  },
  {
    "id": 2671,
    "name": "Orion Hunter",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/_/0_b8fcj22gk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 69,
      "control": 55,
      "pressure": 56,
      "agility": 60,
      "physical": 49,
      "technique": 64
    }
  },
  {
    "id": 2672,
    "name": "Alex Zabel",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/n/rnibivvd8uc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 57,
      "control": 44,
      "pressure": 56,
      "agility": 68,
      "physical": 51,
      "technique": 61
    }
  },
  {
    "id": 2673,
    "name": "Dave Quagmire",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/k/_ko_f7wg2he.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 59,
      "control": 67,
      "pressure": 55,
      "agility": 45,
      "physical": 43,
      "technique": 64
    }
  },
  {
    "id": 2674,
    "name": "Quentin Cinquedea",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/v/_vaot5sbd5m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 48,
      "control": 57,
      "pressure": 57,
      "agility": 53,
      "physical": 73,
      "technique": 50
    }
  },
  {
    "id": 2675,
    "name": "Aimé Quintet",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/6/f657-kzt2z8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 60,
      "control": 49,
      "pressure": 73,
      "agility": 48,
      "physical": 70,
      "technique": 52
    }
  },
  {
    "id": 2676,
    "name": "Eljas Viisi",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/s/usiatb_pbqu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 58,
      "control": 45,
      "pressure": 57,
      "agility": 43,
      "physical": 61,
      "technique": 42
    }
  },
  {
    "id": 2677,
    "name": "Pentra Chek",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/z/szpg9ctfesu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 66,
      "control": 64,
      "pressure": 47,
      "agility": 50,
      "physical": 49,
      "technique": 54
    }
  },
  {
    "id": 2678,
    "name": "Federigo Cinco",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/b/db-nq9l_zf8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 59,
      "control": 69,
      "pressure": 47,
      "agility": 58,
      "physical": 50,
      "technique": 62
    }
  },
  {
    "id": 2679,
    "name": "Ferdinand Delafünfe",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/0/90dsdg-3g_m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 60,
      "control": 62,
      "pressure": 41,
      "agility": 59,
      "physical": 44,
      "technique": 58
    }
  },
  {
    "id": 2680,
    "name": "Quinque Flores",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/c/mcszufynrmk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 57,
      "control": 47,
      "pressure": 41,
      "agility": 72,
      "physical": 55,
      "technique": 58
    }
  },
  {
    "id": 2681,
    "name": "Jacques Cinquini",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/2/42trfsbvmzm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 52,
      "control": 43,
      "pressure": 54,
      "agility": 69,
      "physical": 56,
      "technique": 63
    }
  },
  {
    "id": 2682,
    "name": "Fivier Saviola",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/e/jeikyt9vhak.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 64,
      "control": 61,
      "pressure": 47,
      "agility": 43,
      "physical": 59,
      "technique": 68
    }
  },
  {
    "id": 2683,
    "name": "David Quintola",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/2/n25hos0case.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 46,
      "control": 43,
      "pressure": 53,
      "agility": 66,
      "physical": 47,
      "technique": 63
    }
  },
  {
    "id": 2684,
    "name": "Erik Pentona",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/e/weimftsmtfs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 46,
      "control": 51,
      "pressure": 54,
      "agility": 72,
      "physical": 51,
      "technique": 49
    }
  },
  {
    "id": 2685,
    "name": "Leonidas Epsilon",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/x/2xrtwonuy_c.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 56,
      "control": 41,
      "pressure": 75,
      "agility": 40,
      "physical": 68,
      "technique": 50
    }
  },
  {
    "id": 2686,
    "name": "George Wu",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/z/hzay7xbu1m0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 66,
      "control": 78,
      "pressure": 55,
      "agility": 53,
      "physical": 55,
      "technique": 62
    }
  },
  {
    "id": 2687,
    "name": "Geert Vandevijf",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/4/f4duvot4wk0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 45,
      "control": 41,
      "pressure": 41,
      "agility": 62,
      "physical": 50,
      "technique": 57
    }
  },
  {
    "id": 2688,
    "name": "Folke Fem",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/q/0qsp4x1cd5c.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 77,
      "control": 65,
      "pressure": 50,
      "agility": 51,
      "physical": 58,
      "technique": 63
    }
  },
  {
    "id": 2689,
    "name": "Naji Khamsa",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/_/u_p6rkakozs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 58,
      "control": 59,
      "pressure": 74,
      "agility": 51,
      "physical": 60,
      "technique": 47
    }
  },
  {
    "id": 2690,
    "name": "Gyan Cinquedea",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/f/bfvxma6x-um.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 58,
      "control": 74,
      "pressure": 55,
      "agility": 59,
      "physical": 49,
      "technique": 54
    }
  },
  {
    "id": 2691,
    "name": "Albion Lumina",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/d/tdxsu9wyjgc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 41,
      "control": 51,
      "pressure": 75,
      "agility": 58,
      "physical": 74,
      "technique": 44
    }
  },
  {
    "id": 2692,
    "name": "Candido Glow",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/s/ns0nhgjqwms.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 59,
      "control": 51,
      "pressure": 69,
      "agility": 55,
      "physical": 62,
      "technique": 51
    }
  },
  {
    "id": 2693,
    "name": "Dwight Whittaker",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/e/8efgqffq7ve.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 50,
      "control": 54,
      "pressure": 60,
      "agility": 56,
      "physical": 60,
      "technique": 48
    }
  },
  {
    "id": 2694,
    "name": "Beamer Daye",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/l/-lcaegxg-te.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 51,
      "control": 58,
      "pressure": 53,
      "agility": 52,
      "physical": 64,
      "technique": 50
    }
  },
  {
    "id": 2695,
    "name": "Chandler Blanc",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/n/pnz7p5x8tgs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 55,
      "control": 46,
      "pressure": 54,
      "agility": 55,
      "physical": 73,
      "technique": 50
    }
  },
  {
    "id": 2696,
    "name": "Beacon Noor",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/i/viqo6ke0mac.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 73,
      "control": 68,
      "pressure": 60,
      "agility": 56,
      "physical": 53,
      "technique": 58
    }
  },
  {
    "id": 2697,
    "name": "Dawntavius Spectrum",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/k/ekhvxbiolz0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 68,
      "control": 60,
      "pressure": 46,
      "agility": 51,
      "physical": 43,
      "technique": 51
    }
  },
  {
    "id": 2698,
    "name": "Brighton Spark",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/g/qge3mwhssmc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 64,
      "control": 61,
      "pressure": 52,
      "agility": 45,
      "physical": 51,
      "technique": 65
    }
  },
  {
    "id": 2699,
    "name": "Laban Lux",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/i/bivwlphwb_0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 74,
      "control": 64,
      "pressure": 48,
      "agility": 47,
      "physical": 44,
      "technique": 56
    }
  },
  {
    "id": 2700,
    "name": "Bailong",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/g/1g0broofgtu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 40,
      "control": 46,
      "pressure": 45,
      "agility": 54,
      "physical": 47,
      "technique": 49
    }
  },
  {
    "id": 2701,
    "name": "Filbert Weissman",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/i/eif68xolng8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 59,
      "control": 40,
      "pressure": 58,
      "agility": 62,
      "physical": 54,
      "technique": 61
    }
  },
  {
    "id": 2702,
    "name": "Nero Night",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/d/nddug11k9_u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 48,
      "control": 54,
      "pressure": 74,
      "agility": 45,
      "physical": 77,
      "technique": 40
    }
  },
  {
    "id": 2703,
    "name": "Morris Moore",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/s/tsghzoasifk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 46,
      "control": 49,
      "pressure": 50,
      "agility": 55,
      "physical": 58,
      "technique": 49
    }
  },
  {
    "id": 2704,
    "name": "Jet Onyx",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/e/ceraexmwlsm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 49,
      "control": 58,
      "pressure": 76,
      "agility": 44,
      "physical": 74,
      "technique": 45
    }
  },
  {
    "id": 2705,
    "name": "Cole Ebony",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/l/elwcwo06gqm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 52,
      "control": 46,
      "pressure": 61,
      "agility": 60,
      "physical": 73,
      "technique": 47
    }
  },
  {
    "id": 2706,
    "name": "Blake Obscura",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/n/vnn9dxsanzk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 47,
      "control": 57,
      "pressure": 68,
      "agility": 52,
      "physical": 65,
      "technique": 47
    }
  },
  {
    "id": 2707,
    "name": "Shady Shwartz",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/i/pieiosni45u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 54,
      "control": 71,
      "pressure": 51,
      "agility": 41,
      "physical": 40,
      "technique": 63
    }
  },
  {
    "id": 2708,
    "name": "Goth Grimshaw",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/k/-k1pjtbyvk8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 52,
      "control": 80,
      "pressure": 42,
      "agility": 54,
      "physical": 44,
      "technique": 74
    }
  },
  {
    "id": 2709,
    "name": "Duff Dooley",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/g/kgkxsecqy1u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 70,
      "control": 64,
      "pressure": 42,
      "agility": 57,
      "physical": 52,
      "technique": 52
    }
  },
  {
    "id": 2710,
    "name": "Tynan Crowe",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/i/7i7q_hkqfg8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 71,
      "control": 69,
      "pressure": 53,
      "agility": 56,
      "physical": 47,
      "technique": 47
    }
  },
  {
    "id": 2711,
    "name": "Tezcat",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/g/vggdlgtj-qc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 55,
      "control": 43,
      "pressure": 47,
      "agility": 76,
      "physical": 54,
      "technique": 63
    }
  },
  {
    "id": 2712,
    "name": "Yang",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/i/kir8iflztz0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 45,
      "control": 46,
      "pressure": 51,
      "agility": 73,
      "physical": 57,
      "technique": 64
    }
  },
  {
    "id": 2713,
    "name": "Pinkus Mountbatten",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/z/uzm8omoc9n8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 59,
      "control": 67,
      "pressure": 56,
      "agility": 58,
      "physical": 59,
      "technique": 53
    }
  },
  {
    "id": 2714,
    "name": "Flint Charcoal",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/c/ocfj7rdkihm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 75,
      "control": 73,
      "pressure": 53,
      "agility": 47,
      "physical": 59,
      "technique": 69
    }
  },
  {
    "id": 2715,
    "name": "Glaucous Gull",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/0/_00owu7wl0k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 57,
      "control": 54,
      "pressure": 58,
      "agility": 57,
      "physical": 43,
      "technique": 60
    }
  },
  {
    "id": 2716,
    "name": "Ashley Silverwood",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/v/9vz043pcgyk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 54,
      "control": 50,
      "pressure": 67,
      "agility": 41,
      "physical": 67,
      "technique": 57
    }
  },
  {
    "id": 2717,
    "name": "Gus Martin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/9/m9cvvipmnbm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 53,
      "control": 41,
      "pressure": 59,
      "agility": 49,
      "physical": 62,
      "technique": 54
    }
  },
  {
    "id": 2718,
    "name": "Cinereous Slate",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/s/sshggv6u4h8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 58,
      "control": 48,
      "pressure": 68,
      "agility": 56,
      "physical": 64,
      "technique": 60
    }
  },
  {
    "id": 2719,
    "name": "Damien Blackloch",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/f/hfxy12ymgvm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 45,
      "control": 40,
      "pressure": 51,
      "agility": 67,
      "physical": 46,
      "technique": 74
    }
  },
  {
    "id": 2720,
    "name": "Xavier Shotwell",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/t/qtatyj-crck.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 59,
      "control": 45,
      "pressure": 72,
      "agility": 47,
      "physical": 69,
      "technique": 51
    }
  },
  {
    "id": 2721,
    "name": "Crimson Wiseman",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/c/wcjmlulue8u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 60,
      "control": 48,
      "pressure": 59,
      "agility": 47,
      "physical": 70,
      "technique": 52
    }
  },
  {
    "id": 2722,
    "name": "Linden Haregrove",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/q/bqshmrtuzp8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 42,
      "control": 58,
      "pressure": 71,
      "agility": 51,
      "physical": 67,
      "technique": 47
    }
  },
  {
    "id": 2723,
    "name": "Jared Dapplegrey",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/l/dlvbiy_c2j8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 57,
      "control": 45,
      "pressure": 54,
      "agility": 43,
      "physical": 68,
      "technique": 47
    }
  },
  {
    "id": 2724,
    "name": "Keith Wellington",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/j/yjk6lnz4b6u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 46,
      "control": 51,
      "pressure": 59,
      "agility": 51,
      "physical": 66,
      "technique": 40
    }
  },
  {
    "id": 2725,
    "name": "Cirrus Whisp",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/m/smhp2qswuak.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 69,
      "control": 73,
      "pressure": 50,
      "agility": 60,
      "physical": 51,
      "technique": 64
    }
  },
  {
    "id": 2726,
    "name": "Gamal Everlast",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/k/jk2ubvkkdpm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 73,
      "control": 53,
      "pressure": 60,
      "agility": 58,
      "physical": 41,
      "technique": 52
    }
  },
  {
    "id": 2727,
    "name": "Sandy Dryhill",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/o/xoj2qijokwk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 58,
      "control": 69,
      "pressure": 54,
      "agility": 44,
      "physical": 50,
      "technique": 57
    }
  },
  {
    "id": 2728,
    "name": "Dryden Zephyr",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/m/mm4xhdvsjlm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 69,
      "control": 60,
      "pressure": 57,
      "agility": 60,
      "physical": 46,
      "technique": 55
    }
  },
  {
    "id": 2729,
    "name": "Solomon Roundhay",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/o/iojadcmbojs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 49,
      "control": 56,
      "pressure": 47,
      "agility": 77,
      "physical": 49,
      "technique": 54
    }
  },
  {
    "id": 2730,
    "name": "Harry Dwind",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/m/5ms7wjahf6e.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 58,
      "control": 45,
      "pressure": 49,
      "agility": 50,
      "physical": 44,
      "technique": 54
    }
  },
  {
    "id": 2731,
    "name": "Brutus Nastion",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/j/zjxoj-1pwa0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 54,
      "control": 41,
      "pressure": 75,
      "agility": 46,
      "physical": 67,
      "technique": 52
    }
  },
  {
    "id": 2732,
    "name": "Linder Loper",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/h/ohavobttdpc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 58,
      "control": 45,
      "pressure": 60,
      "agility": 52,
      "physical": 68,
      "technique": 40
    }
  },
  {
    "id": 2733,
    "name": "Jude Osbourne",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/a/qahzgyb_yvc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 54,
      "control": 52,
      "pressure": 66,
      "agility": 49,
      "physical": 58,
      "technique": 59
    }
  },
  {
    "id": 2734,
    "name": "Locke Saflowe",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/o/bo2snnnf1c0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 56,
      "control": 57,
      "pressure": 50,
      "agility": 60,
      "physical": 65,
      "technique": 40
    }
  },
  {
    "id": 2735,
    "name": "Nate Gobby",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/h/7hvne6sna8e.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 45,
      "control": 50,
      "pressure": 61,
      "agility": 50,
      "physical": 66,
      "technique": 57
    }
  },
  {
    "id": 2736,
    "name": "Reggie Alldark",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/v/kvkgzf03tps.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 65,
      "control": 69,
      "pressure": 45,
      "agility": 41,
      "physical": 60,
      "technique": 74
    }
  },
  {
    "id": 2737,
    "name": "Bill Froger",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/f/-fbeci3vkwe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 67,
      "control": 67,
      "pressure": 45,
      "agility": 52,
      "physical": 55,
      "technique": 69
    }
  },
  {
    "id": 2738,
    "name": "Romeo Fitzroy",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/t/ptq_v3rvnds.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 66,
      "control": 73,
      "pressure": 46,
      "agility": 45,
      "physical": 56,
      "technique": 53
    }
  },
  {
    "id": 2739,
    "name": "Caesar Lionheart",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/t/zt8umyilmqc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 70,
      "control": 55,
      "pressure": 48,
      "agility": 46,
      "physical": 49,
      "technique": 59
    }
  },
  {
    "id": 2740,
    "name": "Stan Roller",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/7/c7nphneflj0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 49,
      "control": 55,
      "pressure": 49,
      "agility": 57,
      "physical": 44,
      "technique": 67
    }
  },
  {
    "id": 2741,
    "name": "Bracknell Forge",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/u/iuu6yqxx-de.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 60,
      "control": 45,
      "pressure": 58,
      "agility": 61,
      "physical": 47,
      "technique": 70
    }
  },
  {
    "id": 2742,
    "name": "Vivian Doosley",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/l/8lrgrisbdys.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 55,
      "control": 53,
      "pressure": 79,
      "agility": 58,
      "physical": 67,
      "technique": 44
    }
  },
  {
    "id": 2743,
    "name": "Sean Muller",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/k/ckivcvnjo4c.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 58,
      "control": 40,
      "pressure": 58,
      "agility": 50,
      "physical": 56,
      "technique": 53
    }
  },
  {
    "id": 2744,
    "name": "Abe Roof",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/i/ti50vqbzfl0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 60,
      "control": 60,
      "pressure": 71,
      "agility": 46,
      "physical": 71,
      "technique": 48
    }
  },
  {
    "id": 2745,
    "name": "Buck Tucker",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/d/vd-obztfan0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 48,
      "control": 42,
      "pressure": 61,
      "agility": 41,
      "physical": 72,
      "technique": 44
    }
  },
  {
    "id": 2746,
    "name": "Edward Headwood",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/r/erpjsm1lt-c.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 56,
      "control": 53,
      "pressure": 58,
      "agility": 59,
      "physical": 72,
      "technique": 47
    }
  },
  {
    "id": 2747,
    "name": "Ricky Shea",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/e/-es8_ratyes.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 57,
      "control": 64,
      "pressure": 55,
      "agility": 56,
      "physical": 40,
      "technique": 72
    }
  },
  {
    "id": 2748,
    "name": "Felix Higgins",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/s/psddsumx1te.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 67,
      "control": 67,
      "pressure": 51,
      "agility": 50,
      "physical": 42,
      "technique": 50
    }
  },
  {
    "id": 2749,
    "name": "Warren Cool",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/g/7gifjjl1sss.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 47,
      "control": 50,
      "pressure": 46,
      "agility": 61,
      "physical": 58,
      "technique": 61
    }
  },
  {
    "id": 2750,
    "name": "Keeley Hall",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/u/kutkocdp_he.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 58,
      "control": 58,
      "pressure": 42,
      "agility": 56,
      "physical": 54,
      "technique": 71
    }
  },
  {
    "id": 2751,
    "name": "Walt Riverside",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/g/kgipudkgenk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 63,
      "control": 61,
      "pressure": 41,
      "agility": 50,
      "physical": 51,
      "technique": 49
    }
  },
  {
    "id": 2752,
    "name": "Elizabeth Buble",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/u/vu5i5is8z-m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 81,
      "intelligence": 55,
      "control": 55,
      "pressure": 45,
      "agility": 59,
      "physical": 46,
      "technique": 58
    }
  },
  {
    "id": 2753,
    "name": "Titch Allhare",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/b/1ba9q_z0ge8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 59,
      "control": 55,
      "pressure": 61,
      "agility": 45,
      "physical": 65,
      "technique": 53
    }
  },
  {
    "id": 2754,
    "name": "Puck Fishley",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/p/eprcha_ortu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 49,
      "control": 47,
      "pressure": 66,
      "agility": 51,
      "physical": 50,
      "technique": 45
    }
  },
  {
    "id": 2755,
    "name": "Reed Maind",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/i/gisapztiuru.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 60,
      "control": 56,
      "pressure": 43,
      "agility": 49,
      "physical": 49,
      "technique": 60
    }
  },
  {
    "id": 2756,
    "name": "Jacqueline Rabbit",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/g/3gdhemlydy8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 50,
      "control": 51,
      "pressure": 48,
      "agility": 72,
      "physical": 57,
      "technique": 57
    }
  },
  {
    "id": 2757,
    "name": "Bert Trapper",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/p/xp-ux7-q24m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 56,
      "control": 60,
      "pressure": 77,
      "agility": 41,
      "physical": 67,
      "technique": 44
    }
  },
  {
    "id": 2758,
    "name": "Steve Grim",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/m/mmlfvr44nnk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 72,
      "control": 52,
      "pressure": 43,
      "agility": 46,
      "physical": 53,
      "technique": 63
    }
  },
  {
    "id": 2759,
    "name": "Millie Moonlight",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/j/sjoq82nw4tu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 43,
      "control": 43,
      "pressure": 52,
      "agility": 56,
      "physical": 52,
      "technique": 53
    }
  },
  {
    "id": 2760,
    "name": "Chuck Pumpkins",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/v/jvnrm0ifi48.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 60,
      "control": 52,
      "pressure": 62,
      "agility": 45,
      "physical": 66,
      "technique": 47
    }
  },
  {
    "id": 2761,
    "name": "Scott Banyan",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/a/paue1pxxxym.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 57,
      "control": 51,
      "pressure": 60,
      "agility": 42,
      "physical": 70,
      "technique": 50
    }
  },
  {
    "id": 2762,
    "name": "Filbert Chestnut",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/o/yof_ywxt6rk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 45,
      "control": 54,
      "pressure": 67,
      "agility": 57,
      "physical": 79,
      "technique": 41
    }
  },
  {
    "id": 2763,
    "name": "Gadish Oldman",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/j/ajyj2pjb_tk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 49,
      "control": 59,
      "pressure": 72,
      "agility": 53,
      "physical": 67,
      "technique": 49
    }
  },
  {
    "id": 2764,
    "name": "Autumn Leaf",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/h/rhpcbwf7sem.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 41,
      "control": 43,
      "pressure": 61,
      "agility": 42,
      "physical": 67,
      "technique": 49
    }
  },
  {
    "id": 2765,
    "name": "Skeeter Hawk",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/o/lok3itwzn-8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 72,
      "control": 59,
      "pressure": 56,
      "agility": 46,
      "physical": 44,
      "technique": 57
    }
  },
  {
    "id": 2766,
    "name": "Hal Löwén",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/m/6m7wlswjknu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 79,
      "control": 74,
      "pressure": 50,
      "agility": 49,
      "physical": 59,
      "technique": 65
    }
  },
  {
    "id": 2767,
    "name": "Jacko Lantern",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/m/omeoufvrty8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 66,
      "control": 66,
      "pressure": 43,
      "agility": 51,
      "physical": 52,
      "technique": 57
    }
  },
  {
    "id": 2768,
    "name": "Guy-Jean Harvestman",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/k/_k1v5gzrabu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 69,
      "control": 71,
      "pressure": 59,
      "agility": 42,
      "physical": 53,
      "technique": 57
    }
  },
  {
    "id": 2769,
    "name": "Bobine Apples",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/m/rmuijh6yht0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 60,
      "control": 57,
      "pressure": 59,
      "agility": 58,
      "physical": 47,
      "technique": 58
    }
  },
  {
    "id": 2770,
    "name": "Sibylle Equinox",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/k/gkfdoecimec.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 45,
      "control": 50,
      "pressure": 60,
      "agility": 74,
      "physical": 49,
      "technique": 68
    }
  },
  {
    "id": 2771,
    "name": "Silvia Woods",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/p/hp5wumlbrne.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 51,
      "control": 45,
      "pressure": 71,
      "agility": 47,
      "physical": 61,
      "technique": 59
    }
  },
  {
    "id": 2772,
    "name": "Clem Attish",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/l/cl_mlax9dhk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 45,
      "control": 44,
      "pressure": 70,
      "agility": 53,
      "physical": 56,
      "technique": 48
    }
  },
  {
    "id": 2773,
    "name": "Tyrian Purpel",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/k/8kct2de12bu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 59,
      "control": 71,
      "pressure": 56,
      "agility": 48,
      "physical": 45,
      "technique": 69
    }
  },
  {
    "id": 2774,
    "name": "Pike Pollack",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/i/nitybiipby8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 57,
      "control": 46,
      "pressure": 60,
      "agility": 47,
      "physical": 69,
      "technique": 46
    }
  },
  {
    "id": 2775,
    "name": "Martin Blando",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/d/pdqu17wje08.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 54,
      "control": 59,
      "pressure": 73,
      "agility": 43,
      "physical": 55,
      "technique": 43
    }
  },
  {
    "id": 2776,
    "name": "Keane Gardner",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/r/-rbpyewzzhu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 40,
      "control": 48,
      "pressure": 65,
      "agility": 53,
      "physical": 72,
      "technique": 55
    }
  },
  {
    "id": 2777,
    "name": "Shaun Bonce",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/e/ee46lzjrgnk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 60,
      "control": 76,
      "pressure": 43,
      "agility": 53,
      "physical": 41,
      "technique": 75
    }
  },
  {
    "id": 2778,
    "name": "Penn Minim",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/s/vsjbmmfrrum.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 67,
      "control": 67,
      "pressure": 40,
      "agility": 40,
      "physical": 48,
      "technique": 58
    }
  },
  {
    "id": 2779,
    "name": "Brook Bold",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/g/bg2dxrgjmrk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 68,
      "control": 68,
      "pressure": 49,
      "agility": 48,
      "physical": 52,
      "technique": 57
    }
  },
  {
    "id": 2780,
    "name": "Francis Tuffnot",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/u/quhi6ugzhym.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 58,
      "control": 50,
      "pressure": 58,
      "agility": 53,
      "physical": 58,
      "technique": 56
    }
  },
  {
    "id": 2781,
    "name": "Joshua Bleak",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/g/egcvgvp6a0s.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 59,
      "control": 40,
      "pressure": 50,
      "agility": 65,
      "physical": 57,
      "technique": 66
    }
  },
  {
    "id": 2782,
    "name": "Hayden Whyrl",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/u/1utonqpathe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 53,
      "control": 51,
      "pressure": 56,
      "agility": 66,
      "physical": 51,
      "technique": 52
    }
  },
  {
    "id": 2783,
    "name": "Matt Durer",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/b/vbo7e36iyn0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 52,
      "control": 47,
      "pressure": 71,
      "agility": 51,
      "physical": 72,
      "technique": 57
    }
  },
  {
    "id": 2784,
    "name": "Nixon Earlnight",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/p/kp_azicy1uc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 44,
      "control": 52,
      "pressure": 76,
      "agility": 45,
      "physical": 64,
      "technique": 57
    }
  },
  {
    "id": 2785,
    "name": "Jack Balance",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/i/mi4gdroewsc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 65,
      "control": 61,
      "pressure": 43,
      "agility": 40,
      "physical": 49,
      "technique": 67
    }
  },
  {
    "id": 2786,
    "name": "Skylar Lepton",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/g/xgjnwuokdh0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 47,
      "control": 57,
      "pressure": 65,
      "agility": 48,
      "physical": 63,
      "technique": 48
    }
  },
  {
    "id": 2787,
    "name": "Tarquin Orchards",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/p/3pqsjzdsobe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 59,
      "control": 58,
      "pressure": 50,
      "agility": 77,
      "physical": 43,
      "technique": 72
    }
  },
  {
    "id": 2788,
    "name": "Arion Sherwind",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/o/uov2svfc9ru.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 58,
      "control": 63,
      "pressure": 53,
      "agility": 48,
      "physical": 51,
      "technique": 52
    }
  },
  {
    "id": 2789,
    "name": "Spotter",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/o/eoahtgovnru.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 69,
      "control": 61,
      "pressure": 55,
      "agility": 54,
      "physical": 47,
      "technique": 61
    }
  },
  {
    "id": 2791,
    "name": "Charley Horse",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/p/ups4-dkf2yc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 51,
      "control": 55,
      "pressure": 63,
      "agility": 57,
      "physical": 72,
      "technique": 43
    }
  },
  {
    "id": 2792,
    "name": "Chester Horse Sr",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/n/lndztis_br0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 56,
      "control": 53,
      "pressure": 76,
      "agility": 43,
      "physical": 54,
      "technique": 40
    }
  },
  {
    "id": 2795,
    "name": "Janison Veteran",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/3/q3-7fz-65-k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 54,
      "control": 44,
      "pressure": 80,
      "agility": 58,
      "physical": 59,
      "technique": 55
    }
  },
  {
    "id": 2796,
    "name": "Nelly Evans",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/u/wurkqeypzec.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 48,
      "control": 51,
      "pressure": 51,
      "agility": 62,
      "physical": 42,
      "technique": 68
    }
  },
  {
    "id": 2797,
    "name": "Camellia Travis",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/i/fi-sa_z3ule.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 51,
      "control": 59,
      "pressure": 65,
      "agility": 51,
      "physical": 61,
      "technique": 57
    }
  },
  {
    "id": 2798,
    "name": "William Glass",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/h/ohmdbyquilk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 45,
      "control": 45,
      "pressure": 41,
      "agility": 77,
      "physical": 44,
      "technique": 58
    }
  },
  {
    "id": 2799,
    "name": "Aquilina Schiller",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/f/hfpaymyaunm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 41,
      "control": 50,
      "pressure": 41,
      "agility": 68,
      "physical": 52,
      "technique": 65
    }
  },
  {
    "id": 2800,
    "name": "Seymour Hillman",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/r/5rxybedzoi8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 47,
      "control": 53,
      "pressure": 58,
      "agility": 45,
      "physical": 61,
      "technique": 49
    }
  },
  {
    "id": 2801,
    "name": "Percival Travis",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/g/0gpnta_nd4s.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 75,
      "control": 70,
      "pressure": 42,
      "agility": 56,
      "physical": 59,
      "technique": 55
    }
  },
  {
    "id": 2802,
    "name": "Sonny Raimon",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/y/kyhlyiplm9u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 54,
      "control": 60,
      "pressure": 48,
      "agility": 69,
      "physical": 44,
      "technique": 62
    }
  },
  {
    "id": 2803,
    "name": "Frank Wintersea",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/5/i5a5277jj7u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 40,
      "control": 58,
      "pressure": 60,
      "agility": 58,
      "physical": 61,
      "technique": 45
    }
  },
  {
    "id": 2804,
    "name": "Faythe Heeler",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/i/oi_eyewabss.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 41,
      "control": 49,
      "pressure": 65,
      "agility": 47,
      "physical": 59,
      "technique": 57
    }
  },
  {
    "id": 2805,
    "name": "Julia Blaze",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/r/9rjjxiimzne.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 74,
      "control": 73,
      "pressure": 57,
      "agility": 53,
      "physical": 54,
      "technique": 69
    }
  },
  {
    "id": 2806,
    "name": "Nathan Swift",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/e/desox8ppge0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 46,
      "control": 58,
      "pressure": 63,
      "agility": 46,
      "physical": 67,
      "technique": 51
    }
  },
  {
    "id": 2807,
    "name": "Jack Wallside",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/n/unkvua7_ixc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 50,
      "control": 59,
      "pressure": 56,
      "agility": 54,
      "physical": 75,
      "technique": 45
    }
  },
  {
    "id": 2808,
    "name": "Kevin Dragonfly",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/p/4p_kytf5foe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 60,
      "control": 55,
      "pressure": 56,
      "agility": 76,
      "physical": 49,
      "technique": 57
    }
  },
  {
    "id": 2809,
    "name": "Shawn Froste",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/p/npvivtwkt3m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 53,
      "control": 53,
      "pressure": 49,
      "agility": 65,
      "physical": 50,
      "technique": 65
    }
  },
  {
    "id": 2810,
    "name": "Caleb Stonewall",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/r/9rxdeh6hvke.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 61,
      "control": 68,
      "pressure": 44,
      "agility": 48,
      "physical": 52,
      "technique": 53
    }
  },
  {
    "id": 2811,
    "name": "Darren LaChance",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/o/9o6-cuecg-m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 29,
      "intelligence": 40,
      "control": 50,
      "pressure": 71,
      "agility": 55,
      "physical": 67,
      "technique": 41
    }
  },
  {
    "id": 2812,
    "name": "Xavier Schiller",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/b/jbof1s5dybs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 41,
      "control": 60,
      "pressure": 51,
      "agility": 54,
      "physical": 51,
      "technique": 58
    }
  },
  {
    "id": 2813,
    "name": "Jordan Greenway",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/l/fltkmmfodb0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 62,
      "control": 54,
      "pressure": 56,
      "agility": 54,
      "physical": 40,
      "technique": 67
    }
  },
  {
    "id": 2814,
    "name": "Austin Hobbes",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/n/uncrhzjsuyc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 46,
      "control": 55,
      "pressure": 45,
      "agility": 76,
      "physical": 50,
      "technique": 62
    }
  },
  {
    "id": 2815,
    "name": "Archer Hawkins",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/v/_v9isnmul4m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 44,
      "control": 43,
      "pressure": 74,
      "agility": 43,
      "physical": 72,
      "technique": 48
    }
  },
  {
    "id": 2816,
    "name": "Victoria Vanguard",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/h/dhzlrjrkve8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 56,
      "control": 63,
      "pressure": 44,
      "agility": 53,
      "physical": 42,
      "technique": 58
    }
  },
  {
    "id": 2817,
    "name": "Maia",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/d/md4ccde2eus.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 42,
      "control": 45,
      "pressure": 56,
      "agility": 44,
      "physical": 65,
      "technique": 48
    }
  },
  {
    "id": 2818,
    "name": "Icarus Damselfly",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/y/ty-w2uof4n8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 54,
      "control": 59,
      "pressure": 54,
      "agility": 75,
      "physical": 53,
      "technique": 55
    }
  },
  {
    "id": 2819,
    "name": "Casey Moth",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/d/zddflz7xnhm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 42,
      "control": 40,
      "pressure": 54,
      "agility": 40,
      "physical": 61,
      "technique": 45
    }
  },
  {
    "id": 2820,
    "name": "Mariposa Papillon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/1/c1skimdtg0k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 41,
      "control": 43,
      "pressure": 61,
      "agility": 45,
      "physical": 66,
      "technique": 46
    }
  },
  {
    "id": 2821,
    "name": "Paris Sight",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/u/aur4mvpblyk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 40,
      "control": 47,
      "pressure": 56,
      "agility": 50,
      "physical": 62,
      "technique": 42
    }
  },
  {
    "id": 2822,
    "name": "Luca Cervus",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/8/x8azlqp7ibm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 56,
      "control": 40,
      "pressure": 46,
      "agility": 67,
      "physical": 44,
      "technique": 47
    }
  },
  {
    "id": 2823,
    "name": "Cole Optera",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/t/rt5sy3cz9h8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 48,
      "control": 55,
      "pressure": 48,
      "agility": 58,
      "physical": 48,
      "technique": 67
    }
  },
  {
    "id": 2824,
    "name": "Hamish Voracio",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/7/g7in1i6jqsu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 67,
      "control": 58,
      "pressure": 53,
      "agility": 40,
      "physical": 42,
      "technique": 63
    }
  },
  {
    "id": 2825,
    "name": "Ivor Kernel",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/r/ur3vef5r3t8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 40,
      "control": 45,
      "pressure": 47,
      "agility": 67,
      "physical": 55,
      "technique": 49
    }
  },
  {
    "id": 2826,
    "name": "Saskia Fresh",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/5/l5g0p6fraeu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 72,
      "control": 60,
      "pressure": 54,
      "agility": 40,
      "physical": 49,
      "technique": 68
    }
  },
  {
    "id": 2827,
    "name": "Rollo Twain",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/r/lrd5z7wy7y0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 49,
      "control": 45,
      "pressure": 66,
      "agility": 41,
      "physical": 74,
      "technique": 48
    }
  },
  {
    "id": 2828,
    "name": "Buddy Arnolds",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/5/65syeewiwbc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 48,
      "control": 58,
      "pressure": 74,
      "agility": 47,
      "physical": 62,
      "technique": 54
    }
  },
  {
    "id": 2829,
    "name": "Mirabel Tussel",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/w/awptnzfqjhs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 40,
      "control": 48,
      "pressure": 54,
      "agility": 52,
      "physical": 53,
      "technique": 49
    }
  },
  {
    "id": 2830,
    "name": "Monty Montague",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/-/r--mgmjqose.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 41,
      "control": 54,
      "pressure": 56,
      "agility": 43,
      "physical": 76,
      "technique": 40
    }
  },
  {
    "id": 2831,
    "name": "Wilfred Coggle",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/f/pf5qo_x8lue.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 55,
      "control": 41,
      "pressure": 59,
      "agility": 41,
      "physical": 58,
      "technique": 54
    }
  },
  {
    "id": 2832,
    "name": "Soren Uphigh",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/3/y3ixjaxgmns.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 58,
      "control": 61,
      "pressure": 47,
      "agility": 49,
      "physical": 49,
      "technique": 64
    }
  },
  {
    "id": 2833,
    "name": "Frankie Boulder",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/y/4yrewdiothc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 47,
      "control": 44,
      "pressure": 55,
      "agility": 72,
      "physical": 41,
      "technique": 54
    }
  },
  {
    "id": 2834,
    "name": "Alex Gottlieb",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/w/jwaldie0-00.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 76,
      "control": 58,
      "pressure": 51,
      "agility": 47,
      "physical": 51,
      "technique": 71
    }
  },
  {
    "id": 2835,
    "name": "Rosa Welle",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/a/9al9svhwzlc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 53,
      "control": 43,
      "pressure": 41,
      "agility": 54,
      "physical": 53,
      "technique": 67
    }
  },
  {
    "id": 2836,
    "name": "Miles Panzer",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/y/myucbqhs040.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 42,
      "control": 40,
      "pressure": 74,
      "agility": 57,
      "physical": 55,
      "technique": 49
    }
  },
  {
    "id": 2837,
    "name": "Brutus Pummel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/a/cabxvzlzltc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 57,
      "control": 47,
      "pressure": 72,
      "agility": 60,
      "physical": 65,
      "technique": 41
    }
  },
  {
    "id": 2838,
    "name": "Rita Bloggs",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/y/zyq2cmtjme0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 48,
      "control": 41,
      "pressure": 47,
      "agility": 59,
      "physical": 53,
      "technique": 61
    }
  },
  {
    "id": 2839,
    "name": "Trajan Leet",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/d/tdjdr7yrt-e.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 64,
      "control": 67,
      "pressure": 50,
      "agility": 57,
      "physical": 47,
      "technique": 50
    }
  },
  {
    "id": 2840,
    "name": "Sirius Buff",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/1/i14i8e-r-ns.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 47,
      "control": 47,
      "pressure": 70,
      "agility": 43,
      "physical": 69,
      "technique": 59
    }
  },
  {
    "id": 2841,
    "name": "Siarti Tivi",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/u/gu_-sds97ls.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 46,
      "control": 46,
      "pressure": 69,
      "agility": 45,
      "physical": 63,
      "technique": 56
    }
  },
  {
    "id": 2842,
    "name": "Cumulo Nimbus",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/8/r8of_ikhw4e.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 56,
      "control": 49,
      "pressure": 65,
      "agility": 45,
      "physical": 63,
      "technique": 59
    }
  },
  {
    "id": 2843,
    "name": "Sunny Fairweather",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/t/xttqs__pjy0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 43,
      "control": 55,
      "pressure": 48,
      "agility": 64,
      "physical": 55,
      "technique": 56
    }
  },
  {
    "id": 2844,
    "name": "Tye Foon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/7/a7clbaz1orc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 45,
      "control": 44,
      "pressure": 70,
      "agility": 45,
      "physical": 63,
      "technique": 57
    }
  },
  {
    "id": 2845,
    "name": "Romulus Fulmen",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/r/0rjtwnaxpu0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 72,
      "control": 72,
      "pressure": 53,
      "agility": 48,
      "physical": 56,
      "technique": 61
    }
  },
  {
    "id": 2846,
    "name": "Rayne Shawa",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/5/f5sydy8tenc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 68,
      "control": 55,
      "pressure": 59,
      "agility": 43,
      "physical": 58,
      "technique": 50
    }
  },
  {
    "id": 2847,
    "name": "Nieve Alba",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/r/rrj_hz1kll8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 60,
      "control": 61,
      "pressure": 40,
      "agility": 53,
      "physical": 56,
      "technique": 70
    }
  },
  {
    "id": 2848,
    "name": "Newt Tangels",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/5/a54eqmtei4u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 53,
      "control": 54,
      "pressure": 66,
      "agility": 49,
      "physical": 67,
      "technique": 57
    }
  },
  {
    "id": 2849,
    "name": "Romeo Wheedler",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/w/6wbr5rmw9yk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 57,
      "control": 57,
      "pressure": 52,
      "agility": 44,
      "physical": 51,
      "technique": 53
    }
  },
  {
    "id": 2850,
    "name": "Bruno Tanner",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/-/l-qkuuasqrm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 67,
      "control": 52,
      "pressure": 42,
      "agility": 45,
      "physical": 45,
      "technique": 63
    }
  },
  {
    "id": 2851,
    "name": "Donald Hooan",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/f/jftw63savtm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 42,
      "control": 44,
      "pressure": 71,
      "agility": 43,
      "physical": 69,
      "technique": 51
    }
  },
  {
    "id": 2852,
    "name": "Goldie Locke",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/3/43c3xi064ek.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 59,
      "control": 42,
      "pressure": 59,
      "agility": 59,
      "physical": 40,
      "technique": 58
    }
  },
  {
    "id": 2853,
    "name": "Harriet Bunne",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/y/yy_cevbyn-u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 48,
      "control": 57,
      "pressure": 53,
      "agility": 66,
      "physical": 40,
      "technique": 49
    }
  },
  {
    "id": 2854,
    "name": "Cato Pillar",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/w/pwojpqnign8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 64,
      "control": 58,
      "pressure": 47,
      "agility": 45,
      "physical": 56,
      "technique": 62
    }
  },
  {
    "id": 2855,
    "name": "Trent Ulah",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/a/dax7ynkqhyu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 44,
      "control": 45,
      "pressure": 73,
      "agility": 56,
      "physical": 55,
      "technique": 52
    }
  },
  {
    "id": 2856,
    "name": "Beatrix Hunny",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/y/syaa1ycqqb8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 45,
      "control": 50,
      "pressure": 50,
      "agility": 41,
      "physical": 78,
      "technique": 52
    }
  },
  {
    "id": 2857,
    "name": "Piero Mantisse",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/m/qmwlwdxarsm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 58,
      "control": 55,
      "pressure": 53,
      "agility": 69,
      "physical": 48,
      "technique": 54
    }
  },
  {
    "id": 2858,
    "name": "Grant Hoppa",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/k/hknq7ixgghk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 74,
      "control": 57,
      "pressure": 48,
      "agility": 49,
      "physical": 47,
      "technique": 61
    }
  },
  {
    "id": 2859,
    "name": "Anne Tenney",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/l/blefo_iozbu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 56,
      "control": 69,
      "pressure": 49,
      "agility": 51,
      "physical": 54,
      "technique": 70
    }
  },
  {
    "id": 2860,
    "name": "Renardo Foxe",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/j/wj1-faesey8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 28,
      "intelligence": 60,
      "control": 44,
      "pressure": 63,
      "agility": 43,
      "physical": 75,
      "technique": 60
    }
  },
  {
    "id": 2861,
    "name": "Tawny Screech",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/c/ycyirzw-b08.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 55,
      "control": 49,
      "pressure": 67,
      "agility": 47,
      "physical": 59,
      "technique": 42
    }
  },
  {
    "id": 2862,
    "name": "Gerda Dogge",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/q/dqddgmwe2hu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 59,
      "control": 44,
      "pressure": 42,
      "agility": 66,
      "physical": 46,
      "technique": 66
    }
  },
  {
    "id": 2863,
    "name": "Ruby Catbear",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/f/jfg2v7fmdnk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 71,
      "control": 55,
      "pressure": 52,
      "agility": 55,
      "physical": 53,
      "technique": 48
    }
  },
  {
    "id": 2864,
    "name": "Magnus Aype",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/t/strx4ej2uum.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 45,
      "control": 43,
      "pressure": 70,
      "agility": 44,
      "physical": 67,
      "technique": 43
    }
  },
  {
    "id": 2865,
    "name": "Leon Griffin",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/h/mhupjjgujrk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 58,
      "control": 56,
      "pressure": 56,
      "agility": 70,
      "physical": 51,
      "technique": 63
    }
  },
  {
    "id": 2866,
    "name": "Tommy Wobbal",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/v/xvfuk2gukym.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 29,
      "intelligence": 51,
      "control": 57,
      "pressure": 80,
      "agility": 52,
      "physical": 58,
      "technique": 42
    }
  },
  {
    "id": 2867,
    "name": "Rhys Semanrime",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/h/5hej-3pnf0s.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 48,
      "control": 42,
      "pressure": 63,
      "agility": 56,
      "physical": 60,
      "technique": 50
    }
  },
  {
    "id": 2868,
    "name": "Boe Heemian",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/v/iv1ctipdohe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 44,
      "control": 51,
      "pressure": 58,
      "agility": 67,
      "physical": 58,
      "technique": 71
    }
  },
  {
    "id": 2869,
    "name": "Summer Salt",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/a/oaw3avcvdn0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 58,
      "control": 51,
      "pressure": 52,
      "agility": 67,
      "physical": 57,
      "technique": 57
    }
  },
  {
    "id": 2870,
    "name": "Heezbie Heindyu",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/o/zonwtq6vwuc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 60,
      "control": 43,
      "pressure": 81,
      "agility": 60,
      "physical": 65,
      "technique": 54
    }
  },
  {
    "id": 2871,
    "name": "Freddie Stayre",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/j/bjgkdzod1sc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 53,
      "control": 66,
      "pressure": 47,
      "agility": 44,
      "physical": 52,
      "technique": 60
    }
  },
  {
    "id": 2872,
    "name": "Incus Quid",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/h/qhrrumo5yh0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 57,
      "control": 58,
      "pressure": 61,
      "agility": 51,
      "physical": 72,
      "technique": 57
    }
  },
  {
    "id": 2873,
    "name": "Douglas Fische",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/o/koye9r7xtbe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 52,
      "control": 42,
      "pressure": 54,
      "agility": 51,
      "physical": 80,
      "technique": 60
    }
  },
  {
    "id": 2874,
    "name": "Pyro Nyah",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/m/7md_qudlays.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 82,
      "intelligence": 54,
      "control": 52,
      "pressure": 60,
      "agility": 62,
      "physical": 55,
      "technique": 58
    }
  },
  {
    "id": 2875,
    "name": "Otto Legge",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/m/pm8nhjepnne.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 60,
      "control": 42,
      "pressure": 55,
      "agility": 42,
      "physical": 65,
      "technique": 51
    }
  },
  {
    "id": 2876,
    "name": "Lucian Sunfish",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/k/-kngmc4tk-s.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 61,
      "control": 66,
      "pressure": 53,
      "agility": 46,
      "physical": 56,
      "technique": 51
    }
  },
  {
    "id": 2877,
    "name": "Jemima Ellison",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/m/wmcnivsm1re.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 61,
      "control": 71,
      "pressure": 41,
      "agility": 41,
      "physical": 44,
      "technique": 63
    }
  },
  {
    "id": 2878,
    "name": "Martin Fleet",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/k/bkzspq0cyys.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 50,
      "control": 56,
      "pressure": 67,
      "agility": 56,
      "physical": 67,
      "technique": 42
    }
  },
  {
    "id": 2879,
    "name": "Mudhi Uppindown",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/l/hlqzc3but4c.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 42,
      "control": 42,
      "pressure": 58,
      "agility": 57,
      "physical": 49,
      "technique": 50
    }
  },
  {
    "id": 2880,
    "name": "Joe Leggit",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/j/qjh4xinual0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 55,
      "control": 61,
      "pressure": 50,
      "agility": 57,
      "physical": 49,
      "technique": 59
    }
  },
  {
    "id": 2881,
    "name": "Jenral Gaim",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/c/scmkfr1cfn0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 52,
      "control": 55,
      "pressure": 72,
      "agility": 41,
      "physical": 60,
      "technique": 57
    }
  },
  {
    "id": 2882,
    "name": "Snap Breakwater",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/q/jqxfyut4o-c.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 45,
      "control": 46,
      "pressure": 58,
      "agility": 73,
      "physical": 51,
      "technique": 65
    }
  },
  {
    "id": 2883,
    "name": "Narcisse Rotondo",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/f/df0whzmwdes.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 53,
      "control": 66,
      "pressure": 47,
      "agility": 46,
      "physical": 48,
      "technique": 55
    }
  },
  {
    "id": 2884,
    "name": "Apnus Braithwaite",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/t/ytfrmmakwte.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 50,
      "control": 59,
      "pressure": 63,
      "agility": 56,
      "physical": 71,
      "technique": 44
    }
  },
  {
    "id": 2885,
    "name": "Ron Flappibal",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/h/gh6j9bdoxss.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 54,
      "control": 49,
      "pressure": 59,
      "agility": 56,
      "physical": 62,
      "technique": 48
    }
  },
  {
    "id": 2886,
    "name": "Clara Schott",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/v/3vloq-ls6he.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 56,
      "control": 60,
      "pressure": 52,
      "agility": 66,
      "physical": 59,
      "technique": 65
    }
  },
  {
    "id": 2887,
    "name": "Penn Manship",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/h/zhqlk_sbbnk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 60,
      "control": 68,
      "pressure": 50,
      "agility": 60,
      "physical": 58,
      "technique": 55
    }
  },
  {
    "id": 2888,
    "name": "Roland Netland",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/v/ovhenakh2-m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 40,
      "control": 51,
      "pressure": 66,
      "agility": 44,
      "physical": 57,
      "technique": 53
    }
  },
  {
    "id": 2889,
    "name": "Apra Chabel",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/a/iacx0d_pde8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 44,
      "control": 49,
      "pressure": 40,
      "agility": 57,
      "physical": 43,
      "technique": 52
    }
  },
  {
    "id": 2890,
    "name": "Uzi Slugge",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/o/5ozqziztutu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 56,
      "control": 56,
      "pressure": 52,
      "agility": 51,
      "physical": 42,
      "technique": 53
    }
  },
  {
    "id": 2891,
    "name": "Larveo Antlion",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/j/7j0m37l_rru.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 57,
      "control": 43,
      "pressure": 53,
      "agility": 61,
      "physical": 46,
      "technique": 48
    }
  },
  {
    "id": 2892,
    "name": "Sheldon Bugg",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/h/khftaetfgy8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 60,
      "control": 41,
      "pressure": 73,
      "agility": 56,
      "physical": 66,
      "technique": 43
    }
  },
  {
    "id": 2893,
    "name": "Finn Boyle",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/o/qomyjzynz4m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 55,
      "control": 60,
      "pressure": 64,
      "agility": 60,
      "physical": 73,
      "technique": 43
    }
  },
  {
    "id": 2894,
    "name": "Venoma Sting",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/m/bmx5km-3elk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 57,
      "control": 50,
      "pressure": 66,
      "agility": 47,
      "physical": 56,
      "technique": 47
    }
  },
  {
    "id": 2895,
    "name": "Bert Laydie",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/m/vmohvr9v50m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 51,
      "control": 45,
      "pressure": 72,
      "agility": 51,
      "physical": 58,
      "technique": 45
    }
  },
  {
    "id": 2896,
    "name": "Hulk Flounder",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/k/ekza4ubvuhk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 55,
      "control": 54,
      "pressure": 58,
      "agility": 43,
      "physical": 69,
      "technique": 40
    }
  },
  {
    "id": 2897,
    "name": "Bjorn Thiswey",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/g/0gmykufdqss.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 46,
      "control": 45,
      "pressure": 63,
      "agility": 53,
      "physical": 60,
      "technique": 51
    }
  },
  {
    "id": 2898,
    "name": "Duane Jerus",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/i/fi9tjrjnhfe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 52,
      "control": 46,
      "pressure": 46,
      "agility": 60,
      "physical": 60,
      "technique": 48
    }
  },
  {
    "id": 2899,
    "name": "Don Capo",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/n/lnema2wvy_0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 41,
      "control": 51,
      "pressure": 48,
      "agility": 66,
      "physical": 41,
      "technique": 58
    }
  },
  {
    "id": 2900,
    "name": "Riff Ormd",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/p/upvh3jwvfmc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 75,
      "control": 62,
      "pressure": 52,
      "agility": 52,
      "physical": 41,
      "technique": 56
    }
  },
  {
    "id": 2901,
    "name": "Dusty Weeza",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/u/wuobzqi5akc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 53,
      "control": 42,
      "pressure": 67,
      "agility": 42,
      "physical": 56,
      "technique": 44
    }
  },
  {
    "id": 2902,
    "name": "Louisa Borde",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/g/ngz60ved350.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 54,
      "control": 53,
      "pressure": 61,
      "agility": 54,
      "physical": 62,
      "technique": 45
    }
  },
  {
    "id": 2903,
    "name": "Ty Tanner",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/p/hp6pnyxlcze.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 60,
      "control": 44,
      "pressure": 67,
      "agility": 50,
      "physical": 58,
      "technique": 47
    }
  },
  {
    "id": 2904,
    "name": "Lucan Thorpe",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/b/2bluknxxvqs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 49,
      "control": 57,
      "pressure": 76,
      "agility": 55,
      "physical": 71,
      "technique": 47
    }
  },
  {
    "id": 2905,
    "name": "Aymer Loozit",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/r/cr027autive.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 70,
      "control": 58,
      "pressure": 60,
      "agility": 55,
      "physical": 46,
      "technique": 60
    }
  },
  {
    "id": 2906,
    "name": "Kitty Spinster",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/d/zdfxw_yplms.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 59,
      "control": 51,
      "pressure": 60,
      "agility": 72,
      "physical": 51,
      "technique": 59
    }
  },
  {
    "id": 2907,
    "name": "Oswald Bones",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/r/dream-7gekm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 56,
      "control": 40,
      "pressure": 52,
      "agility": 60,
      "physical": 45,
      "technique": 52
    }
  },
  {
    "id": 2908,
    "name": "Kingston Whitebridge",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/d/sdv7hbdap5k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 54,
      "control": 46,
      "pressure": 63,
      "agility": 56,
      "physical": 60,
      "technique": 53
    }
  },
  {
    "id": 2909,
    "name": "Bisher Whitehurst",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/s/msmoycosczu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 44,
      "control": 51,
      "pressure": 68,
      "agility": 47,
      "physical": 75,
      "technique": 53
    }
  },
  {
    "id": 2910,
    "name": "Nitely Whitehurst",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/e/9e9vfjooxq8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 44,
      "control": 40,
      "pressure": 58,
      "agility": 59,
      "physical": 47,
      "technique": 69
    }
  },
  {
    "id": 2911,
    "name": "Rick Whitehurst",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/l/_l6zx6ce0s8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 78,
      "control": 58,
      "pressure": 48,
      "agility": 53,
      "physical": 59,
      "technique": 63
    }
  },
  {
    "id": 2912,
    "name": "Quinn Whitebridge",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/n/onlscf6-zfu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 54,
      "control": 47,
      "pressure": 56,
      "agility": 67,
      "physical": 59,
      "technique": 55
    }
  },
  {
    "id": 2913,
    "name": "Drei Whitely",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/i/uionpyp2s_k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 58,
      "control": 66,
      "pressure": 46,
      "agility": 60,
      "physical": 50,
      "technique": 58
    }
  },
  {
    "id": 2914,
    "name": "Iggy Heade",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/k/fkzginpmbmm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 60,
      "control": 59,
      "pressure": 54,
      "agility": 55,
      "physical": 49,
      "technique": 55
    }
  },
  {
    "id": 2915,
    "name": "Tyko Wondo",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/g/rgmetqqumzk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 50,
      "control": 42,
      "pressure": 72,
      "agility": 45,
      "physical": 67,
      "technique": 53
    }
  },
  {
    "id": 2916,
    "name": "Sid Steppe",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/i/aix_-vmulam.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 70,
      "control": 62,
      "pressure": 42,
      "agility": 49,
      "physical": 49,
      "technique": 53
    }
  },
  {
    "id": 2917,
    "name": "Rhonda House",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/n/yni0oe-x8ls.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 47,
      "control": 57,
      "pressure": 70,
      "agility": 48,
      "physical": 70,
      "technique": 54
    }
  },
  {
    "id": 2918,
    "name": "Francis Shoe",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/l/dltvfhytrwe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 57,
      "control": 56,
      "pressure": 52,
      "agility": 58,
      "physical": 56,
      "technique": 67
    }
  },
  {
    "id": 2919,
    "name": "Ken Haddow",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/k/jkwgw8tlk20.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 55,
      "control": 54,
      "pressure": 45,
      "agility": 62,
      "physical": 47,
      "technique": 45
    }
  },
  {
    "id": 2920,
    "name": "Price Shaids",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/i/sibb7dlfjfc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 49,
      "control": 45,
      "pressure": 74,
      "agility": 57,
      "physical": 62,
      "technique": 40
    }
  },
  {
    "id": 2921,
    "name": "Patton Fairway",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/d/qdgdvazzmdc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 60,
      "control": 46,
      "pressure": 66,
      "agility": 48,
      "physical": 57,
      "technique": 47
    }
  },
  {
    "id": 2922,
    "name": "Philippa Belle",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/r/hr384l_jhw0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 44,
      "control": 56,
      "pressure": 49,
      "agility": 72,
      "physical": 45,
      "technique": 71
    }
  },
  {
    "id": 2923,
    "name": "Des Eving",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/e/beujr4kbuqe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 58,
      "control": 68,
      "pressure": 51,
      "agility": 43,
      "physical": 45,
      "technique": 59
    }
  },
  {
    "id": 2924,
    "name": "Newt Lease",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/s/wsloghs75js.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 55,
      "control": 53,
      "pressure": 75,
      "agility": 56,
      "physical": 66,
      "technique": 58
    }
  },
  {
    "id": 2925,
    "name": "Armand Sedate",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/g/egaw3kvzece.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 66,
      "control": 74,
      "pressure": 43,
      "agility": 54,
      "physical": 55,
      "technique": 62
    }
  },
  {
    "id": 2926,
    "name": "Kingley Blackcrown",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/u/1urra1jjzvs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 53,
      "control": 59,
      "pressure": 65,
      "agility": 49,
      "physical": 70,
      "technique": 47
    }
  },
  {
    "id": 2927,
    "name": "Bishopp Blackside",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/g/bgwca0aqsdm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 49,
      "control": 50,
      "pressure": 61,
      "agility": 48,
      "physical": 78,
      "technique": 44
    }
  },
  {
    "id": 2928,
    "name": "Nate Blackside",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/u/qub9tlmq_wk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 81,
      "intelligence": 57,
      "control": 42,
      "pressure": 40,
      "agility": 56,
      "physical": 40,
      "technique": 58
    }
  },
  {
    "id": 2929,
    "name": "Rook Blackside",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/b/kbii-wtykqu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 66,
      "control": 77,
      "pressure": 40,
      "agility": 58,
      "physical": 58,
      "technique": 62
    }
  },
  {
    "id": 2930,
    "name": "Queenie Blackcrown",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/p/7ptptp1inj8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 52,
      "control": 50,
      "pressure": 53,
      "agility": 71,
      "physical": 57,
      "technique": 56
    }
  },
  {
    "id": 2931,
    "name": "Tre Blackley",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/i/5iu19wnoil8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 68,
      "control": 54,
      "pressure": 40,
      "agility": 46,
      "physical": 58,
      "technique": 53
    }
  },
  {
    "id": 2932,
    "name": "Ernest Etson",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/g/igluqpb0pwu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 49,
      "control": 40,
      "pressure": 67,
      "agility": 58,
      "physical": 68,
      "technique": 45
    }
  },
  {
    "id": 2933,
    "name": "Turner Tabel",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/p/opghds0862k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 60,
      "control": 49,
      "pressure": 59,
      "agility": 54,
      "physical": 50,
      "technique": 58
    }
  },
  {
    "id": 2934,
    "name": "Reilly Italot",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/n/zn3autsgxfm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 61,
      "control": 74,
      "pressure": 55,
      "agility": 47,
      "physical": 58,
      "technique": 68
    }
  },
  {
    "id": 2935,
    "name": "Rocky McCanns",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/n/tniyfgrkw6k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 52,
      "control": 42,
      "pressure": 77,
      "agility": 41,
      "physical": 58,
      "technique": 43
    }
  },
  {
    "id": 2936,
    "name": "Nash Room",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/l/cl55yf3edjm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 44,
      "control": 54,
      "pressure": 61,
      "agility": 48,
      "physical": 52,
      "technique": 57
    }
  },
  {
    "id": 2937,
    "name": "Will Lusion",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/n/sn2ycwdrick.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 54,
      "control": 57,
      "pressure": 78,
      "agility": 56,
      "physical": 61,
      "technique": 48
    }
  },
  {
    "id": 2938,
    "name": "Christian Ball",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/l/jlhtxp7rpvm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 55,
      "control": 47,
      "pressure": 72,
      "agility": 43,
      "physical": 60,
      "technique": 58
    }
  },
  {
    "id": 2939,
    "name": "Lynne Wildcat",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/k/dkkmi0oz6p8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 81,
      "intelligence": 45,
      "control": 49,
      "pressure": 49,
      "agility": 69,
      "physical": 43,
      "technique": 70
    }
  },
  {
    "id": 2940,
    "name": "Shaun Asparr",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/i/yivhplojx8u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 58,
      "control": 51,
      "pressure": 42,
      "agility": 45,
      "physical": 60,
      "technique": 73
    }
  },
  {
    "id": 2941,
    "name": "Don Prima",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/d/wdsbhs6ps6u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 53,
      "control": 51,
      "pressure": 71,
      "agility": 45,
      "physical": 65,
      "technique": 50
    }
  },
  {
    "id": 2942,
    "name": "Doug Spoddy",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/r/brj6mtc1_j8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 45,
      "control": 44,
      "pressure": 63,
      "agility": 59,
      "physical": 53,
      "technique": 53
    }
  },
  {
    "id": 2943,
    "name": "Faulk Dansa",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/e/heapfwp9kpm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 59,
      "control": 55,
      "pressure": 78,
      "agility": 48,
      "physical": 60,
      "technique": 47
    }
  },
  {
    "id": 2944,
    "name": "Nick Yergrub",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/s/qsxuypphnak.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 45,
      "control": 50,
      "pressure": 73,
      "agility": 56,
      "physical": 60,
      "technique": 60
    }
  },
  {
    "id": 2945,
    "name": "Cain Cavalier",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/g/kgo2dcmlalm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 53,
      "control": 47,
      "pressure": 43,
      "agility": 67,
      "physical": 57,
      "technique": 57
    }
  },
  {
    "id": 2946,
    "name": "Selwyn Crawler",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/u/vu_xu9qftwk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 56,
      "control": 51,
      "pressure": 57,
      "agility": 44,
      "physical": 41,
      "technique": 73
    }
  },
  {
    "id": 2947,
    "name": "Saul Durban",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/g/7gka08jwm6e.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 47,
      "control": 48,
      "pressure": 69,
      "agility": 41,
      "physical": 69,
      "technique": 42
    }
  },
  {
    "id": 2948,
    "name": "Algo Rithm",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/u/kuv7zdfshjs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 42,
      "control": 55,
      "pressure": 52,
      "agility": 68,
      "physical": 40,
      "technique": 67
    }
  },
  {
    "id": 2949,
    "name": "Posy Striker",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/b/qb2okewkupc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 42,
      "control": 54,
      "pressure": 67,
      "agility": 42,
      "physical": 60,
      "technique": 53
    }
  },
  {
    "id": 2950,
    "name": "Adi Sivfeet",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/p/bphvnhwe5a0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 61,
      "control": 70,
      "pressure": 57,
      "agility": 41,
      "physical": 60,
      "technique": 69
    }
  },
  {
    "id": 2951,
    "name": "Camille Aeon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/i/ziazj4ey8c0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 44,
      "control": 42,
      "pressure": 53,
      "agility": 45,
      "physical": 78,
      "technique": 47
    }
  },
  {
    "id": 2952,
    "name": "Axel Lottle",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/g/ogxskhiirvc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 57,
      "control": 51,
      "pressure": 49,
      "agility": 58,
      "physical": 48,
      "technique": 61
    }
  },
  {
    "id": 2953,
    "name": "Ada Vyper",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/p/ipsn3axakps.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 83,
      "intelligence": 47,
      "control": 50,
      "pressure": 46,
      "agility": 68,
      "physical": 44,
      "technique": 64
    }
  },
  {
    "id": 2954,
    "name": "Sheldon Myrtle",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/n/5njgalx6j8e.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 49,
      "control": 58,
      "pressure": 62,
      "agility": 45,
      "physical": 74,
      "technique": 40
    }
  },
  {
    "id": 2955,
    "name": "Callum Rocke",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/n/nnceroyyuds.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 54,
      "control": 56,
      "pressure": 40,
      "agility": 57,
      "physical": 55,
      "technique": 63
    }
  },
  {
    "id": 2956,
    "name": "Jack Skipper",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/l/8lt_gxuidwe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 57,
      "control": 43,
      "pressure": 60,
      "agility": 60,
      "physical": 66,
      "technique": 46
    }
  },
  {
    "id": 2957,
    "name": "Ruben Lamp",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/b/ab7ulsnocj0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 51,
      "control": 48,
      "pressure": 71,
      "agility": 47,
      "physical": 59,
      "technique": 45
    }
  },
  {
    "id": 2958,
    "name": "Hilda Brunner",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/z/xzkpitbsvqc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 55,
      "control": 59,
      "pressure": 52,
      "agility": 72,
      "physical": 51,
      "technique": 56
    }
  },
  {
    "id": 2959,
    "name": "Eolia Amhart",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/c/rcp6bw0aaws.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 60,
      "control": 58,
      "pressure": 53,
      "agility": 49,
      "physical": 52,
      "technique": 62
    }
  },
  {
    "id": 2960,
    "name": "Plato Mail",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/0/g0yb2psg3de.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 49,
      "control": 57,
      "pressure": 68,
      "agility": 47,
      "physical": 74,
      "technique": 42
    }
  },
  {
    "id": 2961,
    "name": "Dreama Paris",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/v/ivfhywamyfe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 60,
      "control": 41,
      "pressure": 66,
      "agility": 40,
      "physical": 59,
      "technique": 48
    }
  },
  {
    "id": 2962,
    "name": "Wally Ramm",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/9/t9um1pm2f2s.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 53,
      "control": 77,
      "pressure": 55,
      "agility": 60,
      "physical": 41,
      "technique": 61
    }
  },
  {
    "id": 2963,
    "name": "Falco Peregrine",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/s/zsntm0t-qwc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 46,
      "control": 46,
      "pressure": 53,
      "agility": 51,
      "physical": 65,
      "technique": 49
    }
  },
  {
    "id": 2964,
    "name": "Paco Dermott",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/6/c68yll1ehl0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 60,
      "control": 42,
      "pressure": 72,
      "agility": 55,
      "physical": 54,
      "technique": 60
    }
  },
  {
    "id": 2965,
    "name": "Snorri Sloth",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/q/2qdq6g2mgac.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 59,
      "control": 44,
      "pressure": 67,
      "agility": 48,
      "physical": 64,
      "technique": 56
    }
  },
  {
    "id": 2966,
    "name": "Rory Tigre",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/4/h4ylx5qcnp0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 48,
      "control": 54,
      "pressure": 55,
      "agility": 56,
      "physical": 51,
      "technique": 47
    }
  },
  {
    "id": 2967,
    "name": "Barbara Bitt",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/q/pqpgn4zvsfu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 48,
      "control": 49,
      "pressure": 52,
      "agility": 59,
      "physical": 57,
      "technique": 50
    }
  },
  {
    "id": 2968,
    "name": "Bloomer Topp",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/4/y4yngh_vb28.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 41,
      "control": 46,
      "pressure": 62,
      "agility": 41,
      "physical": 72,
      "technique": 53
    }
  },
  {
    "id": 2969,
    "name": "Spike Echidna",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/x/4x7szakn0wm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 44,
      "control": 43,
      "pressure": 41,
      "agility": 58,
      "physical": 52,
      "technique": 52
    }
  },
  {
    "id": 2970,
    "name": "Sal Armando",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/_/j_kzelsdzlk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 62,
      "control": 60,
      "pressure": 42,
      "agility": 51,
      "physical": 59,
      "technique": 54
    }
  },
  {
    "id": 2971,
    "name": "Shai Klopps",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/e/lenvw8-xcjk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 59,
      "control": 55,
      "pressure": 63,
      "agility": 53,
      "physical": 66,
      "technique": 58
    }
  },
  {
    "id": 2972,
    "name": "Janice Queen",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/2/628oddylxqm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 53,
      "control": 77,
      "pressure": 40,
      "agility": 43,
      "physical": 54,
      "technique": 56
    }
  },
  {
    "id": 2973,
    "name": "Serena Halcyon",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/z/azf7oetdew8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 52,
      "control": 64,
      "pressure": 51,
      "agility": 60,
      "physical": 55,
      "technique": 58
    }
  },
  {
    "id": 2974,
    "name": "Gus Tronom",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/x/rxuajhl5pdu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 56,
      "control": 56,
      "pressure": 66,
      "agility": 43,
      "physical": 67,
      "technique": 57
    }
  },
  {
    "id": 2975,
    "name": "Mollie Cular",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/b/fbrcssibo88.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 44,
      "control": 57,
      "pressure": 45,
      "agility": 68,
      "physical": 55,
      "technique": 68
    }
  },
  {
    "id": 2976,
    "name": "Spark Volt",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/z/uzgj_tuhjpu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 56,
      "control": 45,
      "pressure": 69,
      "agility": 52,
      "physical": 64,
      "technique": 45
    }
  },
  {
    "id": 2977,
    "name": "Tex Tuber",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/b/gbvoraeuca8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 62,
      "control": 54,
      "pressure": 42,
      "agility": 47,
      "physical": 59,
      "technique": 63
    }
  },
  {
    "id": 2978,
    "name": "Ross Seption",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/z/rzej8liuxpu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 42,
      "control": 47,
      "pressure": 64,
      "agility": 58,
      "physical": 59,
      "technique": 60
    }
  },
  {
    "id": 2979,
    "name": "Luke Dwight",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/c/xc98v4xmejk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 52,
      "control": 41,
      "pressure": 71,
      "agility": 46,
      "physical": 59,
      "technique": 45
    }
  },
  {
    "id": 2980,
    "name": "Hunter Wanabi",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/0/a0mdchxcp6m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 45,
      "control": 44,
      "pressure": 57,
      "agility": 57,
      "physical": 62,
      "technique": 44
    }
  },
  {
    "id": 2981,
    "name": "Walden Squire",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/v/cvlbsejws8m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 48,
      "control": 52,
      "pressure": 47,
      "agility": 75,
      "physical": 52,
      "technique": 57
    }
  },
  {
    "id": 2982,
    "name": "Millie Terry",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/9/z96gbhfkbpk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 56,
      "control": 57,
      "pressure": 46,
      "agility": 65,
      "physical": 44,
      "technique": 63
    }
  },
  {
    "id": 2983,
    "name": "Pontius Blank",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/s/tszvs8wc0vu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 51,
      "control": 47,
      "pressure": 58,
      "agility": 48,
      "physical": 70,
      "technique": 46
    }
  },
  {
    "id": 2984,
    "name": "Marcus Maan",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/6/i6o0_dw4zc8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 64,
      "control": 63,
      "pressure": 45,
      "agility": 50,
      "physical": 55,
      "technique": 57
    }
  },
  {
    "id": 2985,
    "name": "Gwen Slinga",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/q/wqxsoova-ju.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 56,
      "control": 49,
      "pressure": 60,
      "agility": 58,
      "physical": 70,
      "technique": 57
    }
  },
  {
    "id": 2986,
    "name": "Isaac Celise",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/4/n4mnjxzgtq8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 82,
      "intelligence": 56,
      "control": 44,
      "pressure": 54,
      "agility": 62,
      "physical": 50,
      "technique": 47
    }
  },
  {
    "id": 2987,
    "name": "Radius Pye",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/q/jq9a5w6py8c.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 47,
      "control": 47,
      "pressure": 67,
      "agility": 41,
      "physical": 60,
      "technique": 51
    }
  },
  {
    "id": 2988,
    "name": "Rick Tangle",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/4/44mhupctfp0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 64,
      "control": 71,
      "pressure": 57,
      "agility": 55,
      "physical": 55,
      "technique": 51
    }
  },
  {
    "id": 2989,
    "name": "Xanthe Crosse",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/x/yxvuhspbqve.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 76,
      "control": 55,
      "pressure": 44,
      "agility": 47,
      "physical": 40,
      "technique": 73
    }
  },
  {
    "id": 2990,
    "name": "Trappy Zeum",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/_/p_e1qtphhcs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 42,
      "control": 42,
      "pressure": 70,
      "agility": 47,
      "physical": 63,
      "technique": 57
    }
  },
  {
    "id": 2991,
    "name": "Ken Dough",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/e/rezpe0dncas.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 54,
      "control": 72,
      "pressure": 54,
      "agility": 47,
      "physical": 55,
      "technique": 48
    }
  },
  {
    "id": 2992,
    "name": "Sam Arritan",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/2/a2oipl73vpe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 47,
      "control": 55,
      "pressure": 58,
      "agility": 74,
      "physical": 50,
      "technique": 56
    }
  },
  {
    "id": 2993,
    "name": "Simon Cleric",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/z/6zl96wo_aj0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 47,
      "control": 44,
      "pressure": 68,
      "agility": 56,
      "physical": 65,
      "technique": 52
    }
  },
  {
    "id": 2994,
    "name": "Archie Valry",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/x/lx6cxpof36c.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 70,
      "control": 77,
      "pressure": 52,
      "agility": 48,
      "physical": 48,
      "technique": 54
    }
  },
  {
    "id": 2995,
    "name": "Howard Robin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/b/_bfemkrnqf0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 55,
      "control": 50,
      "pressure": 70,
      "agility": 44,
      "physical": 52,
      "technique": 57
    }
  },
  {
    "id": 2996,
    "name": "Esme Hexe",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/z/oz0llbnd92c.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 77,
      "control": 63,
      "pressure": 56,
      "agility": 49,
      "physical": 59,
      "technique": 57
    }
  },
  {
    "id": 2997,
    "name": "Freyer Monk",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/3/k3hxxbtvddu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 50,
      "control": 41,
      "pressure": 76,
      "agility": 40,
      "physical": 72,
      "technique": 53
    }
  },
  {
    "id": 2998,
    "name": "Caetano Settler",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/f/vfq26k1vuu8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 54,
      "control": 40,
      "pressure": 48,
      "agility": 65,
      "physical": 47,
      "technique": 63
    }
  },
  {
    "id": 2999,
    "name": "Saul Hermit",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/w/1wzdp5adbom.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 64,
      "control": 68,
      "pressure": 47,
      "agility": 49,
      "physical": 59,
      "technique": 64
    }
  },
  {
    "id": 3000,
    "name": "Ollie Impix",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/y/eyciegmn29k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 60,
      "control": 44,
      "pressure": 58,
      "agility": 42,
      "physical": 65,
      "technique": 57
    }
  },
  {
    "id": 3001,
    "name": "Kit Cymbal",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/5/g5f-qf0lz7k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 48,
      "control": 41,
      "pressure": 65,
      "agility": 53,
      "physical": 74,
      "technique": 49
    }
  },
  {
    "id": 3002,
    "name": "Al Overa",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/r/3r0fhgsxeim.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 53,
      "control": 73,
      "pressure": 54,
      "agility": 46,
      "physical": 41,
      "technique": 69
    }
  },
  {
    "id": 3003,
    "name": "Amanda Jurr",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/-/x-xqu9n5ro8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 60,
      "control": 52,
      "pressure": 48,
      "agility": 50,
      "physical": 40,
      "technique": 65
    }
  },
  {
    "id": 3004,
    "name": "Tostig Muffler",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/w/mwml5cbdgbu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 48,
      "control": 48,
      "pressure": 56,
      "agility": 42,
      "physical": 65,
      "technique": 55
    }
  },
  {
    "id": 3005,
    "name": "Buzz Cutt",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/8/s8ztipchhk8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 43,
      "control": 51,
      "pressure": 57,
      "agility": 44,
      "physical": 74,
      "technique": 52
    }
  },
  {
    "id": 3006,
    "name": "Fritzy Flaps",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/u/juoylwkbmxu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 52,
      "control": 63,
      "pressure": 58,
      "agility": 42,
      "physical": 58,
      "technique": 49
    }
  },
  {
    "id": 3007,
    "name": "Cornelius Roes",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/8/n8z__xtst70.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 69,
      "control": 76,
      "pressure": 48,
      "agility": 44,
      "physical": 49,
      "technique": 69
    }
  },
  {
    "id": 3008,
    "name": "Fishel Bucket",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/u/8ucesoloaic.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 40,
      "control": 58,
      "pressure": 58,
      "agility": 40,
      "physical": 62,
      "technique": 52
    }
  },
  {
    "id": 3009,
    "name": "Violet Eamow",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/7/c7hrbt-g1os.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 41,
      "control": 47,
      "pressure": 43,
      "agility": 62,
      "physical": 60,
      "technique": 55
    }
  },
  {
    "id": 3010,
    "name": "Bolt Cagey",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/t/ttqkssyaybe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 60,
      "control": 59,
      "pressure": 43,
      "agility": 67,
      "physical": 52,
      "technique": 48
    }
  },
  {
    "id": 3011,
    "name": "Walter Skimmer",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/y/vyxwc1k2dde.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 54,
      "control": 54,
      "pressure": 75,
      "agility": 49,
      "physical": 55,
      "technique": 44
    }
  },
  {
    "id": 3012,
    "name": "Gordon Hoe",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/a/eam3vksmwus.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 52,
      "control": 45,
      "pressure": 54,
      "agility": 43,
      "physical": 71,
      "technique": 59
    }
  },
  {
    "id": 3013,
    "name": "Xander Noddle",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/1/-1fc8xzefoc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 43,
      "control": 49,
      "pressure": 66,
      "agility": 47,
      "physical": 67,
      "technique": 52
    }
  },
  {
    "id": 3014,
    "name": "Stella Thee",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/d/pd0jro_-o90.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 60,
      "control": 40,
      "pressure": 63,
      "agility": 50,
      "physical": 70,
      "technique": 46
    }
  },
  {
    "id": 3015,
    "name": "Rudy Blush",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/3/73l7gl8cpcc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 55,
      "control": 54,
      "pressure": 66,
      "agility": 48,
      "physical": 70,
      "technique": 51
    }
  },
  {
    "id": 3016,
    "name": "Buck Choy",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/f/kf6anaamix0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 74,
      "control": 57,
      "pressure": 49,
      "agility": 58,
      "physical": 56,
      "technique": 67
    }
  },
  {
    "id": 3017,
    "name": "Beau Gotcher",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/1/c1ua9pfag3k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 45,
      "control": 54,
      "pressure": 67,
      "agility": 49,
      "physical": 68,
      "technique": 59
    }
  },
  {
    "id": 3018,
    "name": "Troi Dryer",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/d/zdl7qwj6rem.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 52,
      "control": 55,
      "pressure": 66,
      "agility": 51,
      "physical": 63,
      "technique": 55
    }
  },
  {
    "id": 3019,
    "name": "Raider Takkel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/y/tygodtwyek8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 48,
      "control": 52,
      "pressure": 76,
      "agility": 43,
      "physical": 76,
      "technique": 41
    }
  },
  {
    "id": 3020,
    "name": "Manny Saboy",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/a/ia3vuswizxu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 55,
      "control": 50,
      "pressure": 57,
      "agility": 74,
      "physical": 40,
      "technique": 67
    }
  },
  {
    "id": 3021,
    "name": "Jack Alltrade",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/7/g7wzalik2ru.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 57,
      "control": 46,
      "pressure": 69,
      "agility": 60,
      "physical": 70,
      "technique": 50
    }
  },
  {
    "id": 3022,
    "name": "Spacey Flipper",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/t/rtbst0eebi8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 51,
      "control": 44,
      "pressure": 59,
      "agility": 49,
      "physical": 56,
      "technique": 56
    }
  },
  {
    "id": 3023,
    "name": "Bobbie Pompon",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/8/x8in-pxwucm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 72,
      "control": 70,
      "pressure": 60,
      "agility": 44,
      "physical": 42,
      "technique": 55
    }
  },
  {
    "id": 3024,
    "name": "Frosty Patissier",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/u/autgtwxsdxk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 50,
      "control": 56,
      "pressure": 61,
      "agility": 52,
      "physical": 71,
      "technique": 53
    }
  },
  {
    "id": 3025,
    "name": "Keir Mudgeon",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/-/0-seibuokom.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 67,
      "control": 55,
      "pressure": 52,
      "agility": 54,
      "physical": 45,
      "technique": 62
    }
  },
  {
    "id": 3026,
    "name": "Gus Bagge",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/w/fwd_pky0j9k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 81,
      "intelligence": 40,
      "control": 49,
      "pressure": 53,
      "agility": 66,
      "physical": 42,
      "technique": 63
    }
  },
  {
    "id": 3027,
    "name": "Eira Dynamic",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/-/r-gyvl79ore.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 49,
      "control": 47,
      "pressure": 80,
      "agility": 52,
      "physical": 73,
      "technique": 45
    }
  },
  {
    "id": 3028,
    "name": "Trump Dealer",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/w/aw3t4adhfis.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 54,
      "control": 55,
      "pressure": 48,
      "agility": 69,
      "physical": 43,
      "technique": 64
    }
  },
  {
    "id": 3029,
    "name": "Rob O'Meca",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/5/65umrhopwcc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 49,
      "control": 40,
      "pressure": 75,
      "agility": 42,
      "physical": 59,
      "technique": 50
    }
  },
  {
    "id": 3030,
    "name": "Debbie Dare",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/r/lrlhg4o1dx0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 65,
      "control": 69,
      "pressure": 43,
      "agility": 60,
      "physical": 52,
      "technique": 48
    }
  },
  {
    "id": 3031,
    "name": "Bill Sye",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/w/jwibohczy30.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 56,
      "control": 46,
      "pressure": 62,
      "agility": 40,
      "physical": 74,
      "technique": 41
    }
  },
  {
    "id": 3032,
    "name": "Primrose Proppa",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/y/4yt6fe6j1ec.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 47,
      "control": 42,
      "pressure": 59,
      "agility": 58,
      "physical": 43,
      "technique": 60
    }
  },
  {
    "id": 3033,
    "name": "Ricky Shee",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/3/y3wpwdpraks.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 49,
      "control": 48,
      "pressure": 59,
      "agility": 59,
      "physical": 70,
      "technique": 59
    }
  },
  {
    "id": 3034,
    "name": "Patrick Childs",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/f/pfbu78prtxe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 63,
      "control": 58,
      "pressure": 47,
      "agility": 52,
      "physical": 45,
      "technique": 51
    }
  },
  {
    "id": 3035,
    "name": "Ciaran Wale",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/1/d1-2kxqzkos.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 58,
      "control": 60,
      "pressure": 57,
      "agility": 40,
      "physical": 66,
      "technique": 59
    }
  },
  {
    "id": 3036,
    "name": "Leroy Kingsley",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/d/sdpxnomjnbe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 42,
      "control": 46,
      "pressure": 83,
      "agility": 44,
      "physical": 70,
      "technique": 42
    }
  },
  {
    "id": 3037,
    "name": "Rhiannon Hoode",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/1/i1acjhm8yos.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 53,
      "control": 58,
      "pressure": 60,
      "agility": 68,
      "physical": 59,
      "technique": 50
    }
  },
  {
    "id": 3038,
    "name": "Bianca Snough",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/d/tdx9k4ag19e.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 85,
      "intelligence": 57,
      "control": 46,
      "pressure": 50,
      "agility": 64,
      "physical": 52,
      "technique": 46
    }
  },
  {
    "id": 3039,
    "name": "Cindy Reller",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/y/zysi3l1oad0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 48,
      "control": 52,
      "pressure": 42,
      "agility": 65,
      "physical": 57,
      "technique": 49
    }
  },
  {
    "id": 3040,
    "name": "Ted Ledd",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/a/cajpaat0tuc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 47,
      "control": 48,
      "pressure": 55,
      "agility": 71,
      "physical": 59,
      "technique": 68
    }
  },
  {
    "id": 3041,
    "name": "Sita Square",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/7/a7k10dbyooc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 69,
      "control": 76,
      "pressure": 40,
      "agility": 48,
      "physical": 49,
      "technique": 52
    }
  },
  {
    "id": 3042,
    "name": "Stanley Switch",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/t/xtvuz8nifb0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 66,
      "control": 58,
      "pressure": 49,
      "agility": 60,
      "physical": 43,
      "technique": 74
    }
  },
  {
    "id": 3043,
    "name": "Pero Tractor",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/8/r82hkhsqw7e.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 51,
      "control": 46,
      "pressure": 58,
      "agility": 48,
      "physical": 59,
      "technique": 58
    }
  },
  {
    "id": 3044,
    "name": "Perla Sizzors",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/u/guhane0qdis.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 52,
      "control": 42,
      "pressure": 75,
      "agility": 58,
      "physical": 70,
      "technique": 43
    }
  },
  {
    "id": 3045,
    "name": "Robbie Tout",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/-/u-4ywt3y63e.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 50,
      "control": 57,
      "pressure": 73,
      "agility": 48,
      "physical": 69,
      "technique": 44
    }
  },
  {
    "id": 3046,
    "name": "Silas Andice",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/w/lwj57srixes.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 46,
      "control": 53,
      "pressure": 58,
      "agility": 40,
      "physical": 74,
      "technique": 44
    }
  },
  {
    "id": 3047,
    "name": "Tia Towell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/-/l-s0htyb2om.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 66,
      "control": 62,
      "pressure": 58,
      "agility": 57,
      "physical": 52,
      "technique": 66
    }
  },
  {
    "id": 3048,
    "name": "Cooper Kettle",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/w/6wjvms-7bbk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 55,
      "control": 60,
      "pressure": 48,
      "agility": 49,
      "physical": 52,
      "technique": 73
    }
  },
  {
    "id": 3049,
    "name": "Stuart Potty",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/5/a5agfplzu7u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 56,
      "control": 71,
      "pressure": 50,
      "agility": 55,
      "physical": 43,
      "technique": 56
    }
  },
  {
    "id": 3050,
    "name": "Prosper Cooka",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/r/rrxbywtjdi8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 55,
      "control": 53,
      "pressure": 58,
      "agility": 45,
      "physical": 69,
      "technique": 45
    }
  },
  {
    "id": 3051,
    "name": "Trey Prongs",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/w/pw2dcp_lgo8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 45,
      "control": 52,
      "pressure": 70,
      "agility": 42,
      "physical": 55,
      "technique": 40
    }
  },
  {
    "id": 3052,
    "name": "Philip Stic",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/y/yyh8xwzfr9u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 41,
      "control": 42,
      "pressure": 69,
      "agility": 47,
      "physical": 58,
      "technique": 48
    }
  },
  {
    "id": 3053,
    "name": "Andy Kareem",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/3/43kjilsxedk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 56,
      "control": 52,
      "pressure": 73,
      "agility": 57,
      "physical": 64,
      "technique": 47
    }
  },
  {
    "id": 3054,
    "name": "Cara Mass",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/f/jfvop0ktzum.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 49,
      "control": 42,
      "pressure": 57,
      "agility": 43,
      "physical": 69,
      "technique": 51
    }
  },
  {
    "id": 3055,
    "name": "Aya Shadowe",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/1/91qw-5jpurk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 46,
      "control": 44,
      "pressure": 45,
      "agility": 72,
      "physical": 41,
      "technique": 50
    }
  },
  {
    "id": 3056,
    "name": "Scarlett Strands",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/d/mdbrtgv15im.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 81,
      "intelligence": 54,
      "control": 60,
      "pressure": 50,
      "agility": 75,
      "physical": 46,
      "technique": 48
    }
  },
  {
    "id": 3057,
    "name": "Silke Coombe",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/j/wjnawdc_4x8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 74,
      "control": 56,
      "pressure": 43,
      "agility": 42,
      "physical": 54,
      "technique": 54
    }
  },
  {
    "id": 3058,
    "name": "Nuno Vertigo",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/l/bl8hd86fvcu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 45,
      "control": 42,
      "pressure": 66,
      "agility": 44,
      "physical": 70,
      "technique": 45
    }
  },
  {
    "id": 3059,
    "name": "Ian Spike",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/k/hkfuohpngik.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 44,
      "control": 49,
      "pressure": 64,
      "agility": 44,
      "physical": 61,
      "technique": 58
    }
  },
  {
    "id": 3060,
    "name": "Chip Chisel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/m/qmu1jep3nrm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 47,
      "control": 52,
      "pressure": 66,
      "agility": 50,
      "physical": 72,
      "technique": 49
    }
  },
  {
    "id": 3061,
    "name": "Claude Hammer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/t/stppnh7bixm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 75,
      "control": 70,
      "pressure": 46,
      "agility": 48,
      "physical": 47,
      "technique": 54
    }
  },
  {
    "id": 3062,
    "name": "Dougal Axe",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/f/jfyig4dhlkk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 47,
      "control": 48,
      "pressure": 57,
      "agility": 62,
      "physical": 54,
      "technique": 54
    }
  },
  {
    "id": 3063,
    "name": "Hank Saw",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/q/dq79zlopqeu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 69,
      "control": 66,
      "pressure": 41,
      "agility": 48,
      "physical": 59,
      "technique": 67
    }
  },
  {
    "id": 3064,
    "name": "Dias Mondragon",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/c/yckceaot938.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 56,
      "control": 55,
      "pressure": 62,
      "agility": 46,
      "physical": 59,
      "technique": 53
    }
  },
  {
    "id": 3065,
    "name": "Garreth Nett",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/o/go1evxnxaiu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 54,
      "control": 51,
      "pressure": 54,
      "agility": 53,
      "physical": 68,
      "technique": 47
    }
  },
  {
    "id": 3066,
    "name": "Amelio Thyst",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/a/3aelcorl378.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 48,
      "control": 55,
      "pressure": 68,
      "agility": 57,
      "physical": 65,
      "technique": 59
    }
  },
  {
    "id": 3067,
    "name": "Moonir Stone",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/o/zofoypicwxc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 62,
      "control": 76,
      "pressure": 42,
      "agility": 56,
      "physical": 57,
      "technique": 66
    }
  },
  {
    "id": 3068,
    "name": "Cory Alberts",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/a/oauj1we47k0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 42,
      "control": 59,
      "pressure": 41,
      "agility": 63,
      "physical": 49,
      "technique": 48
    }
  },
  {
    "id": 3069,
    "name": "Emett Raldo",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/v/ivn8mlxwoee.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 57,
      "control": 54,
      "pressure": 56,
      "agility": 73,
      "physical": 60,
      "technique": 66
    }
  },
  {
    "id": 3070,
    "name": "Ruth Byron",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/h/5h8dl0xkj3s.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 57,
      "control": 56,
      "pressure": 59,
      "agility": 62,
      "physical": 46,
      "technique": 51
    }
  },
  {
    "id": 3071,
    "name": "Ambrose Ericson",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/m/7m7bltfmmxs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 41,
      "control": 56,
      "pressure": 80,
      "agility": 59,
      "physical": 68,
      "technique": 50
    }
  },
  {
    "id": 3072,
    "name": "Sapp Hirell",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/o/kokgisjclce.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 41,
      "control": 57,
      "pressure": 68,
      "agility": 51,
      "physical": 79,
      "technique": 49
    }
  },
  {
    "id": 3073,
    "name": "Ciril Trine",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/h/qhpvbpwu-i0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 59,
      "control": 55,
      "pressure": 70,
      "agility": 60,
      "physical": 52,
      "technique": 45
    }
  },
  {
    "id": 3074,
    "name": "Turco Quoisey",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/j/bjy02wwutrc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 60,
      "control": 62,
      "pressure": 44,
      "agility": 46,
      "physical": 45,
      "technique": 51
    }
  },
  {
    "id": 3075,
    "name": "Ophelio Albans",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/j/vjnsh9zm0u0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 69,
      "control": 71,
      "pressure": 53,
      "agility": 48,
      "physical": 51,
      "technique": 69
    }
  },
  {
    "id": 3076,
    "name": "Rufus Brunt",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/l/elwnqcv2zdc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 58,
      "control": 43,
      "pressure": 72,
      "agility": 48,
      "physical": 69,
      "technique": 45
    }
  },
  {
    "id": 3077,
    "name": "Alben Moretti",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/j/qjzgel_dmi0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 52,
      "control": 55,
      "pressure": 56,
      "agility": 56,
      "physical": 44,
      "technique": 54
    }
  },
  {
    "id": 3078,
    "name": "Gordon Bolt",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/l/hlonp0z5l7c.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 42,
      "control": 54,
      "pressure": 55,
      "agility": 48,
      "physical": 66,
      "technique": 40
    }
  },
  {
    "id": 3079,
    "name": "Tez Beyan",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/k/bkls6psx-bs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 40,
      "control": 44,
      "pressure": 57,
      "agility": 63,
      "physical": 45,
      "technique": 51
    }
  },
  {
    "id": 3080,
    "name": "Dylan Quint",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/m/wm6zxwkltoe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 61,
      "control": 68,
      "pressure": 50,
      "agility": 49,
      "physical": 48,
      "technique": 61
    }
  },
  {
    "id": 3081,
    "name": "Mel O'Drahma",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/t/yt9v5pynwue.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 40,
      "control": 56,
      "pressure": 41,
      "agility": 78,
      "physical": 44,
      "technique": 53
    }
  },
  {
    "id": 3082,
    "name": "Alan McCallum",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/f/dfmouw-d7ds.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 42,
      "control": 59,
      "pressure": 46,
      "agility": 60,
      "physical": 44,
      "technique": 58
    }
  },
  {
    "id": 3083,
    "name": "Art Turner",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/q/jqv7htlvo9c.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 60,
      "control": 46,
      "pressure": 79,
      "agility": 52,
      "physical": 57,
      "technique": 43
    }
  },
  {
    "id": 3084,
    "name": "Nai Swanson",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/c/sceaqstvjo0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 40,
      "control": 56,
      "pressure": 62,
      "agility": 50,
      "physical": 68,
      "technique": 59
    }
  },
  {
    "id": 3085,
    "name": "Juan Avis",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/o/mohcbfunexc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 76,
      "control": 68,
      "pressure": 40,
      "agility": 48,
      "physical": 59,
      "technique": 54
    }
  },
  {
    "id": 3086,
    "name": "Caul Erpa",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/a/xaqj2gi3pc0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 54,
      "control": 55,
      "pressure": 50,
      "agility": 53,
      "physical": 52,
      "technique": 62
    }
  },
  {
    "id": 3087,
    "name": "Abby de Valera",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/o/5olushb-iuu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 51,
      "control": 61,
      "pressure": 40,
      "agility": 51,
      "physical": 58,
      "technique": 54
    }
  },
  {
    "id": 3088,
    "name": "Sal Hughes",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/a/ia6pbeneld8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 53,
      "control": 42,
      "pressure": 47,
      "agility": 68,
      "physical": 50,
      "technique": 61
    }
  },
  {
    "id": 3089,
    "name": "Gale Mistral",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/v/ovz6sdsmq9m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 42,
      "control": 44,
      "pressure": 70,
      "agility": 53,
      "physical": 69,
      "technique": 56
    }
  },
  {
    "id": 3090,
    "name": "Rihanna Lin",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/h/zhob_8029ok.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 56,
      "control": 63,
      "pressure": 47,
      "agility": 52,
      "physical": 55,
      "technique": 69
    }
  },
  {
    "id": 3091,
    "name": "Richard Roake",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/m/bmvhrlma4ik.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 41,
      "control": 47,
      "pressure": 66,
      "agility": 45,
      "physical": 69,
      "technique": 43
    }
  },
  {
    "id": 3092,
    "name": "Tortus Northe",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/o/qoem8aagv7m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 64,
      "control": 56,
      "pressure": 52,
      "agility": 56,
      "physical": 50,
      "technique": 57
    }
  },
  {
    "id": 3093,
    "name": "Taiga West",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/h/kh9tvh1ogb8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 41,
      "control": 45,
      "pressure": 53,
      "agility": 58,
      "physical": 72,
      "technique": 41
    }
  },
  {
    "id": 3094,
    "name": "Phoenix Southers",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/j/7jmyc4tsnou.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 59,
      "control": 60,
      "pressure": 51,
      "agility": 71,
      "physical": 54,
      "technique": 70
    }
  },
  {
    "id": 3095,
    "name": "Drakaina Eastwick",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/j/pjzqz1qwqx8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 57,
      "control": 54,
      "pressure": 67,
      "agility": 48,
      "physical": 65,
      "technique": 55
    }
  },
  {
    "id": 3096,
    "name": "Johann Storm",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/l/-lclek2khku.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 46,
      "control": 54,
      "pressure": 73,
      "agility": 56,
      "physical": 62,
      "technique": 52
    }
  },
  {
    "id": 3097,
    "name": "Jon Himmel",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/p/upx5cko45pc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 50,
      "control": 48,
      "pressure": 57,
      "agility": 77,
      "physical": 54,
      "technique": 52
    }
  },
  {
    "id": 3098,
    "name": "Val Cano",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/n/lnmyv1ocu80.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 60,
      "control": 57,
      "pressure": 53,
      "agility": 57,
      "physical": 40,
      "technique": 56
    }
  },
  {
    "id": 3099,
    "name": "Seb Rosa",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/i/fift8o7khce.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 46,
      "control": 56,
      "pressure": 68,
      "agility": 52,
      "physical": 71,
      "technique": 57
    }
  },
  {
    "id": 3100,
    "name": "Calla de Wild",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/g/0g0mrxdwmvs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 47,
      "control": 51,
      "pressure": 58,
      "agility": 54,
      "physical": 46,
      "technique": 66
    }
  },
  {
    "id": 3101,
    "name": "Anthea Tussore",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/b/2bzq_opcjps.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 64,
      "control": 78,
      "pressure": 57,
      "agility": 48,
      "physical": 41,
      "technique": 65
    }
  },
  {
    "id": 3102,
    "name": "Sylvia Lagus",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/p/hpcxsxpmkae.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 54,
      "control": 55,
      "pressure": 57,
      "agility": 55,
      "physical": 59,
      "technique": 54
    }
  },
  {
    "id": 3103,
    "name": "Sophie Spencer",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/g/nghebscur60.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 51,
      "control": 48,
      "pressure": 48,
      "agility": 59,
      "physical": 40,
      "technique": 64
    }
  },
  {
    "id": 3104,
    "name": "Erwin Goel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/u/wuqlst6u8jc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 53,
      "control": 52,
      "pressure": 68,
      "agility": 44,
      "physical": 58,
      "technique": 58
    }
  },
  {
    "id": 3105,
    "name": "Raphael Allegro",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/e/iev9de52b20.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 49,
      "control": 56,
      "pressure": 59,
      "agility": 42,
      "physical": 68,
      "technique": 55
    }
  },
  {
    "id": 3106,
    "name": "Azrael Andrews",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/s/tsecwhfm2fc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 56,
      "control": 59,
      "pressure": 59,
      "agility": 42,
      "physical": 44,
      "technique": 51
    }
  },
  {
    "id": 3107,
    "name": "Taranis Virga",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/e/9efrqgwfxp8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 44,
      "control": 56,
      "pressure": 53,
      "agility": 68,
      "physical": 44,
      "technique": 54
    }
  },
  {
    "id": 3108,
    "name": "Olympe Haymes",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/s/ms0whfw_6au.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 27,
      "intelligence": 41,
      "control": 41,
      "pressure": 75,
      "agility": 42,
      "physical": 67,
      "technique": 51
    }
  },
  {
    "id": 3109,
    "name": "Sepia Bartletti",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/d/sdxfucf3p6k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 59,
      "control": 65,
      "pressure": 55,
      "agility": 54,
      "physical": 55,
      "technique": 58
    }
  },
  {
    "id": 3110,
    "name": "Neva Kevinne",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/r/drmk59jnijm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 52,
      "control": 54,
      "pressure": 72,
      "agility": 48,
      "physical": 69,
      "technique": 54
    }
  },
  {
    "id": 3111,
    "name": "Seneca Herrmann",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/k/fkh4xkxhnpm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 52,
      "control": 45,
      "pressure": 45,
      "agility": 66,
      "physical": 40,
      "technique": 52
    }
  },
  {
    "id": 3112,
    "name": "Amy Sargent",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/i/uiqz6bxbk8k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 60,
      "control": 70,
      "pressure": 56,
      "agility": 53,
      "physical": 48,
      "technique": 67
    }
  },
  {
    "id": 3113,
    "name": "Aaron Newgate",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/n/onzspgit_cu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 40,
      "control": 54,
      "pressure": 66,
      "agility": 57,
      "physical": 62,
      "technique": 58
    }
  },
  {
    "id": 3114,
    "name": "Ocho Lightning",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/l/_lcne5epsv8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 61,
      "control": 58,
      "pressure": 41,
      "agility": 43,
      "physical": 57,
      "technique": 55
    }
  },
  {
    "id": 3115,
    "name": "Una Lightning",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/p/lp9v10hl1qu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 46,
      "control": 54,
      "pressure": 73,
      "agility": 53,
      "physical": 59,
      "technique": 55
    }
  },
  {
    "id": 3116,
    "name": "Kyu Lightning",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/n/6nm0ylhxyj8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 59,
      "control": 43,
      "pressure": 41,
      "agility": 61,
      "physical": 47,
      "technique": 60
    }
  },
  {
    "id": 3117,
    "name": "Deece Lightning",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/i/si5_oatyvgc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 69,
      "control": 65,
      "pressure": 53,
      "agility": 54,
      "physical": 48,
      "technique": 53
    }
  },
  {
    "id": 3118,
    "name": "Dri Lightning",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/k/jkiej_1ic10.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 40,
      "control": 56,
      "pressure": 64,
      "agility": 53,
      "physical": 62,
      "technique": 47
    }
  },
  {
    "id": 3119,
    "name": "Sett Lightning",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/l/dlrrwiaa3ve.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 60,
      "control": 44,
      "pressure": 65,
      "agility": 51,
      "physical": 59,
      "technique": 57
    }
  },
  {
    "id": 3120,
    "name": "Cinqua Lightning",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/n/ynakddm6ams.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 49,
      "control": 59,
      "pressure": 61,
      "agility": 45,
      "physical": 62,
      "technique": 55
    }
  },
  {
    "id": 3121,
    "name": "Sei Lightning",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/s/wsdwze0wfgs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 69,
      "control": 72,
      "pressure": 53,
      "agility": 59,
      "physical": 51,
      "technique": 61
    }
  },
  {
    "id": 3122,
    "name": "Charr Lightning",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/e/bes3e7ssyte.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 27,
      "intelligence": 52,
      "control": 53,
      "pressure": 72,
      "agility": 51,
      "physical": 65,
      "technique": 59
    }
  },
  {
    "id": 3123,
    "name": "Dos Lightning",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/r/hrpcnmnkhz0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 50,
      "control": 47,
      "pressure": 53,
      "agility": 68,
      "physical": 40,
      "technique": 53
    }
  },
  {
    "id": 3124,
    "name": "Elf Lightning",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/d/qd-jgzbeqac.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 44,
      "control": 60,
      "pressure": 79,
      "agility": 43,
      "physical": 52,
      "technique": 55
    }
  },
  {
    "id": 3125,
    "name": "Celer Lightfoot",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/p/kpb7ruc8n_0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 45,
      "control": 60,
      "pressure": 41,
      "agility": 71,
      "physical": 60,
      "technique": 70
    }
  },
  {
    "id": 3126,
    "name": "Verity Quick",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/b/vbwa8rkggmc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 54,
      "control": 56,
      "pressure": 57,
      "agility": 55,
      "physical": 60,
      "technique": 60
    }
  },
  {
    "id": 3127,
    "name": "Gonzalo Karter",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/p/7prxmqtpbg8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 60,
      "control": 54,
      "pressure": 68,
      "agility": 55,
      "physical": 70,
      "technique": 60
    }
  },
  {
    "id": 3128,
    "name": "Will Golightly",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/b/kba2lvl1stu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 40,
      "control": 60,
      "pressure": 67,
      "agility": 46,
      "physical": 79,
      "technique": 59
    }
  },
  {
    "id": 3129,
    "name": "Fred Wheeler",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/u/qu5dyi-9zzk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 43,
      "control": 56,
      "pressure": 74,
      "agility": 58,
      "physical": 58,
      "technique": 60
    }
  },
  {
    "id": 3130,
    "name": "Capro Lynes",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/g/bgii13yh0am.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 66,
      "control": 64,
      "pressure": 48,
      "agility": 41,
      "physical": 55,
      "technique": 56
    }
  },
  {
    "id": 3131,
    "name": "Gabe Roundhouse",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/n/znp-bukrxgm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 46,
      "control": 57,
      "pressure": 71,
      "agility": 54,
      "physical": 63,
      "technique": 42
    }
  },
  {
    "id": 3132,
    "name": "Beorn Kodiak",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/p/op-f2rsrc1k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 48,
      "control": 57,
      "pressure": 72,
      "agility": 59,
      "physical": 57,
      "technique": 48
    }
  },
  {
    "id": 3133,
    "name": "Cham Barra",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/g/igdqlmzzpvu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 51,
      "control": 58,
      "pressure": 68,
      "agility": 58,
      "physical": 59,
      "technique": 41
    }
  },
  {
    "id": 3134,
    "name": "Rex Less",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/i/5isliz_jem8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 74,
      "control": 65,
      "pressure": 50,
      "agility": 48,
      "physical": 44,
      "technique": 51
    }
  },
  {
    "id": 3135,
    "name": "Leon Proudler",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/i/nitt5-8bjzu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 46,
      "control": 59,
      "pressure": 53,
      "agility": 69,
      "physical": 51,
      "technique": 66
    }
  },
  {
    "id": 3136,
    "name": "Watta Kicker",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/k/8kiyuba7oq8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 70,
      "control": 70,
      "pressure": 58,
      "agility": 42,
      "physical": 45,
      "technique": 58
    }
  },
  {
    "id": 3137,
    "name": "Egor Coxcomb",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/i/yit56iwox_u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 56,
      "control": 48,
      "pressure": 74,
      "agility": 60,
      "physical": 57,
      "technique": 47
    }
  },
  {
    "id": 3138,
    "name": "Chrissy Urchin",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/k/dkcyx3w0cm8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 56,
      "control": 65,
      "pressure": 40,
      "agility": 53,
      "physical": 49,
      "technique": 72
    }
  },
  {
    "id": 3139,
    "name": "Brane Friese",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/l/jl_teqj8psm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 55,
      "control": 44,
      "pressure": 44,
      "agility": 73,
      "physical": 55,
      "technique": 50
    }
  },
  {
    "id": 3140,
    "name": "Nitey Niht",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/n/snompvfgefk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 51,
      "control": 52,
      "pressure": 58,
      "agility": 44,
      "physical": 69,
      "technique": 56
    }
  },
  {
    "id": 3141,
    "name": "Toadie Fauna",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/s/qsjqhmxqbzk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 59,
      "control": 56,
      "pressure": 59,
      "agility": 54,
      "physical": 53,
      "technique": 51
    }
  },
  {
    "id": 3142,
    "name": "Trey Faste",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/e/he4xqzxqsqm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 70,
      "control": 64,
      "pressure": 44,
      "agility": 44,
      "physical": 40,
      "technique": 58
    }
  },
  {
    "id": 3143,
    "name": "Spookie Otherside",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/r/brbe5ueyzk8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 44,
      "control": 58,
      "pressure": 78,
      "agility": 56,
      "physical": 77,
      "technique": 44
    }
  },
  {
    "id": 3144,
    "name": "Roland Dent",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/d/wdqlurii05u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 51,
      "control": 53,
      "pressure": 68,
      "agility": 41,
      "physical": 56,
      "technique": 43
    }
  },
  {
    "id": 3145,
    "name": "Trev Eeya",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/p/epv9lchatg8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 54,
      "control": 41,
      "pressure": 60,
      "agility": 74,
      "physical": 42,
      "technique": 65
    }
  },
  {
    "id": 3146,
    "name": "Homer Cooken",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/b/1bkcijh6-1u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 49,
      "control": 56,
      "pressure": 51,
      "agility": 67,
      "physical": 55,
      "technique": 52
    }
  },
  {
    "id": 3147,
    "name": "Leafy Tryadd",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/p/bp_rsiozfz0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 43,
      "control": 43,
      "pressure": 61,
      "agility": 56,
      "physical": 68,
      "technique": 42
    }
  },
  {
    "id": 3148,
    "name": "Bluster Tryadd",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/b/qbow_dojyqc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 45,
      "control": 58,
      "pressure": 69,
      "agility": 51,
      "physical": 60,
      "technique": 48
    }
  },
  {
    "id": 3149,
    "name": "Toasty Tryadd",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/u/kutfsadbhks.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 54,
      "control": 50,
      "pressure": 55,
      "agility": 65,
      "physical": 46,
      "technique": 54
    }
  },
  {
    "id": 3150,
    "name": "Watson Itfamie",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/g/7gckb_77q5e.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 49,
      "control": 46,
      "pressure": 52,
      "agility": 57,
      "physical": 44,
      "technique": 61
    }
  },
  {
    "id": 3151,
    "name": "Snapper Krabbie",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/n/5nb4vmpxv_e.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 58,
      "control": 41,
      "pressure": 70,
      "agility": 51,
      "physical": 60,
      "technique": 57
    }
  },
  {
    "id": 3152,
    "name": "Blakey Itchifoot",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/p/ipqzczptcms.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 58,
      "control": 63,
      "pressure": 44,
      "agility": 44,
      "physical": 42,
      "technique": 69
    }
  },
  {
    "id": 3153,
    "name": "Foley Edge",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/g/ogjsre6l3sc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 52,
      "control": 43,
      "pressure": 75,
      "agility": 60,
      "physical": 69,
      "technique": 42
    }
  },
  {
    "id": 3154,
    "name": "Gee Kasoid",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/i/zi4n87cfaf0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 80,
      "control": 75,
      "pressure": 49,
      "agility": 48,
      "physical": 49,
      "technique": 58
    }
  },
  {
    "id": 3155,
    "name": "Hippolytus Horseriver",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/i/tihvn2f99gc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 45,
      "control": 50,
      "pressure": 70,
      "agility": 58,
      "physical": 63,
      "technique": 54
    }
  },
  {
    "id": 3156,
    "name": "Hart O'Gold",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/k/ck20gj5hqt0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 54,
      "control": 47,
      "pressure": 53,
      "agility": 66,
      "physical": 46,
      "technique": 52
    }
  },
  {
    "id": 3157,
    "name": "Oz Rater",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/0/g0gldmknrae.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 48,
      "control": 43,
      "pressure": 41,
      "agility": 73,
      "physical": 50,
      "technique": 59
    }
  },
  {
    "id": 3158,
    "name": "Tish Badum",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/c/rcreuzs38zs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 41,
      "control": 46,
      "pressure": 65,
      "agility": 46,
      "physical": 66,
      "technique": 54
    }
  },
  {
    "id": 3159,
    "name": "Stace Strikes",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/z/xzyx9uz_jtc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 61,
      "control": 58,
      "pressure": 52,
      "agility": 56,
      "physical": 52,
      "technique": 52
    }
  },
  {
    "id": 3160,
    "name": "Mo Zake",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/b/abdqqr_fkg0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 53,
      "control": 42,
      "pressure": 70,
      "agility": 50,
      "physical": 64,
      "technique": 60
    }
  },
  {
    "id": 3161,
    "name": "Eska Layte",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/6/c6em-itphm0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 53,
      "control": 45,
      "pressure": 53,
      "agility": 55,
      "physical": 42,
      "technique": 54
    }
  },
  {
    "id": 3162,
    "name": "Eartha Toughlove",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/s/zs1tt3ltmvc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 52,
      "control": 54,
      "pressure": 83,
      "agility": 43,
      "physical": 55,
      "technique": 53
    }
  },
  {
    "id": 3163,
    "name": "Carny Voris",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/9/t9wyaq-b51s.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 43,
      "control": 52,
      "pressure": 74,
      "agility": 60,
      "physical": 70,
      "technique": 53
    }
  },
  {
    "id": 3164,
    "name": "Logan Armstrong",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/v/ivn5tvyhuge.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 53,
      "control": 60,
      "pressure": 61,
      "agility": 41,
      "physical": 55,
      "technique": 54
    }
  },
  {
    "id": 3165,
    "name": "Boyle Egger",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/_/w_yhcybdz5s.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 56,
      "control": 41,
      "pressure": 52,
      "agility": 59,
      "physical": 45,
      "technique": 55
    }
  },
  {
    "id": 3166,
    "name": "Robin O'Cruise",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/x/nxpaxn95eke.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 63,
      "control": 75,
      "pressure": 59,
      "agility": 51,
      "physical": 55,
      "technique": 69
    }
  },
  {
    "id": 3167,
    "name": "Eric Byrne",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/_/j_ynrm0w_mk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 49,
      "control": 44,
      "pressure": 48,
      "agility": 77,
      "physical": 49,
      "technique": 66
    }
  },
  {
    "id": 3168,
    "name": "Lykan Moss",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/x/4xdsgzsksvm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 42,
      "control": 60,
      "pressure": 68,
      "agility": 44,
      "physical": 72,
      "technique": 50
    }
  },
  {
    "id": 3169,
    "name": "Charity Verchu",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/4/y4gzvencn18.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 59,
      "control": 52,
      "pressure": 46,
      "agility": 54,
      "physical": 40,
      "technique": 62
    }
  },
  {
    "id": 3170,
    "name": "Moos Akka",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/q/pqr447b4kgu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 71,
      "control": 71,
      "pressure": 42,
      "agility": 48,
      "physical": 60,
      "technique": 69
    }
  },
  {
    "id": 3171,
    "name": "Tommie Loveapple",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/x/rxwkwitupau.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 57,
      "control": 52,
      "pressure": 56,
      "agility": 58,
      "physical": 73,
      "technique": 40
    }
  },
  {
    "id": 3172,
    "name": "Pepe Bell",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/z/aznf7d1uiz8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 57,
      "control": 56,
      "pressure": 75,
      "agility": 57,
      "physical": 53,
      "technique": 60
    }
  },
  {
    "id": 3173,
    "name": "Ginger Carret",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/2/62ewoaamxtm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 45,
      "control": 47,
      "pressure": 68,
      "agility": 48,
      "physical": 54,
      "technique": 50
    }
  },
  {
    "id": 3174,
    "name": "Shah Lott",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/e/le1rf_mc6gk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 29,
      "intelligence": 59,
      "control": 57,
      "pressure": 68,
      "agility": 52,
      "physical": 52,
      "technique": 51
    }
  },
  {
    "id": 3175,
    "name": "Hal Istic",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/0/_0kj0yl-dfm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 51,
      "control": 44,
      "pressure": 44,
      "agility": 65,
      "physical": 42,
      "technique": 68
    }
  },
  {
    "id": 3176,
    "name": "Fred Sidemanners",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/c/oc7ozndewsk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 54,
      "control": 49,
      "pressure": 70,
      "agility": 44,
      "physical": 58,
      "technique": 52
    }
  },
  {
    "id": 3177,
    "name": "Dennis Tistry",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/0/a00j3epxp5m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 61,
      "control": 70,
      "pressure": 41,
      "agility": 47,
      "physical": 49,
      "technique": 53
    }
  },
  {
    "id": 3178,
    "name": "Slim Pointer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/c/xcfca7plikk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 62,
      "control": 64,
      "pressure": 51,
      "agility": 54,
      "physical": 49,
      "technique": 48
    }
  },
  {
    "id": 3179,
    "name": "Florence Orderly",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/z/rzm3jm6dxqu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 55,
      "control": 47,
      "pressure": 67,
      "agility": 57,
      "physical": 61,
      "technique": 51
    }
  },
  {
    "id": 3180,
    "name": "Prue Scription",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/b/gbxwkzc56z8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 58,
      "control": 50,
      "pressure": 58,
      "agility": 54,
      "physical": 76,
      "technique": 49
    }
  },
  {
    "id": 3181,
    "name": "Indy Rockrolle",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/6/i6qkkaov_f8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 57,
      "control": 58,
      "pressure": 60,
      "agility": 45,
      "physical": 63,
      "technique": 48
    }
  },
  {
    "id": 3182,
    "name": "Orson Riffe",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/s/tshrn_ovssu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 62,
      "control": 64,
      "pressure": 45,
      "agility": 58,
      "physical": 40,
      "technique": 60
    }
  },
  {
    "id": 3183,
    "name": "Joe Bloggs",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/9/z9ce0idnnmk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 57,
      "control": 69,
      "pressure": 45,
      "agility": 56,
      "physical": 52,
      "technique": 61
    }
  },
  {
    "id": 3184,
    "name": "Devin Hornes",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/v/cvz_zd7dk_m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 56,
      "control": 58,
      "pressure": 59,
      "agility": 55,
      "physical": 66,
      "technique": 42
    }
  },
  {
    "id": 3185,
    "name": "Tom-Tom Thrasher",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/_/2_mnoq4_tak.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 56,
      "control": 55,
      "pressure": 65,
      "agility": 57,
      "physical": 66,
      "technique": 47
    }
  },
  {
    "id": 3186,
    "name": "Bea Jou",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/x/hx9gfvefazm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 59,
      "control": 47,
      "pressure": 47,
      "agility": 77,
      "physical": 56,
      "technique": 57
    }
  },
  {
    "id": 3187,
    "name": "Scaris Cowler",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/_/p_mlfuxmhfs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 40,
      "control": 59,
      "pressure": 52,
      "agility": 65,
      "physical": 43,
      "technique": 56
    }
  },
  {
    "id": 3188,
    "name": "Hardy Scrapper",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/x/yxxqyrx2mse.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 59,
      "control": 52,
      "pressure": 49,
      "agility": 69,
      "physical": 58,
      "technique": 60
    }
  },
  {
    "id": 3189,
    "name": "Rumer ReVeale",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/4/440fhme-5m0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 45,
      "control": 40,
      "pressure": 43,
      "agility": 61,
      "physical": 45,
      "technique": 60
    }
  },
  {
    "id": 3190,
    "name": "Larga Thanlyfe",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/q/jqf-mzieu_c.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 43,
      "control": 41,
      "pressure": 69,
      "agility": 48,
      "physical": 67,
      "technique": 55
    }
  },
  {
    "id": 3191,
    "name": "Scally Wagg",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/x/lxciiqwor5c.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 53,
      "control": 75,
      "pressure": 44,
      "agility": 40,
      "physical": 57,
      "technique": 52
    }
  },
  {
    "id": 3192,
    "name": "Esteban Range",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/z/6zzdpvws8k0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 58,
      "control": 57,
      "pressure": 75,
      "agility": 51,
      "physical": 58,
      "technique": 45
    }
  },
  {
    "id": 3193,
    "name": "Emilia Odde",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/2/a2q2cijajqe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 26,
      "intelligence": 57,
      "control": 41,
      "pressure": 68,
      "agility": 57,
      "physical": 54,
      "technique": 57
    }
  },
  {
    "id": 3194,
    "name": "Alicia Odde",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/e/rehxx3fgkzs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 48,
      "control": 48,
      "pressure": 70,
      "agility": 49,
      "physical": 68,
      "technique": 53
    }
  },
  {
    "id": 3195,
    "name": "Dilly Honeywell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/0/f0epa6gcdme.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 51,
      "control": 67,
      "pressure": 60,
      "agility": 49,
      "physical": 52,
      "technique": 75
    }
  },
  {
    "id": 3196,
    "name": "Sally Honeywell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/c/ucvutfg4uvs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 68,
      "control": 70,
      "pressure": 45,
      "agility": 47,
      "physical": 56,
      "technique": 64
    }
  },
  {
    "id": 3197,
    "name": "Lora Fayre",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/y/ey6cxf-kq-k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 60,
      "control": 41,
      "pressure": 54,
      "agility": 64,
      "physical": 41,
      "technique": 69
    }
  },
  {
    "id": 3198,
    "name": "Melody Fayre",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/w/1wl9c6yw9nm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 49,
      "control": 50,
      "pressure": 51,
      "agility": 71,
      "physical": 57,
      "technique": 59
    }
  },
  {
    "id": 3199,
    "name": "Carter Spaid",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/f/vfoipnt4it8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 52,
      "control": 47,
      "pressure": 47,
      "agility": 75,
      "physical": 46,
      "technique": 49
    }
  },
  {
    "id": 3200,
    "name": "Cobie Clubb",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/3/k3zpiylcleu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 48,
      "control": 50,
      "pressure": 67,
      "agility": 50,
      "physical": 67,
      "technique": 57
    }
  },
  {
    "id": 3201,
    "name": "Dai Mondo",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/w/mwe1mbzugyu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 54,
      "control": 60,
      "pressure": 55,
      "agility": 55,
      "physical": 53,
      "technique": 46
    }
  },
  {
    "id": 3202,
    "name": "Pinkie Harte",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/-/x-vuh-_unr8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 69,
      "control": 59,
      "pressure": 56,
      "agility": 54,
      "physical": 54,
      "technique": 61
    }
  },
  {
    "id": 3203,
    "name": "Captain Jokar",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/r/3rmhyjkc4lm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 51,
      "control": 59,
      "pressure": 43,
      "agility": 79,
      "physical": 41,
      "technique": 59
    }
  },
  {
    "id": 3204,
    "name": "Ms QT",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/5/g59afcsmv4k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 63,
      "control": 75,
      "pressure": 54,
      "agility": 40,
      "physical": 46,
      "technique": 71
    }
  },
  {
    "id": 3205,
    "name": "Ruff Weedon",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/t/ytcyurveyhm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 45,
      "control": 41,
      "pressure": 49,
      "agility": 64,
      "physical": 54,
      "technique": 66
    }
  },
  {
    "id": 3206,
    "name": "Tuff Weedon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/7/d7z5duj-f0k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 45,
      "control": 40,
      "pressure": 59,
      "agility": 42,
      "physical": 55,
      "technique": 57
    }
  },
  {
    "id": 3207,
    "name": "Gen Tillmann",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/t/tto0zva3-ye.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 41,
      "control": 50,
      "pressure": 69,
      "agility": 55,
      "physical": 57,
      "technique": 51
    }
  },
  {
    "id": 3208,
    "name": "Abel Bumpkin",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/7/c7zv0qmntrs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 51,
      "control": 56,
      "pressure": 70,
      "agility": 43,
      "physical": 66,
      "technique": 54
    }
  },
  {
    "id": 3209,
    "name": "Av Antguard",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/u/8u6gnntfmlc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 30,
      "intelligence": 42,
      "control": 40,
      "pressure": 69,
      "agility": 58,
      "physical": 60,
      "technique": 53
    }
  },
  {
    "id": 3210,
    "name": "Beat Baxter",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/8/n8lbky1_l40.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 50,
      "control": 53,
      "pressure": 71,
      "agility": 60,
      "physical": 73,
      "technique": 52
    }
  },
  {
    "id": 3211,
    "name": "Rocky Zine",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/d/pdmdkrnto-0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 60,
      "control": 50,
      "pressure": 57,
      "agility": 50,
      "physical": 42,
      "technique": 56
    }
  },
  {
    "id": 3212,
    "name": "Baz Boyes",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/1/-198jubpjnc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 66,
      "control": 61,
      "pressure": 41,
      "agility": 44,
      "physical": 58,
      "technique": 61
    }
  },
  {
    "id": 3213,
    "name": "Orel Knighter",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/a/eaejaj0hwts.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 58,
      "control": 58,
      "pressure": 48,
      "agility": 56,
      "physical": 44,
      "technique": 55
    }
  },
  {
    "id": 3214,
    "name": "Rith McCal",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/y/vyvo32sb7ee.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 51,
      "control": 44,
      "pressure": 62,
      "agility": 48,
      "physical": 73,
      "technique": 43
    }
  },
  {
    "id": 3215,
    "name": "Tarquin Chatstone",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/y/byqwg7r5chs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 50,
      "control": 52,
      "pressure": 74,
      "agility": 49,
      "physical": 60,
      "technique": 53
    }
  },
  {
    "id": 3216,
    "name": "Ed Jogge",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/w/qwhrre3dxse.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 60,
      "control": 60,
      "pressure": 65,
      "agility": 60,
      "physical": 58,
      "technique": 54
    }
  },
  {
    "id": 3217,
    "name": "Shiv Allrie",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/s/rsiryxtoxn8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 74,
      "control": 60,
      "pressure": 46,
      "agility": 48,
      "physical": 44,
      "technique": 57
    }
  },
  {
    "id": 3218,
    "name": "Teo Chaspet",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/6/g65wfolscuu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 57,
      "control": 50,
      "pressure": 41,
      "agility": 64,
      "physical": 60,
      "technique": 59
    }
  },
  {
    "id": 3219,
    "name": "Drummond Bays",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/v/avafmt-ap0k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 55,
      "control": 48,
      "pressure": 40,
      "agility": 71,
      "physical": 41,
      "technique": 53
    }
  },
  {
    "id": 3220,
    "name": "Bowan Arras",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/9/x9rkhsygehm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 45,
      "control": 52,
      "pressure": 41,
      "agility": 50,
      "physical": 49,
      "technique": 57
    }
  },
  {
    "id": 3221,
    "name": "Patty Sierra",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/c/zcs4p1kmbbm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 42,
      "control": 59,
      "pressure": 62,
      "agility": 47,
      "physical": 64,
      "technique": 51
    }
  },
  {
    "id": 3222,
    "name": "Millie Cheer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/0/c0dziks2syk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 58,
      "control": 56,
      "pressure": 40,
      "agility": 54,
      "physical": 47,
      "technique": 56
    }
  },
  {
    "id": 3223,
    "name": "Daisy Young",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/b/ib-sxxz-zsu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 53,
      "control": 50,
      "pressure": 57,
      "agility": 56,
      "physical": 69,
      "technique": 45
    }
  },
  {
    "id": 3224,
    "name": "Precious Cryan",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/z/tzpnco_e0h8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 42,
      "control": 43,
      "pressure": 62,
      "agility": 54,
      "physical": 68,
      "technique": 53
    }
  },
  {
    "id": 3225,
    "name": "Rio Sands",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/z/nzwvtl8mteu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 50,
      "control": 54,
      "pressure": 47,
      "agility": 62,
      "physical": 51,
      "technique": 58
    }
  },
  {
    "id": 3226,
    "name": "Cynthia Electra",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/x/wxb0aaac-t8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 51,
      "control": 52,
      "pressure": 47,
      "agility": 65,
      "physical": 45,
      "technique": 47
    }
  },
  {
    "id": 3227,
    "name": "Ord Ayshus",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/z/4za5abtvfbc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 60,
      "control": 42,
      "pressure": 75,
      "agility": 46,
      "physical": 69,
      "technique": 45
    }
  },
  {
    "id": 3228,
    "name": "Moe Tivation",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/x/jxry3k1vyy0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 40,
      "control": 47,
      "pressure": 65,
      "agility": 57,
      "physical": 61,
      "technique": 60
    }
  },
  {
    "id": 3229,
    "name": "Gus Duneaton",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/e/peitk5anhse.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 44,
      "control": 46,
      "pressure": 76,
      "agility": 52,
      "physical": 60,
      "technique": 60
    }
  },
  {
    "id": 3230,
    "name": "Dexter Poine",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/2/y25mjgmdqhs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 55,
      "control": 41,
      "pressure": 41,
      "agility": 70,
      "physical": 41,
      "technique": 55
    }
  },
  {
    "id": 3231,
    "name": "Barry Tone",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/x/ax-qnf0xvns.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 69,
      "control": 54,
      "pressure": 48,
      "agility": 44,
      "physical": 51,
      "technique": 66
    }
  },
  {
    "id": 3232,
    "name": "Noah Nymous",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/_/r_pxkgslcue.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 64,
      "control": 61,
      "pressure": 60,
      "agility": 48,
      "physical": 45,
      "technique": 50
    }
  },
  {
    "id": 3233,
    "name": "Dan Bannerman",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/q/lqsez9nd300.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 51,
      "control": 49,
      "pressure": 57,
      "agility": 51,
      "physical": 65,
      "technique": 50
    }
  },
  {
    "id": 3234,
    "name": "Neil Yetty",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/4/64dl0cb5ahc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 54,
      "control": 57,
      "pressure": 48,
      "agility": 56,
      "physical": 45,
      "technique": 48
    }
  },
  {
    "id": 3235,
    "name": "Montana Fleetfoot",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/s/osi9fpcb940.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 63,
      "control": 71,
      "pressure": 52,
      "agility": 58,
      "physical": 52,
      "technique": 58
    }
  },
  {
    "id": 3236,
    "name": "Harold Oldings",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/6/_6tcowkhqlc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 47,
      "control": 50,
      "pressure": 50,
      "agility": 45,
      "physical": 61,
      "technique": 53
    }
  },
  {
    "id": 3237,
    "name": "Bonza Barnett",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/s/xscxg5ouve0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 67,
      "control": 58,
      "pressure": 51,
      "agility": 57,
      "physical": 40,
      "technique": 55
    }
  },
  {
    "id": 3238,
    "name": "Drew Serkell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/6/a6t2rgouctc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 70,
      "control": 68,
      "pressure": 56,
      "agility": 52,
      "physical": 55,
      "technique": 54
    }
  },
  {
    "id": 3239,
    "name": "Jack O'Nonne",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/v/gvod4bdm3ns.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 55,
      "control": 59,
      "pressure": 57,
      "agility": 52,
      "physical": 45,
      "technique": 48
    }
  },
  {
    "id": 3240,
    "name": "Delia Sykes",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/9/r9_ivk7ca-e.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 42,
      "control": 60,
      "pressure": 59,
      "agility": 68,
      "physical": 45,
      "technique": 58
    }
  },
  {
    "id": 3241,
    "name": "Lucius Lox",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/c/tc4-79pwf4e.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 50,
      "control": 55,
      "pressure": 70,
      "agility": 57,
      "physical": 51,
      "technique": 42
    }
  },
  {
    "id": 3242,
    "name": "Strata Pudden",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/0/i0jfwcpkyls.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 45,
      "control": 55,
      "pressure": 52,
      "agility": 55,
      "physical": 67,
      "technique": 55
    }
  },
  {
    "id": 3243,
    "name": "Silvio Di Fence",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/b/cbqqff6chrc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 60,
      "control": 60,
      "pressure": 55,
      "agility": 69,
      "physical": 47,
      "technique": 64
    }
  },
  {
    "id": 3244,
    "name": "Harriet Pynn",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/z/zzblogc4qy0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 50,
      "control": 56,
      "pressure": 55,
      "agility": 56,
      "physical": 62,
      "technique": 48
    }
  },
  {
    "id": 3245,
    "name": "Ash Cagger",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/z/hzktztfannc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 55,
      "control": 53,
      "pressure": 73,
      "agility": 47,
      "physical": 60,
      "technique": 46
    }
  },
  {
    "id": 3246,
    "name": "Mint Royle",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/x/2xvy0s5ggu0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 51,
      "control": 66,
      "pressure": 60,
      "agility": 50,
      "physical": 57,
      "technique": 50
    }
  },
  {
    "id": 3247,
    "name": "Virgil Ante",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/z/yzo_utwpb4u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 50,
      "control": 43,
      "pressure": 74,
      "agility": 58,
      "physical": 57,
      "technique": 54
    }
  },
  {
    "id": 3248,
    "name": "Del Aket",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/x/px_edswtsl8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 42,
      "control": 44,
      "pressure": 71,
      "agility": 50,
      "physical": 73,
      "technique": 54
    }
  },
  {
    "id": 3249,
    "name": "Holly Blue",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/e/jecrqxjbzrm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 55,
      "control": 56,
      "pressure": 42,
      "agility": 72,
      "physical": 51,
      "technique": 51
    }
  },
  {
    "id": 3250,
    "name": "Preston Digitate",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/2/42tk9ofh0yk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 54,
      "control": 45,
      "pressure": 65,
      "agility": 50,
      "physical": 57,
      "technique": 59
    }
  },
  {
    "id": 3251,
    "name": "Graham Bock",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/x/6xqwtxxnxek.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 62,
      "control": 68,
      "pressure": 55,
      "agility": 60,
      "physical": 51,
      "technique": 63
    }
  },
  {
    "id": 3252,
    "name": "Ryan Tamer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/_/l_b3-ox3ctm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 67,
      "control": 55,
      "pressure": 45,
      "agility": 43,
      "physical": 60,
      "technique": 65
    }
  },
  {
    "id": 3253,
    "name": "Jon Gleur",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/q/rq4ct1e_pn8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 50,
      "control": 52,
      "pressure": 67,
      "agility": 56,
      "physical": 74,
      "technique": 60
    }
  },
  {
    "id": 3254,
    "name": "Sammy Salter",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/4/a4jjakife-u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 58,
      "control": 57,
      "pressure": 67,
      "agility": 42,
      "physical": 75,
      "technique": 54
    }
  },
  {
    "id": 3255,
    "name": "Singer Long",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/s/us27xhhnjb8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 45,
      "control": 48,
      "pressure": 69,
      "agility": 47,
      "physical": 62,
      "technique": 57
    }
  },
  {
    "id": 3256,
    "name": "Turner Newleaf",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/6/f6hac4hdoyu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 49,
      "control": 58,
      "pressure": 68,
      "agility": 41,
      "physical": 60,
      "technique": 58
    }
  },
  {
    "id": 3257,
    "name": "Humphrey Dictable",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/e/jerl_90xphk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 48,
      "control": 56,
      "pressure": 76,
      "agility": 53,
      "physical": 72,
      "technique": 57
    }
  },
  {
    "id": 3258,
    "name": "Kik O'Round",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/s/ssgqscstism.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 81,
      "intelligence": 58,
      "control": 40,
      "pressure": 44,
      "agility": 63,
      "physical": 54,
      "technique": 67
    }
  },
  {
    "id": 3259,
    "name": "Dirk Point",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/d/yddfbfnlxy8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 54,
      "control": 73,
      "pressure": 46,
      "agility": 48,
      "physical": 44,
      "technique": 62
    }
  },
  {
    "id": 3260,
    "name": "Molly Gunn",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/r/dry-sgbf6bu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 46,
      "control": 50,
      "pressure": 44,
      "agility": 57,
      "physical": 52,
      "technique": 59
    }
  },
  {
    "id": 3261,
    "name": "Gord Squash",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/k/bk1ic5tz_hu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 60,
      "control": 50,
      "pressure": 72,
      "agility": 42,
      "physical": 58,
      "technique": 56
    }
  },
  {
    "id": 3262,
    "name": "Luna Reid",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/i/wiedvg1js08.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 58,
      "control": 55,
      "pressure": 61,
      "agility": 53,
      "physical": 79,
      "technique": 60
    }
  },
  {
    "id": 3263,
    "name": "Cole Bludd",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/n/qnn28babnum.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 53,
      "control": 40,
      "pressure": 62,
      "agility": 50,
      "physical": 60,
      "technique": 59
    }
  },
  {
    "id": 3264,
    "name": "Sidney Cal",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/l/hlwxrkm7knk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 58,
      "control": 65,
      "pressure": 56,
      "agility": 52,
      "physical": 59,
      "technique": 61
    }
  },
  {
    "id": 3265,
    "name": "Greena Grasse",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/p/vpppgplztym.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 43,
      "control": 43,
      "pressure": 78,
      "agility": 43,
      "physical": 55,
      "technique": 55
    }
  },
  {
    "id": 3266,
    "name": "Rick Whited",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/n/knyunwdjark.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 79,
      "control": 58,
      "pressure": 49,
      "agility": 47,
      "physical": 54,
      "technique": 47
    }
  },
  {
    "id": 3267,
    "name": "Carey Noakie",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/p/kpdjxxkqhhe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 41,
      "control": 40,
      "pressure": 41,
      "agility": 75,
      "physical": 52,
      "technique": 56
    }
  },
  {
    "id": 3268,
    "name": "Dave Dreem",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/n/7nyc6osqm0s.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 52,
      "control": 44,
      "pressure": 55,
      "agility": 53,
      "physical": 50,
      "technique": 44
    }
  },
  {
    "id": 3269,
    "name": "Donna Hooan",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/i/bir3p1zy5uc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 58,
      "control": 40,
      "pressure": 79,
      "agility": 51,
      "physical": 58,
      "technique": 56
    }
  },
  {
    "id": 3270,
    "name": "Bertie Cees",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/g/qggwek_iun0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 53,
      "control": 51,
      "pressure": 61,
      "agility": 57,
      "physical": 75,
      "technique": 56
    }
  },
  {
    "id": 3271,
    "name": "Sylvester Tung",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/b/obnkqttorh0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 57,
      "control": 58,
      "pressure": 80,
      "agility": 55,
      "physical": 66,
      "technique": 54
    }
  },
  {
    "id": 3272,
    "name": "Steph Scorer",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/p/zpwrhsl08sc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 42,
      "control": 42,
      "pressure": 42,
      "agility": 62,
      "physical": 57,
      "technique": 71
    }
  },
  {
    "id": 3273,
    "name": "Gen Tallgiant",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/g/5g1eux-8jys.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 43,
      "control": 49,
      "pressure": 70,
      "agility": 42,
      "physical": 55,
      "technique": 50
    }
  },
  {
    "id": 3274,
    "name": "Wick Bowler",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/u/iue_5oygkbe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 55,
      "control": 53,
      "pressure": 40,
      "agility": 66,
      "physical": 43,
      "technique": 56
    }
  },
  {
    "id": 3275,
    "name": "Perpetua Naim",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/e/8e7nidbkd-s.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 65,
      "control": 75,
      "pressure": 41,
      "agility": 49,
      "physical": 51,
      "technique": 61
    }
  },
  {
    "id": 3276,
    "name": "Rhys Eller",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/s/nskgl89eune.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 56,
      "control": 57,
      "pressure": 72,
      "agility": 53,
      "physical": 55,
      "technique": 46
    }
  },
  {
    "id": 3277,
    "name": "Ro St Nutts",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/e/defnl1xrrys.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 57,
      "control": 48,
      "pressure": 51,
      "agility": 43,
      "physical": 59,
      "technique": 46
    }
  },
  {
    "id": 3278,
    "name": "Byrd Stryke",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/s/ys0smkxr8re.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 50,
      "control": 41,
      "pressure": 74,
      "agility": 42,
      "physical": 63,
      "technique": 54
    }
  },
  {
    "id": 3279,
    "name": "Bianco Snowden",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/d/sdxz1xezjl0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 42,
      "control": 48,
      "pressure": 78,
      "agility": 43,
      "physical": 59,
      "technique": 51
    }
  },
  {
    "id": 3280,
    "name": "Folda Steel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/r/jrm4yoijk4c.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 42,
      "control": 58,
      "pressure": 75,
      "agility": 59,
      "physical": 68,
      "technique": 47
    }
  },
  {
    "id": 3281,
    "name": "Bonnie Sytree",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/k/hkhk2xwph-c.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 78,
      "control": 54,
      "pressure": 56,
      "agility": 58,
      "physical": 49,
      "technique": 65
    }
  },
  {
    "id": 3282,
    "name": "Chief Kerr",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/i/qiqfbow1mn0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 70,
      "control": 70,
      "pressure": 49,
      "agility": 47,
      "physical": 51,
      "technique": 54
    }
  },
  {
    "id": 3283,
    "name": "Benji Near",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/n/wnzwitj95te.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 59,
      "control": 50,
      "pressure": 63,
      "agility": 40,
      "physical": 65,
      "technique": 59
    }
  },
  {
    "id": 3284,
    "name": "Boo Fonte",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/l/blcrlsfhues.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 51,
      "control": 54,
      "pressure": 73,
      "agility": 49,
      "physical": 50,
      "technique": 45
    }
  },
  {
    "id": 3285,
    "name": "Wyther Longfeys",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/p/1p9juhglzhe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 55,
      "control": 56,
      "pressure": 63,
      "agility": 48,
      "physical": 64,
      "technique": 60
    }
  },
  {
    "id": 3286,
    "name": "Griz Munkie",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/n/enmo5egfess.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 40,
      "control": 40,
      "pressure": 55,
      "agility": 62,
      "physical": 48,
      "technique": 60
    }
  },
  {
    "id": 3287,
    "name": "Buzz O'Hare",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/p/qpxljfpw_-m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 58,
      "control": 68,
      "pressure": 56,
      "agility": 56,
      "physical": 46,
      "technique": 52
    }
  },
  {
    "id": 3288,
    "name": "Tsun Derrey",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/n/bnmeogpssnk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 69,
      "control": 56,
      "pressure": 59,
      "agility": 53,
      "physical": 57,
      "technique": 50
    }
  },
  {
    "id": 3289,
    "name": "Mia Tior",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/i/7ifxd96kntu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 49,
      "control": 40,
      "pressure": 67,
      "agility": 42,
      "physical": 71,
      "technique": 60
    }
  },
  {
    "id": 3290,
    "name": "Noah Yu",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/g/kg0qwcceke8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 48,
      "control": 49,
      "pressure": 58,
      "agility": 52,
      "physical": 63,
      "technique": 42
    }
  },
  {
    "id": 3291,
    "name": "Art Izan",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/b/ibzmeboypy8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 49,
      "control": 56,
      "pressure": 63,
      "agility": 44,
      "physical": 71,
      "technique": 44
    }
  },
  {
    "id": 3292,
    "name": "Downtworth Beyan",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/p/5pctzkoiiru.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 68,
      "control": 61,
      "pressure": 59,
      "agility": 60,
      "physical": 40,
      "technique": 47
    }
  },
  {
    "id": 3293,
    "name": "Hartwin Throbb",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/g/zghyg5daxlk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 60,
      "control": 44,
      "pressure": 57,
      "agility": 80,
      "physical": 51,
      "technique": 65
    }
  },
  {
    "id": 3294,
    "name": "Damo Jukes",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/u/ouq5ng7664m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 45,
      "control": 42,
      "pressure": 59,
      "agility": 72,
      "physical": 59,
      "technique": 56
    }
  },
  {
    "id": 3295,
    "name": "Indy Iffrent",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/e/cevh8l4ydhk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 58,
      "control": 51,
      "pressure": 65,
      "agility": 56,
      "physical": 53,
      "technique": 40
    }
  },
  {
    "id": 3296,
    "name": "Askel Blays",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/s/tsear0eiw0m.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 47,
      "control": 54,
      "pressure": 71,
      "agility": 51,
      "physical": 68,
      "technique": 40
    }
  },
  {
    "id": 3297,
    "name": "Burt Zerka",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/o/holyn0aqofe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 48,
      "control": 42,
      "pressure": 52,
      "agility": 57,
      "physical": 55,
      "technique": 56
    }
  },
  {
    "id": 3298,
    "name": "Drew Pii",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/a/2a6tglmqjss.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 65,
      "control": 71,
      "pressure": 60,
      "agility": 58,
      "physical": 59,
      "technique": 50
    }
  },
  {
    "id": 3299,
    "name": "Alma Verchu",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/v/wvzmzwtiwmc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 61,
      "control": 74,
      "pressure": 50,
      "agility": 51,
      "physical": 40,
      "technique": 60
    }
  },
  {
    "id": 3300,
    "name": "Sly Sundice",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/h/nhohep1y7_0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 70,
      "control": 73,
      "pressure": 56,
      "agility": 47,
      "physical": 60,
      "technique": 51
    }
  },
  {
    "id": 3301,
    "name": "Pat Ryarke",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/m/lmvbwwn0-50.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 50,
      "control": 54,
      "pressure": 57,
      "agility": 53,
      "physical": 57,
      "technique": 51
    }
  },
  {
    "id": 3302,
    "name": "Trixie Playfair",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/o/uoe6dpbotkc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 67,
      "control": 60,
      "pressure": 57,
      "agility": 48,
      "physical": 46,
      "technique": 59
    }
  },
  {
    "id": 3303,
    "name": "Humphrey Hedrass",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/h/0h9pos0gmqs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 55,
      "control": 69,
      "pressure": 54,
      "agility": 53,
      "physical": 49,
      "technique": 60
    }
  },
  {
    "id": 3304,
    "name": "Hugh Handy",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/j/fjmujts8lze.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 43,
      "control": 52,
      "pressure": 57,
      "agility": 55,
      "physical": 45,
      "technique": 67
    }
  },
  {
    "id": 3305,
    "name": "Len Grayves",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/j/xjz2sgresms.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 57,
      "control": 51,
      "pressure": 43,
      "agility": 76,
      "physical": 59,
      "technique": 65
    }
  },
  {
    "id": 3306,
    "name": "Mick Sologee",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/l/alcx_f3kbve.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 50,
      "control": 56,
      "pressure": 69,
      "agility": 40,
      "physical": 55,
      "technique": 57
    }
  },
  {
    "id": 3307,
    "name": "Colin Urlane",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/j/ujzale-tg5k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 71,
      "control": 66,
      "pressure": 54,
      "agility": 46,
      "physical": 42,
      "technique": 52
    }
  },
  {
    "id": 3308,
    "name": "Francie Holly",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/l/flo7ihyxnkm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 70,
      "control": 57,
      "pressure": 54,
      "agility": 59,
      "physical": 55,
      "technique": 55
    }
  },
  {
    "id": 3309,
    "name": "Mitzi Holly",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/k/_klob8tf4q8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 40,
      "control": 40,
      "pressure": 59,
      "agility": 46,
      "physical": 72,
      "technique": 55
    }
  },
  {
    "id": 3310,
    "name": "Breeze Windward",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/m/om6v2dllvzu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 59,
      "control": 46,
      "pressure": 48,
      "agility": 67,
      "physical": 53,
      "technique": 56
    }
  },
  {
    "id": 3311,
    "name": "Sloan Steddy",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/t/mt9zyazjqfu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 77,
      "control": 65,
      "pressure": 52,
      "agility": 56,
      "physical": 50,
      "technique": 62
    }
  },
  {
    "id": 3312,
    "name": "Frank Redmond",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/f/9fms1l_z9s8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 56,
      "control": 58,
      "pressure": 45,
      "agility": 63,
      "physical": 42,
      "technique": 56
    }
  },
  {
    "id": 3313,
    "name": "Evita Gowell",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/q/dqvnm4k7imm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 50,
      "control": 44,
      "pressure": 78,
      "agility": 43,
      "physical": 65,
      "technique": 46
    }
  },
  {
    "id": 3314,
    "name": "Rundeep Stillwater",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/c/sceglhsbl_k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 60,
      "control": 55,
      "pressure": 61,
      "agility": 50,
      "physical": 65,
      "technique": 53
    }
  },
  {
    "id": 3315,
    "name": "Maya O'Pier",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/o/yohe6kvjcam.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 48,
      "control": 45,
      "pressure": 58,
      "agility": 70,
      "physical": 42,
      "technique": 61
    }
  },
  {
    "id": 3316,
    "name": "Cash Tempest",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/a/paq_x1jzvzk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 65,
      "control": 53,
      "pressure": 52,
      "agility": 52,
      "physical": 54,
      "technique": 53
    }
  },
  {
    "id": 3317,
    "name": "Ramona Tempest",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/f/bfl0b-7aywe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 46,
      "control": 54,
      "pressure": 49,
      "agility": 53,
      "physical": 60,
      "technique": 54
    }
  },
  {
    "id": 3318,
    "name": "Rolanda Tempest",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/t/wtuvsbdg1ls.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 67,
      "control": 75,
      "pressure": 44,
      "agility": 53,
      "physical": 50,
      "technique": 60
    }
  },
  {
    "id": 3319,
    "name": "Shilo Placidus",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/c/qc3g_cooafc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 49,
      "control": 52,
      "pressure": 56,
      "agility": 56,
      "physical": 56,
      "technique": 67
    }
  },
  {
    "id": 3320,
    "name": "Uno Blackley",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/q/hqgbsjost20.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 28,
      "intelligence": 59,
      "control": 47,
      "pressure": 69,
      "agility": 49,
      "physical": 60,
      "technique": 56
    }
  },
  {
    "id": 3321,
    "name": "Due Blackley",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/l/jlbd86c-ow0.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 54,
      "control": 46,
      "pressure": 64,
      "agility": 58,
      "physical": 65,
      "technique": 45
    }
  },
  {
    "id": 3322,
    "name": "Quattro Blackley",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/j/sjw8rf6efdc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 44,
      "control": 57,
      "pressure": 49,
      "agility": 74,
      "physical": 42,
      "technique": 52
    }
  },
  {
    "id": 3323,
    "name": "Cinque Blackley",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/m/ymtjcypmwjs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 81,
      "intelligence": 50,
      "control": 42,
      "pressure": 46,
      "agility": 63,
      "physical": 59,
      "technique": 57
    }
  },
  {
    "id": 3324,
    "name": "Eins Whitely",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/k/dkiovnp2dqe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 55,
      "control": 50,
      "pressure": 55,
      "agility": 47,
      "physical": 64,
      "technique": 52
    }
  },
  {
    "id": 3325,
    "name": "Zwei Whitely",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/o/3odweqqu6vs.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 41,
      "control": 52,
      "pressure": 73,
      "agility": 49,
      "physical": 71,
      "technique": 43
    }
  },
  {
    "id": 3326,
    "name": "Vier Whitely",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/m/gmsrzvmuxce.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 82,
      "intelligence": 55,
      "control": 48,
      "pressure": 47,
      "agility": 63,
      "physical": 42,
      "technique": 63
    }
  },
  {
    "id": 3327,
    "name": "Fünf Whitely",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/o/oo3cpufn2wk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 49,
      "control": 53,
      "pressure": 47,
      "agility": 76,
      "physical": 57,
      "technique": 62
    }
  },
  {
    "id": 3328,
    "name": "Nan Desuka",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/m/zmg9erjdbdm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 46,
      "control": 49,
      "pressure": 74,
      "agility": 45,
      "physical": 54,
      "technique": 47
    }
  },
  {
    "id": 3329,
    "name": "Cloudy Forbes",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/j/5jlix2wvuj8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 45,
      "control": 41,
      "pressure": 55,
      "agility": 58,
      "physical": 58,
      "technique": 54
    }
  },
  {
    "id": 3330,
    "name": "Faye Ted",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/h/ihup6jwvdqu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 58,
      "control": 60,
      "pressure": 50,
      "agility": 51,
      "physical": 40,
      "technique": 65
    }
  },
  {
    "id": 3331,
    "name": "Maude Erne",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/a/kat1uqidgwu.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 42,
      "control": 43,
      "pressure": 48,
      "agility": 64,
      "physical": 40,
      "technique": 60
    }
  },
  {
    "id": 3332,
    "name": "Anne Sestral",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/o/7oiu5ve5rl8.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 50,
      "control": 40,
      "pressure": 40,
      "agility": 68,
      "physical": 41,
      "technique": 60
    }
  },
  {
    "id": 3333,
    "name": "Gale Sweep",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/h/bhbhqyxxefm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 40,
      "control": 48,
      "pressure": 52,
      "agility": 58,
      "physical": 73,
      "technique": 42
    }
  },
  {
    "id": 3334,
    "name": "Theo Therr",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/v/qvwahnxlz2k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 56,
      "control": 52,
      "pressure": 57,
      "agility": 40,
      "physical": 61,
      "technique": 53
    }
  },
  {
    "id": 3335,
    "name": "Samson Bigglesworth",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/f/efpy2aupujm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 51,
      "control": 41,
      "pressure": 71,
      "agility": 57,
      "physical": 56,
      "technique": 55
    }
  },
  {
    "id": 3336,
    "name": "Adam Orable",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/t/vt-5b_yt56k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 71,
      "control": 71,
      "pressure": 57,
      "agility": 47,
      "physical": 41,
      "technique": 49
    }
  },
  {
    "id": 3337,
    "name": "Rain Bowe",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/e/2ea_me35tom.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 58,
      "control": 68,
      "pressure": 60,
      "agility": 41,
      "physical": 57,
      "technique": 57
    }
  },
  {
    "id": 3338,
    "name": "Gazza Irons",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/z/4zihvyl45cc.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 45,
      "control": 48,
      "pressure": 58,
      "agility": 51,
      "physical": 72,
      "technique": 59
    }
  },
  {
    "id": 3339,
    "name": "Grandpa Danger",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/2/y2by8f-wmis.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 52,
      "control": 47,
      "pressure": 66,
      "agility": 48,
      "physical": 55,
      "technique": 42
    }
  },
  {
    "id": 3340,
    "name": "Shortcake Holmes",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/e/pewtr6ykhre.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 46,
      "control": 43,
      "pressure": 71,
      "agility": 53,
      "physical": 59,
      "technique": 47
    }
  },
  {
    "id": 3341,
    "name": "Corvus Cardson",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/b/ibgseubt_ru.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 42,
      "control": 51,
      "pressure": 59,
      "agility": 70,
      "physical": 54,
      "technique": 62
    }
  },
  {
    "id": 3342,
    "name": "Avery Rarecard",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/0/c0lnxj0bkxk.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 48,
      "control": 53,
      "pressure": 50,
      "agility": 73,
      "physical": 44,
      "technique": 52
    }
  },
  {
    "id": 3343,
    "name": "Spot Barkley",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/c/zcug62shncm.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 51,
      "control": 59,
      "pressure": 73,
      "agility": 49,
      "physical": 73,
      "technique": 58
    }
  },
  {
    "id": 3344,
    "name": "Esau Tariq",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/2/h2rel7rda9k.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 63,
      "control": 55,
      "pressure": 48,
      "agility": 49,
      "physical": 57,
      "technique": 71
    }
  },
  {
    "id": 3345,
    "name": "Fletch Blitzen",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/4/64lbbbzu8ec.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 84,
      "intelligence": 55,
      "control": 60,
      "pressure": 52,
      "agility": 77,
      "physical": 40,
      "technique": 63
    }
  },
  {
    "id": 3346,
    "name": "Lawrence Leepson",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/q/lqu6s-_ur30.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 47,
      "control": 41,
      "pressure": 60,
      "agility": 40,
      "physical": 63,
      "technique": 49
    }
  },
  {
    "id": 3347,
    "name": "Bill Ingsgate",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/_/r_3p_jkmkxe.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 58,
      "control": 53,
      "pressure": 41,
      "agility": 59,
      "physical": 47,
      "technique": 60
    }
  },
  {
    "id": 3348,
    "name": "Mickey Schmitt",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/x/axguscscjks.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 52,
      "control": 53,
      "pressure": 60,
      "agility": 47,
      "physical": 53,
      "technique": 48
    }
  },
  {
    "id": 3349,
    "name": "Deliah Azel",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/9/u952jrv-ube.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 57,
      "control": 56,
      "pressure": 55,
      "agility": 58,
      "physical": 57,
      "technique": 59
    }
  },
  {
    "id": 3350,
    "name": "Dirk Eisberg",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/v/fvixoujedos.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 55,
      "control": 62,
      "pressure": 41,
      "agility": 41,
      "physical": 40,
      "technique": 59
    }
  },
  {
    "id": 3351,
    "name": "Damon Valiant",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/9/r9hcgnjx89e.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 59,
      "control": 50,
      "pressure": 49,
      "agility": 67,
      "physical": 40,
      "technique": 61
    }
  },
  {
    "id": 3352,
    "name": "Everard Valiant",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/v/gv29nyflros.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 47,
      "control": 51,
      "pressure": 72,
      "agility": 58,
      "physical": 56,
      "technique": 53
    }
  },
  {
    "id": 3353,
    "name": "Ton Nino",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/j/yjceqobv95u.png",
    "game": [
      "Inazuma Eleven GO"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 67,
      "control": 52,
      "pressure": 40,
      "agility": 55,
      "physical": 59,
      "technique": 64
    }
  },
  {
    "id": 3479,
    "name": "Fei Rune",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/f/3fu1s2p-6ic.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 41,
      "control": 58,
      "pressure": 43,
      "agility": 52,
      "physical": 51,
      "technique": 58
    }
  },
  {
    "id": 3480,
    "name": "Clark von Wunderbar",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/a/qajwzujoguc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 44,
      "control": 40,
      "pressure": 53,
      "agility": 54,
      "physical": 54,
      "technique": 69
    }
  },
  {
    "id": 3481,
    "name": "Vladimir Blade",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/w/xwnabrc2pos.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 44,
      "control": 56,
      "pressure": 59,
      "agility": 55,
      "physical": 49,
      "technique": 66
    }
  },
  {
    "id": 3482,
    "name": "Goldie Lemmon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/5/k579cnognde.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 45,
      "control": 60,
      "pressure": 70,
      "agility": 41,
      "physical": 65,
      "technique": 53
    }
  },
  {
    "id": 3483,
    "name": "Sor",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/r/vrkcvyoakus.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 57,
      "control": 40,
      "pressure": 69,
      "agility": 49,
      "physical": 68,
      "technique": 58
    }
  },
  {
    "id": 3484,
    "name": "Biggsy",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/u/eu8d6cxduu8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 54,
      "control": 40,
      "pressure": 57,
      "agility": 51,
      "physical": 59,
      "technique": 49
    }
  },
  {
    "id": 3485,
    "name": "Smiley",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/7/-7fopbilhom.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 45,
      "control": 57,
      "pressure": 72,
      "agility": 56,
      "physical": 77,
      "technique": 56
    }
  },
  {
    "id": 3486,
    "name": "Skinny",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/t/ptuje-exm9k.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 58,
      "control": 42,
      "pressure": 70,
      "agility": 48,
      "physical": 55,
      "technique": 43
    }
  },
  {
    "id": 3487,
    "name": "Smarty",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/y/nypvqnwdj7k.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 52,
      "control": 57,
      "pressure": 55,
      "agility": 44,
      "physical": 59,
      "technique": 59
    }
  },
  {
    "id": 3488,
    "name": "Chunky",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/a/8ay0hywnkim.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 43,
      "control": 55,
      "pressure": 58,
      "agility": 41,
      "physical": 67,
      "technique": 59
    }
  },
  {
    "id": 3489,
    "name": "Tiny",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/1/c17buffvro8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 70,
      "control": 70,
      "pressure": 48,
      "agility": 52,
      "physical": 57,
      "technique": 66
    }
  },
  {
    "id": 3490,
    "name": "Hairy",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/d/tdkg56jv8bu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 51,
      "control": 55,
      "pressure": 45,
      "agility": 47,
      "physical": 50,
      "technique": 55
    }
  },
  {
    "id": 3491,
    "name": "Spikey",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/f/ofezlign2xu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 75,
      "control": 61,
      "pressure": 44,
      "agility": 45,
      "physical": 54,
      "technique": 65
    }
  },
  {
    "id": 3492,
    "name": "Creepy",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/3/g3fu_jpex70.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 48,
      "control": 56,
      "pressure": 43,
      "agility": 63,
      "physical": 54,
      "technique": 59
    }
  },
  {
    "id": 3493,
    "name": "Hotel",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/c/sclh3qo8qok.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 44,
      "control": 47,
      "pressure": 69,
      "agility": 56,
      "physical": 56,
      "technique": 56
    }
  },
  {
    "id": 3494,
    "name": "Oscar",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/t/mtgykn70fiu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 44,
      "control": 57,
      "pressure": 66,
      "agility": 41,
      "physical": 67,
      "technique": 47
    }
  },
  {
    "id": 3495,
    "name": "Echo",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/f/9f3tjydoy78.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 49,
      "control": 52,
      "pressure": 53,
      "agility": 53,
      "physical": 71,
      "technique": 55
    }
  },
  {
    "id": 3496,
    "name": "Golf",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/k/_kwpnrpi398.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 55,
      "control": 43,
      "pressure": 62,
      "agility": 50,
      "physical": 60,
      "technique": 45
    }
  },
  {
    "id": 3497,
    "name": "Charlie",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/m/ombukupyaou.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 63,
      "control": 66,
      "pressure": 57,
      "agility": 51,
      "physical": 54,
      "technique": 66
    }
  },
  {
    "id": 3498,
    "name": "Lima",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/j/ujibzjcqvuk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 53,
      "control": 67,
      "pressure": 42,
      "agility": 60,
      "physical": 47,
      "technique": 73
    }
  },
  {
    "id": 3499,
    "name": "Bravo",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/l/flt6026qcdm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 62,
      "control": 75,
      "pressure": 42,
      "agility": 46,
      "physical": 56,
      "technique": 68
    }
  },
  {
    "id": 3500,
    "name": "India",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/h/rhsif75ilik.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 74,
      "control": 66,
      "pressure": 58,
      "agility": 53,
      "physical": 53,
      "technique": 61
    }
  },
  {
    "id": 3501,
    "name": "Juliet",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/j/ajddoefyirm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 46,
      "control": 54,
      "pressure": 48,
      "agility": 62,
      "physical": 51,
      "technique": 59
    }
  },
  {
    "id": 3502,
    "name": "Alpha",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/h/0hgoyfw7p9s.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 46,
      "control": 40,
      "pressure": 43,
      "agility": 68,
      "physical": 45,
      "technique": 68
    }
  },
  {
    "id": 3503,
    "name": "Mike",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/j/fj3vf6wbeoe.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 47,
      "control": 45,
      "pressure": 52,
      "agility": 61,
      "physical": 52,
      "technique": 55
    }
  },
  {
    "id": 3504,
    "name": "Uniform",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/m/lmuamnfjxu0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 49,
      "control": 46,
      "pressure": 52,
      "agility": 60,
      "physical": 72,
      "technique": 51
    }
  },
  {
    "id": 3505,
    "name": "Tango",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/o/uol7hyjzcdc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 54,
      "control": 48,
      "pressure": 72,
      "agility": 53,
      "physical": 59,
      "technique": 52
    }
  },
  {
    "id": 3506,
    "name": "Zulu",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/v/wvinpbxfzbc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 52,
      "control": 68,
      "pressure": 45,
      "agility": 55,
      "physical": 41,
      "technique": 65
    }
  },
  {
    "id": 3507,
    "name": "X-Ray",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/h/nhtgi-xl0o0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 56,
      "control": 51,
      "pressure": 60,
      "agility": 51,
      "physical": 57,
      "technique": 64
    }
  },
  {
    "id": 3508,
    "name": "Delta",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/o/howzxjitbie.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 59,
      "control": 41,
      "pressure": 52,
      "agility": 72,
      "physical": 51,
      "technique": 52
    }
  },
  {
    "id": 3509,
    "name": "Kilo",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/f/dfjv96-ysc0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 48,
      "control": 46,
      "pressure": 75,
      "agility": 59,
      "physical": 63,
      "technique": 52
    }
  },
  {
    "id": 3510,
    "name": "Foxtrot",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/m/umvo-ckke3c.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 69,
      "control": 71,
      "pressure": 52,
      "agility": 55,
      "physical": 53,
      "technique": 57
    }
  },
  {
    "id": 3511,
    "name": "November",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/h/lh4kxza07bs.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 69,
      "control": 54,
      "pressure": 57,
      "agility": 57,
      "physical": 54,
      "technique": 53
    }
  },
  {
    "id": 3512,
    "name": "Beta",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/h/uhsign1h3ek.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 53,
      "control": 53,
      "pressure": 55,
      "agility": 55,
      "physical": 59,
      "technique": 59
    }
  },
  {
    "id": 3514,
    "name": "Romeo",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/j/ljjpryt9a3m.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 60,
      "control": 44,
      "pressure": 80,
      "agility": 52,
      "physical": 70,
      "technique": 46
    }
  },
  {
    "id": 3515,
    "name": "Papa",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/v/2v2h7jsjhiu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 46,
      "control": 51,
      "pressure": 68,
      "agility": 58,
      "physical": 65,
      "technique": 45
    }
  },
  {
    "id": 3516,
    "name": "Quebec",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/h/hhhaw20zqr8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 67,
      "control": 62,
      "pressure": 60,
      "agility": 41,
      "physical": 49,
      "technique": 66
    }
  },
  {
    "id": 3517,
    "name": "Sierra",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/q/iqqmzzkjv9m.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 65,
      "control": 66,
      "pressure": 43,
      "agility": 59,
      "physical": 58,
      "technique": 66
    }
  },
  {
    "id": 3518,
    "name": "Gamma",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/g/5gofomcbgls.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 43,
      "control": 48,
      "pressure": 56,
      "agility": 60,
      "physical": 46,
      "technique": 72
    }
  },
  {
    "id": 3530,
    "name": "Norimaru Gazen",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/d/odr4jtbx9fe.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 42,
      "control": 44,
      "pressure": 61,
      "agility": 53,
      "physical": 65,
      "technique": 60
    }
  },
  {
    "id": 3531,
    "name": "Sokichi Kitagami",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/s/usynao05i_0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 54,
      "control": 45,
      "pressure": 62,
      "agility": 52,
      "physical": 57,
      "technique": 57
    }
  },
  {
    "id": 3532,
    "name": "Hoichiro Ashiguro",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/e/feds3xsdlmc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 50,
      "control": 58,
      "pressure": 65,
      "agility": 59,
      "physical": 53,
      "technique": 48
    }
  },
  {
    "id": 3533,
    "name": "Hanbee Yabe",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/l/dlewzoavgkc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 56,
      "control": 49,
      "pressure": 69,
      "agility": 43,
      "physical": 69,
      "technique": 54
    }
  },
  {
    "id": 3534,
    "name": "Ikkatsu Kano",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/n/sn1r0xmvn50.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 71,
      "control": 66,
      "pressure": 58,
      "agility": 60,
      "physical": 44,
      "technique": 55
    }
  },
  {
    "id": 3535,
    "name": "Denbee Asama",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/i/miwknktd4ze.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 53,
      "control": 61,
      "pressure": 60,
      "agility": 45,
      "physical": 40,
      "technique": 48
    }
  },
  {
    "id": 3536,
    "name": "Ginji Santetsu",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/k/9knfk11nvqs.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 67,
      "control": 65,
      "pressure": 43,
      "agility": 41,
      "physical": 43,
      "technique": 55
    }
  },
  {
    "id": 3537,
    "name": "Denrai Ochimura",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/g/jgyd742fyve.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 74,
      "control": 64,
      "pressure": 58,
      "agility": 59,
      "physical": 58,
      "technique": 60
    }
  },
  {
    "id": 3538,
    "name": "Senji Kudo",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/i/4ip8whq_fms.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 62,
      "control": 61,
      "pressure": 40,
      "agility": 45,
      "physical": 42,
      "technique": 56
    }
  },
  {
    "id": 3539,
    "name": "Taian Inaba",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/g/wgyxmgz2-km.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 49,
      "control": 41,
      "pressure": 52,
      "agility": 68,
      "physical": 50,
      "technique": 57
    }
  },
  {
    "id": 3540,
    "name": "Korin Maebayashi",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/i/nidqh5_mt5k.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 50,
      "control": 47,
      "pressure": 40,
      "agility": 56,
      "physical": 59,
      "technique": 56
    }
  },
  {
    "id": 3541,
    "name": "Mikimaru Ujiki",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/n/hnglykkemzu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 43,
      "control": 51,
      "pressure": 69,
      "agility": 45,
      "physical": 65,
      "technique": 50
    }
  },
  {
    "id": 3542,
    "name": "Doshin Yomoyama",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/p/2prefbs-lq8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 42,
      "control": 59,
      "pressure": 58,
      "agility": 56,
      "physical": 74,
      "technique": 46
    }
  },
  {
    "id": 3543,
    "name": "Tenkei Yazu",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/u/0uwyxc-sos8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 58,
      "control": 55,
      "pressure": 50,
      "agility": 47,
      "physical": 53,
      "technique": 51
    }
  },
  {
    "id": 3544,
    "name": "Hokuro Ayabe",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/g/fgn5c9yojfu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 41,
      "control": 48,
      "pressure": 43,
      "agility": 72,
      "physical": 57,
      "technique": 61
    }
  },
  {
    "id": 3545,
    "name": "Kaburo Hayama",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/p/lpempgtgw_k.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 45,
      "control": 44,
      "pressure": 48,
      "agility": 69,
      "physical": 40,
      "technique": 70
    }
  },
  {
    "id": 3546,
    "name": "Bête Noire",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/x/vxq3pqqp_hs.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 41,
      "control": 42,
      "pressure": 58,
      "agility": 64,
      "physical": 46,
      "technique": 56
    }
  },
  {
    "id": 3559,
    "name": "Eka",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/v/8viiefyodzc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 41,
      "control": 51,
      "pressure": 76,
      "agility": 57,
      "physical": 67,
      "technique": 41
    }
  },
  {
    "id": 3560,
    "name": "Dva",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/6/c6rxxctg25s.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 45,
      "control": 48,
      "pressure": 55,
      "agility": 45,
      "physical": 59,
      "technique": 45
    }
  },
  {
    "id": 3561,
    "name": "Tyrah",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/s/tsa269l8bke.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 45,
      "control": 54,
      "pressure": 70,
      "agility": 58,
      "physical": 72,
      "technique": 50
    }
  },
  {
    "id": 3562,
    "name": "Catvari",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/z/vzdqukzqeme.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 44,
      "control": 44,
      "pressure": 63,
      "agility": 60,
      "physical": 56,
      "technique": 45
    }
  },
  {
    "id": 3563,
    "name": "Panca",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/b/ebsl5b_qz_s.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 53,
      "control": 77,
      "pressure": 49,
      "agility": 50,
      "physical": 56,
      "technique": 50
    }
  },
  {
    "id": 3564,
    "name": "Sas",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/0/-0p-qgkigfc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 67,
      "control": 74,
      "pressure": 44,
      "agility": 48,
      "physical": 41,
      "technique": 47
    }
  },
  {
    "id": 3565,
    "name": "Sapta",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/c/pc-fh5syrs0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 56,
      "control": 61,
      "pressure": 50,
      "agility": 54,
      "physical": 60,
      "technique": 68
    }
  },
  {
    "id": 3566,
    "name": "Asta",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/2/72bh20v6mtc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 78,
      "control": 80,
      "pressure": 60,
      "agility": 49,
      "physical": 47,
      "technique": 65
    }
  },
  {
    "id": 3567,
    "name": "Navan",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/e/kewmbljahg0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 56,
      "control": 57,
      "pressure": 55,
      "agility": 51,
      "physical": 54,
      "technique": 51
    }
  },
  {
    "id": 3568,
    "name": "Zanark Avalonic",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/2/k2rrbkajamu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 51,
      "control": 52,
      "pressure": 42,
      "agility": 68,
      "physical": 57,
      "technique": 63
    }
  },
  {
    "id": 3569,
    "name": "Dasan",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/e/veaks1mzt_8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 49,
      "control": 44,
      "pressure": 46,
      "agility": 58,
      "physical": 55,
      "technique": 61
    }
  },
  {
    "id": 3570,
    "name": "Sata",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/x/1x5__ot7yfm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 48,
      "control": 47,
      "pressure": 83,
      "agility": 55,
      "physical": 58,
      "technique": 59
    }
  },
  {
    "id": 3571,
    "name": "Sahasra",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/z/eziesx1b1sk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 56,
      "control": 54,
      "pressure": 53,
      "agility": 42,
      "physical": 65,
      "technique": 46
    }
  },
  {
    "id": 3572,
    "name": "Ayuta",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/4/g4pc8ontwqk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 70,
      "control": 59,
      "pressure": 42,
      "agility": 46,
      "physical": 58,
      "technique": 52
    }
  },
  {
    "id": 3573,
    "name": "Laksha",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/q/3q-jrxbxdzm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 48,
      "control": 46,
      "pressure": 41,
      "agility": 72,
      "physical": 48,
      "technique": 63
    }
  },
  {
    "id": 3574,
    "name": "Niyuta",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/_/x_dwcs0fo58.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 57,
      "control": 48,
      "pressure": 43,
      "agility": 68,
      "physical": 56,
      "technique": 50
    }
  },
  {
    "id": 3575,
    "name": "Vee Wai",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/5/y5sb2wsjcn8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 43,
      "control": 52,
      "pressure": 68,
      "agility": 40,
      "physical": 67,
      "technique": 58
    }
  },
  {
    "id": 3576,
    "name": "Dee Vee",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/w/4wxullzb3hm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 57,
      "control": 40,
      "pressure": 78,
      "agility": 41,
      "physical": 58,
      "technique": 60
    }
  },
  {
    "id": 3577,
    "name": "Ayt Bee",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/-/j-api0_7a0k.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 44,
      "control": 41,
      "pressure": 65,
      "agility": 51,
      "physical": 59,
      "technique": 60
    }
  },
  {
    "id": 3578,
    "name": "En Sicks",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/f/lfhtmttxfyk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 53,
      "control": 57,
      "pressure": 67,
      "agility": 60,
      "physical": 70,
      "technique": 51
    }
  },
  {
    "id": 3579,
    "name": "Wun Ell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/3/632ylsltybm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 72,
      "control": 64,
      "pressure": 47,
      "agility": 53,
      "physical": 46,
      "technique": 48
    }
  },
  {
    "id": 3580,
    "name": "Zed Kyu",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/y/ayvhyp-lhh8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 66,
      "control": 66,
      "pressure": 52,
      "agility": 56,
      "physical": 58,
      "technique": 58
    }
  },
  {
    "id": 3581,
    "name": "Kay Zirro",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/w/rwkm1wyfqsu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 71,
      "control": 73,
      "pressure": 56,
      "agility": 54,
      "physical": 46,
      "technique": 58
    }
  },
  {
    "id": 3582,
    "name": "Cee Eff",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/a/fab-e9b9nt8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 61,
      "control": 59,
      "pressure": 48,
      "agility": 44,
      "physical": 52,
      "technique": 70
    }
  },
  {
    "id": 3583,
    "name": "Ar Ecks",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/y/uyqfpc9hgeu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 77,
      "control": 63,
      "pressure": 60,
      "agility": 40,
      "physical": 54,
      "technique": 67
    }
  },
  {
    "id": 3584,
    "name": "Em Tee",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/a/aaxszd0oby0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 50,
      "control": 59,
      "pressure": 49,
      "agility": 56,
      "physical": 60,
      "technique": 51
    }
  },
  {
    "id": 3585,
    "name": "Ough Cee",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/y/xyaze8s0sbc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 57,
      "control": 51,
      "pressure": 44,
      "agility": 71,
      "physical": 44,
      "technique": 64
    }
  },
  {
    "id": 3586,
    "name": "Jay Yuu",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/d/rdjgnhn8zhs.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 40,
      "control": 43,
      "pressure": 71,
      "agility": 42,
      "physical": 71,
      "technique": 52
    }
  },
  {
    "id": 3587,
    "name": "Faiv Ess",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/1/g1sngebg0se.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 49,
      "control": 47,
      "pressure": 74,
      "agility": 41,
      "physical": 56,
      "technique": 56
    }
  },
  {
    "id": 3588,
    "name": "Tu Eigh",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/u/iuv7ohtqxue.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 66,
      "control": 54,
      "pressure": 53,
      "agility": 47,
      "physical": 59,
      "technique": 58
    }
  },
  {
    "id": 3589,
    "name": "Aye Nort",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/8/t8kaj41qcns.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 59,
      "control": 52,
      "pressure": 49,
      "agility": 54,
      "physical": 56,
      "technique": 63
    }
  },
  {
    "id": 3590,
    "name": "Ji Tenn",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/t/zthvwlayphc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 41,
      "control": 48,
      "pressure": 57,
      "agility": 70,
      "physical": 54,
      "technique": 64
    }
  },
  {
    "id": 3591,
    "name": "Schemer Guile",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/1/w1afgzwgvos.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 47,
      "control": 55,
      "pressure": 55,
      "agility": 66,
      "physical": 47,
      "technique": 65
    }
  },
  {
    "id": 3592,
    "name": "Feduhm",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/t/stqklgalnyc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 59,
      "control": 58,
      "pressure": 63,
      "agility": 42,
      "physical": 60,
      "technique": 55
    }
  },
  {
    "id": 3593,
    "name": "Tsync",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/c/mcj_2b1tsss.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 46,
      "control": 45,
      "pressure": 66,
      "agility": 45,
      "physical": 72,
      "technique": 59
    }
  },
  {
    "id": 3594,
    "name": "Driss",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/q/9q4ebktx_he.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 53,
      "control": 54,
      "pressure": 69,
      "agility": 43,
      "physical": 66,
      "technique": 60
    }
  },
  {
    "id": 3595,
    "name": "Ludeau",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/l/_l_c19b76ne.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 43,
      "control": 58,
      "pressure": 72,
      "agility": 46,
      "physical": 62,
      "technique": 51
    }
  },
  {
    "id": 3596,
    "name": "Dios",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/j/ojojycnbxus.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 69,
      "control": 66,
      "pressure": 46,
      "agility": 41,
      "physical": 56,
      "technique": 54
    }
  },
  {
    "id": 3597,
    "name": "Grigham",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/m/umtwlfsji0c.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 70,
      "control": 72,
      "pressure": 54,
      "agility": 50,
      "physical": 47,
      "technique": 62
    }
  },
  {
    "id": 3598,
    "name": "Zatang",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/k/fkc3mg0zph0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 69,
      "control": 69,
      "pressure": 41,
      "agility": 49,
      "physical": 40,
      "technique": 66
    }
  },
  {
    "id": 3599,
    "name": "Rodh",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/o/rojvxt3ro4c.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 59,
      "control": 72,
      "pressure": 44,
      "agility": 59,
      "physical": 54,
      "technique": 61
    }
  },
  {
    "id": 3600,
    "name": "Djibz",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/m/amso6srrfl0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 61,
      "control": 61,
      "pressure": 52,
      "agility": 60,
      "physical": 47,
      "technique": 74
    }
  },
  {
    "id": 3601,
    "name": "Garreau",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/m/fm4ins-yju8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 71,
      "control": 73,
      "pressure": 55,
      "agility": 58,
      "physical": 49,
      "technique": 50
    }
  },
  {
    "id": 3602,
    "name": "Steiyah",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/j/ljbxexlq80m.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 48,
      "control": 55,
      "pressure": 73,
      "agility": 44,
      "physical": 76,
      "technique": 41
    }
  },
  {
    "id": 3603,
    "name": "Mhadoor",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/h/uhq2zotqrhk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 53,
      "control": 55,
      "pressure": 56,
      "agility": 44,
      "physical": 62,
      "technique": 43
    }
  },
  {
    "id": 3604,
    "name": "Heyze",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/a/watqdx_gubk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 75,
      "control": 73,
      "pressure": 60,
      "agility": 60,
      "physical": 46,
      "technique": 52
    }
  },
  {
    "id": 3605,
    "name": "Kuhrach",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/o/noclwoz85ym.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 62,
      "control": 72,
      "pressure": 54,
      "agility": 58,
      "physical": 46,
      "technique": 72
    }
  },
  {
    "id": 3606,
    "name": "Torhm",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/h/hh_-j1s0ms8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 46,
      "control": 48,
      "pressure": 46,
      "agility": 54,
      "physical": 45,
      "technique": 62
    }
  },
  {
    "id": 3607,
    "name": "Bhufa",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/b/obk1jhxe410.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 60,
      "control": 50,
      "pressure": 81,
      "agility": 55,
      "physical": 63,
      "technique": 56
    }
  },
  {
    "id": 3608,
    "name": "Zohtan",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/u/iuhawaiwnve.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 44,
      "control": 40,
      "pressure": 70,
      "agility": 58,
      "physical": 71,
      "technique": 40
    }
  },
  {
    "id": 3609,
    "name": "Mustah",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/g/5g2hdlesgms.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 56,
      "control": 49,
      "pressure": 68,
      "agility": 59,
      "physical": 74,
      "technique": 50
    }
  },
  {
    "id": 3610,
    "name": "Mohrir",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/n/7nx9z8walgs.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 40,
      "control": 60,
      "pressure": 62,
      "agility": 40,
      "physical": 76,
      "technique": 56
    }
  },
  {
    "id": 3611,
    "name": "Ghimus",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/p/kpacedw6ite.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 64,
      "control": 75,
      "pressure": 56,
      "agility": 54,
      "physical": 46,
      "technique": 57
    }
  },
  {
    "id": 3612,
    "name": "Tzeikh",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/g/qgjpnefy9z0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 75,
      "control": 65,
      "pressure": 45,
      "agility": 41,
      "physical": 57,
      "technique": 58
    }
  },
  {
    "id": 3613,
    "name": "Miehd",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/i/bisighjiqac.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 51,
      "control": 63,
      "pressure": 54,
      "agility": 55,
      "physical": 55,
      "technique": 71
    }
  },
  {
    "id": 3614,
    "name": "Mehr",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/i/vitqrsgq3_0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 73,
      "control": 69,
      "pressure": 59,
      "agility": 45,
      "physical": 57,
      "technique": 64
    }
  },
  {
    "id": 3615,
    "name": "Ghiris",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/k/ekcx8tgqamc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 70,
      "control": 51,
      "pressure": 48,
      "agility": 56,
      "physical": 48,
      "technique": 63
    }
  },
  {
    "id": 3616,
    "name": "Chell",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/i/wih8mspz7g8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 49,
      "control": 41,
      "pressure": 60,
      "agility": 69,
      "physical": 50,
      "technique": 64
    }
  },
  {
    "id": 3617,
    "name": "Zetoh",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/k/bk2dltpjwtu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 52,
      "control": 45,
      "pressure": 46,
      "agility": 70,
      "physical": 50,
      "technique": 51
    }
  },
  {
    "id": 3618,
    "name": "Enimaux",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/l/hlvoywcrjzk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 55,
      "control": 59,
      "pressure": 75,
      "agility": 59,
      "physical": 63,
      "technique": 55
    }
  },
  {
    "id": 3619,
    "name": "Darehn",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/n/qnkj1p6roam.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 55,
      "control": 44,
      "pressure": 57,
      "agility": 48,
      "physical": 59,
      "technique": 45
    }
  },
  {
    "id": 3620,
    "name": "Mabhi",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/s/ssjvbwo9lgm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 75,
      "control": 70,
      "pressure": 60,
      "agility": 51,
      "physical": 40,
      "technique": 50
    }
  },
  {
    "id": 3621,
    "name": "Nahrje",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/e/jes02pohm1k.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 54,
      "control": 59,
      "pressure": 54,
      "agility": 49,
      "physical": 59,
      "technique": 49
    }
  },
  {
    "id": 3622,
    "name": "Veneth",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/r/drxbl07ptvu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 56,
      "control": 53,
      "pressure": 46,
      "agility": 71,
      "physical": 56,
      "technique": 66
    }
  },
  {
    "id": 3623,
    "name": "Chitoh",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/s/uskzvnsuu80.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 49,
      "control": 55,
      "pressure": 77,
      "agility": 51,
      "physical": 68,
      "technique": 48
    }
  },
  {
    "id": 3624,
    "name": "Kazach",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/d/odpg8qzcbce.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 53,
      "control": 48,
      "pressure": 67,
      "agility": 44,
      "physical": 60,
      "technique": 48
    }
  },
  {
    "id": 3625,
    "name": "Fumh",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/r/_rynrv_m2vs.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 59,
      "control": 57,
      "pressure": 76,
      "agility": 58,
      "physical": 60,
      "technique": 54
    }
  },
  {
    "id": 3626,
    "name": "Gumille",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/k/9kf7_2tkzps.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 49,
      "control": 45,
      "pressure": 63,
      "agility": 45,
      "physical": 61,
      "technique": 48
    }
  },
  {
    "id": 3627,
    "name": "Yurkeh",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/i/miuasjlweae.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 59,
      "control": 66,
      "pressure": 58,
      "agility": 51,
      "physical": 52,
      "technique": 59
    }
  },
  {
    "id": 3628,
    "name": "Rokah",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/n/snnvbu-4r60.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 66,
      "control": 64,
      "pressure": 48,
      "agility": 41,
      "physical": 48,
      "technique": 56
    }
  },
  {
    "id": 3629,
    "name": "Pinoh",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/l/dl8osrycgjc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 70,
      "control": 65,
      "pressure": 45,
      "agility": 56,
      "physical": 46,
      "technique": 57
    }
  },
  {
    "id": 3630,
    "name": "Tahk",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/p/ppdwdmbgh20.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 66,
      "control": 53,
      "pressure": 50,
      "agility": 55,
      "physical": 48,
      "technique": 54
    }
  },
  {
    "id": 3631,
    "name": "Dekih",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/p/2pp6qy0ttp8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 46,
      "control": 46,
      "pressure": 52,
      "agility": 65,
      "physical": 46,
      "technique": 55
    }
  },
  {
    "id": 3632,
    "name": "Yuh",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/n/hnybhnspaau.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 52,
      "control": 47,
      "pressure": 55,
      "agility": 68,
      "physical": 46,
      "technique": 59
    }
  },
  {
    "id": 3633,
    "name": "Bhabass",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/i/ni7uu6nh16k.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 47,
      "control": 47,
      "pressure": 58,
      "agility": 60,
      "physical": 70,
      "technique": 41
    }
  },
  {
    "id": 3634,
    "name": "Sheenai",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/g/wgkp5fbbyjm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 40,
      "control": 56,
      "pressure": 71,
      "agility": 56,
      "physical": 75,
      "technique": 53
    }
  },
  {
    "id": 3635,
    "name": "Tessell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/b/ubntxct3dpm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 65,
      "control": 64,
      "pressure": 43,
      "agility": 41,
      "physical": 57,
      "technique": 57
    }
  },
  {
    "id": 3636,
    "name": "Chikka",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/p/lp8y6j1nw8k.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 65,
      "control": 75,
      "pressure": 42,
      "agility": 60,
      "physical": 53,
      "technique": 63
    }
  },
  {
    "id": 3637,
    "name": "Mahrsa",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/g/fgfhp-affcu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 41,
      "control": 49,
      "pressure": 43,
      "agility": 75,
      "physical": 53,
      "technique": 70
    }
  },
  {
    "id": 3638,
    "name": "Hippos Kohlt",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/s/ose1bfpowf8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 41,
      "control": 42,
      "pressure": 80,
      "agility": 49,
      "physical": 71,
      "technique": 46
    }
  },
  {
    "id": 3639,
    "name": "Anas Eidah",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/d/ud9aiy6gflm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 58,
      "control": 53,
      "pressure": 67,
      "agility": 44,
      "physical": 67,
      "technique": 57
    }
  },
  {
    "id": 3640,
    "name": "Djung Hamstah",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/r/frmhlncaowk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 46,
      "control": 50,
      "pressure": 63,
      "agility": 52,
      "physical": 55,
      "technique": 57
    }
  },
  {
    "id": 3641,
    "name": "Ewa Mouton",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/k/dkl9l-o2tqk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 41,
      "control": 53,
      "pressure": 69,
      "agility": 56,
      "physical": 71,
      "technique": 45
    }
  },
  {
    "id": 3642,
    "name": "Sus Swihn",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/i/si6cmbomajm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 56,
      "control": 79,
      "pressure": 59,
      "agility": 53,
      "physical": 51,
      "technique": 56
    }
  },
  {
    "id": 3643,
    "name": "Katya Felis",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/n/mnzp1cde1d8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 79,
      "control": 68,
      "pressure": 55,
      "agility": 46,
      "physical": 52,
      "technique": 65
    }
  },
  {
    "id": 3644,
    "name": "Macah Psitta",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/l/9loiyj7-ywu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 77,
      "control": 64,
      "pressure": 55,
      "agility": 60,
      "physical": 45,
      "technique": 54
    }
  },
  {
    "id": 3645,
    "name": "Simeon Ayp",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/p/wp98eqxvzq0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 58,
      "control": 53,
      "pressure": 53,
      "agility": 68,
      "physical": 49,
      "technique": 61
    }
  },
  {
    "id": 3647,
    "name": "Kyon Canis",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/n/nnmdzvxvejc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 40,
      "control": 59,
      "pressure": 58,
      "agility": 74,
      "physical": 56,
      "technique": 62
    }
  },
  {
    "id": 3648,
    "name": "Siid Sinapis",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/i/hivogyedrds.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 51,
      "control": 56,
      "pressure": 64,
      "agility": 46,
      "physical": 61,
      "technique": 44
    }
  },
  {
    "id": 3649,
    "name": "Pelta Chincha",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/g/2gejnningwe.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 56,
      "control": 49,
      "pressure": 74,
      "agility": 43,
      "physical": 70,
      "technique": 47
    }
  },
  {
    "id": 3650,
    "name": "Folie Vora",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/b/0bzvjuwld2e.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 64,
      "control": 61,
      "pressure": 43,
      "agility": 40,
      "physical": 58,
      "technique": 67
    }
  },
  {
    "id": 3651,
    "name": "Lieva Snoshu",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/p/fpo0orwxufs.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 62,
      "control": 61,
      "pressure": 54,
      "agility": 50,
      "physical": 57,
      "technique": 55
    }
  },
  {
    "id": 3652,
    "name": "Russo Rosmarus",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/g/lglbd2j5blc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 58,
      "control": 40,
      "pressure": 51,
      "agility": 65,
      "physical": 47,
      "technique": 45
    }
  },
  {
    "id": 3653,
    "name": "Lee Canthrup",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/6/c6tpib1rq6s.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 29,
      "intelligence": 58,
      "control": 43,
      "pressure": 70,
      "agility": 47,
      "physical": 60,
      "technique": 48
    }
  },
  {
    "id": 3654,
    "name": "Gerald Fuss",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/v/8vwcxcajlac.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 41,
      "control": 46,
      "pressure": 68,
      "agility": 50,
      "physical": 66,
      "technique": 44
    }
  },
  {
    "id": 3655,
    "name": "Kym Errer",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/9/n9b9cjmzip0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 48,
      "control": 51,
      "pressure": 68,
      "agility": 50,
      "physical": 72,
      "technique": 40
    }
  },
  {
    "id": 3656,
    "name": "Hunter O'Mann",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/c/pcghy601nv0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 59,
      "control": 52,
      "pressure": 57,
      "agility": 58,
      "physical": 41,
      "technique": 59
    }
  },
  {
    "id": 3657,
    "name": "Mona Selene",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/0/-03affspgcc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 72,
      "control": 72,
      "pressure": 53,
      "agility": 58,
      "physical": 51,
      "technique": 59
    }
  },
  {
    "id": 3658,
    "name": "Lou Garrou",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/b/ebu1mynhv8s.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 78,
      "control": 53,
      "pressure": 55,
      "agility": 52,
      "physical": 44,
      "technique": 53
    }
  },
  {
    "id": 3659,
    "name": "Al Woo",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/z/vzluhnb94pe.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 59,
      "control": 61,
      "pressure": 49,
      "agility": 46,
      "physical": 49,
      "technique": 61
    }
  },
  {
    "id": 3660,
    "name": "Sylvester Bullet",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/z/bzamqqcffws.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 69,
      "control": 54,
      "pressure": 47,
      "agility": 57,
      "physical": 55,
      "technique": 61
    }
  },
  {
    "id": 3661,
    "name": "Terri Ann Thrope",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/x/qxrt9vklyde.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 42,
      "control": 41,
      "pressure": 47,
      "agility": 65,
      "physical": 45,
      "technique": 54
    }
  },
  {
    "id": 3662,
    "name": "Wolfram Vulpeen",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/z/ezwgnutstvk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 41,
      "control": 49,
      "pressure": 46,
      "agility": 57,
      "physical": 40,
      "technique": 55
    }
  },
  {
    "id": 3663,
    "name": "Luke Kayon",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/x/1xbbkrlw-cm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 45,
      "control": 42,
      "pressure": 41,
      "agility": 57,
      "physical": 45,
      "technique": 61
    }
  },
  {
    "id": 3664,
    "name": "Vince Sizor",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/6/86hvwjwxodk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 48,
      "control": 56,
      "pressure": 63,
      "agility": 46,
      "physical": 61,
      "technique": 54
    }
  },
  {
    "id": 3665,
    "name": "Ron Innwater",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/v/cvkafujf7ju.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 48,
      "control": 57,
      "pressure": 63,
      "agility": 49,
      "physical": 69,
      "technique": 46
    }
  },
  {
    "id": 3666,
    "name": "Holly Waters",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/9/t9v7orflwq8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 41,
      "control": 54,
      "pressure": 68,
      "agility": 51,
      "physical": 68,
      "technique": 58
    }
  },
  {
    "id": 3667,
    "name": "Turner Fogg",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/c/vcsngyxjtw8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 53,
      "control": 44,
      "pressure": 68,
      "agility": 55,
      "physical": 57,
      "technique": 53
    }
  },
  {
    "id": 3668,
    "name": "Sid Viper",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/0/e0jgrnxz-lu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 69,
      "control": 60,
      "pressure": 53,
      "agility": 60,
      "physical": 44,
      "technique": 69
    }
  },
  {
    "id": 3669,
    "name": "Dave Walker",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/b/-baz4qe7lfk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 53,
      "control": 68,
      "pressure": 49,
      "agility": 47,
      "physical": 46,
      "technique": 66
    }
  },
  {
    "id": 3670,
    "name": "Porphyria Filia",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/z/pzxsvvibm2m.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 78,
      "control": 63,
      "pressure": 43,
      "agility": 53,
      "physical": 55,
      "technique": 49
    }
  },
  {
    "id": 3671,
    "name": "Hugh Mumford",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/z/7zokkihjbjk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 64,
      "control": 64,
      "pressure": 50,
      "agility": 45,
      "physical": 58,
      "technique": 56
    }
  },
  {
    "id": 3672,
    "name": "Desmodus Drakul",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/x/kx_rjdhzs6m.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 64,
      "control": 60,
      "pressure": 48,
      "agility": 44,
      "physical": 41,
      "technique": 65
    }
  },
  {
    "id": 3673,
    "name": "Woodrow Stake",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/z/kzkmtcoqnws.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 57,
      "control": 51,
      "pressure": 59,
      "agility": 75,
      "physical": 52,
      "technique": 63
    }
  },
  {
    "id": 3674,
    "name": "Nora Flexion",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/x/vxvh-joqgle.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 53,
      "control": 56,
      "pressure": 50,
      "agility": 74,
      "physical": 45,
      "technique": 64
    }
  },
  {
    "id": 3675,
    "name": "Hurley Kane",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/s/ssjj6dptn3c.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 51,
      "control": 40,
      "pressure": 57,
      "agility": 60,
      "physical": 58,
      "technique": 43
    }
  },
  {
    "id": 3676,
    "name": "Axel Blaze",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/b/wbkpcsww-ek.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 59,
      "control": 40,
      "pressure": 46,
      "agility": 70,
      "physical": 59,
      "technique": 66
    }
  },
  {
    "id": 3677,
    "name": "Lotus",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/m/7m4-s5_2pls.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 46,
      "control": 48,
      "pressure": 62,
      "agility": 45,
      "physical": 60,
      "technique": 54
    }
  },
  {
    "id": 3678,
    "name": "Magnol",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/j/bjbl_kk-6fc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 51,
      "control": 58,
      "pressure": 68,
      "agility": 49,
      "physical": 56,
      "technique": 55
    }
  },
  {
    "id": 3679,
    "name": "Tulip",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/h/qhqqsbsex20.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 44,
      "control": 40,
      "pressure": 58,
      "agility": 54,
      "physical": 63,
      "technique": 60
    }
  },
  {
    "id": 3680,
    "name": "Argyr",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/a/oat28c-osw0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 50,
      "control": 40,
      "pressure": 68,
      "agility": 46,
      "physical": 74,
      "technique": 47
    }
  },
  {
    "id": 3681,
    "name": "Laven",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/o/zocxr9ys_dc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 56,
      "control": 72,
      "pressure": 49,
      "agility": 46,
      "physical": 57,
      "technique": 67
    }
  },
  {
    "id": 3682,
    "name": "Viol",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/h/5h_icgtakjs.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 59,
      "control": 71,
      "pressure": 56,
      "agility": 55,
      "physical": 48,
      "technique": 65
    }
  },
  {
    "id": 3683,
    "name": "Dandy",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/v/ivodvflgnqe.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 69,
      "control": 62,
      "pressure": 57,
      "agility": 57,
      "physical": 56,
      "technique": 67
    }
  },
  {
    "id": 3684,
    "name": "Chamomile",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/f/8fxbesicavs.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 70,
      "control": 52,
      "pressure": 57,
      "agility": 53,
      "physical": 48,
      "technique": 52
    }
  },
  {
    "id": 3685,
    "name": "Orchid",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/t/nta6ztu4tce.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 71,
      "control": 58,
      "pressure": 60,
      "agility": 43,
      "physical": 43,
      "technique": 56
    }
  },
  {
    "id": 3686,
    "name": "Aster",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/f/jfb3psnxmwk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 40,
      "control": 57,
      "pressure": 44,
      "agility": 71,
      "physical": 43,
      "technique": 63
    }
  },
  {
    "id": 3687,
    "name": "Gentian",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/t/stqwetblhdm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 41,
      "control": 47,
      "pressure": 46,
      "agility": 65,
      "physical": 60,
      "technique": 64
    }
  },
  {
    "id": 3688,
    "name": "Flora",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/c/ycjjxo0duj8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 81,
      "intelligence": 42,
      "control": 49,
      "pressure": 57,
      "agility": 77,
      "physical": 55,
      "technique": 63
    }
  },
  {
    "id": 3689,
    "name": "Sterne",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/q/dq4c6xs55qu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 48,
      "control": 54,
      "pressure": 58,
      "agility": 74,
      "physical": 51,
      "technique": 55
    }
  },
  {
    "id": 3690,
    "name": "Cross Word Cryptix",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/1/v1qpxn51zrk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 42,
      "control": 50,
      "pressure": 57,
      "agility": 67,
      "physical": 51,
      "technique": 57
    }
  },
  {
    "id": 3691,
    "name": "Adrastus Argos",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/d/bdxknmw849e.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 51,
      "control": 59,
      "pressure": 61,
      "agility": 47,
      "physical": 66,
      "technique": 56
    }
  },
  {
    "id": 3692,
    "name": "Gammon Checker",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/u/2u_ikm7vtnu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 27,
      "intelligence": 41,
      "control": 40,
      "pressure": 70,
      "agility": 45,
      "physical": 60,
      "technique": 49
    }
  },
  {
    "id": 3697,
    "name": "Kyoko Hanabayashi",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/b/wbcx3rodyhk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 56,
      "control": 46,
      "pressure": 54,
      "agility": 60,
      "physical": 43,
      "technique": 55
    }
  },
  {
    "id": 3699,
    "name": "Victor Blade",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/3/q3kql_cttdk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 83,
      "intelligence": 43,
      "control": 49,
      "pressure": 49,
      "agility": 71,
      "physical": 54,
      "technique": 68
    }
  },
  {
    "id": 3700,
    "name": "Vladimir Blade",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/d/edbi6yfp0im.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 56,
      "control": 42,
      "pressure": 58,
      "agility": 65,
      "physical": 41,
      "technique": 62
    }
  },
  {
    "id": 3701,
    "name": "Axel Blaze",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/a/wa32hmay-xu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 53,
      "control": 52,
      "pressure": 60,
      "agility": 61,
      "physical": 53,
      "technique": 52
    }
  },
  {
    "id": 3702,
    "name": "David Evans",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/-/z-stizo77om.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 54,
      "control": 56,
      "pressure": 55,
      "agility": 42,
      "physical": 69,
      "technique": 47
    }
  },
  {
    "id": 3706,
    "name": "Tasuke",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/a/camyzqtb6xe.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 51,
      "control": 40,
      "pressure": 53,
      "agility": 44,
      "physical": 75,
      "technique": 56
    }
  },
  {
    "id": 3707,
    "name": "Shishimaru",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/y/ty9tev1hxcs.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 56,
      "control": 40,
      "pressure": 70,
      "agility": 54,
      "physical": 56,
      "technique": 48
    }
  },
  {
    "id": 3708,
    "name": "Gorota",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/t/vt6pw2nnses.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 50,
      "control": 43,
      "pressure": 68,
      "agility": 57,
      "physical": 75,
      "technique": 48
    }
  },
  {
    "id": 3709,
    "name": "Ichimasa",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/u/-uobou0_kx0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 40,
      "control": 53,
      "pressure": 73,
      "agility": 43,
      "physical": 65,
      "technique": 42
    }
  },
  {
    "id": 3710,
    "name": "Jingo",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/7/e7ludjb3_3e.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 53,
      "control": 42,
      "pressure": 72,
      "agility": 59,
      "physical": 53,
      "technique": 41
    }
  },
  {
    "id": 3711,
    "name": "Katsu",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/p/npt2auon10m.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 44,
      "control": 57,
      "pressure": 59,
      "agility": 46,
      "physical": 61,
      "technique": 51
    }
  },
  {
    "id": 3712,
    "name": "Nobunaga Oda",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/d/ndemnyapiic.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 53,
      "control": 42,
      "pressure": 60,
      "agility": 74,
      "physical": 49,
      "technique": 68
    }
  },
  {
    "id": 3713,
    "name": "Tokichiro Kinoshita",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/3/53h-8_dlfd0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 47,
      "control": 50,
      "pressure": 75,
      "agility": 44,
      "physical": 67,
      "technique": 48
    }
  },
  {
    "id": 3714,
    "name": "Nagahide Niwa",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/n/fnjfnqpdfs8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 76,
      "control": 63,
      "pressure": 46,
      "agility": 56,
      "physical": 53,
      "technique": 53
    }
  },
  {
    "id": 3715,
    "name": "Toshiie Maeda",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/n/xn2hwnmhitu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 51,
      "control": 43,
      "pressure": 48,
      "agility": 69,
      "physical": 49,
      "technique": 74
    }
  },
  {
    "id": 3716,
    "name": "Joan of Arc",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/f/ifqfralxouc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 51,
      "control": 55,
      "pressure": 69,
      "agility": 47,
      "physical": 68,
      "technique": 50
    }
  },
  {
    "id": 3717,
    "name": "Prince Charles",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/p/0p4-kvp5ohu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 56,
      "control": 57,
      "pressure": 54,
      "agility": 48,
      "physical": 60,
      "technique": 57
    }
  },
  {
    "id": 3718,
    "name": "La Hire",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/3/m3lslbs4jc8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 46,
      "control": 44,
      "pressure": 48,
      "agility": 60,
      "physical": 54,
      "technique": 51
    }
  },
  {
    "id": 3719,
    "name": "Gilles de Rais",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/f/xf6zm-kckxu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 65,
      "control": 73,
      "pressure": 43,
      "agility": 53,
      "physical": 53,
      "technique": 54
    }
  },
  {
    "id": 3720,
    "name": "Liu Bei",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/w/3wzg1j_krrk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 44,
      "control": 51,
      "pressure": 55,
      "agility": 58,
      "physical": 59,
      "technique": 53
    }
  },
  {
    "id": 3721,
    "name": "Guan Yu",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/y/gyonyczw8im.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 59,
      "control": 59,
      "pressure": 68,
      "agility": 60,
      "physical": 74,
      "technique": 56
    }
  },
  {
    "id": 3722,
    "name": "Zhang Fei",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/5/e5v72flc5km.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 60,
      "control": 42,
      "pressure": 57,
      "agility": 69,
      "physical": 42,
      "technique": 61
    }
  },
  {
    "id": 3723,
    "name": "Zhuge Liang",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/r/1reab6tmuxk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 63,
      "control": 71,
      "pressure": 52,
      "agility": 54,
      "physical": 51,
      "technique": 48
    }
  },
  {
    "id": 3724,
    "name": "Cao Cao",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/-/v-9vinyuh3u.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 57,
      "control": 45,
      "pressure": 68,
      "agility": 58,
      "physical": 71,
      "technique": 43
    }
  },
  {
    "id": 3725,
    "name": "Ryoma Sakamoto",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/8/q8zwuv92r7u.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 73,
      "control": 60,
      "pressure": 46,
      "agility": 47,
      "physical": 55,
      "technique": 65
    }
  },
  {
    "id": 3726,
    "name": "Soji Okita",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/w/kwmoly-ume8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 59,
      "control": 57,
      "pressure": 55,
      "agility": 69,
      "physical": 56,
      "technique": 67
    }
  },
  {
    "id": 3727,
    "name": "Shintaro Nakaoka",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/g/ugblzicxdbk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 67,
      "control": 52,
      "pressure": 45,
      "agility": 45,
      "physical": 41,
      "technique": 68
    }
  },
  {
    "id": 3728,
    "name": "Isami Kondo",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/l/alhm7yqbpe8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 51,
      "control": 42,
      "pressure": 61,
      "agility": 55,
      "physical": 54,
      "technique": 43
    }
  },
  {
    "id": 3730,
    "name": "King Arthur",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/u/huc35qbmgi8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 43,
      "control": 48,
      "pressure": 47,
      "agility": 67,
      "physical": 44,
      "technique": 56
    }
  },
  {
    "id": 3732,
    "name": "Quetzalcoatlus",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/a/faex_q5mqy8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 40,
      "control": 54,
      "pressure": 59,
      "agility": 42,
      "physical": 59,
      "technique": 51
    }
  },
  {
    "id": 3734,
    "name": "Big",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/q/rqhpod6e3nu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 56,
      "control": 42,
      "pressure": 49,
      "agility": 52,
      "physical": 44,
      "technique": 57
    }
  },
  {
    "id": 3736,
    "name": "Queen of Dragons",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/c/acqujic-au8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 43,
      "control": 59,
      "pressure": 61,
      "agility": 60,
      "physical": 65,
      "technique": 46
    }
  },
  {
    "id": 3737,
    "name": "Hurricane Zeta",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/q/0qlj5jv374c.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 46,
      "control": 42,
      "pressure": 53,
      "agility": 58,
      "physical": 43,
      "technique": 63
    }
  },
  {
    "id": 3739,
    "name": "Aslei Rune",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/i/liqq036lwym.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 52,
      "control": 76,
      "pressure": 52,
      "agility": 54,
      "physical": 42,
      "technique": 56
    }
  },
  {
    "id": 3740,
    "name": "Mecha-Mark",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/8/o8ahvxamit8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 52,
      "control": 51,
      "pressure": 72,
      "agility": 59,
      "physical": 57,
      "technique": 56
    }
  },
  {
    "id": 3753,
    "name": "Terracotta Warrior 1",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/c/tc7dt8sowdu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 60,
      "control": 48,
      "pressure": 64,
      "agility": 59,
      "physical": 58,
      "technique": 52
    }
  },
  {
    "id": 3754,
    "name": "Terracotta Warrior 2",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/z/nzyoahngf9k.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 46,
      "control": 56,
      "pressure": 62,
      "agility": 57,
      "physical": 56,
      "technique": 57
    }
  },
  {
    "id": 3755,
    "name": "Terracotta Warrior 3",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/b/8bpjteb8oom.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 53,
      "control": 41,
      "pressure": 60,
      "agility": 56,
      "physical": 67,
      "technique": 58
    }
  },
  {
    "id": 3756,
    "name": "Terracotta Warrior 4",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/6/-6uvdhtqtim.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 48,
      "control": 60,
      "pressure": 71,
      "agility": 51,
      "physical": 65,
      "technique": 59
    }
  },
  {
    "id": 3757,
    "name": "Terracotta Warrior 5",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/s/psf0u41qa7k.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 72,
      "control": 74,
      "pressure": 51,
      "agility": 41,
      "physical": 42,
      "technique": 60
    }
  },
  {
    "id": 3758,
    "name": "Terracotta Warrior 6",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/9/v98b9lai1bu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 64,
      "control": 71,
      "pressure": 57,
      "agility": 59,
      "physical": 59,
      "technique": 71
    }
  },
  {
    "id": 3759,
    "name": "Terracotta Warrior 7",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/v/evngqamyyo8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 63,
      "control": 64,
      "pressure": 50,
      "agility": 58,
      "physical": 50,
      "technique": 67
    }
  },
  {
    "id": 3760,
    "name": "Terracotta Warrior 8",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/_/q_y4hxl6_xu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 63,
      "control": 75,
      "pressure": 52,
      "agility": 60,
      "physical": 57,
      "technique": 58
    }
  },
  {
    "id": 3761,
    "name": "Terracotta Warrior 9",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/x/bxdzmodask8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 78,
      "control": 55,
      "pressure": 41,
      "agility": 41,
      "physical": 42,
      "technique": 61
    }
  },
  {
    "id": 3762,
    "name": "Terracotta Warrior 10",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/_/1_yuwpkjzic.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 61,
      "control": 76,
      "pressure": 44,
      "agility": 58,
      "physical": 59,
      "technique": 63
    }
  },
  {
    "id": 3763,
    "name": "Terracotta Warrior 11",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/x/exp17wsze70.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 42,
      "control": 40,
      "pressure": 45,
      "agility": 71,
      "physical": 40,
      "technique": 63
    }
  },
  {
    "id": 3764,
    "name": "Sandi Bay",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/c/ycxdinsuyg8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 51,
      "control": 53,
      "pressure": 76,
      "agility": 57,
      "physical": 70,
      "technique": 47
    }
  },
  {
    "id": 3765,
    "name": "Meg Imai",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/t/stsoxqzmham.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 59,
      "control": 47,
      "pressure": 74,
      "agility": 57,
      "physical": 67,
      "technique": 59
    }
  },
  {
    "id": 3766,
    "name": "Ori Gami",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/f/jfjjcv_cqzk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 51,
      "control": 58,
      "pressure": 75,
      "agility": 54,
      "physical": 60,
      "technique": 55
    }
  },
  {
    "id": 3767,
    "name": "Élise la Transe",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/k/hkkvy2twv1k.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 51,
      "control": 42,
      "pressure": 66,
      "agility": 58,
      "physical": 56,
      "technique": 44
    }
  },
  {
    "id": 3768,
    "name": "Mei Gongzhu",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/m/qmv0fjlkcgm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 60,
      "control": 64,
      "pressure": 43,
      "agility": 54,
      "physical": 58,
      "technique": 66
    }
  },
  {
    "id": 3769,
    "name": "Toshihito Ishida",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/j/wj2bmu-c3m8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 43,
      "control": 53,
      "pressure": 43,
      "agility": 72,
      "physical": 42,
      "technique": 62
    }
  },
  {
    "id": 3770,
    "name": "Liana Moonicorn",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/l/blhghry4avu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 71,
      "control": 56,
      "pressure": 47,
      "agility": 41,
      "physical": 60,
      "technique": 61
    }
  },
  {
    "id": 3771,
    "name": "Ai Machina",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/h/1h44qmba9q8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 58,
      "control": 51,
      "pressure": 62,
      "agility": 59,
      "physical": 60,
      "technique": 47
    }
  },
  {
    "id": 3772,
    "name": "Crester Lipp",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/k/dknzgtpzkpc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 53,
      "control": 51,
      "pressure": 40,
      "agility": 71,
      "physical": 40,
      "technique": 66
    }
  },
  {
    "id": 3773,
    "name": "Wade Posey",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/l/9lugvwcr_vs.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 40,
      "control": 55,
      "pressure": 45,
      "agility": 58,
      "physical": 49,
      "technique": 68
    }
  },
  {
    "id": 3774,
    "name": "Leila Sway",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/j/mjfn4p6rsce.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 54,
      "control": 44,
      "pressure": 60,
      "agility": 58,
      "physical": 65,
      "technique": 40
    }
  },
  {
    "id": 3775,
    "name": "Stan Proud",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/c/ocy7wwohxae.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 56,
      "control": 55,
      "pressure": 43,
      "agility": 55,
      "physical": 42,
      "technique": 67
    }
  },
  {
    "id": 3776,
    "name": "Grub Munsch",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/q/_qpa7po96ps.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 48,
      "control": 50,
      "pressure": 66,
      "agility": 51,
      "physical": 65,
      "technique": 55
    }
  },
  {
    "id": 3777,
    "name": "Lave Hato",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/f/ffkvo071pjc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 60,
      "control": 72,
      "pressure": 45,
      "agility": 57,
      "physical": 40,
      "technique": 52
    }
  },
  {
    "id": 3778,
    "name": "Kwa Fiyur",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/t/ut7ofldpi60.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 57,
      "control": 42,
      "pressure": 49,
      "agility": 60,
      "physical": 45,
      "technique": 66
    }
  },
  {
    "id": 3779,
    "name": "Trigo Teah",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/h/ahew0getffc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 48,
      "control": 47,
      "pressure": 59,
      "agility": 54,
      "physical": 67,
      "technique": 51
    }
  },
  {
    "id": 3780,
    "name": "Johnny Kato",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/v/rv13z54xo20.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 45,
      "control": 42,
      "pressure": 45,
      "agility": 54,
      "physical": 55,
      "technique": 67
    }
  },
  {
    "id": 3781,
    "name": "Chaa Mehn",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/h/fhu6d4xejau.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 43,
      "control": 54,
      "pressure": 47,
      "agility": 66,
      "physical": 52,
      "technique": 74
    }
  },
  {
    "id": 3782,
    "name": "Wowah Zumu",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/v/0vfbuhxkkp8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 78,
      "control": 71,
      "pressure": 44,
      "agility": 46,
      "physical": 47,
      "technique": 54
    }
  },
  {
    "id": 3783,
    "name": "Tey Liadika",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/a/ua8u9aisrjm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 43,
      "control": 48,
      "pressure": 68,
      "agility": 47,
      "physical": 66,
      "technique": 58
    }
  },
  {
    "id": 3784,
    "name": "Pyon Pyon",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/o/lonpqlew86k.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 48,
      "control": 45,
      "pressure": 64,
      "agility": 58,
      "physical": 66,
      "technique": 54
    }
  },
  {
    "id": 3785,
    "name": "Jeku Hydia",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/j/njkt-8w658k.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 41,
      "control": 52,
      "pressure": 66,
      "agility": 58,
      "physical": 73,
      "technique": 54
    }
  },
  {
    "id": 3786,
    "name": "Asbe Stostumi",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/h/wh7ytdwaupm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 44,
      "control": 48,
      "pressure": 60,
      "agility": 52,
      "physical": 68,
      "technique": 43
    }
  },
  {
    "id": 3787,
    "name": "Sayo Nakamise",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/o/2oyhaefihv8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 54,
      "control": 57,
      "pressure": 78,
      "agility": 51,
      "physical": 65,
      "technique": 43
    }
  },
  {
    "id": 3788,
    "name": "Konano Futsuno",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/m/hmpmthjymcu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 50,
      "control": 58,
      "pressure": 60,
      "agility": 40,
      "physical": 54,
      "technique": 45
    }
  },
  {
    "id": 3789,
    "name": "An Tafuri",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/m/zmw-csgqrj8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 40,
      "control": 56,
      "pressure": 74,
      "agility": 59,
      "physical": 68,
      "technique": 55
    }
  },
  {
    "id": 3790,
    "name": "Konomi Kodawara",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/k/cknfxtgqgqu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 67,
      "control": 55,
      "pressure": 56,
      "agility": 54,
      "physical": 52,
      "technique": 56
    }
  },
  {
    "id": 3791,
    "name": "Haname Sasakure",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/m/mmoufasf5f8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 59,
      "control": 49,
      "pressure": 82,
      "agility": 60,
      "physical": 66,
      "technique": 60
    }
  },
  {
    "id": 3792,
    "name": "Masaichi Motoyoshi",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/k/9kz1ylklu2u.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 59,
      "control": 50,
      "pressure": 53,
      "agility": 70,
      "physical": 40,
      "technique": 59
    }
  },
  {
    "id": 3793,
    "name": "Dennosuke Tokuni",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/l/dl6ah4_thwk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 51,
      "control": 53,
      "pressure": 60,
      "agility": 74,
      "physical": 46,
      "technique": 66
    }
  },
  {
    "id": 3794,
    "name": "Susuru Hanawa",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/j/sjlhmhzxmlm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 45,
      "control": 54,
      "pressure": 41,
      "agility": 72,
      "physical": 60,
      "technique": 55
    }
  },
  {
    "id": 3795,
    "name": "Jetaime Horitara",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/c/ucm9iel7jjm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 41,
      "control": 58,
      "pressure": 72,
      "agility": 59,
      "physical": 54,
      "technique": 45
    }
  },
  {
    "id": 3796,
    "name": "Souta Hayari",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/q/fq9cphtbkqk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 66,
      "control": 61,
      "pressure": 57,
      "agility": 48,
      "physical": 57,
      "technique": 67
    }
  },
  {
    "id": 3797,
    "name": "Emosuke Rokudo",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/f/_fepc8yjrwu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 47,
      "control": 60,
      "pressure": 46,
      "agility": 59,
      "physical": 58,
      "technique": 74
    }
  },
  {
    "id": 3798,
    "name": "Kippoji Ani",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/t/otvixd-z8d8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 41,
      "control": 49,
      "pressure": 68,
      "agility": 55,
      "physical": 56,
      "technique": 42
    }
  },
  {
    "id": 3799,
    "name": "Jinpei Ashiga",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/h/6hqqao9rb8u.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 54,
      "control": 45,
      "pressure": 73,
      "agility": 41,
      "physical": 75,
      "technique": 53
    }
  },
  {
    "id": 3800,
    "name": "Utamaro Kusuri",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/v/lvhxtxbr2p8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 46,
      "control": 57,
      "pressure": 56,
      "agility": 64,
      "physical": 59,
      "technique": 67
    }
  },
  {
    "id": 3801,
    "name": "Nirasane Nebuka",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/h/lh683wsixjc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 56,
      "control": 42,
      "pressure": 57,
      "agility": 72,
      "physical": 48,
      "technique": 62
    }
  },
  {
    "id": 3802,
    "name": "Bon Homie",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/v/uvldap0y6q0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 70,
      "control": 69,
      "pressure": 48,
      "agility": 47,
      "physical": 43,
      "technique": 63
    }
  },
  {
    "id": 3803,
    "name": "Marc Mystique",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/a/0aoojsbqpwe.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 52,
      "control": 41,
      "pressure": 80,
      "agility": 54,
      "physical": 65,
      "technique": 59
    }
  },
  {
    "id": 3804,
    "name": "Giselle Roque",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/o/fozjktnqids.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 51,
      "control": 46,
      "pressure": 72,
      "agility": 44,
      "physical": 71,
      "technique": 47
    }
  },
  {
    "id": 3805,
    "name": "Esme la Transe",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/j/hjevk01gnfs.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 56,
      "control": 59,
      "pressure": 54,
      "agility": 55,
      "physical": 65,
      "technique": 52
    }
  },
  {
    "id": 3806,
    "name": "Phil de Rol",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/h/2hv0nlt8k2e.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 57,
      "control": 48,
      "pressure": 41,
      "agility": 67,
      "physical": 43,
      "technique": 59
    }
  },
  {
    "id": 3807,
    "name": "Lupin Wolfe",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/o/womb0wm0_w0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 45,
      "control": 59,
      "pressure": 41,
      "agility": 60,
      "physical": 52,
      "technique": 65
    }
  },
  {
    "id": 3808,
    "name": "Ruff LeGrand",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/m/nm9gzpaoslc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 54,
      "control": 51,
      "pressure": 68,
      "agility": 50,
      "physical": 56,
      "technique": 59
    }
  },
  {
    "id": 3809,
    "name": "Champ Pignon",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/m/tmc4okds1a0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 57,
      "control": 60,
      "pressure": 41,
      "agility": 53,
      "physical": 53,
      "technique": 50
    }
  },
  {
    "id": 3810,
    "name": "Hugo Sauvage",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/k/ikzzfblwypc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 50,
      "control": 40,
      "pressure": 59,
      "agility": 61,
      "physical": 58,
      "technique": 59
    }
  },
  {
    "id": 3811,
    "name": "Constance Durand",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/a/ealimewcz6s.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 41,
      "control": 43,
      "pressure": 55,
      "agility": 57,
      "physical": 45,
      "technique": 57
    }
  },
  {
    "id": 3812,
    "name": "Erneste LaRue",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/y/vyuplhwm0je.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 54,
      "control": 43,
      "pressure": 70,
      "agility": 42,
      "physical": 61,
      "technique": 51
    }
  },
  {
    "id": 3813,
    "name": "Will Reynard",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/d/pd3cy8fubp0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 59,
      "control": 54,
      "pressure": 57,
      "agility": 59,
      "physical": 56,
      "technique": 50
    }
  },
  {
    "id": 3814,
    "name": "Roost Dubois",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/1/-1g91djusac.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 44,
      "control": 50,
      "pressure": 53,
      "agility": 52,
      "physical": 55,
      "technique": 61
    }
  },
  {
    "id": 3815,
    "name": "Herman Chauvin",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/u/8ubhbax4pcc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 71,
      "control": 69,
      "pressure": 46,
      "agility": 59,
      "physical": 46,
      "technique": 59
    }
  },
  {
    "id": 3816,
    "name": "Saul Première",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/8/n8wa2lxcev0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 66,
      "control": 71,
      "pressure": 58,
      "agility": 50,
      "physical": 47,
      "technique": 60
    }
  },
  {
    "id": 3817,
    "name": "Genko Ka",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/t/ttt1l4ikxpe.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 57,
      "control": 47,
      "pressure": 60,
      "agility": 58,
      "physical": 45,
      "technique": 58
    }
  },
  {
    "id": 3818,
    "name": "Kakui Ten",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/7/c7iuihewc8s.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 57,
      "control": 47,
      "pressure": 66,
      "agility": 54,
      "physical": 66,
      "technique": 47
    }
  },
  {
    "id": 3819,
    "name": "Kocho Kyo",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/r/ordm5khs7de.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 53,
      "control": 40,
      "pressure": 60,
      "agility": 75,
      "physical": 49,
      "technique": 68
    }
  },
  {
    "id": 3820,
    "name": "Choen Ryo",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/5/z5stu1howws.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 48,
      "control": 56,
      "pressure": 51,
      "agility": 56,
      "physical": 46,
      "technique": 49
    }
  },
  {
    "id": 3821,
    "name": "Shinken Gaku",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/r/3r3go0oh3cm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 57,
      "control": 45,
      "pressure": 55,
      "agility": 70,
      "physical": 43,
      "technique": 63
    }
  },
  {
    "id": 3822,
    "name": "Kyohi Sho",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/5/g5gbjlobavk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 41,
      "control": 57,
      "pressure": 66,
      "agility": 58,
      "physical": 58,
      "technique": 60
    }
  },
  {
    "id": 3823,
    "name": "Ryuun Cho",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/w/mwl0ww7tvpu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 57,
      "control": 52,
      "pressure": 40,
      "agility": 68,
      "physical": 53,
      "technique": 69
    }
  },
  {
    "id": 3824,
    "name": "Chomo Ba",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/-/x-uvdpdpc88.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 77,
      "control": 66,
      "pressure": 49,
      "agility": 50,
      "physical": 46,
      "technique": 51
    }
  },
  {
    "id": 3825,
    "name": "Kanchu Ko",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/f/vftjzwpfh68.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 62,
      "control": 74,
      "pressure": 51,
      "agility": 50,
      "physical": 56,
      "technique": 70
    }
  },
  {
    "id": 3826,
    "name": "Hakki Kyo",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/3/k3ioepp_qju.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 53,
      "control": 49,
      "pressure": 52,
      "agility": 69,
      "physical": 42,
      "technique": 47
    }
  },
  {
    "id": 3827,
    "name": "Nizo Koda",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/y/eybdnsc3fpk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 50,
      "control": 47,
      "pressure": 46,
      "agility": 62,
      "physical": 56,
      "technique": 51
    }
  },
  {
    "id": 3828,
    "name": "Ryo Terada",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/w/1ww8gt6nyam.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 48,
      "control": 40,
      "pressure": 69,
      "agility": 43,
      "physical": 70,
      "technique": 56
    }
  },
  {
    "id": 3829,
    "name": "Senjiro Kohama",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/a/bapkrg5vvlk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 50,
      "control": 49,
      "pressure": 63,
      "agility": 56,
      "physical": 60,
      "technique": 54
    }
  },
  {
    "id": 3830,
    "name": "Senzo Takamori",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/y/wy-f8ffv4wm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 44,
      "control": 48,
      "pressure": 51,
      "agility": 62,
      "physical": 53,
      "technique": 74
    }
  },
  {
    "id": 3831,
    "name": "Kojuro Katsuragi",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/a/-axosw1ghdk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 40,
      "control": 60,
      "pressure": 42,
      "agility": 62,
      "physical": 60,
      "technique": 65
    }
  },
  {
    "id": 3832,
    "name": "Senkuro Hajime",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/y/pyav_ptaqwm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 41,
      "control": 54,
      "pressure": 44,
      "agility": 63,
      "physical": 60,
      "technique": 58
    }
  },
  {
    "id": 3833,
    "name": "Samey Kondo",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/d/vdjas0msfq8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 58,
      "control": 40,
      "pressure": 56,
      "agility": 68,
      "physical": 51,
      "technique": 73
    }
  },
  {
    "id": 3834,
    "name": "Hachinoshin Nitta",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/1/e1s7blaoyju.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 55,
      "control": 54,
      "pressure": 50,
      "agility": 50,
      "physical": 61,
      "technique": 53
    }
  },
  {
    "id": 3835,
    "name": "Munetsugu Niseya",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/u/cuvnvsse3lu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 43,
      "control": 41,
      "pressure": 41,
      "agility": 71,
      "physical": 60,
      "technique": 61
    }
  },
  {
    "id": 3836,
    "name": "Taiji Kinetsuki",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/8/t8kgct0-aw8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 57,
      "control": 46,
      "pressure": 78,
      "agility": 57,
      "physical": 57,
      "technique": 45
    }
  },
  {
    "id": 3837,
    "name": "Mai Assamu",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/t/nthzrwb2v2m.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 48,
      "control": 40,
      "pressure": 67,
      "agility": 40,
      "physical": 73,
      "technique": 43
    }
  },
  {
    "id": 3838,
    "name": "Yuki Oolong",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/7/872s8pnmcfk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 53,
      "control": 62,
      "pressure": 58,
      "agility": 55,
      "physical": 50,
      "technique": 61
    }
  },
  {
    "id": 3839,
    "name": "Matsuri Chai",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/r/irjknckul6m.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 45,
      "control": 56,
      "pressure": 61,
      "agility": 53,
      "physical": 77,
      "technique": 40
    }
  },
  {
    "id": 3840,
    "name": "Macha Green",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/5/554rg9cuijk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 53,
      "control": 49,
      "pressure": 55,
      "agility": 74,
      "physical": 48,
      "technique": 62
    }
  },
  {
    "id": 3841,
    "name": "Mimi Ceylon",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/r/xrjm68ldple.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 43,
      "control": 47,
      "pressure": 79,
      "agility": 59,
      "physical": 78,
      "technique": 53
    }
  },
  {
    "id": 3842,
    "name": "Kim Terberry",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/5/m5shxdtnews.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 47,
      "control": 52,
      "pressure": 58,
      "agility": 52,
      "physical": 58,
      "technique": 57
    }
  },
  {
    "id": 3843,
    "name": "Chester Mann",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/w/gwxyeeyvx2c.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 60,
      "control": 55,
      "pressure": 72,
      "agility": 52,
      "physical": 58,
      "technique": 56
    }
  },
  {
    "id": 3844,
    "name": "Rick Warwick",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/-/3-atph-vcf0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 82,
      "intelligence": 50,
      "control": 45,
      "pressure": 52,
      "agility": 63,
      "physical": 49,
      "technique": 65
    }
  },
  {
    "id": 3845,
    "name": "May Fayeux",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/f/1fhph4s5zd0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 64,
      "control": 71,
      "pressure": 40,
      "agility": 42,
      "physical": 51,
      "technique": 72
    }
  },
  {
    "id": 3846,
    "name": "Eddie Burroughs",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/3/e32uqhkd0wc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 42,
      "control": 54,
      "pressure": 41,
      "agility": 77,
      "physical": 54,
      "technique": 55
    }
  },
  {
    "id": 3847,
    "name": "Scott Chegwin",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/y/kyvb5a_lbqs.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 46,
      "control": 60,
      "pressure": 40,
      "agility": 52,
      "physical": 54,
      "technique": 61
    }
  },
  {
    "id": 3848,
    "name": "Jor Braykur",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/w/vwk6ulzxsje.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 47,
      "control": 51,
      "pressure": 55,
      "agility": 43,
      "physical": 76,
      "technique": 41
    }
  },
  {
    "id": 3849,
    "name": "Pam Duff",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/a/habiloatlcs.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 54,
      "control": 59,
      "pressure": 82,
      "agility": 53,
      "physical": 62,
      "technique": 55
    }
  },
  {
    "id": 3850,
    "name": "Phil English",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/y/qyqdix8pmve.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 55,
      "control": 43,
      "pressure": 58,
      "agility": 53,
      "physical": 44,
      "technique": 61
    }
  },
  {
    "id": 3851,
    "name": "Neville Foodcake",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/2/62_xuxibyem.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 54,
      "control": 75,
      "pressure": 48,
      "agility": 41,
      "physical": 41,
      "technique": 53
    }
  },
  {
    "id": 3852,
    "name": "Fae Grimm",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/e/leoq5oeh13k.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 46,
      "control": 40,
      "pressure": 58,
      "agility": 49,
      "physical": 55,
      "technique": 54
    }
  },
  {
    "id": 3853,
    "name": "Sloan Hinge",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/x/rxtlq1xpaxu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 53,
      "control": 48,
      "pressure": 48,
      "agility": 60,
      "physical": 43,
      "technique": 59
    }
  },
  {
    "id": 3854,
    "name": "Winnie Hull",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/z/azcehkxttk8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 59,
      "control": 60,
      "pressure": 62,
      "agility": 54,
      "physical": 61,
      "technique": 59
    }
  },
  {
    "id": 3855,
    "name": "Sylvain Elph",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/4/y4byptf_oi8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 59,
      "control": 51,
      "pressure": 70,
      "agility": 51,
      "physical": 73,
      "technique": 60
    }
  },
  {
    "id": 3856,
    "name": "Vic Longboat",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/q/pqq5esjffru.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 49,
      "control": 56,
      "pressure": 60,
      "agility": 51,
      "physical": 67,
      "technique": 53
    }
  },
  {
    "id": 3857,
    "name": "Gezun Dight",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/_/j_jmxxwnwxk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 45,
      "control": 53,
      "pressure": 44,
      "agility": 56,
      "physical": 54,
      "technique": 69
    }
  },
  {
    "id": 3858,
    "name": "Rei Nurtur",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/x/4x4t6ow3dcm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 56,
      "control": 55,
      "pressure": 66,
      "agility": 50,
      "physical": 79,
      "technique": 41
    }
  },
  {
    "id": 3859,
    "name": "Zato Memmor",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/9/m9h1ldzv69k.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 57,
      "control": 60,
      "pressure": 46,
      "agility": 70,
      "physical": 50,
      "technique": 65
    }
  },
  {
    "id": 3860,
    "name": "Dijea Graffin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/v/9v2um8vvxom.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 45,
      "control": 49,
      "pressure": 61,
      "agility": 41,
      "physical": 60,
      "technique": 55
    }
  },
  {
    "id": 3861,
    "name": "Agnethe Presari",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/9/t9tz89cm2is.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 57,
      "control": 56,
      "pressure": 59,
      "agility": 40,
      "physical": 67,
      "technique": 58
    }
  },
  {
    "id": 3862,
    "name": "Endura Vigil",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/v/ivc4rc6cbre.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 57,
      "control": 55,
      "pressure": 59,
      "agility": 70,
      "physical": 46,
      "technique": 48
    }
  },
  {
    "id": 3863,
    "name": "Giv'r Trupal",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/6/c6_ncfpuux0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 46,
      "control": 50,
      "pressure": 57,
      "agility": 50,
      "physical": 78,
      "technique": 49
    }
  },
  {
    "id": 3864,
    "name": "Onor Doodad",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/s/zsosvgpudcc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 46,
      "control": 57,
      "pressure": 43,
      "agility": 63,
      "physical": 41,
      "technique": 60
    }
  },
  {
    "id": 3865,
    "name": "Xander Ice",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/z/xzjwb57cgec.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 60,
      "control": 40,
      "pressure": 50,
      "agility": 60,
      "physical": 43,
      "technique": 71
    }
  },
  {
    "id": 3866,
    "name": "Mmor Pegg",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/b/ab4rsgd4r30.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 57,
      "control": 50,
      "pressure": 64,
      "agility": 44,
      "physical": 68,
      "technique": 45
    }
  },
  {
    "id": 3867,
    "name": "Fanqs Kamagen",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/f/qf3ikkhd__8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 41,
      "control": 43,
      "pressure": 44,
      "agility": 59,
      "physical": 41,
      "technique": 52
    }
  },
  {
    "id": 3868,
    "name": "Eoin Geary",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/-/s-wuktzx658.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 49,
      "control": 53,
      "pressure": 59,
      "agility": 63,
      "physical": 46,
      "technique": 59
    }
  },
  {
    "id": 3869,
    "name": "Graham Awn",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/w/jwb1nsvlxku.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 75,
      "control": 66,
      "pressure": 50,
      "agility": 51,
      "physical": 54,
      "technique": 62
    }
  },
  {
    "id": 3870,
    "name": "Keenan Mustard",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/5/d5ia0xgdiqk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 46,
      "control": 45,
      "pressure": 55,
      "agility": 55,
      "physical": 43,
      "technique": 55
    }
  },
  {
    "id": 3871,
    "name": "Suzy Stamp",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/r/yrthzog5pzm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 55,
      "control": 40,
      "pressure": 65,
      "agility": 41,
      "physical": 57,
      "technique": 49
    }
  },
  {
    "id": 3872,
    "name": "Peachy Keen",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/7/g7s5odfbomk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 60,
      "control": 42,
      "pressure": 69,
      "agility": 55,
      "physical": 64,
      "technique": 55
    }
  },
  {
    "id": 3873,
    "name": "Brick DeVille",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/t/3tdyf8jhfvm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 44,
      "control": 57,
      "pressure": 49,
      "agility": 71,
      "physical": 48,
      "technique": 48
    }
  },
  {
    "id": 3874,
    "name": "Breeze Skyler",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/7/57str1ju6ak.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 42,
      "control": 58,
      "pressure": 75,
      "agility": 50,
      "physical": 65,
      "technique": 53
    }
  },
  {
    "id": 3875,
    "name": "Synch Rogram",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/u/zuxm4o8cpgu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 67,
      "control": 66,
      "pressure": 60,
      "agility": 54,
      "physical": 47,
      "technique": 58
    }
  },
  {
    "id": 3876,
    "name": "C-Bear",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/1/b126wxuwkmu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 40,
      "control": 53,
      "pressure": 58,
      "agility": 58,
      "physical": 61,
      "technique": 46
    }
  },
  {
    "id": 3878,
    "name": "Van Yamano",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/y/bylcaoyvnsk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 49,
      "control": 50,
      "pressure": 52,
      "agility": 58,
      "physical": 48,
      "technique": 58
    }
  },
  {
    "id": 3879,
    "name": "Hiro Hughes",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/3/h3gpj1hnsmu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 40,
      "control": 42,
      "pressure": 56,
      "agility": 66,
      "physical": 53,
      "technique": 53
    }
  },
  {
    "id": 3880,
    "name": "Hershel Layton",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 3881,
    "name": "Luke Triton",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 3883,
    "name": "Silvain Hache",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/_/m_tnal4vi0k.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 52,
      "control": 43,
      "pressure": 52,
      "agility": 56,
      "physical": 56,
      "technique": 65
    }
  },
  {
    "id": 3884,
    "name": "Goldus Janque",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/q/sqo4twnd9uu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 49,
      "control": 54,
      "pressure": 70,
      "agility": 54,
      "physical": 66,
      "technique": 49
    }
  },
  {
    "id": 3885,
    "name": "Sting Xiang",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/4/d4_z-prnqn8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 72,
      "control": 67,
      "pressure": 52,
      "agility": 57,
      "physical": 48,
      "technique": 69
    }
  },
  {
    "id": 3886,
    "name": "Venom Braggard",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/z/fz4fqw5lvh8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 46,
      "control": 41,
      "pressure": 69,
      "agility": 40,
      "physical": 72,
      "technique": 47
    }
  },
  {
    "id": 3887,
    "name": "Redd Hazzard",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/x/uxjk9pfx4su.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 59,
      "control": 43,
      "pressure": 48,
      "agility": 58,
      "physical": 46,
      "technique": 54
    }
  },
  {
    "id": 3888,
    "name": "Fei Rune",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/s/ksdlmbdfe9k.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 51,
      "control": 43,
      "pressure": 53,
      "agility": 62,
      "physical": 56,
      "technique": 58
    }
  },
  {
    "id": 3889,
    "name": "Vladimir Blade",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/9/q9g-fc2xrdu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 84,
      "intelligence": 55,
      "control": 40,
      "pressure": 49,
      "agility": 71,
      "physical": 53,
      "technique": 58
    }
  },
  {
    "id": 3890,
    "name": "Arion Sherwind",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/v/bvrfyjqtgu8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 65,
      "control": 57,
      "pressure": 44,
      "agility": 41,
      "physical": 48,
      "technique": 71
    }
  },
  {
    "id": 3891,
    "name": "Riccardo Di Rigo",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/0/z0wdc6cbdo8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 76,
      "control": 57,
      "pressure": 50,
      "agility": 46,
      "physical": 51,
      "technique": 63
    }
  },
  {
    "id": 3892,
    "name": "Gabriel Garcia",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/c/ocnixfk7ubu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 55,
      "control": 60,
      "pressure": 72,
      "agility": 51,
      "physical": 71,
      "technique": 51
    }
  },
  {
    "id": 3893,
    "name": "Sol Daystar",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/z/izexiyrzb7k.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 44,
      "control": 47,
      "pressure": 59,
      "agility": 75,
      "physical": 54,
      "technique": 54
    }
  },
  {
    "id": 3894,
    "name": "Jean-Pierre Lapin",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/b/5b12pn3j2im.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 40,
      "control": 41,
      "pressure": 74,
      "agility": 48,
      "physical": 54,
      "technique": 46
    }
  },
  {
    "id": 3895,
    "name": "Sor",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/x/nxku-q0rr3k.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 52,
      "control": 50,
      "pressure": 71,
      "agility": 57,
      "physical": 55,
      "technique": 56
    }
  },
  {
    "id": 3896,
    "name": "Fei Rune",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/z/8z7ptvsr8em.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 57,
      "control": 47,
      "pressure": 50,
      "agility": 70,
      "physical": 43,
      "technique": 56
    }
  },
  {
    "id": 3897,
    "name": "Ryoma Nishiki",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/x/sxgcjubydos.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 65,
      "control": 75,
      "pressure": 57,
      "agility": 45,
      "physical": 43,
      "technique": 65
    }
  },
  {
    "id": 3898,
    "name": "Victor Blade",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/z/jzrjkr9iwbe.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 58,
      "control": 40,
      "pressure": 47,
      "agility": 75,
      "physical": 52,
      "technique": 58
    }
  },
  {
    "id": 3899,
    "name": "Goldie Lemmon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/2/d2yw32iqf70.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 59,
      "control": 53,
      "pressure": 71,
      "agility": 43,
      "physical": 71,
      "technique": 47
    }
  },
  {
    "id": 3900,
    "name": "Arion Sherwind",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/e/yed3ajuqoic.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 60,
      "control": 59,
      "pressure": 58,
      "agility": 42,
      "physical": 54,
      "technique": 61
    }
  },
  {
    "id": 3901,
    "name": "Bailong",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/_/w_er0q88toc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 51,
      "control": 47,
      "pressure": 54,
      "agility": 62,
      "physical": 48,
      "technique": 68
    }
  },
  {
    "id": 3902,
    "name": "Zanark Avalonic",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/x/bx1kzvaga90.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 50,
      "control": 52,
      "pressure": 47,
      "agility": 67,
      "physical": 55,
      "technique": 49
    }
  },
  {
    "id": 3903,
    "name": "Zanark Avalonic",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/4/h4w_kyvo1de.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 43,
      "control": 54,
      "pressure": 51,
      "agility": 65,
      "physical": 51,
      "technique": 55
    }
  },
  {
    "id": 3904,
    "name": "Romeo",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/s/qsxn4jgjaes.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 30,
      "intelligence": 51,
      "control": 51,
      "pressure": 56,
      "agility": 44,
      "physical": 71,
      "technique": 50
    }
  },
  {
    "id": 3905,
    "name": "Oscar",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/9/k904ruvr1kc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 51,
      "control": 43,
      "pressure": 55,
      "agility": 41,
      "physical": 71,
      "technique": 47
    }
  },
  {
    "id": 3906,
    "name": "Kilo",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/v/7vfzgrzryx0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 41,
      "control": 53,
      "pressure": 56,
      "agility": 53,
      "physical": 64,
      "technique": 58
    }
  },
  {
    "id": 3907,
    "name": "Papa",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/0/50cfoyh9dr0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 54,
      "control": 49,
      "pressure": 52,
      "agility": 45,
      "physical": 60,
      "technique": 44
    }
  },
  {
    "id": 3908,
    "name": "Quebec",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/c/iczkfnhhwic.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 55,
      "control": 69,
      "pressure": 51,
      "agility": 40,
      "physical": 56,
      "technique": 56
    }
  },
  {
    "id": 3909,
    "name": "Lima",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/z/ozqrwqypfcs.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 69,
      "control": 60,
      "pressure": 58,
      "agility": 45,
      "physical": 40,
      "technique": 66
    }
  },
  {
    "id": 3910,
    "name": "November",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/b/zbhw7vu1oxe.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 71,
      "control": 62,
      "pressure": 47,
      "agility": 47,
      "physical": 44,
      "technique": 66
    }
  },
  {
    "id": 3911,
    "name": "Sierra",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/x/txeokixxpos.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 68,
      "control": 65,
      "pressure": 50,
      "agility": 48,
      "physical": 51,
      "technique": 50
    }
  },
  {
    "id": 3912,
    "name": "Juliet",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/z/czvjndxti9e.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 59,
      "control": 53,
      "pressure": 40,
      "agility": 58,
      "physical": 57,
      "technique": 64
    }
  },
  {
    "id": 3913,
    "name": "Gamma",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/x/yx0e9c4kdrk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 44,
      "control": 55,
      "pressure": 47,
      "agility": 59,
      "physical": 41,
      "technique": 63
    }
  },
  {
    "id": 3914,
    "name": "Mike",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/z/dzflqjeeuim.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 54,
      "control": 48,
      "pressure": 53,
      "agility": 74,
      "physical": 55,
      "technique": 53
    }
  },
  {
    "id": 3915,
    "name": "Vee Wai",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/e/4earbnagg78.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 47,
      "control": 58,
      "pressure": 67,
      "agility": 59,
      "physical": 50,
      "technique": 60
    }
  },
  {
    "id": 3916,
    "name": "Dee Vee",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/r/yr5ksqvovbm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 53,
      "control": 50,
      "pressure": 56,
      "agility": 48,
      "physical": 75,
      "technique": 43
    }
  },
  {
    "id": 3917,
    "name": "Ayt Bee",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/d/pdif_vjs4ok.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 56,
      "control": 54,
      "pressure": 60,
      "agility": 58,
      "physical": 75,
      "technique": 41
    }
  },
  {
    "id": 3918,
    "name": "En Sicks",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/i/ripzr2b-9uk.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 41,
      "control": 45,
      "pressure": 65,
      "agility": 41,
      "physical": 67,
      "technique": 52
    }
  },
  {
    "id": 3919,
    "name": "Wun Ell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/k/ak-48j9eqdm.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 65,
      "control": 73,
      "pressure": 44,
      "agility": 59,
      "physical": 53,
      "technique": 71
    }
  },
  {
    "id": 3920,
    "name": "Zed Kyu",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/l/6ldnvuiml98.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 73,
      "control": 67,
      "pressure": 41,
      "agility": 52,
      "physical": 41,
      "technique": 58
    }
  },
  {
    "id": 3921,
    "name": "Kay Zirro",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/n/lnsscru2iou.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 59,
      "control": 72,
      "pressure": 44,
      "agility": 47,
      "physical": 47,
      "technique": 57
    }
  },
  {
    "id": 3922,
    "name": "Cee Eff",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/n/_nt0zmtuvx8.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 59,
      "control": 69,
      "pressure": 41,
      "agility": 41,
      "physical": 42,
      "technique": 69
    }
  },
  {
    "id": 3923,
    "name": "Ar Ecks",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/p/opivezluccu.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 62,
      "control": 62,
      "pressure": 42,
      "agility": 47,
      "physical": 44,
      "technique": 49
    }
  },
  {
    "id": 3924,
    "name": "Em Tee",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/n/gn5yeycnju0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 55,
      "control": 52,
      "pressure": 53,
      "agility": 77,
      "physical": 53,
      "technique": 46
    }
  },
  {
    "id": 3925,
    "name": "Ough Cee",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/p/rpi5pnkdodc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 57,
      "control": 44,
      "pressure": 56,
      "agility": 65,
      "physical": 40,
      "technique": 70
    }
  },
  {
    "id": 3926,
    "name": "Jay Yuu",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/g/xgrm66rv79s.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 42,
      "control": 57,
      "pressure": 54,
      "agility": 43,
      "physical": 64,
      "technique": 40
    }
  },
  {
    "id": 3927,
    "name": "Faiv Ess",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/i/aiatxf3vwoe.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 48,
      "control": 59,
      "pressure": 51,
      "agility": 54,
      "physical": 70,
      "technique": 50
    }
  },
  {
    "id": 3928,
    "name": "Tu Eigh",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/p/cpdx5cldtie.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 73,
      "control": 71,
      "pressure": 50,
      "agility": 50,
      "physical": 51,
      "technique": 54
    }
  },
  {
    "id": 3929,
    "name": "Aye Nort",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/b/zbsqujd5-7s.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 55,
      "control": 45,
      "pressure": 54,
      "agility": 73,
      "physical": 58,
      "technique": 65
    }
  },
  {
    "id": 3930,
    "name": "Ji Tenn",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/u/tuplh-2xlbc.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 42,
      "control": 40,
      "pressure": 50,
      "agility": 75,
      "physical": 51,
      "technique": 57
    }
  },
  {
    "id": 3931,
    "name": "Simeon Ayp",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/r/4rtimymulie.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 54,
      "control": 44,
      "pressure": 49,
      "agility": 55,
      "physical": 56,
      "technique": 60
    }
  },
  {
    "id": 3932,
    "name": "Wolfram Vulpeen",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/d/jdcdlnqumrs.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 48,
      "control": 60,
      "pressure": 54,
      "agility": 74,
      "physical": 57,
      "technique": 56
    }
  },
  {
    "id": 3933,
    "name": "Desmodus Drakul",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/i/libfl-4cjxs.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 54,
      "control": 66,
      "pressure": 42,
      "agility": 55,
      "physical": 58,
      "technique": 57
    }
  },
  {
    "id": 3934,
    "name": "Flora",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/e/yeox1f5c-c0.png",
    "game": [
      "Inazuma Eleven GO 2"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 53,
      "control": 55,
      "pressure": 53,
      "agility": 71,
      "physical": 56,
      "technique": 57
    }
  },
  {
    "id": 3935,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 3936,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 3937,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 3938,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 3939,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 3940,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 3941,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 3942,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 3943,
    "name": "Falco Flashman",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/k/0ks2lhuo2sm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 47,
      "control": 54,
      "pressure": 54,
      "agility": 59,
      "physical": 60,
      "technique": 69
    }
  },
  {
    "id": 3945,
    "name": "Falco Flashman",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/g/pgc9ollbn5e.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 83,
      "intelligence": 49,
      "control": 48,
      "pressure": 51,
      "agility": 67,
      "physical": 46,
      "technique": 67
    }
  },
  {
    "id": 3946,
    "name": "Terry Archibald",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/v/dvaenlqvyks.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 53,
      "control": 54,
      "pressure": 62,
      "agility": 47,
      "physical": 64,
      "technique": 56
    }
  },
  {
    "id": 3947,
    "name": "Cerise Blossom",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/m/um2jotedw_e.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 59,
      "control": 62,
      "pressure": 44,
      "agility": 52,
      "physical": 45,
      "technique": 59
    }
  },
  {
    "id": 3948,
    "name": "Buddy Fury",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/o/fohcjs45dms.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 53,
      "control": 62,
      "pressure": 49,
      "agility": 42,
      "physical": 43,
      "technique": 45
    }
  },
  {
    "id": 3950,
    "name": "Frank Foreman",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/h/_hk3wpnxosc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 50,
      "control": 45,
      "pressure": 67,
      "agility": 53,
      "physical": 70,
      "technique": 49
    }
  },
  {
    "id": 3951,
    "name": "Zippy Lerner",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/j/ojvwdwrlff0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 58,
      "control": 43,
      "pressure": 67,
      "agility": 50,
      "physical": 70,
      "technique": 54
    }
  },
  {
    "id": 3952,
    "name": "Keenan Sharpe",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/o/moskzp5naz0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 53,
      "control": 58,
      "pressure": 68,
      "agility": 50,
      "physical": 60,
      "technique": 54
    }
  },
  {
    "id": 3953,
    "name": "Trina Verdure",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/a/9ajrewfdtqc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 60,
      "control": 56,
      "pressure": 74,
      "agility": 52,
      "physical": 68,
      "technique": 40
    }
  },
  {
    "id": 3954,
    "name": "Zack Avalon",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/l/ulxd28hgdm8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 53,
      "control": 50,
      "pressure": 46,
      "agility": 61,
      "physical": 53,
      "technique": 46
    }
  },
  {
    "id": 3956,
    "name": "Fake Victor",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/c/nch-1av2r5u.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 60,
      "control": 57,
      "pressure": 51,
      "agility": 72,
      "physical": 44,
      "technique": 57
    }
  },
  {
    "id": 3957,
    "name": "Astero Black",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/1/p1-vjfajhos.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 57,
      "control": 55,
      "pressure": 59,
      "agility": 65,
      "physical": 50,
      "technique": 67
    }
  },
  {
    "id": 3958,
    "name": "Justin Shipwood",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/y/hysrerf0nd0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 54,
      "control": 47,
      "pressure": 80,
      "agility": 56,
      "physical": 67,
      "technique": 59
    }
  },
  {
    "id": 3959,
    "name": "Skie Blue",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/v/9vuy5djpgzk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 52,
      "control": 55,
      "pressure": 48,
      "agility": 50,
      "physical": 53,
      "technique": 53
    }
  },
  {
    "id": 3960,
    "name": "Glacia Vessal",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/a/da3tqe8hztu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 60,
      "control": 60,
      "pressure": 54,
      "agility": 65,
      "physical": 56,
      "technique": 65
    }
  },
  {
    "id": 3961,
    "name": "Do-Hyeon Nam",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/5/v5zeahzqmm0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 54,
      "control": 53,
      "pressure": 55,
      "agility": 54,
      "physical": 65,
      "technique": 56
    }
  },
  {
    "id": 3962,
    "name": "Shinjae Choi",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/w/pw6xtagitse.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 55,
      "control": 54,
      "pressure": 66,
      "agility": 49,
      "physical": 71,
      "technique": 55
    }
  },
  {
    "id": 3963,
    "name": "Jun-Ho Bae",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/-/--lq-lgy-fs.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 60,
      "control": 46,
      "pressure": 70,
      "agility": 60,
      "physical": 58,
      "technique": 55
    }
  },
  {
    "id": 3964,
    "name": "Yongjin Seo",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/f/8fmmq8y07zs.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 40,
      "control": 57,
      "pressure": 65,
      "agility": 60,
      "physical": 60,
      "technique": 48
    }
  },
  {
    "id": 3965,
    "name": "Ujin Shin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/3/n39t9duowqe.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 49,
      "control": 47,
      "pressure": 73,
      "agility": 57,
      "physical": 72,
      "technique": 60
    }
  },
  {
    "id": 3966,
    "name": "Gunwoo Yang",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/y/tyeyuehgjk0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 59,
      "control": 66,
      "pressure": 55,
      "agility": 48,
      "physical": 49,
      "technique": 55
    }
  },
  {
    "id": 3967,
    "name": "Jihun Song",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/w/cwv5dhh8o5c.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 59,
      "control": 53,
      "pressure": 56,
      "agility": 45,
      "physical": 55,
      "technique": 69
    }
  },
  {
    "id": 3968,
    "name": "Minseo Byun",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/a/oaqhyseepg0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 71,
      "control": 68,
      "pressure": 44,
      "agility": 54,
      "physical": 41,
      "technique": 58
    }
  },
  {
    "id": 3969,
    "name": "Soyeon Sim",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/y/zyhaftike1c.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 54,
      "control": 43,
      "pressure": 52,
      "agility": 69,
      "physical": 51,
      "technique": 73
    }
  },
  {
    "id": 3970,
    "name": "Jun-Yeong Lee",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/a/3a6nfsrtlz8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 54,
      "control": 48,
      "pressure": 58,
      "agility": 58,
      "physical": 42,
      "technique": 53
    }
  },
  {
    "id": 3971,
    "name": "Joon-Ho Hwang",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/y/gylsotnxiqu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 41,
      "control": 58,
      "pressure": 56,
      "agility": 52,
      "physical": 51,
      "technique": 60
    }
  },
  {
    "id": 3972,
    "name": "Changsu Choi",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/m/smqk_nfotgm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 70,
      "control": 68,
      "pressure": 55,
      "agility": 58,
      "physical": 52,
      "technique": 69
    }
  },
  {
    "id": 3973,
    "name": "Jude Gordon",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/5/p5nc0pqw418.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 49,
      "control": 43,
      "pressure": 71,
      "agility": 59,
      "physical": 68,
      "technique": 49
    }
  },
  {
    "id": 3974,
    "name": "Owe Noyster",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/w/vwu3nslenvm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 54,
      "control": 45,
      "pressure": 59,
      "agility": 40,
      "physical": 69,
      "technique": 43
    }
  },
  {
    "id": 3975,
    "name": "Whaly Walker",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/-/e-fwktdkgmk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 54,
      "control": 46,
      "pressure": 56,
      "agility": 58,
      "physical": 69,
      "technique": 42
    }
  },
  {
    "id": 3976,
    "name": "Sunny Fishton",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/f/cfykk0rilgk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 57,
      "control": 44,
      "pressure": 56,
      "agility": 42,
      "physical": 67,
      "technique": 54
    }
  },
  {
    "id": 3977,
    "name": "Clem Chowdry",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/3/t3prjl3yitm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 45,
      "control": 57,
      "pressure": 65,
      "agility": 53,
      "physical": 62,
      "technique": 50
    }
  },
  {
    "id": 3978,
    "name": "Oscar Squidows",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/y/nykeawc69z8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 57,
      "control": 64,
      "pressure": 42,
      "agility": 48,
      "physical": 48,
      "technique": 50
    }
  },
  {
    "id": 3979,
    "name": "Marsha Ark",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/w/8w7_3pkaqau.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 73,
      "control": 55,
      "pressure": 57,
      "agility": 58,
      "physical": 43,
      "technique": 49
    }
  },
  {
    "id": 3980,
    "name": "Cole Reef",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/a/iaengkni3_8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 58,
      "control": 71,
      "pressure": 46,
      "agility": 41,
      "physical": 54,
      "technique": 60
    }
  },
  {
    "id": 3981,
    "name": "Amanda Ray",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/y/5y1grbbyamu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 63,
      "control": 68,
      "pressure": 58,
      "agility": 56,
      "physical": 48,
      "technique": 65
    }
  },
  {
    "id": 3982,
    "name": "Lob Stark",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/a/xaulxair7g0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 51,
      "control": 44,
      "pressure": 59,
      "agility": 51,
      "physical": 49,
      "technique": 59
    }
  },
  {
    "id": 3983,
    "name": "Octavius Parson",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/y/myfqclurwtc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 55,
      "control": 49,
      "pressure": 41,
      "agility": 65,
      "physical": 53,
      "technique": 53
    }
  },
  {
    "id": 3984,
    "name": "Orlando Sherman",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/v/fvcz8br-fvk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 76,
      "control": 60,
      "pressure": 58,
      "agility": 55,
      "physical": 41,
      "technique": 65
    }
  },
  {
    "id": 3985,
    "name": "Salman Karim",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/v/lvd9yohtnyu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 48,
      "control": 52,
      "pressure": 55,
      "agility": 48,
      "physical": 67,
      "technique": 55
    }
  },
  {
    "id": 3986,
    "name": "Shakir Zahir",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/6/r6gihtylssk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 51,
      "control": 44,
      "pressure": 65,
      "agility": 57,
      "physical": 77,
      "technique": 49
    }
  },
  {
    "id": 3987,
    "name": "Asad Gheisari",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/s/asrpmsuf_hm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 55,
      "control": 41,
      "pressure": 64,
      "agility": 56,
      "physical": 67,
      "technique": 43
    }
  },
  {
    "id": 3988,
    "name": "Batal Majid",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/z/yzw1i1gz6nm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 47,
      "control": 51,
      "pressure": 65,
      "agility": 47,
      "physical": 60,
      "technique": 47
    }
  },
  {
    "id": 3989,
    "name": "Qamar Sadir",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/b/pbnupkgjxuk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 44,
      "control": 50,
      "pressure": 68,
      "agility": 46,
      "physical": 65,
      "technique": 55
    }
  },
  {
    "id": 3990,
    "name": "Khalil Haddaoui",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/0/j0ehcxvbi0u.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 70,
      "control": 65,
      "pressure": 42,
      "agility": 52,
      "physical": 44,
      "technique": 71
    }
  },
  {
    "id": 3991,
    "name": "Nazim Nizar",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/c/4c1axoz7ph8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 73,
      "control": 77,
      "pressure": 56,
      "agility": 47,
      "physical": 43,
      "technique": 67
    }
  },
  {
    "id": 3992,
    "name": "Tamir Nasr",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/2/m2kyalwzo4u.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 65,
      "control": 76,
      "pressure": 51,
      "agility": 51,
      "physical": 44,
      "technique": 56
    }
  },
  {
    "id": 3993,
    "name": "Rashid Hakim",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/e/9e75tawjfl8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 63,
      "control": 60,
      "pressure": 43,
      "agility": 44,
      "physical": 42,
      "technique": 55
    }
  },
  {
    "id": 3994,
    "name": "Said Ashraf",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/2/t2g03bfqknc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 48,
      "control": 51,
      "pressure": 45,
      "agility": 66,
      "physical": 53,
      "technique": 62
    }
  },
  {
    "id": 3995,
    "name": "Qasim Batal",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/e/iervak5qju0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 60,
      "control": 60,
      "pressure": 49,
      "agility": 65,
      "physical": 41,
      "technique": 60
    }
  },
  {
    "id": 3996,
    "name": "Murshid Amir",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/a/_a_svce2w1u.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 50,
      "control": 56,
      "pressure": 72,
      "agility": 50,
      "physical": 72,
      "technique": 46
    }
  },
  {
    "id": 3997,
    "name": "Udom Kaochuea",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/4/n4t7-e8nx7u.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 50,
      "control": 54,
      "pressure": 65,
      "agility": 55,
      "physical": 66,
      "technique": 44
    }
  },
  {
    "id": 3998,
    "name": "Yuth Poonlarp",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/x/txootzjvebk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 52,
      "control": 53,
      "pressure": 62,
      "agility": 56,
      "physical": 62,
      "technique": 43
    }
  },
  {
    "id": 3999,
    "name": "Napa Rattana",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/_/c__vamvvpom.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 43,
      "control": 60,
      "pressure": 69,
      "agility": 53,
      "physical": 60,
      "technique": 47
    }
  },
  {
    "id": 4000,
    "name": "Naid Sirisukha",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/e/ee4zu_95sum.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 45,
      "control": 42,
      "pressure": 66,
      "agility": 46,
      "physical": 78,
      "technique": 59
    }
  },
  {
    "id": 4001,
    "name": "Solada Kulkit",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/2/v2jsdabdbdk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 69,
      "control": 59,
      "pressure": 59,
      "agility": 45,
      "physical": 47,
      "technique": 65
    }
  },
  {
    "id": 4002,
    "name": "Suchart Chaowarat",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/z/pzqnqdul09u.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 72,
      "control": 77,
      "pressure": 58,
      "agility": 48,
      "physical": 43,
      "technique": 71
    }
  },
  {
    "id": 4003,
    "name": "Naowarat Rahman",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/x/-xbg9iixzo8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 71,
      "control": 57,
      "pressure": 52,
      "agility": 40,
      "physical": 57,
      "technique": 57
    }
  },
  {
    "id": 4004,
    "name": "Mei Chaptri",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/b/kbkemvlt-xu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 61,
      "control": 71,
      "pressure": 55,
      "agility": 48,
      "physical": 42,
      "technique": 50
    }
  },
  {
    "id": 4005,
    "name": "Bhak Sepakroh",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/z/7zv_hqtptc8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 71,
      "control": 53,
      "pressure": 52,
      "agility": 46,
      "physical": 50,
      "technique": 64
    }
  },
  {
    "id": 4006,
    "name": "Klaharn Sangsorn",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/b/vboy7rkgyuc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 74,
      "control": 53,
      "pressure": 51,
      "agility": 41,
      "physical": 43,
      "technique": 67
    }
  },
  {
    "id": 4007,
    "name": "Tamgan Jaa",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/z/kz_twucafd0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 55,
      "control": 44,
      "pressure": 51,
      "agility": 71,
      "physical": 50,
      "technique": 55
    }
  },
  {
    "id": 4008,
    "name": "Rashiri Saran",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/o/oooncj4mdg8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 28,
      "intelligence": 58,
      "control": 44,
      "pressure": 64,
      "agility": 41,
      "physical": 61,
      "technique": 53
    }
  },
  {
    "id": 4009,
    "name": "Aleksei Karimov",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/4/t459kmfbvcc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 50,
      "control": 57,
      "pressure": 67,
      "agility": 58,
      "physical": 52,
      "technique": 58
    }
  },
  {
    "id": 4010,
    "name": "Sergei Chernov",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/x/nxaizrqtais.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 49,
      "control": 54,
      "pressure": 61,
      "agility": 57,
      "physical": 59,
      "technique": 40
    }
  },
  {
    "id": 4011,
    "name": "Mitya Eremin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/_/8_rp0ump3re.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 50,
      "control": 46,
      "pressure": 52,
      "agility": 55,
      "physical": 76,
      "technique": 48
    }
  },
  {
    "id": 4012,
    "name": "Yuri Avelin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/e/-es1a3efyxe.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 54,
      "control": 60,
      "pressure": 61,
      "agility": 57,
      "physical": 65,
      "technique": 58
    }
  },
  {
    "id": 4013,
    "name": "Kenja Jo'rayev",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/2/p2du3i4_fks.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 47,
      "control": 58,
      "pressure": 63,
      "agility": 56,
      "physical": 68,
      "technique": 55
    }
  },
  {
    "id": 4014,
    "name": "Leonid Mirzayev",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/z/vz-hkvn3qec.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 58,
      "control": 64,
      "pressure": 60,
      "agility": 53,
      "physical": 58,
      "technique": 67
    }
  },
  {
    "id": 4015,
    "name": "Ruslan Kashimov",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/x/expajqrnh30.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 52,
      "control": 72,
      "pressure": 56,
      "agility": 50,
      "physical": 53,
      "technique": 62
    }
  },
  {
    "id": 4016,
    "name": "Aaron Gachinsky",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/b/qbwy4novgic.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 58,
      "control": 70,
      "pressure": 48,
      "agility": 46,
      "physical": 42,
      "technique": 53
    }
  },
  {
    "id": 4017,
    "name": "Maxim Adrov",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/z/bzb5vyovn70.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 46,
      "control": 48,
      "pressure": 54,
      "agility": 67,
      "physical": 49,
      "technique": 75
    }
  },
  {
    "id": 4018,
    "name": "Domitri Sobirov",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/b/1ba0pzhcsxu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 55,
      "control": 55,
      "pressure": 58,
      "agility": 66,
      "physical": 52,
      "technique": 55
    }
  },
  {
    "id": 4019,
    "name": "Zafar Malayev",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/z/ezrvimhmbk8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 53,
      "control": 42,
      "pressure": 45,
      "agility": 66,
      "physical": 45,
      "technique": 74
    }
  },
  {
    "id": 4020,
    "name": "Nikolai Gagarin",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/m/ymv8oqckkfk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 44,
      "control": 45,
      "pressure": 55,
      "agility": 53,
      "physical": 45,
      "technique": 54
    }
  },
  {
    "id": 4021,
    "name": "B'adaen",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/u/_u0hzilyp9m.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 50,
      "control": 57,
      "pressure": 53,
      "agility": 60,
      "physical": 69,
      "technique": 50
    }
  },
  {
    "id": 4022,
    "name": "G'ob",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/b/fbxugvqq6d8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 40,
      "control": 53,
      "pressure": 69,
      "agility": 45,
      "physical": 60,
      "technique": 42
    }
  },
  {
    "id": 4023,
    "name": "A'ddah",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/p/upm1nq2qxuu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 42,
      "control": 50,
      "pressure": 67,
      "agility": 60,
      "physical": 57,
      "technique": 48
    }
  },
  {
    "id": 4024,
    "name": "R'adji",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/i/sihpjzkgsou.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 56,
      "control": 46,
      "pressure": 70,
      "agility": 53,
      "physical": 54,
      "technique": 52
    }
  },
  {
    "id": 4025,
    "name": "A'kra",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/g/dgqiomc8_b8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 60,
      "control": 49,
      "pressure": 72,
      "agility": 43,
      "physical": 73,
      "technique": 60
    }
  },
  {
    "id": 4026,
    "name": "N'ameeb",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/p/9pz9dr30k7m.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 45,
      "control": 42,
      "pressure": 68,
      "agility": 42,
      "physical": 66,
      "technique": 40
    }
  },
  {
    "id": 4027,
    "name": "K'aran",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/n/mnccwuronik.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 66,
      "control": 77,
      "pressure": 50,
      "agility": 54,
      "physical": 41,
      "technique": 65
    }
  },
  {
    "id": 4028,
    "name": "K'al",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/n/4n9ebjssa3m.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 50,
      "control": 45,
      "pressure": 54,
      "agility": 65,
      "physical": 60,
      "technique": 60
    }
  },
  {
    "id": 4029,
    "name": "S'haha",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/l/jlmlsc0wtek.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 50,
      "control": 40,
      "pressure": 44,
      "agility": 67,
      "physical": 46,
      "technique": 64
    }
  },
  {
    "id": 4030,
    "name": "S'harqiyah",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/n/nnxo2d9fmoe.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 51,
      "control": 58,
      "pressure": 56,
      "agility": 67,
      "physical": 51,
      "technique": 59
    }
  },
  {
    "id": 4031,
    "name": "A'tac",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/l/wlmjbiblhbs.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 55,
      "control": 59,
      "pressure": 42,
      "agility": 56,
      "physical": 42,
      "technique": 70
    }
  },
  {
    "id": 4032,
    "name": "Ogar Circes",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/k/2kf8i_utu7c.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 60,
      "control": 54,
      "pressure": 63,
      "agility": 48,
      "physical": 70,
      "technique": 52
    }
  },
  {
    "id": 4033,
    "name": "Zundar Zand",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/j/mjjrs6qgya8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 51,
      "control": 41,
      "pressure": 52,
      "agility": 65,
      "physical": 48,
      "technique": 56
    }
  },
  {
    "id": 4034,
    "name": "Van Tarel",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/u/fugnhagkree.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 47,
      "control": 54,
      "pressure": 65,
      "agility": 46,
      "physical": 61,
      "technique": 44
    }
  },
  {
    "id": 4035,
    "name": "Squalcha Nhess",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/b/_bdsudzskk0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 40,
      "control": 47,
      "pressure": 72,
      "agility": 50,
      "physical": 76,
      "technique": 41
    }
  },
  {
    "id": 4036,
    "name": "Sog Galily",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/p/opyz5ivwjxc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 56,
      "control": 46,
      "pressure": 74,
      "agility": 40,
      "physical": 55,
      "technique": 59
    }
  },
  {
    "id": 4037,
    "name": "Tinkel Urmia",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/i/mi1vx7h6mrc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 58,
      "control": 65,
      "pressure": 42,
      "agility": 45,
      "physical": 48,
      "technique": 50
    }
  },
  {
    "id": 4038,
    "name": "Plink Powai",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/g/9geo6ehahi0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 56,
      "control": 63,
      "pressure": 55,
      "agility": 52,
      "physical": 58,
      "technique": 51
    }
  },
  {
    "id": 4039,
    "name": "Puddel Khaspian",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/p/dpn7pzuiuce.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 61,
      "control": 56,
      "pressure": 59,
      "agility": 55,
      "physical": 47,
      "technique": 66
    }
  },
  {
    "id": 4040,
    "name": "Sploosh Saroma",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/n/snwaemyy5xs.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 62,
      "control": 58,
      "pressure": 55,
      "agility": 41,
      "physical": 43,
      "technique": 49
    }
  },
  {
    "id": 4041,
    "name": "Droplit Turkana",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/n/ynpc1rxqeoe.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 55,
      "control": 75,
      "pressure": 60,
      "agility": 57,
      "physical": 54,
      "technique": 57
    }
  },
  {
    "id": 4042,
    "name": "Plip Batur",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/l/plyjyuxqz9s.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 49,
      "control": 46,
      "pressure": 43,
      "agility": 57,
      "physical": 42,
      "technique": 54
    }
  },
  {
    "id": 4043,
    "name": "Serban Bacha",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/n/hnducvejsrm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 44,
      "control": 43,
      "pressure": 55,
      "agility": 71,
      "physical": 49,
      "technique": 56
    }
  },
  {
    "id": 4044,
    "name": "Plunk Balkhash",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/l/2lypvq4z_ik.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 46,
      "control": 48,
      "pressure": 52,
      "agility": 59,
      "physical": 59,
      "technique": 63
    }
  },
  {
    "id": 4045,
    "name": "Rondula Flehl",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/k/wkr683nrkcu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 77,
      "control": 58,
      "pressure": 41,
      "agility": 58,
      "physical": 40,
      "technique": 56
    }
  },
  {
    "id": 4046,
    "name": "Porco Umir",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/h/9h4wbfma1zu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 77,
      "control": 51,
      "pressure": 43,
      "agility": 41,
      "physical": 53,
      "technique": 51
    }
  },
  {
    "id": 4047,
    "name": "Aoba Gyr",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/c/bcuybbrfods.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 40,
      "control": 40,
      "pressure": 60,
      "agility": 41,
      "physical": 60,
      "technique": 60
    }
  },
  {
    "id": 4048,
    "name": "Mayon Langcrest",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/t/7tntsckx7jc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 40,
      "control": 46,
      "pressure": 67,
      "agility": 60,
      "physical": 72,
      "technique": 52
    }
  },
  {
    "id": 4049,
    "name": "Merapil Sekretair",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/f/kf8m_jctwq0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 50,
      "control": 57,
      "pressure": 72,
      "agility": 54,
      "physical": 68,
      "technique": 53
    }
  },
  {
    "id": 4050,
    "name": "Misty Aul",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/k/ik7qr6qbtw0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 68,
      "control": 59,
      "pressure": 58,
      "agility": 58,
      "physical": 40,
      "technique": 52
    }
  },
  {
    "id": 4051,
    "name": "Nevado Condorum",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/m/5mkx8f27-lc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 57,
      "control": 57,
      "pressure": 41,
      "agility": 60,
      "physical": 50,
      "technique": 67
    }
  },
  {
    "id": 4052,
    "name": "Etna Horx",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/j/zjpevydzlfs.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 76,
      "control": 61,
      "pressure": 56,
      "agility": 58,
      "physical": 59,
      "technique": 55
    }
  },
  {
    "id": 4053,
    "name": "Promon Shubill",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/l/olylcnljm2e.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 55,
      "control": 69,
      "pressure": 46,
      "agility": 55,
      "physical": 43,
      "technique": 69
    }
  },
  {
    "id": 4054,
    "name": "Cotopax Gerigar",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/h/chn9zqmrbjs.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 57,
      "control": 40,
      "pressure": 49,
      "agility": 71,
      "physical": 49,
      "technique": 70
    }
  },
  {
    "id": 4055,
    "name": "Vesuvion Bubo",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/j/tjwcevars6e.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 50,
      "control": 58,
      "pressure": 46,
      "agility": 68,
      "physical": 58,
      "technique": 54
    }
  },
  {
    "id": 4056,
    "name": "Tar Parky",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/h/dhnreujynwk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 58,
      "control": 41,
      "pressure": 42,
      "agility": 59,
      "physical": 54,
      "technique": 62
    }
  },
  {
    "id": 4057,
    "name": "Nyira Fezun",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/j/yj8wprviglm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 44,
      "control": 60,
      "pressure": 47,
      "agility": 69,
      "physical": 40,
      "technique": 62
    }
  },
  {
    "id": 4058,
    "name": "Bala Gasgula",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/m/smff62aqvf8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 83,
      "intelligence": 55,
      "control": 55,
      "pressure": 48,
      "agility": 67,
      "physical": 51,
      "technique": 58
    }
  },
  {
    "id": 4059,
    "name": "Caldera Dorne",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/k/pkkdjv6wnsm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 69,
      "control": 60,
      "pressure": 58,
      "agility": 46,
      "physical": 44,
      "technique": 57
    }
  },
  {
    "id": 4060,
    "name": "Ceram Longicorn",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/a/9abvrvhwlpc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 41,
      "control": 59,
      "pressure": 59,
      "agility": 57,
      "physical": 69,
      "technique": 59
    }
  },
  {
    "id": 4061,
    "name": "Romborina Drohn",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/v/dv4g4iy4-js.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 60,
      "control": 41,
      "pressure": 57,
      "agility": 47,
      "physical": 68,
      "technique": 56
    }
  },
  {
    "id": 4062,
    "name": "Heterocera Mothlin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/h/shjbv3uct6e.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 49,
      "control": 51,
      "pressure": 56,
      "agility": 48,
      "physical": 73,
      "technique": 58
    }
  },
  {
    "id": 4063,
    "name": "Formica Anz",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/m/umod7uguw8e.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 63,
      "control": 62,
      "pressure": 48,
      "agility": 55,
      "physical": 60,
      "technique": 60
    }
  },
  {
    "id": 4064,
    "name": "Mantodea Mantus",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/o/fo_8wrgu7ps.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 63,
      "control": 53,
      "pressure": 51,
      "agility": 44,
      "physical": 59,
      "technique": 54
    }
  },
  {
    "id": 4065,
    "name": "Lepidoptera Flutterby",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/h/_hcjfmvcovc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 59,
      "control": 55,
      "pressure": 44,
      "agility": 52,
      "physical": 47,
      "technique": 57
    }
  },
  {
    "id": 4066,
    "name": "Vespa Hornest",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/j/ojtoozzmjc0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 48,
      "control": 53,
      "pressure": 48,
      "agility": 74,
      "physical": 50,
      "technique": 55
    }
  },
  {
    "id": 4067,
    "name": "Caelif Hopper",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/j/6jswz-weejc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 57,
      "control": 72,
      "pressure": 43,
      "agility": 46,
      "physical": 43,
      "technique": 51
    }
  },
  {
    "id": 4068,
    "name": "Lucan Stag",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/l/lljr0bw-pq0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 57,
      "control": 75,
      "pressure": 54,
      "agility": 46,
      "physical": 45,
      "technique": 65
    }
  },
  {
    "id": 4069,
    "name": "Banda Crix",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/j/lj4cuaf3i8u.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 62,
      "control": 71,
      "pressure": 56,
      "agility": 42,
      "physical": 42,
      "technique": 66
    }
  },
  {
    "id": 4070,
    "name": "Schisto Locus",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/l/ulj9d_5nlp8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 50,
      "control": 48,
      "pressure": 53,
      "agility": 70,
      "physical": 40,
      "technique": 60
    }
  },
  {
    "id": 4071,
    "name": "Ruger Baran",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/k/0kqiqimfqvm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 43,
      "control": 40,
      "pressure": 57,
      "agility": 55,
      "physical": 43,
      "technique": 56
    }
  },
  {
    "id": 4072,
    "name": "Gandares Baran",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/m/fmbp9dq_9ck.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 59,
      "control": 54,
      "pressure": 54,
      "agility": 69,
      "physical": 44,
      "technique": 70
    }
  },
  {
    "id": 4073,
    "name": "Banda Crix Junior",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/t/htc1te4t4ak.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 72,
      "control": 57,
      "pressure": 55,
      "agility": 46,
      "physical": 46,
      "technique": 47
    }
  },
  {
    "id": 4074,
    "name": "Simeur Feromont",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/o/dobfsy5satk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 47,
      "control": 53,
      "pressure": 62,
      "agility": 55,
      "physical": 66,
      "technique": 46
    }
  },
  {
    "id": 4086,
    "name": "Argon Bulgess",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/w/vwwjsr9zrwm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 51,
      "control": 48,
      "pressure": 53,
      "agility": 47,
      "physical": 68,
      "technique": 52
    }
  },
  {
    "id": 4087,
    "name": "Xenon Reith",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/5/p518bmi7e28.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 55,
      "control": 56,
      "pressure": 59,
      "agility": 47,
      "physical": 66,
      "technique": 45
    }
  },
  {
    "id": 4088,
    "name": "Radon Mons",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/w/8wdbcq8t2du.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 51,
      "control": 53,
      "pressure": 55,
      "agility": 58,
      "physical": 64,
      "technique": 56
    }
  },
  {
    "id": 4089,
    "name": "Selenia Mund",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/y/nyygvvaxbw8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 66,
      "control": 63,
      "pressure": 45,
      "agility": 60,
      "physical": 47,
      "technique": 58
    }
  },
  {
    "id": 4090,
    "name": "Neon Rotarus",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/f/cfg0r3jldjk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 69,
      "control": 70,
      "pressure": 54,
      "agility": 55,
      "physical": 49,
      "technique": 58
    }
  },
  {
    "id": 4091,
    "name": "Brimstone Bol",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/1/311axel0ode.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 53,
      "control": 53,
      "pressure": 49,
      "agility": 67,
      "physical": 40,
      "technique": 54
    }
  },
  {
    "id": 4092,
    "name": "Phobos Quasar",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/6/r6y2uqqi0rk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 49,
      "control": 44,
      "pressure": 70,
      "agility": 51,
      "physical": 59,
      "technique": 56
    }
  },
  {
    "id": 4093,
    "name": "Aegir Cepheid",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/v/lv7dhnfabxu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 46,
      "control": 55,
      "pressure": 68,
      "agility": 58,
      "physical": 67,
      "technique": 59
    }
  },
  {
    "id": 4094,
    "name": "Meteo Garnet",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/9/69kiqy56sc8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 47,
      "control": 52,
      "pressure": 70,
      "agility": 51,
      "physical": 66,
      "technique": 42
    }
  },
  {
    "id": 4095,
    "name": "Deimos Lepton",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/c/4cn-errwpe8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 54,
      "control": 43,
      "pressure": 73,
      "agility": 56,
      "physical": 64,
      "technique": 59
    }
  },
  {
    "id": 4096,
    "name": "Ymir Catena",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/0/j08fpunse3u.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 42,
      "control": 55,
      "pressure": 76,
      "agility": 41,
      "physical": 72,
      "technique": 51
    }
  },
  {
    "id": 4097,
    "name": "Sinope Linea",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/b/pbfq6j4kxxk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 49,
      "control": 52,
      "pressure": 74,
      "agility": 54,
      "physical": 67,
      "technique": 49
    }
  },
  {
    "id": 4098,
    "name": "Tarvos Boson",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/z/yzulx2eeckm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 71,
      "control": 64,
      "pressure": 60,
      "agility": 49,
      "physical": 46,
      "technique": 64
    }
  },
  {
    "id": 4099,
    "name": "Dione Bolide",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/z/szrtm7d87bk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 66,
      "control": 56,
      "pressure": 59,
      "agility": 49,
      "physical": 42,
      "technique": 57
    }
  },
  {
    "id": 4100,
    "name": "Despina Lux",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/x/dxgyle7gwom.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 54,
      "control": 44,
      "pressure": 49,
      "agility": 53,
      "physical": 41,
      "technique": 69
    }
  },
  {
    "id": 4101,
    "name": "Ozrock Boldar",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/z/zz7_rfyp3es.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 41,
      "control": 55,
      "pressure": 45,
      "agility": 75,
      "physical": 41,
      "technique": 49
    }
  },
  {
    "id": 4102,
    "name": "Loge Colles",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/x/cxke86u1a3e.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 44,
      "control": 41,
      "pressure": 49,
      "agility": 61,
      "physical": 41,
      "technique": 52
    }
  },
  {
    "id": 4103,
    "name": "Strem Goozer",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/x/tx2wyarciyk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 60,
      "control": 54,
      "pressure": 73,
      "agility": 41,
      "physical": 74,
      "technique": 55
    }
  },
  {
    "id": 4104,
    "name": "Fow Tudas",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/4/n4vflhkkx4u.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 40,
      "control": 47,
      "pressure": 63,
      "agility": 47,
      "physical": 71,
      "technique": 43
    }
  },
  {
    "id": 4105,
    "name": "Cherio Pardon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/q/8qkkm4cw6l8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 57,
      "control": 43,
      "pressure": 61,
      "agility": 49,
      "physical": 58,
      "technique": 50
    }
  },
  {
    "id": 4106,
    "name": "Bambaros Tower",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/x/-xj4ihqc_n8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 44,
      "control": 44,
      "pressure": 70,
      "agility": 42,
      "physical": 58,
      "technique": 42
    }
  },
  {
    "id": 4107,
    "name": "Zartan Walder",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/z/pzszle2ms-u.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 40,
      "control": 47,
      "pressure": 72,
      "agility": 49,
      "physical": 67,
      "technique": 53
    }
  },
  {
    "id": 4108,
    "name": "Zyne Hanging",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/2/v2xs2ddunek.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 51,
      "control": 40,
      "pressure": 57,
      "agility": 47,
      "physical": 59,
      "technique": 58
    }
  },
  {
    "id": 4109,
    "name": "Madison Barada",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/e/eeanb8luktm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 40,
      "control": 42,
      "pressure": 76,
      "agility": 60,
      "physical": 65,
      "technique": 51
    }
  },
  {
    "id": 4110,
    "name": "Bindal Hermit",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/0/q0_vqxm2tsk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 73,
      "control": 58,
      "pressure": 59,
      "agility": 57,
      "physical": 58,
      "technique": 53
    }
  },
  {
    "id": 4111,
    "name": "Astro Justin",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/c/bco0hoamahm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 58,
      "control": 52,
      "pressure": 42,
      "agility": 52,
      "physical": 43,
      "technique": 65
    }
  },
  {
    "id": 4112,
    "name": "Circulus Corona",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/0/10v5dpjfhns.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 52,
      "control": 43,
      "pressure": 55,
      "agility": 66,
      "physical": 46,
      "technique": 60
    }
  },
  {
    "id": 4114,
    "name": "Joss Fool",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/c/eckywwv_m-e.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 60,
      "control": 56,
      "pressure": 47,
      "agility": 44,
      "physical": 55,
      "technique": 57
    }
  },
  {
    "id": 4115,
    "name": "Ashvina Bharani",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/x/nxi2ssy-8hs.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 54,
      "control": 44,
      "pressure": 66,
      "agility": 47,
      "physical": 77,
      "technique": 55
    }
  },
  {
    "id": 4116,
    "name": "Hastar Savitar",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/4/t4bd_ph2jbc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 44,
      "control": 56,
      "pressure": 57,
      "agility": 45,
      "physical": 72,
      "technique": 55
    }
  },
  {
    "id": 4117,
    "name": "Apas Mulan",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/q/cqwiswhmky0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 48,
      "control": 52,
      "pressure": 58,
      "agility": 50,
      "physical": 69,
      "technique": 48
    }
  },
  {
    "id": 4118,
    "name": "Soma Lobi",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/x/ex3-8pzgh00.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 44,
      "control": 49,
      "pressure": 64,
      "agility": 51,
      "physical": 69,
      "technique": 51
    }
  },
  {
    "id": 4119,
    "name": "Rudra Ardo",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/z/vzgfrwvamhc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 51,
      "control": 40,
      "pressure": 57,
      "agility": 43,
      "physical": 70,
      "technique": 47
    }
  },
  {
    "id": 4120,
    "name": "Bhaga Guni",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/2/p2lqclgs5ns.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 43,
      "control": 49,
      "pressure": 63,
      "agility": 42,
      "physical": 61,
      "technique": 49
    }
  },
  {
    "id": 4121,
    "name": "Bass Danish",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/e/-eulv0gouue.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 57,
      "control": 69,
      "pressure": 43,
      "agility": 58,
      "physical": 42,
      "technique": 70
    }
  },
  {
    "id": 4122,
    "name": "Indra Vayu",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/0/k0rte5fkzrs.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 65,
      "control": 64,
      "pressure": 41,
      "agility": 56,
      "physical": 44,
      "technique": 62
    }
  },
  {
    "id": 4123,
    "name": "Mitra Jeshu",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/c/7cayzgjweye.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 64,
      "control": 72,
      "pressure": 52,
      "agility": 55,
      "physical": 55,
      "technique": 74
    }
  },
  {
    "id": 4124,
    "name": "Arculus Orbes",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/0/v0b_phq5_0k.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 58,
      "control": 42,
      "pressure": 55,
      "agility": 65,
      "physical": 41,
      "technique": 54
    }
  },
  {
    "id": 4126,
    "name": "Ashley Sarpala",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/c/kcwee4mdshm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 79,
      "control": 67,
      "pressure": 47,
      "agility": 48,
      "physical": 56,
      "technique": 65
    }
  },
  {
    "id": 4127,
    "name": "Ptumri",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/d/hdli5etamem.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 51,
      "control": 46,
      "pressure": 74,
      "agility": 52,
      "physical": 69,
      "technique": 43
    }
  },
  {
    "id": 4128,
    "name": "Ptumri Emnator",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/d/-dpoo68zqbe.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 42,
      "control": 40,
      "pressure": 49,
      "agility": 62,
      "physical": 41,
      "technique": 52
    }
  },
  {
    "id": 4129,
    "name": "Ptumri Emnator",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/u/yutcf0t7kks.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 84,
      "intelligence": 54,
      "control": 41,
      "pressure": 59,
      "agility": 74,
      "physical": 48,
      "technique": 66
    }
  },
  {
    "id": 4130,
    "name": "Axel Blaze",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/y/bygxqzmitk8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 42,
      "control": 43,
      "pressure": 44,
      "agility": 65,
      "physical": 48,
      "technique": 61
    }
  },
  {
    "id": 4131,
    "name": "Skip Flashman",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/t/jtvnwixyib0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 57,
      "control": 52,
      "pressure": 60,
      "agility": 41,
      "physical": 56,
      "technique": 58
    }
  },
  {
    "id": 4132,
    "name": "Chip Flashman",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/7/s7ksd3xiloc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 81,
      "intelligence": 43,
      "control": 43,
      "pressure": 58,
      "agility": 72,
      "physical": 54,
      "technique": 63
    }
  },
  {
    "id": 4133,
    "name": "Thales Foreman",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/u/yuhzoqeqqis.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 60,
      "control": 56,
      "pressure": 64,
      "agility": 44,
      "physical": 71,
      "technique": 56
    }
  },
  {
    "id": 4134,
    "name": "Cerise Blossom",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/8/d824jviq97e.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 63,
      "control": 64,
      "pressure": 59,
      "agility": 56,
      "physical": 53,
      "technique": 58
    }
  },
  {
    "id": 4135,
    "name": "Cedric Blossom",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/w/3wjgsyhyaes.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 44,
      "control": 46,
      "pressure": 59,
      "agility": 72,
      "physical": 60,
      "technique": 55
    }
  },
  {
    "id": 4136,
    "name": "Marigold Blossom",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/-/g-4b_nhi33e.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 54,
      "control": 53,
      "pressure": 50,
      "agility": 72,
      "physical": 48,
      "technique": 56
    }
  },
  {
    "id": 4137,
    "name": "Judy Scarriot",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/w/iw3krut9iis.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 56,
      "control": 43,
      "pressure": 51,
      "agility": 73,
      "physical": 58,
      "technique": 64
    }
  },
  {
    "id": 4138,
    "name": "Jasper Lerner",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/-/5-gr8rlhlre.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 57,
      "control": 48,
      "pressure": 55,
      "agility": 74,
      "physical": 45,
      "technique": 57
    }
  },
  {
    "id": 4139,
    "name": "Mabel Lerner",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/r/zrlevm-pqx0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 73,
      "control": 69,
      "pressure": 47,
      "agility": 41,
      "physical": 58,
      "technique": 68
    }
  },
  {
    "id": 4141,
    "name": "Keenan Sharpe",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/y/qytjsqkz4ec.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 55,
      "control": 58,
      "pressure": 56,
      "agility": 58,
      "physical": 70,
      "technique": 52
    }
  },
  {
    "id": 4142,
    "name": "Seraph Sharpe",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/w/bwicbvsjv30.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 56,
      "control": 60,
      "pressure": 62,
      "agility": 55,
      "physical": 63,
      "technique": 41
    }
  },
  {
    "id": 4143,
    "name": "Miriam Sharpe",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/f/7fb3sizrgxe.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 53,
      "control": 48,
      "pressure": 53,
      "agility": 73,
      "physical": 43,
      "technique": 55
    }
  },
  {
    "id": 4145,
    "name": "Catra Page",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/o/sogmhhabeg8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 55,
      "control": 46,
      "pressure": 59,
      "agility": 53,
      "physical": 47,
      "technique": 51
    }
  },
  {
    "id": 4146,
    "name": "Laraya Orbes",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/j/ujbqp4i3bm8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 54,
      "control": 69,
      "pressure": 57,
      "agility": 48,
      "physical": 42,
      "technique": 64
    }
  },
  {
    "id": 4147,
    "name": "Globulus Ava",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/3/k3ww_3_rnks.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 53,
      "control": 40,
      "pressure": 65,
      "agility": 42,
      "physical": 60,
      "technique": 59
    }
  },
  {
    "id": 4148,
    "name": "Catra Page",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/8/j8i-xdbsjcm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 52,
      "control": 48,
      "pressure": 47,
      "agility": 74,
      "physical": 60,
      "technique": 61
    }
  },
  {
    "id": 4149,
    "name": "Laraya Orbes",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/w/xwdmmqcoe9k.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 59,
      "control": 65,
      "pressure": 50,
      "agility": 41,
      "physical": 44,
      "technique": 54
    }
  },
  {
    "id": 4150,
    "name": "Globulus Ava",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/a/aa6woqx-od8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 42,
      "control": 57,
      "pressure": 75,
      "agility": 59,
      "physical": 60,
      "technique": 44
    }
  },
  {
    "id": 4151,
    "name": "Elreid Orbes",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/-/m-shlvk0pom.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 44,
      "control": 56,
      "pressure": 71,
      "agility": 55,
      "physical": 70,
      "technique": 50
    }
  },
  {
    "id": 4155,
    "name": "Jabhat Graffias",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/w/-wq7xk5qvi8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 58,
      "control": 40,
      "pressure": 63,
      "agility": 41,
      "physical": 61,
      "technique": 55
    }
  },
  {
    "id": 4156,
    "name": "Lesath Tine",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/f/efjoe5migom.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 43,
      "control": 40,
      "pressure": 67,
      "agility": 42,
      "physical": 69,
      "technique": 57
    }
  },
  {
    "id": 4157,
    "name": "Akram Alvayra",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/3/v34vpgqynbk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 53,
      "control": 54,
      "pressure": 68,
      "agility": 42,
      "physical": 58,
      "technique": 41
    }
  },
  {
    "id": 4158,
    "name": "Calkrab Antares",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/w/tw_zhf40idk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 49,
      "control": 57,
      "pressure": 46,
      "agility": 67,
      "physical": 43,
      "technique": 63
    }
  },
  {
    "id": 4159,
    "name": "Shaula Toxbarb",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/-/c-osqgeolum.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 83,
      "intelligence": 46,
      "control": 60,
      "pressure": 46,
      "agility": 70,
      "physical": 58,
      "technique": 56
    }
  },
  {
    "id": 4160,
    "name": "Res Ord",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/r/8rtn59rgqo8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 45,
      "control": 53,
      "pressure": 64,
      "agility": 52,
      "physical": 60,
      "technique": 48
    }
  },
  {
    "id": 4161,
    "name": "Doro Might",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/5/n5cgucn899u.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 68,
      "control": 77,
      "pressure": 56,
      "agility": 51,
      "physical": 50,
      "technique": 64
    }
  },
  {
    "id": 4162,
    "name": "Craig Chart",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/t/5tjelpoeac8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 49,
      "control": 42,
      "pressure": 40,
      "agility": 63,
      "physical": 44,
      "technique": 52
    }
  },
  {
    "id": 4163,
    "name": "Mesa Bute",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/7/i7s_iwok3xu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 57,
      "control": 52,
      "pressure": 68,
      "agility": 51,
      "physical": 68,
      "technique": 43
    }
  },
  {
    "id": 4164,
    "name": "Sad Sajord",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/t/mtjysxhtwd0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 57,
      "control": 65,
      "pressure": 56,
      "agility": 46,
      "physical": 46,
      "technique": 64
    }
  },
  {
    "id": 4165,
    "name": "Silt Deigan",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/7/x74t_ohx7uc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 43,
      "control": 41,
      "pressure": 48,
      "agility": 69,
      "physical": 41,
      "technique": 56
    }
  },
  {
    "id": 4166,
    "name": "Cord Ratozol",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/u/3ubmstyfoos.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 57,
      "control": 43,
      "pressure": 61,
      "agility": 42,
      "physical": 56,
      "technique": 53
    }
  },
  {
    "id": 4167,
    "name": "Warim Kalkawa",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/8/g8qhbsulj9e.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 46,
      "control": 59,
      "pressure": 60,
      "agility": 66,
      "physical": 53,
      "technique": 62
    }
  },
  {
    "id": 4168,
    "name": "Nomare Lusha",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/d/edtbv1gjm7e.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 58,
      "control": 46,
      "pressure": 51,
      "agility": 66,
      "physical": 45,
      "technique": 64
    }
  },
  {
    "id": 4169,
    "name": "Dry Karwack",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/1/11c6ckgzlis.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 48,
      "control": 47,
      "pressure": 78,
      "agility": 55,
      "physical": 64,
      "technique": 41
    }
  },
  {
    "id": 4170,
    "name": "Nenban Slate",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/a/va_prxv7-oc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 56,
      "control": 50,
      "pressure": 62,
      "agility": 43,
      "physical": 63,
      "technique": 59
    }
  },
  {
    "id": 4171,
    "name": "Wacke Koshra",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/y/kyou8ozbtb0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 59,
      "control": 56,
      "pressure": 61,
      "agility": 46,
      "physical": 78,
      "technique": 58
    }
  },
  {
    "id": 4172,
    "name": "Arenite Serka",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/y/qyx2nlwj0kc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 43,
      "control": 55,
      "pressure": 51,
      "agility": 44,
      "physical": 72,
      "technique": 42
    }
  },
  {
    "id": 4173,
    "name": "Feriando Hidery",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/w/hwaxgawzzx0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 69,
      "control": 69,
      "pressure": 47,
      "agility": 46,
      "physical": 43,
      "technique": 52
    }
  },
  {
    "id": 4174,
    "name": "Foggara Kanart",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/y/vypcot8smcc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 58,
      "control": 45,
      "pressure": 60,
      "agility": 75,
      "physical": 52,
      "technique": 61
    }
  },
  {
    "id": 4175,
    "name": "Flint Heutch",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/w/ew-9jsawlx0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 47,
      "control": 60,
      "pressure": 65,
      "agility": 44,
      "physical": 70,
      "technique": 50
    }
  },
  {
    "id": 4176,
    "name": "Jari Baras",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/f/-fdiwxve-re.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 55,
      "control": 49,
      "pressure": 40,
      "agility": 65,
      "physical": 49,
      "technique": 62
    }
  },
  {
    "id": 4177,
    "name": "Hika Rabeer",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/3/p3spdojktis.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 59,
      "control": 58,
      "pressure": 62,
      "agility": 58,
      "physical": 74,
      "technique": 52
    }
  },
  {
    "id": 4178,
    "name": "Dervan Yorhal",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/w/nwr1zxbiwks.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 46,
      "control": 42,
      "pressure": 57,
      "agility": 75,
      "physical": 55,
      "technique": 55
    }
  },
  {
    "id": 4179,
    "name": "Kudon Kanran",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/-/8-aueo9y7xe.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 64,
      "control": 53,
      "pressure": 56,
      "agility": 57,
      "physical": 46,
      "technique": 58
    }
  },
  {
    "id": 4180,
    "name": "Derika Cachil",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/r/cr5hn1i6o30.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 29,
      "intelligence": 60,
      "control": 52,
      "pressure": 57,
      "agility": 54,
      "physical": 60,
      "technique": 55
    }
  },
  {
    "id": 4181,
    "name": "Gupas Melaka",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/5/t5iagkuajec.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 40,
      "control": 58,
      "pressure": 55,
      "agility": 44,
      "physical": 67,
      "technique": 46
    }
  },
  {
    "id": 4182,
    "name": "Catro Corydoras",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/t/zt3yrhtie70.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 60,
      "control": 59,
      "pressure": 51,
      "agility": 54,
      "physical": 41,
      "technique": 51
    }
  },
  {
    "id": 4183,
    "name": "Tetrae Charlong",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/7/o7g584lypic.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 55,
      "control": 59,
      "pressure": 46,
      "agility": 57,
      "physical": 51,
      "technique": 66
    }
  },
  {
    "id": 4184,
    "name": "Guramki Abantis",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/t/gtd0m5crik8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 51,
      "control": 59,
      "pressure": 52,
      "agility": 67,
      "physical": 60,
      "technique": 60
    }
  },
  {
    "id": 4185,
    "name": "Hatara Tehaze",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/7/37svlgkrlxu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 50,
      "control": 56,
      "pressure": 55,
      "agility": 71,
      "physical": 44,
      "technique": 72
    }
  },
  {
    "id": 4186,
    "name": "Kiroh Beira",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/u/xupgybrjq3k.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 71,
      "control": 66,
      "pressure": 51,
      "agility": 43,
      "physical": 57,
      "technique": 57
    }
  },
  {
    "id": 4187,
    "name": "Uzma Kyallak",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/8/m8-b1k3z9em.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 72,
      "control": 56,
      "pressure": 48,
      "agility": 45,
      "physical": 41,
      "technique": 63
    }
  },
  {
    "id": 4188,
    "name": "Bettas Renden",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/d/kd5db9l14cm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 57,
      "control": 58,
      "pressure": 53,
      "agility": 62,
      "physical": 59,
      "technique": 52
    }
  },
  {
    "id": 4189,
    "name": "Durmali Altos",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/1/v1i82cdpvxk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 30,
      "intelligence": 58,
      "control": 48,
      "pressure": 73,
      "agility": 47,
      "physical": 74,
      "technique": 49
    }
  },
  {
    "id": 4190,
    "name": "Unahr Giil",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/a/1arjlf2hgru.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 42,
      "control": 56,
      "pressure": 40,
      "agility": 63,
      "physical": 57,
      "technique": 70
    }
  },
  {
    "id": 4191,
    "name": "Holsten Leebrook",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/y/eyaoigq9ni8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 43,
      "control": 51,
      "pressure": 74,
      "agility": 57,
      "physical": 61,
      "technique": 54
    }
  },
  {
    "id": 4192,
    "name": "Anky Mo",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/y/wylw5ttfqdu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 75,
      "control": 71,
      "pressure": 53,
      "agility": 47,
      "physical": 60,
      "technique": 51
    }
  },
  {
    "id": 4193,
    "name": "Menoh Seaweed",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/w/bwurus1lhu8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 47,
      "control": 48,
      "pressure": 62,
      "agility": 55,
      "physical": 63,
      "technique": 59
    }
  },
  {
    "id": 4194,
    "name": "Sierra Mone",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/o/9oca3xgvg9m.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 50,
      "control": 52,
      "pressure": 70,
      "agility": 57,
      "physical": 78,
      "technique": 57
    }
  },
  {
    "id": 4195,
    "name": "Piranu Rajelly",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/m/mmzhaogvrok.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 60,
      "control": 40,
      "pressure": 61,
      "agility": 51,
      "physical": 65,
      "technique": 46
    }
  },
  {
    "id": 4196,
    "name": "Claria Leone",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/j/sjquj1vdeuu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 60,
      "control": 58,
      "pressure": 45,
      "agility": 56,
      "physical": 51,
      "technique": 55
    }
  },
  {
    "id": 4197,
    "name": "Umral Seaslug",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/h/dhh1kkznzd8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 51,
      "control": 54,
      "pressure": 42,
      "agility": 63,
      "physical": 56,
      "technique": 72
    }
  },
  {
    "id": 4198,
    "name": "Cherrie Menjikko",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/a/fampkthl2b8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 45,
      "control": 43,
      "pressure": 62,
      "agility": 42,
      "physical": 67,
      "technique": 54
    }
  },
  {
    "id": 4199,
    "name": "Sambas Soya",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/o/uoxinshxbou.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 51,
      "control": 44,
      "pressure": 45,
      "agility": 73,
      "physical": 40,
      "technique": 56
    }
  },
  {
    "id": 4200,
    "name": "Oggris Roya",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/h/oh090xy5uik.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 43,
      "control": 43,
      "pressure": 56,
      "agility": 44,
      "physical": 61,
      "technique": 46
    }
  },
  {
    "id": 4201,
    "name": "Galiaf Satonga",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/v/_vfczoudd7m.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 74,
      "control": 60,
      "pressure": 47,
      "agility": 42,
      "physical": 60,
      "technique": 55
    }
  },
  {
    "id": 4202,
    "name": "Eli Mantary",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/f/lf6eodxhkek.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 66,
      "control": 59,
      "pressure": 50,
      "agility": 52,
      "physical": 49,
      "technique": 55
    }
  },
  {
    "id": 4203,
    "name": "Teodorus Toxsin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/t/6tllf8xbj3m.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 44,
      "control": 57,
      "pressure": 69,
      "agility": 40,
      "physical": 76,
      "technique": 44
    }
  },
  {
    "id": 4204,
    "name": "Minack Sargo",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/f/ufqof94sobs.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 30,
      "intelligence": 50,
      "control": 49,
      "pressure": 69,
      "agility": 55,
      "physical": 57,
      "technique": 43
    }
  },
  {
    "id": 4205,
    "name": "Kazar Kibane",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/t/lthjyceofoe.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 55,
      "control": 40,
      "pressure": 68,
      "agility": 60,
      "physical": 72,
      "technique": 44
    }
  },
  {
    "id": 4206,
    "name": "Doyle Coco",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/c/fcc8hfrgwi0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 54,
      "control": 44,
      "pressure": 50,
      "agility": 59,
      "physical": 54,
      "technique": 60
    }
  },
  {
    "id": 4207,
    "name": "Kreaton Coco",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/q/0qzdmgnad7c.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 57,
      "control": 64,
      "pressure": 46,
      "agility": 52,
      "physical": 48,
      "technique": 50
    }
  },
  {
    "id": 4208,
    "name": "Kanzan Focho",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/l/2l0bi5f2y9c.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 48,
      "control": 42,
      "pressure": 54,
      "agility": 43,
      "physical": 73,
      "technique": 54
    }
  },
  {
    "id": 4209,
    "name": "Hattar Meppo",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/j/hjfgpg5m1o0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 78,
      "control": 58,
      "pressure": 48,
      "agility": 56,
      "physical": 56,
      "technique": 47
    }
  },
  {
    "id": 4210,
    "name": "Ilka Rugar",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/m/nmmvcbmeaue.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 58,
      "control": 59,
      "pressure": 74,
      "agility": 50,
      "physical": 70,
      "technique": 48
    }
  },
  {
    "id": 4211,
    "name": "Jan Suparo",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/k/wkx0xkq-tds.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 48,
      "control": 43,
      "pressure": 51,
      "agility": 64,
      "physical": 60,
      "technique": 62
    }
  },
  {
    "id": 4212,
    "name": "Korum Jintal",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/o/ioosappckie.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 64,
      "control": 71,
      "pressure": 55,
      "agility": 49,
      "physical": 51,
      "technique": 64
    }
  },
  {
    "id": 4213,
    "name": "Perrick Ambin",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/m/tmzntwpmnrs.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 44,
      "control": 51,
      "pressure": 58,
      "agility": 54,
      "physical": 71,
      "technique": 50
    }
  },
  {
    "id": 4214,
    "name": "Hick Idris",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/o/dowgdfltyee.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 69,
      "control": 75,
      "pressure": 60,
      "agility": 51,
      "physical": 44,
      "technique": 59
    }
  },
  {
    "id": 4215,
    "name": "Hashi Bilocco",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/m/smnnugdp13s.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 42,
      "control": 55,
      "pressure": 67,
      "agility": 54,
      "physical": 66,
      "technique": 47
    }
  },
  {
    "id": 4216,
    "name": "Karka Poe",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/j/mjes992haxc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 51,
      "control": 49,
      "pressure": 46,
      "agility": 60,
      "physical": 46,
      "technique": 63
    }
  },
  {
    "id": 4217,
    "name": "Bo Lourdash",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/h/9h1zqcqbtk0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 41,
      "control": 59,
      "pressure": 61,
      "agility": 54,
      "physical": 58,
      "technique": 49
    }
  },
  {
    "id": 4218,
    "name": "Mendry Charbeau",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/a/_ayv-bc3oi0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 46,
      "control": 51,
      "pressure": 59,
      "agility": 60,
      "physical": 72,
      "technique": 54
    }
  },
  {
    "id": 4219,
    "name": "Iyer Zuck",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/o/oodotkknfrc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 41,
      "control": 52,
      "pressure": 72,
      "agility": 48,
      "physical": 68,
      "technique": 54
    }
  },
  {
    "id": 4220,
    "name": "Ugwis Ann",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/h/uhg7a5rfwxs.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 56,
      "control": 42,
      "pressure": 53,
      "agility": 59,
      "physical": 41,
      "technique": 58
    }
  },
  {
    "id": 4221,
    "name": "Hector See",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/v/fvratg3_dce.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 54,
      "control": 71,
      "pressure": 46,
      "agility": 53,
      "physical": 44,
      "technique": 59
    }
  },
  {
    "id": 4222,
    "name": "Men Pukk",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/f/rfuccl0d69s.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 45,
      "control": 51,
      "pressure": 49,
      "agility": 58,
      "physical": 56,
      "technique": 61
    }
  },
  {
    "id": 4223,
    "name": "Mozun Yarne",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/t/atfjx0snxoe.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 56,
      "control": 53,
      "pressure": 71,
      "agility": 50,
      "physical": 73,
      "technique": 50
    }
  },
  {
    "id": 4224,
    "name": "Crow Icarus",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/f/0feur1bu2ik.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 72,
      "control": 64,
      "pressure": 47,
      "agility": 54,
      "physical": 52,
      "technique": 66
    }
  },
  {
    "id": 4225,
    "name": "Silas Kaye",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/t/ft1pgk9ubrm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 42,
      "control": 56,
      "pressure": 50,
      "agility": 57,
      "physical": 73,
      "technique": 55
    }
  },
  {
    "id": 4226,
    "name": "Horton Giess",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/c/lcw6vxicux8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 43,
      "control": 43,
      "pressure": 43,
      "agility": 56,
      "physical": 45,
      "technique": 59
    }
  },
  {
    "id": 4227,
    "name": "Cameron Agura",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/q/uqnb4oumdcu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 57,
      "control": 58,
      "pressure": 43,
      "agility": 56,
      "physical": 49,
      "technique": 67
    }
  },
  {
    "id": 4228,
    "name": "Ewano Bee",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/l/wlghwx8kgeu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 54,
      "control": 46,
      "pressure": 59,
      "agility": 69,
      "physical": 53,
      "technique": 51
    }
  },
  {
    "id": 4229,
    "name": "Tobiah Bragg",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/j/njrm7oawr38.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 52,
      "control": 46,
      "pressure": 82,
      "agility": 42,
      "physical": 76,
      "technique": 44
    }
  },
  {
    "id": 4230,
    "name": "Norritz Ranhatch",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/m/hmytotv4exm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 45,
      "control": 57,
      "pressure": 75,
      "agility": 40,
      "physical": 65,
      "technique": 58
    }
  },
  {
    "id": 4231,
    "name": "Worren Mooram",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/k/2kdyfsjczkk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 47,
      "control": 46,
      "pressure": 45,
      "agility": 74,
      "physical": 53,
      "technique": 71
    }
  },
  {
    "id": 4232,
    "name": "Okai Cosmer",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/o/co8q0hkgubm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 60,
      "control": 41,
      "pressure": 66,
      "agility": 42,
      "physical": 66,
      "technique": 45
    }
  },
  {
    "id": 4233,
    "name": "Elater Clicka",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/m/zmnlzesa5ok.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 40,
      "control": 57,
      "pressure": 58,
      "agility": 56,
      "physical": 52,
      "technique": 62
    }
  },
  {
    "id": 4234,
    "name": "Theraphos Tranchla",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/i/ziy5feyohds.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 47,
      "control": 50,
      "pressure": 42,
      "agility": 66,
      "physical": 50,
      "technique": 64
    }
  },
  {
    "id": 4235,
    "name": "Mantiska Markiry",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/k/okpyohusqwe.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 57,
      "control": 40,
      "pressure": 54,
      "agility": 42,
      "physical": 69,
      "technique": 59
    }
  },
  {
    "id": 4236,
    "name": "Norlan Rikwatta",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/l/ilkt78hafq0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 46,
      "control": 60,
      "pressure": 59,
      "agility": 49,
      "physical": 60,
      "technique": 44
    }
  },
  {
    "id": 4237,
    "name": "Nathanos Hoshten",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/n/5n7mwdhgyjc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 48,
      "control": 59,
      "pressure": 64,
      "agility": 57,
      "physical": 57,
      "technique": 45
    }
  },
  {
    "id": 4238,
    "name": "Aurora Sorker",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/s/7s8q4avm3lc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 41,
      "control": 60,
      "pressure": 51,
      "agility": 51,
      "physical": 52,
      "technique": 59
    }
  },
  {
    "id": 4239,
    "name": "Skoll Pion",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/e/kenxvlz2aw0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 53,
      "control": 56,
      "pressure": 53,
      "agility": 59,
      "physical": 58,
      "technique": 55
    }
  },
  {
    "id": 4240,
    "name": "Edana Naves",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/r/qrueg4g-v2e.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 58,
      "control": 57,
      "pressure": 47,
      "agility": 70,
      "physical": 49,
      "technique": 56
    }
  },
  {
    "id": 4241,
    "name": "Kierry Reese",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/d/bdflrhgecfs.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 55,
      "control": 50,
      "pressure": 42,
      "agility": 53,
      "physical": 52,
      "technique": 67
    }
  },
  {
    "id": 4242,
    "name": "Mitchi Osha",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/p/vpg9akjml6e.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 42,
      "control": 49,
      "pressure": 67,
      "agility": 57,
      "physical": 57,
      "technique": 55
    }
  },
  {
    "id": 4243,
    "name": "Alec Sarker",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/b/ebrc31fcijs.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 59,
      "control": 65,
      "pressure": 49,
      "agility": 47,
      "physical": 59,
      "technique": 68
    }
  },
  {
    "id": 4244,
    "name": "Milo Agrias",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/p/wpkrt0mvplm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 60,
      "control": 54,
      "pressure": 59,
      "agility": 76,
      "physical": 41,
      "technique": 70
    }
  },
  {
    "id": 4245,
    "name": "Herak Lestril",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/b/bb7walqvewk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 43,
      "control": 58,
      "pressure": 63,
      "agility": 43,
      "physical": 75,
      "technique": 40
    }
  },
  {
    "id": 4246,
    "name": "Kagraro Ephemera",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/u/huyftwfnx2u.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 41,
      "control": 42,
      "pressure": 72,
      "agility": 50,
      "physical": 69,
      "technique": 51
    }
  },
  {
    "id": 4247,
    "name": "Amon Boaker",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/g/qgpk-p5dcf8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 55,
      "control": 44,
      "pressure": 61,
      "agility": 59,
      "physical": 66,
      "technique": 53
    }
  },
  {
    "id": 4248,
    "name": "Hugaro Tarlow",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/n/snu4qwrxzd8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 52,
      "control": 54,
      "pressure": 49,
      "agility": 56,
      "physical": 57,
      "technique": 60
    }
  },
  {
    "id": 4249,
    "name": "Hanam Gurry",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/p/jpfz9pnl0wu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 44,
      "control": 47,
      "pressure": 71,
      "agility": 43,
      "physical": 73,
      "technique": 54
    }
  },
  {
    "id": 4250,
    "name": "Ares Zumish",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/g/dg8sus4dbqk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 50,
      "control": 56,
      "pressure": 77,
      "agility": 57,
      "physical": 63,
      "technique": 46
    }
  },
  {
    "id": 4251,
    "name": "Morr Fauche",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/i/yinndte5sjm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 63,
      "control": 73,
      "pressure": 52,
      "agility": 60,
      "physical": 41,
      "technique": 60
    }
  },
  {
    "id": 4252,
    "name": "Gomara Raccamere",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/i/giyvygdblck.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 57,
      "control": 49,
      "pressure": 60,
      "agility": 56,
      "physical": 56,
      "technique": 65
    }
  },
  {
    "id": 4253,
    "name": "Gengo Rowe",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/k/3kd0ff7hmvm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 46,
      "control": 55,
      "pressure": 76,
      "agility": 51,
      "physical": 74,
      "technique": 51
    }
  },
  {
    "id": 4254,
    "name": "Otto Sheveme",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/g/_gt0vkkhcpc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 72,
      "control": 69,
      "pressure": 43,
      "agility": 60,
      "physical": 54,
      "technique": 65
    }
  },
  {
    "id": 4255,
    "name": "Luka Aril",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/i/oicvc1c9va0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 55,
      "control": 53,
      "pressure": 56,
      "agility": 58,
      "physical": 53,
      "technique": 67
    }
  },
  {
    "id": 4256,
    "name": "Anthocia Arnin",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/n/un_gro31a6e.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 58,
      "control": 50,
      "pressure": 63,
      "agility": 44,
      "physical": 63,
      "technique": 49
    }
  },
  {
    "id": 4257,
    "name": "Isor Eshen",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/p/fpob8xrp3js.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 43,
      "control": 51,
      "pressure": 62,
      "agility": 57,
      "physical": 69,
      "technique": 41
    }
  },
  {
    "id": 4258,
    "name": "Terryl Terrid",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/u/dujdsodjyps.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 67,
      "control": 64,
      "pressure": 48,
      "agility": 49,
      "physical": 44,
      "technique": 60
    }
  },
  {
    "id": 4259,
    "name": "Dioxily Bocca",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/g/sg48_xlzf8e.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 74,
      "control": 60,
      "pressure": 50,
      "agility": 43,
      "physical": 47,
      "technique": 60
    }
  },
  {
    "id": 4260,
    "name": "Ribo Som",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/p/mpbjssqrqc0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 58,
      "control": 66,
      "pressure": 43,
      "agility": 53,
      "physical": 53,
      "technique": 67
    }
  },
  {
    "id": 4261,
    "name": "Mag Nessium",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/b/9bqobt2rhvc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 58,
      "control": 41,
      "pressure": 50,
      "agility": 66,
      "physical": 51,
      "technique": 75
    }
  },
  {
    "id": 4262,
    "name": "Brom Hexine",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/r/jrvwwe1jgq0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 58,
      "control": 45,
      "pressure": 41,
      "agility": 68,
      "physical": 44,
      "technique": 69
    }
  },
  {
    "id": 4263,
    "name": "Tau Rin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/d/4dkrdhtznjc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 40,
      "control": 49,
      "pressure": 73,
      "agility": 45,
      "physical": 74,
      "technique": 55
    }
  },
  {
    "id": 4264,
    "name": "Diazo Cabot",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/r/wr_chga6sp8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 40,
      "control": 42,
      "pressure": 65,
      "agility": 42,
      "physical": 76,
      "technique": 59
    }
  },
  {
    "id": 4265,
    "name": "Salicy Lic",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/d/ndo9qf8ab8u.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 53,
      "control": 55,
      "pressure": 47,
      "agility": 60,
      "physical": 46,
      "technique": 58
    }
  },
  {
    "id": 4266,
    "name": "Metha Nol",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/s/hsti5cji0ck.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 72,
      "control": 61,
      "pressure": 45,
      "agility": 59,
      "physical": 57,
      "technique": 60
    }
  },
  {
    "id": 4267,
    "name": "Hemo Globin",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/e/2ecpu9vyzvm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 48,
      "control": 50,
      "pressure": 61,
      "agility": 42,
      "physical": 76,
      "technique": 41
    }
  },
  {
    "id": 4268,
    "name": "Silica Gel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/l/0lb16k9ecpm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 52,
      "control": 43,
      "pressure": 70,
      "agility": 51,
      "physical": 65,
      "technique": 52
    }
  },
  {
    "id": 4269,
    "name": "Golgi Tai",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/n/fnquxbbkxak.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 41,
      "control": 50,
      "pressure": 66,
      "agility": 43,
      "physical": 70,
      "technique": 41
    }
  },
  {
    "id": 4270,
    "name": "Iwers Mogan",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/i/lijheguse6u.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 47,
      "control": 41,
      "pressure": 41,
      "agility": 69,
      "physical": 42,
      "technique": 51
    }
  },
  {
    "id": 4271,
    "name": "Nemy Minimiz",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/k/uk4ap5iwpj8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 61,
      "control": 74,
      "pressure": 57,
      "agility": 49,
      "physical": 40,
      "technique": 56
    }
  },
  {
    "id": 4272,
    "name": "Smeba Myko",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/g/gghyy0l0o2u.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 55,
      "control": 47,
      "pressure": 45,
      "agility": 57,
      "physical": 54,
      "technique": 58
    }
  },
  {
    "id": 4273,
    "name": "Hannah Jarrow",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/i/ri251ltojf8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 68,
      "control": 74,
      "pressure": 59,
      "agility": 45,
      "physical": 58,
      "technique": 50
    }
  },
  {
    "id": 4274,
    "name": "Nactena Naksey",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/g/fg5ybch7cqu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 40,
      "control": 60,
      "pressure": 57,
      "agility": 80,
      "physical": 50,
      "technique": 61
    }
  },
  {
    "id": 4275,
    "name": "Shiro Hatch",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/i/uiit29hbxj8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 71,
      "control": 65,
      "pressure": 45,
      "agility": 42,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4276,
    "name": "Ned Jovan",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/n/onrmlgujedm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 57,
      "control": 45,
      "pressure": 64,
      "agility": 47,
      "physical": 55,
      "technique": 59
    }
  },
  {
    "id": 4277,
    "name": "Holly Mirae",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/p/_pahifyzpwk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 60,
      "control": 59,
      "pressure": 51,
      "agility": 73,
      "physical": 40,
      "technique": 57
    }
  },
  {
    "id": 4278,
    "name": "Niall Rugan",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/u/9udbmggfs2k.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 77,
      "control": 64,
      "pressure": 59,
      "agility": 56,
      "physical": 45,
      "technique": 64
    }
  },
  {
    "id": 4279,
    "name": "Coby Redstone",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/g/mgs6l5glbfm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 57,
      "control": 49,
      "pressure": 54,
      "agility": 71,
      "physical": 41,
      "technique": 62
    }
  },
  {
    "id": 4280,
    "name": "Hawky Turbay",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/p/spppykzt0l8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 56,
      "control": 47,
      "pressure": 50,
      "agility": 66,
      "physical": 56,
      "technique": 59
    }
  },
  {
    "id": 4281,
    "name": "Seth Yinkley",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/b/db-u1bvxzwu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 59,
      "control": 53,
      "pressure": 41,
      "agility": 64,
      "physical": 59,
      "technique": 54
    }
  },
  {
    "id": 4282,
    "name": "Ricky Regomen",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/r/prb2eww1-p8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 30,
      "intelligence": 47,
      "control": 42,
      "pressure": 74,
      "agility": 54,
      "physical": 68,
      "technique": 60
    }
  },
  {
    "id": 4283,
    "name": "Shawby Ehan",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/d/ydwxppwptau.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 42,
      "control": 50,
      "pressure": 75,
      "agility": 46,
      "physical": 64,
      "technique": 54
    }
  },
  {
    "id": 4284,
    "name": "Moka Rimmer",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/r/2rrazo5gy20.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 59,
      "control": 59,
      "pressure": 63,
      "agility": 52,
      "physical": 62,
      "technique": 46
    }
  },
  {
    "id": 4285,
    "name": "Honena Sisson",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/d/hda7exf8ffc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 43,
      "control": 44,
      "pressure": 63,
      "agility": 59,
      "physical": 59,
      "technique": 59
    }
  },
  {
    "id": 4286,
    "name": "Yolanda Umick",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/s/ns5onkq0qls.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 55,
      "control": 46,
      "pressure": 58,
      "agility": 53,
      "physical": 66,
      "technique": 44
    }
  },
  {
    "id": 4287,
    "name": "Gieve & Tik",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/e/weivg1mohwe.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 56,
      "control": 51,
      "pressure": 57,
      "agility": 56,
      "physical": 55,
      "technique": 63
    }
  },
  {
    "id": 4288,
    "name": "Tippi & Tappa",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/l/ulpzoseicqe.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 50,
      "control": 40,
      "pressure": 52,
      "agility": 68,
      "physical": 57,
      "technique": 51
    }
  },
  {
    "id": 4289,
    "name": "Tog Romack",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/n/ln-sjt4yvjs.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 66,
      "control": 56,
      "pressure": 47,
      "agility": 44,
      "physical": 49,
      "technique": 64
    }
  },
  {
    "id": 4290,
    "name": "Elu Suay",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/i/fidnwonqadc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 56,
      "control": 59,
      "pressure": 52,
      "agility": 45,
      "physical": 58,
      "technique": 65
    }
  },
  {
    "id": 4291,
    "name": "Thor Nado",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/k/0ksgdxrq3w0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 45,
      "control": 49,
      "pressure": 74,
      "agility": 47,
      "physical": 54,
      "technique": 47
    }
  },
  {
    "id": 4292,
    "name": "Eas Tarmo",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/g/agtes8oiqpc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 43,
      "control": 55,
      "pressure": 71,
      "agility": 43,
      "physical": 55,
      "technique": 58
    }
  },
  {
    "id": 4293,
    "name": "Maneuver Gibbs",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/i/xii_bdoy980.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 47,
      "control": 40,
      "pressure": 60,
      "agility": 63,
      "physical": 45,
      "technique": 51
    }
  },
  {
    "id": 4294,
    "name": "Croy Roy",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/2/n20uig948ve.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 59,
      "control": 60,
      "pressure": 60,
      "agility": 58,
      "physical": 68,
      "technique": 42
    }
  },
  {
    "id": 4295,
    "name": "Kaven Mirae",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/e/8efpp5bcrcs.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 52,
      "control": 60,
      "pressure": 75,
      "agility": 43,
      "physical": 72,
      "technique": 44
    }
  },
  {
    "id": 4296,
    "name": "Hugh Semburn",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/x/cxm6ckukk8c.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 48,
      "control": 60,
      "pressure": 65,
      "agility": 40,
      "physical": 70,
      "technique": 53
    }
  },
  {
    "id": 4297,
    "name": "Tage Hamley",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/z/tzxbxbiwjp0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 73,
      "control": 61,
      "pressure": 40,
      "agility": 44,
      "physical": 60,
      "technique": 62
    }
  },
  {
    "id": 4298,
    "name": "Jomon Dorg",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/4/v4qhfcacmj0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 49,
      "control": 45,
      "pressure": 59,
      "agility": 60,
      "physical": 50,
      "technique": 63
    }
  },
  {
    "id": 4299,
    "name": "Tanky Hanson",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/q/eqhmy98mh6c.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 43,
      "control": 57,
      "pressure": 58,
      "agility": 59,
      "physical": 41,
      "technique": 62
    }
  },
  {
    "id": 4300,
    "name": "Manny Armal",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/_/-_cthgjuuas.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 54,
      "control": 41,
      "pressure": 50,
      "agility": 66,
      "physical": 41,
      "technique": 63
    }
  },
  {
    "id": 4301,
    "name": "Kohen Moak",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/x/pxzymfvu5pe.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 54,
      "control": 53,
      "pressure": 60,
      "agility": 43,
      "physical": 58,
      "technique": 59
    }
  },
  {
    "id": 4302,
    "name": "Mikala Datasby",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/9/79mq9ss2ews.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 46,
      "control": 58,
      "pressure": 65,
      "agility": 54,
      "physical": 78,
      "technique": 45
    }
  },
  {
    "id": 4303,
    "name": "Geoff Nory",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/v/kv9lqtkmzle.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 42,
      "control": 51,
      "pressure": 58,
      "agility": 74,
      "physical": 54,
      "technique": 56
    }
  },
  {
    "id": 4304,
    "name": "Solton Benvan",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/9/k9mgksdfsjk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 51,
      "control": 59,
      "pressure": 61,
      "agility": 42,
      "physical": 70,
      "technique": 53
    }
  },
  {
    "id": 4305,
    "name": "Sylvany Igan",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/v/vvxnntl__6m.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 46,
      "control": 47,
      "pressure": 79,
      "agility": 58,
      "physical": 62,
      "technique": 60
    }
  },
  {
    "id": 4306,
    "name": "Josina Mary",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/6/160s0oq3ka8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 54,
      "control": 40,
      "pressure": 69,
      "agility": 50,
      "physical": 74,
      "technique": 46
    }
  },
  {
    "id": 4307,
    "name": "Senna Regan",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/s/esfzzx2nnpu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 56,
      "control": 53,
      "pressure": 68,
      "agility": 53,
      "physical": 62,
      "technique": 53
    }
  },
  {
    "id": 4308,
    "name": "Nico Burz",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/z/gzcv3okhivu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 56,
      "control": 53,
      "pressure": 68,
      "agility": 40,
      "physical": 72,
      "technique": 41
    }
  },
  {
    "id": 4309,
    "name": "Concord Rigan",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/b/3bzoaxcbpc8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 58,
      "control": 62,
      "pressure": 41,
      "agility": 53,
      "physical": 60,
      "technique": 53
    }
  },
  {
    "id": 4310,
    "name": "Iwan Gahana",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/0/x0q7jk3t68m.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 55,
      "control": 42,
      "pressure": 67,
      "agility": 52,
      "physical": 69,
      "technique": 56
    }
  },
  {
    "id": 4311,
    "name": "Seyon Shore",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/c/mchak1rpxpk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 43,
      "control": 46,
      "pressure": 67,
      "agility": 59,
      "physical": 61,
      "technique": 46
    }
  },
  {
    "id": 4312,
    "name": "Bennet Goodacre",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/2/s2ecv4slwwm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 53,
      "control": 64,
      "pressure": 57,
      "agility": 47,
      "physical": 42,
      "technique": 68
    }
  },
  {
    "id": 4313,
    "name": "Bunash Magee",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/e/jevj4h0xddk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 43,
      "control": 44,
      "pressure": 62,
      "agility": 59,
      "physical": 50,
      "technique": 44
    }
  },
  {
    "id": 4314,
    "name": "Tri & Trot",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/2/t2gowoeeiwm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 40,
      "control": 42,
      "pressure": 43,
      "agility": 63,
      "physical": 56,
      "technique": 62
    }
  },
  {
    "id": 4315,
    "name": "Luvy & Duvy",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/e/cerj7x4-plk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 42,
      "control": 54,
      "pressure": 62,
      "agility": 57,
      "physical": 75,
      "technique": 43
    }
  },
  {
    "id": 4316,
    "name": "Uni & Sync",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/x/8xy8osn26fu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 41,
      "control": 57,
      "pressure": 59,
      "agility": 66,
      "physical": 43,
      "technique": 56
    }
  },
  {
    "id": 4317,
    "name": "Dotmar Tricks",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/z/nzddftrmx28.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 48,
      "control": 47,
      "pressure": 57,
      "agility": 68,
      "physical": 55,
      "technique": 59
    }
  },
  {
    "id": 4318,
    "name": "Shuse Keylor",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/4/p4ebrk5gsw8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 57,
      "control": 60,
      "pressure": 55,
      "agility": 53,
      "physical": 53,
      "technique": 60
    }
  },
  {
    "id": 4319,
    "name": "Mony Tarling",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/q/-q1gg1fa_du.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 53,
      "control": 45,
      "pressure": 69,
      "agility": 42,
      "physical": 69,
      "technique": 48
    }
  },
  {
    "id": 4320,
    "name": "Tech Nobit",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/_/e_wvvoqskjk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 54,
      "control": 41,
      "pressure": 71,
      "agility": 56,
      "physical": 64,
      "technique": 40
    }
  },
  {
    "id": 4321,
    "name": "Tsum Jicker",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/x/vxn04xmonqm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 56,
      "control": 51,
      "pressure": 67,
      "agility": 47,
      "physical": 67,
      "technique": 43
    }
  },
  {
    "id": 4322,
    "name": "Sofu Tokrim",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/9/b9ysjapkavk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 55,
      "control": 56,
      "pressure": 48,
      "agility": 47,
      "physical": 58,
      "technique": 46
    }
  },
  {
    "id": 4323,
    "name": "Jigo Jetok",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/v/qvpnklpwtcm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 57,
      "control": 59,
      "pressure": 80,
      "agility": 49,
      "physical": 63,
      "technique": 56
    }
  },
  {
    "id": 4324,
    "name": "Ducksquiggan Barboyle",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/o/rol3fvxefuu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 43,
      "control": 48,
      "pressure": 43,
      "agility": 73,
      "physical": 56,
      "technique": 52
    }
  },
  {
    "id": 4325,
    "name": "Ducksquiggan Carboyle",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/h/lhocwiemwok.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 71,
      "control": 64,
      "pressure": 43,
      "agility": 48,
      "physical": 59,
      "technique": 58
    }
  },
  {
    "id": 4326,
    "name": "Ducksquiggan Tarboyle",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/v/6vzj73i2d9m.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 50,
      "control": 53,
      "pressure": 76,
      "agility": 43,
      "physical": 63,
      "technique": 50
    }
  },
  {
    "id": 4327,
    "name": "Ducksquiggan Zarboyle",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/o/4oe_vuway7m.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 44,
      "control": 42,
      "pressure": 61,
      "agility": 49,
      "physical": 63,
      "technique": 49
    }
  },
  {
    "id": 4328,
    "name": "Ducksquiggan Garboyle",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/m/jmve4rwg1ik.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 45,
      "control": 51,
      "pressure": 67,
      "agility": 59,
      "physical": 70,
      "technique": 55
    }
  },
  {
    "id": 4329,
    "name": "Ken Park",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/9/e9ya-kg5mws.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 42,
      "control": 47,
      "pressure": 74,
      "agility": 47,
      "physical": 59,
      "technique": 47
    }
  },
  {
    "id": 4330,
    "name": "Ezra Gin",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/v/1vdhtbgdhde.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 57,
      "control": 43,
      "pressure": 61,
      "agility": 44,
      "physical": 60,
      "technique": 59
    }
  },
  {
    "id": 4331,
    "name": "Silva Gin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/6/v6guagzluj0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 40,
      "control": 57,
      "pressure": 59,
      "agility": 42,
      "physical": 59,
      "technique": 52
    }
  },
  {
    "id": 4332,
    "name": "Argus Gin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/s/ksr1t5vx5qc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 43,
      "control": 46,
      "pressure": 63,
      "agility": 45,
      "physical": 56,
      "technique": 57
    }
  },
  {
    "id": 4333,
    "name": "Micah Gin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/z/mzwpdghd8wc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 50,
      "control": 54,
      "pressure": 68,
      "agility": 49,
      "physical": 78,
      "technique": 47
    }
  },
  {
    "id": 4334,
    "name": "Maxter Gin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/b/xbniufhnrl0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 49,
      "control": 60,
      "pressure": 75,
      "agility": 59,
      "physical": 55,
      "technique": 41
    }
  },
  {
    "id": 4335,
    "name": "Casey Gin",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/0/30e99cuvkfe.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 67,
      "control": 64,
      "pressure": 58,
      "agility": 56,
      "physical": 58,
      "technique": 64
    }
  },
  {
    "id": 4336,
    "name": "Consy Gin",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/c/gc1cq9yvj2s.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 70,
      "control": 69,
      "pressure": 50,
      "agility": 45,
      "physical": 46,
      "technique": 71
    }
  },
  {
    "id": 4337,
    "name": "Shari Gin",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/2/y2kehwx3uje.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 75,
      "control": 50,
      "pressure": 55,
      "agility": 48,
      "physical": 42,
      "technique": 73
    }
  },
  {
    "id": 4338,
    "name": "Colin Gin",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/e/de7lmpxnd6s.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 53,
      "control": 46,
      "pressure": 42,
      "agility": 65,
      "physical": 56,
      "technique": 61
    }
  },
  {
    "id": 4339,
    "name": "Nathas Gin",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/a/pauxqpj_9rk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 40,
      "control": 46,
      "pressure": 52,
      "agility": 71,
      "physical": 51,
      "technique": 70
    }
  },
  {
    "id": 4340,
    "name": "Zane Gin",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/y/yyf29wvfqim.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 45,
      "control": 55,
      "pressure": 56,
      "agility": 60,
      "physical": 57,
      "technique": 59
    }
  },
  {
    "id": 4360,
    "name": "Tem Akirrol",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/g/qgralqhw6g8.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 26,
      "intelligence": 57,
      "control": 46,
      "pressure": 70,
      "agility": 47,
      "physical": 69,
      "technique": 57
    }
  },
  {
    "id": 4361,
    "name": "Barton Combo",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/u/hug7mvhkx1u.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 76,
      "control": 63,
      "pressure": 44,
      "agility": 59,
      "physical": 57,
      "technique": 73
    }
  },
  {
    "id": 4362,
    "name": "Nio Rentall",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/b/bbdo1iycivk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 40,
      "control": 57,
      "pressure": 46,
      "agility": 65,
      "physical": 52,
      "technique": 57
    }
  },
  {
    "id": 4363,
    "name": "Biffy Sausse",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/p/wpyvy3u4pmm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 51,
      "control": 52,
      "pressure": 63,
      "agility": 51,
      "physical": 60,
      "technique": 46
    }
  },
  {
    "id": 4364,
    "name": "Hubert Iger",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/i/yi1z2ugukgm.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 50,
      "control": 49,
      "pressure": 50,
      "agility": 72,
      "physical": 53,
      "technique": 50
    }
  },
  {
    "id": 4365,
    "name": "Thorin Kards",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/g/dgesbrguntk.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 29,
      "intelligence": 52,
      "control": 41,
      "pressure": 67,
      "agility": 52,
      "physical": 60,
      "technique": 56
    }
  },
  {
    "id": 4366,
    "name": "Haniwa Pawlo",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/p/jpnnimvmszu.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 40,
      "control": 53,
      "pressure": 69,
      "agility": 49,
      "physical": 65,
      "technique": 52
    }
  },
  {
    "id": 4367,
    "name": "Nathan Adams",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/g/pg728uod2z0.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 60,
      "control": 61,
      "pressure": 50,
      "agility": 49,
      "physical": 59,
      "technique": 71
    }
  },
  {
    "id": 4368,
    "name": "Katie Forester",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/u/-ukxrro5bqc.png",
    "game": [
      "Inazuma Eleven GO Galaxy"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 74,
      "control": 58,
      "pressure": 44,
      "agility": 58,
      "physical": 49,
      "technique": 55
    }
  },
  {
    "id": 4375,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4375,
    "name": "Sonny Wright",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/w/swel73jmr2c.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4376,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4376,
    "name": "Basile Hardy",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/5/m5nqoq8uews.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4377,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4377,
    "name": "Adriano Donati",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/r/9rwxfvauzle.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4378,
    "name": "Sandra Fischer",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/w/_wrtrmi42je.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4378,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4379,
    "name": "Kiko Calavento",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/y/oygmgzucbqs.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4379,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4380,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4380,
    "name": "César Montalbán",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/3/u3d5vubkuwc.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4381,
    "name": "Maxime Dassier",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/f/ffyy4r9wdd0.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4381,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4382,
    "name": "Trevor Cook",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/1/r1najc-sk8c.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4382,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4383,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4383,
    "name": "Cliff Parker",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/d/ad8hkjyojp0.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4384,
    "name": "Valentin Eisner",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/1/01ns-irhoju.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4384,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4385,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4385,
    "name": "Nino Nango",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/d/fdwntd3bfq8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4386,
    "name": "Mister Yi",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/x/vxsjctiezes.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4386,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4387,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4387,
    "name": "Li Kobun",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/l/tljfqmotmw0.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4388,
    "name": "Dean Rush",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/_/e_joxsu-03e.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4388,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4389,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4389,
    "name": "Regina Mulgrave",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/4/p4x8po9mskc.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4390,
    "name": "Aurelia Dingle",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/4/v4l67gewydu.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4390,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4391,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4391,
    "name": "Mickey Way",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/q/zqth4tmtm6k.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4392,
    "name": "Larry Lyre",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/c/cccavsaxljm.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4392,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4393,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4393,
    "name": "Cygnus Starkey",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/q/sqhnptjeqls.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4394,
    "name": "Ari Zimmerman",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/c/dc2sisvkhwe.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4394,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4395,
    "name": "Acker Reese",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/o/poj0tfsggps.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4395,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4396,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4396,
    "name": "Jimmy Nigh",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/a/ya4v-gk8nae.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4397,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4397,
    "name": "Caesar Pike",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/v/4vbgt9_0460.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4398,
    "name": "Oliver Golightly",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/h/jhqbaczovjc.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4398,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4399,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4399,
    "name": "Oscar Pio",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/m/lmtdubliqpc.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4400,
    "name": "Eddy O'Ryan",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/o/6oc8dkty980.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4400,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4401,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4401,
    "name": "Elliot Ember",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/h/ah_jq5yqice.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4402,
    "name": "Jude Sharp",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/f/tfourotltau.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4402,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4403,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4403,
    "name": "Holt Northam",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/t/it_1gx1f-p8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4404,
    "name": "Braveon Halvors",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/m/gm4poonz7v8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4404,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4405,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4405,
    "name": "Konrad Hardin",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/k/rkjifxbjwcu.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4406,
    "name": "Aren Yarrow",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/l/xlq9wk0bj8k.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4406,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4407,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4407,
    "name": "Percival Travis",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/v/1v2c3fcvfxk.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4408,
    "name": "Dominic Hewitt",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/9/e9h9agkvykm.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4408,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4409,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4409,
    "name": "Celia Hills",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/2/n2btgc5uc7k.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4410,
    "name": "Duske Grayling",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/r/graq5qx3ije.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4410,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4411,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4411,
    "name": "Solomon Owle",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/5/35rluvxnp6s.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4412,
    "name": "Oleander Meadows",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/w/ewd2xzfbnpe.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4412,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4413,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4413,
    "name": "Piers Thornton",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/d/-dawvi64u88.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4414,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4414,
    "name": "Bud Bloome",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/1/p1r3cdcc5pu.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4415,
    "name": "Reid Rivers",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/1/q1bb1jzx1qc.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4415,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4416,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4416,
    "name": "Willow Proude",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/d/hdw6ycvlyj0.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4417,
    "name": "Wolfe Redwood",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/3/v3piprwp_cc.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4417,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4418,
    "name": "Raven Vale",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/f/kf-deuwtsv0.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4418,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4419,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4419,
    "name": "Heath Moore",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/-/m-5fq3i_xp0.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4420,
    "name": "Leif Bolt",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/y/1ysx6mjhk8s.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4420,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4421,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4421,
    "name": "Lucian Skye",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/a/vaicrapkmvk.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4422,
    "name": "Solren Dawnwright",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/y/ey5j8_pwhcm.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4422,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4423,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4423,
    "name": "Elior March",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/t/ct-_smdckam.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4424,
    "name": "Raylon Highmoor",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/7/t7pe_z7mjpk.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4424,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4425,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4425,
    "name": "Fedrin Fennley",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/u/nusrseou8ju.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4426,
    "name": "Curt Gale",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/s/kskij9rdhe8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4426,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4427,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4427,
    "name": "Knox Loxley",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/7/c7wirtsod28.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4428,
    "name": "Björn Brocken",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/t/strvlsbhiac.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4428,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4429,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4429,
    "name": "Lunk Ironbrow",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/-/w-spzdkkrpk.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4430,
    "name": "Hefton Bulk",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/f/ufrtda2iuvk.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4430,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4431,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4431,
    "name": "Barry Cade",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/t/ztbd8s00ufu.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4432,
    "name": "Rick Wall",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/3/l3aywlqy5cm.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4432,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4433,
    "name": "Ivor Shield",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/r/2rp6gerskju.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4433,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4434,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4434,
    "name": "Rocky Hardcastle",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/y/fy5hj4l6m88.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4435,
    "name": "Waldo Gibbons",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/7/d7aomt99pp0.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4435,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4436,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4436,
    "name": "Sebastian Fortwright",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/5/h5-bnh3wj68.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4437,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4437,
    "name": "Iggy Motte",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/w/nwdue8ce8am.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4438,
    "name": "Jack Wallside",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/8/m8iaypupx6s.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4438,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4439,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4439,
    "name": "Corbin Brickham",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/u/9u571wi16je.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4440,
    "name": "Helena Harwood",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/1/_1-nbpaz_pe.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4440,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4441,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4441,
    "name": "Dane Upchurch",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/d/odpg2w8js8s.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4442,
    "name": "Warden Watchford",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/y/uyszlljrncc.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4442,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4443,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4443,
    "name": "Fortnum Pile",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/q/hqqxvp0fni8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4444,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4444,
    "name": "Skinner Lankley",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/4/q4bq4ws_g7u.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4445,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4445,
    "name": "Bastiana Chateau",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/6/v6vpkc3nq3u.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4446,
    "name": "Trice Topper",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/j/bjb4ky4xjv8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4446,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4447,
    "name": "Malcolm Night",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/m/7m4n3vn5wpm.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4447,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4448,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4448,
    "name": "Alfred Meenan",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/o/kojsaqrd78k.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4449,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4449,
    "name": "Dan Mirthful",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/k/-k20rdohcdm.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4450,
    "name": "Ricky Clover",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/m/pmhvgiobxwk.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4450,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4451,
    "name": "Toby Damian",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/k/hkcycjhsqce.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4451,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4452,
    "name": "York Nashmith",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/m/qmt5xcho9vs.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4452,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4453,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4453,
    "name": "Zachary Moore",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/j/wjomibugipc.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4454,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4454,
    "name": "Marvin Murdock",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/o/zockkrqdmp8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4455,
    "name": "Thomas Murdock",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/a/oatfnumnlau.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4455,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4456,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4456,
    "name": "Tyler Murdock",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/h/qhqzjnelocu.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4457,
    "name": "Axel Blaze",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/h/5h_rz2fvtjm.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4457,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4458,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4458,
    "name": "Hilary Prentice",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/l/bl_tp-yal80.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4459,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4459,
    "name": "Jodi Green",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/q/dq4xhng2g60.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4460,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4460,
    "name": "Seth Nichols",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/b/obsfjtpe9xu.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4461,
    "name": "Lynn Tambelle",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/z/5zj4qascod0.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4461,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4462,
    "name": "Gideon Poe",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/w/pwe9y4ojwju.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4462,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4463,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4463,
    "name": "Harry Leading",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/f/vfnihl7rfdk.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4464,
    "name": "Terry Stronger",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/3/e3wpmadrowm.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4464,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4465,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4465,
    "name": "Philip Marvel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/w/cwr1idp9t2m.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4466,
    "name": "Noel Good",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/-/t-gup8phafk.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4466,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4467,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4467,
    "name": "Electra Faraday",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/r/nrdhchcp1lu.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4468,
    "name": "Francis Tell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/5/85yaxe61yw8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4468,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4469,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4469,
    "name": "Darren Gouger",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/t/itnyat5x_pu.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4470,
    "name": "Jonathan Seller",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/7/5785tsftsa8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4471,
    "name": "Victor Kind",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/t/xtn03twkz2c.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4472,
    "name": "Neil Turner",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/7/m7wvasweef0.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4473,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4474,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4476,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4477,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4478,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4479,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4480,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4481,
    "name": "Des Pott",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/b/ib4z9lk4juc.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4481,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4482,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4482,
    "name": "Jethro Mackin",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/x/8xhbmojaer0.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4483,
    "name": "Joseph King",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/v/zvcri20mvwk.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4483,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4484,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4484,
    "name": "Peter Drent",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/o/ioq_2un-3f8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4485,
    "name": "Ben Simmons",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/j/gjxjyn1syd8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4485,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4486,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4486,
    "name": "Alan Master",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/h/rhmc1ytofwu.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4487,
    "name": "Gus Martin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/o/xof3mvmgqqk.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4487,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4488,
    "name": "Herman Waldon",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/m/am0wlqaahjm.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4488,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4489,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4489,
    "name": "John Bloom",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/m/0mlo6dd4gck.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4490,
    "name": "Derek Swing",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/k/fk6vxilcnvm.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4491,
    "name": "Daniel Hatch",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/m/rmhinjslsds.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4491,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4492,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4492,
    "name": "David Samford",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/a/tahebrbea2u.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4493,
    "name": "Nathan Swift",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/l/6lz2zb_50q0.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4494,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4495,
    "name": "Grotley Bogwash",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/j/ljcxe-zdzjc.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4495,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4496,
    "name": "Caleb Stonewall",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/k/akqdgckxbwe.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4496,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4497,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4498,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4499,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4500,
    "name": "Ray Dark",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/_/-_3ufkncqom.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4500,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4501,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4501,
    "name": "Emperio N. Guinn",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/e/cek0f18sxxe.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4502,
    "name": "Ross Siddon",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/f/afwvwmrmwd8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4502,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4503,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4503,
    "name": "Apollo Light",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/t/rtno7zncduu.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4504,
    "name": "Hadrian Diesel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/m/pmgsvafwyou.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4504,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4505,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4505,
    "name": "Lane War",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/k/ykrz4_5k1b8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4506,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4506,
    "name": "Danny Wood",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/l/4lygrimca7m.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4507,
    "name": "Artie Mishman",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/j/jjdngdq4tik.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4507,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4508,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4508,
    "name": "Arion Matlock",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/j/9j8_3qpak3m.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4509,
    "name": "Wesley Knox",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/h/mhneavpgnek.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4509,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4510,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4510,
    "name": "Jonas Demetrius",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/j/ijwtaugpgoe.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4511,
    "name": "Byron Love",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/q/6q1af7euf9m.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4511,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4512,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4512,
    "name": "Percy Hurst",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/h/thnytrgtrbs.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4513,
    "name": "Deirdre Staples",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/z/mzjunkdxcc8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4513,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4514,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4514,
    "name": "Alexander Scrivener",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/b/xbs1kbllvxu.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4515,
    "name": "Adam Ropes",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/w/ewqf6g8gzd0.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4515,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4516,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4516,
    "name": "Joaquine Downtown",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/-/w-ligh1p4xu.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4517,
    "name": "Milton Bindings",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/8/18fx8tqxy9u.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4517,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4518,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4518,
    "name": "Spike Gleeson",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/-/v-hkxfa80uc.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4519,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4519,
    "name": "Sean Snowfield",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/w/bw6pnet1vc8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4520,
    "name": "Kerry Bootgaiter",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/7/k7xlcxdlqum.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4520,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4521,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4521,
    "name": "Maddox Rock",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/u/eu0qrs2tfo8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4522,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4522,
    "name": "Robert Skipolson",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/t/vtmevolfhdk.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4523,
    "name": "Shawn Froste",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/1/g1zm_1kbai8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4523,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4524,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4524,
    "name": "Aiden Froste",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/a/maq5sorjvom.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4525,
    "name": "Quentin Rackner",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/r/prcrecv0bos.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4525,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4526,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4526,
    "name": "Roland Climbstein",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/y/xyhybx3zcbk.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4527,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4527,
    "name": "Bunny Cottontail",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/5/-5zwp9jos9e.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4528,
    "name": "Kevin Dragonfly",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/y/8y0shkbip7e.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4528,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4529,
    "name": "Robert Cottontail",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/0/30xazgqdark.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4529,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4530,
    "name": "Mila Simmering",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/c/gcah05253im.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4530,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4531,
    "name": "Dave Quagmire",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/v/sv5c5do761u.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4531,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4532,
    "name": "Grant Icewater",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/q/nqpdszxik1e.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4532,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4533,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4533,
    "name": "Claire Lesnow",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/4/w4-ibmxyjgs.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4534,
    "name": "Jordan Greenway",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/0/u0-exe6x_zu.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4534,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4535,
    "name": "Ben Blowton",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/4/j4uo2y4rfzk.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4535,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4536,
    "name": "Isabelle Trick",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/9/d9ijuiobxg8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4536,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4537,
    "name": "Nigel August",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/q/4qlvbneroqm.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4537,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4538,
    "name": "Claude Beacons",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/6/m6a3qadzpvk.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4538,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4539,
    "name": "Bryce Whitingale",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/s/9srwh_7jimm.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4539,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4540,
    "name": "Hunter Foster",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/z/_zskpmplngm.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4540,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4541,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4541,
    "name": "Xavier Schiller",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/c/fcp_67ctsa8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4542,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4542,
    "name": "Ronny Metcalf",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/_/h_s2_ueqrv0.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4543,
    "name": "Zeke Valanche",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/e/ferqr3wgut0.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4543,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4544,
    "name": "Bonnie Sparks",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/x/2xdxsriq8mc.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4544,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4545,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4545,
    "name": "Aquilina Schiller",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/q/equbw54kfu8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4546,
    "name": "Mark Evans",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/d/jdjpa1mcn1m.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4546,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4547,
    "name": "Billy Miller",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/s/dsqctotk4v8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4547,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4548,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4548,
    "name": "Jack Sawyer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/l/wlchqoncqgu.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4549,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4549,
    "name": "Meriwether Beaumont",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/p/bpjvw9ln7a0.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4550,
    "name": "Burleigh Carpenter",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/n/qn407ct3wzc.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4550,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4551,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4551,
    "name": "Luke Blank",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/r/sr4itka4ggk.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4552,
    "name": "Gaffer Mason",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/p/epj5hdk-3f8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4552,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4553,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4553,
    "name": "Dan Bowsun",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/n/1nsym8ceasu.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4554,
    "name": "Giles Farmer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/n/bnta9xbm9t8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4554,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4555,
    "name": "Pacey Hawker",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/i/hio1us0uizm.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4555,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4556,
    "name": "Neville Merchant",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/k/qk_udtsulak.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4556,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4557,
    "name": "Kia Tanner",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/i/kibbofy_jts.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4557,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4558,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4559,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4559,
    "name": "Eamond Everwing",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/g/7gqgfg-foge.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4560,
    "name": "Frey Fielding",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/b/5bt8r5splme.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4560,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4561,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4561,
    "name": "Tobin Harveston",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/p/ipcdggktmvs.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4562,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4562,
    "name": "Everest Brightwell",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/g/og_ovb_bt1c.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4563,
    "name": "Seymour Hillman",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/x/cxth4gqmao8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4563,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4564,
    "name": "Silvia Woods",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/z/tzimvfmc3bu.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4564,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4565,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4565,
    "name": "Tod Ironside",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/9/m9e4oddigq8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4566,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4566,
    "name": "Steve Grim",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/0/v0yfr730ufu.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4567,
    "name": "Maxwell Carson",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/b/1brw4mc8b_k.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4567,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4568,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4568,
    "name": "Tim Saunders",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/v/xv1zfilyrzu.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4569,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4569,
    "name": "Sam Kincaid",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/4/y4yvkn1iu1k.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4570,
    "name": "Jim Wraith",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/s/gsnn7a2qzkm.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4570,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4571,
    "name": "William Glass",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/c/kcdkgerods8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4571,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4572,
    "name": "Erik Eagle",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/6/36wsw_qqe5k.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4572,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4573,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4573,
    "name": "Bobby Shearer",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/q/dqp0nyty5gm.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4574,
    "name": "Salvador Castell",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/p/gpfoqcguqs0.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4574,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4575,
    "name": "Antoni Valls",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/n/rn0vh9guhfc.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4575,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4576,
    "name": "Jordi Belloch",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/p/_pvid8pdmz8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4576,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4577,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4577,
    "name": "Gerard Carbonell",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/n/onedwdpnlau.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4578,
    "name": "Carles Ripoll",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/n/6nhbbomfs_8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4579,
    "name": "Josep Anglesola",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/l/llq6sxq_bmu.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4580,
    "name": "Xavi Casals",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/k/rkzp_sf30sk.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4581,
    "name": "Ronaldo Ramallets",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/i/aicust5nzfm.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4582,
    "name": "Leo Segarra",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/d/ydfy8krhczm.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4583,
    "name": "Sergi Hernández",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/e/jexmco4teku.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4584,
    "name": "Joan Asensi",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/r/pr0tr1nbxqk.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4585,
    "name": "Augusto Gomez",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/g/agm75fzmfme.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4586,
    "name": "Geraldo Enrique",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/i/xixaugvcy_s.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4587,
    "name": "Alessio Ganonti",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/x/pxgpobr4h9k.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4594,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4595,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4596,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4597,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4598,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4599,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4600,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4601,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4602,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4603,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4604,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4604,
    "name": "Griffit Valiance",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/k/gkqeanupja0.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4605,
    "name": "Wryn Twincrest",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/l/aljxj6hhwge.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4605,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4606,
    "name": "Aurel Ashdown",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/n/xn4qkfh97ts.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4606,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4607,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4607,
    "name": "Corwin Lumen",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/s/zs_mkcvr-vs.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4608,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4608,
    "name": "Garvin Cliffmarch",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/e/ceotnjzrtme.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4609,
    "name": "Corin Cainver",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/r/irty0-gjmg0.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4609,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4610,
    "name": "Orphion Ordain",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/d/tdc5zbgzl1c.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4611,
    "name": "Aveline Morrin",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/p/npjhomj7sk0.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4612,
    "name": "Therion Daywick",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/b/wbsafzfbb5c.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4613,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4613,
    "name": "Alaric Durnham",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/p/4pjnfymigv8.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4614,
    "name": "Galad Worden",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/b/jb4synqynmu.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4614,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4615,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4615,
    "name": "Sylvar Verdis",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/u/pubzhqf64gk.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4616,
    "name": "Plumian Whitlock",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/g/ygq4mv5av1m.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4616,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4617,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4617,
    "name": "Tarvon Runnel",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/n/antki2rsqzm.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4618,
    "name": "Queintas Quillmere",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/p/rpcfpjnw9ak.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4619,
    "name": "Merrick Seawell",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/g/lg_wcu4eigu.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4619,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4620,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4620,
    "name": "Silasar Noirmont",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/_/k_qxs-v3etk.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4621,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4622,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4623,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4624,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4624,
    "name": "Rolland Bowlby",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/y/ly14aactwwm.png",
    "game": [
      "Inazuma Eleven Ares"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4625,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4626,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4627,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4628,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4629,
    "name": "Faith Winter",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4629,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4630,
    "name": "Hunter Foster",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4630,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4631,
    "name": "Xavier Schiller",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4631,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4632,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4632,
    "name": "Massimo Donati",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4633,
    "name": "Chesney Horse",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4633,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4634,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4635,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4636,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4637,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4638,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4639,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4640,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4641,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4642,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4645,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4646,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4647,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4648,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4649,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4650,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4651,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4652,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4653,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4654,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4655,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4656,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4657,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4658,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4659,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4660,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4661,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4662,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4663,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4664,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4665,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4666,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4667,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4668,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4669,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4670,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4671,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4672,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4673,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4674,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4675,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4676,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4677,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4678,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4679,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4680,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4681,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4682,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4683,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4684,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4685,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4686,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4687,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4688,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4689,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4690,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4691,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4692,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4693,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4694,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4695,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4697,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4699,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4700,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4701,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4702,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4703,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4704,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4705,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4709,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4710,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4711,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4712,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4713,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4714,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4715,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4716,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4717,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4718,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4719,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4720,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4721,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4722,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4723,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4724,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4725,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4726,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4727,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4728,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4729,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4730,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4731,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4732,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4733,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4734,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4735,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4736,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4737,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4738,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4739,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4740,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4741,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4743,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4745,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4746,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4747,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4748,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4749,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4750,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4751,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4752,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4753,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4754,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4755,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4756,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4757,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4758,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4759,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4760,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4761,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4762,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4763,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4764,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4765,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4766,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4767,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4768,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4769,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4770,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4771,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4772,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4773,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4774,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4775,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4776,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4777,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4778,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4779,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4780,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4781,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4782,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4783,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4784,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4785,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4786,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4787,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4788,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4789,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4790,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4791,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4792,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4793,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4794,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4795,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4796,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4797,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4798,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4799,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4800,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4802,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4805,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4806,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4807,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4808,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4809,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4810,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4811,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4812,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4813,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4814,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4815,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4817,
    "name": "Destin Billows",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/i/qinvwy2o6g0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 74,
      "control": 52,
      "pressure": 51,
      "agility": 57,
      "physical": 46,
      "technique": 63
    }
  },
  {
    "id": 4818,
    "name": "Briar Bloomhurst",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/n/wneajfdgpae.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 55,
      "control": 45,
      "pressure": 56,
      "agility": 67,
      "physical": 44,
      "technique": 66
    }
  },
  {
    "id": 4819,
    "name": "Cedric Freud",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/s/ysdgncrqkge.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 63,
      "control": 62,
      "pressure": 41,
      "agility": 58,
      "physical": 59,
      "technique": 57
    }
  },
  {
    "id": 4820,
    "name": "Raika Shinohara",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/d/sdgzebki_m0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 53,
      "control": 60,
      "pressure": 43,
      "agility": 67,
      "physical": 50,
      "technique": 64
    }
  },
  {
    "id": 4821,
    "name": "Cade Shelby",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/r/jrrsz-cysvc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 40,
      "control": 53,
      "pressure": 66,
      "agility": 47,
      "physical": 62,
      "technique": 57
    }
  },
  {
    "id": 4823,
    "name": "Alix La Fontaine",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/l/bl17o6l8izs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 50,
      "control": 53,
      "pressure": 80,
      "agility": 51,
      "physical": 61,
      "technique": 54
    }
  },
  {
    "id": 4824,
    "name": "Thierry Reyes",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/e/deyngj3qn1s.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 63,
      "control": 67,
      "pressure": 56,
      "agility": 48,
      "physical": 59,
      "technique": 68
    }
  },
  {
    "id": 4825,
    "name": "Winsor Compete",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/i/7iyb2rafrau.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 58,
      "control": 47,
      "pressure": 53,
      "agility": 54,
      "physical": 65,
      "technique": 55
    }
  },
  {
    "id": 4826,
    "name": "Charis Benzaie",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/b/ibem1nuj518.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 42,
      "control": 54,
      "pressure": 64,
      "agility": 55,
      "physical": 72,
      "technique": 46
    }
  },
  {
    "id": 4827,
    "name": "Maine Alsop",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/g/zgwylv97hmk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 64,
      "control": 71,
      "pressure": 49,
      "agility": 53,
      "physical": 41,
      "technique": 52
    }
  },
  {
    "id": 4828,
    "name": "Dario Highton",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/u/ountmqbbmvm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 80,
      "control": 56,
      "pressure": 54,
      "agility": 47,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4829,
    "name": "Amelia Rainwalker",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/p/qpgpijjtjtm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 55,
      "control": 55,
      "pressure": 71,
      "agility": 57,
      "physical": 57,
      "technique": 54
    }
  },
  {
    "id": 4830,
    "name": "Marisol Cavallo",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/n/bnrul2vxkgk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 54,
      "control": 53,
      "pressure": 61,
      "agility": 41,
      "physical": 56,
      "technique": 47
    }
  },
  {
    "id": 4831,
    "name": "Meridia Althoff",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/g/kgd6bu8l8z8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 55,
      "control": 60,
      "pressure": 72,
      "agility": 49,
      "physical": 76,
      "technique": 58
    }
  },
  {
    "id": 4832,
    "name": "Tai Richter",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/b/xbukczb61q0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 70,
      "control": 60,
      "pressure": 40,
      "agility": 49,
      "physical": 53,
      "technique": 57
    }
  },
  {
    "id": 4833,
    "name": "Davin Bullock",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/p/mpfrvmnayzc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 54,
      "control": 71,
      "pressure": 52,
      "agility": 55,
      "physical": 52,
      "technique": 68
    }
  },
  {
    "id": 4834,
    "name": "Lycus Foxworth",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/p/5p1hyyizugu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 42,
      "control": 41,
      "pressure": 53,
      "agility": 52,
      "physical": 62,
      "technique": 44
    }
  },
  {
    "id": 4835,
    "name": "Florent Shorleigh",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/n/qnqcxng6r5m.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 50,
      "control": 67,
      "pressure": 50,
      "agility": 57,
      "physical": 49,
      "technique": 61
    }
  },
  {
    "id": 4836,
    "name": "Antonia Felicier",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/i/wizpeqvykz8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 42,
      "control": 60,
      "pressure": 71,
      "agility": 43,
      "physical": 59,
      "technique": 53
    }
  },
  {
    "id": 4837,
    "name": "Kelvin Steelborne",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/k/bkcipvzijqu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 59,
      "control": 45,
      "pressure": 62,
      "agility": 56,
      "physical": 73,
      "technique": 45
    }
  },
  {
    "id": 4838,
    "name": "Lemmy Stretchen",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/k/-k8iqz_hbmu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 40,
      "control": 56,
      "pressure": 76,
      "agility": 46,
      "physical": 58,
      "technique": 43
    }
  },
  {
    "id": 4839,
    "name": "Starla Thorn",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/i/pindhmz92_8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 61,
      "control": 69,
      "pressure": 42,
      "agility": 58,
      "physical": 48,
      "technique": 62
    }
  },
  {
    "id": 4840,
    "name": "Elaine Sereno",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/w/qwneste18k8.png",
    "game": [
      "Inazuma Eleven: Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4841,
    "name": "Lilac Tausend",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/5/k5er_or9jem.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 71,
      "control": 74,
      "pressure": 57,
      "agility": 43,
      "physical": 43,
      "technique": 58
    }
  },
  {
    "id": 4842,
    "name": "Juno Hundertmark",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/y/oyxxlfats7e.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 51,
      "control": 51,
      "pressure": 77,
      "agility": 49,
      "physical": 59,
      "technique": 45
    }
  },
  {
    "id": 4843,
    "name": "Edwin Grove",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/x/6xd84b32hzk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 46,
      "control": 49,
      "pressure": 84,
      "agility": 41,
      "physical": 59,
      "technique": 55
    }
  },
  {
    "id": 4844,
    "name": "Zander Warmington",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/b/eb4qmsacpsc.png",
    "game": [
      "Inazuma Eleven: Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4845,
    "name": "Viorain Maleby",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/0/k0bf1p1ucms.png",
    "game": [
      "Inazuma Eleven: Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4846,
    "name": "Clement Mariner",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/c/vcq-ywtux_e.png",
    "game": [
      "Inazuma Eleven: Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4847,
    "name": "Boone Wretman",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/s/3soxl00kbz0.png",
    "game": [
      "Inazuma Eleven: Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4848,
    "name": "Jazmine Carmine",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/z/1zjlltmmef0.png",
    "game": [
      "Inazuma Eleven: Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4849,
    "name": "Colton Sharps",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/x/vxteghsncm8.png",
    "game": [
      "Inazuma Eleven: Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4850,
    "name": "Maddock Jackson",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/2/-2_ked__afk.png",
    "game": [
      "Inazuma Eleven: Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4851,
    "name": "Eleanor Estrella",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/2/h2vmp9qmwas.png",
    "game": [
      "Inazuma Eleven: Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4852,
    "name": "Darian Moonward",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/6/g6_2ilswsqc.png",
    "game": [
      "Inazuma Eleven: Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4853,
    "name": "Harper Evans",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/v/mvcdbwn4zks.png",
    "game": [
      "Inazuma Eleven: Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4854,
    "name": "Talon Lewis",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/e/qekhec227ze.png",
    "game": [
      "Inazuma Eleven: Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4855,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4856,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4857,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4858,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4859,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4860,
    "name": "Addison Norris",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/g/mgmqtpmakz8.png",
    "game": [
      "Inazuma Eleven: Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4861,
    "name": "Leia Caperton",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/i/9ixx-wa6jqu.png",
    "game": [
      "Inazuma Eleven: Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4862,
    "name": "Milo Rankin",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/s/jspdxjcjbqe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 45,
      "control": 59,
      "pressure": 70,
      "agility": 54,
      "physical": 63,
      "technique": 42
    }
  },
  {
    "id": 4863,
    "name": "Peake Fletcher",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/n/gnd1zji01mk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 52,
      "control": 42,
      "pressure": 68,
      "agility": 48,
      "physical": 64,
      "technique": 49
    }
  },
  {
    "id": 4864,
    "name": "Sentry Scarborough",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/p/rpsu02eoy_m.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 47,
      "control": 55,
      "pressure": 79,
      "agility": 42,
      "physical": 71,
      "technique": 59
    }
  },
  {
    "id": 4865,
    "name": "Autry Rogers",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/g/xgphnrxgtf8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 52,
      "control": 51,
      "pressure": 55,
      "agility": 55,
      "physical": 61,
      "technique": 53
    }
  },
  {
    "id": 4866,
    "name": "Bodhi Field",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/r/yrdjpbp7d5c.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 76,
      "control": 60,
      "pressure": 59,
      "agility": 45,
      "physical": 54,
      "technique": 69
    }
  },
  {
    "id": 4867,
    "name": "Chase Winthrop",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/p/dptwtzqjj1c.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 62,
      "control": 59,
      "pressure": 53,
      "agility": 41,
      "physical": 52,
      "technique": 64
    }
  },
  {
    "id": 4868,
    "name": "Hawky Savard",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/d/pdsoi-pbuk0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 61,
      "control": 57,
      "pressure": 56,
      "agility": 53,
      "physical": 40,
      "technique": 72
    }
  },
  {
    "id": 4869,
    "name": "Taliesin Greenhunt",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/e/4e-8cc6z2zs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 73,
      "control": 72,
      "pressure": 55,
      "agility": 56,
      "physical": 51,
      "technique": 68
    }
  },
  {
    "id": 4870,
    "name": "Ivan Mercer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/l/6l5gyfofzfs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 57,
      "control": 70,
      "pressure": 58,
      "agility": 46,
      "physical": 49,
      "technique": 66
    }
  },
  {
    "id": 4871,
    "name": "Erdem Barath",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/n/lnibf6olese.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 53,
      "control": 48,
      "pressure": 56,
      "agility": 58,
      "physical": 57,
      "technique": 58
    }
  },
  {
    "id": 4872,
    "name": "Nikas Himmelstein",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/k/akavhydxg_c.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 52,
      "control": 60,
      "pressure": 49,
      "agility": 70,
      "physical": 58,
      "technique": 54
    }
  },
  {
    "id": 4873,
    "name": "Hugh Pronghorn",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/g/igap3qwywkk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 44,
      "control": 56,
      "pressure": 58,
      "agility": 53,
      "physical": 41,
      "technique": 57
    }
  },
  {
    "id": 4874,
    "name": "Everett Shipman",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/b/sbir-mmzkg0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 62,
      "control": 64,
      "pressure": 43,
      "agility": 53,
      "physical": 47,
      "technique": 56
    }
  },
  {
    "id": 4875,
    "name": "Armin Marshall",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/u/turiavwid5m.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 58,
      "control": 52,
      "pressure": 66,
      "agility": 44,
      "physical": 59,
      "technique": 44
    }
  },
  {
    "id": 4876,
    "name": "Conley Quiver",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/b/zbi9jyjqoz8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 58,
      "control": 50,
      "pressure": 61,
      "agility": 56,
      "physical": 60,
      "technique": 60
    }
  },
  {
    "id": 4877,
    "name": "Denzel Harvest",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/p/cp5cknfqfqu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 54,
      "control": 51,
      "pressure": 50,
      "agility": 77,
      "physical": 40,
      "technique": 71
    }
  },
  {
    "id": 4878,
    "name": "Neil Turner",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/_/w_ggpbcv7sm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 50,
      "control": 48,
      "pressure": 44,
      "agility": 62,
      "physical": 51,
      "technique": 46
    }
  },
  {
    "id": 4879,
    "name": "Raz Pond",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/x/bxrne-6vwfk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 74,
      "control": 59,
      "pressure": 59,
      "agility": 43,
      "physical": 45,
      "technique": 48
    }
  },
  {
    "id": 4880,
    "name": "Dax Prescott",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/v/wvjtcihjfk8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 44,
      "control": 45,
      "pressure": 70,
      "agility": 43,
      "physical": 65,
      "technique": 46
    }
  },
  {
    "id": 4881,
    "name": "Edvan Trodden",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/z/fzcbszg9cfk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 47,
      "control": 47,
      "pressure": 63,
      "agility": 59,
      "physical": 71,
      "technique": 49
    }
  },
  {
    "id": 4882,
    "name": "Drever Olflaire",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/4/s4oz6zeas5e.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 40,
      "control": 49,
      "pressure": 64,
      "agility": 56,
      "physical": 72,
      "technique": 55
    }
  },
  {
    "id": 4883,
    "name": "Looke Raundoff",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/c/lc_ubev13_u.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 50,
      "control": 56,
      "pressure": 63,
      "agility": 52,
      "physical": 54,
      "technique": 47
    }
  },
  {
    "id": 4884,
    "name": "Rutheo Wheyston",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/4/z4kfnnxzgmm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 40,
      "control": 53,
      "pressure": 70,
      "agility": 57,
      "physical": 67,
      "technique": 45
    }
  },
  {
    "id": 4885,
    "name": "Ernesta Beauregard",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/q/dq_sxm46bks.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 71,
      "control": 67,
      "pressure": 50,
      "agility": 42,
      "physical": 51,
      "technique": 56
    }
  },
  {
    "id": 4886,
    "name": "Laymark Starwyn",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/9/n94yvdhzy5u.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 62,
      "control": 68,
      "pressure": 51,
      "agility": 45,
      "physical": 60,
      "technique": 60
    }
  },
  {
    "id": 4887,
    "name": "Moby Tidbitt",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/s/hsbh8ayrhzk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 76,
      "control": 71,
      "pressure": 43,
      "agility": 41,
      "physical": 55,
      "technique": 64
    }
  },
  {
    "id": 4888,
    "name": "Edgard Loathe",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/6/26qmr_urqqm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 57,
      "control": 58,
      "pressure": 54,
      "agility": 57,
      "physical": 50,
      "technique": 66
    }
  },
  {
    "id": 4889,
    "name": "Flanko Midspringle",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/q/cqv-gyxjnvk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 60,
      "control": 41,
      "pressure": 59,
      "agility": 69,
      "physical": 52,
      "technique": 68
    }
  },
  {
    "id": 4890,
    "name": "Berdy Caster",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/0/u0ops7zpam8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 53,
      "control": 50,
      "pressure": 54,
      "agility": 73,
      "physical": 53,
      "technique": 61
    }
  },
  {
    "id": 4891,
    "name": "Chicory Bellflower",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/x/mxtgpurizz0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 55,
      "control": 58,
      "pressure": 46,
      "agility": 40,
      "physical": 56,
      "technique": 48
    }
  },
  {
    "id": 4892,
    "name": "Aysen DeMacon",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/_/9_cnerny0qc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 52,
      "control": 59,
      "pressure": 41,
      "agility": 70,
      "physical": 40,
      "technique": 51
    }
  },
  {
    "id": 4893,
    "name": "Breppo Terrey",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/e/_eb7qifexsc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 61,
      "control": 62,
      "pressure": 46,
      "agility": 44,
      "physical": 51,
      "technique": 57
    }
  },
  {
    "id": 4894,
    "name": "Frie Sorbet",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/2/o2qah35kcf0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 54,
      "control": 45,
      "pressure": 62,
      "agility": 59,
      "physical": 53,
      "technique": 52
    }
  },
  {
    "id": 4895,
    "name": "Eddi Losse",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/z/uzjvuqmsp_e.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 46,
      "control": 51,
      "pressure": 77,
      "agility": 55,
      "physical": 64,
      "technique": 51
    }
  },
  {
    "id": 4896,
    "name": "Waddell Homely",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/g/vgmiaahf_m0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 41,
      "control": 57,
      "pressure": 65,
      "agility": 47,
      "physical": 65,
      "technique": 50
    }
  },
  {
    "id": 4897,
    "name": "Yasmin Tausend",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/u/euxp3_h_s_c.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 64,
      "control": 63,
      "pressure": 60,
      "agility": 58,
      "physical": 44,
      "technique": 62
    }
  },
  {
    "id": 4898,
    "name": "Martino Leone",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/d/id1jh1i55mk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 56,
      "control": 55,
      "pressure": 85,
      "agility": 53,
      "physical": 63,
      "technique": 57
    }
  },
  {
    "id": 4899,
    "name": "Judie Cassios",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/n/0nusl8g_u_8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 55,
      "control": 45,
      "pressure": 69,
      "agility": 40,
      "physical": 69,
      "technique": 40
    }
  },
  {
    "id": 4900,
    "name": "Gigy Maharaja",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/p/ap1fr9p2ptc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 55,
      "control": 51,
      "pressure": 59,
      "agility": 55,
      "physical": 55,
      "technique": 52
    }
  },
  {
    "id": 4901,
    "name": "Jenny Okutba",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/e/zen35xxlh18.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 49,
      "control": 50,
      "pressure": 59,
      "agility": 53,
      "physical": 51,
      "technique": 56
    }
  },
  {
    "id": 4902,
    "name": "Robart Anderson",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/k/rkdeetwvrtm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 73,
      "control": 60,
      "pressure": 42,
      "agility": 50,
      "physical": 49,
      "technique": 60
    }
  },
  {
    "id": 4903,
    "name": "Ming Chow",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/p/fpfzmdgfdmu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 56,
      "control": 71,
      "pressure": 54,
      "agility": 57,
      "physical": 41,
      "technique": 58
    }
  },
  {
    "id": 4904,
    "name": "Maribelle Flanmir",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/l/xlgrxojnkz8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 76,
      "control": 63,
      "pressure": 54,
      "agility": 41,
      "physical": 60,
      "technique": 54
    }
  },
  {
    "id": 4905,
    "name": "Toyo Yamanouchi",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/n/anrk6xfdjau.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 59,
      "control": 75,
      "pressure": 53,
      "agility": 41,
      "physical": 59,
      "technique": 49
    }
  },
  {
    "id": 4906,
    "name": "Sikuvot Shivan",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/r/trecqkeduvm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 49,
      "control": 59,
      "pressure": 58,
      "agility": 76,
      "physical": 59,
      "technique": 57
    }
  },
  {
    "id": 4907,
    "name": "Kai Yoshizaki",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/n/rne-8cpmig0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 53,
      "control": 47,
      "pressure": 59,
      "agility": 60,
      "physical": 55,
      "technique": 49
    }
  },
  {
    "id": 4908,
    "name": "Joey Beat",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/i/giy_pswv8gk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 42,
      "control": 48,
      "pressure": 44,
      "agility": 65,
      "physical": 58,
      "technique": 71
    }
  },
  {
    "id": 4909,
    "name": "Olson Carchis",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/g/6gwqcg6-6zs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 44,
      "control": 48,
      "pressure": 40,
      "agility": 66,
      "physical": 51,
      "technique": 61
    }
  },
  {
    "id": 4910,
    "name": "Mengmeng Wang",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/i/linlvfcexae.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 75,
      "control": 76,
      "pressure": 43,
      "agility": 54,
      "physical": 41,
      "technique": 54
    }
  },
  {
    "id": 4911,
    "name": "Kaos Dao",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/p/jpgxbgoosge.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 59,
      "control": 42,
      "pressure": 66,
      "agility": 59,
      "physical": 77,
      "technique": 58
    }
  },
  {
    "id": 4912,
    "name": "Edmond Pias",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/b/4br2s5os_1s.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 54,
      "control": 44,
      "pressure": 57,
      "agility": 41,
      "physical": 70,
      "technique": 51
    }
  },
  {
    "id": 4913,
    "name": "Kain Vijet",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/u/yuyd_kdakvc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 59,
      "control": 42,
      "pressure": 56,
      "agility": 44,
      "physical": 64,
      "technique": 55
    }
  },
  {
    "id": 4914,
    "name": "Derrin Wilson",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/x/zxdkxowzcms.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 69,
      "control": 70,
      "pressure": 50,
      "agility": 60,
      "physical": 51,
      "technique": 52
    }
  },
  {
    "id": 4915,
    "name": "Anita Navarro",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/z/ozsfcxwjxve.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 43,
      "control": 41,
      "pressure": 62,
      "agility": 44,
      "physical": 70,
      "technique": 40
    }
  },
  {
    "id": 4916,
    "name": "Kiona Blackwell",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/s/8sxca__yw1k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 50,
      "control": 49,
      "pressure": 79,
      "agility": 56,
      "physical": 67,
      "technique": 54
    }
  },
  {
    "id": 4917,
    "name": "Lennox Portsman",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/4/i4oexy8qxkm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 46,
      "control": 41,
      "pressure": 61,
      "agility": 52,
      "physical": 72,
      "technique": 60
    }
  },
  {
    "id": 4918,
    "name": "Kaz Bloomfield",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/0/v0cuqe-slg8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 46,
      "control": 50,
      "pressure": 79,
      "agility": 44,
      "physical": 58,
      "technique": 57
    }
  },
  {
    "id": 4919,
    "name": "Govin Castlehoven",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/c/ecz197ywmtu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 48,
      "control": 45,
      "pressure": 64,
      "agility": 59,
      "physical": 59,
      "technique": 47
    }
  },
  {
    "id": 4920,
    "name": "Floramira Pagotta",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/b/pbhhdzlk-am.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 68,
      "control": 62,
      "pressure": 56,
      "agility": 52,
      "physical": 42,
      "technique": 53
    }
  },
  {
    "id": 4921,
    "name": "Alistar Montero",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/v/tvfi-dsaom8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 66,
      "control": 75,
      "pressure": 44,
      "agility": 44,
      "physical": 58,
      "technique": 75
    }
  },
  {
    "id": 4922,
    "name": "Elijah Singleton",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/6/n6m9tazi7gm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 78,
      "control": 52,
      "pressure": 46,
      "agility": 40,
      "physical": 44,
      "technique": 55
    }
  },
  {
    "id": 4923,
    "name": "Rohan Snatchett",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/q/5qzlcnaqc5k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 72,
      "control": 67,
      "pressure": 46,
      "agility": 49,
      "physical": 57,
      "technique": 63
    }
  },
  {
    "id": 4924,
    "name": "Umbren Lightwood",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/q/mqzjrz1zqms.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 46,
      "control": 44,
      "pressure": 41,
      "agility": 63,
      "physical": 45,
      "technique": 60
    }
  },
  {
    "id": 4925,
    "name": "Blaine Westbrook",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/9/c90ptik6jvu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 59,
      "control": 43,
      "pressure": 46,
      "agility": 68,
      "physical": 60,
      "technique": 60
    }
  },
  {
    "id": 4926,
    "name": "Marinus Courier",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/4/x4cogmtj9ve.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 57,
      "control": 59,
      "pressure": 42,
      "agility": 61,
      "physical": 50,
      "technique": 71
    }
  },
  {
    "id": 4927,
    "name": "Zelane Whitlow",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/_/g_q84uarlgc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 42,
      "control": 53,
      "pressure": 73,
      "agility": 42,
      "physical": 58,
      "technique": 49
    }
  },
  {
    "id": 4928,
    "name": "Rael Abbeybogy",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/x/3xhdvrmri10.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 71,
      "control": 74,
      "pressure": 54,
      "agility": 45,
      "physical": 45,
      "technique": 62
    }
  },
  {
    "id": 4929,
    "name": "Dawsey Geistfeld",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/2/12mb7i0hnz0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 47,
      "control": 41,
      "pressure": 55,
      "agility": 69,
      "physical": 53,
      "technique": 59
    }
  },
  {
    "id": 4930,
    "name": "Volk Lorius",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/e/eexgw3s9gac.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 60,
      "control": 63,
      "pressure": 45,
      "agility": 55,
      "physical": 53,
      "technique": 71
    }
  },
  {
    "id": 4931,
    "name": "Drexel Kixley",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/x/kx0vfqn1vgs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 60,
      "control": 60,
      "pressure": 70,
      "agility": 56,
      "physical": 71,
      "technique": 58
    }
  },
  {
    "id": 4932,
    "name": "Wythers Moonridge",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/u/lubylakcdtc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 53,
      "control": 63,
      "pressure": 56,
      "agility": 44,
      "physical": 60,
      "technique": 72
    }
  },
  {
    "id": 4933,
    "name": "Mirela Delisle",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/g/ugqtm_smug0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 46,
      "control": 48,
      "pressure": 58,
      "agility": 51,
      "physical": 60,
      "technique": 48
    }
  },
  {
    "id": 4934,
    "name": "Ashlan Panoptos",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/v/vve4m-f76ne.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 40,
      "control": 49,
      "pressure": 68,
      "agility": 49,
      "physical": 61,
      "technique": 54
    }
  },
  {
    "id": 4935,
    "name": "Hudson Headland",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/4/v4dyevgyj-8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 46,
      "control": 57,
      "pressure": 65,
      "agility": 42,
      "physical": 50,
      "technique": 40
    }
  },
  {
    "id": 4936,
    "name": "Vex Frieden",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/v/wvuurawi2sm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 54,
      "control": 47,
      "pressure": 71,
      "agility": 50,
      "physical": 61,
      "technique": 51
    }
  },
  {
    "id": 4937,
    "name": "Asten Royds",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/_/e_rmgnzqrtk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 55,
      "control": 51,
      "pressure": 64,
      "agility": 47,
      "physical": 58,
      "technique": 42
    }
  },
  {
    "id": 4938,
    "name": "Ruelle Neurivieu",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/e/gewqouhgurk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 60,
      "control": 54,
      "pressure": 61,
      "agility": 41,
      "physical": 73,
      "technique": 54
    }
  },
  {
    "id": 4939,
    "name": "Theon Stillcliffe",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/9/e91zlb5bx-s.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 51,
      "control": 65,
      "pressure": 56,
      "agility": 58,
      "physical": 41,
      "technique": 52
    }
  },
  {
    "id": 4940,
    "name": "Ciel Natcherall",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/x/1xgtnyvq8em.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 65,
      "control": 68,
      "pressure": 49,
      "agility": 50,
      "physical": 43,
      "technique": 55
    }
  },
  {
    "id": 4941,
    "name": "Kaien Spiradawn",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/q/kqy5zqgiknu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 53,
      "control": 52,
      "pressure": 49,
      "agility": 71,
      "physical": 47,
      "technique": 69
    }
  },
  {
    "id": 4942,
    "name": "Kyo Seestar",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/9/b9f18_wybhk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 56,
      "control": 45,
      "pressure": 59,
      "agility": 65,
      "physical": 53,
      "technique": 55
    }
  },
  {
    "id": 4943,
    "name": "Syd Faircrest",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/z/xzeew2y0m48.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 64,
      "control": 74,
      "pressure": 57,
      "agility": 58,
      "physical": 49,
      "technique": 67
    }
  },
  {
    "id": 4944,
    "name": "Solan Brightmoor",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/x/mx1ldjuohlu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 81,
      "intelligence": 59,
      "control": 50,
      "pressure": 43,
      "agility": 60,
      "physical": 41,
      "technique": 63
    }
  },
  {
    "id": 4945,
    "name": "Lenox Grinder",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/6/p6nn1jqzpt0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 41,
      "control": 59,
      "pressure": 60,
      "agility": 59,
      "physical": 54,
      "technique": 66
    }
  },
  {
    "id": 4946,
    "name": "Ophelia Ennercourt",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/s/-swsycmjiec.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 56,
      "control": 44,
      "pressure": 41,
      "agility": 68,
      "physical": 57,
      "technique": 48
    }
  },
  {
    "id": 4947,
    "name": "Riggs Fornstrut",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/z/8zrw2felnyc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 65,
      "control": 64,
      "pressure": 50,
      "agility": 50,
      "physical": 44,
      "technique": 69
    }
  },
  {
    "id": 4948,
    "name": "Leticia Legatus",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/b/nbgrb64fkr0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 54,
      "control": 42,
      "pressure": 65,
      "agility": 44,
      "physical": 53,
      "technique": 45
    }
  },
  {
    "id": 4949,
    "name": "Arran Realis",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/0/t0dkinnx_le.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 47,
      "control": 43,
      "pressure": 74,
      "agility": 40,
      "physical": 60,
      "technique": 50
    }
  },
  {
    "id": 4950,
    "name": "Alice Rendell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/r/srsdgng-p40.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 78,
      "control": 63,
      "pressure": 57,
      "agility": 46,
      "physical": 60,
      "technique": 63
    }
  },
  {
    "id": 4951,
    "name": "Partis Payton",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/d/dddirygeelc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 56,
      "control": 51,
      "pressure": 69,
      "agility": 60,
      "physical": 73,
      "technique": 57
    }
  },
  {
    "id": 4952,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4953,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4954,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4955,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4956,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4957,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4958,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4959,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4960,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4961,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4962,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4963,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4964,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4965,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4966,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4967,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4968,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4969,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 4970,
    "name": "Hobie Chartwood",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/p/yp0vje8n74k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 43,
      "control": 42,
      "pressure": 74,
      "agility": 51,
      "physical": 63,
      "technique": 45
    }
  },
  {
    "id": 4971,
    "name": "Lila Glosswood",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/n/pnfokha3wlm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 47,
      "control": 41,
      "pressure": 59,
      "agility": 43,
      "physical": 74,
      "technique": 52
    }
  },
  {
    "id": 4972,
    "name": "Rowland Brightwood",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/l/zlhbptqcqye.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 60,
      "control": 43,
      "pressure": 60,
      "agility": 55,
      "physical": 73,
      "technique": 58
    }
  },
  {
    "id": 4973,
    "name": "Tristan Brookwood",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/i/9izjgxsdeuu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 54,
      "control": 60,
      "pressure": 56,
      "agility": 44,
      "physical": 59,
      "technique": 43
    }
  },
  {
    "id": 4974,
    "name": "Lachlan Hartwood",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/g/rgcsk4ibtnm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 56,
      "control": 69,
      "pressure": 40,
      "agility": 58,
      "physical": 60,
      "technique": 51
    }
  },
  {
    "id": 4975,
    "name": "Nathaniel Whitewood",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/e/xemhh0cwvee.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 62,
      "control": 70,
      "pressure": 58,
      "agility": 47,
      "physical": 44,
      "technique": 69
    }
  },
  {
    "id": 4976,
    "name": "Orin Wildwood",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/b/6bqg0abpleu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 53,
      "control": 58,
      "pressure": 49,
      "agility": 44,
      "physical": 40,
      "technique": 68
    }
  },
  {
    "id": 4977,
    "name": "Calvin Sixwood",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/r/rrfyyp34g-0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 61,
      "control": 73,
      "pressure": 48,
      "agility": 59,
      "physical": 50,
      "technique": 59
    }
  },
  {
    "id": 4978,
    "name": "Iris Nightwood",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/u/auzznhuh--k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 64,
      "control": 59,
      "pressure": 53,
      "agility": 56,
      "physical": 52,
      "technique": 59
    }
  },
  {
    "id": 4979,
    "name": "Vearn Dashwood",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/n/cnq6is2m9rs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 40,
      "control": 54,
      "pressure": 47,
      "agility": 70,
      "physical": 52,
      "technique": 62
    }
  },
  {
    "id": 4980,
    "name": "Asher Norwood",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/k/mkocroknpn8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 41,
      "control": 41,
      "pressure": 59,
      "agility": 68,
      "physical": 48,
      "technique": 59
    }
  },
  {
    "id": 4981,
    "name": "Emory Plainwood",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/k/tkcucwlul40.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 49,
      "control": 52,
      "pressure": 76,
      "agility": 54,
      "physical": 65,
      "technique": 47
    }
  },
  {
    "id": 4982,
    "name": "Maris Hollowwood",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/s/asxmmlkk4ts.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 79,
      "control": 58,
      "pressure": 58,
      "agility": 59,
      "physical": 57,
      "technique": 63
    }
  },
  {
    "id": 4983,
    "name": "Ronan Strongwood",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/g/4gxaadjfoyu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 42,
      "control": 54,
      "pressure": 54,
      "agility": 76,
      "physical": 48,
      "technique": 63
    }
  },
  {
    "id": 4984,
    "name": "Lydia Trailwood",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/i/iizpxpduilc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 74,
      "control": 62,
      "pressure": 41,
      "agility": 56,
      "physical": 52,
      "technique": 71
    }
  },
  {
    "id": 4985,
    "name": "Alden Songwood",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/i/jim738v_jr8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 46,
      "control": 59,
      "pressure": 73,
      "agility": 56,
      "physical": 72,
      "technique": 60
    }
  },
  {
    "id": 4986,
    "name": "Theobald Longwood",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/0/q0qv8dar2ne.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 49,
      "control": 57,
      "pressure": 44,
      "agility": 61,
      "physical": 46,
      "technique": 49
    }
  },
  {
    "id": 4987,
    "name": "Mabel Greenwood",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/c/hcb0r88rb-s.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 56,
      "control": 43,
      "pressure": 71,
      "agility": 50,
      "physical": 78,
      "technique": 52
    }
  },
  {
    "id": 4988,
    "name": "Lilia Charmont",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/t/wtb-wtsfhl0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 44,
      "control": 55,
      "pressure": 57,
      "agility": 53,
      "physical": 67,
      "technique": 41
    }
  },
  {
    "id": 4989,
    "name": "Evelyn Hale",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/t/jtxsht9sl68.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 58,
      "control": 48,
      "pressure": 70,
      "agility": 55,
      "physical": 60,
      "technique": 60
    }
  },
  {
    "id": 4990,
    "name": "Elara Silvane",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/7/n7qfds0lqwc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 52,
      "control": 58,
      "pressure": 71,
      "agility": 58,
      "physical": 68,
      "technique": 53
    }
  },
  {
    "id": 4991,
    "name": "Margie Frostveil",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/7/47azqsbwmju.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 59,
      "control": 52,
      "pressure": 61,
      "agility": 51,
      "physical": 58,
      "technique": 43
    }
  },
  {
    "id": 4992,
    "name": "Galia Flair",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/5/95ok2e-osfu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 56,
      "control": 68,
      "pressure": 42,
      "agility": 56,
      "physical": 55,
      "technique": 53
    }
  },
  {
    "id": 4993,
    "name": "Selene Trance",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/r/mr_rbhy0b28.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 74,
      "control": 56,
      "pressure": 53,
      "agility": 50,
      "physical": 59,
      "technique": 60
    }
  },
  {
    "id": 4994,
    "name": "Elyse Reign",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/w/dwt_ldlgzlk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 64,
      "control": 53,
      "pressure": 41,
      "agility": 54,
      "physical": 60,
      "technique": 63
    }
  },
  {
    "id": 4995,
    "name": "Eliza Florence",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/-/s-cei8t80wm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 68,
      "control": 58,
      "pressure": 59,
      "agility": 52,
      "physical": 48,
      "technique": 67
    }
  },
  {
    "id": 4996,
    "name": "Adelina Gearhart",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/f/ufbcml_qxqm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 47,
      "control": 58,
      "pressure": 41,
      "agility": 59,
      "physical": 59,
      "technique": 68
    }
  },
  {
    "id": 4997,
    "name": "Clarisse Luxe",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/3/f3qjlazqcjk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 46,
      "control": 50,
      "pressure": 43,
      "agility": 67,
      "physical": 51,
      "technique": 56
    }
  },
  {
    "id": 4998,
    "name": "Celina Lavelle",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/y/_yjwyhsipdu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 41,
      "control": 40,
      "pressure": 50,
      "agility": 71,
      "physical": 49,
      "technique": 67
    }
  },
  {
    "id": 4999,
    "name": "Amara Winslow",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/y/uycie0azcj0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 58,
      "control": 42,
      "pressure": 68,
      "agility": 56,
      "physical": 58,
      "technique": 48
    }
  },
  {
    "id": 5000,
    "name": "Liliane Alban",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/d/0d_xnp173de.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 52,
      "control": 57,
      "pressure": 50,
      "agility": 63,
      "physical": 58,
      "technique": 58
    }
  },
  {
    "id": 5001,
    "name": "Lenora Graves",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/1/f1o2gwtbaws.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 40,
      "control": 44,
      "pressure": 54,
      "agility": 60,
      "physical": 45,
      "technique": 64
    }
  },
  {
    "id": 5002,
    "name": "Kiyora Asakiri",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/u/hujqopbtf2s.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 54,
      "control": 64,
      "pressure": 47,
      "agility": 46,
      "physical": 43,
      "technique": 61
    }
  },
  {
    "id": 5003,
    "name": "Talia Jester",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/8/284ljwnxyfe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 43,
      "control": 41,
      "pressure": 72,
      "agility": 44,
      "physical": 73,
      "technique": 60
    }
  },
  {
    "id": 5004,
    "name": "Apia Crownwell",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/t/vtzfqetauqe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 60,
      "control": 47,
      "pressure": 47,
      "agility": 77,
      "physical": 41,
      "technique": 48
    }
  },
  {
    "id": 5005,
    "name": "Melissa Hivewood",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/f/kfck9hlg5js.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 58,
      "control": 40,
      "pressure": 78,
      "agility": 43,
      "physical": 67,
      "technique": 47
    }
  },
  {
    "id": 5006,
    "name": "Mayen Harmet",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/m/qmdokjowyqe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 51,
      "control": 43,
      "pressure": 74,
      "agility": 41,
      "physical": 80,
      "technique": 58
    }
  },
  {
    "id": 5007,
    "name": "Vinda Koral",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/a/saducrf_ul8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 45,
      "control": 57,
      "pressure": 74,
      "agility": 49,
      "physical": 70,
      "technique": 42
    }
  },
  {
    "id": 5008,
    "name": "Yarkin Cittey",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/k/ekglqih558k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 47,
      "control": 46,
      "pressure": 52,
      "agility": 54,
      "physical": 58,
      "technique": 47
    }
  },
  {
    "id": 5009,
    "name": "Susen Faircourt",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/m/1m3e9dhdupm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 44,
      "control": 56,
      "pressure": 73,
      "agility": 56,
      "physical": 61,
      "technique": 40
    }
  },
  {
    "id": 5010,
    "name": "Budan Ashwell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/m/bmicmqehzwk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 59,
      "control": 62,
      "pressure": 51,
      "agility": 59,
      "physical": 50,
      "technique": 57
    }
  },
  {
    "id": 5011,
    "name": "Hathea Calmell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/k/bksjncok1js.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 53,
      "control": 68,
      "pressure": 52,
      "agility": 48,
      "physical": 53,
      "technique": 59
    }
  },
  {
    "id": 5012,
    "name": "Benton Zellner",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/j/hjrpfnxpgqu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 65,
      "control": 70,
      "pressure": 55,
      "agility": 55,
      "physical": 56,
      "technique": 69
    }
  },
  {
    "id": 5013,
    "name": "Froclan Junn",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/h/qhaiyyxtrj8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 69,
      "control": 73,
      "pressure": 40,
      "agility": 43,
      "physical": 54,
      "technique": 64
    }
  },
  {
    "id": 5014,
    "name": "Ebiss Marlowe",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/o/jos1xujfdwu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 70,
      "control": 67,
      "pressure": 43,
      "agility": 46,
      "physical": 58,
      "technique": 62
    }
  },
  {
    "id": 5015,
    "name": "Vashan Morell",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/h/dhpaijwn22k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 49,
      "control": 56,
      "pressure": 40,
      "agility": 65,
      "physical": 54,
      "technique": 57
    }
  },
  {
    "id": 5016,
    "name": "Itor Sheerman",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/o/wo59hvibedm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 56,
      "control": 59,
      "pressure": 46,
      "agility": 59,
      "physical": 59,
      "technique": 66
    }
  },
  {
    "id": 5017,
    "name": "Orfreya Newcomb",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/t/ota0k66cdwe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 50,
      "control": 48,
      "pressure": 76,
      "agility": 52,
      "physical": 75,
      "technique": 53
    }
  },
  {
    "id": 5018,
    "name": "Trevin Seabourne",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/j/kj-dz-d4tw0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 60,
      "control": 56,
      "pressure": 73,
      "agility": 44,
      "physical": 66,
      "technique": 60
    }
  },
  {
    "id": 5019,
    "name": "Jory Jinx",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/l/7lp80b7cadc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 48,
      "control": 47,
      "pressure": 55,
      "agility": 62,
      "physical": 60,
      "technique": 52
    }
  },
  {
    "id": 5020,
    "name": "Clementine Weston",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/c/ic5b3npuo20.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 79,
      "control": 75,
      "pressure": 40,
      "agility": 45,
      "physical": 42,
      "technique": 67
    }
  },
  {
    "id": 5021,
    "name": "Jakob Serveraw",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/q/5qigaypuffc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 48,
      "control": 50,
      "pressure": 81,
      "agility": 60,
      "physical": 63,
      "technique": 55
    }
  },
  {
    "id": 5022,
    "name": "Conrado Pottinger",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/y/py1tqqx1ll0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 46,
      "control": 47,
      "pressure": 41,
      "agility": 57,
      "physical": 58,
      "technique": 61
    }
  },
  {
    "id": 5023,
    "name": "Celeste Fairbourne",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/a/yaeyhvxpmwc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 51,
      "control": 40,
      "pressure": 46,
      "agility": 60,
      "physical": 44,
      "technique": 57
    }
  },
  {
    "id": 5024,
    "name": "Terra Hillcroft",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/h/rhwtonaw6p8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 57,
      "control": 43,
      "pressure": 66,
      "agility": 47,
      "physical": 75,
      "technique": 50
    }
  },
  {
    "id": 5025,
    "name": "Alvaro Ventura",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/l/aldni-2hrvc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 48,
      "control": 55,
      "pressure": 68,
      "agility": 49,
      "physical": 71,
      "technique": 46
    }
  },
  {
    "id": 5026,
    "name": "Mirina Mackrell",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/m/om7fbikgfjm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 54,
      "control": 41,
      "pressure": 57,
      "agility": 51,
      "physical": 51,
      "technique": 49
    }
  },
  {
    "id": 5027,
    "name": "Yelena Poplawska",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/j/xjyglbqb8c0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 47,
      "control": 41,
      "pressure": 65,
      "agility": 47,
      "physical": 75,
      "technique": 50
    }
  },
  {
    "id": 5028,
    "name": "Pattie Whitfield",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/c/zc1alyc35a0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 56,
      "control": 45,
      "pressure": 52,
      "agility": 50,
      "physical": 68,
      "technique": 47
    }
  },
  {
    "id": 5029,
    "name": "Newman Wiford",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/m/6mehwvjcick.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 72,
      "control": 73,
      "pressure": 42,
      "agility": 46,
      "physical": 60,
      "technique": 56
    }
  },
  {
    "id": 5030,
    "name": "Sheila Threadwell",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/j/ajnyjy8kx8u.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 58,
      "control": 48,
      "pressure": 51,
      "agility": 76,
      "physical": 60,
      "technique": 65
    }
  },
  {
    "id": 5031,
    "name": "Primavera Bluefield",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/o/yogunrums6u.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 52,
      "control": 70,
      "pressure": 52,
      "agility": 58,
      "physical": 60,
      "technique": 56
    }
  },
  {
    "id": 5032,
    "name": "Vera Presswell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/k/gkgsbjdpkps.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 55,
      "control": 78,
      "pressure": 41,
      "agility": 43,
      "physical": 60,
      "technique": 60
    }
  },
  {
    "id": 5033,
    "name": "Cinnamon Dougherty",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/q/cqe7mnknupc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 72,
      "control": 63,
      "pressure": 43,
      "agility": 49,
      "physical": 43,
      "technique": 65
    }
  },
  {
    "id": 5034,
    "name": "Brandy Ryehart",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/m/rmrz2cltj8e.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 56,
      "control": 54,
      "pressure": 45,
      "agility": 71,
      "physical": 50,
      "technique": 59
    }
  },
  {
    "id": 5035,
    "name": "He Liu",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/f/ifno16rfhjs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 29,
      "intelligence": 40,
      "control": 51,
      "pressure": 72,
      "agility": 51,
      "physical": 56,
      "technique": 41
    }
  },
  {
    "id": 5036,
    "name": "Gibson Forte",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/a/parpguic_j8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 56,
      "control": 48,
      "pressure": 59,
      "agility": 66,
      "physical": 44,
      "technique": 54
    }
  },
  {
    "id": 5037,
    "name": "Love Stirling",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/v/jvy6zj9ukpm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 52,
      "control": 40,
      "pressure": 45,
      "agility": 68,
      "physical": 43,
      "technique": 61
    }
  },
  {
    "id": 5038,
    "name": "Marlin Sharkey",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/k/_kk-sdsaoqk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 42,
      "control": 40,
      "pressure": 71,
      "agility": 43,
      "physical": 65,
      "technique": 52
    }
  },
  {
    "id": 5039,
    "name": "Lorcan Oxfield",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/o/lo1mdqv4pvm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 62,
      "control": 59,
      "pressure": 50,
      "agility": 51,
      "physical": 53,
      "technique": 67
    }
  },
  {
    "id": 5040,
    "name": "Joon Kim",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/a/jaip7q8s36c.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 43,
      "control": 53,
      "pressure": 54,
      "agility": 47,
      "physical": 56,
      "technique": 58
    }
  },
  {
    "id": 5041,
    "name": "Daria Poplawska",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/y/sy5iwvawaj0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 49,
      "control": 53,
      "pressure": 44,
      "agility": 71,
      "physical": 58,
      "technique": 64
    }
  },
  {
    "id": 5042,
    "name": "Cobb Hightail",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/w/mwhkz8glijk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 48,
      "control": 53,
      "pressure": 61,
      "agility": 46,
      "physical": 62,
      "technique": 51
    }
  },
  {
    "id": 5043,
    "name": "June Davidson",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/w/1w0sjhh7vc8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 42,
      "control": 55,
      "pressure": 71,
      "agility": 59,
      "physical": 59,
      "technique": 44
    }
  },
  {
    "id": 5044,
    "name": "Jazzmine Skylark",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/5/g5crkhzt9pu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 55,
      "control": 57,
      "pressure": 75,
      "agility": 51,
      "physical": 59,
      "technique": 56
    }
  },
  {
    "id": 5045,
    "name": "Moray Delmar",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/f/vfxzaayzg8m.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 43,
      "control": 45,
      "pressure": 73,
      "agility": 53,
      "physical": 51,
      "technique": 60
    }
  },
  {
    "id": 5046,
    "name": "Holden Monday",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/3/k3m43lujnpk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 57,
      "control": 75,
      "pressure": 57,
      "agility": 48,
      "physical": 40,
      "technique": 65
    }
  },
  {
    "id": 5047,
    "name": "Caius Rushford",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/7/d7mowtw13lu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 71,
      "control": 62,
      "pressure": 47,
      "agility": 51,
      "physical": 46,
      "technique": 54
    }
  },
  {
    "id": 5048,
    "name": "Noctis Dunn",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/7/c7meht5g76c.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 67,
      "control": 60,
      "pressure": 53,
      "agility": 43,
      "physical": 54,
      "technique": 66
    }
  },
  {
    "id": 5049,
    "name": "Goldy",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/d/cdfazhp7edu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 69,
      "control": 65,
      "pressure": 40,
      "agility": 56,
      "physical": 43,
      "technique": 61
    }
  },
  {
    "id": 5050,
    "name": "Aniki",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/3/o3gcckmz5i8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 54,
      "control": 59,
      "pressure": 60,
      "agility": 66,
      "physical": 51,
      "technique": 48
    }
  },
  {
    "id": 5051,
    "name": "Berg",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/f/zfrjv1qjuru.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 40,
      "control": 59,
      "pressure": 57,
      "agility": 67,
      "physical": 41,
      "technique": 68
    }
  },
  {
    "id": 5052,
    "name": "Brandt",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/1/t1u7e4pbzu8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 56,
      "control": 48,
      "pressure": 56,
      "agility": 66,
      "physical": 59,
      "technique": 57
    }
  },
  {
    "id": 5053,
    "name": "Chancer Cosgrave",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/u/8ufxywmooas.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 49,
      "control": 57,
      "pressure": 60,
      "agility": 53,
      "physical": 51,
      "technique": 44
    }
  },
  {
    "id": 5054,
    "name": "Drako Bonner",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/t/ttxlmsf8wj0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 72,
      "control": 54,
      "pressure": 60,
      "agility": 56,
      "physical": 49,
      "technique": 52
    }
  },
  {
    "id": 5055,
    "name": "Deor Rummond",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/r/3rzwnevxqa8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 84,
      "intelligence": 53,
      "control": 42,
      "pressure": 52,
      "agility": 62,
      "physical": 51,
      "technique": 67
    }
  },
  {
    "id": 5056,
    "name": "Anson Barker",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/t/yt9j7swpaw8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 57,
      "control": 79,
      "pressure": 58,
      "agility": 48,
      "physical": 47,
      "technique": 64
    }
  },
  {
    "id": 5057,
    "name": "Jaxon Taggart",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/-/x-qf0dgfl6m.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 44,
      "control": 40,
      "pressure": 71,
      "agility": 53,
      "physical": 58,
      "technique": 42
    }
  },
  {
    "id": 5058,
    "name": "The Second",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/f/ffo_begdops.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 71,
      "control": 70,
      "pressure": 50,
      "agility": 46,
      "physical": 49,
      "technique": 67
    }
  },
  {
    "id": 5059,
    "name": "Reuben Sidegate",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/t/ut_eshg5f8e.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 47,
      "control": 58,
      "pressure": 74,
      "agility": 55,
      "physical": 57,
      "technique": 43
    }
  },
  {
    "id": 5060,
    "name": "Garrison Hayfield",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/1/o1x9fdy5nc8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 57,
      "control": 45,
      "pressure": 69,
      "agility": 49,
      "physical": 78,
      "technique": 60
    }
  },
  {
    "id": 5061,
    "name": "Swae Talltree",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/f/lfcjdu0om8c.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 41,
      "control": 44,
      "pressure": 76,
      "agility": 50,
      "physical": 53,
      "technique": 60
    }
  },
  {
    "id": 5062,
    "name": "Chilton Churner",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/a/ua0iwatx48m.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 45,
      "control": 54,
      "pressure": 60,
      "agility": 43,
      "physical": 69,
      "technique": 53
    }
  },
  {
    "id": 5063,
    "name": "Seon Gulliver",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/d/_dmcoi-dgvu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 53,
      "control": 48,
      "pressure": 62,
      "agility": 42,
      "physical": 64,
      "technique": 42
    }
  },
  {
    "id": 5064,
    "name": "Plume Hathaway",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/y/0yqd9mna-ve.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 69,
      "control": 69,
      "pressure": 52,
      "agility": 51,
      "physical": 54,
      "technique": 53
    }
  },
  {
    "id": 5065,
    "name": "Peridot Runehart",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/d/gdmwfcrwswc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 72,
      "control": 72,
      "pressure": 60,
      "agility": 42,
      "physical": 58,
      "technique": 72
    }
  },
  {
    "id": 5066,
    "name": "Jewel Tremaine",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/t/dtc1vmznqjk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 55,
      "control": 67,
      "pressure": 52,
      "agility": 56,
      "physical": 57,
      "technique": 62
    }
  },
  {
    "id": 5067,
    "name": "Carlton Lawstrom",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/5/25xbtv127pe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 59,
      "control": 63,
      "pressure": 50,
      "agility": 47,
      "physical": 48,
      "technique": 63
    }
  },
  {
    "id": 5068,
    "name": "Kean Aimes",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/r/hrmg-qtmwas.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 41,
      "control": 58,
      "pressure": 59,
      "agility": 71,
      "physical": 54,
      "technique": 50
    }
  },
  {
    "id": 5069,
    "name": "Asuna Sugami",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/w/ww00aia-oj0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 58,
      "control": 50,
      "pressure": 46,
      "agility": 69,
      "physical": 53,
      "technique": 59
    }
  },
  {
    "id": 5070,
    "name": "Reamond Lockhard",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/w/fwh8qzbgtcs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 58,
      "control": 56,
      "pressure": 48,
      "agility": 63,
      "physical": 60,
      "technique": 62
    }
  },
  {
    "id": 5071,
    "name": "Beryl Granger",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/3/u3zoursslp0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 55,
      "control": 52,
      "pressure": 46,
      "agility": 73,
      "physical": 43,
      "technique": 72
    }
  },
  {
    "id": 5072,
    "name": "Quip Netley",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/8/98hag7svlpu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 61,
      "control": 68,
      "pressure": 41,
      "agility": 41,
      "physical": 49,
      "technique": 53
    }
  },
  {
    "id": 5073,
    "name": "Imogen Greenbourne",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/y/fyfp7_llvpk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 59,
      "control": 65,
      "pressure": 48,
      "agility": 41,
      "physical": 42,
      "technique": 51
    }
  },
  {
    "id": 5074,
    "name": "Summers Laughlin",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/1/r19ryj3kbd0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 70,
      "control": 55,
      "pressure": 58,
      "agility": 59,
      "physical": 48,
      "technique": 52
    }
  },
  {
    "id": 5075,
    "name": "Kata Caballo",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/7/s7zu4z_d96m.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 60,
      "control": 54,
      "pressure": 51,
      "agility": 41,
      "physical": 55,
      "technique": 42
    }
  },
  {
    "id": 5076,
    "name": "Julie Page",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/j/8jonirbgzak.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 60,
      "control": 50,
      "pressure": 48,
      "agility": 61,
      "physical": 44,
      "technique": 65
    }
  },
  {
    "id": 5077,
    "name": "Hopkins Foamcrest",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/l/nl_glun8epm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 41,
      "control": 58,
      "pressure": 66,
      "agility": 53,
      "physical": 60,
      "technique": 43
    }
  },
  {
    "id": 5078,
    "name": "Melvin Moodry",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/m/cmtsbm0og6u.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 47,
      "control": 58,
      "pressure": 74,
      "agility": 53,
      "physical": 59,
      "technique": 59
    }
  },
  {
    "id": 5079,
    "name": "Hawke Ambrose",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/k/tkcz2zs0rj8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 53,
      "control": 78,
      "pressure": 52,
      "agility": 58,
      "physical": 59,
      "technique": 64
    }
  },
  {
    "id": 5080,
    "name": "Chat Baltauk",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/r/8rq7cvevh2s.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 58,
      "control": 43,
      "pressure": 67,
      "agility": 60,
      "physical": 73,
      "technique": 57
    }
  },
  {
    "id": 5081,
    "name": "Elric Spiech",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/3/v3_zsufxaj0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 53,
      "control": 45,
      "pressure": 68,
      "agility": 44,
      "physical": 75,
      "technique": 59
    }
  },
  {
    "id": 5082,
    "name": "Habib Liomont",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/w/-wtnsmmdcws.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 45,
      "control": 45,
      "pressure": 56,
      "agility": 40,
      "physical": 51,
      "technique": 59
    }
  },
  {
    "id": 5083,
    "name": "Histrion Etcher",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/d/bdarjjct9cc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 44,
      "control": 40,
      "pressure": 63,
      "agility": 50,
      "physical": 64,
      "technique": 58
    }
  },
  {
    "id": 5084,
    "name": "Nelvin Dustrie",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/1/q1xkoc6pqv0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 78,
      "control": 71,
      "pressure": 52,
      "agility": 50,
      "physical": 45,
      "technique": 50
    }
  },
  {
    "id": 5085,
    "name": "Keepie Upshire",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/f/efos_r5l3qc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 73,
      "control": 70,
      "pressure": 43,
      "agility": 46,
      "physical": 48,
      "technique": 60
    }
  },
  {
    "id": 5086,
    "name": "Jorna Privinski",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/-/c-jorirnywc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 67,
      "control": 76,
      "pressure": 54,
      "agility": 43,
      "physical": 49,
      "technique": 66
    }
  },
  {
    "id": 5087,
    "name": "Marcelline Memoir",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/y/pycgbzq5vde.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 72,
      "control": 57,
      "pressure": 44,
      "agility": 42,
      "physical": 58,
      "technique": 54
    }
  },
  {
    "id": 5088,
    "name": "Staton Folhard",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/d/edqhudzgxdu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 70,
      "control": 66,
      "pressure": 59,
      "agility": 50,
      "physical": 48,
      "technique": 60
    }
  },
  {
    "id": 5089,
    "name": "Aurelio Auditus",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/5/n5bavq4vqfe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 47,
      "control": 45,
      "pressure": 54,
      "agility": 76,
      "physical": 44,
      "technique": 59
    }
  },
  {
    "id": 5090,
    "name": "Wilhelmina Goforth",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/1/11bm5ivacw8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 41,
      "control": 48,
      "pressure": 48,
      "agility": 67,
      "physical": 55,
      "technique": 49
    }
  },
  {
    "id": 5091,
    "name": "Basil Wanderbilt",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/a/va4tq_gspqm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 82,
      "intelligence": 44,
      "control": 55,
      "pressure": 46,
      "agility": 53,
      "physical": 53,
      "technique": 53
    }
  },
  {
    "id": 5092,
    "name": "Odell Farley",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/y/kyjyhagoejk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 48,
      "control": 52,
      "pressure": 60,
      "agility": 55,
      "physical": 63,
      "technique": 57
    }
  },
  {
    "id": 5093,
    "name": "Viki Devine",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/t/mtoupzueblk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 73,
      "control": 60,
      "pressure": 50,
      "agility": 44,
      "physical": 59,
      "technique": 53
    }
  },
  {
    "id": 5094,
    "name": "Horatio Tickner",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/7/x7_pemy-swm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 53,
      "control": 41,
      "pressure": 64,
      "agility": 44,
      "physical": 71,
      "technique": 44
    }
  },
  {
    "id": 5095,
    "name": "Barney Snellman",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/u/3uc6x7h2z28.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 45,
      "control": 51,
      "pressure": 73,
      "agility": 40,
      "physical": 66,
      "technique": 60
    }
  },
  {
    "id": 5096,
    "name": "Maynard Giddings",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/l/2lzdzrqfpfm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 57,
      "control": 55,
      "pressure": 48,
      "agility": 79,
      "physical": 57,
      "technique": 57
    }
  },
  {
    "id": 5097,
    "name": "Lether Penderick",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/j/hjc80umli2k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 56,
      "control": 40,
      "pressure": 53,
      "agility": 69,
      "physical": 59,
      "technique": 60
    }
  },
  {
    "id": 5098,
    "name": "Gael Vehemaint",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/1/31awhbmhobe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 41,
      "control": 53,
      "pressure": 72,
      "agility": 44,
      "physical": 56,
      "technique": 55
    }
  },
  {
    "id": 5099,
    "name": "Mateo Potensio",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/y/sy3auu2xx30.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 52,
      "control": 40,
      "pressure": 75,
      "agility": 54,
      "physical": 69,
      "technique": 43
    }
  },
  {
    "id": 5100,
    "name": "Berta Brunche",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/u/1udkpy0ntde.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 45,
      "control": 58,
      "pressure": 72,
      "agility": 43,
      "physical": 68,
      "technique": 60
    }
  },
  {
    "id": 5101,
    "name": "Targan Snowbringer",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/8/e8srins3aus.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 43,
      "control": 51,
      "pressure": 69,
      "agility": 40,
      "physical": 68,
      "technique": 52
    }
  },
  {
    "id": 5102,
    "name": "Ivar Trialton",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/3/t3-dknskuim.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 47,
      "control": 44,
      "pressure": 67,
      "agility": 53,
      "physical": 55,
      "technique": 50
    }
  },
  {
    "id": 5103,
    "name": "Fergat Silverpine",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/w/8wsx0v_42bu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 65,
      "control": 72,
      "pressure": 45,
      "agility": 44,
      "physical": 58,
      "technique": 51
    }
  },
  {
    "id": 5104,
    "name": "Zain Blizzard",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/f/cfpinykwd7k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 58,
      "control": 71,
      "pressure": 46,
      "agility": 54,
      "physical": 48,
      "technique": 69
    }
  },
  {
    "id": 5105,
    "name": "Hail Homestead",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/a/xa5jyctpd70.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 51,
      "control": 77,
      "pressure": 45,
      "agility": 49,
      "physical": 59,
      "technique": 66
    }
  },
  {
    "id": 5106,
    "name": "Anastasia Mingler",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/d/gdr3m-abfos.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 66,
      "control": 72,
      "pressure": 58,
      "agility": 42,
      "physical": 58,
      "technique": 50
    }
  },
  {
    "id": 5107,
    "name": "Lev Langvil",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/y/myicfj1twic.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 52,
      "control": 42,
      "pressure": 53,
      "agility": 62,
      "physical": 54,
      "technique": 56
    }
  },
  {
    "id": 5108,
    "name": "Arlo Galbrash",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/7/v7-_cfbfy90.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 56,
      "control": 49,
      "pressure": 57,
      "agility": 54,
      "physical": 46,
      "technique": 50
    }
  },
  {
    "id": 5109,
    "name": "Wren Habilton",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/w/jwg7drql6ec.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 40,
      "control": 57,
      "pressure": 51,
      "agility": 57,
      "physical": 47,
      "technique": 64
    }
  },
  {
    "id": 5110,
    "name": "Fifi Frostkin",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/y/nyd2zqzcbo8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 52,
      "control": 46,
      "pressure": 80,
      "agility": 40,
      "physical": 65,
      "technique": 42
    }
  },
  {
    "id": 5111,
    "name": "Yetzy Klaus",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/w/vw5fku-mrom.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 57,
      "control": 49,
      "pressure": 58,
      "agility": 58,
      "physical": 62,
      "technique": 59
    }
  },
  {
    "id": 5112,
    "name": "Bayard Boreas",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/-/e-i-jrycg9k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 45,
      "control": 47,
      "pressure": 44,
      "agility": 68,
      "physical": 47,
      "technique": 65
    }
  },
  {
    "id": 5113,
    "name": "Elon Entremet",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/r/-rrla2tuzdu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 43,
      "control": 60,
      "pressure": 67,
      "agility": 58,
      "physical": 68,
      "technique": 57
    }
  },
  {
    "id": 5114,
    "name": "Clifford Chillard",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/o/_oesuca9luk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 44,
      "control": 54,
      "pressure": 60,
      "agility": 42,
      "physical": 66,
      "technique": 56
    }
  },
  {
    "id": 5115,
    "name": "Adovis Albleicher",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/m/om1n5jmhidm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 58,
      "control": 48,
      "pressure": 62,
      "agility": 58,
      "physical": 63,
      "technique": 58
    }
  },
  {
    "id": 5116,
    "name": "Rufery Faire",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/h/ghpyrgritjs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 52,
      "control": 52,
      "pressure": 65,
      "agility": 56,
      "physical": 71,
      "technique": 50
    }
  },
  {
    "id": 5117,
    "name": "Willard Headdon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/h/zhaq79qww20.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 43,
      "control": 50,
      "pressure": 67,
      "agility": 47,
      "physical": 68,
      "technique": 56
    }
  },
  {
    "id": 5118,
    "name": "Eames Rapport",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/a/iaieffdkols.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 51,
      "control": 45,
      "pressure": 61,
      "agility": 48,
      "physical": 69,
      "technique": 55
    }
  },
  {
    "id": 5119,
    "name": "Gusto Reitonly",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/c/ncg9ztm8ips.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 44,
      "control": 56,
      "pressure": 65,
      "agility": 51,
      "physical": 67,
      "technique": 40
    }
  },
  {
    "id": 5120,
    "name": "Normon Peeveton",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/q/jqdwdsv1dfm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 43,
      "control": 55,
      "pressure": 77,
      "agility": 53,
      "physical": 65,
      "technique": 58
    }
  },
  {
    "id": 5121,
    "name": "Prudence Witt",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/m/xmdmvkc61w0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 69,
      "control": 65,
      "pressure": 46,
      "agility": 52,
      "physical": 57,
      "technique": 54
    }
  },
  {
    "id": 5122,
    "name": "Fabricius Cator",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/t/ytpk9o8hbwu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 56,
      "control": 52,
      "pressure": 49,
      "agility": 50,
      "physical": 42,
      "technique": 70
    }
  },
  {
    "id": 5123,
    "name": "Dion Arbiter",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/o/to5loglefwe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 54,
      "control": 56,
      "pressure": 55,
      "agility": 48,
      "physical": 60,
      "technique": 63
    }
  },
  {
    "id": 5124,
    "name": "Adamas Quarell",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/q/wq3c0sagpae.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 43,
      "control": 59,
      "pressure": 58,
      "agility": 62,
      "physical": 51,
      "technique": 52
    }
  },
  {
    "id": 5125,
    "name": "Norwin Naeve",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/v/cvrxwc2sdfc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 53,
      "control": 55,
      "pressure": 41,
      "agility": 77,
      "physical": 41,
      "technique": 57
    }
  },
  {
    "id": 5126,
    "name": "Faust Fennrick",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/c/4csrutjpu2k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 44,
      "control": 60,
      "pressure": 52,
      "agility": 56,
      "physical": 43,
      "technique": 50
    }
  },
  {
    "id": 5127,
    "name": "Cordelia Collison",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/f/pf-fqxa92l8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 57,
      "control": 71,
      "pressure": 54,
      "agility": 58,
      "physical": 56,
      "technique": 62
    }
  },
  {
    "id": 5128,
    "name": "Brie Brillante",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/o/aost4bkaydc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 60,
      "control": 41,
      "pressure": 65,
      "agility": 59,
      "physical": 57,
      "technique": 53
    }
  },
  {
    "id": 5129,
    "name": "Recco Rectenwald",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/m/ami4txurequ.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 53,
      "control": 43,
      "pressure": 40,
      "agility": 59,
      "physical": 48,
      "technique": 63
    }
  },
  {
    "id": 5130,
    "name": "Kieran Knavenly",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/k/rk5z-oirzj8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 47,
      "control": 42,
      "pressure": 72,
      "agility": 50,
      "physical": 69,
      "technique": 50
    }
  },
  {
    "id": 5131,
    "name": "Alzen Wasruff",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/l/llast19zgdm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 53,
      "control": 55,
      "pressure": 70,
      "agility": 43,
      "physical": 61,
      "technique": 44
    }
  },
  {
    "id": 5132,
    "name": "Helene Justitia",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/u/ku1ljfqwqw8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 60,
      "control": 41,
      "pressure": 73,
      "agility": 41,
      "physical": 78,
      "technique": 41
    }
  },
  {
    "id": 5133,
    "name": "Willoughby Lexford",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/8/78eqog2k9du.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 48,
      "control": 51,
      "pressure": 73,
      "agility": 55,
      "physical": 64,
      "technique": 60
    }
  },
  {
    "id": 5134,
    "name": "Eugenio Provost",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/l/jlbc1woiyo0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 48,
      "control": 50,
      "pressure": 74,
      "agility": 46,
      "physical": 64,
      "technique": 47
    }
  },
  {
    "id": 5135,
    "name": "Pradip Lurning",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/h/uhxmugmeice.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 42,
      "control": 58,
      "pressure": 63,
      "agility": 59,
      "physical": 63,
      "technique": 60
    }
  },
  {
    "id": 5136,
    "name": "Talim Muskel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/k/pk4pml7qhie.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 48,
      "control": 44,
      "pressure": 59,
      "agility": 45,
      "physical": 75,
      "technique": 57
    }
  },
  {
    "id": 5137,
    "name": "Synthian Volkel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/t/atoultp8v9s.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 54,
      "control": 46,
      "pressure": 76,
      "agility": 54,
      "physical": 74,
      "technique": 59
    }
  },
  {
    "id": 5138,
    "name": "Randon Datta",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/o/cotdg4x7sok.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 56,
      "control": 58,
      "pressure": 64,
      "agility": 58,
      "physical": 63,
      "technique": 44
    }
  },
  {
    "id": 5139,
    "name": "Chayce Golana",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/h/xhbgjejtedm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 40,
      "pressure": 64,
      "agility": 55,
      "physical": 62,
      "technique": 48
    }
  },
  {
    "id": 5140,
    "name": "Annalisa Cubon",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/j/tj_jeaej078.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 70,
      "control": 67,
      "pressure": 58,
      "agility": 54,
      "physical": 40,
      "technique": 51
    }
  },
  {
    "id": 5141,
    "name": "Cleo Balbot",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/q/lqcabpco3u0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 57,
      "control": 71,
      "pressure": 60,
      "agility": 47,
      "physical": 48,
      "technique": 59
    }
  },
  {
    "id": 5142,
    "name": "Reubel Kauntless",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/f/rf_1ispgcoe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 55,
      "control": 72,
      "pressure": 44,
      "agility": 48,
      "physical": 53,
      "technique": 51
    }
  },
  {
    "id": 5143,
    "name": "Obert Deance",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/j/4jq9ypoyfbc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 60,
      "control": 57,
      "pressure": 59,
      "agility": 65,
      "physical": 57,
      "technique": 61
    }
  },
  {
    "id": 5144,
    "name": "Zuzu Intel",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/c/6cth2w60adc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 49,
      "control": 59,
      "pressure": 40,
      "agility": 61,
      "physical": 60,
      "technique": 52
    }
  },
  {
    "id": 5145,
    "name": "Bren Techner",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/v/fvat5fqklxs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 42,
      "control": 48,
      "pressure": 67,
      "agility": 54,
      "physical": 71,
      "technique": 41
    }
  },
  {
    "id": 5146,
    "name": "Cognus Sention",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/v/avqbohfxpuk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 42,
      "control": 43,
      "pressure": 62,
      "agility": 47,
      "physical": 59,
      "technique": 42
    }
  },
  {
    "id": 5147,
    "name": "Manila Brickit",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/a/gaj0d8wfcou.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 54,
      "control": 56,
      "pressure": 40,
      "agility": 61,
      "physical": 49,
      "technique": 69
    }
  },
  {
    "id": 5148,
    "name": "Nettie Neuralyn",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/o/ro4vwdwlx98.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 41,
      "control": 40,
      "pressure": 61,
      "agility": 58,
      "physical": 51,
      "technique": 50
    }
  },
  {
    "id": 5149,
    "name": "Deacon Pewter",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/h/ihoozlizziu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 49,
      "control": 57,
      "pressure": 66,
      "agility": 55,
      "physical": 65,
      "technique": 49
    }
  },
  {
    "id": 5150,
    "name": "Soyogi Soyogi",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/r/drc6us6s6bu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 60,
      "control": 58,
      "pressure": 50,
      "agility": 41,
      "physical": 54,
      "technique": 52
    }
  },
  {
    "id": 5151,
    "name": "Silica Fieltour",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/5/y5zbdtcoxo8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 53,
      "control": 58,
      "pressure": 68,
      "agility": 59,
      "physical": 72,
      "technique": 49
    }
  },
  {
    "id": 5156,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5166,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5173,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5174,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5175,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5177,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5178,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5179,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5180,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5181,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5182,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5183,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5184,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5185,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5186,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5187,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5188,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5189,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5190,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5192,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5193,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5194,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5195,
    "name": "Josephine",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/s/jsorkoc-pdm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 47,
      "control": 48,
      "pressure": 56,
      "agility": 59,
      "physical": 56,
      "technique": 62
    }
  },
  {
    "id": 5196,
    "name": "Wagner Waltz",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/r/7r1ksxnhk3k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 30,
      "intelligence": 54,
      "control": 55,
      "pressure": 78,
      "agility": 54,
      "physical": 64,
      "technique": 44
    }
  },
  {
    "id": 5197,
    "name": "Linton Judson",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/w/5wyw8ofrhxk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 55,
      "control": 56,
      "pressure": 47,
      "agility": 70,
      "physical": 48,
      "technique": 62
    }
  },
  {
    "id": 5198,
    "name": "Douglass Serve",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/1/y1expggy_x0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 49,
      "control": 40,
      "pressure": 64,
      "agility": 44,
      "physical": 63,
      "technique": 54
    }
  },
  {
    "id": 5199,
    "name": "Jeremy Yung",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/r/brhmm5u76os.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 50,
      "control": 53,
      "pressure": 69,
      "agility": 56,
      "physical": 68,
      "technique": 46
    }
  },
  {
    "id": 5200,
    "name": "Huxley Tagg",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/w/zwmqig8x_is.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 46,
      "control": 43,
      "pressure": 70,
      "agility": 57,
      "physical": 68,
      "technique": 57
    }
  },
  {
    "id": 5201,
    "name": "Fergus Lougdon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/p/kph0wdrkajm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 53,
      "control": 43,
      "pressure": 61,
      "agility": 52,
      "physical": 68,
      "technique": 52
    }
  },
  {
    "id": 5202,
    "name": "Maximus Cordray",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/i/bi-kvt92tmk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 44,
      "control": 52,
      "pressure": 75,
      "agility": 41,
      "physical": 69,
      "technique": 53
    }
  },
  {
    "id": 5203,
    "name": "Eamon Cattrall",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/k/qkpf4sbma_m.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 72,
      "control": 73,
      "pressure": 42,
      "agility": 52,
      "physical": 58,
      "technique": 67
    }
  },
  {
    "id": 5204,
    "name": "Zayn Pinegrove",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/r/orizw1jgf5m.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 47,
      "control": 48,
      "pressure": 67,
      "agility": 42,
      "physical": 67,
      "technique": 52
    }
  },
  {
    "id": 5205,
    "name": "Kendrick Townsend",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/s/5sanoxasdqu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 52,
      "control": 64,
      "pressure": 60,
      "agility": 44,
      "physical": 42,
      "technique": 66
    }
  },
  {
    "id": 5206,
    "name": "Flynn Duval",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/d/zd547kvaokk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 63,
      "intelligence": 60,
      "control": 40,
      "pressure": 59,
      "agility": 67,
      "physical": 51,
      "technique": 74
    }
  },
  {
    "id": 5207,
    "name": "Paxton Plumfield",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/n/7ndrgoi-ysu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 54,
      "control": 44,
      "pressure": 48,
      "agility": 61,
      "physical": 58,
      "technique": 73
    }
  },
  {
    "id": 5208,
    "name": "Godfrey Shahmann",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/l/klswrxue1f8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 66,
      "control": 69,
      "pressure": 46,
      "agility": 53,
      "physical": 49,
      "technique": 53
    }
  },
  {
    "id": 5209,
    "name": "Nico Kensee",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/p/-ptoa8tmsgu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 58,
      "control": 47,
      "pressure": 77,
      "agility": 52,
      "physical": 63,
      "technique": 59
    }
  },
  {
    "id": 5210,
    "name": "Kurtis Loafinn",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/n/pnij3dlc_t8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 71,
      "control": 69,
      "pressure": 50,
      "agility": 43,
      "physical": 40,
      "technique": 64
    }
  },
  {
    "id": 5211,
    "name": "Gilbert Kraft",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/p/hp5etccve_c.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 42,
      "control": 42,
      "pressure": 70,
      "agility": 40,
      "physical": 69,
      "technique": 52
    }
  },
  {
    "id": 5212,
    "name": "Vicente Olsean",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/n/qnila9kvzm0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 72,
      "control": 72,
      "pressure": 45,
      "agility": 53,
      "physical": 44,
      "technique": 55
    }
  },
  {
    "id": 5213,
    "name": "Ruckus Dinglestar",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/i/wirqtgrngse.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 58,
      "control": 52,
      "pressure": 61,
      "agility": 45,
      "physical": 63,
      "technique": 49
    }
  },
  {
    "id": 5214,
    "name": "Burley Billabong",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/g/bgax-f3drfs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 59,
      "control": 60,
      "pressure": 77,
      "agility": 56,
      "physical": 68,
      "technique": 44
    }
  },
  {
    "id": 5215,
    "name": "Britson Farago",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/b/dbdtqglxuzs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 59,
      "control": 46,
      "pressure": 45,
      "agility": 63,
      "physical": 57,
      "technique": 66
    }
  },
  {
    "id": 5216,
    "name": "Verdy Golnuts",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/p/ypsm95dldqe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 65,
      "control": 78,
      "pressure": 59,
      "agility": 47,
      "physical": 59,
      "technique": 53
    }
  },
  {
    "id": 5217,
    "name": "Zackory Wart",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/g/sgp5uk2d2k0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 46,
      "control": 59,
      "pressure": 52,
      "agility": 71,
      "physical": 54,
      "technique": 47
    }
  },
  {
    "id": 5218,
    "name": "Zoey Tippings",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/i/ximfq_jyxmm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 52,
      "control": 59,
      "pressure": 43,
      "agility": 69,
      "physical": 57,
      "technique": 59
    }
  },
  {
    "id": 5219,
    "name": "Bellie Jerant",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/g/egxcriotqgc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 56,
      "control": 56,
      "pressure": 42,
      "agility": 48,
      "physical": 41,
      "technique": 56
    }
  },
  {
    "id": 5220,
    "name": "Megpie O'Neering",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/l/gl0ludwqp1u.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 40,
      "control": 43,
      "pressure": 73,
      "agility": 42,
      "physical": 56,
      "technique": 54
    }
  },
  {
    "id": 5221,
    "name": "Coby Cogsworth",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/e/eezx6eigszu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 57,
      "control": 49,
      "pressure": 66,
      "agility": 41,
      "physical": 68,
      "technique": 47
    }
  },
  {
    "id": 5222,
    "name": "Gon Vyrall",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/s/1sc2x7e8ba8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 48,
      "control": 51,
      "pressure": 45,
      "agility": 54,
      "physical": 45,
      "technique": 71
    }
  },
  {
    "id": 5223,
    "name": "Cristensen Blance",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/d/vdhdemx00gm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 47,
      "control": 45,
      "pressure": 59,
      "agility": 46,
      "physical": 56,
      "technique": 59
    }
  },
  {
    "id": 5224,
    "name": "Ravyn Grooves",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/r/krqipzxoztk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 69,
      "control": 69,
      "pressure": 40,
      "agility": 48,
      "physical": 44,
      "technique": 57
    }
  },
  {
    "id": 5225,
    "name": "Berlinda Glitz",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/b/qbv6yuus-sm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 54,
      "control": 61,
      "pressure": 54,
      "agility": 57,
      "physical": 58,
      "technique": 61
    }
  },
  {
    "id": 5226,
    "name": "Hedrick Wilspin",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/p/hpeb1rywtfk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 54,
      "control": 52,
      "pressure": 74,
      "agility": 59,
      "physical": 73,
      "technique": 56
    }
  },
  {
    "id": 5227,
    "name": "Marjorette Pompom",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/b/pbfwvq7fyze.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 60,
      "control": 59,
      "pressure": 52,
      "agility": 41,
      "physical": 52,
      "technique": 52
    }
  },
  {
    "id": 5228,
    "name": "Jubilee Meriday",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/p/-p03cvdlfas.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 43,
      "control": 47,
      "pressure": 63,
      "agility": 54,
      "physical": 59,
      "technique": 53
    }
  },
  {
    "id": 5229,
    "name": "Wendy Stitchilton",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/n/3nfq5iwqeg8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 52,
      "control": 54,
      "pressure": 45,
      "agility": 50,
      "physical": 44,
      "technique": 59
    }
  },
  {
    "id": 5230,
    "name": "Fizz Kablooey",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/u/vumj83oxht0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 58,
      "control": 50,
      "pressure": 48,
      "agility": 62,
      "physical": 59,
      "technique": 54
    }
  },
  {
    "id": 5231,
    "name": "Hanz Boll",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/w/gwwzfthijk8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 45,
      "control": 52,
      "pressure": 63,
      "agility": 50,
      "physical": 54,
      "technique": 49
    }
  },
  {
    "id": 5232,
    "name": "Lisa Lovetluke",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/a/naqx_uypl0e.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 83,
      "intelligence": 59,
      "control": 56,
      "pressure": 50,
      "agility": 75,
      "physical": 41,
      "technique": 47
    }
  },
  {
    "id": 5233,
    "name": "Hildy Tattleswell",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/1/h1zeszth-u0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 48,
      "control": 56,
      "pressure": 65,
      "agility": 47,
      "physical": 63,
      "technique": 53
    }
  },
  {
    "id": 5234,
    "name": "Tendance Chausefutt",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/d/2dclbml9tnc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 55,
      "control": 78,
      "pressure": 43,
      "agility": 52,
      "physical": 52,
      "technique": 59
    }
  },
  {
    "id": 5235,
    "name": "Caellum Orison",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/8/08f5vvzrwhc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 55,
      "control": 72,
      "pressure": 55,
      "agility": 52,
      "physical": 40,
      "technique": 56
    }
  },
  {
    "id": 5236,
    "name": "Tina Hopkins",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/u/fu0ycq_r7s0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 62,
      "control": 54,
      "pressure": 57,
      "agility": 55,
      "physical": 54,
      "technique": 55
    }
  },
  {
    "id": 5237,
    "name": "Selen Dippity",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/7/l7xtr3kjoye.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 60,
      "control": 57,
      "pressure": 44,
      "agility": 60,
      "physical": 47,
      "technique": 52
    }
  },
  {
    "id": 5238,
    "name": "Nivea Etoile",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/t/utmm8iszjbs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 54,
      "control": 55,
      "pressure": 58,
      "agility": 59,
      "physical": 76,
      "technique": 47
    }
  },
  {
    "id": 5239,
    "name": "Liam Tossarawn",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/5/g5zunfv7e-e.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 46,
      "control": 50,
      "pressure": 42,
      "agility": 70,
      "physical": 51,
      "technique": 55
    }
  },
  {
    "id": 5240,
    "name": "Ferron Rockfort",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/r/rro1g6jbpns.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 52,
      "control": 41,
      "pressure": 69,
      "agility": 46,
      "physical": 60,
      "technique": 58
    }
  },
  {
    "id": 5241,
    "name": "Wily Wimpinberg",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/5/_5z467aiihm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 56,
      "control": 65,
      "pressure": 44,
      "agility": 40,
      "physical": 50,
      "technique": 59
    }
  },
  {
    "id": 5242,
    "name": "Tally McIntosh",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/-/r-n4yshykxu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 46,
      "control": 51,
      "pressure": 48,
      "agility": 66,
      "physical": 56,
      "technique": 64
    }
  },
  {
    "id": 5243,
    "name": "Brenae Ackermann",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/t/3tipdwoniou.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 71,
      "control": 60,
      "pressure": 57,
      "agility": 57,
      "physical": 40,
      "technique": 62
    }
  },
  {
    "id": 5244,
    "name": "Jester Biggs",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/n/3n9umho9if8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 52,
      "control": 57,
      "pressure": 47,
      "agility": 41,
      "physical": 42,
      "technique": 57
    }
  },
  {
    "id": 5245,
    "name": "Alexei Einmeister",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/i/xiehf871xlm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 80,
      "control": 61,
      "pressure": 42,
      "agility": 41,
      "physical": 60,
      "technique": 57
    }
  },
  {
    "id": 5246,
    "name": "Edmin Streator",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/k/mkvayddp6wk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 72,
      "control": 56,
      "pressure": 44,
      "agility": 60,
      "physical": 45,
      "technique": 56
    }
  },
  {
    "id": 5247,
    "name": "Codey Presto",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/r/kroccapj_qk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 53,
      "control": 58,
      "pressure": 54,
      "agility": 55,
      "physical": 64,
      "technique": 53
    }
  },
  {
    "id": 5248,
    "name": "Finck Zaplan",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/d/vdz9xlpzsjm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 60,
      "control": 43,
      "pressure": 59,
      "agility": 40,
      "physical": 66,
      "technique": 45
    }
  },
  {
    "id": 5249,
    "name": "Cid Drewend",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/s/1s6ii4crnd8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 58,
      "control": 41,
      "pressure": 69,
      "agility": 60,
      "physical": 60,
      "technique": 44
    }
  },
  {
    "id": 5250,
    "name": "Aylin Terpheis",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/e/eelpph6rkwu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 57,
      "control": 49,
      "pressure": 75,
      "agility": 56,
      "physical": 60,
      "technique": 51
    }
  },
  {
    "id": 5251,
    "name": "Keyston Typewright",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/u/wu0x-k5jtp8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 53,
      "control": 60,
      "pressure": 81,
      "agility": 42,
      "physical": 69,
      "technique": 51
    }
  },
  {
    "id": 5252,
    "name": "Vivi DeHues",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/g/bgfqt1fza8u.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 50,
      "control": 52,
      "pressure": 45,
      "agility": 66,
      "physical": 55,
      "technique": 70
    }
  },
  {
    "id": 5253,
    "name": "Petra Cornerstone",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/u/vuedj0w6hq0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 49,
      "control": 49,
      "pressure": 74,
      "agility": 58,
      "physical": 69,
      "technique": 52
    }
  },
  {
    "id": 5254,
    "name": "Choco Racketfeld",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/w/_w81otorf70.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 40,
      "control": 45,
      "pressure": 47,
      "agility": 70,
      "physical": 53,
      "technique": 65
    }
  },
  {
    "id": 5255,
    "name": "Minty Shuttlebrook",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/-/o-nufsoroic.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 55,
      "control": 58,
      "pressure": 41,
      "agility": 57,
      "physical": 45,
      "technique": 60
    }
  },
  {
    "id": 5256,
    "name": "Phoebe Soarsky",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/9/09m6wqwn8kc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 55,
      "control": 52,
      "pressure": 50,
      "agility": 40,
      "physical": 69,
      "technique": 51
    }
  },
  {
    "id": 5257,
    "name": "Helen Deavor",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/s/usvpjnfvjes.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 51,
      "control": 54,
      "pressure": 74,
      "agility": 48,
      "physical": 67,
      "technique": 42
    }
  },
  {
    "id": 5258,
    "name": "Janet Hollilocks",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/6/l6euoyjvk3e.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 56,
      "control": 43,
      "pressure": 57,
      "agility": 50,
      "physical": 57,
      "technique": 49
    }
  },
  {
    "id": 5259,
    "name": "Barnaby Livergain",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/b/nbzygrx5hxe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 63,
      "control": 66,
      "pressure": 58,
      "agility": 49,
      "physical": 47,
      "technique": 63
    }
  },
  {
    "id": 5260,
    "name": "Sten Fanborough",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/z/wzotnuxdmcs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 78,
      "control": 65,
      "pressure": 57,
      "agility": 45,
      "physical": 53,
      "technique": 57
    }
  },
  {
    "id": 5261,
    "name": "Crest Vertall",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/c/2clmejil5ic.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 69,
      "control": 57,
      "pressure": 60,
      "agility": 46,
      "physical": 49,
      "technique": 64
    }
  },
  {
    "id": 5262,
    "name": "Wyatt Stockaway",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/0/h06hz2exur0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 26,
      "intelligence": 49,
      "control": 55,
      "pressure": 81,
      "agility": 59,
      "physical": 62,
      "technique": 60
    }
  },
  {
    "id": 5263,
    "name": "Pristin Florynce",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/e/zeffc7htzuc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 75,
      "control": 62,
      "pressure": 47,
      "agility": 46,
      "physical": 49,
      "technique": 62
    }
  },
  {
    "id": 5264,
    "name": "Edmund Boon",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/2/c20-vehped0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 40,
      "control": 49,
      "pressure": 74,
      "agility": 45,
      "physical": 61,
      "technique": 41
    }
  },
  {
    "id": 5265,
    "name": "Willem Durrmore",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/e/sevz1fog_xu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 51,
      "control": 40,
      "pressure": 75,
      "agility": 59,
      "physical": 67,
      "technique": 40
    }
  },
  {
    "id": 5266,
    "name": "Corday Dremin",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/2/d2esy6oasc8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 48,
      "control": 57,
      "pressure": 51,
      "agility": 55,
      "physical": 49,
      "technique": 60
    }
  },
  {
    "id": 5267,
    "name": "Candace Mardipanz",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/z/9z9nln7snim.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 63,
      "control": 60,
      "pressure": 59,
      "agility": 48,
      "physical": 56,
      "technique": 54
    }
  },
  {
    "id": 5268,
    "name": "Gloria Somdenn",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/x/mxmgmydokrk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 46,
      "control": 51,
      "pressure": 57,
      "agility": 71,
      "physical": 57,
      "technique": 62
    }
  },
  {
    "id": 5269,
    "name": "Ryden Waverley",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/5/f5fa7w7zwbe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 57,
      "control": 69,
      "pressure": 42,
      "agility": 48,
      "physical": 42,
      "technique": 58
    }
  },
  {
    "id": 5270,
    "name": "Safine Papillonia",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/s/usxxwodcvhs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 53,
      "control": 43,
      "pressure": 46,
      "agility": 66,
      "physical": 43,
      "technique": 53
    }
  },
  {
    "id": 5271,
    "name": "Caspian Hearken",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/9/090eftokanc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 76,
      "control": 59,
      "pressure": 53,
      "agility": 50,
      "physical": 58,
      "technique": 61
    }
  },
  {
    "id": 5272,
    "name": "Davis Tarvish",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/v/fvflosow3u0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 49,
      "control": 50,
      "pressure": 49,
      "agility": 66,
      "physical": 40,
      "technique": 67
    }
  },
  {
    "id": 5273,
    "name": "Bastian Brineford",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/0/h0c5g1ccys0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 71,
      "control": 65,
      "pressure": 48,
      "agility": 60,
      "physical": 54,
      "technique": 66
    }
  },
  {
    "id": 5274,
    "name": "Kenneth Frostner",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/c/2czyrk6mfhc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 74,
      "control": 56,
      "pressure": 58,
      "agility": 47,
      "physical": 53,
      "technique": 63
    }
  },
  {
    "id": 5275,
    "name": "Ripley Swaydon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/z/wzqt4xpuqbs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 56,
      "control": 41,
      "pressure": 61,
      "agility": 51,
      "physical": 73,
      "technique": 46
    }
  },
  {
    "id": 5276,
    "name": "Kyle Flaggard",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/b/nbhmvopuhye.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 54,
      "control": 46,
      "pressure": 57,
      "agility": 42,
      "physical": 73,
      "technique": 52
    }
  },
  {
    "id": 5277,
    "name": "Landric Delphin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/x/txeuklq2gns.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 40,
      "control": 53,
      "pressure": 76,
      "agility": 56,
      "physical": 57,
      "technique": 48
    }
  },
  {
    "id": 5278,
    "name": "Volbert Brackenbal",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/z/izv1jammn-e.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 50,
      "control": 48,
      "pressure": 80,
      "agility": 47,
      "physical": 57,
      "technique": 50
    }
  },
  {
    "id": 5279,
    "name": "Niles Gawkerson",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/x/mx04tbffssk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 54,
      "control": 58,
      "pressure": 65,
      "agility": 58,
      "physical": 59,
      "technique": 40
    }
  },
  {
    "id": 5280,
    "name": "Cecilia Alabaster",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/z/9zfz-kj_bhm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 42,
      "control": 44,
      "pressure": 73,
      "agility": 47,
      "physical": 69,
      "technique": 53
    }
  },
  {
    "id": 5281,
    "name": "Pinn Persica",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/2/d2mst5w30b8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 59,
      "control": 52,
      "pressure": 55,
      "agility": 50,
      "physical": 64,
      "technique": 52
    }
  },
  {
    "id": 5282,
    "name": "Karina Rosenqueen",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/y/dyycvpp11de.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 47,
      "control": 43,
      "pressure": 61,
      "agility": 40,
      "physical": 64,
      "technique": 52
    }
  },
  {
    "id": 5283,
    "name": "Micco Chantelle",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/f/ef6ulblwg2u.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 55,
      "control": 50,
      "pressure": 50,
      "agility": 75,
      "physical": 42,
      "technique": 65
    }
  },
  {
    "id": 5284,
    "name": "Shena Ennigans",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/q/kqzh2c-4zwk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 64,
      "control": 58,
      "pressure": 54,
      "agility": 40,
      "physical": 53,
      "technique": 66
    }
  },
  {
    "id": 5285,
    "name": "Alanna Ordelyne",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/c/vcoabjycelm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 70,
      "control": 67,
      "pressure": 43,
      "agility": 46,
      "physical": 41,
      "technique": 67
    }
  },
  {
    "id": 5286,
    "name": "Patrice Kampanee",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/j/xjvc16kubjm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 69,
      "control": 54,
      "pressure": 47,
      "agility": 49,
      "physical": 42,
      "technique": 68
    }
  },
  {
    "id": 5287,
    "name": "Aubrey McCoy",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/l/mle9yfsu2qk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 63,
      "control": 68,
      "pressure": 57,
      "agility": 50,
      "physical": 47,
      "technique": 48
    }
  },
  {
    "id": 5288,
    "name": "Erina Haberdash",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/k/gk9ilyzcdwu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 70,
      "control": 59,
      "pressure": 56,
      "agility": 58,
      "physical": 56,
      "technique": 70
    }
  },
  {
    "id": 5289,
    "name": "Roxy Roarke",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/m/3mmpmn_mud8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 57,
      "control": 53,
      "pressure": 72,
      "agility": 53,
      "physical": 54,
      "technique": 57
    }
  },
  {
    "id": 5290,
    "name": "Frey Granzburn",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/m/dmzxxq8ej8u.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 58,
      "control": 53,
      "pressure": 58,
      "agility": 48,
      "physical": 75,
      "technique": 50
    }
  },
  {
    "id": 5291,
    "name": "Silky Fersken",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/o/yocq6va-kp8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 53,
      "control": 40,
      "pressure": 78,
      "agility": 59,
      "physical": 52,
      "technique": 43
    }
  },
  {
    "id": 5292,
    "name": "Aura Tempesta",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/m/cmzdgut3fjc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 40,
      "control": 52,
      "pressure": 57,
      "agility": 48,
      "physical": 60,
      "technique": 55
    }
  },
  {
    "id": 5293,
    "name": "Teagan Leafhart",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/o/too8nr1noq0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 49,
      "control": 58,
      "pressure": 50,
      "agility": 58,
      "physical": 61,
      "technique": 59
    }
  },
  {
    "id": 5294,
    "name": "Livia Marsquall",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/h/nhlje2afdwe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 56,
      "control": 55,
      "pressure": 72,
      "agility": 54,
      "physical": 60,
      "technique": 42
    }
  },
  {
    "id": 5295,
    "name": "Isanna Countenford",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/j/8j6ozjm_wds.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 56,
      "control": 60,
      "pressure": 60,
      "agility": 46,
      "physical": 63,
      "technique": 46
    }
  },
  {
    "id": 5296,
    "name": "Minerva Elderbright",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/o/-o90dq0t1fs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 76,
      "control": 68,
      "pressure": 57,
      "agility": 60,
      "physical": 47,
      "technique": 65
    }
  },
  {
    "id": 5297,
    "name": "Faris Creed",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/w/swp94wppyus.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 76,
      "control": 76,
      "pressure": 56,
      "agility": 44,
      "physical": 51,
      "technique": 48
    }
  },
  {
    "id": 5298,
    "name": "Sophia Goston",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/z/tz0svth2ses.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 58,
      "control": 67,
      "pressure": 57,
      "agility": 44,
      "physical": 60,
      "technique": 69
    }
  },
  {
    "id": 5299,
    "name": "Stellan Checkman",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/c/zcxz8wu-nkc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 65,
      "control": 62,
      "pressure": 45,
      "agility": 53,
      "physical": 52,
      "technique": 62
    }
  },
  {
    "id": 5300,
    "name": "Ayla Bordaire",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/0/c0m4rpyekx0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 55,
      "control": 47,
      "pressure": 47,
      "agility": 70,
      "physical": 42,
      "technique": 55
    }
  },
  {
    "id": 5301,
    "name": "Jerome Knight",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/v/avhk_wgopr0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 51,
      "control": 72,
      "pressure": 41,
      "agility": 43,
      "physical": 41,
      "technique": 61
    }
  },
  {
    "id": 5302,
    "name": "Harris Gridley",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/9/x9qfspgsiic.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 53,
      "control": 65,
      "pressure": 53,
      "agility": 49,
      "physical": 45,
      "technique": 63
    }
  },
  {
    "id": 5303,
    "name": "Pierce Castleton",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/s/rszwb0zaxcs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 55,
      "control": 44,
      "pressure": 46,
      "agility": 52,
      "physical": 42,
      "technique": 71
    }
  },
  {
    "id": 5304,
    "name": "Link Whitstone",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/6/g6crslvg6xe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 48,
      "control": 57,
      "pressure": 50,
      "agility": 58,
      "physical": 60,
      "technique": 50
    }
  },
  {
    "id": 5305,
    "name": "Whitney Blackrock",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/q/uq9jdgwcdos.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 41,
      "control": 49,
      "pressure": 53,
      "agility": 51,
      "physical": 74,
      "technique": 52
    }
  },
  {
    "id": 5306,
    "name": "Vivienne Starling",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/4/l4mow5w4w9e.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 44,
      "control": 53,
      "pressure": 63,
      "agility": 53,
      "physical": 59,
      "technique": 40
    }
  },
  {
    "id": 5307,
    "name": "Bartholomew Blitzer",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/f/mfkirl6htoc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 45,
      "control": 43,
      "pressure": 77,
      "agility": 51,
      "physical": 56,
      "technique": 44
    }
  },
  {
    "id": 5308,
    "name": "Heathcliff Humbold",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/k/dkzjci3e71u.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 70,
      "control": 60,
      "pressure": 53,
      "agility": 43,
      "physical": 51,
      "technique": 54
    }
  },
  {
    "id": 5309,
    "name": "Tufton Frizzell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/l/jl68p_cmovk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 65,
      "control": 56,
      "pressure": 57,
      "agility": 52,
      "physical": 44,
      "technique": 51
    }
  },
  {
    "id": 5310,
    "name": "Eldon Compayne",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/j/sjldiak2jmm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 56,
      "control": 53,
      "pressure": 63,
      "agility": 41,
      "physical": 68,
      "technique": 41
    }
  },
  {
    "id": 5311,
    "name": "Lysander Trimore",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/c/qcmbmz2amgm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 45,
      "control": 54,
      "pressure": 57,
      "agility": 41,
      "physical": 67,
      "technique": 55
    }
  },
  {
    "id": 5312,
    "name": "Hapleigh Mistakian",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/q/hq9ghmqgltk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 65,
      "control": 52,
      "pressure": 59,
      "agility": 52,
      "physical": 42,
      "technique": 70
    }
  },
  {
    "id": 5313,
    "name": "Seph T. Forst",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/f/bfevy7lo-zu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 68,
      "control": 71,
      "pressure": 46,
      "agility": 57,
      "physical": 52,
      "technique": 56
    }
  },
  {
    "id": 5314,
    "name": "Cuthbert Obelidge",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/t/wtv0fedsta8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 50,
      "control": 48,
      "pressure": 48,
      "agility": 58,
      "physical": 60,
      "technique": 55
    }
  },
  {
    "id": 5315,
    "name": "Bernadine Banquet",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/h/ehqsujaw0_u.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 59,
      "control": 60,
      "pressure": 60,
      "agility": 66,
      "physical": 56,
      "technique": 50
    }
  },
  {
    "id": 5316,
    "name": "Isolde Bourgeon",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/v/1vhnd2mkzm8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 46,
      "control": 41,
      "pressure": 73,
      "agility": 49,
      "physical": 58,
      "technique": 45
    }
  },
  {
    "id": 5317,
    "name": "Dashiell Fass",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/h/bh6az3vd4gc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 60,
      "control": 72,
      "pressure": 56,
      "agility": 59,
      "physical": 42,
      "technique": 66
    }
  },
  {
    "id": 5318,
    "name": "Feodor Wayte",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/v/qvlh0ij5vt0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 79,
      "control": 70,
      "pressure": 46,
      "agility": 40,
      "physical": 53,
      "technique": 48
    }
  },
  {
    "id": 5319,
    "name": "Zacharias Klutchett",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/a/kaounv8xgze.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 72,
      "control": 65,
      "pressure": 45,
      "agility": 54,
      "physical": 53,
      "technique": 55
    }
  },
  {
    "id": 5320,
    "name": "Adele Lettante",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/o/7oz1kqalnas.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 42,
      "control": 50,
      "pressure": 69,
      "agility": 45,
      "physical": 53,
      "technique": 47
    }
  },
  {
    "id": 5321,
    "name": "Casper Forman",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/q/7qnsj-pfhie.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 69,
      "control": 75,
      "pressure": 40,
      "agility": 46,
      "physical": 49,
      "technique": 57
    }
  },
  {
    "id": 5322,
    "name": "Jensen Nariopoulos",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/f/bfuzwj6nyc0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 54,
      "control": 44,
      "pressure": 70,
      "agility": 41,
      "physical": 67,
      "technique": 50
    }
  },
  {
    "id": 5323,
    "name": "Lester Bawlund",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/t/qtf4dcc3fxc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 53,
      "control": 49,
      "pressure": 75,
      "agility": 47,
      "physical": 61,
      "technique": 51
    }
  },
  {
    "id": 5324,
    "name": "Hernan Rippett",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/m/omykzfoba3c.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 67,
      "control": 65,
      "pressure": 55,
      "agility": 58,
      "physical": 42,
      "technique": 46
    }
  },
  {
    "id": 5325,
    "name": "Cosette Lyricotte",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/k/zkpfe6oh3e0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 65,
      "control": 68,
      "pressure": 54,
      "agility": 60,
      "physical": 40,
      "technique": 60
    }
  },
  {
    "id": 5326,
    "name": "Winifred Wardrow",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/l/5lkwnndpcke.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 59,
      "control": 72,
      "pressure": 48,
      "agility": 56,
      "physical": 42,
      "technique": 59
    }
  },
  {
    "id": 5327,
    "name": "Sona Sondheim",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/j/ij7rgy7tvxs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 57,
      "control": 45,
      "pressure": 72,
      "agility": 47,
      "physical": 73,
      "technique": 53
    }
  },
  {
    "id": 5328,
    "name": "Iza Improvelli",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/j/8jejrv4xioe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 65,
      "control": 71,
      "pressure": 40,
      "agility": 41,
      "physical": 50,
      "technique": 72
    }
  },
  {
    "id": 5329,
    "name": "Carole Meine",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/h/nh1o8qellbs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 50,
      "control": 54,
      "pressure": 55,
      "agility": 71,
      "physical": 58,
      "technique": 57
    }
  },
  {
    "id": 5330,
    "name": "Coco Lajoie",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/j/jjulmrxce3m.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 60,
      "control": 44,
      "pressure": 66,
      "agility": 43,
      "physical": 66,
      "technique": 45
    }
  },
  {
    "id": 5331,
    "name": "Orlando Sterlight",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/h/shfelux4pek.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 48,
      "control": 49,
      "pressure": 66,
      "agility": 42,
      "physical": 58,
      "technique": 59
    }
  },
  {
    "id": 5332,
    "name": "Wentworth Wiggins",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/o/yo8xyjewcku.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 52,
      "control": 55,
      "pressure": 65,
      "agility": 60,
      "physical": 72,
      "technique": 43
    }
  },
  {
    "id": 5333,
    "name": "Pina Propp",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/m/dmnq12ikxx8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 65,
      "control": 56,
      "pressure": 43,
      "agility": 60,
      "physical": 46,
      "technique": 62
    }
  },
  {
    "id": 5334,
    "name": "Mika Upton",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/h/bhkmbvwm0r8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 63,
      "control": 59,
      "pressure": 58,
      "agility": 52,
      "physical": 53,
      "technique": 61
    }
  },
  {
    "id": 5335,
    "name": "Trix Rosenblum",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/3/937pg0c9a90.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 43,
      "control": 57,
      "pressure": 52,
      "agility": 68,
      "physical": 57,
      "technique": 52
    }
  },
  {
    "id": 5336,
    "name": "Barcley Dover",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/9/r9gjqxz3ut8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 43,
      "control": 49,
      "pressure": 43,
      "agility": 56,
      "physical": 56,
      "technique": 61
    }
  },
  {
    "id": 5337,
    "name": "Mora Grimmoir",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/s/lsd8dss_bzm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 55,
      "control": 47,
      "pressure": 72,
      "agility": 54,
      "physical": 67,
      "technique": 59
    }
  },
  {
    "id": 5338,
    "name": "Norma Paranon",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/6/66ydutkf2ak.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 59,
      "control": 68,
      "pressure": 46,
      "agility": 53,
      "physical": 44,
      "technique": 69
    }
  },
  {
    "id": 5339,
    "name": "Roderick Sawsbury",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/b/4b1bakypzgk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 30,
      "intelligence": 59,
      "control": 41,
      "pressure": 57,
      "agility": 53,
      "physical": 70,
      "technique": 54
    }
  },
  {
    "id": 5340,
    "name": "Kipp Sycamore",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/z/jzegt1-te1m.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 40,
      "control": 57,
      "pressure": 62,
      "agility": 40,
      "physical": 74,
      "technique": 45
    }
  },
  {
    "id": 5341,
    "name": "Clarissa Gimmich",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/c/pcnv-olbrv8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 66,
      "control": 63,
      "pressure": 53,
      "agility": 47,
      "physical": 49,
      "technique": 53
    }
  },
  {
    "id": 5342,
    "name": "Pennie Pound",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/0/y0w0txthgmu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 63,
      "control": 73,
      "pressure": 51,
      "agility": 47,
      "physical": 52,
      "technique": 61
    }
  },
  {
    "id": 5343,
    "name": "Joyce Deckard",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/e/sepsiaudhz8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 53,
      "control": 59,
      "pressure": 67,
      "agility": 44,
      "physical": 71,
      "technique": 56
    }
  },
  {
    "id": 5344,
    "name": "Nasser Pryce",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/2/d2ynpli5mqu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 80,
      "intelligence": 55,
      "control": 49,
      "pressure": 44,
      "agility": 56,
      "physical": 57,
      "technique": 61
    }
  },
  {
    "id": 5345,
    "name": "Zuna Yokochenko",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/d/jdex35ffncc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 41,
      "control": 59,
      "pressure": 40,
      "agility": 62,
      "physical": 58,
      "technique": 71
    }
  },
  {
    "id": 5346,
    "name": "Stouton Savant",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/w/fwozclttbc8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 43,
      "control": 59,
      "pressure": 66,
      "agility": 48,
      "physical": 65,
      "technique": 45
    }
  },
  {
    "id": 5347,
    "name": "Finnes Grapplefeld",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/-/u-zsxalx2xu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 41,
      "control": 50,
      "pressure": 62,
      "agility": 54,
      "physical": 59,
      "technique": 46
    }
  },
  {
    "id": 5348,
    "name": "Barrett Mistbarrow",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/r/or6nih-fdrk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 41,
      "control": 45,
      "pressure": 64,
      "agility": 51,
      "physical": 66,
      "technique": 55
    }
  },
  {
    "id": 5349,
    "name": "Jakell Wardly",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/f/bfwnfgigub0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 60,
      "control": 46,
      "pressure": 52,
      "agility": 44,
      "physical": 56,
      "technique": 59
    }
  },
  {
    "id": 5350,
    "name": "Bechet Ardevout",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/q/7q1sw9xohhe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 63,
      "control": 74,
      "pressure": 59,
      "agility": 59,
      "physical": 45,
      "technique": 65
    }
  },
  {
    "id": 5351,
    "name": "Argion Boneback",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/c/kcez7cxsmss.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 42,
      "control": 56,
      "pressure": 53,
      "agility": 60,
      "physical": 40,
      "technique": 57
    }
  },
  {
    "id": 5352,
    "name": "Sahl Saltzman",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/j/ijdvvbj-jus.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 61,
      "control": 67,
      "pressure": 45,
      "agility": 56,
      "physical": 48,
      "technique": 54
    }
  },
  {
    "id": 5353,
    "name": "Fermin Dealitz",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/l/5lyo4kfekne.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 46,
      "control": 42,
      "pressure": 46,
      "agility": 64,
      "physical": 44,
      "technique": 61
    }
  },
  {
    "id": 5354,
    "name": "Ricemond Chowen",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/k/zkr7r5wmrh0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 51,
      "control": 49,
      "pressure": 74,
      "agility": 45,
      "physical": 76,
      "technique": 40
    }
  },
  {
    "id": 5355,
    "name": "Vergil Turnaraud",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/m/omgaggw280c.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 55,
      "control": 68,
      "pressure": 57,
      "agility": 48,
      "physical": 44,
      "technique": 72
    }
  },
  {
    "id": 5356,
    "name": "Chaunce Gambell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/m/cmfc3lvubl0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 58,
      "control": 75,
      "pressure": 46,
      "agility": 44,
      "physical": 43,
      "technique": 56
    }
  },
  {
    "id": 5357,
    "name": "Arby Trayton",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/o/touja0zu24c.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 41,
      "control": 57,
      "pressure": 60,
      "agility": 57,
      "physical": 60,
      "technique": 49
    }
  },
  {
    "id": 5358,
    "name": "Darrell Dignard",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/m/dm1ua16nxu8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 41,
      "control": 52,
      "pressure": 74,
      "agility": 48,
      "physical": 56,
      "technique": 57
    }
  },
  {
    "id": 5359,
    "name": "Ottis Quisley",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/r/uruhwpdjdos.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 49,
      "control": 60,
      "pressure": 61,
      "agility": 48,
      "physical": 66,
      "technique": 43
    }
  },
  {
    "id": 5360,
    "name": "Harrey Tagebard",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/j/kjskxkga03s.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 40,
      "control": 59,
      "pressure": 51,
      "agility": 63,
      "physical": 50,
      "technique": 64
    }
  },
  {
    "id": 5361,
    "name": "Olivier Gourmand",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/q/kqhfdfmvvvk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 42,
      "control": 60,
      "pressure": 40,
      "agility": 62,
      "physical": 59,
      "technique": 51
    }
  },
  {
    "id": 5362,
    "name": "Felicia Felton",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/k/gkf2-bbxlzu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 77,
      "control": 58,
      "pressure": 43,
      "agility": 55,
      "physical": 45,
      "technique": 59
    }
  },
  {
    "id": 5363,
    "name": "Trad Askenburg",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/v/avpwinnglju.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 75,
      "control": 66,
      "pressure": 45,
      "agility": 56,
      "physical": 47,
      "technique": 52
    }
  },
  {
    "id": 5364,
    "name": "Pietro Olley",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/0/y0ukmu1mglu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 69,
      "control": 57,
      "pressure": 44,
      "agility": 43,
      "physical": 45,
      "technique": 45
    }
  },
  {
    "id": 5365,
    "name": "Taxter Coilschmidt",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/c/pcfrlrt2nw8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 71,
      "control": 60,
      "pressure": 41,
      "agility": 55,
      "physical": 59,
      "technique": 53
    }
  },
  {
    "id": 5366,
    "name": "Bridget Steepen",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/b/4bn_1jaevfk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 47,
      "control": 58,
      "pressure": 62,
      "agility": 44,
      "physical": 56,
      "technique": 56
    }
  },
  {
    "id": 5367,
    "name": "Margo Versier",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/x/mxyneedmy6m.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 56,
      "control": 51,
      "pressure": 68,
      "agility": 53,
      "physical": 59,
      "technique": 48
    }
  },
  {
    "id": 5368,
    "name": "Circe Roundella",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/z/9zdgp7lcfjk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 58,
      "control": 59,
      "pressure": 57,
      "agility": 50,
      "physical": 56,
      "technique": 44
    }
  },
  {
    "id": 5369,
    "name": "Montoodle Wixley",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/x/txylz6sv-le.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 49,
      "control": 52,
      "pressure": 63,
      "agility": 58,
      "physical": 68,
      "technique": 47
    }
  },
  {
    "id": 5370,
    "name": "Enna Flashette",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/z/izpqefkvtws.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 56,
      "control": 60,
      "pressure": 83,
      "agility": 48,
      "physical": 60,
      "technique": 49
    }
  },
  {
    "id": 5371,
    "name": "Shawl Creedstern",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/l/eljb5dkvlie.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 52,
      "control": 53,
      "pressure": 59,
      "agility": 40,
      "physical": 63,
      "technique": 43
    }
  },
  {
    "id": 5372,
    "name": "Diana Whispervelt",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/i/iikskekijrs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 62,
      "control": 72,
      "pressure": 53,
      "agility": 54,
      "physical": 50,
      "technique": 67
    }
  },
  {
    "id": 5373,
    "name": "Bam Buschutt",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/n/onpzzd_awxc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 52,
      "control": 59,
      "pressure": 54,
      "agility": 61,
      "physical": 56,
      "technique": 54
    }
  },
  {
    "id": 5374,
    "name": "Ruy Roosalot",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/l/zly408z67c0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 54,
      "control": 56,
      "pressure": 76,
      "agility": 42,
      "physical": 67,
      "technique": 54
    }
  },
  {
    "id": 5375,
    "name": "Draven Savager",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/e/befkallw-e0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 49,
      "control": 40,
      "pressure": 41,
      "agility": 67,
      "physical": 52,
      "technique": 63
    }
  },
  {
    "id": 5376,
    "name": "Readon Booke",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/d/kdnwkhykmxs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 42,
      "control": 45,
      "pressure": 57,
      "agility": 42,
      "physical": 68,
      "technique": 51
    }
  },
  {
    "id": 5377,
    "name": "Wander Treeday",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/r/7r8rj4-elke.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 52,
      "control": 56,
      "pressure": 60,
      "agility": 46,
      "physical": 59,
      "technique": 42
    }
  },
  {
    "id": 5378,
    "name": "Abbie Sentridge",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/b/pbdj4198sbs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 53,
      "control": 49,
      "pressure": 66,
      "agility": 52,
      "physical": 51,
      "technique": 58
    }
  },
  {
    "id": 5379,
    "name": "Justine Gardenet",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/p/-pyovkbgboe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 47,
      "control": 58,
      "pressure": 62,
      "agility": 59,
      "physical": 57,
      "technique": 46
    }
  },
  {
    "id": 5380,
    "name": "Beatrice Estiletto",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/b/qbplplspgek.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 80,
      "control": 58,
      "pressure": 54,
      "agility": 44,
      "physical": 59,
      "technique": 52
    }
  },
  {
    "id": 5381,
    "name": "Carlisle Laimlight",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/j/1jsgu8svmrs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 45,
      "control": 48,
      "pressure": 63,
      "agility": 57,
      "physical": 74,
      "technique": 57
    }
  },
  {
    "id": 5382,
    "name": "Brandan Broomdorf",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/1/y1nj5rc6kgu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 54,
      "control": 47,
      "pressure": 64,
      "agility": 44,
      "physical": 60,
      "technique": 42
    }
  },
  {
    "id": 5383,
    "name": "Charlotte Graceslowe",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/a/4ae8qmpy_ak.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 78,
      "control": 58,
      "pressure": 55,
      "agility": 56,
      "physical": 47,
      "technique": 56
    }
  },
  {
    "id": 5384,
    "name": "Yohannes Drummand",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/y/jy1dhzpiszm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 59,
      "control": 68,
      "pressure": 57,
      "agility": 41,
      "physical": 60,
      "technique": 57
    }
  },
  {
    "id": 5385,
    "name": "Manni Lamasque",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/t/ltybpqdkx1m.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 68,
      "control": 61,
      "pressure": 49,
      "agility": 54,
      "physical": 60,
      "technique": 67
    }
  },
  {
    "id": 5386,
    "name": "Tiffany Fencourt",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/7/67dgev7e6gk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 82,
      "intelligence": 51,
      "control": 45,
      "pressure": 51,
      "agility": 72,
      "physical": 44,
      "technique": 58
    }
  },
  {
    "id": 5387,
    "name": "Oralyn Everfable",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/u/augvxiowpmu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 43,
      "control": 42,
      "pressure": 76,
      "agility": 54,
      "physical": 65,
      "technique": 43
    }
  },
  {
    "id": 5388,
    "name": "Farah Tigressa",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/8/r8r063osiv8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 81,
      "intelligence": 50,
      "control": 58,
      "pressure": 58,
      "agility": 53,
      "physical": 42,
      "technique": 51
    }
  },
  {
    "id": 5389,
    "name": "Macy Drapeley",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/w/fwusl6rofqu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 47,
      "control": 42,
      "pressure": 54,
      "agility": 55,
      "physical": 65,
      "technique": 48
    }
  },
  {
    "id": 5390,
    "name": "Alyra Verselle",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/-/u-fnmfn0oz8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 63,
      "control": 68,
      "pressure": 51,
      "agility": 56,
      "physical": 60,
      "technique": 61
    }
  },
  {
    "id": 5391,
    "name": "Misia Cheveuse",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/w/awea8ee9j1c.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 43,
      "control": 45,
      "pressure": 68,
      "agility": 47,
      "physical": 56,
      "technique": 46
    }
  },
  {
    "id": 5392,
    "name": "Randy Teastock",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/m/vmxvhhzdtxc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 41,
      "control": 46,
      "pressure": 44,
      "agility": 73,
      "physical": 44,
      "technique": 69
    }
  },
  {
    "id": 5393,
    "name": "Sabine Jellis",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/n/onrnsantwyc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 56,
      "control": 59,
      "pressure": 63,
      "agility": 53,
      "physical": 71,
      "technique": 41
    }
  },
  {
    "id": 5394,
    "name": "Caddy Chamomile",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/i/iiys_dslfss.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 73,
      "control": 72,
      "pressure": 58,
      "agility": 59,
      "physical": 52,
      "technique": 63
    }
  },
  {
    "id": 5395,
    "name": "Azam Darjeel",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/k/5kdzsi0fohe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 59,
      "control": 51,
      "pressure": 64,
      "agility": 41,
      "physical": 67,
      "technique": 46
    }
  },
  {
    "id": 5396,
    "name": "Barley Coldholt",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/r/7rev87mztne.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 48,
      "control": 54,
      "pressure": 64,
      "agility": 41,
      "physical": 64,
      "technique": 43
    }
  },
  {
    "id": 5397,
    "name": "Blendon Frugel",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/d/kd1oreajaus.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 54,
      "control": 59,
      "pressure": 76,
      "agility": 58,
      "physical": 71,
      "technique": 56
    }
  },
  {
    "id": 5398,
    "name": "Puerita Cakeley",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/s/qsw7cz1b10c.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 52,
      "control": 48,
      "pressure": 61,
      "agility": 41,
      "physical": 53,
      "technique": 55
    }
  },
  {
    "id": 5399,
    "name": "Graye Earlnest",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/e/benavmt7yh0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 59,
      "control": 61,
      "pressure": 60,
      "agility": 46,
      "physical": 58,
      "technique": 66
    }
  },
  {
    "id": 5400,
    "name": "Masala Mettler",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/u/vuycerqz_4c.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 43,
      "control": 42,
      "pressure": 40,
      "agility": 69,
      "physical": 58,
      "technique": 60
    }
  },
  {
    "id": 5401,
    "name": "Machaela Thevert",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/g/egpjzu2jsl0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 66,
      "control": 61,
      "pressure": 53,
      "agility": 48,
      "physical": 46,
      "technique": 58
    }
  },
  {
    "id": 5402,
    "name": "Trane Levitt",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/y/wyzunsmyaes.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 50,
      "control": 55,
      "pressure": 47,
      "agility": 64,
      "physical": 40,
      "technique": 73
    }
  },
  {
    "id": 5403,
    "name": "Domino Guerrera",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/1/h1l6zw1qyx0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 50,
      "control": 45,
      "pressure": 59,
      "agility": 43,
      "physical": 57,
      "technique": 52
    }
  },
  {
    "id": 5404,
    "name": "Leston Thoreau",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/a/naopktait3e.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 42,
      "control": 42,
      "pressure": 56,
      "agility": 60,
      "physical": 60,
      "technique": 43
    }
  },
  {
    "id": 5405,
    "name": "Judeau Garb",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/a/4a8cfpxfzdk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 71,
      "control": 57,
      "pressure": 57,
      "agility": 49,
      "physical": 44,
      "technique": 63
    }
  },
  {
    "id": 5406,
    "name": "Belton McGirdle",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/1/y1f3msexsju.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 42,
      "control": 49,
      "pressure": 68,
      "agility": 43,
      "physical": 60,
      "technique": 55
    }
  },
  {
    "id": 5407,
    "name": "Agil Surefall",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/d/pduwhtitbq8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 55,
      "control": 47,
      "pressure": 73,
      "agility": 53,
      "physical": 60,
      "technique": 57
    }
  },
  {
    "id": 5408,
    "name": "Bowen Fleurmett",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/8/r8pkp0wbew8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 74,
      "control": 63,
      "pressure": 55,
      "agility": 51,
      "physical": 44,
      "technique": 59
    }
  },
  {
    "id": 5409,
    "name": "Healan Masson",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/u/auyrilw7plu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 56,
      "control": 77,
      "pressure": 56,
      "agility": 55,
      "physical": 42,
      "technique": 54
    }
  },
  {
    "id": 5410,
    "name": "Damion Duform",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/7/677exwjzcfk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 70,
      "control": 63,
      "pressure": 41,
      "agility": 56,
      "physical": 54,
      "technique": 69
    }
  },
  {
    "id": 5411,
    "name": "Hovard Schulder",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/t/ltk_cpfjx2m.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 64,
      "control": 64,
      "pressure": 48,
      "agility": 53,
      "physical": 43,
      "technique": 61
    }
  },
  {
    "id": 5412,
    "name": "Colter Fairburn",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/s/vsy6vjbznxc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 84,
      "intelligence": 60,
      "control": 55,
      "pressure": 49,
      "agility": 62,
      "physical": 56,
      "technique": 66
    }
  },
  {
    "id": 5413,
    "name": "Fang Arzola",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/d/pdrpg-ur4rs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 42,
      "control": 56,
      "pressure": 69,
      "agility": 58,
      "physical": 63,
      "technique": 40
    }
  },
  {
    "id": 5414,
    "name": "Benoni Espinoza",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/r/-rgurbirvie.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 44,
      "control": 53,
      "pressure": 40,
      "agility": 73,
      "physical": 44,
      "technique": 50
    }
  },
  {
    "id": 5415,
    "name": "Trip Cresta",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/k/8knyfyahqke.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 53,
      "control": 42,
      "pressure": 66,
      "agility": 59,
      "physical": 71,
      "technique": 41
    }
  },
  {
    "id": 5416,
    "name": "Aram Manton",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/i/niwton899xs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 71,
      "control": 59,
      "pressure": 46,
      "agility": 57,
      "physical": 59,
      "technique": 59
    }
  },
  {
    "id": 5417,
    "name": "Hiatt Heddon",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/n/tn1m76j1i3c.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 41,
      "control": 55,
      "pressure": 65,
      "agility": 60,
      "physical": 70,
      "technique": 49
    }
  },
  {
    "id": 5418,
    "name": "Danica Wynn",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/l/clehwfvple0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 42,
      "control": 50,
      "pressure": 74,
      "agility": 53,
      "physical": 67,
      "technique": 51
    }
  },
  {
    "id": 5419,
    "name": "Chiana Fielder",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/p/op7fnistc7c.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 72,
      "control": 75,
      "pressure": 50,
      "agility": 50,
      "physical": 51,
      "technique": 71
    }
  },
  {
    "id": 5420,
    "name": "Sara Lyle",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/n/znk-k3kxvi0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 59,
      "control": 57,
      "pressure": 68,
      "agility": 54,
      "physical": 71,
      "technique": 51
    }
  },
  {
    "id": 5421,
    "name": "Kali Seaborn",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/p/3przq2deoku.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 70,
      "control": 64,
      "pressure": 49,
      "agility": 58,
      "physical": 41,
      "technique": 59
    }
  },
  {
    "id": 5422,
    "name": "Nolan Ashby",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/n/gngs9jlkjx8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 54,
      "control": 56,
      "pressure": 54,
      "agility": 56,
      "physical": 62,
      "technique": 48
    }
  },
  {
    "id": 5423,
    "name": "Arin Fairey",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/i/midnuuqsw3m.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 54,
      "control": 71,
      "pressure": 42,
      "agility": 52,
      "physical": 60,
      "technique": 66
    }
  },
  {
    "id": 5424,
    "name": "Hanah Keller",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/g/xgygdr2w7ek.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 60,
      "control": 58,
      "pressure": 47,
      "agility": 76,
      "physical": 60,
      "technique": 50
    }
  },
  {
    "id": 5425,
    "name": "Hercule Gaillard",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/8/089hawb8wic.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 65,
      "control": 59,
      "pressure": 60,
      "agility": 48,
      "physical": 51,
      "technique": 61
    }
  },
  {
    "id": 5426,
    "name": "Didar Valmont",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/w/awcfrbcexd0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 54,
      "control": 42,
      "pressure": 73,
      "agility": 44,
      "physical": 69,
      "technique": 46
    }
  },
  {
    "id": 5427,
    "name": "Iro Armussel",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/-/x-z-gkkk6uc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 44,
      "control": 47,
      "pressure": 51,
      "agility": 69,
      "physical": 59,
      "technique": 69
    }
  },
  {
    "id": 5428,
    "name": "Stratos Merrill",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/7/_7ffmsnrkak.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 60,
      "control": 58,
      "pressure": 61,
      "agility": 58,
      "physical": 60,
      "technique": 50
    }
  },
  {
    "id": 5429,
    "name": "Kairo Reaser",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/u/fu8q1x4jrgu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 73,
      "control": 65,
      "pressure": 60,
      "agility": 46,
      "physical": 50,
      "technique": 61
    }
  },
  {
    "id": 5430,
    "name": "Watt Ownes",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/8/u8nlyoez8t8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 68,
      "control": 70,
      "pressure": 55,
      "agility": 46,
      "physical": 52,
      "technique": 64
    }
  },
  {
    "id": 5431,
    "name": "Proteus Flavout",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/d/sdkx2xm15v8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 46,
      "control": 60,
      "pressure": 69,
      "agility": 58,
      "physical": 80,
      "technique": 54
    }
  },
  {
    "id": 5432,
    "name": "Olan Ackroyd",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/1/d172boqpumu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 43,
      "control": 42,
      "pressure": 49,
      "agility": 65,
      "physical": 53,
      "technique": 64
    }
  },
  {
    "id": 5433,
    "name": "Evander Greenvale",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/a/9aydi1fhhgk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 81,
      "intelligence": 56,
      "control": 43,
      "pressure": 46,
      "agility": 52,
      "physical": 48,
      "technique": 64
    }
  },
  {
    "id": 5434,
    "name": "Floyn Circuits",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/y/mypilk59m1m.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 42,
      "control": 49,
      "pressure": 75,
      "agility": 52,
      "physical": 74,
      "technique": 44
    }
  },
  {
    "id": 5435,
    "name": "Zaydan Smythe",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/y/4yw6uh6frkk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 47,
      "control": 40,
      "pressure": 67,
      "agility": 52,
      "physical": 63,
      "technique": 40
    }
  },
  {
    "id": 5436,
    "name": "Praiseton Strongshout",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/w/jwnb54clg5m.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 44,
      "control": 58,
      "pressure": 65,
      "agility": 47,
      "physical": 72,
      "technique": 40
    }
  },
  {
    "id": 5437,
    "name": "Wheyland Schultz",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/y/ny8wj5vsnvs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 68,
      "control": 69,
      "pressure": 42,
      "agility": 45,
      "physical": 60,
      "technique": 56
    }
  },
  {
    "id": 5438,
    "name": "Heron Champs",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/w/wwn3ogzwkme.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 51,
      "control": 47,
      "pressure": 59,
      "agility": 77,
      "physical": 48,
      "technique": 54
    }
  },
  {
    "id": 5439,
    "name": "Starry Durant",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/k/kka0qe_n-c0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 59,
      "control": 48,
      "pressure": 69,
      "agility": 48,
      "physical": 67,
      "technique": 51
    }
  },
  {
    "id": 5440,
    "name": "Nova Holloway",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/8/p8xcmpmfhoc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 51,
      "control": 49,
      "pressure": 65,
      "agility": 42,
      "physical": 53,
      "technique": 53
    }
  },
  {
    "id": 5441,
    "name": "Raymond Galak",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/t/uteyjl00fcs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 53,
      "control": 42,
      "pressure": 58,
      "agility": 53,
      "physical": 51,
      "technique": 47
    }
  },
  {
    "id": 5442,
    "name": "Luceus Cloudstrider",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/7/l7vtk0sooxe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 67,
      "control": 54,
      "pressure": 59,
      "agility": 43,
      "physical": 58,
      "technique": 49
    }
  },
  {
    "id": 5443,
    "name": "Cosmo Starward",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/u/fumm3pngdr0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 49,
      "control": 58,
      "pressure": 53,
      "agility": 75,
      "physical": 53,
      "technique": 56
    }
  },
  {
    "id": 5444,
    "name": "Altair Aldrin",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/1/w1i9-jh3dke.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 55,
      "control": 60,
      "pressure": 56,
      "agility": 62,
      "physical": 52,
      "technique": 63
    }
  },
  {
    "id": 5445,
    "name": "Lyra Nazar",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/u/-ua9lwqlm90.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 67,
      "intelligence": 51,
      "control": 50,
      "pressure": 41,
      "agility": 79,
      "physical": 42,
      "technique": 69
    }
  },
  {
    "id": 5446,
    "name": "Santi Lite",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/d/nd2aiwezkic.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 60,
      "control": 71,
      "pressure": 49,
      "agility": 59,
      "physical": 53,
      "technique": 70
    }
  },
  {
    "id": 5447,
    "name": "Jackson Bover",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/y/tyv1btr7ros.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 43,
      "control": 50,
      "pressure": 73,
      "agility": 49,
      "physical": 61,
      "technique": 53
    }
  },
  {
    "id": 5448,
    "name": "Eilidh Innes",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/7/e7jiylft5de.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 60,
      "control": 53,
      "pressure": 43,
      "agility": 50,
      "physical": 40,
      "technique": 61
    }
  },
  {
    "id": 5449,
    "name": "Ashe Connelly",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/t/vtsp105xuus.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 61,
      "control": 57,
      "pressure": 58,
      "agility": 44,
      "physical": 41,
      "technique": 56
    }
  },
  {
    "id": 5450,
    "name": "Mina Veyance",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/f/mfhoehtl7e0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 42,
      "control": 41,
      "pressure": 53,
      "agility": 66,
      "physical": 46,
      "technique": 61
    }
  },
  {
    "id": 5451,
    "name": "Bunette Volane",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/k/dkbl7_ibn5k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 52,
      "control": 40,
      "pressure": 74,
      "agility": 42,
      "physical": 55,
      "technique": 51
    }
  },
  {
    "id": 5452,
    "name": "Cocoa Bounce",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/l/9l4qoi9j4zu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 48,
      "control": 55,
      "pressure": 59,
      "agility": 51,
      "physical": 70,
      "technique": 40
    }
  },
  {
    "id": 5453,
    "name": "Naya Prism",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/n/mnjxfdbzvq8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 57,
      "control": 56,
      "pressure": 46,
      "agility": 66,
      "physical": 44,
      "technique": 72
    }
  },
  {
    "id": 5454,
    "name": "Corwin Lockhart",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/s/osotrejfqs8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 44,
      "control": 44,
      "pressure": 74,
      "agility": 40,
      "physical": 63,
      "technique": 43
    }
  },
  {
    "id": 5455,
    "name": "Damian Stonewell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/e/_e_mg7vl9fu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 63,
      "control": 59,
      "pressure": 41,
      "agility": 57,
      "physical": 54,
      "technique": 65
    }
  },
  {
    "id": 5456,
    "name": "Rylan Spiker",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/r/frc5vmati_k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 56,
      "control": 41,
      "pressure": 54,
      "agility": 76,
      "physical": 48,
      "technique": 50
    }
  },
  {
    "id": 5457,
    "name": "Ecole Linwood",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/d/udty4z8xlmm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 56,
      "control": 64,
      "pressure": 44,
      "agility": 45,
      "physical": 49,
      "technique": 52
    }
  },
  {
    "id": 5458,
    "name": "Landon Crosser",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/p/apsaju_1czk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 60,
      "control": 49,
      "pressure": 55,
      "agility": 48,
      "physical": 59,
      "technique": 55
    }
  },
  {
    "id": 5459,
    "name": "Duarte Wilde",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/b/rbjhkrzpvam.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 53,
      "control": 62,
      "pressure": 42,
      "agility": 40,
      "physical": 51,
      "technique": 53
    }
  },
  {
    "id": 5460,
    "name": "Finnard Grit",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/p/fp4s-qqgoss.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 50,
      "control": 56,
      "pressure": 74,
      "agility": 43,
      "physical": 76,
      "technique": 48
    }
  },
  {
    "id": 5461,
    "name": "Tenison Onsera",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/t/xt2jp4lxw3c.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 65,
      "control": 65,
      "pressure": 51,
      "agility": 57,
      "physical": 48,
      "technique": 54
    }
  },
  {
    "id": 5462,
    "name": "Selina Goldpyre",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/h/phizl4fc-7s.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 59,
      "control": 55,
      "pressure": 65,
      "agility": 51,
      "physical": 60,
      "technique": 49
    }
  },
  {
    "id": 5463,
    "name": "Dazziel Spinwick",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/y/tytluuzw3rs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 62,
      "control": 56,
      "pressure": 49,
      "agility": 44,
      "physical": 48,
      "technique": 57
    }
  },
  {
    "id": 5464,
    "name": "Curven Rallye",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/d/ndo-9zgeclc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 41,
      "control": 40,
      "pressure": 66,
      "agility": 57,
      "physical": 73,
      "technique": 54
    }
  },
  {
    "id": 5465,
    "name": "Ryker Strive",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/1/81_fqmgkv40.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 78,
      "control": 68,
      "pressure": 48,
      "agility": 43,
      "physical": 58,
      "technique": 66
    }
  },
  {
    "id": 5466,
    "name": "Cyrus Veil",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/u/-u4d-vyiq-0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 48,
      "control": 50,
      "pressure": 58,
      "agility": 58,
      "physical": 56,
      "technique": 43
    }
  },
  {
    "id": 5467,
    "name": "Gavin Mallory",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/8/p8jitquyhnc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 51,
      "control": 52,
      "pressure": 57,
      "agility": 71,
      "physical": 54,
      "technique": 64
    }
  },
  {
    "id": 5468,
    "name": "Mira Fiendish",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/t/vtqxa3h6yts.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 66,
      "control": 64,
      "pressure": 60,
      "agility": 56,
      "physical": 44,
      "technique": 72
    }
  },
  {
    "id": 5469,
    "name": "Carly Veneer",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/7/e7b2tihafee.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 50,
      "control": 47,
      "pressure": 64,
      "agility": 42,
      "physical": 64,
      "technique": 42
    }
  },
  {
    "id": 5470,
    "name": "Ponny Grace",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/r/qrkucfei4hs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 56,
      "control": 41,
      "pressure": 65,
      "agility": 50,
      "physical": 65,
      "technique": 52
    }
  },
  {
    "id": 5471,
    "name": "Aria Fondue",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/5/b5vpx6iyvse.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 53,
      "control": 60,
      "pressure": 65,
      "agility": 48,
      "physical": 59,
      "technique": 57
    }
  },
  {
    "id": 5472,
    "name": "Charlet Namora",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/r/1rocr7rr0-k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 76,
      "control": 52,
      "pressure": 58,
      "agility": 46,
      "physical": 40,
      "technique": 51
    }
  },
  {
    "id": 5473,
    "name": "Lorenzo Dellart",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/1/411qag5lkx0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 61,
      "intelligence": 44,
      "control": 52,
      "pressure": 51,
      "agility": 67,
      "physical": 60,
      "technique": 71
    }
  },
  {
    "id": 5474,
    "name": "Aimee Porteret",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/1/n1f8t4wwgu8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 59,
      "control": 65,
      "pressure": 41,
      "agility": 47,
      "physical": 54,
      "technique": 56
    }
  },
  {
    "id": 5475,
    "name": "Mireille Modelle",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/l/9laudhlkeau.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 60,
      "control": 41,
      "pressure": 54,
      "agility": 50,
      "physical": 70,
      "technique": 41
    }
  },
  {
    "id": 5476,
    "name": "Greef Lonbrusch",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/k/dkjbo8qsr6k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 56,
      "control": 50,
      "pressure": 71,
      "agility": 54,
      "physical": 54,
      "technique": 52
    }
  },
  {
    "id": 5477,
    "name": "Bracker Grippe",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/i/sis6jd2wgjm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 45,
      "control": 47,
      "pressure": 45,
      "agility": 59,
      "physical": 60,
      "technique": 60
    }
  },
  {
    "id": 5478,
    "name": "Trew Talif",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/d/udvmnak6dpm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 69,
      "control": 57,
      "pressure": 57,
      "agility": 43,
      "physical": 55,
      "technique": 64
    }
  },
  {
    "id": 5479,
    "name": "Madeline Milke",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/r/frkhglcau8k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 59,
      "control": 42,
      "pressure": 72,
      "agility": 59,
      "physical": 61,
      "technique": 44
    }
  },
  {
    "id": 5480,
    "name": "Giovanni Buston",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/e/_ehyz43ibcu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 58,
      "control": 55,
      "pressure": 55,
      "agility": 43,
      "physical": 50,
      "technique": 53
    }
  },
  {
    "id": 5481,
    "name": "Audreen Slumberey",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/s/os2tehry2v8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 75,
      "control": 67,
      "pressure": 54,
      "agility": 48,
      "physical": 56,
      "technique": 63
    }
  },
  {
    "id": 5482,
    "name": "Zinnia Crylic",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/g/6gjlvksqrqu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 52,
      "control": 53,
      "pressure": 50,
      "agility": 72,
      "physical": 54,
      "technique": 51
    }
  },
  {
    "id": 5483,
    "name": "Alara Belmont",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/a/yabfmxbhpbs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 49,
      "control": 60,
      "pressure": 53,
      "agility": 64,
      "physical": 52,
      "technique": 67
    }
  },
  {
    "id": 5484,
    "name": "Lyla Loveland",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/a/sapdsf4d3ik.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 51,
      "control": 66,
      "pressure": 52,
      "agility": 45,
      "physical": 54,
      "technique": 65
    }
  },
  {
    "id": 5485,
    "name": "Ana Santini",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/v/-vxahqb-a70.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 44,
      "control": 41,
      "pressure": 56,
      "agility": 40,
      "physical": 74,
      "technique": 50
    }
  },
  {
    "id": 5486,
    "name": "Dasher Ballard",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/6/e6s1ynu21be.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 40,
      "control": 55,
      "pressure": 49,
      "agility": 53,
      "physical": 41,
      "technique": 57
    }
  },
  {
    "id": 5487,
    "name": "Javor Bonnaire",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/s/vsjufyimyos.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 40,
      "control": 40,
      "pressure": 62,
      "agility": 57,
      "physical": 61,
      "technique": 41
    }
  },
  {
    "id": 5488,
    "name": "Tobin Tempelhof",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/z/tzkixragdus.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 59,
      "control": 51,
      "pressure": 73,
      "agility": 49,
      "physical": 61,
      "technique": 59
    }
  },
  {
    "id": 5489,
    "name": "Shiryu Hanabusa",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/b/cbvpcu8awde.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 30,
      "intelligence": 59,
      "control": 52,
      "pressure": 74,
      "agility": 57,
      "physical": 60,
      "technique": 58
    }
  },
  {
    "id": 5490,
    "name": "Dyne Amic",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/0/802cpjjsf90.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 55,
      "control": 70,
      "pressure": 59,
      "agility": 57,
      "physical": 55,
      "technique": 67
    }
  },
  {
    "id": 5491,
    "name": "Callista Norton",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/c/nch9i2voooc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 51,
      "control": 48,
      "pressure": 48,
      "agility": 59,
      "physical": 55,
      "technique": 63
    }
  },
  {
    "id": 5492,
    "name": "Neve Paisley",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/2/524lt7skpx0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 79,
      "control": 70,
      "pressure": 46,
      "agility": 42,
      "physical": 42,
      "technique": 65
    }
  },
  {
    "id": 5493,
    "name": "Serene Goldwell",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/e/ieje-ekwicc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 41,
      "control": 52,
      "pressure": 53,
      "agility": 59,
      "physical": 58,
      "technique": 48
    }
  },
  {
    "id": 5494,
    "name": "Mirko Harding",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/2/m2sjkfd5du8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 60,
      "control": 55,
      "pressure": 76,
      "agility": 43,
      "physical": 66,
      "technique": 45
    }
  },
  {
    "id": 5495,
    "name": "Clyde Dalen",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/e/xejoj6ldudu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 77,
      "control": 75,
      "pressure": 47,
      "agility": 52,
      "physical": 58,
      "technique": 53
    }
  },
  {
    "id": 5496,
    "name": "Curia Caldwell",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/x/3xadanqlb9k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 42,
      "control": 46,
      "pressure": 56,
      "agility": 54,
      "physical": 69,
      "technique": 40
    }
  },
  {
    "id": 5497,
    "name": "Ava Ehrenreich",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/z/gzx83y2x2om.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 62,
      "intelligence": 45,
      "control": 48,
      "pressure": 40,
      "agility": 62,
      "physical": 43,
      "technique": 61
    }
  },
  {
    "id": 5498,
    "name": "Cassiel Longstaff",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/o/doqklo9beoe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 50,
      "control": 54,
      "pressure": 56,
      "agility": 51,
      "physical": 68,
      "technique": 44
    }
  },
  {
    "id": 5499,
    "name": "Farran Corsa",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/l/7ldr61ggzee.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 44,
      "control": 44,
      "pressure": 61,
      "agility": 47,
      "physical": 73,
      "technique": 56
    }
  },
  {
    "id": 5500,
    "name": "Geri Spears",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/c/ucclsfnmpkm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 82,
      "intelligence": 49,
      "control": 51,
      "pressure": 40,
      "agility": 71,
      "physical": 53,
      "technique": 72
    }
  },
  {
    "id": 5501,
    "name": "Lita Vault",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/t/ot_qbc4ecq8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 82,
      "intelligence": 57,
      "control": 52,
      "pressure": 47,
      "agility": 70,
      "physical": 58,
      "technique": 68
    }
  },
  {
    "id": 5502,
    "name": "Leero Pard",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/f/_foxs9e-xzu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 47,
      "control": 49,
      "pressure": 51,
      "agility": 78,
      "physical": 46,
      "technique": 64
    }
  },
  {
    "id": 5503,
    "name": "Russ Radcliff",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/k/9kjtckms0fu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 64,
      "control": 61,
      "pressure": 56,
      "agility": 57,
      "physical": 58,
      "technique": 73
    }
  },
  {
    "id": 5504,
    "name": "Batton Farrow",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/m/mm4mvbqozs8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 58,
      "control": 40,
      "pressure": 53,
      "agility": 45,
      "physical": 70,
      "technique": 53
    }
  },
  {
    "id": 5505,
    "name": "Jett Allegri",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/j/sjb58gfgsmm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 65,
      "control": 55,
      "pressure": 42,
      "agility": 47,
      "physical": 56,
      "technique": 57
    }
  },
  {
    "id": 5506,
    "name": "Ralya Chersey",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/l/dlqyr55ab_k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 41,
      "control": 53,
      "pressure": 57,
      "agility": 59,
      "physical": 61,
      "technique": 47
    }
  },
  {
    "id": 5507,
    "name": "Wing Hyland",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/h/phvag064mam.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 42,
      "control": 41,
      "pressure": 68,
      "agility": 51,
      "physical": 64,
      "technique": 52
    }
  },
  {
    "id": 5508,
    "name": "Thalia Petras",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/j/yjkhnlcclzk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 73,
      "control": 58,
      "pressure": 59,
      "agility": 40,
      "physical": 60,
      "technique": 56
    }
  },
  {
    "id": 5509,
    "name": "Calina Breezer",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/h/2h_sxkvlqfe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 50,
      "control": 51,
      "pressure": 70,
      "agility": 53,
      "physical": 69,
      "technique": 56
    }
  },
  {
    "id": 5510,
    "name": "Lace Tangler",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/j/hjon61zxhss.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 52,
      "control": 60,
      "pressure": 41,
      "agility": 53,
      "physical": 53,
      "technique": 65
    }
  },
  {
    "id": 5511,
    "name": "Eli Hoopsen",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/a/taxprp0slek.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 62,
      "control": 69,
      "pressure": 53,
      "agility": 45,
      "physical": 45,
      "technique": 51
    }
  },
  {
    "id": 5512,
    "name": "Marcel Leapman",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/o/jo-i_genarm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 63,
      "control": 64,
      "pressure": 60,
      "agility": 57,
      "physical": 59,
      "technique": 67
    }
  },
  {
    "id": 5513,
    "name": "Tris Baylor",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/6/e6qlho2btye.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 40,
      "control": 60,
      "pressure": 58,
      "agility": 54,
      "physical": 72,
      "technique": 42
    }
  },
  {
    "id": 5514,
    "name": "Dunk Highfield",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/v/-vj-utdtm40.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 57,
      "control": 42,
      "pressure": 69,
      "agility": 40,
      "physical": 73,
      "technique": 44
    }
  },
  {
    "id": 5515,
    "name": "Somnal Brightmore",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/9/p94f5slpllc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 41,
      "control": 49,
      "pressure": 63,
      "agility": 50,
      "physical": 67,
      "technique": 42
    }
  },
  {
    "id": 5516,
    "name": "Pillan Hallstead",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/c/nc_dx13fonc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 30,
      "intelligence": 42,
      "control": 50,
      "pressure": 64,
      "agility": 53,
      "physical": 68,
      "technique": 40
    }
  },
  {
    "id": 5517,
    "name": "Leander Courtman",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/0/80oi6kr_j-0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 50,
      "control": 55,
      "pressure": 49,
      "agility": 60,
      "physical": 49,
      "technique": 49
    }
  },
  {
    "id": 5518,
    "name": "Laurence Stumbleton",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/b/cbtxpxk3wee.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 67,
      "control": 61,
      "pressure": 53,
      "agility": 57,
      "physical": 49,
      "technique": 56
    }
  },
  {
    "id": 5519,
    "name": "Figgo Balpark",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/z/tzc2eocn7ts.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 47,
      "control": 48,
      "pressure": 73,
      "agility": 52,
      "physical": 51,
      "technique": 52
    }
  },
  {
    "id": 5520,
    "name": "Lazaro Coveton",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/z/zzju1lbvcse.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 60,
      "control": 57,
      "pressure": 41,
      "agility": 58,
      "physical": 59,
      "technique": 54
    }
  },
  {
    "id": 5521,
    "name": "Nicolas Pirrant",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/x/oxspyanvxhs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 58,
      "control": 51,
      "pressure": 42,
      "agility": 60,
      "physical": 50,
      "technique": 68
    }
  },
  {
    "id": 5522,
    "name": "Hazlo Prophyle",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/z/gzjccbucqnm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 53,
      "control": 67,
      "pressure": 54,
      "agility": 47,
      "physical": 59,
      "technique": 60
    }
  },
  {
    "id": 5523,
    "name": "Emil Tait",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/x/3x4jvkim9-k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 78,
      "control": 71,
      "pressure": 57,
      "agility": 45,
      "physical": 53,
      "technique": 50
    }
  },
  {
    "id": 5524,
    "name": "Fouad Togenick",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/e/xebw859uieu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 56,
      "control": 52,
      "pressure": 65,
      "agility": 59,
      "physical": 76,
      "technique": 57
    }
  },
  {
    "id": 5525,
    "name": "Talken Bigby",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/2/m2q3rgbult8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 55,
      "control": 40,
      "pressure": 42,
      "agility": 64,
      "physical": 42,
      "technique": 55
    }
  },
  {
    "id": 5526,
    "name": "Jasper Chatterly",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/o/coai8wsoi3m.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 44,
      "control": 43,
      "pressure": 60,
      "agility": 40,
      "physical": 67,
      "technique": 42
    }
  },
  {
    "id": 5527,
    "name": "Foster Bracewell",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/a/ha8j-ljezom.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 45,
      "control": 42,
      "pressure": 71,
      "agility": 57,
      "physical": 61,
      "technique": 59
    }
  },
  {
    "id": 5528,
    "name": "Dreamer Havenridge",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/y/2ynotafke9k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 76,
      "control": 62,
      "pressure": 54,
      "agility": 49,
      "physical": 41,
      "technique": 59
    }
  },
  {
    "id": 5529,
    "name": "Smiles Thrussell",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/t/0tk09dxib7k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 31,
      "intelligence": 48,
      "control": 43,
      "pressure": 62,
      "agility": 55,
      "physical": 63,
      "technique": 42
    }
  },
  {
    "id": 5530,
    "name": "Noelle Harmon",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/t/othu0bgp6p8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 85,
      "intelligence": 56,
      "control": 57,
      "pressure": 53,
      "agility": 62,
      "physical": 50,
      "technique": 62
    }
  },
  {
    "id": 5531,
    "name": "Grace Starlet",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/c/uckbncvhpjm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 52,
      "control": 56,
      "pressure": 69,
      "agility": 56,
      "physical": 66,
      "technique": 42
    }
  },
  {
    "id": 5532,
    "name": "Eden Snowbell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/q/fqv6kjzbi6k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 60,
      "control": 54,
      "pressure": 50,
      "agility": 59,
      "physical": 53,
      "technique": 56
    }
  },
  {
    "id": 5533,
    "name": "Octavia Carroll",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/l/dlsmk6h3n8k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 49,
      "control": 55,
      "pressure": 78,
      "agility": 49,
      "physical": 71,
      "technique": 47
    }
  },
  {
    "id": 5534,
    "name": "Valentine Lovejoy",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/j/sjjhjfhnkpm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 59,
      "control": 68,
      "pressure": 57,
      "agility": 59,
      "physical": 57,
      "technique": 51
    }
  },
  {
    "id": 5535,
    "name": "Hope Astor",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/m/mmayayyf_v8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 58,
      "control": 45,
      "pressure": 48,
      "agility": 56,
      "physical": 40,
      "technique": 62
    }
  },
  {
    "id": 5536,
    "name": "Dina Kingston",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/k/9kxt3nu_scu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 49,
      "control": 48,
      "pressure": 69,
      "agility": 57,
      "physical": 64,
      "technique": 51
    }
  },
  {
    "id": 5537,
    "name": "Levy Vales",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/o/joolgqxd1j8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 56,
      "control": 57,
      "pressure": 58,
      "agility": 40,
      "physical": 59,
      "technique": 59
    }
  },
  {
    "id": 5538,
    "name": "Flash Lighton",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/m/4m_qrvxnyqu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 68,
      "control": 64,
      "pressure": 48,
      "agility": 59,
      "physical": 60,
      "technique": 56
    }
  },
  {
    "id": 5539,
    "name": "Banner Weaving",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/o/woknxu4u580.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 30,
      "intelligence": 54,
      "control": 48,
      "pressure": 70,
      "agility": 41,
      "physical": 62,
      "technique": 40
    }
  },
  {
    "id": 5540,
    "name": "Finley Brooks",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/h/8hj9vlng9x8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 46,
      "control": 58,
      "pressure": 55,
      "agility": 65,
      "physical": 59,
      "technique": 61
    }
  },
  {
    "id": 5541,
    "name": "Alonzo Readdie",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/m/emwn1awwmo0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 60,
      "control": 57,
      "pressure": 56,
      "agility": 62,
      "physical": 56,
      "technique": 59
    }
  },
  {
    "id": 5542,
    "name": "Galina Chilvers",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/b/zbjw-tkvube.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 60,
      "control": 57,
      "pressure": 52,
      "agility": 54,
      "physical": 42,
      "technique": 58
    }
  },
  {
    "id": 5543,
    "name": "Rockin Sunshaide",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/0/50qjtw_nb70.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 63,
      "control": 62,
      "pressure": 47,
      "agility": 54,
      "physical": 40,
      "technique": 59
    }
  },
  {
    "id": 5544,
    "name": "Medwin Silvers",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/c/icbcapzd2ic.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 48,
      "control": 51,
      "pressure": 59,
      "agility": 45,
      "physical": 71,
      "technique": 56
    }
  },
  {
    "id": 5545,
    "name": "Kipper Marino",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/9/k9ceuwlxzoc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 61,
      "control": 57,
      "pressure": 60,
      "agility": 47,
      "physical": 47,
      "technique": 52
    }
  },
  {
    "id": 5546,
    "name": "Wale Gambon",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/v/7vt_dptle90.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 51,
      "control": 47,
      "pressure": 69,
      "agility": 48,
      "physical": 62,
      "technique": 55
    }
  },
  {
    "id": 5547,
    "name": "Calem Backstrom",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/6/b6okq0ydrde.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 56,
      "control": 52,
      "pressure": 63,
      "agility": 59,
      "physical": 79,
      "technique": 59
    }
  },
  {
    "id": 5548,
    "name": "Castor Fatica",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/s/qs_r9l-5gus.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 46,
      "control": 53,
      "pressure": 63,
      "agility": 51,
      "physical": 69,
      "technique": 45
    }
  },
  {
    "id": 5549,
    "name": "Papilla Revert",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/4/e4azmg9bhre.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 75,
      "control": 53,
      "pressure": 52,
      "agility": 50,
      "physical": 43,
      "technique": 55
    }
  },
  {
    "id": 5550,
    "name": "Amita Rudd",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/q/vqxsh5bhmis.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 49,
      "control": 53,
      "pressure": 70,
      "agility": 52,
      "physical": 53,
      "technique": 54
    }
  },
  {
    "id": 5551,
    "name": "Yarden Forsman",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/4/b4qf74sotom.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 59,
      "control": 50,
      "pressure": 46,
      "agility": 74,
      "physical": 51,
      "technique": 64
    }
  },
  {
    "id": 5552,
    "name": "Cheery Allende",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/q/wqb-wh0sa9k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 54,
      "control": 45,
      "pressure": 69,
      "agility": 49,
      "physical": 68,
      "technique": 57
    }
  },
  {
    "id": 5553,
    "name": "Rafton Calmers",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/v/nvscc0baqku.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 44,
      "control": 46,
      "pressure": 50,
      "agility": 57,
      "physical": 46,
      "technique": 60
    }
  },
  {
    "id": 5554,
    "name": "Ballmer Netting",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/j/-jtsmhj4tie.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 49,
      "control": 60,
      "pressure": 49,
      "agility": 60,
      "physical": 53,
      "technique": 52
    }
  },
  {
    "id": 5555,
    "name": "Avan Floane",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/m/jmkznicdhq8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 78,
      "control": 68,
      "pressure": 57,
      "agility": 52,
      "physical": 44,
      "technique": 69
    }
  },
  {
    "id": 5556,
    "name": "Davey Lockers",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/j/pjhge_pvykm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 55,
      "control": 59,
      "pressure": 40,
      "agility": 58,
      "physical": 43,
      "technique": 58
    }
  },
  {
    "id": 5557,
    "name": "Akela Portner",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/l/yl2nzapvf5k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 35,
      "intelligence": 48,
      "control": 46,
      "pressure": 56,
      "agility": 60,
      "physical": 75,
      "technique": 41
    }
  },
  {
    "id": 5558,
    "name": "Divar Deepwell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/q/aqx7dzdda_k.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 72,
      "control": 55,
      "pressure": 48,
      "agility": 45,
      "physical": 48,
      "technique": 66
    }
  },
  {
    "id": 5559,
    "name": "Cleon Balogh",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/c/rcaawm753mm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 76,
      "control": 67,
      "pressure": 43,
      "agility": 58,
      "physical": 40,
      "technique": 58
    }
  },
  {
    "id": 5560,
    "name": "Credence Throwe",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/t/ltjvj7oxcs8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 55,
      "control": 41,
      "pressure": 64,
      "agility": 55,
      "physical": 57,
      "technique": 42
    }
  },
  {
    "id": 5561,
    "name": "Ivo Woodward",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/f/6fsooeolvfu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 43,
      "control": 54,
      "pressure": 59,
      "agility": 41,
      "physical": 68,
      "technique": 51
    }
  },
  {
    "id": 5562,
    "name": "Gentino Sorella",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/v/ovtw_jrpig8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 66,
      "control": 67,
      "pressure": 60,
      "agility": 56,
      "physical": 51,
      "technique": 69
    }
  },
  {
    "id": 5563,
    "name": "Richter Poole",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/h/_hc3s2ntltu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 45,
      "control": 49,
      "pressure": 79,
      "agility": 48,
      "physical": 59,
      "technique": 53
    }
  },
  {
    "id": 5564,
    "name": "Lior Morrissey",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/v/rvh6i3eae_0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 43,
      "control": 44,
      "pressure": 42,
      "agility": 61,
      "physical": 55,
      "technique": 52
    }
  },
  {
    "id": 5565,
    "name": "Focas Quayle",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/h/gh2bliigpmc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 73,
      "control": 64,
      "pressure": 40,
      "agility": 46,
      "physical": 46,
      "technique": 55
    }
  },
  {
    "id": 5566,
    "name": "Timmit Bower",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/o/aovu2vxocss.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 45,
      "control": 51,
      "pressure": 77,
      "agility": 45,
      "physical": 68,
      "technique": 48
    }
  },
  {
    "id": 5567,
    "name": "Izekiel Truth",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/o/povastt2viu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 64,
      "control": 58,
      "pressure": 59,
      "agility": 54,
      "physical": 56,
      "technique": 66
    }
  },
  {
    "id": 5568,
    "name": "Gemma Coombs",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/c/xcb6otdf9uk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 59,
      "control": 41,
      "pressure": 67,
      "agility": 57,
      "physical": 77,
      "technique": 52
    }
  },
  {
    "id": 5569,
    "name": "Fuyo Catcher",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/c/xcwwy-kc79s.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 73,
      "control": 62,
      "pressure": 58,
      "agility": 59,
      "physical": 42,
      "technique": 66
    }
  },
  {
    "id": 5570,
    "name": "Eviden Tracer",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/t/rttjhjruodc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 53,
      "control": 71,
      "pressure": 55,
      "agility": 46,
      "physical": 54,
      "technique": 52
    }
  },
  {
    "id": 5571,
    "name": "Murray Hollowpot",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/f/gficmc3uju0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 63,
      "control": 76,
      "pressure": 57,
      "agility": 57,
      "physical": 41,
      "technique": 57
    }
  },
  {
    "id": 5572,
    "name": "Morrigan Shutterly",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/k/ikleiflcmo0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 55,
      "control": 53,
      "pressure": 73,
      "agility": 55,
      "physical": 64,
      "technique": 49
    }
  },
  {
    "id": 5573,
    "name": "Sylas Saxton",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/m/tmu_p6d4lbc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 57,
      "control": 48,
      "pressure": 63,
      "agility": 55,
      "physical": 74,
      "technique": 54
    }
  },
  {
    "id": 5574,
    "name": "Ferdy Fenwick",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/j/zj3kcn2w-7s.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 74,
      "control": 56,
      "pressure": 45,
      "agility": 48,
      "physical": 60,
      "technique": 57
    }
  },
  {
    "id": 5575,
    "name": "Hazel Woodrow",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/l/clgrxyqktie.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 46,
      "control": 59,
      "pressure": 67,
      "agility": 47,
      "physical": 50,
      "technique": 60
    }
  },
  {
    "id": 5576,
    "name": "Ouijane Boarden",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/h/2h5zavto03s.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 58,
      "control": 54,
      "pressure": 70,
      "agility": 45,
      "physical": 77,
      "technique": 56
    }
  },
  {
    "id": 5577,
    "name": "Flaurine Woodwind",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/m/-mkhbs1m4r8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 47,
      "control": 55,
      "pressure": 49,
      "agility": 61,
      "physical": 53,
      "technique": 70
    }
  },
  {
    "id": 5578,
    "name": "Kellan Beatley",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/o/vobgylwklbc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 52,
      "control": 67,
      "pressure": 55,
      "agility": 40,
      "physical": 42,
      "technique": 66
    }
  },
  {
    "id": 5579,
    "name": "Louise Basson",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/v/hvdzbxyusmu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 44,
      "control": 43,
      "pressure": 62,
      "agility": 57,
      "physical": 60,
      "technique": 55
    }
  },
  {
    "id": 5580,
    "name": "Claudette Clackenoff",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/6/b6-gsshmnsk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 60,
      "control": 60,
      "pressure": 48,
      "agility": 69,
      "physical": 43,
      "technique": 63
    }
  },
  {
    "id": 5581,
    "name": "Brooke Reedman",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/s/wspn_thckfm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 45,
      "control": 49,
      "pressure": 80,
      "agility": 53,
      "physical": 65,
      "technique": 45
    }
  },
  {
    "id": 5582,
    "name": "Cornelia Hoopett",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/z/yzi7rkzwpzm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 76,
      "control": 69,
      "pressure": 57,
      "agility": 40,
      "physical": 53,
      "technique": 59
    }
  },
  {
    "id": 5583,
    "name": "Penelope Mozartin",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/b/db5a81vkiqk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 44,
      "control": 53,
      "pressure": 61,
      "agility": 53,
      "physical": 70,
      "technique": 50
    }
  },
  {
    "id": 5584,
    "name": "Brianna Summing",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/0/j0avvogcxku.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 71,
      "control": 56,
      "pressure": 55,
      "agility": 41,
      "physical": 53,
      "technique": 67
    }
  },
  {
    "id": 5585,
    "name": "Henrietta Kettingham",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/c/scrocxg4658.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 73,
      "control": 57,
      "pressure": 56,
      "agility": 50,
      "physical": 59,
      "technique": 66
    }
  },
  {
    "id": 5586,
    "name": "Marjorie Piperplume",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/2/m2uwzafadgu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 56,
      "control": 54,
      "pressure": 59,
      "agility": 46,
      "physical": 68,
      "technique": 43
    }
  },
  {
    "id": 5587,
    "name": "Dizzy Fumbleton",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/e/xel3eljgw18.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 59,
      "control": 47,
      "pressure": 50,
      "agility": 42,
      "physical": 61,
      "technique": 49
    }
  },
  {
    "id": 5588,
    "name": "Donovan Brasswagon",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/2/52-6ekqprzc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 48,
      "control": 52,
      "pressure": 52,
      "agility": 64,
      "physical": 40,
      "technique": 61
    }
  },
  {
    "id": 5589,
    "name": "Liselotte Heartsway",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/e/iepbpbmt8q0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 70,
      "control": 72,
      "pressure": 49,
      "agility": 50,
      "physical": 52,
      "technique": 56
    }
  },
  {
    "id": 5590,
    "name": "Jaslyn Warbleton",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/o/x/oxsu6g5bjke.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 49,
      "control": 48,
      "pressure": 66,
      "agility": 45,
      "physical": 64,
      "technique": 57
    }
  },
  {
    "id": 5591,
    "name": "Francesca Fintootle",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/z/zzdpx5fhk5s.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 33,
      "intelligence": 44,
      "control": 51,
      "pressure": 72,
      "agility": 52,
      "physical": 75,
      "technique": 51
    }
  },
  {
    "id": 5592,
    "name": "Ezekiel Gravendirge",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/t/rtrdugj5oec.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 54,
      "control": 52,
      "pressure": 57,
      "agility": 40,
      "physical": 65,
      "technique": 42
    }
  },
  {
    "id": 5593,
    "name": "Regis Tunesmith",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/c/xcioh98xd-s.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 50,
      "control": 66,
      "pressure": 42,
      "agility": 46,
      "physical": 49,
      "technique": 63
    }
  },
  {
    "id": 5594,
    "name": "Vincent Melodin",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/q/aq5jqcalwne.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 51,
      "control": 72,
      "pressure": 50,
      "agility": 55,
      "physical": 41,
      "technique": 62
    }
  },
  {
    "id": 5595,
    "name": "Renee Sirensong",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/l/cl-vebin1le.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 50,
      "control": 41,
      "pressure": 42,
      "agility": 67,
      "physical": 44,
      "technique": 51
    }
  },
  {
    "id": 5596,
    "name": "Monica Kinbird",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/j/zjp0pkudy4s.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 60,
      "control": 62,
      "pressure": 40,
      "agility": 41,
      "physical": 53,
      "technique": 67
    }
  },
  {
    "id": 5597,
    "name": "Sonata Cherub",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/m/tmsb65bvtyc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 43,
      "control": 43,
      "pressure": 47,
      "agility": 59,
      "physical": 47,
      "technique": 56
    }
  },
  {
    "id": 5598,
    "name": "Allegra Langton",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/k/ikdgxg9var0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 52,
      "control": 57,
      "pressure": 69,
      "agility": 42,
      "physical": 64,
      "technique": 53
    }
  },
  {
    "id": 5599,
    "name": "Millicent Vociere",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/o/woi4ml-nnuc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 73,
      "control": 63,
      "pressure": 44,
      "agility": 60,
      "physical": 60,
      "technique": 69
    }
  },
  {
    "id": 5600,
    "name": "Selena Sopralis",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/m/nmtzl0y3kn0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 56,
      "control": 57,
      "pressure": 67,
      "agility": 55,
      "physical": 53,
      "technique": 50
    }
  },
  {
    "id": 5601,
    "name": "Rondo Harmond",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/o/joiur1r-rlu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 57,
      "control": 54,
      "pressure": 67,
      "agility": 59,
      "physical": 66,
      "technique": 55
    }
  },
  {
    "id": 5602,
    "name": "Aretha Rumbell",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/m/4m518k3eg48.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 52,
      "control": 47,
      "pressure": 57,
      "agility": 52,
      "physical": 61,
      "technique": 59
    }
  },
  {
    "id": 5603,
    "name": "Hexine Cantation",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/j/yjaavxcmzym.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 42,
      "control": 55,
      "pressure": 60,
      "agility": 59,
      "physical": 64,
      "technique": 55
    }
  },
  {
    "id": 5604,
    "name": "Rockson Grohl",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/j/ejhuspaenxm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 54,
      "control": 56,
      "pressure": 74,
      "agility": 56,
      "physical": 57,
      "technique": 58
    }
  },
  {
    "id": 5605,
    "name": "Sadley Lonsom",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/v/tvga28imodc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 69,
      "intelligence": 55,
      "control": 54,
      "pressure": 45,
      "agility": 66,
      "physical": 43,
      "technique": 52
    }
  },
  {
    "id": 5606,
    "name": "Blossom Laine",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/6/b6g4nvflbvk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 68,
      "control": 78,
      "pressure": 45,
      "agility": 41,
      "physical": 56,
      "technique": 51
    }
  },
  {
    "id": 5607,
    "name": "Thompson Hummings",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/v/hvln0yqd0pu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 58,
      "control": 59,
      "pressure": 52,
      "agility": 56,
      "physical": 51,
      "technique": 75
    }
  },
  {
    "id": 5608,
    "name": "Trebor Donders",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/9/q9usznm5z88.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 73,
      "control": 64,
      "pressure": 46,
      "agility": 51,
      "physical": 43,
      "technique": 71
    }
  },
  {
    "id": 5609,
    "name": "Liron Suesskind",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/c/sctw3uevc68.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 60,
      "control": 47,
      "pressure": 76,
      "agility": 43,
      "physical": 64,
      "technique": 44
    }
  },
  {
    "id": 5610,
    "name": "Marius Harlow",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/0/j0irar4vxju.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 32,
      "intelligence": 42,
      "control": 52,
      "pressure": 54,
      "agility": 49,
      "physical": 61,
      "technique": 56
    }
  },
  {
    "id": 5611,
    "name": "Raya Sixstring",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/b/dbbkj2nnepk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 55,
      "control": 56,
      "pressure": 59,
      "agility": 48,
      "physical": 73,
      "technique": 44
    }
  },
  {
    "id": 5612,
    "name": "Minna Smallwood",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/z/yzwfkjrdpam.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 69,
      "control": 65,
      "pressure": 52,
      "agility": 40,
      "physical": 57,
      "technique": 64
    }
  },
  {
    "id": 5613,
    "name": "Cleara Sounds",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/z/gzpdveo_olk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 63,
      "control": 69,
      "pressure": 51,
      "agility": 51,
      "physical": 58,
      "technique": 54
    }
  },
  {
    "id": 5614,
    "name": "Hop Sadler",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/x/3x-847ofjwm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 55,
      "control": 40,
      "pressure": 69,
      "agility": 42,
      "physical": 60,
      "technique": 56
    }
  },
  {
    "id": 5615,
    "name": "Bang Revell",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/z/zzlxi6hmc6s.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 44,
      "control": 57,
      "pressure": 51,
      "agility": 65,
      "physical": 58,
      "technique": 59
    }
  },
  {
    "id": 5616,
    "name": "Verica Nyman",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/h/vh21_wm-gck.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 74,
      "control": 62,
      "pressure": 49,
      "agility": 42,
      "physical": 58,
      "technique": 67
    }
  },
  {
    "id": 5617,
    "name": "Aldus Ogden",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/k/ck3wbehrfoe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 49,
      "control": 44,
      "pressure": 53,
      "agility": 57,
      "physical": 64,
      "technique": 44
    }
  },
  {
    "id": 5618,
    "name": "Veronica Camry",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/d/pdq3dx8j57u.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 74,
      "control": 73,
      "pressure": 47,
      "agility": 49,
      "physical": 58,
      "technique": 50
    }
  },
  {
    "id": 5619,
    "name": "Cora Inkton",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/1/y1hwuoazui8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 44,
      "control": 54,
      "pressure": 63,
      "agility": 46,
      "physical": 73,
      "technique": 59
    }
  },
  {
    "id": 5620,
    "name": "Uriah Goldfield",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/d/wdudahwsrdu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 79,
      "intelligence": 54,
      "control": 51,
      "pressure": 56,
      "agility": 75,
      "physical": 50,
      "technique": 68
    }
  },
  {
    "id": 5621,
    "name": "Adal Miramond",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/l/ilujiduzqu0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 64,
      "control": 51,
      "pressure": 42,
      "agility": 49,
      "physical": 57,
      "technique": 66
    }
  },
  {
    "id": 5622,
    "name": "Trace Combe",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/t/n/tnlcl8yjhdc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 40,
      "control": 53,
      "pressure": 70,
      "agility": 49,
      "physical": 71,
      "technique": 45
    }
  },
  {
    "id": 5623,
    "name": "Tito De Core",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/s/rsiellgpcbc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 47,
      "control": 48,
      "pressure": 52,
      "agility": 77,
      "physical": 49,
      "technique": 47
    }
  },
  {
    "id": 5624,
    "name": "Fiona Leroux",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/e/get_mag1vo0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 60,
      "control": 62,
      "pressure": 52,
      "agility": 50,
      "physical": 51,
      "technique": 66
    }
  },
  {
    "id": 5625,
    "name": "Nance Meridian",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/r/arwk1hz9aie.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 34,
      "intelligence": 45,
      "control": 53,
      "pressure": 74,
      "agility": 59,
      "physical": 64,
      "technique": 47
    }
  },
  {
    "id": 5626,
    "name": "Memo Rize",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/d/xdbry4vh37s.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 58,
      "control": 76,
      "pressure": 44,
      "agility": 44,
      "physical": 40,
      "technique": 56
    }
  },
  {
    "id": 5627,
    "name": "Krome Tallic",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/l/bljto9lch9m.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 64,
      "control": 71,
      "pressure": 48,
      "agility": 59,
      "physical": 51,
      "technique": 71
    }
  },
  {
    "id": 5628,
    "name": "Jewelyn Plunkett",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/o/8ouoiexuwoe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 51,
      "control": 50,
      "pressure": 62,
      "agility": 41,
      "physical": 74,
      "technique": 53
    }
  },
  {
    "id": 5629,
    "name": "Gildred Gainstead",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/d/sdazor3j2_8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 50,
      "control": 42,
      "pressure": 64,
      "agility": 56,
      "physical": 69,
      "technique": 57
    }
  },
  {
    "id": 5630,
    "name": "Ezrail Corbell",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/y/yy5g7mcrdfm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 61,
      "control": 52,
      "pressure": 53,
      "agility": 46,
      "physical": 52,
      "technique": 65
    }
  },
  {
    "id": 5631,
    "name": "Culinaro Brons",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/a/dainwzkrusk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 50,
      "control": 50,
      "pressure": 61,
      "agility": 50,
      "physical": 74,
      "technique": 41
    }
  },
  {
    "id": 5632,
    "name": "Elian Kitronic",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/7/b7p74q29rqk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 71,
      "control": 63,
      "pressure": 55,
      "agility": 44,
      "physical": 46,
      "technique": 62
    }
  },
  {
    "id": 5633,
    "name": "Slater Verbenbaum",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/t/wt-avvqhgzm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 70,
      "intelligence": 56,
      "control": 45,
      "pressure": 55,
      "agility": 60,
      "physical": 43,
      "technique": 65
    }
  },
  {
    "id": 5634,
    "name": "Kurtz Armishaw",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/8/q8dvgilpz58.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 41,
      "control": 59,
      "pressure": 41,
      "agility": 77,
      "physical": 55,
      "technique": 64
    }
  },
  {
    "id": 5635,
    "name": "Tessa Rapperton",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/u/husor3d1eku.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 42,
      "control": 44,
      "pressure": 57,
      "agility": 48,
      "physical": 68,
      "technique": 44
    }
  },
  {
    "id": 5636,
    "name": "Miriam Masheene",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/-/v-twa6ax518.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 60,
      "control": 60,
      "pressure": 60,
      "agility": 50,
      "physical": 60,
      "technique": 59
    }
  },
  {
    "id": 5637,
    "name": "Armani Armure",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/w/kwi33fmtugu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 47,
      "control": 58,
      "pressure": 74,
      "agility": 47,
      "physical": 64,
      "technique": 51
    }
  },
  {
    "id": 5638,
    "name": "Gusmin Strelbard",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/-/k-56tevk1q0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 58,
      "intelligence": 59,
      "control": 70,
      "pressure": 45,
      "agility": 57,
      "physical": 53,
      "technique": 59
    }
  },
  {
    "id": 5639,
    "name": "Jayce Chorden",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/7/w/7wiba7jeyzc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 72,
      "intelligence": 51,
      "control": 46,
      "pressure": 52,
      "agility": 74,
      "physical": 49,
      "technique": 54
    }
  },
  {
    "id": 5640,
    "name": "Tobias Thumpern",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/5/b5rutm8wt5s.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 37,
      "intelligence": 46,
      "control": 59,
      "pressure": 64,
      "agility": 57,
      "physical": 63,
      "technique": 57
    }
  },
  {
    "id": 5641,
    "name": "Kara Okenridge",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/r/qrap-zasake.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 59,
      "control": 67,
      "pressure": 56,
      "agility": 55,
      "physical": 44,
      "technique": 55
    }
  },
  {
    "id": 5642,
    "name": "Kohara Staley",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/j/qj4mjcdmqok.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 85,
      "intelligence": 40,
      "control": 51,
      "pressure": 55,
      "agility": 66,
      "physical": 50,
      "technique": 70
    }
  },
  {
    "id": 5643,
    "name": "Kye Sendon",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/8/u8pbueiaubu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 52,
      "control": 52,
      "pressure": 55,
      "agility": 55,
      "physical": 45,
      "technique": 66
    }
  },
  {
    "id": 5644,
    "name": "Jella Fisker",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/l/ilsd9am0mt0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 46,
      "control": 43,
      "pressure": 67,
      "agility": 43,
      "physical": 55,
      "technique": 45
    }
  },
  {
    "id": 5645,
    "name": "Salpida Longwheel",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/k/ckpoud585ne.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 68,
      "control": 70,
      "pressure": 42,
      "agility": 40,
      "physical": 44,
      "technique": 58
    }
  },
  {
    "id": 5646,
    "name": "Ezra Bachmann",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/z/i/zi-jdifgu-s.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 60,
      "intelligence": 60,
      "control": 68,
      "pressure": 54,
      "agility": 45,
      "physical": 47,
      "technique": 75
    }
  },
  {
    "id": 5647,
    "name": "Evon Newground",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/x/d/xd5vt7nqr4s.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 73,
      "control": 64,
      "pressure": 50,
      "agility": 51,
      "physical": 52,
      "technique": 68
    }
  },
  {
    "id": 5648,
    "name": "Barrac Kuda",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/r/ari0aerq8le.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 59,
      "control": 47,
      "pressure": 73,
      "agility": 45,
      "physical": 70,
      "technique": 42
    }
  },
  {
    "id": 5649,
    "name": "Mako Carcher",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/e/gerbtzeyjr0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 70,
      "control": 65,
      "pressure": 58,
      "agility": 58,
      "physical": 53,
      "technique": 65
    }
  },
  {
    "id": 5650,
    "name": "Inga Calmari",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/s/rsag-m4ikyc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 47,
      "control": 51,
      "pressure": 68,
      "agility": 43,
      "physical": 62,
      "technique": 50
    }
  },
  {
    "id": 5651,
    "name": "Azure Marcet",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/g/lgl4pr7adn0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 54,
      "control": 55,
      "pressure": 76,
      "agility": 40,
      "physical": 69,
      "technique": 54
    }
  },
  {
    "id": 5652,
    "name": "Octavian Da Lua",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/u/uuuziud6uuc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 75,
      "control": 59,
      "pressure": 49,
      "agility": 49,
      "physical": 42,
      "technique": 53
    }
  },
  {
    "id": 5653,
    "name": "Megal O'Donn",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/g/6gpu4vuzp48.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 77,
      "intelligence": 48,
      "control": 58,
      "pressure": 49,
      "agility": 61,
      "physical": 52,
      "technique": 51
    }
  },
  {
    "id": 5654,
    "name": "Tempest Liebkind",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/u/lu-1vqyjilu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 52,
      "control": 44,
      "pressure": 73,
      "agility": 47,
      "physical": 75,
      "technique": 45
    }
  },
  {
    "id": 5655,
    "name": "Griffin Fastwell",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/l/kl3hnlptvbm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 48,
      "control": 41,
      "pressure": 63,
      "agility": 51,
      "physical": 59,
      "technique": 40
    }
  },
  {
    "id": 5656,
    "name": "Sienna Fairborn",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/n/gn54lk-okck.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 47,
      "control": 46,
      "pressure": 60,
      "agility": 60,
      "physical": 51,
      "technique": 63
    }
  },
  {
    "id": 5657,
    "name": "Lockin Somnal",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/y/yyb4opaglcm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 71,
      "intelligence": 43,
      "control": 52,
      "pressure": 55,
      "agility": 55,
      "physical": 54,
      "technique": 69
    }
  },
  {
    "id": 5658,
    "name": "Aeron Rushmore",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/d/sdindsvoq88.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 50,
      "control": 41,
      "pressure": 69,
      "agility": 50,
      "physical": 61,
      "technique": 42
    }
  },
  {
    "id": 5659,
    "name": "Grayson Tiltwood",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/1/j1tswtj09pu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 58,
      "control": 66,
      "pressure": 50,
      "agility": 46,
      "physical": 59,
      "technique": 60
    }
  },
  {
    "id": 5660,
    "name": "Calix Virtus",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/u/huuwe0by4ju.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 57,
      "control": 45,
      "pressure": 77,
      "agility": 42,
      "physical": 55,
      "technique": 58
    }
  },
  {
    "id": 5661,
    "name": "Torwyn Endeavor",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/8/q8lrzl9iv68.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 63,
      "control": 61,
      "pressure": 46,
      "agility": 45,
      "physical": 44,
      "technique": 58
    }
  },
  {
    "id": 5662,
    "name": "Torric Brawnstone",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/t/wtgkgwiqgam.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 42,
      "control": 44,
      "pressure": 69,
      "agility": 57,
      "physical": 69,
      "technique": 44
    }
  },
  {
    "id": 5663,
    "name": "Cassia Bladecroft",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/7/b73fnpuqnpk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 70,
      "control": 69,
      "pressure": 58,
      "agility": 54,
      "physical": 44,
      "technique": 54
    }
  },
  {
    "id": 5664,
    "name": "Actie Verran",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/r/1rid8ktyqwm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 46,
      "intelligence": 52,
      "control": 42,
      "pressure": 56,
      "agility": 44,
      "physical": 55,
      "technique": 48
    }
  },
  {
    "id": 5665,
    "name": "Ellie Fumble",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/5/e558rblihlk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 42,
      "control": 52,
      "pressure": 55,
      "agility": 40,
      "physical": 59,
      "technique": 42
    }
  },
  {
    "id": 5666,
    "name": "Biijiro Onoda",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/3/c/3cv86l-5jxs.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 76,
      "intelligence": 49,
      "control": 51,
      "pressure": 40,
      "agility": 62,
      "physical": 47,
      "technique": 66
    }
  },
  {
    "id": 5667,
    "name": "Kujira Torikawa",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/q/gqkdxaydoke.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 73,
      "intelligence": 47,
      "control": 41,
      "pressure": 60,
      "agility": 70,
      "physical": 58,
      "technique": 66
    }
  },
  {
    "id": 5668,
    "name": "Romain Romanze",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/e/lepaejwaxu0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 49,
      "control": 43,
      "pressure": 69,
      "agility": 59,
      "physical": 68,
      "technique": 48
    }
  },
  {
    "id": 5669,
    "name": "Edton Prentt",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/r/frs1x-fieoe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 76,
      "control": 67,
      "pressure": 43,
      "agility": 53,
      "physical": 52,
      "technique": 59
    }
  },
  {
    "id": 5670,
    "name": "Drewey Fournell",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/0/d/0ddu6bjyp9s.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 56,
      "control": 53,
      "pressure": 58,
      "agility": 47,
      "physical": 58,
      "technique": 57
    }
  },
  {
    "id": 5671,
    "name": "Edith Endenwald",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/2/i/2iaiuyxes7s.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 52,
      "control": 52,
      "pressure": 62,
      "agility": 42,
      "physical": 65,
      "technique": 48
    }
  },
  {
    "id": 5672,
    "name": "Harolde Narcissus",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/k/hkrp5nxkbie.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 65,
      "control": 57,
      "pressure": 45,
      "agility": 51,
      "physical": 40,
      "technique": 47
    }
  },
  {
    "id": 5673,
    "name": "Manon Matopia",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/l/nlicq6is0o0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 40,
      "control": 50,
      "pressure": 67,
      "agility": 60,
      "physical": 68,
      "technique": 49
    }
  },
  {
    "id": 5674,
    "name": "Soria Bordeau",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/n/wn59hfewzbc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 43,
      "intelligence": 78,
      "control": 58,
      "pressure": 50,
      "agility": 55,
      "physical": 42,
      "technique": 58
    }
  },
  {
    "id": 5675,
    "name": "Norah Noshawn",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/i/n/ingl2ih0-k0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 40,
      "control": 41,
      "pressure": 65,
      "agility": 45,
      "physical": 76,
      "technique": 53
    }
  },
  {
    "id": 5676,
    "name": "Puffet Vearn",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/k/skwo7xjzgok.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 42,
      "control": 45,
      "pressure": 59,
      "agility": 50,
      "physical": 69,
      "technique": 58
    }
  },
  {
    "id": 5677,
    "name": "Glorian Flaunt",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/l/ylt7oswrviu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 64,
      "intelligence": 55,
      "control": 54,
      "pressure": 60,
      "agility": 73,
      "physical": 45,
      "technique": 54
    }
  },
  {
    "id": 5678,
    "name": "Rhianna Wardholdt",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/9/y/9ymahhkjrkm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 58,
      "control": 55,
      "pressure": 40,
      "agility": 50,
      "physical": 59,
      "technique": 66
    }
  },
  {
    "id": 5679,
    "name": "Ordin Scriben",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/_/5/_5lgp4yluim.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 41,
      "control": 42,
      "pressure": 57,
      "agility": 59,
      "physical": 65,
      "technique": 60
    }
  },
  {
    "id": 5680,
    "name": "Coraline Quisittor",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/w/mw97meszgxk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 44,
      "control": 55,
      "pressure": 41,
      "agility": 65,
      "physical": 54,
      "technique": 65
    }
  },
  {
    "id": 5681,
    "name": "Judis Nitcher",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/f/sfeofdz7z3u.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 55,
      "intelligence": 58,
      "control": 74,
      "pressure": 46,
      "agility": 60,
      "physical": 59,
      "technique": 63
    }
  },
  {
    "id": 5682,
    "name": "Lawton Dappermann",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/3/d3vvy8_bee8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 72,
      "control": 67,
      "pressure": 60,
      "agility": 48,
      "physical": 49,
      "technique": 48
    }
  },
  {
    "id": 5683,
    "name": "Rudgar Dennings",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/7/f77vq8xy2im.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 48,
      "intelligence": 55,
      "control": 41,
      "pressure": 54,
      "agility": 48,
      "physical": 62,
      "technique": 58
    }
  },
  {
    "id": 5684,
    "name": "Hardan Kempton",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/u/luygdhe6do8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 56,
      "intelligence": 66,
      "control": 70,
      "pressure": 54,
      "agility": 44,
      "physical": 51,
      "technique": 46
    }
  },
  {
    "id": 5685,
    "name": "Montgomery Marchand",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/j/vjgmg0pp4ok.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 44,
      "control": 44,
      "pressure": 73,
      "agility": 52,
      "physical": 59,
      "technique": 54
    }
  },
  {
    "id": 5686,
    "name": "Elmer Trommel",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/c/h/ch37bdecju0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 75,
      "control": 53,
      "pressure": 53,
      "agility": 44,
      "physical": 44,
      "technique": 55
    }
  },
  {
    "id": 5687,
    "name": "Cane Fangley",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/1/m/1mltzp6hniu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 54,
      "intelligence": 58,
      "control": 50,
      "pressure": 73,
      "agility": 49,
      "physical": 67,
      "technique": 46
    }
  },
  {
    "id": 5688,
    "name": "Fenric Wulfgang",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/k/ekuyewcbg78.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 57,
      "control": 43,
      "pressure": 53,
      "agility": 71,
      "physical": 55,
      "technique": 56
    }
  },
  {
    "id": 5689,
    "name": "Romica Glimmerly",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/g/f/gftuwpo3l98.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 74,
      "intelligence": 59,
      "control": 59,
      "pressure": 43,
      "agility": 54,
      "physical": 42,
      "technique": 54
    }
  },
  {
    "id": 5690,
    "name": "Stran Linemont",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/m/n/mnstexcnfbm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 75,
      "intelligence": 47,
      "control": 57,
      "pressure": 57,
      "agility": 61,
      "physical": 41,
      "technique": 65
    }
  },
  {
    "id": 5691,
    "name": "Lacie Pawford",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/e/veaqdx2b3uk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 53,
      "intelligence": 48,
      "control": 54,
      "pressure": 55,
      "agility": 40,
      "physical": 59,
      "technique": 57
    }
  },
  {
    "id": 5692,
    "name": "Marcol Leapstone",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/d/ediej1lpv98.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 57,
      "intelligence": 71,
      "control": 61,
      "pressure": 41,
      "agility": 53,
      "physical": 56,
      "technique": 69
    }
  },
  {
    "id": 5693,
    "name": "Ignacio Gerhardt",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/b/bbg9_haxlx8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 49,
      "control": 45,
      "pressure": 62,
      "agility": 48,
      "physical": 67,
      "technique": 48
    }
  },
  {
    "id": 5694,
    "name": "Rynor Rushenfort",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/e/b/ebsri5vcpu0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 78,
      "intelligence": 56,
      "control": 42,
      "pressure": 49,
      "agility": 61,
      "physical": 56,
      "technique": 55
    }
  },
  {
    "id": 5695,
    "name": "Crag Bolderin",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/p/vpdwlgj4edc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 71,
      "control": 59,
      "pressure": 40,
      "agility": 41,
      "physical": 54,
      "technique": 57
    }
  },
  {
    "id": 5696,
    "name": "Bowie Buffoon",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/g/pg-f2b8wx9s.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 59,
      "control": 57,
      "pressure": 60,
      "agility": 48,
      "physical": 74,
      "technique": 42
    }
  },
  {
    "id": 5697,
    "name": "Margot Napier",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/-/u/-upkbkakcoe.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 47,
      "intelligence": 74,
      "control": 65,
      "pressure": 60,
      "agility": 60,
      "physical": 55,
      "technique": 46
    }
  },
  {
    "id": 5698,
    "name": "Colette Brushmont",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/5/f/5fflb9jfkoc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 38,
      "intelligence": 42,
      "control": 58,
      "pressure": 62,
      "agility": 55,
      "physical": 67,
      "technique": 57
    }
  },
  {
    "id": 5699,
    "name": "Blue Cleverley",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/n/1/n169qwk9tx0.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 36,
      "intelligence": 55,
      "control": 58,
      "pressure": 58,
      "agility": 51,
      "physical": 64,
      "technique": 58
    }
  },
  {
    "id": 5700,
    "name": "Matilde Pendlebury",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/8/d/8dlchpshakc.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 42,
      "intelligence": 78,
      "control": 63,
      "pressure": 40,
      "agility": 40,
      "physical": 60,
      "technique": 50
    }
  },
  {
    "id": 5701,
    "name": "Niro Vannaburg",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/s/1/s1qrdolohi8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 68,
      "intelligence": 54,
      "control": 58,
      "pressure": 47,
      "agility": 66,
      "physical": 54,
      "technique": 62
    }
  },
  {
    "id": 5702,
    "name": "Heather Lovella",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/d/jdhwwxd0m7u.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 44,
      "control": 44,
      "pressure": 51,
      "agility": 63,
      "physical": 44,
      "technique": 66
    }
  },
  {
    "id": 5703,
    "name": "Brannon Chalant",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/d/y/dycfjs285bk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 59,
      "control": 41,
      "pressure": 77,
      "agility": 59,
      "physical": 66,
      "technique": 41
    }
  },
  {
    "id": 5704,
    "name": "Jayden Durance",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/a/yazkotqguom.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 51,
      "intelligence": 55,
      "control": 77,
      "pressure": 51,
      "agility": 57,
      "physical": 42,
      "technique": 71
    }
  },
  {
    "id": 5705,
    "name": "Capricia Saiz",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/w/7/w704gkcqrum.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 39,
      "intelligence": 40,
      "control": 46,
      "pressure": 63,
      "agility": 47,
      "physical": 60,
      "technique": 40
    }
  },
  {
    "id": 5706,
    "name": "Colm Dawdlin",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/b/t/btfzn1kq8dk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 52,
      "control": 55,
      "pressure": 40,
      "agility": 47,
      "physical": 45,
      "technique": 68
    }
  },
  {
    "id": 5707,
    "name": "Adelaide Plainhart",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/h/8/h8mseoryj9u.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 65,
      "control": 56,
      "pressure": 50,
      "agility": 54,
      "physical": 58,
      "technique": 54
    }
  },
  {
    "id": 5708,
    "name": "Sami Wampovich",
    "role": "GK",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/q/u/quxnzx3iko8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 40,
      "intelligence": 44,
      "control": 59,
      "pressure": 84,
      "agility": 49,
      "physical": 61,
      "technique": 55
    }
  },
  {
    "id": 5709,
    "name": "Alphonse Wreckenbach",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/k/-/k-ovca0adxu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 40,
      "control": 46,
      "pressure": 45,
      "agility": 55,
      "physical": 49,
      "technique": 56
    }
  },
  {
    "id": 5710,
    "name": "Annie Glenvale",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/v/w/vwz0vls6uc8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 78,
      "control": 67,
      "pressure": 46,
      "agility": 52,
      "physical": 48,
      "technique": 60
    }
  },
  {
    "id": 5711,
    "name": "Fitzbon Vivant",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/p/o/poplmghwvrm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 62,
      "control": 70,
      "pressure": 49,
      "agility": 48,
      "physical": 42,
      "technique": 53
    }
  },
  {
    "id": 5712,
    "name": "Rico Falsettis",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/y/a/ya-ehfhkcik.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 44,
      "intelligence": 65,
      "control": 63,
      "pressure": 47,
      "agility": 40,
      "physical": 58,
      "technique": 46
    }
  },
  {
    "id": 5713,
    "name": "Amadeus Lyland",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/4/v/4vdxycyc3cu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 66,
      "intelligence": 55,
      "control": 60,
      "pressure": 60,
      "agility": 63,
      "physical": 55,
      "technique": 55
    }
  },
  {
    "id": 5714,
    "name": "Aila Pavey",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/j/h/jhsqf9u4ax8.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 59,
      "intelligence": 59,
      "control": 56,
      "pressure": 45,
      "agility": 59,
      "physical": 45,
      "technique": 69
    }
  },
  {
    "id": 5715,
    "name": "Emi Blanchett",
    "role": "FW",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/l/m/lmrmxkguf38.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 65,
      "intelligence": 42,
      "control": 44,
      "pressure": 43,
      "agility": 63,
      "physical": 40,
      "technique": 48
    }
  },
  {
    "id": 5716,
    "name": "Colleen Evenholm",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/6/o/6oatcbguyeu.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 78,
      "control": 69,
      "pressure": 41,
      "agility": 52,
      "physical": 44,
      "technique": 45
    }
  },
  {
    "id": 5717,
    "name": "Emery Hillmere",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/a/h/ah5ypgvmhkk.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 52,
      "intelligence": 67,
      "control": 54,
      "pressure": 46,
      "agility": 42,
      "physical": 56,
      "technique": 57
    }
  },
  {
    "id": 5718,
    "name": "Vane Nishmont",
    "role": "DF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/r/j/rji5i5zcqxm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 49,
      "intelligence": 57,
      "control": 43,
      "pressure": 68,
      "agility": 46,
      "physical": 64,
      "technique": 43
    }
  },
  {
    "id": 5719,
    "name": "Juniper Cushionne",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/f/j/fj3ht0w-nok.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 41,
      "intelligence": 68,
      "control": 61,
      "pressure": 55,
      "agility": 59,
      "physical": 51,
      "technique": 59
    }
  },
  {
    "id": 5720,
    "name": "Nadia Watershed",
    "role": "MF",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/k/u/l/ulga-lwegbm.png",
    "game": [
      "Inazuma Eleven Victory Road"
    ],
    "baseStats": {
      "shoot": 45,
      "intelligence": 53,
      "control": 55,
      "pressure": 46,
      "agility": 55,
      "physical": 56,
      "technique": 62
    }
  },
  {
    "id": 5721,
    "name": "Victorio Cryptix",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5722,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5723,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5724,
    "name": "Fei Rune",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5725,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5726,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5728,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5729,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5730,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5731,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5732,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5733,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5734,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5735,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5736,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5737,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5738,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5739,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5740,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5741,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5742,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5743,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5744,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5745,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5746,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5747,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5748,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5749,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5750,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5751,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5752,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5753,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5754,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5755,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5756,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5757,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5758,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5759,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5760,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5761,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5762,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5763,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5764,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5765,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5766,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5767,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5768,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5769,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5770,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5771,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5772,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5773,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5774,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5775,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5776,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5777,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5778,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5779,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5780,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5781,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5782,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5783,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5784,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5785,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5786,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5787,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5788,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5789,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5790,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5791,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5792,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5793,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5794,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5795,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5796,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5797,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5798,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5799,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5800,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5801,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5802,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5803,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5804,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5805,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5806,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5807,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5808,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5809,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5810,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5811,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5812,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5813,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  },
  {
    "id": 5814,
    "name": "???",
    "role": "-",
    "sprite": "https://dxi4wb638ujep.cloudfront.net/1/prd/assets/4/img/shared/icn_secret_character.png",
    "game": [
      "-"
    ],
    "baseStats": {
      "shoot": 50,
      "intelligence": 50,
      "control": 50,
      "pressure": 50,
      "agility": 50,
      "physical": 50,
      "technique": 50
    }
  }
];
